import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions =  {}
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: any;
  /** Custom JSON scalar type */
  JSON: any;
  /** The `Upload` scalar type represents a file upload. */
  Upload: File;
}

export interface IAboutYouDtoAddCandidate {
  countryOfResidence?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  githubUrl?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  linkedinUrl?: Maybe<Scalars['String']>;
  optionExploring?: Maybe<Scalars['String']>;
  paymentOption?: Maybe<Array<IBillingCycle>>;
  phoneNumber?: Maybe<Scalars['String']>;
  seekingNewRole?: Maybe<Scalars['Boolean']>;
  startDate?: Maybe<Scalars['String']>;
  timeZone?: Maybe<Scalars['String']>;
}

export interface IAccessChangeLogResponseDto {
  allowAccess?: Maybe<Scalars['Boolean']>;
  reason?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<Scalars['String']>;
}

export interface IAccountExecutiveDto {
  email?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  ownerId?: Maybe<Scalars['String']>;
}

export interface IAddPermissionToGroupDto {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  permissions: Array<Scalars['String']>;
}

export interface IAddResumeRequestDto {
  jobId: Scalars['String'];
  resumeIds?: Maybe<Array<Scalars['String']>>;
  source: Scalars['String'];
}

export interface IAdditionalNoteResponseDto {
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUserInfo?: Maybe<ICreatedByUserInfoDto>;
  id?: Maybe<Scalars['ID']>;
  involvementHistoryId?: Maybe<Scalars['String']>;
  modifications?: Maybe<Array<Maybe<INoteModificationsResponseDto>>>;
  note?: Maybe<Scalars['String']>;
  noteType?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  userSquadHistoryId?: Maybe<Scalars['String']>;
}

export enum IAdditionalNoteTypeEnum {
  ASSIGNED = 'ASSIGNED',
  REGULAR = 'REGULAR',
  STATUS_CHANGED = 'STATUS_CHANGED'
}

export interface IAdvancedJobSearchPaged {
  /** List of fetched data */
  content: Array<IJobResult>;
  /** Information about pagination */
  pageable: IPageable;
}

export interface IAdvancedResumeSearchPaged {
  /** List of fetched data */
  content: Array<IParsedResume>;
  /** Information about pagination */
  pageable: IPageable;
}

export interface IAdvancedSearchRequestDto {
  addedBy?: Maybe<Array<Scalars['String']>>;
  addedOnFrom?: Maybe<Scalars['String']>;
  addedOnTo?: Maybe<Scalars['String']>;
  aiResumeScoreFrom?: Maybe<Scalars['Float']>;
  aiResumeScoreTo?: Maybe<Scalars['Float']>;
  location?: Maybe<Array<Scalars['String']>>;
  name?: Maybe<Scalars['String']>;
  parseStatus?: Maybe<Array<IParseStatus>>;
  region?: Maybe<Array<Scalars['String']>>;
  searchText?: Maybe<Scalars['String']>;
  skills?: Maybe<Array<Scalars['String']>>;
  source?: Maybe<Scalars['String']>;
  stage?: Maybe<IJobCandidateStages>;
}

export interface IAllCronsResponseObjectType {
  databaseCrons?: Maybe<Array<IDbCronObject>>;
  registeredJobs?: Maybe<Array<Scalars['String']>>;
}

export interface IAllocatedTimeResponse {
  allocatedFrom?: Maybe<Scalars['String']>;
  allocatedMinutes: Scalars['Float'];
  allocatedPer: Scalars['String'];
  allocatedUntil?: Maybe<Scalars['String']>;
  squadId: Scalars['String'];
  userId: Scalars['String'];
}

export interface IAllowIpInputDto {
  allowAccess: Scalars['Boolean'];
  ipAddress: Scalars['String'];
  reason: Scalars['String'];
  userId?: Maybe<Scalars['String']>;
}

export interface IApproveDeclineWorklogArgs {
  comment?: Maybe<Scalars['String']>;
  declinedCategories?: Maybe<Array<Scalars['String']>>;
  newStatus: Scalars['String'];
  sendNotification: Scalars['Boolean'];
  squadId: Scalars['String'];
  userId: Scalars['String'];
  worklogIds?: Maybe<Array<Maybe<Scalars['String']>>>;
}

export interface IApproverDto {
  /** designation of the approver */
  designation?: Maybe<Scalars['String']>;
  /** name of the approver */
  fullname?: Maybe<Scalars['String']>;
  /** unique id of approver in collection */
  userId?: Maybe<Scalars['String']>;
}

export interface IApproverInfo {
  /** Approver's designation */
  designation?: Maybe<Scalars['String']>;
  /** Approver's user email */
  email?: Maybe<Scalars['String']>;
  /** Approver's fullname */
  fullname?: Maybe<Scalars['String']>;
  /** Approver's user ID */
  id?: Maybe<Scalars['String']>;
}

export interface IAssignPersonaDto {
  permissionGroupIds: Array<Scalars['String']>;
  personaIds: Array<Scalars['String']>;
  userId: Scalars['String'];
  userIds: Array<Scalars['String']>;
}

export interface IAssignedDevices {
  _id?: Maybe<Scalars['String']>;
  assignedDate?: Maybe<Scalars['DateTime']>;
  deviceCode: Scalars['String'];
  deviceDescription: Scalars['String'];
  deviceName?: Maybe<Scalars['String']>;
  profileId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
}

export interface IAssignedDevicesDto {
  _id?: Maybe<Scalars['String']>;
  assignedDate?: Maybe<Scalars['DateTime']>;
  deviceCode?: Maybe<Scalars['String']>;
  deviceDescription?: Maybe<Scalars['String']>;
  deviceName?: Maybe<Scalars['String']>;
  profileId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
}

export interface IAssignedEmployeeDto {
  designation?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  employeeActiveStatus?: Maybe<Scalars['String']>;
  involvementStatus?: Maybe<Scalars['String']>;
  isApproverAssigned?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  rate?: Maybe<Scalars['Float']>;
  role?: Maybe<Scalars['String']>;
  squadId?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
  userSquadHistoryId?: Maybe<Scalars['String']>;
}

export interface IAssignedResourcesWorklogTab {
  employee: IEmployeeInfo;
}

export interface IAssignedResourcesWorklogTabDto {
  employee: IEmployeeInfo;
  resourceWorklogs: IHourOverviewResponseDto;
}

export interface IAssignedResourcesWorklogTabDtoPaged {
  /** List of fetched data */
  content: Array<IAssignedResourcesWorklogTabDto>;
  /** Information about pagination */
  pageable: IPageable;
}

export interface IAssignedSquadInfoDto {
  clientId?: Maybe<Scalars['String']>;
  clientName?: Maybe<Scalars['String']>;
  /** Date onwards which employee was not assigned in the squad */
  endDate?: Maybe<Scalars['DateTime']>;
  /** Consultant's worklog hour overview */
  hourOverview: IHourOverviewResponseDto;
  /** Consultant's past involvement history in the squad */
  involvementHistory?: Maybe<Array<Maybe<IInvolvementHistoryResponseDto>>>;
  /** Consultant's involvement status in the squad */
  involvementStatus?: Maybe<Scalars['String']>;
  /** Date on which employee joined the squad */
  joinedDate?: Maybe<Scalars['DateTime']>;
  /** Squad ID */
  squadId: Scalars['String'];
  /** Name of the squad */
  squadName: Scalars['String'];
  /** Type of the Squad */
  squadType: Scalars['String'];
}

export enum IAssignedStatus {
  ASSIGNED = 'ASSIGNED',
  NOT_ASSIGNED = 'NOT_ASSIGNED'
}

export interface IAvailability {
  availabiltyForWork?: Maybe<Scalars['String']>;
  currentSalary?: Maybe<ICurrentSalary>;
  hoursPerweek?: Maybe<Scalars['Float']>;
  isAvailable?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['String']>;
}

export interface IAvailabilityOptionsResponseDto {
  label?: Maybe<Scalars['String']>;
  values?: Maybe<Array<Maybe<Scalars['String']>>>;
}

export enum IAvailabilityStatus {
  AVAILABLE = 'AVAILABLE',
  PARTIALLY_AVAILABLE = 'PARTIALLY_AVAILABLE',
  UNAVAILABLE = 'UNAVAILABLE'
}

export interface IAvailableSquadRoles {
  assigned?: Maybe<Array<IEmployeeInfo>>;
  assignedCandidates?: Maybe<Scalars['Float']>;
  considered?: Maybe<Array<IAvailableSquadRolesDto>>;
  countSquads?: Maybe<Scalars['Float']>;
  totalCandidates?: Maybe<Scalars['Float']>;
  unassigned?: Maybe<Array<IAvailableSquadRolesDto>>;
}

export interface IAvailableSquadRolesDto {
  createdBy?: Maybe<Scalars['String']>;
  department?: Maybe<Scalars['String']>;
  departmentId?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['DateTime']>;
  estimatedEndDate?: Maybe<Scalars['DateTime']>;
  estimatedStartDate?: Maybe<Scalars['DateTime']>;
  experienceLevel?: Maybe<Scalars['String']>;
  goodToHaveSkills?: Maybe<Array<Scalars['String']>>;
  isJobTemplateSaved?: Maybe<Scalars['Boolean']>;
  isRequestedForHire?: Maybe<Scalars['Boolean']>;
  jobType?: Maybe<Scalars['String']>;
  locationToBeHiredFrom?: Maybe<Array<Scalars['String']>>;
  numberOfCandidates?: Maybe<Scalars['Float']>;
  offboardingCandidate?: Maybe<Scalars['Float']>;
  phasesAssigned?: Maybe<Array<Scalars['String']>>;
  priority?: Maybe<IPriorityEnum>;
  probableCandidates?: Maybe<Array<IProbableCandidatesDto>>;
  rate?: Maybe<Scalars['Float']>;
  region?: Maybe<Array<Scalars['String']>>;
  requiredForKickOff?: Maybe<Scalars['Boolean']>;
  requiredSkills?: Maybe<Array<Scalars['String']>>;
  role?: Maybe<Scalars['String']>;
  roleDescription?: Maybe<Scalars['String']>;
  softSkills?: Maybe<Array<Scalars['String']>>;
  squadResourceId?: Maybe<Scalars['String']>;
  squadRoleId?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  ticketId?: Maybe<Scalars['String']>;
  timeZone?: Maybe<Array<Scalars['String']>>;
  workingHour?: Maybe<Scalars['Float']>;
  yearsOfExperience?: Maybe<Scalars['Float']>;
}

export interface IBatchCommentResponseDto {
  addedOn: Scalars['DateTime'];
  content: Scalars['String'];
  user: ICommentUserResponseDto;
}

export interface IBenchStatusResponseDto {
  benchStatus?: Maybe<Array<Maybe<Scalars['String']>>>;
  benchType?: Maybe<Scalars['String']>;
}

export interface IBillingCycle {
  billingAmount?: Maybe<Scalars['String']>;
  billingType?: Maybe<Scalars['String']>;
}

export interface IBillingCycleOption {
  billingAmount: Scalars['String'];
  billingType: Scalars['String'];
}

export interface IBillingOption {
  billingAmount?: Maybe<Scalars['String']>;
  billingType?: Maybe<Scalars['String']>;
}

export interface IBulkCvUpdateResponse {
  clashedName: Array<Scalars['String']>;
  matchedName: Array<Scalars['String']>;
  notMatchedName: Array<Scalars['String']>;
}

export enum ICombined_Permissions {
  ADD_ALL_SQUADS_APPROVERS = 'ADD_ALL_SQUADS_APPROVERS',
  ADD_ASSIGNED_SQUAD_APPROVERS = 'ADD_ASSIGNED_SQUAD_APPROVERS',
  ADD_CANDIDATE = 'ADD_CANDIDATE',
  ADD_CANDIDATE_DOCUMENT = 'ADD_CANDIDATE_DOCUMENT',
  ADD_CANDIDATE_NOTE = 'ADD_CANDIDATE_NOTE',
  ADD_CLIENT = 'ADD_CLIENT',
  ADD_CONTRIBUTOR = 'ADD_CONTRIBUTOR',
  ADD_EMPLOYEES = 'ADD_EMPLOYEES',
  ADD_JOB = 'ADD_JOB',
  ADD_MODULE = 'ADD_MODULE',
  ADD_ORG_PERMISSION_GROUP = 'ADD_ORG_PERMISSION_GROUP',
  ADD_ORG_PERSONA = 'ADD_ORG_PERSONA',
  ADD_PERMISSION_GROUP = 'ADD_PERMISSION_GROUP',
  ADD_PERMISSION_TO_ORG_PERMISSION_GROUP = 'ADD_PERMISSION_TO_ORG_PERMISSION_GROUP',
  ADD_PERMISSION_TO_PERMISSION_GROUP = 'ADD_PERMISSION_TO_PERMISSION_GROUP',
  ADD_PERSONA = 'ADD_PERSONA',
  ADD_USERS_IN_PERSONA = 'ADD_USERS_IN_PERSONA',
  ALLOW_EXPORT_WORKLOGS = 'ALLOW_EXPORT_WORKLOGS',
  ALLOW_GENERATE_INVOICE = 'ALLOW_GENERATE_INVOICE',
  ANALYTICS = 'ANALYTICS',
  ARCHIVE_JOB = 'ARCHIVE_JOB',
  AR_STATUS = 'AR_STATUS',
  AR_STATUS_EDIT = 'AR_STATUS_EDIT',
  ASSIGNED_RESOURCES = 'ASSIGNED_RESOURCES',
  ASSIGN_PERSONA_AND_PERMISSION_GROUP_TO_ORG_USERS = 'ASSIGN_PERSONA_AND_PERMISSION_GROUP_TO_ORG_USERS',
  ASSIGN_PERSONA_AND_PERMISSION_GROUP_TO_USERS = 'ASSIGN_PERSONA_AND_PERMISSION_GROUP_TO_USERS',
  CHANGE_ALL_SQUADS_DEFAULT_APPROVERS = 'CHANGE_ALL_SQUADS_DEFAULT_APPROVERS',
  CHANGE_ASSIGNED_SQUAD_DEFAULT_APPROVERS = 'CHANGE_ASSIGNED_SQUAD_DEFAULT_APPROVERS',
  CHANGE_CANDIDATE_STATUS = 'CHANGE_CANDIDATE_STATUS',
  CLIENT_ASSIGNED_RESOURCES = 'CLIENT_ASSIGNED_RESOURCES',
  CLIENT_CONTACTS = 'CLIENT_CONTACTS',
  CLIENT_DETAILS = 'CLIENT_DETAILS',
  CLIENT_LIST = 'CLIENT_LIST',
  CLIENT_RATE = 'CLIENT_RATE',
  CLOSE_JOB = 'CLOSE_JOB',
  CM = 'CM',
  CM_SQUAD_LIST = 'CM_SQUAD_LIST',
  COMMENT_ALL_SQUADS_WORKLOGS = 'COMMENT_ALL_SQUADS_WORKLOGS',
  COMMENT_ASSIGNED_SQUAD_WORKLOGS = 'COMMENT_ASSIGNED_SQUAD_WORKLOGS',
  CONSIDERED_RESOURCES = 'CONSIDERED_RESOURCES',
  CREATE_ADDITIONAL_NOTES = 'CREATE_ADDITIONAL_NOTES',
  CREATE_ROLES_IN_SQUAD = 'CREATE_ROLES_IN_SQUAD',
  CREATE_SQUAD = 'CREATE_SQUAD',
  CREATE_WORKLOG = 'CREATE_WORKLOG',
  DB_ADMIN = 'DB_ADMIN',
  DELETE_CANDIDATE = 'DELETE_CANDIDATE',
  DELETE_CANDIDATE_DOCUMENT = 'DELETE_CANDIDATE_DOCUMENT',
  DELETE_CANDIDATE_NOTE = 'DELETE_CANDIDATE_NOTE',
  DELETE_ORG_PERMISSION_GROUP = 'DELETE_ORG_PERMISSION_GROUP',
  DELETE_ORG_PERSONA = 'DELETE_ORG_PERSONA',
  DELETE_PERMISSION_GROUP = 'DELETE_PERMISSION_GROUP',
  DELETE_PERSONA = 'DELETE_PERSONA',
  DELETE_WORKLOG = 'DELETE_WORKLOG',
  DISABLE_USERS_IN_PERSONA = 'DISABLE_USERS_IN_PERSONA',
  DOWNLOAD_CANDIDATE_DOCUMENT = 'DOWNLOAD_CANDIDATE_DOCUMENT',
  DUPLICATE_JOB = 'DUPLICATE_JOB',
  ECMA = 'ECMA',
  EDIT_CANDIDATE_NOTE = 'EDIT_CANDIDATE_NOTE',
  EDIT_MODULE = 'EDIT_MODULE',
  EDIT_PERMISSION_GROUP = 'EDIT_PERMISSION_GROUP',
  EDIT_PERSONA = 'EDIT_PERSONA',
  EDIT_USERS_IN_PERSONA = 'EDIT_USERS_IN_PERSONA',
  EMPLOYEE_CSV = 'EMPLOYEE_CSV',
  EMPLOYEE_PROFILE = 'EMPLOYEE_PROFILE',
  EMPLOYEE_PROFILE_VIEW_ONLY = 'EMPLOYEE_PROFILE_VIEW_ONLY',
  EMP_LIST = 'EMP_LIST',
  EMP_RATE = 'EMP_RATE',
  EXPORT_CANDIDATE = 'EXPORT_CANDIDATE',
  EXPORT_EMPLOYEE_LIST = 'EXPORT_EMPLOYEE_LIST',
  HIRE = 'HIRE',
  HUBSPOT_ACCESS = 'HUBSPOT_ACCESS',
  LATEST_STATUS = 'LATEST_STATUS',
  LIST_NOTES = 'LIST_NOTES',
  LIST_RESOURCES = 'LIST_RESOURCES',
  MANAGE = 'MANAGE',
  MANAGE_PERMISSIONS = 'MANAGE_PERMISSIONS',
  MODIFY_ALL_SQUADS_WORKLOG_INFO = 'MODIFY_ALL_SQUADS_WORKLOG_INFO',
  MODIFY_ASSIGNED_SQUADS_WORKLOG_INFO = 'MODIFY_ASSIGNED_SQUADS_WORKLOG_INFO',
  MODIFY_EMPLOYEE_ID = 'MODIFY_EMPLOYEE_ID',
  OFFBOARD_ONBOARD = 'OFFBOARD_ONBOARD',
  OPEN_JOB = 'OPEN_JOB',
  PERMISSIONS_LIST = 'PERMISSIONS_LIST',
  PERMISSION_GROUPS = 'PERMISSION_GROUPS',
  PERSONA = 'PERSONA',
  PERSONA_PERMISSION_LIST_TAB = 'PERSONA_PERMISSION_LIST_TAB',
  PERSONA_USER_LIST_TAB = 'PERSONA_USER_LIST_TAB',
  POC = 'POC',
  READ_SQUAD_INFO = 'READ_SQUAD_INFO',
  READ_WORKLOG = 'READ_WORKLOG',
  REMOVE_ALL_SQUADS_ADDITIONAL_APPROVERS = 'REMOVE_ALL_SQUADS_ADDITIONAL_APPROVERS',
  REMOVE_ASSIGNED_DEVICE = 'REMOVE_ASSIGNED_DEVICE',
  REMOVE_ASSIGNED_SQUAD_ADDITIONAL_APPROVERS = 'REMOVE_ASSIGNED_SQUAD_ADDITIONAL_APPROVERS',
  REMOVE_PERMISSION_FROM_ORG_PERMISSION_GROUP = 'REMOVE_PERMISSION_FROM_ORG_PERMISSION_GROUP',
  REMOVE_PERMISSION_FROM_PERMISSION_GROUP = 'REMOVE_PERMISSION_FROM_PERMISSION_GROUP',
  REMOVE_USER_SQUAD_HISTORY = 'REMOVE_USER_SQUAD_HISTORY',
  REOPEN_WORKLOG = 'REOPEN_WORKLOG',
  REQUEST_TO_HIRE = 'REQUEST_TO_HIRE',
  REQUIRED_RESOURCES = 'REQUIRED_RESOURCES',
  RM = 'RM',
  RR_ASSIGN_RESOURCES = 'RR_ASSIGN_RESOURCES',
  SM = 'SM',
  SM_ADD_RESOURCE = 'SM_ADD_RESOURCE',
  SM_EDIT_SQUAD = 'SM_EDIT_SQUAD',
  SM_START_DATE = 'SM_START_DATE',
  SM_STATUS = 'SM_STATUS',
  SQUAD_BREAKDOWN = 'SQUAD_BREAKDOWN',
  SQUAD_BUDGET = 'SQUAD_BUDGET',
  SQUAD_CSV = 'SQUAD_CSV',
  SQUAD_DETAILS = 'SQUAD_DETAILS',
  SQUAD_ROLES_COUNT = 'SQUAD_ROLES_COUNT',
  UM_USERS = 'UM_USERS',
  UNARCHIVE_JOB = 'UNARCHIVE_JOB',
  UPDATE_ADDITIONAL_NOTES = 'UPDATE_ADDITIONAL_NOTES',
  UPDATE_ASSIGNED_DEVICE = 'UPDATE_ASSIGNED_DEVICE',
  UPDATE_CANDIDATE = 'UPDATE_CANDIDATE',
  UPDATE_CERTIFICATE = 'UPDATE_CERTIFICATE',
  UPDATE_CLIENT_STATUS = 'UPDATE_CLIENT_STATUS',
  UPDATE_EDUCATION = 'UPDATE_EDUCATION',
  UPDATE_EMPLOYEE_SKILLS = 'UPDATE_EMPLOYEE_SKILLS',
  UPDATE_EMPLOYEE_SQUADS = 'UPDATE_EMPLOYEE_SQUADS',
  UPDATE_JOB_EXPERIENCE = 'UPDATE_JOB_EXPERIENCE',
  UPDATE_PERSONAL_INFO = 'UPDATE_PERSONAL_INFO',
  UPDATE_SQUAD = 'UPDATE_SQUAD',
  UPDATE_SUPERVISOR = 'UPDATE_SUPERVISOR',
  UPDATE_WORKLOG = 'UPDATE_WORKLOG',
  UPDATE_WORK_INFO = 'UPDATE_WORK_INFO',
  UPLOAD_BULK_CSV = 'UPLOAD_BULK_CSV',
  USER_MANAGEMENT = 'USER_MANAGEMENT',
  VIEW_ADDITIONAL_NOTES = 'VIEW_ADDITIONAL_NOTES',
  VIEW_ALL_SQUADS_APPROVERS = 'VIEW_ALL_SQUADS_APPROVERS',
  VIEW_ALL_SQUADS_INVOICING_PERIODS = 'VIEW_ALL_SQUADS_INVOICING_PERIODS',
  VIEW_ALL_SQUADS_LIST = 'VIEW_ALL_SQUADS_LIST',
  VIEW_ALL_SQUADS_WORKLOG_COMMENTS = 'VIEW_ALL_SQUADS_WORKLOG_COMMENTS',
  VIEW_ALL_SQUADS_WORKLOG_INFO = 'VIEW_ALL_SQUADS_WORKLOG_INFO',
  VIEW_ASSIGNED_SQUADS_LIST = 'VIEW_ASSIGNED_SQUADS_LIST',
  VIEW_ASSIGNED_SQUADS_WORKLOG_INFO = 'VIEW_ASSIGNED_SQUADS_WORKLOG_INFO',
  VIEW_ASSIGNED_SQUAD_APPROVERS = 'VIEW_ASSIGNED_SQUAD_APPROVERS',
  VIEW_ASSIGNED_SQUAD_INVOICING_PERIODS = 'VIEW_ASSIGNED_SQUAD_INVOICING_PERIODS',
  VIEW_ASSIGNED_SQUAD_WORKLOG_COMMENTS = 'VIEW_ASSIGNED_SQUAD_WORKLOG_COMMENTS',
  VIEW_CANDIDATE = 'VIEW_CANDIDATE',
  VIEW_CANDIDATES_LIST = 'VIEW_CANDIDATES_LIST',
  VIEW_JOB_DETAILS = 'VIEW_JOB_DETAILS',
  VIEW_JOB_LIST = 'VIEW_JOB_LIST',
  VIEW_ORG_PERMISSION_GROUPS = 'VIEW_ORG_PERMISSION_GROUPS',
  VIEW_ORG_PERSONAS = 'VIEW_ORG_PERSONAS',
  VIEW_PERMISSION_GROUPS_LIST = 'VIEW_PERMISSION_GROUPS_LIST',
  VIEW_PERMISSION_GROUP_DETAIL = 'VIEW_PERMISSION_GROUP_DETAIL',
  VIEW_PERSONA_DETAIL = 'VIEW_PERSONA_DETAIL',
  VIEW_PERSONA_LIST = 'VIEW_PERSONA_LIST',
  VIEW_RESUME = 'VIEW_RESUME',
  VIEW_USERS_LIST = 'VIEW_USERS_LIST',
  WORKLOG = 'WORKLOG'
}

export interface ICsvResponse {
  email: Scalars['String'];
  message: Scalars['String'];
}

export interface ICandidateAdvancedList {
  candidates: Array<ICandidateInfoObject>;
  totalPages: Scalars['Float'];
}

export interface ICandidateAdvancedSearchDto {
  candidateStatus?: Maybe<Array<Scalars['String']>>;
  endDate?: Maybe<Scalars['String']>;
  page: Scalars['Float'];
  roles?: Maybe<Array<Scalars['String']>>;
  searchText: Scalars['String'];
  size: Scalars['Float'];
  sortBy: Scalars['String'];
  sortOrder: Scalars['String'];
  startDate?: Maybe<Scalars['String']>;
}

export interface ICandidateDocuments {
  docUrl: Scalars['String'];
  originalFileName: Scalars['String'];
  timeStamp: Scalars['DateTime'];
  uploadedBy: Scalars['String'];
}

export interface ICandidateDocumentsInput {
  docUrl: Scalars['String'];
  originalFileName: Scalars['String'];
  timeStamp: Scalars['DateTime'];
  uploadedBy: Scalars['String'];
}

export interface ICandidateInfo {
  address?: Maybe<Scalars['String']>;
  email?: Maybe<Array<Scalars['String']>>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  lastName?: Maybe<Scalars['String']>;
  latestEmployer?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  phone?: Maybe<Array<Scalars['String']>>;
  resumeUrl?: Maybe<Scalars['String']>;
  softSkills?: Maybe<Array<Scalars['String']>>;
  technicalSkills?: Maybe<Array<Scalars['String']>>;
  yearsOfExperience?: Maybe<Scalars['String']>;
}

export interface ICandidateInfoObject {
  candidateStatus?: Maybe<ICandidateStatus>;
  countryOfResidence?: Maybe<Scalars['String']>;
  dateAdded: Scalars['DateTime'];
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  githubUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  interviewEvaluation?: Maybe<IInterviewEvaluationOption>;
  lastName?: Maybe<Scalars['String']>;
  linkedinUrl?: Maybe<Scalars['String']>;
  optionExploring?: Maybe<IJobTypeAddcandidate>;
  originalFilename?: Maybe<Scalars['String']>;
  paymentOption?: Maybe<Array<IBillingOption>>;
  phoneNumber?: Maybe<Scalars['String']>;
  resumeUrl?: Maybe<Scalars['String']>;
  roles?: Maybe<Array<Scalars['String']>>;
  seekingNewRole?: Maybe<Scalars['Boolean']>;
  startDate?: Maybe<Scalars['DateTime']>;
  timeZone?: Maybe<Scalars['String']>;
}

export interface ICandidateJobBasicInfo {
  candidateStage: IJobCandidateStages;
  candidateStageStatus: Scalars['String'];
  email: Array<Scalars['String']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  middleName: Scalars['String'];
  phoneNumber: Array<Scalars['String']>;
  score: Scalars['Float'];
}

export interface ICandidateNoteType {
  _id: Scalars['String'];
  candidateId: Scalars['String'];
  candidateStage?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  creatorId: Scalars['String'];
  jobId: Scalars['String'];
  note: Scalars['String'];
  noteContext?: Maybe<Scalars['String']>;
  parentId?: Maybe<Scalars['String']>;
  parsedResumeId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  visibility: INoteVisibility;
}

export interface ICandidateNotes {
  _id: Scalars['String'];
  candidateId: Scalars['String'];
  candidateStage?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  creatorId: Scalars['String'];
  jobId: Scalars['String'];
  note: Scalars['String'];
  noteContext?: Maybe<Scalars['String']>;
  parentId?: Maybe<Scalars['String']>;
  parsedResumeId: Scalars['String'];
  replyCount: Scalars['Float'];
  updatedAt: Scalars['DateTime'];
  visibility: INoteVisibility;
}

export interface ICandidateParsedResumeInfo {
  address: Scalars['String'];
  email: Array<Scalars['String']>;
  firstName: Scalars['String'];
  id: Scalars['String'];
  lastName: Scalars['String'];
  latestEmployer: Scalars['String'];
  middleName: Scalars['String'];
  phone: Array<Scalars['String']>;
  resumeUrl?: Maybe<Scalars['String']>;
  softSkills: Array<Scalars['String']>;
  technicalSkills: Array<Scalars['String']>;
  yearsOfExperience: Scalars['String'];
}

export interface ICandidateProfileInfo {
  countryOfResidence: Scalars['String'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  githubUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  intervieweval: IInterviewEvaluationResponse;
  jobDescriptionFileName: Scalars['String'];
  jobDescriptionUrl: Scalars['String'];
  joinedDate?: Maybe<Scalars['DateTime']>;
  lastName: Scalars['String'];
  linkedinUrl?: Maybe<Scalars['String']>;
  optionExploring: Scalars['String'];
  originalFilename: Scalars['String'];
  paymentOption: Array<IBillingCycleOption>;
  phoneNumber?: Maybe<Scalars['String']>;
  profileImage?: Maybe<Scalars['String']>;
  resumeUrl: Scalars['String'];
  seekingNewRole: Scalars['Boolean'];
  skillsSet: ISkillsSetCandidateProifleInfo;
  startDate: Scalars['String'];
  timeZone?: Maybe<Scalars['String']>;
}

export interface ICandidateProfileResponse {
  jobDescription: Scalars['String'];
  resumeUrl: Scalars['String'];
}

export interface ICandidateSkillsResponse {
  id: Scalars['String'];
  mostProficientTechnologies: Array<Scalars['String']>;
  roles: Array<Scalars['String']>;
  selectedTechnologies: Array<Scalars['String']>;
  softSkills: Array<Scalars['String']>;
  somewhatProficientTechnologies: Array<Scalars['String']>;
  yearsOfExperienceInRole: Array<IYearsOfExperienceResponse>;
}

export interface ICandidateStageCountResponse {
  count: Scalars['Float'];
  stage: Scalars['String'];
}

export enum ICandidateStatus {
  ACCEPTED = 'ACCEPTED',
  DRAFTED = 'DRAFTED',
  INVITED = 'INVITED'
}

export interface ICandidates {
  active?: Maybe<Scalars['Float']>;
  hired?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
}

export interface ICategoryOverviewResponseDto {
  category: Scalars['String'];
  totalMinutes: Scalars['Int'];
}

export interface ICbuDepartmentsDto {
  cbu: Scalars['String'];
  departments: Array<Scalars['String']>;
}

export interface IChangeLogDto {
  _id?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  documentId?: Maybe<Scalars['String']>;
  modifications?: Maybe<IModificationsResponseDto>;
  modificationsArray?: Maybe<Array<Maybe<IModificationsResponseDto>>>;
  modifiedBy?: Maybe<IModifiedByResponseDto>;
  modifiedObject?: Maybe<IModifiedObjectResponseDto>;
  operationType?: Maybe<Scalars['String']>;
  userInfo?: Maybe<IUserInfoResponseDtoType>;
}

export interface IChartData {
  consultantEmployeeList: Array<IListData>;
  department: Scalars['String'];
  fuseMachineEmployeeList: Array<IListData>;
  totalCountOfDepartment?: Maybe<Scalars['Float']>;
}

export interface IClientDepartmentDto {
  clientId: Scalars['String'];
  name: Scalars['String'];
}

export interface IClientDetailDto {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
}

export interface IClientDto {
  accountExecutive?: Maybe<IAccountExecutiveDto>;
  annualRevenue?: Maybe<Scalars['Float']>;
  businessUnit?: Maybe<Scalars['String']>;
  buyingLeader?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  clientType: Scalars['String'];
  companyId: Scalars['String'];
  contactIds?: Maybe<Array<Scalars['String']>>;
  countSquads?: Maybe<Scalars['Float']>;
  country?: Maybe<Scalars['String']>;
  createdFromHubspot: Scalars['Boolean'];
  csatRating?: Maybe<Scalars['Float']>;
  deliveryManager?: Maybe<Scalars['String']>;
  domain: Scalars['String'];
  duLeader?: Maybe<Scalars['String']>;
  emailDomains?: Maybe<Array<Scalars['String']>>;
  hubspotClientType: Scalars['String'];
  id?: Maybe<Scalars['ID']>;
  itBudget: Scalars['Float'];
  legalEntity?: Maybe<Scalars['String']>;
  msa?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  nda?: Maybe<Scalars['Boolean']>;
  noOfEmployees?: Maybe<Scalars['String']>;
  npsScore?: Maybe<Scalars['Float']>;
  onboardingDate?: Maybe<Scalars['DateTime']>;
  orgId?: Maybe<Scalars['String']>;
  sow?: Maybe<Scalars['Boolean']>;
  startDate?: Maybe<Scalars['DateTime']>;
  state?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  streetAddress?: Maybe<Scalars['String']>;
  streetAddress2?: Maybe<Scalars['String']>;
  tier?: Maybe<Scalars['String']>;
  vertical?: Maybe<IVerticalInfoDto>;
}

export interface IClientFilterDto {
  /** search for clients by industries */
  industry?: Maybe<Array<Scalars['String']>>;
  /** search for clients having number of squads equal to */
  numberOfSquads?: Maybe<Scalars['Float']>;
  /** date to search for the onboarding date ending to */
  onboardEndDate?: Maybe<Scalars['String']>;
  /** date to search for the onboarding date starting from */
  onboardStartDate?: Maybe<Scalars['String']>;
  /** search for clients having resources equal to */
  overallEngineers?: Maybe<Scalars['Float']>;
  /** Any string or key you want to search for */
  searchKey?: Maybe<Scalars['String']>;
  /** search for clients having active or inactive status */
  status?: Maybe<IClientStatus>;
  /** search for client by vertical heads */
  verticalHead?: Maybe<Array<Scalars['String']>>;
  /** search for  clients by verticals */
  verticals?: Maybe<Array<Scalars['String']>>;
}

export interface IClientIdNameDto {
  /** Type of the client */
  clientType?: Maybe<Scalars['String']>;
  /** Flag to identify if client is created from Hubspot */
  createdFromHubspot?: Maybe<Scalars['String']>;
  /** Unique id of the client collection */
  id: Scalars['String'];
  /** Name of the client */
  name: Scalars['String'];
}

export interface IClientInfoDto {
  clientId?: Maybe<Scalars['String']>;
  clientName?: Maybe<Scalars['String']>;
}

export interface IClientInfoDtoPaged {
  /** List of fetched data */
  content: Array<IClientInfoDto>;
  /** Information about pagination */
  pageable: IPageable;
}

export interface IClientNameAndSquads {
  clientName?: Maybe<Scalars['String']>;
  squads?: Maybe<Array<Scalars['String']>>;
}

export interface IClientNameDto {
  _id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
}

export interface IClientNamesDto {
  name?: Maybe<Scalars['String']>;
}

export interface IClientRolesPagedResponse {
  /** List of fetched data */
  content: Array<IClientRolesResponseDto>;
  /** Information about pagination */
  pageable: IPageable;
}

export interface IClientRolesResponseDto {
  clientInfo?: Maybe<IClientInfoDto>;
  country?: Maybe<Array<Scalars['String']>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  inProgressCandidatesCount?: Maybe<Scalars['Float']>;
  involvementStatusForClients?: Maybe<Array<Scalars['String']>>;
  openCandidatesCount?: Maybe<Scalars['Float']>;
  probableCandidates?: Maybe<Array<IProbableCandidateInfoDto>>;
  probableCandidatesCount?: Maybe<Scalars['Float']>;
  requiredCount?: Maybe<Scalars['Float']>;
  reviewPendingCandidatesCount?: Maybe<Scalars['Float']>;
  role?: Maybe<Scalars['String']>;
  selectedCandidatesCount?: Maybe<Scalars['Float']>;
  squadId?: Maybe<Scalars['String']>;
  squadName?: Maybe<Scalars['String']>;
  squadResourceId: Scalars['String'];
  squadRoleId: Scalars['String'];
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<Scalars['String']>;
}

export interface IClientSpecificSquadsPaged {
  /** List of fetched data */
  content: Array<IClientOverviewSquadListDto>;
  /** Information about pagination */
  pageable: IPageable;
}

export interface IClientSquadDto {
  /** status of the squad like not started , running , delayed, completed or onhold */
  activeStatus?: Maybe<Scalars['String']>;
  /** client department id */
  clientDepartmentId?: Maybe<Scalars['String']>;
  /** id of the client */
  clientId: Scalars['String'];
  /** list of contact ids */
  contactIds?: Maybe<Array<Scalars['String']>>;
  /** if created in hubspot , will be true else false */
  createdFromHubspot?: Maybe<Scalars['Boolean']>;
  /** name of the squad */
  name: Scalars['String'];
  /** start date of the squad */
  startDate?: Maybe<Scalars['DateTime']>;
  /** type of the squad */
  type?: Maybe<Scalars['String']>;
}

export interface IClientSquadsResponseDto {
  /** Name of the client */
  clientName: Scalars['String'];
  /** list of client squads */
  squads?: Maybe<Array<Maybe<Scalars['String']>>>;
}

export enum IClientStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE'
}

export interface IClientVerticalInfo {
  industry?: Maybe<Scalars['String']>;
  vertical?: Maybe<Scalars['String']>;
  verticalLead?: Maybe<Scalars['String']>;
}

export interface IColumnMetadata {
  columnName: Scalars['String'];
  columnWidth: Scalars['Float'];
  isPinned: Scalars['Boolean'];
  isVisible: Scalars['Boolean'];
}

export interface IColumnMetadataInput {
  columnName: Scalars['String'];
  columnWidth?: Maybe<Scalars['Float']>;
  isPinned?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
}

export interface ICommentDto {
  addedOn?: Maybe<Scalars['DateTime']>;
  commentedBy?: Maybe<IUserInformationResponseDto>;
  content?: Maybe<Scalars['String']>;
}

export interface ICommentFilter {
  includeDrafts?: Maybe<Scalars['Boolean']>;
  invoicingEnd?: Maybe<Scalars['DateTime']>;
  invoicingStart?: Maybe<Scalars['DateTime']>;
  squadId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  worklogIds?: Maybe<Array<Scalars['String']>>;
}

export interface ICommentUserResponseDto {
  designation?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  profileImage?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
}

export interface IConstantKeyValueDto {
  constantType: ISquaderyConstantsEnum;
  key: Scalars['String'];
  value: Scalars['String'];
}

export interface IConsultantInfo {
  id: Scalars['String'];
  name: Scalars['String'];
}

export interface IContributingHiringMemberTypes {
  /** designation information of the user */
  designation?: Maybe<IDesignationDto>;
  /** email of the user */
  email: Scalars['String'];
  /** name of the user */
  fullname: Scalars['String'];
  /** unique id of user */
  id: Scalars['String'];
  /** role of the user */
  roles?: Maybe<Scalars['String']>;
}

export interface IContributingHiringMembers {
  id: Scalars['String'];
  isCreator: Scalars['Boolean'];
}

export interface IContributingMember {
  id: Scalars['String'];
  isCreator: Scalars['Boolean'];
}

export interface IContributingMemberDetailsDto {
  designation?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  fullname?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isCreator: Scalars['Boolean'];
}

export interface ICountSquadResponseDto {
  /** total number of squads based on filter or without filter */
  totalSquads: Scalars['Float'];
  /** total number of unassigned roles based on filter or without filter */
  totalUnassignedRoles: Scalars['Float'];
}

export interface ICountryDto {
  currencyCode: Scalars['String'];
  name: Scalars['String'];
}

export interface ICreateAdditionalNoteDto {
  /** User Squad History ID.This field is required. */
  involvementHistoryId?: Maybe<Scalars['String']>;
  /** History of changes made */
  modifications?: Maybe<Array<IModificationsInput>>;
  /** Note/comments. This field is required */
  note: Scalars['String'];
  /** Type of Note. Available Type can be viewed in AdditionalNoteTypeEnum.This field is required. */
  noteType: IAdditionalNoteTypeEnum;
  /** Changed Involvement status of the employee.Available InvolvementStatus can be viewed in InvolvementStatus enum.This field is required */
  status: Scalars['String'];
  /** User Squad History ID.This field is required. */
  userSquadHistoryId: Scalars['String'];
}

export interface ICreateClientContactDto {
  active?: Maybe<Scalars['Boolean']>;
  buyingRole?: Maybe<Scalars['String']>;
  clientDepartmentId?: Maybe<Scalars['String']>;
  clientId?: Maybe<Scalars['String']>;
  contactId?: Maybe<Scalars['String']>;
  designation?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  number?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
}

export interface ICreateClientDto {
  clientType: Scalars['String'];
  createdFromHubspot?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  startDate: Scalars['DateTime'];
  status: Scalars['String'];
}

export interface ICreateDepartmentHodDto {
  associatedCountry?: Maybe<Scalars['String']>;
  departmentHOD?: Maybe<Scalars['String']>;
  departmentHODEmail?: Maybe<Scalars['String']>;
  departmentId?: Maybe<Scalars['String']>;
  departmentName?: Maybe<Scalars['String']>;
  managingDirector?: Maybe<Scalars['String']>;
}

export interface ICreateDepartmentHodDtoReq {
  associatedCountry?: Maybe<Scalars['String']>;
  departmentHOD?: Maybe<Scalars['String']>;
  departmentHODEmail?: Maybe<Scalars['String']>;
  departmentId?: Maybe<Scalars['String']>;
  departmentName?: Maybe<Scalars['String']>;
  managingDirector?: Maybe<Scalars['String']>;
}

export interface ICreateEmployeeRespDto {
  profileId: Scalars['String'];
  userId: Scalars['String'];
}

export interface ICreateJobDescriptionTemplate {
  createdBy: Scalars['String'];
  jobDescription: Scalars['String'];
  title: Scalars['String'];
}

export interface ICreateNoteDto {
  candidateStage?: Maybe<Scalars['String']>;
  createdBy: Scalars['String'];
  note: Scalars['String'];
  noteContext?: Maybe<Scalars['String']>;
  parentId?: Maybe<Scalars['String']>;
  parsedResumeId: Scalars['String'];
  visibility?: Maybe<INoteVisibility>;
}

export interface ICreatePermissionGroupResp {
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  orgId: Scalars['String'];
  permissions: Array<Scalars['String']>;
}

export interface ICreateRecipientGroupInput {
  groupName: IRecipientGroupEnum;
  members: Array<Maybe<IRecipientInputType>>;
}

export interface ICreateRoleDto {
  /** list of countries */
  country?: Maybe<Array<Scalars['String']>>;
  /** department related to role */
  department: Scalars['String'];
  departmentId?: Maybe<Scalars['String']>;
  /** end date for the job */
  endDate?: Maybe<Scalars['DateTime']>;
  /** level of experience */
  experienceLevel: IEmployeeLevel;
  /** skills which is good to have for the role */
  goodToHaveSkills?: Maybe<Array<Scalars['String']>>;
  /** type of job */
  jobType: Scalars['String'];
  phases?: Maybe<Scalars['String']>;
  /** priority for the job */
  priority?: Maybe<IPriorityEnum>;
  /** rates per hour */
  rate?: Maybe<Scalars['Float']>;
  /** total number of resources required */
  requiredCount?: Maybe<Scalars['Float']>;
  /** will be true if immediately required else false */
  requiredForKickOff?: Maybe<Scalars['Boolean']>;
  /** total number of resources required */
  requiredSkills?: Maybe<Array<Scalars['String']>>;
  /** role name for the job */
  role: Scalars['String'];
  /** job description */
  roleDescription: Scalars['String'];
  /** soft skills */
  softSkills?: Maybe<Array<Scalars['String']>>;
  /** id of the squad for which role is being created */
  squadId: Scalars['String'];
  /** start date for the job */
  startDate?: Maybe<Scalars['DateTime']>;
  /** time zone in where resources are required to work */
  timeZone?: Maybe<Array<Scalars['String']>>;
  /** hours per week */
  workingHour?: Maybe<Scalars['Float']>;
  /** years of experience required */
  yearsOfExperience?: Maybe<Scalars['Float']>;
}

export interface ICreateTrainingCertificateDto {
  certificateId?: Maybe<Scalars['String']>;
  certificateTitle?: Maybe<Scalars['String']>;
  currentlyStudying?: Maybe<Scalars['Boolean']>;
  endDate?: Maybe<Scalars['DateTime']>;
  instructor?: Maybe<Scalars['String']>;
  issuingInstituionOrOrganization?: Maybe<Scalars['String']>;
  profileId: Scalars['String'];
  startDate: Scalars['DateTime'];
  uploads?: Maybe<Array<Maybe<IUploadInputType>>>;
}

export interface ICreateUpdateCronControlInput {
  activeStatus?: Maybe<Scalars['Boolean']>;
  cronType?: Maybe<ICronTypeEnum>;
  frequency: Scalars['String'];
}

export interface ICreateUpdateSkillDto {
  id?: Maybe<Scalars['String']>;
  mostPSkills?: Maybe<Array<ISkillDetail>>;
  profileId?: Maybe<Scalars['String']>;
  softSkills?: Maybe<Array<ISkillDetail>>;
  someWhatPSkills?: Maybe<Array<ISkillDetail>>;
  userId?: Maybe<Scalars['String']>;
}

export interface ICreateUpdateSkillDtoReq {
  id?: Maybe<Scalars['String']>;
  mostPSkills?: Maybe<Array<ISkillDetailReq>>;
  profileId?: Maybe<Scalars['String']>;
  softSkills?: Maybe<Array<ISkillDetailReq>>;
  someWhatPSkills?: Maybe<Array<ISkillDetailReq>>;
  userId?: Maybe<Scalars['String']>;
}

export interface ICreateUserSettingDtoInput {
  orgId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  worklogReminder?: Maybe<IWorklogReminder>;
}

export interface ICreateUserSettingType {
  id?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  worklogReminder?: Maybe<IWorklogReminder>;
}

export interface ICreateUserSettingTypeInput {
  id?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  worklogReminder?: Maybe<IWorklogReminder>;
}

export interface ICreateWorkExperienceInput {
  company: Scalars['String'];
  companyAddress?: Maybe<Scalars['String']>;
  profileId: Scalars['String'];
  userId: Scalars['String'];
  workExperienceId?: Maybe<Scalars['String']>;
  workHistory: Array<IWorkHistoryInput>;
}

export interface ICreatedByUserInfoDto {
  email: Scalars['String'];
  fullname: Scalars['String'];
  profileId: Scalars['String'];
  profileImage?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
}

export interface ICronControlResponseObjectType {
  cronType: ICronTypeEnum;
  isRunning: Scalars['Boolean'];
}

export enum ICronTypeEnum {
  CRON_EMAIL_NOTIFICATION_EMPLOYEE_OFFBOARDING_PRIOR_1_DAY = 'CRON_EMAIL_NOTIFICATION_EMPLOYEE_OFFBOARDING_PRIOR_1_DAY',
  CRON_EMAIL_NOTIFICATION_EMPLOYEE_OFFBOARDING_PRIOR_7_DAYS = 'CRON_EMAIL_NOTIFICATION_EMPLOYEE_OFFBOARDING_PRIOR_7_DAYS',
  CRON_EMAIL_NOTIFICATION_ENDING_SQUAD_PRIOR_1_DAY = 'CRON_EMAIL_NOTIFICATION_ENDING_SQUAD_PRIOR_1_DAY',
  CRON_EMAIL_NOTIFICATION_ENDING_SQUAD_PRIOR_30_DAYS = 'CRON_EMAIL_NOTIFICATION_ENDING_SQUAD_PRIOR_30_DAYS',
  CRON_EMAIL_NOTIFICATION_SEND_EMAILS = 'CRON_EMAIL_NOTIFICATION_SEND_EMAILS',
  CRON_REGISTER_ON_BOOT = 'CRON_REGISTER_ON_BOOT',
  CRON_WORKLOG_EMAIL_NOTIFICATION = 'CRON_WORKLOG_EMAIL_NOTIFICATION'
}

export interface ICurrentSalary {
  amount?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['String']>;
  salaryType?: Maybe<Scalars['String']>;
}

export interface ICurrentSquad {
  allocatedHours?: Maybe<Scalars['Float']>;
  clientId?: Maybe<Scalars['String']>;
  clientName?: Maybe<Scalars['String']>;
  employeementType?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['DateTime']>;
  jobType?: Maybe<IJobTypeEnum>;
  joinedDate?: Maybe<Scalars['DateTime']>;
  squadId?: Maybe<Scalars['String']>;
  squadName?: Maybe<Scalars['String']>;
}

export interface ICurrentSquads {
  allocatedHours?: Maybe<Scalars['Float']>;
  clientId: Scalars['String'];
  clientName: Scalars['String'];
  involvedAs?: Maybe<Scalars['String']>;
  involvementStatus?: Maybe<Scalars['String']>;
  jobType?: Maybe<IJobTypeEnum>;
  squadHistoryId?: Maybe<Scalars['String']>;
  squadId: Scalars['String'];
  squadName?: Maybe<Scalars['String']>;
  squadType?: Maybe<Scalars['String']>;
}

export interface ICurrentWorkInfoDto {
  billable?: Maybe<Scalars['Boolean']>;
  /** Employee's sub department details */
  department?: Maybe<IDepartmentDto>;
  /** Employee's deployment/availability status */
  deploymentStatus?: Maybe<IDeploymentStatus>;
  /** Employee's designation. */
  designation?: Maybe<Scalars['String']>;
  /** Squadery employee ID */
  employeeId?: Maybe<Scalars['String']>;
  employeementType?: Maybe<IFuseEmployeementType>;
  /** Job type */
  jobType?: Maybe<Scalars['String']>;
  /** Employee's seniority level. */
  level?: Maybe<IEmployeeLevel>;
  /** Employee's main department */
  mainDepartment?: Maybe<Scalars['String']>;
  /** Employee's options exploring */
  optionExploring?: Maybe<Scalars['String']>;
  /** Employee's roles */
  roles?: Maybe<Array<Scalars['String']>>;
  /** Employee's work shift */
  workShift?: Maybe<Scalars['String']>;
}

export interface ICustomQueryFieldReq {
  fields?: Maybe<Array<IFieldDescriptionsReq>>;
  listName: Scalars['String'];
}

export interface ICustomQueryFieldResp {
  fields?: Maybe<Array<IFieldDescriptionsResp>>;
  listName: Scalars['String'];
}

export interface IDbCronObject {
  _id: Scalars['String'];
  activeStatus: Scalars['Boolean'];
  cronType: Scalars['String'];
  frequency: Scalars['String'];
}

export interface IDashboardAnalyticsDto {
  partiallyDeployable: Scalars['Int'];
  totalDeployable: Scalars['Int'];
  totalNoOfActiveConsultant: Scalars['Int'];
  totalNoOfActiveConsultantCoreFullTime: Scalars['Int'];
  totalNoOfActiveConsultantCorePartTime: Scalars['Int'];
  totalNoOfAssigned: Scalars['Int'];
  totalNoOfClientBillableProjectCore: Scalars['Int'];
  totalNoOfClientBillableProjectCoreFullTime: Scalars['Int'];
  totalNoOfClientBillableProjectCorePartTime: Scalars['Int'];
  totalNoOfClientNonBillableProjectShadow: Scalars['Int'];
  totalNoOfClientNonBillableProjectShadowFullTime: Scalars['Int'];
  totalNoOfClientNonBillableProjectShadowPartTime: Scalars['Int'];
  totalNoOfClientNonBillableProjectSupport: Scalars['Int'];
  totalNoOfClientNonBillableProjectSupportFullTime: Scalars['Int'];
  totalNoOfClientNonBillableProjectSupportPartTime: Scalars['Int'];
  totalNoOfEmployees: Scalars['Int'];
  totalNoOfInactiveConsultant: Scalars['Int'];
  totalNoOfInternalProjectCoreFullTime: Scalars['Int'];
  totalNoOfInternalProjectCorePartTime: Scalars['Int'];
  totalNoOfInternalProjectShadowFullTime: Scalars['Int'];
  totalNoOfInternalProjectShadowPartTime: Scalars['Int'];
  totalNoOfInternalProjectSupportFullTime: Scalars['Int'];
  totalNoOfInternalProjectSupportPartTime: Scalars['Int'];
  totalNoOfOnBench: Scalars['Int'];
  totalNoOfUnassigned: Scalars['Int'];
  totalNofOfInternalProjectCore: Scalars['Int'];
  totalNofOfInternalProjectShadow: Scalars['Int'];
  totalNofOfInternalProjectSupport: Scalars['Int'];
}

export enum IDashboardAnalyticsEmployeeListDataType {
  CLIENT_BILLABLE_CORE_FULL_TIME = 'CLIENT_BILLABLE_CORE_FULL_TIME',
  CLIENT_BILLABLE_CORE_PART_TIME = 'CLIENT_BILLABLE_CORE_PART_TIME',
  CLIENT_NON_BILLABLE_SHADOW_FULL_TIME = 'CLIENT_NON_BILLABLE_SHADOW_FULL_TIME',
  CLIENT_NON_BILLABLE_SHADOW_PART_TIME = 'CLIENT_NON_BILLABLE_SHADOW_PART_TIME',
  CLIENT_NON_BILLABLE_SUPPORT_FULL_TIME = 'CLIENT_NON_BILLABLE_SUPPORT_FULL_TIME',
  CLIENT_NON_BILLABLE_SUPPORT_PART_TIME = 'CLIENT_NON_BILLABLE_SUPPORT_PART_TIME',
  CLIENT_TOTAL = 'CLIENT_TOTAL',
  CLIENT_TOTAL_BILLABLE = 'CLIENT_TOTAL_BILLABLE',
  CLIENT_TOTAL_NON_BILLABLE = 'CLIENT_TOTAL_NON_BILLABLE',
  CLIENT_TOTAL_NON_BILLABLE_SHADOW = 'CLIENT_TOTAL_NON_BILLABLE_SHADOW',
  CLIENT_TOTAL_NON_BILLABLE_SUPPORT = 'CLIENT_TOTAL_NON_BILLABLE_SUPPORT',
  CONSULTANT_CORE_FULL_TIME = 'CONSULTANT_CORE_FULL_TIME',
  CONSULTANT_CORE_PART_TIME = 'CONSULTANT_CORE_PART_TIME',
  CONSULTANT_POOL = 'CONSULTANT_POOL',
  FUSE_EMPLOYEE_ASSIGNED = 'FUSE_EMPLOYEE_ASSIGNED',
  FUSE_EMPLOYEE_NOT_ASSIGNED = 'FUSE_EMPLOYEE_NOT_ASSIGNED',
  FUSE_EMPLOYEE_ON_BENCH = 'FUSE_EMPLOYEE_ON_BENCH',
  FUSE_EMPLOYEE_PARTIALLY_DEPLOYABLE = 'FUSE_EMPLOYEE_PARTIALLY_DEPLOYABLE',
  FUSE_EMPLOYEE_TOTAL = 'FUSE_EMPLOYEE_TOTAL',
  FUSE_EMPLOYEE_TOTAL_DEPLOYABLE = 'FUSE_EMPLOYEE_TOTAL_DEPLOYABLE',
  INTERNAL_CORE_FULL_TIME = 'INTERNAL_CORE_FULL_TIME',
  INTERNAL_CORE_PART_TIME = 'INTERNAL_CORE_PART_TIME',
  INTERNAL_SHADOW_FULL_TIME = 'INTERNAL_SHADOW_FULL_TIME',
  INTERNAL_SHADOW_PART_TIME = 'INTERNAL_SHADOW_PART_TIME',
  INTERNAL_SUPPORT_FULL_TIME = 'INTERNAL_SUPPORT_FULL_TIME',
  INTERNAL_SUPPORT_PART_TIME = 'INTERNAL_SUPPORT_PART_TIME',
  INTERNAL_TOTAL = 'INTERNAL_TOTAL',
  INTERNAL_TOTAL_CORE = 'INTERNAL_TOTAL_CORE',
  INTERNAL_TOTAL_SHADOW = 'INTERNAL_TOTAL_SHADOW',
  INTERNAL_TOTAL_SUPPORT = 'INTERNAL_TOTAL_SUPPORT',
  TOTAL_CONSULTANT_CORE = 'TOTAL_CONSULTANT_CORE'
}

export interface IDateDto {
  day?: Maybe<Scalars['String']>;
  month?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['String']>;
}

export interface IDeleteResponseDto {
  message: Scalars['String'];
}

export interface IDeleteWorklogResponseDto {
  message: Scalars['String'];
}

export interface IDepartmentAndSubDepartment {
  departmentName?: Maybe<Scalars['String']>;
  subDepartment?: Maybe<Array<Scalars['String']>>;
}

export interface IDepartmentBreakdown {
  departments: Array<Scalars['String']>;
  name: Scalars['String'];
}

export interface IDepartmentBreakdownResponseDto {
  mainDepartmentId: Scalars['ID'];
  mainDepartmentName: Scalars['String'];
  subDepartments?: Maybe<Array<Maybe<IDepartment>>>;
}

export interface IDepartmentRequest {
  id?: Maybe<Scalars['String']>;
  level?: Maybe<IDepartmentLevel>;
  name?: Maybe<Scalars['String']>;
  parentId?: Maybe<Scalars['String']>;
}

export interface IDepartmentResponse {
  id?: Maybe<Scalars['String']>;
  level?: Maybe<IDepartmentLevel>;
  name?: Maybe<Scalars['String']>;
  parentId?: Maybe<Scalars['String']>;
}

export interface IDepartmentResponseDto {
  id: Scalars['String'];
  name: Scalars['String'];
}

export enum IDeploymentStatus {
  DEPLOYABLE = 'DEPLOYABLE',
  NOT_DEPLOYABLE = 'NOT_DEPLOYABLE',
  PARTIALLY_DEPLOYABLE = 'PARTIALLY_DEPLOYABLE'
}

export interface IDesignationDto {
  /** grade of the designation */
  grade?: Maybe<Scalars['Float']>;
  /** id of the designation */
  id?: Maybe<Scalars['String']>;
  /** name of the designation */
  name?: Maybe<Scalars['String']>;
}

export interface IDesignationInputDto {
  /** grade of the designation */
  grade?: Maybe<Scalars['Float']>;
  /** id of the designation */
  id?: Maybe<Scalars['String']>;
  /** name of the designation */
  name?: Maybe<Scalars['String']>;
}

export interface IDownloadParsedResumeResp {
  file: Scalars['String'];
  fileName: Scalars['String'];
}

export interface IEligibleCandidatesDto {
  /** user availability status like available , partially available or unavailable but replaced by deploymentstatus */
  availabilityStatus?: Maybe<IAvailabilityStatus>;
  /** if the user has status offboarding and replace will be true else false */
  beingReplaced: Scalars['Boolean'];
  /** if considered candidate will be true else false */
  consideredCandidate: Scalars['Boolean'];
  /** user countryOfResidence matches squad role country */
  countryMatch?: Maybe<Scalars['Boolean']>;
  /** list of involvement history where user is assigned in different squads */
  currentSquads?: Maybe<Array<IUserSquadHistory>>;
  /** department to which user belongs */
  department?: Maybe<Scalars['String']>;
  /** user department matches squad role department */
  departmentMatch?: Maybe<Scalars['Boolean']>;
  /** user deployment status like deployable , partially deployable or not deployable */
  deploymentStatus?: Maybe<IDeploymentStatus>;
  /** designation of the candidate */
  designation?: Maybe<Scalars['String']>;
  /** unique code for an employee */
  employeeId?: Maybe<Scalars['String']>;
  /** employees skills embeddings for ML ranking purposes */
  employeeMostProficientSkillsEmbeddings?: Maybe<Array<Array<Scalars['Float']>>>;
  /** employment type like fuse employee or consultant or user or manager */
  employeeType?: Maybe<IFuseEmployeementType>;
  /** type of job like part time or full time */
  jobType?: Maybe<IJobTypeEnum>;
  /** level of experience of the considered candidate */
  level?: Maybe<IEmployeeLevel>;
  /** user employeeLevel matches squad role experienceLevel */
  levelMatch?: Maybe<Scalars['Boolean']>;
  /** match score details */
  matchInfo?: Maybe<IMatchInfoObject>;
  /** name of the considered candidate */
  name: Scalars['String'];
  overallStatus?: Maybe<Array<IOverallStatus>>;
  parsedResumeData?: Maybe<Scalars['String']>;
  /** previous employee end date for the same role */
  prevEmpEndDate?: Maybe<Scalars['DateTime']>;
  /** previous employee start date for the same role */
  prevEmpStartDate?: Maybe<Scalars['DateTime']>;
  /** unique id of considered candidate from profiles collection */
  profileId: Scalars['String'];
  /** profile image of the candidate */
  profileImage?: Maybe<Scalars['String']>;
  /** rates per hour */
  rate?: Maybe<Scalars['Float']>;
  /** employee region from profiles collection */
  region?: Maybe<Scalars['String']>;
  /** total number of required skills */
  requiredSkillsCount: Scalars['Float'];
  resourceStatus?: Maybe<Scalars['String']>;
  /** aws signedurl of the user's resume */
  resumeUrl?: Maybe<Scalars['String']>;
  /** role for which a candidate is being considered */
  role: Scalars['String'];
  roles?: Maybe<Array<Scalars['String']>>;
  skillMatchedCount: Scalars['Float'];
  /** skillMatchedCount/requiredSkillsCount * 100 percent */
  skillMatchedPercent?: Maybe<Scalars['Float']>;
  /** list of skills */
  skills?: Maybe<Array<Scalars['String']>>;
  /** list of skills */
  softSkills?: Maybe<Array<Scalars['String']>>;
  /** id of the squad */
  squadId?: Maybe<Scalars['String']>;
  /** status of candidate for the squad role */
  squadStatus?: Maybe<IInvolvementStatus>;
  /** Sub department to which user belongs */
  subDepartment?: Maybe<Scalars['String']>;
  /** unique id of ticket in hubspot */
  ticketId?: Maybe<Scalars['String']>;
  /** unique id of considered candidate from users collection */
  userId: Scalars['String'];
  /** list of user involvement history */
  userSquadHistory?: Maybe<Array<IUserSquadHistory>>;
  /** list of user involvement history */
  userSquadHistoryUnfiltered?: Maybe<Array<IUserSquadHistory>>;
}

export interface IEligibleCandidatesDtoPaged {
  /** List of fetched data */
  content: Array<IEligibleCandidatesDto>;
  /** Information about pagination */
  pageable: IPageable;
  skillForAdvancedFilter?: Maybe<Array<Scalars['String']>>;
}

export interface IEligibleCandidatesFilterDto {
  deploymentStatus?: Maybe<Array<IDeploymentStatus>>;
  designation?: Maybe<Scalars['String']>;
  involvedAs?: Maybe<Array<IInvolvedAs>>;
  jobType?: Maybe<IJobTypeEnum>;
  level?: Maybe<IEmployeeLevel>;
  matchType?: Maybe<IMatch_Types>;
  overallStatus?: Maybe<IInvolvementStatus>;
  rateFrom?: Maybe<Scalars['Float']>;
  rateTo?: Maybe<Scalars['Float']>;
  roles?: Maybe<Array<Scalars['String']>>;
  searchField?: Maybe<Scalars['String']>;
  skills?: Maybe<Array<Scalars['String']>>;
  squadRoleId: Scalars['String'];
  squadStatus?: Maybe<IInvolvementStatus>;
}

export interface IEmployeeInfoPaged {
  /** List of fetched data */
  content: Array<IEmployeeInfo>;
  /** Information about pagination */
  pageable: IPageable;
}

export interface IEmployeeInvoicingInformation {
  billingType?: Maybe<Scalars['String']>;
  employeeName: Scalars['String'];
  employeeRate?: Maybe<Scalars['Float']>;
  involvedAs: Scalars['String'];
  role: Scalars['String'];
  roleType: Scalars['String'];
  workingHour: Scalars['Float'];
}

/** Levels of employee */
export enum IEmployeeLevel {
  /** Junior level employee */
  JUNIOR_LEVEL = 'JUNIOR_LEVEL',
  /** Mid level employee */
  MID_LEVEL = 'MID_LEVEL',
  /** Senior level employee */
  SENIOR_LEVEL = 'SENIOR_LEVEL',
  /** Trainee */
  TRAINEE = 'TRAINEE'
}

export interface IEmployeeLevelTypeResponseDto {
  employeeLevel?: Maybe<Array<Maybe<Scalars['String']>>>;
}

export interface IEmployeeResponse {
  department?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  employeeId?: Maybe<Scalars['String']>;
  mainDepartment?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
}

export interface IEmployeementTypeDto {
  employeementType?: Maybe<Array<Maybe<Scalars['String']>>>;
}

export enum IEmploymentType {
  BLANK = 'BLANK',
  BOTH = 'BOTH',
  FULL_TIME = 'FULL_TIME',
  PART_TIME = 'PART_TIME'
}

export interface IEngagementLevelTypeResponseDto {
  engagementLevel?: Maybe<Array<Maybe<Scalars['String']>>>;
}

export interface IEnterpriseUser {
  designation: Scalars['String'];
  email: Scalars['String'];
  fullname: Scalars['String'];
  id: Scalars['String'];
}

export interface IEvidenceDetail {
  company?: Maybe<Scalars['String']>;
  domain?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
  responsibilities?: Maybe<Array<Scalars['String']>>;
  role?: Maybe<Scalars['String']>;
  seniority?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['String']>;
  technologyUsed?: Maybe<Array<Scalars['String']>>;
}

export enum IExperienceLevel {
  BEGINNER = 'BEGINNER',
  BLANK = 'BLANK',
  EXPERT = 'EXPERT',
  JUNIOR_LEVEL = 'JUNIOR_LEVEL',
  MID_LEVEL = 'MID_LEVEL',
  SENIOR = 'SENIOR',
  SENIOR_LEVEL = 'SENIOR_LEVEL'
}

export interface IExperienceResponse {
  role?: Maybe<Scalars['String']>;
  yearsOfExperience?: Maybe<Scalars['Float']>;
}

export interface IExportAndInvoiceWorklogFilter {
  closeOrOpenWorklog?: Maybe<IWorklogCloseStatus>;
  invoicingEnd?: Maybe<Scalars['String']>;
  invoicingStart?: Maybe<Scalars['String']>;
  squadId: Scalars['String'];
  ushIds?: Maybe<Array<Scalars['String']>>;
}

export interface IFaQsDto {
  answer?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  question?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
}

export interface IFaQsReq {
  answer?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  question?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
}

export interface IFavoriteTaskDto {
  category?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  endTime?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  minutes?: Maybe<Scalars['Float']>;
  squadId?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['DateTime']>;
  taskName?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
}

export interface IFavoriteTaskReq {
  category?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  endTime?: Maybe<Scalars['DateTime']>;
  minutes?: Maybe<Scalars['Float']>;
  squadId?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['DateTime']>;
  taskName?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
}

export interface IFetchRecurringTaskDto {
  category: Scalars['String'];
  description: Scalars['String'];
  endTime?: Maybe<Scalars['String']>;
  isRecurring: Scalars['Boolean'];
  minutes: Scalars['Int'];
  recurringDates: Array<Scalars['String']>;
  recurringId: Scalars['String'];
  recurringOptions?: Maybe<IRecurringOptions>;
  squadId: Scalars['String'];
  startTime?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
}

export interface IFieldDescriptionsReq {
  fieldDescription?: Maybe<Scalars['String']>;
  fieldName: Scalars['String'];
  fieldValues?: Maybe<Array<Scalars['String']>>;
  mapsTo: Scalars['String'];
}

export interface IFieldDescriptionsResp {
  fieldDescription?: Maybe<Scalars['String']>;
  fieldName: Scalars['String'];
  fieldValues?: Maybe<Array<Scalars['String']>>;
  mapsTo: Scalars['String'];
}

export interface IFieldHistoryDto {
  _id?: Maybe<IDateDto>;
  changeLog?: Maybe<Array<IChangeLogDto>>;
}

export interface IFieldHistoryFilterDto {
  fieldName: Scalars['String'];
  userId?: Maybe<Scalars['String']>;
}

export interface IFieldHistoryPaged {
  /** List of fetched data */
  content: Array<IFieldHistoryDto>;
  /** Information about pagination */
  pageable: IPageable;
}

export interface IFileMetaData {
  fileType: Scalars['String'];
  filename: Scalars['String'];
}

export enum IFileType {
  CSV = 'CSV',
  XLSX = 'XLSX'
}

export enum IFuseEmployeementType {
  FUSE_CONSULTANT = 'FUSE_CONSULTANT',
  FUSE_EMPLOYEE = 'FUSE_EMPLOYEE',
  FUSE_MANAGER = 'FUSE_MANAGER',
  SQUADERY_USER = 'SQUADERY_USER'
}

export enum IGender {
  FEMALE = 'FEMALE',
  MALE = 'MALE'
}

export interface IGetClientRolesFilterDto {
  clientId?: Maybe<Scalars['String']>;
  searchField?: Maybe<Scalars['String']>;
}

export interface IGetResumeScoresInput {
  jobId?: Maybe<Scalars['String']>;
  parsedResumeIds?: Maybe<Array<Scalars['String']>>;
}

export interface IGetRoleCandidatesFilterDto {
  clientId?: Maybe<Scalars['String']>;
  searchField?: Maybe<Scalars['String']>;
  squadRoleId: Scalars['String'];
}

export interface IHardSkill {
  category?: Maybe<Scalars['String']>;
  skill?: Maybe<Array<Scalars['String']>>;
}

export interface IHelpSectionDto {
  answer?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  question?: Maybe<Scalars['String']>;
}

export interface IHelpSectionReq {
  answer?: Maybe<Scalars['String']>;
  question?: Maybe<Scalars['String']>;
}

export interface IHelpSectionSupportReq {
  emailContent?: Maybe<Scalars['String']>;
  emailSubject?: Maybe<Scalars['String']>;
  userEmail: Scalars['String'];
}

export interface IHourOverviewResponseDto {
  allocatedTimeId?: Maybe<Scalars['String']>;
  notesCount: Scalars['Int'];
  overview: Array<IHoursDto>;
  totalAllocatedMinutes: Scalars['Int'];
  userSquadHistoryId?: Maybe<Scalars['String']>;
}

export interface IHoursDto {
  status: Scalars['String'];
  totalMinutes: Scalars['Int'];
}

export enum IInvolvement_Status_For_Clients_Enum {
  IN_PROGRESS = 'IN_PROGRESS',
  PENDING_REVIEW = 'PENDING_REVIEW',
  REJECTED = 'REJECTED',
  SELECTED = 'SELECTED',
  UNAVAILABLE = 'UNAVAILABLE',
  UNKNOWN = 'UNKNOWN'
}

export interface IIdNamePlaceholder {
  id: Scalars['String'];
  name: Scalars['String'];
}

export interface IImportResumeRequest {
  fileName: Scalars['String'];
  filePath: Scalars['String'];
}

export interface IInternalSquadDto {
  /** description of the squad */
  description: Scalars['String'];
  /** end date of the squad */
  endDate: Scalars['DateTime'];
  /** id of the industry to which squads belong to */
  industryId: Scalars['String'];
  /** name of the industry replaced by industryId */
  lineOfBusiness?: Maybe<Scalars['String']>;
  /** name of the squad */
  name: Scalars['String'];
  squadCategoryId?: Maybe<Scalars['String']>;
  /** start date of the squad */
  startDate: Scalars['DateTime'];
  /** type of the squad like internal or external */
  type?: Maybe<ISquadType>;
  /** id of the verticals to which squads belong to */
  verticalId: Scalars['String'];
}

export interface IInterviewEvaluationDto {
  assignedAssessments?: Maybe<Array<Scalars['String']>>;
  candidateCommunication?: Maybe<Scalars['Float']>;
  candidateEnthusiam?: Maybe<Scalars['Float']>;
  candidateLearning?: Maybe<Scalars['Float']>;
  candidatePreparation?: Maybe<Scalars['String']>;
  candidateQuestionStrength?: Maybe<Scalars['Float']>;
  clientProjectsExperience?: Maybe<Scalars['Float']>;
  isGoodTeamPlayer?: Maybe<Scalars['String']>;
  recentCoachableMoment?: Maybe<Scalars['String']>;
  squaderyUnderstanding?: Maybe<Scalars['String']>;
}

export interface IInterviewEvaluationOption {
  assignedAssessments: Array<Scalars['String']>;
  candidateCommunication: Scalars['Int'];
  candidateEnthusiam: Scalars['Int'];
  candidateLearning: Scalars['Int'];
  candidatePreparation: Scalars['String'];
  candidateQuestionStrength: Scalars['Int'];
  clientProjectsExperience: Scalars['Int'];
  isGoodTeamPlayer: Scalars['String'];
  recentCoachableMoment: Scalars['String'];
  squaderyUnderstanding: Scalars['String'];
}

export interface IInterviewEvaluationResponse {
  assignedAssessments: Array<Scalars['String']>;
  candidateCommunication: Scalars['Float'];
  candidateEnthusiam: Scalars['Float'];
  candidateLearning: Scalars['Float'];
  candidatePreparation: Scalars['String'];
  candidateQuestionStrength: Scalars['Float'];
  clientProjectsExperience: Scalars['Float'];
  isGoodTeamPlayer: Scalars['String'];
  recentCoachableMoment: Scalars['String'];
  squaderyUnderstanding: Scalars['String'];
}

export interface IInvoiceResponseDto {
  clientAddress?: Maybe<Scalars['String']>;
  clientEmail?: Maybe<Scalars['String']>;
  clientName: Scalars['String'];
  employee: Array<IEmployeeInvoicingInformation>;
  invoicingDate: Scalars['String'];
  invoicingPeriod: Scalars['String'];
  squadName: Scalars['String'];
}

export enum IInvolvedAs {
  CORE = 'CORE',
  SHADOW = 'SHADOW',
  SUPPORT = 'SUPPORT'
}

export interface IInvolvementHistory {
  _id?: Maybe<Scalars['String']>;
  allocatedHours: Scalars['Float'];
  endDate?: Maybe<Scalars['DateTime']>;
  involvedAs?: Maybe<IInvolvedAs>;
  involvementStatus?: Maybe<IInvolvementStatus>;
  jobType?: Maybe<IJobTypeEnum>;
  joinedDate?: Maybe<Scalars['DateTime']>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  note?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
}

export interface IInvolvementHistoryDto {
  allocatedHours?: Maybe<Scalars['Float']>;
  endDate?: Maybe<Scalars['DateTime']>;
  involvedAs?: Maybe<IInvolvedAs>;
  involvementStatus?: Maybe<IInvolvementStatus>;
  jobType?: Maybe<IJobTypeEnum>;
  joinedDate?: Maybe<Scalars['DateTime']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  note?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
}

export interface IInvolvementHistoryResponseDto {
  endDate?: Maybe<Scalars['DateTime']>;
  involvedAs?: Maybe<Scalars['String']>;
  involvementStatus?: Maybe<Scalars['String']>;
  joinedDate?: Maybe<Scalars['DateTime']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
}

export enum IInvolvementStatus {
  ASSIGNED = 'ASSIGNED',
  AVAILABLE = 'AVAILABLE',
  COMPLETED = 'COMPLETED',
  CV_REJECTED = 'CV_REJECTED',
  CV_SHARED_WIH_CLIENT = 'CV_SHARED_WIH_CLIENT',
  DURATION_EXPIRED = 'DURATION_EXPIRED',
  INTERVIEWING_WITH_CLIENT = 'INTERVIEWING_WITH_CLIENT',
  INTERVIEW_REJECTED = 'INTERVIEW_REJECTED',
  OFFBOARDED = 'OFFBOARDED',
  OFFBOARDING = 'OFFBOARDING',
  OFFBOARDING_AND_REPLACE = 'OFFBOARDING_AND_REPLACE',
  OFFBOARD_AND_MOVE = 'OFFBOARD_AND_MOVE',
  ONHOLD = 'ONHOLD',
  PENDING_CONTRACT = 'PENDING_CONTRACT',
  REMOVED = 'REMOVED',
  RESIGNED = 'RESIGNED',
  SOFT_ASSIGNED = 'SOFT_ASSIGNED'
}

export interface IInvolvmentHistoryResponseDto {
  _id?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
  joinedDate?: Maybe<Scalars['String']>;
}

export interface IJob {
  billingCycle?: Maybe<IJobBillingCycle>;
  billingRate?: Maybe<Scalars['Float']>;
  clientName?: Maybe<Scalars['String']>;
  clientSelectionProcess?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  department?: Maybe<Scalars['String']>;
  departmentId?: Maybe<Scalars['String']>;
  descriptionTemplateId?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['DateTime']>;
  enterprisePeopleId?: Maybe<Scalars['String']>;
  evaluationCriteria?: Maybe<Scalars['String']>;
  experienceLevel: IExperienceLevel;
  goodToHaveSkills?: Maybe<Array<Scalars['String']>>;
  horizontal?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  industry?: Maybe<Scalars['String']>;
  industryBackground?: Maybe<Scalars['String']>;
  jobCode: Scalars['String'];
  jobDescription?: Maybe<Scalars['String']>;
  jobPriority?: Maybe<IJobPriority>;
  jobStatus: IJobStatus;
  jobType?: Maybe<IEmploymentType>;
  location?: Maybe<Array<Scalars['String']>>;
  locationToBeHiredFrom?: Maybe<Array<Scalars['String']>>;
  maximumBudget?: Maybe<Scalars['Float']>;
  minimumBudget?: Maybe<Scalars['Float']>;
  mustHaveSkills?: Maybe<Array<Scalars['String']>>;
  newResumes?: Maybe<Scalars['Float']>;
  numberOfResources?: Maybe<Scalars['Float']>;
  orgId: Scalars['String'];
  previousReasonsForCandidateDisqualification?: Maybe<Scalars['String']>;
  projectDescription?: Maybe<Scalars['String']>;
  resumeImportCompleted: Scalars['Boolean'];
  resumeParsingStarted?: Maybe<Scalars['Boolean']>;
  resumesFromManualSource?: Maybe<Scalars['Float']>;
  resumesFromSquaderyPlatform?: Maybe<Scalars['Float']>;
  softSkills?: Maybe<Array<Scalars['String']>>;
  squadEndDate?: Maybe<Scalars['DateTime']>;
  squadId?: Maybe<Scalars['String']>;
  squadStartDate?: Maybe<Scalars['DateTime']>;
  startDate?: Maybe<Scalars['DateTime']>;
  technicalInterviewPanel?: Maybe<Scalars['String']>;
  timeZone?: Maybe<Array<Scalars['String']>>;
  title?: Maybe<Scalars['String']>;
  totalPages?: Maybe<Scalars['Float']>;
  totalResumes?: Maybe<Scalars['Float']>;
  travelRequirements?: Maybe<Scalars['String']>;
  typeOfWork?: Maybe<IType_Of_Work>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vertical?: Maybe<Scalars['String']>;
  yearsOfExperience?: Maybe<Scalars['Float']>;
}

export enum IJobBillingCycle {
  BI_WEEKLY = 'BI_WEEKLY',
  BLANK = 'BLANK',
  HOURLY = 'HOURLY',
  MONTHLY = 'MONTHLY',
  YEARLY = 'YEARLY'
}

export interface IJobCandidateInput {
  candidateStage: IJobCandidateStages;
  candidateStageStatus: Scalars['String'];
  documents: Array<ICandidateDocumentsInput>;
  jobId: Scalars['String'];
  parsedResumeId: Scalars['String'];
  userId?: Maybe<Scalars['String']>;
}

export enum IJobCandidateStages {
  ASSESSMENT = 'ASSESSMENT',
  CANDIDATE_APPLIED = 'CANDIDATE_APPLIED',
  FUTURE_POOL = 'FUTURE_POOL',
  INITIAL_INTERVIEW = 'INITIAL_INTERVIEW',
  QUALIFIED_FOR_HIRE = 'QUALIFIED_FOR_HIRE',
  TECHNICAL_INTERVIEW = 'TECHNICAL_INTERVIEW'
}

export interface IJobCandidateType {
  candidateStage: IJobCandidateStages;
  candidateStageStatus: Scalars['String'];
  documents: Array<ICandidateDocuments>;
  jobId: Scalars['String'];
  parsedResumeId: Scalars['String'];
  userId?: Maybe<Scalars['String']>;
}

export interface IJobCreateDto {
  billingCycle: IJobBillingCycle;
  billingRate: Scalars['Float'];
  department: Scalars['String'];
  departmentId: Scalars['String'];
  enterprisePeopleId: Scalars['String'];
  experienceLevel: Scalars['String'];
  goodToHaveSkills: Array<Scalars['String']>;
  jobCode: Scalars['String'];
  jobDescription: Scalars['String'];
  jobPriority: IJobPriority;
  jobType: IEmploymentType;
  location: Array<Scalars['String']>;
  mustHaveSkills: Array<Scalars['String']>;
  numberOfResources: Scalars['Float'];
  timeZone: Array<Scalars['String']>;
  title: Scalars['String'];
}

export interface IJobCreator {
  firstName: Scalars['String'];
  id: Scalars['String'];
  lastName?: Maybe<Scalars['String']>;
}

export interface IJobCreatorDto {
  email: Scalars['String'];
  fullname: Scalars['String'];
  id: Scalars['String'];
  roles: Array<Scalars['String']>;
}

export interface IJobDescriptionTemplateType {
  createdBy: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  jobDescription: Scalars['String'];
  title: Scalars['String'];
}

export interface IJobDurationDto {
  month: Scalars['String'];
  year: Scalars['String'];
}

export interface IJobDurationInputDto {
  month: Scalars['String'];
  year: Scalars['String'];
}

export interface IJobExperienceDto {
  companyName?: Maybe<Scalars['String']>;
  currentlyEmployed?: Maybe<Scalars['Boolean']>;
  jobEndDate?: Maybe<IJobDurationDto>;
  jobLocation?: Maybe<Scalars['String']>;
  jobStartDate?: Maybe<IJobDurationDto>;
  jobTitle?: Maybe<Scalars['String']>;
  rolesAndResponsibility?: Maybe<Scalars['String']>;
}

export interface IJobExperienceInputDto {
  companyName?: Maybe<Scalars['String']>;
  currentlyEmployed?: Maybe<Scalars['Boolean']>;
  jobEndDate?: Maybe<IJobDurationInputDto>;
  jobLocation?: Maybe<Scalars['String']>;
  jobStartDate?: Maybe<IJobDurationInputDto>;
  jobTitle?: Maybe<Scalars['String']>;
  rolesAndResponsibility?: Maybe<Scalars['String']>;
}

export interface IJobJazzHrDetails {
  jazzHrId: Scalars['String'];
  jobLocation: Scalars['String'];
  jobTitle: Scalars['String'];
}

export interface IJobPaginationDto {
  addedOnFrom?: Maybe<Scalars['String']>;
  addedOnTo?: Maybe<Scalars['String']>;
  client?: Maybe<Array<Maybe<Scalars['String']>>>;
  createdBy?: Maybe<Scalars['String']>;
  jobStatus?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  priority?: Maybe<IJobPriority>;
  requestedToHire?: Maybe<Scalars['Boolean']>;
  searchText?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  squad?: Maybe<Array<Maybe<IClientNameAndSquads>>>;
  title?: Maybe<Scalars['String']>;
}

export enum IJobPriority {
  BLANK = 'BLANK',
  CRITICAL = 'CRITICAL',
  HIGH = 'HIGH',
  LOW = 'LOW',
  MEDIUM = 'MEDIUM'
}

export interface IJobResult {
  candidates?: Maybe<ICandidates>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<Scalars['String']>;
  experienceLevel?: Maybe<IExperienceLevel>;
  id?: Maybe<Scalars['String']>;
  jobCode?: Maybe<Scalars['String']>;
  jobDescription?: Maybe<Scalars['String']>;
  jobPriority?: Maybe<IJobPriority>;
  jobStatus?: Maybe<IJobStatus>;
  location?: Maybe<Array<Scalars['String']>>;
  newResumes?: Maybe<Scalars['Float']>;
  noOfVacancies?: Maybe<Scalars['Float']>;
  postedOn?: Maybe<Scalars['DateTime']>;
  previousJobStatus?: Maybe<IJobStatus>;
  requested?: Maybe<Scalars['Boolean']>;
  resumeImportCompleted?: Maybe<Scalars['Boolean']>;
  salaryDetails?: Maybe<Scalars['String']>;
  sources?: Maybe<Array<Scalars['String']>>;
  squadAndClientInfo?: Maybe<ISquadAndClientInfo>;
  squadId?: Maybe<Scalars['String']>;
  ticketId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  totalResumes?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
}

export interface IJobResumeResyncOutputDto {
  status: Scalars['String'];
}

export enum IJobStatus {
  ARCHIVED = 'ARCHIVED',
  BLANK = 'BLANK',
  CLOSED = 'CLOSED',
  CLOSED_LOST = 'CLOSED_LOST',
  DRAFTED = 'DRAFTED',
  ON_HOLD = 'ON_HOLD',
  OPEN = 'OPEN'
}

export interface IJobStatusUpdate {
  done: Scalars['Boolean'];
  matchedCount: Scalars['Float'];
  modifiedCount: Scalars['Float'];
}

export interface IJobStatusUpdateDto {
  ids: Array<Scalars['String']>;
  jobStatus: IJobStatus;
  requestedFromHubspot?: Maybe<Scalars['Boolean']>;
}

export enum IJobType {
  BLANK = 'BLANK',
  BOTH = 'BOTH',
  FULLTIME = 'FULLTIME',
  PARTTIME = 'PARTTIME'
}

export enum IJobTypeAddcandidate {
  BLANK = 'BLANK',
  BOTH = 'BOTH',
  FULLTIME = 'FULLTIME',
  PARTTIME = 'PARTTIME'
}

/** Type of job */
export enum IJobTypeEnum {
  FULL_TIME = 'FULL_TIME',
  PART_TIME = 'PART_TIME'
}

export interface IJobUpdateDto {
  billingCycle?: Maybe<IJobBillingCycle>;
  billingRate?: Maybe<Scalars['Float']>;
  clientSelectionProcess?: Maybe<Scalars['String']>;
  contributingMembers?: Maybe<Array<IContributingHiringMembers>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  department?: Maybe<Scalars['String']>;
  departmentId?: Maybe<Scalars['String']>;
  descriptionTemplateId?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['DateTime']>;
  enterprisePeopleId?: Maybe<Scalars['String']>;
  evaluationCriteria?: Maybe<Scalars['String']>;
  experienceLevel?: Maybe<IExperienceLevel>;
  goodToHaveSkills?: Maybe<Array<Scalars['String']>>;
  horizontal?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  industry?: Maybe<Scalars['String']>;
  industryBackground?: Maybe<Scalars['String']>;
  jobCode?: Maybe<Scalars['String']>;
  jobDescription?: Maybe<Scalars['String']>;
  jobId?: Maybe<Scalars['String']>;
  jobJazzHrDetails?: Maybe<Array<IJobJazzHrDetails>>;
  jobPriority?: Maybe<IJobPriority>;
  jobStatus?: Maybe<IJobStatus>;
  jobType?: Maybe<IEmploymentType>;
  location?: Maybe<Array<Scalars['String']>>;
  locationToBeHiredFrom?: Maybe<Array<Scalars['String']>>;
  maximumBudget?: Maybe<Scalars['Float']>;
  minimumBudget?: Maybe<Scalars['Float']>;
  mustHaveSkills?: Maybe<Array<Scalars['String']>>;
  noOfVacancies?: Maybe<Scalars['Float']>;
  numberOfResources?: Maybe<Scalars['Float']>;
  previousReasonsForCandidateDisqualification?: Maybe<Scalars['String']>;
  projectDescription?: Maybe<Scalars['String']>;
  saveAsDraft?: Maybe<Scalars['Boolean']>;
  softSkills?: Maybe<Array<Scalars['String']>>;
  squadEndDate?: Maybe<Scalars['DateTime']>;
  squadId?: Maybe<Scalars['String']>;
  squadRoleId?: Maybe<Scalars['String']>;
  squadStartDate?: Maybe<Scalars['DateTime']>;
  startDate?: Maybe<Scalars['DateTime']>;
  technicalInterviewPanel?: Maybe<Scalars['String']>;
  ticketId?: Maybe<Scalars['String']>;
  timeZone?: Maybe<Array<Scalars['String']>>;
  title?: Maybe<Scalars['String']>;
  travelRequirements?: Maybe<Scalars['String']>;
  typeOfWork?: Maybe<IType_Of_Work>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vertical?: Maybe<Scalars['String']>;
  yearsOfExperience?: Maybe<Scalars['Float']>;
}

export interface IJobinput {
  billingCycle?: Maybe<IJobBillingCycle>;
  billingRate?: Maybe<Scalars['Float']>;
  clientName?: Maybe<Scalars['String']>;
  clientSelectionProcess?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  department?: Maybe<Scalars['String']>;
  departmentId?: Maybe<Scalars['String']>;
  descriptionTemplateId?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['DateTime']>;
  enterprisePeopleId?: Maybe<Scalars['String']>;
  evaluationCriteria?: Maybe<Scalars['String']>;
  experienceLevel?: Maybe<IExperienceLevel>;
  goodToHaveSkills?: Maybe<Array<Scalars['String']>>;
  horizontal?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  industry?: Maybe<Scalars['String']>;
  industryBackground?: Maybe<Scalars['String']>;
  jobCode?: Maybe<Scalars['String']>;
  jobDescription?: Maybe<Scalars['String']>;
  jobPriority?: Maybe<IJobPriority>;
  jobStatus: IJobStatus;
  jobType?: Maybe<IEmploymentType>;
  location?: Maybe<Array<Scalars['String']>>;
  locationToBeHiredFrom?: Maybe<Array<Scalars['String']>>;
  maximumBudget?: Maybe<Scalars['Float']>;
  minimumBudget?: Maybe<Scalars['Float']>;
  mustHaveSkills?: Maybe<Array<Scalars['String']>>;
  newResumes?: Maybe<Scalars['Float']>;
  numberOfResources?: Maybe<Scalars['Float']>;
  orgId: Scalars['String'];
  previousReasonsForCandidateDisqualification?: Maybe<Scalars['String']>;
  projectDescription?: Maybe<Scalars['String']>;
  resumeImportCompleted?: Maybe<Scalars['Boolean']>;
  resumeParsingStarted?: Maybe<Scalars['Boolean']>;
  resumesFromManualSource?: Maybe<Scalars['Float']>;
  resumesFromSquaderyPlatform?: Maybe<Scalars['Float']>;
  softSkills?: Maybe<Array<Scalars['String']>>;
  squadEndDate?: Maybe<Scalars['DateTime']>;
  squadId?: Maybe<Scalars['String']>;
  squadStartDate?: Maybe<Scalars['DateTime']>;
  startDate?: Maybe<Scalars['DateTime']>;
  technicalInterviewPanel?: Maybe<Scalars['String']>;
  timeZone?: Maybe<Array<Scalars['String']>>;
  title?: Maybe<Scalars['String']>;
  totalPages?: Maybe<Scalars['Float']>;
  totalResumes?: Maybe<Scalars['Float']>;
  travelRequirements?: Maybe<Scalars['String']>;
  typeOfWork?: Maybe<IType_Of_Work>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vertical?: Maybe<Scalars['String']>;
  yearsOfExperience?: Maybe<Scalars['Float']>;
}

export interface IKeyObjectResp {
  key: Scalars['String'];
  value: Array<Scalars['String']>;
}

export interface IKeyObjects {
  key: Scalars['String'];
  value: Array<Scalars['String']>;
}

export interface ILatestResumeScoreResponseDto {
  candidateCons?: Maybe<Array<Scalars['String']>>;
  candidateDescription?: Maybe<Scalars['String']>;
  candidatePros?: Maybe<Array<Scalars['String']>>;
  customScore?: Maybe<Scalars['Int']>;
  resumeClassificationReasoning?: Maybe<Scalars['String']>;
}

export interface ILeaveDetail {
  _id?: Maybe<Scalars['String']>;
  leaveCategory?: Maybe<Scalars['String']>;
  leaveDate?: Maybe<Scalars['DateTime']>;
  leaveRemarks?: Maybe<Scalars['String']>;
  leaveStatus?: Maybe<ILeaveStatus>;
  leaveType?: Maybe<ILeaveType>;
}

export enum ILeaveStatus {
  APPROVED = 'APPROVED',
  DECLINED = 'DECLINED',
  PENDING = 'PENDING'
}

export enum ILeaveType {
  FIRST_HALF = 'FIRST_HALF',
  FUTURE = 'FUTURE',
  SECOND_HALF = 'SECOND_HALF',
  WHOLE_DAY = 'WHOLE_DAY'
}

export interface ILeavesInfo {
  firstHalfLeaves?: Maybe<Scalars['Float']>;
  futureLeaves?: Maybe<Scalars['Float']>;
  secondHalfLeaves?: Maybe<Scalars['Float']>;
  totalApprovedLeaves?: Maybe<Scalars['Float']>;
  totalLeaves?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['String']>;
  wholeDayLeaves?: Maybe<Scalars['Float']>;
}

export interface ILevelAndCount {
  count: Scalars['Float'];
  level: Scalars['String'];
}

export interface ILevelAndCountByRole {
  count: Scalars['Float'];
  level: Scalars['String'];
}

export interface ILevelAndCountObjType {
  count: Scalars['Float'];
  level: Scalars['String'];
}

export interface ILevelData {
  count: Scalars['Float'];
  level: Scalars['String'];
}

export interface ILevelList {
  label: Scalars['String'];
  shortForm: Scalars['String'];
  value: Scalars['String'];
}

export interface ILineOfBusinessDto {
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
}

export interface IListData {
  levelData: Array<ILevelData>;
  role: Scalars['String'];
}

export interface IListNotesResponse {
  allocatedMinutes?: Maybe<Scalars['Float']>;
  allocatedTimeId?: Maybe<Scalars['String']>;
  modifiedBy?: Maybe<IModifiedByDto>;
  note?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userSquadHistoryId?: Maybe<Scalars['String']>;
}

/** Type of resource list to be fetched. */
export enum IMatch_Types {
  /** Fetch list of all resources (TOP, SECONDARY, OTHERS match). */
  ALL = 'ALL',
  /** Fetch list of resources without any match. */
  OTHERS = 'OTHERS',
  /** Fetch list of resources with parial match. */
  SECONDARY = 'SECONDARY',
  /** Fetch list of resources with best match. */
  TOP = 'TOP'
}

export interface IMlResumeDto {
  parsedResumeId?: Maybe<Scalars['String']>;
  resumeId?: Maybe<Scalars['String']>;
  resumeUrl?: Maybe<Scalars['String']>;
}

export interface IMlScoreRequestDto {
  jobId: Scalars['String'];
  promptAsked: Scalars['String'];
  requestedBy: Scalars['String'];
  resumes?: Maybe<Array<IMlResumeDto>>;
  sessionId: Scalars['String'];
}

export interface IMatchInfoObject {
  countryMatchScore?: Maybe<Scalars['Float']>;
  departmentMatchScore?: Maybe<Scalars['Float']>;
  deploymentMatchScore?: Maybe<Scalars['Float']>;
  levelMatchScore?: Maybe<Scalars['Float']>;
  matchScore?: Maybe<Scalars['Float']>;
  matchType?: Maybe<IMatch_Types>;
  overallScore?: Maybe<Scalars['Float']>;
  skillMatchScore?: Maybe<Scalars['Float']>;
}

export interface IModificationsInput {
  modifiedField: Scalars['String'];
  newValue: Scalars['String'];
  oldValue: Scalars['String'];
}

export interface IModificationsResponseDto {
  modifiedField?: Maybe<Scalars['String']>;
  newValue?: Maybe<Scalars['String']>;
  oldValue?: Maybe<Scalars['String']>;
}

export interface IModifiedByDto {
  email?: Maybe<Scalars['String']>;
  fullname?: Maybe<Scalars['String']>;
  profileImage?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
}

export interface IModifiedByResponseDto {
  email?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  profileId?: Maybe<Scalars['String']>;
  profileImage?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
}

export interface IModifiedObjectResponseDto {
  clientName?: Maybe<Scalars['String']>;
  deviceName?: Maybe<Scalars['String']>;
  involvementHistory?: Maybe<IInvolvmentHistoryResponseDto>;
  squadName?: Maybe<Scalars['String']>;
}

export interface IMoveDto {
  clientId: Scalars['String'];
  country: Array<Scalars['String']>;
  department: Scalars['String'];
  departmentId: Scalars['String'];
  endDate?: Maybe<Scalars['DateTime']>;
  experienceLevel?: Maybe<IEmployeeLevel>;
  goodToHaveSkills: Array<Scalars['String']>;
  involvedAs?: Maybe<IInvolvedAs>;
  involvementStatus?: Maybe<IInvolvementStatus>;
  jobType?: Maybe<IJobTypeEnum>;
  newEndDate?: Maybe<Scalars['DateTime']>;
  newJoinedDate?: Maybe<Scalars['DateTime']>;
  orgId?: Maybe<Scalars['String']>;
  phases?: Maybe<Scalars['String']>;
  priority: IPriorityEnum;
  profileId?: Maybe<Scalars['String']>;
  rate: Scalars['Float'];
  requiredCount?: Maybe<Scalars['Float']>;
  requiredForKickOff?: Maybe<Scalars['Boolean']>;
  requiredSkills: Array<Scalars['String']>;
  role: Scalars['String'];
  roleDescription: Scalars['String'];
  squadId: Scalars['String'];
  squadRoleId?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  ticketId?: Maybe<Scalars['String']>;
  timeZone: Array<Scalars['String']>;
  userId: Scalars['String'];
  workShift?: Maybe<IWorkShift>;
  yearsOfExperience?: Maybe<Scalars['Float']>;
}

export interface IMutation {
  addCandidate: ICandidateProfileInfo;
  /** It creates client by name if doesnot exist already and returns the created client information. Permission: ADD_CLIENT */
  addClient: IClient;
  addDepartmentHod: ICreateDepartmentHodDto;
  addFAQs: IFaQsDto;
  addFavoriteTask: IFavoriteTaskDto;
  addHelpSupport: IHelpSectionDto;
  addInterviewEvaluation: ICandidateProfileInfo;
  addKeyValueToConstantType: ISquaderyConstantsResp;
  addLeaveCategories: Scalars['String'];
  /** Add a new comment in worklog request */
  addNewComment: IWorklogCommentsDto;
  addNoteToCandidate: ICandidateNoteType;
  addPermissionToGroup: Array<IPermissionGroupRespObject>;
  addRecurringTasks: Array<IWorklogResponseDto>;
  addSkillSet: ICandidateSkillsResponse;
  addToConstantType: Scalars['String'];
  addToUpdateSkill: ICreateUpdateSkillDto;
  addTrainingCertificate: ITrainingCertificateResponseDto;
  addWorklogCategories: Scalars['String'];
  addWorklogTask: IWorklogTaskResponseDto;
  allowIP: Scalars['String'];
  /** Review and approve/decline worklog requests */
  approveDeclineWorklogs: Scalars['Boolean'];
  assignPermissionGroupAndPersonaToUser: Scalars['String'];
  assignPersonaToUsers: Scalars['String'];
  bulkAddFAQs: Array<IFaQsDto>;
  convertResumeToPdf: Scalars['String'];
  /** Add new note */
  createAdditionalNote: Array<IAdditionalNoteResponseDto>;
  createClientContacts: Array<IClientContact>;
  createDepartment: Array<IClientDepartment>;
  createEmployee: ICreateEmployeeRespDto;
  /** It allows to create internal squad and return the created squad information. */
  createInternalSquad: ISquadDto;
  createJob: IJob;
  createJobDescriptionTemplate: IJobDescriptionTemplateType;
  createLineOfBusiness: ILineOfBusinessDto;
  createOrUpdateAssignedDevices: IAssignedDevices;
  createOrUpdateCbu: Scalars['String'];
  createOrUpdateCronControl: Scalars['String'];
  createOrUpdateDepartment: IDepartmentResponse;
  createOrUpdateRequestToHire: IRequestToHire;
  createOrUpdateWorkExperience: IWorkExperienceDto;
  createOrUpdateWorklogLeave: IWorklogLeaveDto;
  createOverAllExperienceAndRelevantExperience: IProfileDto;
  createPermissionGroup: ICreatePermissionGroupResp;
  createPermissionHierarchy: IPermissionHierarchyResp;
  createPersona: IPersonaDto;
  createRecipientGroup: IRecipientGroupResponseObjectType;
  /** It allows to create roles for a squad. */
  createRolesInSquad: Array<IRoleResp>;
  createRthTemplate: IRthTemplateResp;
  /** It allows to create a squad or list of squads returning the squads list by first squad client id. Permission: CREATE_SQUAD */
  createSquad: Array<ISquad>;
  createSquadCategory: ISquadCategoryResponse;
  createSquadNote: ISquadNote;
  createUserSettingforWorklogReminder: ICreateUserSettingType;
  createWorklog: IWorklogResponseDto;
  deleteCandidateDocument: Scalars['String'];
  deleteFAQ: Scalars['Boolean'];
  deleteFavoriteTaskById: Scalars['String'];
  deleteJobById: Scalars['String'];
  deleteLeaveById: Scalars['String'];
  deleteLeaveCategory: Scalars['String'];
  deleteLeavesByIds: Scalars['String'];
  deleteMultipleResume: Scalars['String'];
  deleteMultipleResumeByIds: Scalars['String'];
  deleteNote: Scalars['String'];
  deleteParsedResume: Scalars['String'];
  deleteQueries: Scalars['String'];
  deleteRecurringTasks: Scalars['String'];
  deleteResume: IResume;
  deleteResumeImportLogByJobId: Scalars['String'];
  deleteSkillByUserId: Scalars['String'];
  deleteSourceParsedResume: Scalars['String'];
  deleteTrainingCertificate: ITrainingCertificateResponseDto;
  deleteWorklog: IDeleteWorklogResponseDto;
  deleteWorklogTask: IDeleteResponseDto;
  duplicateJob: IJob;
  editRecurringTasks: Array<IWorklogResponseDto>;
  findByCronType: ICronControlResponseObjectType;
  generateNewResumeUrl: Scalars['String'];
  getSignedUrlForUpload: Array<IResumeSignedUrlResponse>;
  getViewUrlsForResume: Array<IViewResumeUrlsResponse>;
  /** Permission: EMPLOYEE_CSV */
  importEmployeePhoneFromCsv: IResponseCsvParser;
  importResumes: Scalars['String'];
  importResumesForJob: IResumeImportLogObjectType;
  inviteToSquaderyConnect: Scalars['String'];
  markJobAsViewed: IRequestedJobViewsType;
  /** Permission: OFFBOARD_ONBOARD */
  onboardOrOffboardInSquad: Scalars['String'];
  /** OTP Login for clients */
  otpLogin: IOtpLoginResponseDto;
  refreshProfileSummary: Scalars['String'];
  /** Permission: REMOVE_ASSIGNED_DEVICE */
  removeAssignedDevices: Scalars['String'];
  /** Permission: UPDATE_SQUAD */
  removeClientContact: Scalars['String'];
  removeFromConstantType: Scalars['String'];
  removeKeyFromConstantType: ISquaderyConstantsResp;
  removePermissionFromGroup: Array<IPermissionGroupRespObject>;
  removePersonaAndPermissionGroupFromUser: Scalars['String'];
  removeResumeUrl: Scalars['String'];
  /** Permission: REMOVE_USER_SQUAD_HISTORY */
  removeSquadHistory: Scalars['String'];
  reparseResume: Scalars['String'];
  replaceResume: IResume;
  requestGeminiScoring: Scalars['String'];
  resubmitWorklogs: Scalars['String'];
  saveCustomQueryField: ICustomQueryFieldResp;
  saveListOrder: IUserPreferenceType;
  saveOrUpdateQuery: ISavedQueryResp;
  saveSquaderyConstants: ISquaderyConstantsResp;
  sendEmailToSupport: Scalars['String'];
  sendHelpEmailToSupport: Scalars['String'];
  /** It allows to update pin/unpin status for a squad by squad id and user id. */
  toggleSquadPinByUserId: Scalars['String'];
  unarchiveJob: IJobStatus;
  /** update single note */
  updateAdditionalNote: Array<IAdditionalNoteResponseDto>;
  /** Update the allocated hours of a consultant in given squad; Used in worklog overview page */
  updateAllocatedTime: IUpdateAllocatedTimeResponse;
  /** Update user's basic information. Permission: UPDATE_PERSONAL_INFO */
  updateBasicInfo: IProfileDto;
  /** Permission: UPDATE_PERSONAL_INFO */
  updateBasicInfoAndPersonalInfo: IProfileDto;
  updateCandidateNote: ICandidateNoteType;
  updateCandidateProfile: ICandidateParsedResumeInfo;
  updateCandidateStatus: IJobCandidateType;
  /** Permission: UPDATE_CERTIFICATE */
  updateCertificate: IProfileDto;
  /** Permission: UPDATE_EDUCATION */
  updateEducation: IProfileDto;
  updateFAQs: IFaQsDto;
  updateFavoriteTask: IFavoriteTaskDto;
  updateHelpSupport: IHelpSectionDto;
  updateInvolvementHistory: Scalars['String'];
  updateJob: IJob;
  /** Permission: UPDATE_JOB_EXPERIENCE */
  updateJobExperience: IProfileDto;
  updateJobStatus: IJobStatusUpdate;
  updateParsedResume: IParsedResume;
  /** Update user's personal information. Permission: UPDATE_PERSONAL_INFO */
  updatePersonalInfo: IProfileDto;
  updateRecipientGroup: IRecipientGroupResponseObjectType;
  updateRequestToHire: IRequestToHire;
  /** It allows to update squad resource details by squadResourceId and update in corresponding hubspot ticket mainly for offboarding and replace form. */
  updateRoleDetailsByResourceId: ISquadResourceRoleOutputDto;
  updateSkillSetEmployees: Array<ICsvResponse>;
  /** Permission: UPDATE_EMPLOYEE_SKILLS */
  updateSkills: IProfileDto;
  /** Permission: UPDATE_SQUAD */
  updateSquad: ISquad;
  /** List supervisors */
  updateSupervisors: IUserProfileDto;
  updateTrainingCertificate: ITrainingCertificateResponseDto;
  /** Update user's work experience information. Permission: UPDATE_WORK_INFO */
  updateWorkExperience: IProfileDto;
  /** Update user's work information. Permission: UPDATE_WORK_INFO */
  updateWorkInfo: IProfileDto;
  updateWorklogCloseDocument: Scalars['String'];
  updateWorklogTask: IWorklogTaskResponseDto;
  /** Permission: UPLOAD_BULK_CSV */
  uploadBulkCV: IBulkCvUpdateResponse;
  /** Permission: EMPLOYEE_CSV */
  uploadCSVHarvest: IResponseCsvParser;
  uploadCertificate: IUploadCertificateDto;
  /** It allows to upload squad data from csv with its client information. Permission: SQUAD_CSV */
  uploadClientAndSquadInfo: IResponseCsvParser;
  /** Permission: EMPLOYEE_CSV */
  uploadCsvOfEmployees: IResponseCsvParser;
  uploadDocuments: IJobCandidateType;
  uploadFile: IResume;
  uploadSkillsCSV: ISkillSetUploadResponseDto;
  userBulkUpload: IUserUploadValidationResponse;
  validateUserBulkUpload: IUserUploadValidationResponse;
  /** Verify OTP for client login */
  verifyOtp: IVerifyOtpResponseDto;
  worklogLeaveApproveDecline: Scalars['String'];
}


export interface IMutationAddCandidateArgs {
  aboutyou: IAboutYouDtoAddCandidate;
  file?: Maybe<Scalars['Upload']>;
  jobdescription?: Maybe<Scalars['Upload']>;
  profileId?: Maybe<Scalars['String']>;
}


export interface IMutationAddClientArgs {
  createClientDto: ICreateClientDto;
}


export interface IMutationAddDepartmentHodArgs {
  createDepartmentHodDto: ICreateDepartmentHodDtoReq;
}


export interface IMutationAddFaQsArgs {
  fAQsReq: IFaQsReq;
}


export interface IMutationAddFavoriteTaskArgs {
  favoriteTaskReq: IFavoriteTaskReq;
}


export interface IMutationAddHelpSupportArgs {
  helpSectionReq: IHelpSectionReq;
}


export interface IMutationAddInterviewEvaluationArgs {
  intervieweval: IInterviewEvaluationDto;
  profileid: Scalars['String'];
  saveAsDraft: Scalars['Boolean'];
}


export interface IMutationAddKeyValueToConstantTypeArgs {
  constantKeyValue: IConstantKeyValueDto;
}


export interface IMutationAddLeaveCategoriesArgs {
  categories: Array<Scalars['String']>;
}


export interface IMutationAddNewCommentArgs {
  comment: Scalars['String'];
  squadId: Scalars['String'];
  worklogId: Scalars['String'];
}


export interface IMutationAddNoteToCandidateArgs {
  createNoteDto: ICreateNoteDto;
}


export interface IMutationAddPermissionToGroupArgs {
  addPermissionToGroupInput: IAddPermissionToGroupDto;
}


export interface IMutationAddRecurringTasksArgs {
  recurringWorklogTasksInput: IRecurringWorklogDto;
}


export interface IMutationAddSkillSetArgs {
  profileid: Scalars['String'];
  skillset: ISkillsReqDto;
}


export interface IMutationAddToConstantTypeArgs {
  squaderyConstantsDto: ISquaderyConstantsDto;
}


export interface IMutationAddToUpdateSkillArgs {
  createUpdateSkillDto: ICreateUpdateSkillDtoReq;
}


export interface IMutationAddTrainingCertificateArgs {
  createTrainingCertificateInput: ICreateTrainingCertificateDto;
  uploads?: Maybe<Array<Maybe<Scalars['Upload']>>>;
}


export interface IMutationAddWorklogCategoriesArgs {
  categories: Array<Scalars['String']>;
}


export interface IMutationAddWorklogTaskArgs {
  worklogTaskInput: INewWorklogTaskDto;
}


export interface IMutationAllowIpArgs {
  allowIPData: IAllowIpInputDto;
}


export interface IMutationApproveDeclineWorklogsArgs {
  worklogData: IApproveDeclineWorklogArgs;
}


export interface IMutationAssignPermissionGroupAndPersonaToUserArgs {
  assignPersonaDto: IAssignPersonaDto;
}


export interface IMutationAssignPersonaToUsersArgs {
  assignPersonaDto: IAssignPersonaDto;
}


export interface IMutationBulkAddFaQsArgs {
  faqs: Array<IFaQsReq>;
}


export interface IMutationConvertResumeToPdfArgs {
  file: Scalars['Upload'];
}


export interface IMutationCreateAdditionalNoteArgs {
  createAdditionalNoteDto: ICreateAdditionalNoteDto;
}


export interface IMutationCreateClientContactsArgs {
  createClientContactDto: Array<ICreateClientContactDto>;
}


export interface IMutationCreateDepartmentArgs {
  clientdepartmentDto: Array<IClientDepartmentDto>;
}


export interface IMutationCreateEmployeeArgs {
  file: Scalars['Upload'];
  user: IUserUploadInputDto;
}


export interface IMutationCreateInternalSquadArgs {
  internalSquadDto: IInternalSquadDto;
}


export interface IMutationCreateJobArgs {
  jobCreateDto: IJobCreateDto;
}


export interface IMutationCreateJobDescriptionTemplateArgs {
  template: ICreateJobDescriptionTemplate;
}


export interface IMutationCreateLineOfBusinessArgs {
  lineOfBusiness: ILineOfBusinessReq;
}


export interface IMutationCreateOrUpdateAssignedDevicesArgs {
  AssignedDevicesDto: IAssignedDevicesDto;
}


export interface IMutationCreateOrUpdateCbuArgs {
  cbuDepartmentsDto: ICbuDepartmentsDto;
}


export interface IMutationCreateOrUpdateCronControlArgs {
  createUpdateCronControlInput: ICreateUpdateCronControlInput;
}


export interface IMutationCreateOrUpdateDepartmentArgs {
  department: IDepartmentRequest;
}


export interface IMutationCreateOrUpdateRequestToHireArgs {
  requestToHire: IJobUpdateDto;
}


export interface IMutationCreateOrUpdateWorkExperienceArgs {
  workExperienceDTO: ICreateWorkExperienceInput;
}


export interface IMutationCreateOrUpdateWorklogLeaveArgs {
  leaveId?: Maybe<Scalars['String']>;
  worklogLeaveReq: IWorklogLeaveReq;
}


export interface IMutationCreateOverAllExperienceAndRelevantExperienceArgs {
  experience: IOverallAndRelevantExperienceDto;
}


export interface IMutationCreatePermissionGroupArgs {
  permissionGroupDto: IPermissionGroupDto;
}


export interface IMutationCreatePermissionHierarchyArgs {
  permissionHierarchyDto: IPermissionHierarchyDto;
}


export interface IMutationCreatePersonaArgs {
  personaDto: IPersonaInputDto;
}


export interface IMutationCreateRecipientGroupArgs {
  createRecipientGroupInput: ICreateRecipientGroupInput;
}


export interface IMutationCreateRolesInSquadArgs {
  squadResources: ICreateRoleDto;
}


export interface IMutationCreateRthTemplateArgs {
  rthTemplate: IRthTemplateDto;
}


export interface IMutationCreateSquadArgs {
  clientSquadDto: Array<IClientSquadDto>;
}


export interface IMutationCreateSquadCategoryArgs {
  squadCategory: ISquadCategoryInput;
}


export interface IMutationCreateSquadNoteArgs {
  note: Scalars['String'];
  squadId: Scalars['String'];
}


export interface IMutationCreateUserSettingforWorklogReminderArgs {
  createUserSettingDto: ICreateUserSettingDtoInput;
}


export interface IMutationCreateWorklogArgs {
  worklogInput: INewWorklogDto;
}


export interface IMutationDeleteCandidateDocumentArgs {
  docUrl: Scalars['String'];
  parsedResumeId: Scalars['String'];
}


export interface IMutationDeleteFaqArgs {
  faqId: Scalars['String'];
}


export interface IMutationDeleteFavoriteTaskByIdArgs {
  favoriteTaskId: Scalars['String'];
}


export interface IMutationDeleteJobByIdArgs {
  jobId: Scalars['String'];
}


export interface IMutationDeleteLeaveByIdArgs {
  leaveIds: Scalars['String'];
}


export interface IMutationDeleteLeaveCategoryArgs {
  category: Scalars['String'];
}


export interface IMutationDeleteLeavesByIdsArgs {
  leaveIds: Array<Scalars['String']>;
}


export interface IMutationDeleteMultipleResumeArgs {
  jobId: Scalars['String'];
}


export interface IMutationDeleteMultipleResumeByIdsArgs {
  resumeIds: Array<Scalars['String']>;
}


export interface IMutationDeleteNoteArgs {
  id: Scalars['String'];
}


export interface IMutationDeleteParsedResumeArgs {
  parsedResumeReq: IParsedResumeReq;
}


export interface IMutationDeleteQueriesArgs {
  queryIds: Array<Scalars['String']>;
}


export interface IMutationDeleteRecurringTasksArgs {
  recurringDates: Array<Scalars['String']>;
  recurringId: Scalars['String'];
}


export interface IMutationDeleteResumeArgs {
  resumeId: Scalars['String'];
}


export interface IMutationDeleteResumeImportLogByJobIdArgs {
  jobId: Scalars['String'];
}


export interface IMutationDeleteSkillByUserIdArgs {
  deleteReason: Scalars['String'];
  profileId: Scalars['String'];
  skillId: Scalars['String'];
  userId: Scalars['String'];
}


export interface IMutationDeleteSourceParsedResumeArgs {
  jobId: Scalars['String'];
}


export interface IMutationDeleteTrainingCertificateArgs {
  traniningCertificateId: Scalars['String'];
}


export interface IMutationDeleteWorklogArgs {
  worklogId: Scalars['String'];
}


export interface IMutationDeleteWorklogTaskArgs {
  taskId: Scalars['String'];
}


export interface IMutationDuplicateJobArgs {
  enterprisePeopleId: Scalars['String'];
  importCandidates: Scalars['Boolean'];
  jobId: Scalars['String'];
}


export interface IMutationEditRecurringTasksArgs {
  recurringDates: Array<Scalars['String']>;
  recurringId: Scalars['String'];
  taskInput: IUpdateWorklogTaskDto;
}


export interface IMutationFindByCronTypeArgs {
  cronType: ICronTypeEnum;
}


export interface IMutationGenerateNewResumeUrlArgs {
  profileId: Scalars['String'];
}


export interface IMutationGetSignedUrlForUploadArgs {
  resumeSignedRequest: IResumeSignedUrlRequest;
}


export interface IMutationGetViewUrlsForResumeArgs {
  fileKeys: Array<Scalars['String']>;
}


export interface IMutationImportEmployeePhoneFromCsvArgs {
  file: Scalars['Upload'];
}


export interface IMutationImportResumesArgs {
  jobId: Scalars['String'];
  resumes: Array<IImportResumeRequest>;
}


export interface IMutationImportResumesForJobArgs {
  filterTestUsers: Scalars['Boolean'];
  jobId: Scalars['String'];
  resumeImportDto: IResumeUpdateDto;
}


export interface IMutationInviteToSquaderyConnectArgs {
  userId: Scalars['String'];
}


export interface IMutationMarkJobAsViewedArgs {
  jobId: Scalars['String'];
  viewedBy: Scalars['String'];
}


export interface IMutationOnboardOrOffboardInSquadArgs {
  moveDto?: Maybe<IMoveDto>;
  newResume?: Maybe<Scalars['Upload']>;
  onboardOffboardDto: IOnboardOffboardDto;
  squadResourceInputDto?: Maybe<ISquadResourceInputDto>;
}


export interface IMutationOtpLoginArgs {
  otpLoginArgs: IOtpLoginArgsDto;
}


export interface IMutationRemoveAssignedDevicesArgs {
  assignedDeviceId: Scalars['String'];
}


export interface IMutationRemoveClientContactArgs {
  clientContactId: Scalars['String'];
  squadId: Scalars['String'];
}


export interface IMutationRemoveFromConstantTypeArgs {
  squaderyConstantsDto: ISquaderyConstantsDto;
}


export interface IMutationRemoveKeyFromConstantTypeArgs {
  constantType: IConstantKeyValueDto;
}


export interface IMutationRemovePermissionFromGroupArgs {
  removePermissionFromGroupInput: IRemovePermissionFromGroupDto;
}


export interface IMutationRemovePersonaAndPermissionGroupFromUserArgs {
  removePersonaDto: IAssignPersonaDto;
}


export interface IMutationRemoveResumeUrlArgs {
  fileType: Scalars['String'];
  profileId: Scalars['String'];
}


export interface IMutationRemoveSquadHistoryArgs {
  squadHistoryId: Scalars['String'];
  userId: Scalars['String'];
}


export interface IMutationReparseResumeArgs {
  id: Scalars['String'];
  jobUpdateDto: IJobUpdateDto;
}


export interface IMutationReplaceResumeArgs {
  file: Scalars['Upload'];
  jobId: Scalars['String'];
  resumeId: Scalars['String'];
}


export interface IMutationRequestGeminiScoringArgs {
  data: IMlScoreRequestDto;
}


export interface IMutationResubmitWorklogsArgs {
  resubmitWorklogInput: IResubmitWorklogDto;
}


export interface IMutationSaveCustomQueryFieldArgs {
  customQueryField: ICustomQueryFieldReq;
}


export interface IMutationSaveListOrderArgs {
  listOrder: Array<IColumnMetadataInput>;
  listType: IOrderableListEnum;
}


export interface IMutationSaveOrUpdateQueryArgs {
  savedQueryDto: ISavedQueryReq;
}


export interface IMutationSaveSquaderyConstantsArgs {
  squaderyConstantsDto: ISquaderyConstantsDto;
}


export interface IMutationSendEmailToSupportArgs {
  SupportEmailReq: ISupportEmailReq;
}


export interface IMutationSendHelpEmailToSupportArgs {
  helpSectionSupportReq: IHelpSectionSupportReq;
}


export interface IMutationToggleSquadPinByUserIdArgs {
  squadId: Scalars['String'];
}


export interface IMutationUnarchiveJobArgs {
  id: Scalars['String'];
}


export interface IMutationUpdateAdditionalNoteArgs {
  additionalNoteId: Scalars['String'];
  updateAdditionalNoteDto: IUpdateAdditionalNoteDto;
}


export interface IMutationUpdateAllocatedTimeArgs {
  updateAllocatedTimePayload: IUpdateAllocatedTimePayload;
}


export interface IMutationUpdateBasicInfoArgs {
  file?: Maybe<Scalars['Upload']>;
  personalInfoDto: IUpdateBasicInfoDto;
  profileId: Scalars['String'];
  profilePic?: Maybe<Scalars['Upload']>;
}


export interface IMutationUpdateBasicInfoAndPersonalInfoArgs {
  dto: IUpdateBasicInfoDto;
  file?: Maybe<Scalars['Upload']>;
  personalInfoDto: IUpdatePersonalInfoDto;
  profileId: Scalars['String'];
  profilePic?: Maybe<Scalars['Upload']>;
}


export interface IMutationUpdateCandidateNoteArgs {
  updateNoteDto: IUpdateNoteDto;
}


export interface IMutationUpdateCandidateProfileArgs {
  id: Scalars['String'];
  updateCandidateDto: ICandidateInfo;
}


export interface IMutationUpdateCandidateStatusArgs {
  resumeId: Scalars['String'];
  statusDto: IUpdateCandidateStatusDto;
}


export interface IMutationUpdateCertificateArgs {
  certificateDto: Array<ICertificatesInputDto>;
  profileId: Scalars['String'];
}


export interface IMutationUpdateEducationArgs {
  educationDto: Array<IEducationRequestDto>;
  profileId: Scalars['String'];
}


export interface IMutationUpdateFaQsArgs {
  fAQsId: Scalars['String'];
  fAQsReq: IFaQsReq;
}


export interface IMutationUpdateFavoriteTaskArgs {
  favoriteTaskReq: IFavoriteTaskReq;
  favoriteTaskReqId: Scalars['String'];
}


export interface IMutationUpdateHelpSupportArgs {
  fAQsId: Scalars['String'];
  helpSectionReq: IHelpSectionReq;
}


export interface IMutationUpdateInvolvementHistoryArgs {
  editedHistory?: Maybe<Scalars['Float']>;
  involvementHistory: IInvolvementHistoryInput;
  ushId: Scalars['String'];
}


export interface IMutationUpdateJobArgs {
  id: Scalars['String'];
  jobUpdateDto: IJobUpdateDto;
}


export interface IMutationUpdateJobExperienceArgs {
  jobExperienceDto: Array<IJobExperienceInputDto>;
  profileId: Scalars['String'];
}


export interface IMutationUpdateJobStatusArgs {
  jobStatusUpdateDto: IJobStatusUpdateDto;
}


export interface IMutationUpdateParsedResumeArgs {
  updateParsedResumedDto: IParsedResumeUpdateDto;
}


export interface IMutationUpdatePersonalInfoArgs {
  personalInfoDto: IUpdatePersonalInfoDto;
  profileId: Scalars['String'];
}


export interface IMutationUpdateRecipientGroupArgs {
  recipientGroupId: Scalars['String'];
  updateRecipientGroupInput: IUpdateRecipientGroupInput;
}


export interface IMutationUpdateRequestToHireArgs {
  jobId: Scalars['String'];
  requestToHire: IJobUpdateDto;
}


export interface IMutationUpdateRoleDetailsByResourceIdArgs {
  squadResourceInputDto: ISquadResourceInputDto;
}


export interface IMutationUpdateSkillSetEmployeesArgs {
  file: Scalars['Upload'];
}


export interface IMutationUpdateSkillsArgs {
  profileId: Scalars['String'];
  skillDto: ISkillsReqDto;
}


export interface IMutationUpdateSquadArgs {
  clientContactDto?: Maybe<Array<ICreateClientContactDto>>;
  squadId: Scalars['String'];
  squadListDto: ISquadListDto;
}


export interface IMutationUpdateSupervisorsArgs {
  updateSupervisorData: IUpdateSupervisorDto;
}


export interface IMutationUpdateTrainingCertificateArgs {
  trainingCertificateId: Scalars['String'];
  updateTrainingCertificateInput: IUpdateTrainingCertificateDto;
  uploads?: Maybe<Array<Maybe<Scalars['Upload']>>>;
}


export interface IMutationUpdateWorkExperienceArgs {
  profileId: Scalars['String'];
  workExperience: IWorkExperienceInputDto;
}


export interface IMutationUpdateWorkInfoArgs {
  profileId: Scalars['String'];
  workInfoDto: IUpdateWorkInfoDto;
}


export interface IMutationUpdateWorklogCloseDocumentArgs {
  worklogCloseFilter: IWorklogCloseStatusFilterDto;
}


export interface IMutationUpdateWorklogTaskArgs {
  taskId: Scalars['String'];
  taskInput: IUpdateWorklogTaskDto;
  worklogId: Scalars['String'];
}


export interface IMutationUploadBulkCvArgs {
  file: Array<Scalars['Upload']>;
}


export interface IMutationUploadCsvHarvestArgs {
  file: Scalars['Upload'];
}


export interface IMutationUploadCertificateArgs {
  file: Scalars['Upload'];
}


export interface IMutationUploadClientAndSquadInfoArgs {
  file: Scalars['Upload'];
}


export interface IMutationUploadCsvOfEmployeesArgs {
  file: Scalars['Upload'];
}


export interface IMutationUploadDocumentsArgs {
  files?: Maybe<Array<Scalars['Upload']>>;
  parsedResumeId: Scalars['String'];
  replaceFile: Scalars['Boolean'];
  uploadedBy: Scalars['String'];
}


export interface IMutationUploadFileArgs {
  file: Scalars['Upload'];
  jobId: Scalars['String'];
  keepBoth: Scalars['Boolean'];
}


export interface IMutationUploadSkillsCsvArgs {
  file: Scalars['Upload'];
}


export interface IMutationUserBulkUploadArgs {
  files: Array<Scalars['Upload']>;
  userList: Array<IUserUploadInputDto>;
}


export interface IMutationValidateUserBulkUploadArgs {
  file: Scalars['Upload'];
}


export interface IMutationVerifyOtpArgs {
  verfiyOtpArgs: IVerfiyOtpArgsDto;
}


export interface IMutationWorklogLeaveApproveDeclineArgs {
  worklogLeaveApproveDeclineReq: IWorklogLeaveApproveDeclineReq;
}

export interface INewWorklogDto {
  endDate?: Maybe<Scalars['DateTime']>;
  isfromHarvestCSV?: Maybe<Scalars['Boolean']>;
  squadId: Scalars['String'];
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<IWorklogStatus>;
  tasks: Array<INewWorklogTaskDto>;
}

export interface INewWorklogTaskDto {
  category: Scalars['String'];
  description: Scalars['String'];
  endTime?: Maybe<Scalars['String']>;
  isRecurring?: Maybe<Scalars['Boolean']>;
  isfromHarvestCSV?: Maybe<Scalars['Boolean']>;
  minutes: Scalars['Int'];
  recurringDates?: Maybe<Array<Scalars['String']>>;
  recurringId?: Maybe<Scalars['String']>;
  recurringOptions?: Maybe<IRecurringOptions>;
  squadId?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['String']>;
  startTimeTemp?: Maybe<Scalars['String']>;
  worklogId?: Maybe<Scalars['String']>;
}

export interface INoteModificationsResponseDto {
  modifiedField: Scalars['String'];
  newValue: Scalars['String'];
  oldValue: Scalars['String'];
}

export enum INoteVisibility {
  EVERYONE = 'EVERYONE',
  ONLY_ME = 'ONLY_ME'
}

export interface IOnboardOffboardDto {
  allocatedHours?: Maybe<Scalars['Float']>;
  assignedFrom?: Maybe<Scalars['DateTime']>;
  assignedTo?: Maybe<Scalars['DateTime']>;
  clientBillingRate?: Maybe<Scalars['Float']>;
  clientId?: Maybe<Scalars['String']>;
  contractHours?: Maybe<Scalars['Float']>;
  endDate?: Maybe<Scalars['DateTime']>;
  estimatedEndDate?: Maybe<Scalars['DateTime']>;
  forceAssign?: Maybe<Scalars['Boolean']>;
  hasAllowance?: Maybe<Scalars['Boolean']>;
  involvedAs?: Maybe<IInvolvedAs>;
  involvementHistoryId?: Maybe<Scalars['String']>;
  involvementStatus?: Maybe<IInvolvementStatus>;
  isAssignedCoreWithOutTicket?: Maybe<Scalars['Boolean']>;
  jobType?: Maybe<IJobTypeEnum>;
  joinedDate?: Maybe<Scalars['DateTime']>;
  levelInSquad?: Maybe<IEmployeeLevel>;
  newNote?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  onHoldFrom?: Maybe<Scalars['DateTime']>;
  orgId?: Maybe<Scalars['String']>;
  phase?: Maybe<Array<Scalars['String']>>;
  probableCandidateId?: Maybe<Scalars['String']>;
  profileId?: Maybe<Scalars['String']>;
  replaceResumeInProfile?: Maybe<Scalars['Boolean']>;
  requiredForKickOff?: Maybe<Scalars['Boolean']>;
  resignDate?: Maybe<Scalars['DateTime']>;
  roleInSquad?: Maybe<Scalars['String']>;
  softAssignedTill?: Maybe<Scalars['DateTime']>;
  squadId: Scalars['String'];
  squadRoleId?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
  userSquadHistoryId?: Maybe<Scalars['String']>;
  workShift?: Maybe<IWorkShift>;
}

export enum IOrderableListEnum {
  ADD_RESOURCE_LIST = 'ADD_RESOURCE_LIST',
  ASSIGNED_RESOURCES_LIST = 'ASSIGNED_RESOURCES_LIST',
  CLIENT_LIST = 'CLIENT_LIST',
  CLIENT_ROLES_LIST = 'CLIENT_ROLES_LIST',
  CM_SQUAD_LIST = 'CM_SQUAD_LIST',
  COMPLETED_SQUAD_LIST_ORDER = 'COMPLETED_SQUAD_LIST_ORDER',
  EMPLOYEE_LIST = 'EMPLOYEE_LIST',
  JOB_CANDIDATE_LIST = 'JOB_CANDIDATE_LIST',
  JOB_LIST = 'JOB_LIST',
  NOT_RUNNING_LIST_ORDER = 'NOT_RUNNING_LIST_ORDER',
  REQUIRED_RESOURCES_LIST = 'REQUIRED_RESOURCES_LIST',
  ROLE_CANDIDATE_LIST = 'ROLE_CANDIDATE_LIST',
  SQUAD_LIST = 'SQUAD_LIST',
  WORKLOG_DATA_LIST = 'WORKLOG_DATA_LIST'
}

export interface IOtpLoginArgsDto {
  clientId?: Maybe<Scalars['String']>;
  /** Email associated with client, to send OTP to for verification or to login if already verified */
  email: Scalars['String'];
  /** Unique device fingerprint */
  fingerprint: Scalars['String'];
}

export interface IOtpLoginResponseDto {
  accessToken?: Maybe<Scalars['String']>;
  clientIdsEncoded?: Maybe<Scalars['String']>;
  clientInfo?: Maybe<IClientDetailDto>;
  expiresIn?: Maybe<Scalars['String']>;
  idToken?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  refreshToken?: Maybe<Scalars['String']>;
  resendTimer?: Maybe<Scalars['String']>;
  sessionToken?: Maybe<Scalars['String']>;
  tokenType?: Maybe<Scalars['String']>;
  userInfo?: Maybe<IUserInfoClientDto>;
}

export interface IOverallAndRelevantExperienceDto {
  overAllExperience: IYearMonthDto;
  profileId?: Maybe<Scalars['String']>;
  relevantExperience: IYearMonthDto;
}

export interface IOverallStatus {
  clientName?: Maybe<Scalars['String']>;
  involvementStatus?: Maybe<IInvolvementStatus>;
  roleInSquad?: Maybe<Scalars['String']>;
  squadName?: Maybe<Scalars['String']>;
  squadRoleId: Scalars['String'];
}

export interface IPageRequest {
  /** Items to list per page */
  customQuery?: Maybe<Scalars['String']>;
  /** Items to list per page */
  direction?: Maybe<ISortDirection>;
  /** Current page to fetch data */
  page: Scalars['Float'];
  /** Items to list per page */
  size: Scalars['Float'];
  /** Items to list per page */
  sortField?: Maybe<Scalars['String']>;
}

export interface IPageable {
  /** Current page */
  page: Scalars['Float'];
  /** Items listed in current page */
  size: Scalars['Float'];
  /** Total items in the search result */
  totalElements: Scalars['Float'];
  /** Total pages in the search result */
  totalPages: Scalars['Float'];
}

export interface IPaginationMetaDto {
  limit: Scalars['Float'];
  page: Scalars['Float'];
  totalPages: Scalars['Float'];
}

export enum IParseStatus {
  COMPLETED = 'COMPLETED',
  DUPLICATE = 'DUPLICATE',
  FAILED = 'FAILED',
  IN_PROGRESS = 'IN_PROGRESS'
}

export interface IParsedDeviceResultDto {
  browser: Scalars['String'];
  device: Scalars['String'];
  os: Scalars['String'];
}

export interface IParsedResume {
  addedBy?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  batchId?: Maybe<Scalars['String']>;
  candidateStageStatus?: Maybe<Scalars['String']>;
  candidateStatus?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Array<Maybe<Scalars['String']>>>;
  firstName?: Maybe<Scalars['String']>;
  githubUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  jobId?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  latestEmployer?: Maybe<Scalars['String']>;
  linkedinUrl?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  noteCount?: Maybe<Scalars['Float']>;
  orgId: Scalars['String'];
  parseStatus?: Maybe<IParseStatus>;
  phone?: Maybe<Array<Maybe<Scalars['String']>>>;
  region?: Maybe<Scalars['String']>;
  remarks?: Maybe<Scalars['String']>;
  resumeId?: Maybe<Scalars['String']>;
  resumeSource?: Maybe<Scalars['String']>;
  resumeUrl?: Maybe<Scalars['String']>;
  score?: Maybe<Scalars['Float']>;
  skills?: Maybe<ISkill>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
  yearsOfExperience?: Maybe<Scalars['String']>;
}

export interface IParsedResumeReq {
  isResync?: Maybe<Scalars['Boolean']>;
  jobId: Scalars['String'];
  parsedResumeId: Array<Scalars['String']>;
}

export interface IParsedResumeUpdateDto {
  address?: Maybe<Scalars['String']>;
  email?: Maybe<Array<Scalars['String']>>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  latestEmployer?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  parsedResumeId: Scalars['String'];
  phone?: Maybe<Array<Scalars['String']>>;
  resumeSource: IResumeSource;
  score?: Maybe<Scalars['Float']>;
  skills?: Maybe<ISkillsReqDto>;
  yearsOfExperience?: Maybe<Scalars['String']>;
}

export interface IPermissionGroupDto {
  _id?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  orgId?: Maybe<Scalars['String']>;
  /** Permission_Manage.ANALYTICS */
  permissions: Array<Scalars['String']>;
}

export interface IPermissionGroupRespObject {
  _id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  orgId: Scalars['String'];
  permissions: Array<Scalars['String']>;
}

export interface IPermissionHierarchyDto {
  description: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  parentId?: Maybe<Scalars['String']>;
  permission: Scalars['String'];
  permissionHierarchy?: Maybe<Array<IPermissionHierarchyDto>>;
  selected?: Maybe<Scalars['Boolean']>;
  title: Scalars['String'];
  type?: Maybe<IPermissionType>;
}

export interface IPermissionHierarchyResp {
  description: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  parentId?: Maybe<Scalars['String']>;
  permission: Scalars['String'];
  permissionHierarchy?: Maybe<Array<IPermissionHierarchyResp>>;
  selected?: Maybe<Scalars['Boolean']>;
  title: Scalars['String'];
  type: IPermissionType;
}

export enum IPermissionType {
  ACTION = 'ACTION',
  VIEW = 'VIEW'
}

export interface IPersonaDto {
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  orgId?: Maybe<Scalars['String']>;
  permissionGroupIds?: Maybe<Array<Scalars['String']>>;
  permissionGroups?: Maybe<Array<Maybe<IPermissionGroupResp>>>;
}

export interface IPersonaInputDto {
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  orgId?: Maybe<Scalars['String']>;
  permissionGroupIds?: Maybe<Array<Scalars['String']>>;
  permissionGroups?: Maybe<Array<Maybe<IPermissionGroupDto>>>;
}

export interface IPersonaResponseDto {
  _id?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  orgId?: Maybe<Scalars['String']>;
  permissionGroupIds?: Maybe<Array<Scalars['String']>>;
}

export interface IPersonalInfo {
  availibility?: Maybe<Scalars['String']>;
  countryOfResidence?: Maybe<Scalars['String']>;
  department?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  filename?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  joinedDate?: Maybe<Scalars['DateTime']>;
  level?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  phoneNumber?: Maybe<Scalars['String']>;
  resumeUrl?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
}

export interface IPersonalInfoDto {
  availability?: Maybe<IAvailability>;
  availabilityStatus?: Maybe<Scalars['String']>;
  countryOfResidence?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  employeeActiveStatus?: Maybe<Scalars['String']>;
  filename?: Maybe<Scalars['String']>;
  gender?: Maybe<IGender>;
  githubUrl?: Maybe<Scalars['String']>;
  joinedDate?: Maybe<Scalars['DateTime']>;
  linkedinUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  phoneNumber?: Maybe<Scalars['String']>;
  profileImage?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  resignDate?: Maybe<Scalars['DateTime']>;
  resumeUpdatedDate?: Maybe<Scalars['DateTime']>;
  resumeUrl?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  timeZone?: Maybe<Scalars['String']>;
}

export enum IPriorityEnum {
  HIGH = 'HIGH',
  LOW = 'LOW',
  MEDIUM = 'MEDIUM'
}

export interface IProbableCandidateDto {
  assigned?: Maybe<Scalars['Boolean']>;
  clientId?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['DateTime']>;
  estimatedEndDate?: Maybe<Scalars['DateTime']>;
  involvedAs?: Maybe<IInvolvedAs>;
  involvementStatus: IInvolvementStatus;
  jobType?: Maybe<IJobTypeEnum>;
  joinedDate?: Maybe<Scalars['DateTime']>;
  levelInSquad?: Maybe<IEmployeeLevel>;
  orgId?: Maybe<Scalars['String']>;
  phase?: Maybe<Scalars['String']>;
  probableCandidateId?: Maybe<Scalars['String']>;
  profileId?: Maybe<Scalars['String']>;
  profileImage?: Maybe<Scalars['String']>;
  requiredForKickOff?: Maybe<Scalars['Boolean']>;
  roleInSquad?: Maybe<Scalars['String']>;
  squadId?: Maybe<Scalars['String']>;
  squadResourceId?: Maybe<Scalars['String']>;
  squadRoleId?: Maybe<Scalars['String']>;
  squadType?: Maybe<ISquadType>;
  userId?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
}

export interface IProbableCandidateInfoDto {
  country?: Maybe<Scalars['String']>;
  involvedAs?: Maybe<IInvolvedAs>;
  involvementStatus?: Maybe<IInvolvementStatus>;
  involvementStatusForClients?: Maybe<IInvolvement_Status_For_Clients_Enum>;
  profileId?: Maybe<Scalars['String']>;
  profileImage?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  resumeUrl?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  skills?: Maybe<Array<Scalars['String']>>;
  softAssignedTill?: Maybe<Scalars['DateTime']>;
  squadInfo?: Maybe<ISquadInfoForCandidateDto>;
  timeZone?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
}

export interface IProbableCandidatesDto {
  employeeId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  profileId?: Maybe<Scalars['String']>;
  profileImage?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
}

export interface IProfileDto {
  assignedDevices?: Maybe<Array<IAssignedDevices>>;
  availableSince?: Maybe<Scalars['DateTime']>;
  certificates?: Maybe<Array<ICertificatesDto>>;
  currentSquads: Array<ICurrentSquads>;
  currentWorkInfo: ICurrentWorkInfoDto;
  designation?: Maybe<Scalars['String']>;
  education: Array<IEducationDto>;
  employeeActiveStatus?: Maybe<Scalars['String']>;
  employeementType?: Maybe<IFuseEmployeementType>;
  estimatedEndDate?: Maybe<Scalars['DateTime']>;
  experience?: Maybe<IWorkExperienceDto>;
  invitedToConnect?: Maybe<Scalars['Boolean']>;
  jobExperience?: Maybe<Array<IJobExperienceDto>>;
  overAllExperience?: Maybe<IExperienceDto>;
  paymentOption: Array<IBillingOption>;
  personalInfo: IPersonalInfoDto;
  profileId?: Maybe<Scalars['String']>;
  relevantExperience?: Maybe<IExperienceDto>;
  skills?: Maybe<ISkillsDto>;
  squadStatus?: Maybe<IInvolvementStatus>;
  squads: Array<ISquadInfoDto>;
  supervisors?: Maybe<Array<Maybe<IUserSupervisor>>>;
  userId: Scalars['String'];
  workExperience?: Maybe<Array<IWorkExperienceDto>>;
}

export interface IQuery {
  WorklogLeavesByWorklogId: Scalars['String'];
  addResumes: IJob;
  advancedFilter: IAdvancedResumeSearchPaged;
  advancedJobSearch: IAdvancedJobSearchPaged;
  candidateProfileInfo: ICandidateJobBasicInfo;
  checkJobResumeResyncStatus: IJobResumeResyncOutputDto;
  /** Permission: CONSIDERED_RESOURCES */
  consideredResources: IEligibleCandidatesDtoPaged;
  /** It returns total number of squads and total number of unassigned roles based on filters or without filters. It was previously used in squad management page. Permission: SQUAD_ROLES_COUNT */
  countSquadUnassignedroles: Array<ICountSquadResponseDto>;
  deleteAllJobs: Scalars['String'];
  deleteOneRecurringJob: Scalars['String'];
  deleteWorklogCategories: Scalars['String'];
  deleteWorklogCategory: Scalars['String'];
  downloadParsedResume: IDownloadParsedResumeResp;
  editSkillsNotificationAndEmail: Scalars['String'];
  emailExists: Scalars['Boolean'];
  employeeListExportToCsv: Scalars['String'];
  employeeNames: Array<IUsersNameListDto>;
  /** Permission: ASSIGNED_RESOURCES */
  exportCsvAssignedResources: Scalars['String'];
  exportErrorDataSheet: Scalars['String'];
  /** Export user worklog requests to CSV */
  exportWorklog: Scalars['String'];
  /** Returns a log of changes made to allocated hour time; Used in worklog overview page */
  fetchNotes: Array<IListNotesResponse>;
  /** Get all the additional notes by userSquadHistoryId */
  findAllAdditionalNotesByUserSquadHistoryId: Array<IAdditionalNoteResponseDto>;
  findAllSquadCategory: Array<ISquadCategoryResponse>;
  findAllTrainingCertificatesByProfileId: Array<ITrainingCertificateResponseDto>;
  findBenchStatus: Array<IBenchStatusResponseDto>;
  /** It returns client names and client squads by client type. Permission: EMP_LIST */
  findClientAndSquads: Array<IClientSquadsResponseDto>;
  findEmployeeLevelTypes: IEmployeeLevelTypeResponseDto;
  findEmployeementTypes: IEmployeementTypeDto;
  findEngagementLevelTypes: IEngagementLevelTypeResponseDto;
  findFavoriteTasksByUserIdAndSquadId: Array<IFavoriteTaskDto>;
  findParsedResumesForProfile: Array<Scalars['String']>;
  findProfileSquadRoles: Array<Scalars['String']>;
  findRoles: IRolesResponseDto;
  findSkills: ISkillsResponse;
  findUserSettingByUserId: ICreateUserSettingType;
  getAllClients: Array<IClientNamesDto>;
  getAllCronJobs: IAllCronsResponseObjectType;
  getAllEmployeeSkills: Array<Scalars['String']>;
  getAllEnterpriseUsers: Array<IEnterpriseUser>;
  getAllFAQs: Array<IFaQsDto>;
  getAllFavoriteTasks: Array<IFavoriteTaskDto>;
  getAllLineOfBusiness: Array<ILineOfBusinessDto>;
  getAllNotRunningSquads: Array<ISquadNamesDto>;
  getAllPermissionGroups: Array<IPermissionGroupResp>;
  getAllPermissions: Array<ICombined_Permissions>;
  getAllPersona: Array<IPersonaDto>;
  getAllRoles: Array<IRoleDto>;
  getAllRunningSquads: Array<ISquadNamesDto>;
  getAllSquadsTechStack: Array<Scalars['String']>;
  getAllVerticalHeads: Array<IVerticalHeadDto>;
  getAllVerticalIndustry: Array<IVerticalIndustryNameDto>;
  getAllVerticalIndustryByVerticalId: Array<IVerticalIndustryNameDto>;
  getAllVerticals: Array<IVerticalDto>;
  /** Fetch allocated time records, used for debugging only */
  getAllocatedTime: Array<IAllocatedTimeResponse>;
  getAssessments: Array<Scalars['String']>;
  getAssignedDevices: Array<Scalars['String']>;
  /** Permission: ASSIGNED_RESOURCES */
  getAssignedResources: Array<IAssignedEmployeeDto>;
  /** List squad members for given time period to view worklog related data */
  getAssignedResourcesWorklogTab: IAssignedResourcesWorklogTabDtoPaged;
  /** Permission: ASSIGNED_RESOURCES */
  getAssignedTeamMembers: IEmployeeInfoPaged;
  getAvailabilityOptions: Array<IAvailabilityOptionsResponseDto>;
  getByConstantType: ISquaderyConstantsResp;
  getCandidateDocuments: Array<ICandidateDocuments>;
  getCandidateInfo: ICandidateProfileInfo;
  getCandidateNotes: Array<ICandidateNotes>;
  getCandidateProfileFromResume: ICandidateParsedResumeInfo;
  getCandidateSkillsForJob: Array<Scalars['String']>;
  getCandidateStageCount: Array<ICandidateStageCountResponse>;
  getCandidateSuitabilityScore: IScoringResultsDto;
  getCandidates: ICandidateAdvancedList;
  getCbuDepartments: Array<ICbuDepartmentsResp>;
  getCbuLists: Array<Scalars['String']>;
  getCertificateUrl: Scalars['String'];
  /** It returns the specific client information by id. It will show some client information in client details page like contact and client name. Permission: CLIENT_DETAILS */
  getClientById: IClientInfoDto;
  /** It returns list of client squad contacts. Permission: CLIENT_CONTACTS */
  getClientContactGroupedBySquad: Array<ISquadContactDetail>;
  /** It returns all the client's names only. Permission: CM */
  getClientList: Array<IClientIdNameDto>;
  /** Returns all the roles with details associated with the client */
  getClientRoles: IClientRolesPagedResponse;
  /** It returns all the client's squads with fields required to be shown in squad list tab of client details page. Permission: CM_SQUAD_LIST */
  getClientSpecificSquad: IClientSpecificSquadsPaged;
  /** It returns all the clients with or without filters with fields required to be shown on client management page. Permission: CLIENT_LIST */
  getClients: IClientInfoDtoPaged;
  /** It returns all client's squad with assigned resources in the respective squad with and without filters. It will be used in assigned resources list tab of client details page. Permission: CLIENT_ASSIGNED_RESOURCES */
  getClientsAssignedResources: Array<ISquadEmployeeInfo>;
  /** Fetch user's list of comments */
  getComments?: Maybe<Array<IWorklogCommentsDto>>;
  getConsultantProfile: IProfileDto;
  /** It returns profile information of the logged in user. Permission: REQUEST_TO_HIRE */
  getContributingHiringMembers: IContributingHiringMemberTypes;
  getCountries: Array<ICountryDto>;
  getCountriesAddCandidate: Array<Scalars['String']>;
  getCustomQueryField: ICustomQueryFieldResp;
  getDashboardAnalytics: IDashboardAnalyticsDto;
  /** It returns the list of deal owners available in the squads collection. Permission: SM */
  getDealOwnersInSquad: Array<Scalars['String']>;
  getDepartmentByLevel: Array<IDepartmentResponse>;
  getDepartmentByParentId: Array<IDepartmentResponse>;
  getDepartmentHodByNameAndLocation: Array<ICreateDepartmentHodDto>;
  getDepartments: Array<IDepartmentResponseDto>;
  getDesignations: Array<IDesignationDto>;
  getDocumentUrl: Scalars['String'];
  /** Permission: EMPLOYEE_PROFILE */
  getEmployeePersonalInfo: IProfileDto;
  /** It returns employee profile information by id. If userSquadHistoryId argument is also provided, then the squadStatus for the employee will also be returned in the result. Permission: EMPLOYEE_PROFILE */
  getEmployeePersonalInfoByUserId: IProfileDto;
  getEmployeeUploadSample: Scalars['String'];
  getEnterprisePeople: IEnterprisePeople;
  /** Permission: CLIENT_ASSIGNED_RESOURCES */
  getFMClientAssignedResources: Array<ISquadEmployeeInfo>;
  /** Permission: CLIENT_DETAILS */
  getFMClientById: IClientInfoDto;
  /** Permission: CM_SQUAD_LIST */
  getFMClientSpecificSquad: Array<IClientOverviewSquadListDto>;
  /** Permission: CLIENT_ASSIGNED_RESOURCES */
  getFMClientSquadAssignedResources: ISquadEmployeeInfo;
  getFMSquadById: ISquadDto;
  getFMSquadOverview: ISquadOverviewDto;
  getFieldHistory: IFieldHistoryPaged;
  getHelpSupport: Array<IHelpSectionDto>;
  getHiringContributors: Array<IContributingMemberDetailsDto>;
  getInvoiceRelateData: IInvoiceResponseDto;
  getInvolvementHistory: Array<IInvolvementHistoryDto>;
  getJobCreatorDetails: IJobCreatorDto;
  getJobCreators: Array<IJobCreator>;
  getJobDescriptionTemplates: Array<IJobDescriptionTemplateType>;
  getLatestResumeScore?: Maybe<ILatestResumeScoreResponseDto>;
  getLeaveCategories: Array<Scalars['String']>;
  getMainDepartmentAndSubDepartments: Array<IDepartmentBreakdownResponseDto>;
  getNewRequestedJobs: Array<IRequestedJobViewsType>;
  getParsedResumeById: Scalars['String'];
  getPermissionGroupById: IPermissionGroupResp;
  getPermissionHierarchy?: Maybe<Array<Maybe<IPermissionHierarchyResp>>>;
  getPersonaById: IPersonaDto;
  /** Permission: SM */
  getPhasesInSquad?: Maybe<Array<Scalars['String']>>;
  getRecurringDatesByRecurringId: Array<Scalars['String']>;
  getRecurringWorklogsAndTasks: Array<IFetchRecurringTaskDto>;
  getRegionForRTH: Array<IKeyObjectResp>;
  getRegions: IRegionResponseDto;
  /** Fetch roles of required resources in the squad; Permission: REQUIRED_RESOURCES */
  getRequiredResourceRolesInSquad: Array<Scalars['String']>;
  getResumeScoresSummary: Array<IResumeScoreSummaryDto>;
  /** Returns all the probable candidates for a role with associated details */
  getRoleCandidates: IRoleCandidatesPagedResponse;
  /** It returns squad role , squad resource and usersquadhistory information by squadroleid and usersquadhistoryid */
  getRoleDetailsById: ISquadAndSquadResources;
  /** Permission: RM */
  getRoleDetailsBySquadRoleId: IAvailableSquadRolesDto;
  /** Permission: ASSIGNED_RESOURCES */
  getRoleInfoByHistoryId: IHistorySquadAndClientDto;
  /** Permission: RM */
  getRoleToAssignCandidate: IAvailableSquadRolesDto;
  getRoles: Array<Scalars['String']>;
  /** Permission: CM */
  getRolesByClientOrSquad: Array<Scalars['String']>;
  getRolesByTypes: Array<IRoleDtoAddCandidate>;
  /** Permission: SM */
  getRolesInSquad?: Maybe<Array<Scalars['String']>>;
  /** It returns list of roles for which we can assign resources. */
  getRolesToAssign: Array<Scalars['String']>;
  /** Permission: RM */
  getRolesToAssignCandidates: IAvailableSquadRoles;
  getRolesWithCandidateCount: Array<IRolesWithCandidatesDto>;
  getRthTemplate: Array<IRthTemplateResp>;
  /** It returns list of running squads by client id sorted by name in ascending order. Permission: CM_SQUAD_LIST */
  getRunningSquadsByClientId: Array<ISquadIdNameDto>;
  getSavedQueries: Array<ISavedQueryResp>;
  getSingleParsedResumeData: IParsedResume;
  getSkillByUserId: ICreateUpdateSkillDto;
  getSkills: Array<Scalars['String']>;
  /** Permission: CM */
  getSkillsByClientOrSquad: Array<Scalars['String']>;
  getSoftSkills: Array<Scalars['String']>;
  getSquadAssignedResources: ISquadEmployeeInfo;
  /** Permission: SQUAD_BREAKDOWN */
  getSquadAssignedResourcesBreakdown: IResourceLevelBreakdown;
  /** It returns the specific squad information by id with its contact and client information. It's being used in squad overview page. Permission: SQUAD_DETAILS */
  getSquadById: ISquadDto;
  /** Fetch list of employee ids belonging to squad */
  getSquadEmployeeIds: Array<Scalars['String']>;
  getSquadInvoicingPeriodList: Array<ISquadInvoicePeriodList>;
  /** It returns all the squads by client and organization sorted by squad name in ascending order. Permission: CM_SQUAD_LIST */
  getSquadListByClientId: Array<ISquadIdNameDto>;
  getSquadNoteBySquadId: Array<ISquadNotes>;
  /** It returns specific squad's ai and tech assigned resources count data with their level. Permission: SQUAD_BREAKDOWN */
  getSquadOverview: ISquadOverviewDto;
  /** Permission: REQUIRED_RESOURCES */
  getSquadRequiredResources: IRequiredResourcesPaged;
  /** It returns squad, squad resource and squad role information. Permission: REQUEST_TO_HIRE */
  getSquadResourceAndSquadById: Array<ISquadAndSquadResources>;
  /** Permission: SQUAD_DETAILS */
  getSquadResourceDetails: ISquadResourceDetailDto;
  /** It returns all the squads by organization sorted by squad name in ascending order. Permission: SM */
  getSquads: Array<ISquadDto>;
  /** Permission : READ_SQUAD_INFO */
  getSquadsInfo: Array<IAssignedSquadInfoDto>;
  /** It returns list of squads with its client information with or without filters.It's being used in squad management page. Permission: SM */
  getSquadsWithFilter: ISquadListPaged;
  getSubDepartments: Array<IDepartmentBreakdown>;
  getSucceededUsers: IUsersByRoleAndLevelData;
  getTaggableUsersForJob: Array<ITaggableUser>;
  /** It returns list of ticket owners and countries. */
  getTicketOwnersAndCountries: Array<ITicketOwnersCountriesDto>;
  getTimeZones: Array<Scalars['String']>;
  getTimeZonesAddCandidate: Array<Scalars['String']>;
  getTrackedIps: ITrackedIpsPaged;
  /** Permission: CM */
  getUnassignedClientListByUserId: Array<IClientIdNameDto>;
  /** Permission: SM */
  getUserAssignedSquadsByUserId: Array<IUserAssignedSquads>;
  /** Fetch user's profile and squad details */
  getUserData: IUserInformationResponseDto;
  getUserInfo: IEnterprisePeople;
  getUserList: IUserListPageable;
  getUserListDropDown: IUserListPageable;
  getUserPreference: IUserPreferenceType;
  getWorkingTimeZones: Array<Scalars['String']>;
  getWorklogCategories: Array<Scalars['String']>;
  getWorklogCloseDocument: IWorklogCloseDocumentResponseDto;
  /** Fetch user's worklog overview */
  getWorklogOverview: IWorklogOverviewResponseDto;
  /** Fetch list of user's worklogs */
  getWorklogRequests?: Maybe<IWorklogsDtoPaged>;
  healthCheckGQL: Scalars['String'];
  job: Array<IJob>;
  jobById: IJob;
  jobByOrg: Array<IJob>;
  jobPaginated: Array<IJob>;
  jobStatusBased: Array<IJob>;
  listAllPermissionGroups: Array<IPermissionGroupResp>;
  listAllPersona: Array<IPersonaResponseDto>;
  listAllRepeatableJobs: Scalars['String'];
  /** Fetch list of users (only squad members or all squadery users) to assign as default or additional approver for given squad */
  listApprovers: Array<IApproverInfo>;
  listNotes: Array<IUserSquadHistoryWithNotesDto>;
  /** Permission: LIST_RESOURCES */
  listResources: IEligibleCandidatesDtoPaged;
  /** Fetch list of assigned users in the squad so that they can be assigned to any approvers */
  listResourcesToAssignApprovers: Array<IAssignedEmployeeDto>;
  /** List supervisors */
  listSupervisors: Array<ISupervisorInfo>;
  logAllQueueInfo: Scalars['String'];
  /** It returns offboaring and replacing resource information by squad role id */
  offboardingAndReplaceResources: IEligibleCandidatesDto;
  recipientGroups: Array<IRecipientGroupResponseObjectType>;
  removeCronFromRedis: Scalars['String'];
  removeJobById: Scalars['String'];
  resumeImportLogByJobId: IResumeImportLogObjectType;
  resyncImportForSpecificJob: Scalars['String'];
  resyncImportSucceededCandidates: Scalars['String'];
  resyncResumeParsing: Scalars['String'];
  revalidateEmployeeData: IUserUploadValidationResponse;
  setJobNewResumesToZero: IJob;
  showCandidateProfile: ICandidateProfileResponse;
  startResumeParsing: IJob;
  uniqueAddedBy: Array<Scalars['String']>;
  uniqueLocationsAndRegionsByJobId: Array<IKeyObjectResp>;
  /** Permission: EMP_LIST */
  userSquadHistoriesAdvancedSearch: IUserSquadHistoryPaged;
  viewSquadDetailsBySquadId: IViewSquadDetailsDto;
}


export interface IQueryWorklogLeavesByWorklogIdArgs {
  worklogId: Scalars['String'];
}


export interface IQueryAddResumesArgs {
  addResumeRequest: IAddResumeRequestDto;
}


export interface IQueryAdvancedFilterArgs {
  advancedSearchRequest: IAdvancedSearchRequestDto;
  jobId: Scalars['String'];
  pageRequest: IPageRequest;
}


export interface IQueryAdvancedJobSearchArgs {
  jobPaginationDto: IJobPaginationDto;
  pageRequest: IPageRequest;
}


export interface IQueryCandidateProfileInfoArgs {
  parsedResumeId: Scalars['String'];
}


export interface IQueryConsideredResourcesArgs {
  filter: IEligibleCandidatesFilterDto;
  pageRequest: IPageRequest;
}


export interface IQueryCountSquadUnassignedrolesArgs {
  squadListDto: ISquadListDto;
}


export interface IQueryDeleteOneRecurringJobArgs {
  cron: Scalars['String'];
  jobId: Scalars['String'];
  queueName: Scalars['String'];
}


export interface IQueryDeleteWorklogCategoryArgs {
  category: Scalars['String'];
}


export interface IQueryDownloadParsedResumeArgs {
  exportAll?: Maybe<Scalars['Boolean']>;
  fileType: IFileType;
  jobId: Scalars['String'];
  parsedResumeIds: Array<Scalars['String']>;
}


export interface IQueryEmailExistsArgs {
  email: Scalars['String'];
}


export interface IQueryEmployeeListExportToCsvArgs {
  exportAll?: Maybe<Scalars['Boolean']>;
  fileFormat: Scalars['String'];
  pageRequest: IPageRequest;
  searchDto: IUserSquadHistoryAdvancedSearchDto;
}


export interface IQueryExportCsvAssignedResourcesArgs {
  pageRequest: IPageRequest;
  squadId: Scalars['String'];
  userSquadHistorySearchDTO: IUserSquadHistorySearchDto;
}


export interface IQueryExportErrorDataSheetArgs {
  userList: Scalars['String'];
}


export interface IQueryExportWorklogArgs {
  filter: IExportAndInvoiceWorklogFilter;
}


export interface IQueryFetchNotesArgs {
  userSquadHistoryId: Scalars['String'];
}


export interface IQueryFindAllAdditionalNotesByUserSquadHistoryIdArgs {
  involvementHistoryId?: Maybe<Scalars['String']>;
  userSquadHistoryIds?: Maybe<Array<Scalars['String']>>;
}


export interface IQueryFindAllTrainingCertificatesByProfileIdArgs {
  profileId: Scalars['String'];
}


export interface IQueryFindClientAndSquadsArgs {
  clientType: Scalars['String'];
}


export interface IQueryFindFavoriteTasksByUserIdAndSquadIdArgs {
  squadId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
}


export interface IQueryFindParsedResumesForProfileArgs {
  advancedSearchRequest: IAdvancedSearchRequestDto;
  jobId: Scalars['String'];
  pageRequest: IPageRequest;
}


export interface IQueryFindUserSettingByUserIdArgs {
  userId: Scalars['String'];
}


export interface IQueryGetAllPermissionGroupsArgs {
  searchKey?: Maybe<Scalars['String']>;
}


export interface IQueryGetAllPersonaArgs {
  searchKey: Scalars['String'];
}


export interface IQueryGetAllVerticalIndustryByVerticalIdArgs {
  verticalId: Scalars['String'];
}


export interface IQueryGetAssignedResourcesArgs {
  squadId: Scalars['String'];
}


export interface IQueryGetAssignedResourcesWorklogTabArgs {
  pageRequest: IPageRequest;
  squadId: Scalars['String'];
  userSquadHistorySearchDTO: IUserSquadHistorySearchDto;
}


export interface IQueryGetAssignedTeamMembersArgs {
  pageRequest: IPageRequest;
  squadId: Scalars['String'];
  userSquadHistorySearchDTO: IUserSquadHistorySearchDto;
}


export interface IQueryGetByConstantTypeArgs {
  constantType: ISquaderyConstantsEnum;
}


export interface IQueryGetCandidateDocumentsArgs {
  parsedResumeId: Scalars['String'];
  searchquery: Scalars['String'];
}


export interface IQueryGetCandidateInfoArgs {
  profileId: Scalars['String'];
}


export interface IQueryGetCandidateNotesArgs {
  parentId: Scalars['String'];
  parsedResumeId: Scalars['String'];
  viewedBy: Scalars['String'];
}


export interface IQueryGetCandidateProfileFromResumeArgs {
  id: Scalars['String'];
}


export interface IQueryGetCandidateSkillsForJobArgs {
  jobId: Scalars['String'];
}


export interface IQueryGetCandidateStageCountArgs {
  advancedSearchRequest: IAdvancedSearchRequestDto;
  jobId: Scalars['String'];
  pageRequest: IPageRequest;
}


export interface IQueryGetCandidateSuitabilityScoreArgs {
  parsedResumeId: Scalars['String'];
}


export interface IQueryGetCandidatesArgs {
  candidateAdvancedSearchDto: ICandidateAdvancedSearchDto;
}


export interface IQueryGetCertificateUrlArgs {
  fileName: Scalars['String'];
}


export interface IQueryGetClientByIdArgs {
  id: Scalars['String'];
}


export interface IQueryGetClientContactGroupedBySquadArgs {
  id: Scalars['String'];
}


export interface IQueryGetClientRolesArgs {
  filter: IGetClientRolesFilterDto;
  pageRequest: IPageRequest;
}


export interface IQueryGetClientSpecificSquadArgs {
  id: Scalars['String'];
  pageRequest?: Maybe<IPageRequest>;
  search?: Maybe<Scalars['String']>;
}


export interface IQueryGetClientsArgs {
  filterDto: IClientFilterDto;
  pageable: IPageRequest;
}


export interface IQueryGetClientsAssignedResourcesArgs {
  id: Scalars['String'];
  userSquadHistorySearchDTO: IUserSquadHistorySearchDto;
}


export interface IQueryGetCommentsArgs {
  commentFilter: ICommentFilter;
}


export interface IQueryGetCustomQueryFieldArgs {
  listName: Scalars['String'];
}


export interface IQueryGetDepartmentByLevelArgs {
  level: IDepartmentLevel;
}


export interface IQueryGetDepartmentByParentIdArgs {
  parentId: Scalars['String'];
}


export interface IQueryGetDepartmentHodByNameAndLocationArgs {
  associatedCountry: Array<Scalars['String']>;
  departmentName: Scalars['String'];
}


export interface IQueryGetDocumentUrlArgs {
  docUrl: Scalars['String'];
}


export interface IQueryGetEmployeePersonalInfoArgs {
  squadRoleId?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
}


export interface IQueryGetEmployeePersonalInfoByUserIdArgs {
  squadRoleId?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
  userSquadHistoryId?: Maybe<Scalars['String']>;
}


export interface IQueryGetEnterprisePeopleArgs {
  enterprisePeopleId: Scalars['String'];
}


export interface IQueryGetFmClientAssignedResourcesArgs {
  userSquadHistorySearchDTO: IUserSquadHistorySearchDto;
}


export interface IQueryGetFmClientSpecificSquadArgs {
  search?: Maybe<Scalars['String']>;
}


export interface IQueryGetFmClientSquadAssignedResourcesArgs {
  id: Scalars['String'];
  userSquadHistorySearchDTO: IUserSquadHistorySearchDto;
}


export interface IQueryGetFmSquadByIdArgs {
  id: Scalars['String'];
}


export interface IQueryGetFmSquadOverviewArgs {
  id: Scalars['String'];
}


export interface IQueryGetFieldHistoryArgs {
  fieldHistoryFilter: IFieldHistoryFilterDto;
  pageRequest: IPageRequest;
}


export interface IQueryGetHiringContributorsArgs {
  id: Scalars['String'];
}


export interface IQueryGetInvoiceRelateDataArgs {
  invoicingFilter: IExportAndInvoiceWorklogFilter;
}


export interface IQueryGetInvolvementHistoryArgs {
  ushId: Scalars['String'];
}


export interface IQueryGetJobCreatorDetailsArgs {
  id: Scalars['String'];
}


export interface IQueryGetLatestResumeScoreArgs {
  parsedResumeId: Scalars['String'];
}


export interface IQueryGetNewRequestedJobsArgs {
  enterprisePeopleId: Scalars['String'];
}


export interface IQueryGetParsedResumeByIdArgs {
  parsedResumeId: Scalars['String'];
}


export interface IQueryGetPermissionGroupByIdArgs {
  id: Scalars['String'];
}


export interface IQueryGetPermissionHierarchyArgs {
  filterSelected?: Maybe<Scalars['Boolean']>;
  permissionGroupId?: Maybe<Scalars['String']>;
}


export interface IQueryGetPersonaByIdArgs {
  id: Scalars['String'];
}


export interface IQueryGetPhasesInSquadArgs {
  squadId: Scalars['String'];
}


export interface IQueryGetRecurringDatesByRecurringIdArgs {
  recurringId: Scalars['String'];
}


export interface IQueryGetRecurringWorklogsAndTasksArgs {
  endDate: Scalars['DateTime'];
  squadId: Scalars['String'];
  startDate: Scalars['DateTime'];
  userId: Scalars['String'];
}


export interface IQueryGetRegionForRthArgs {
  selectedLocations?: Maybe<Array<Scalars['String']>>;
  selectedRegions?: Maybe<Array<Scalars['String']>>;
}


export interface IQueryGetRequiredResourceRolesInSquadArgs {
  squadId: Scalars['String'];
}


export interface IQueryGetResumeScoresSummaryArgs {
  input: IGetResumeScoresInput;
}


export interface IQueryGetRoleCandidatesArgs {
  filter: IGetRoleCandidatesFilterDto;
  pageRequest: IPageRequest;
}


export interface IQueryGetRoleDetailsByIdArgs {
  squadRoleId: Scalars['String'];
  userSquadHistoryId: Scalars['String'];
}


export interface IQueryGetRoleDetailsBySquadRoleIdArgs {
  squadId: Scalars['String'];
  squadRoleId: Scalars['String'];
}


export interface IQueryGetRoleInfoByHistoryIdArgs {
  historyId: Scalars['String'];
}


export interface IQueryGetRoleToAssignCandidateArgs {
  squadId: Scalars['String'];
  squadRoleId: Scalars['String'];
}


export interface IQueryGetRolesByClientOrSquadArgs {
  clientId?: Maybe<Scalars['String']>;
  squadId?: Maybe<Scalars['String']>;
}


export interface IQueryGetRolesByTypesArgs {
  types: Scalars['String'];
}


export interface IQueryGetRolesInSquadArgs {
  squadId: Scalars['String'];
}


export interface IQueryGetRolesToAssignCandidatesArgs {
  pageRequest: IPageRequest;
  squadId: Scalars['String'];
}


export interface IQueryGetRthTemplateArgs {
  searchKey: Scalars['String'];
}


export interface IQueryGetRunningSquadsByClientIdArgs {
  clientId: Scalars['String'];
}


export interface IQueryGetSavedQueriesArgs {
  listName: Scalars['String'];
  searchKey?: Maybe<Scalars['String']>;
}


export interface IQueryGetSingleParsedResumeDataArgs {
  parsedResumeId: Scalars['String'];
}


export interface IQueryGetSkillByUserIdArgs {
  userId: Scalars['String'];
}


export interface IQueryGetSkillsByClientOrSquadArgs {
  clientId?: Maybe<Scalars['String']>;
  squadId?: Maybe<Scalars['String']>;
}


export interface IQueryGetSquadAssignedResourcesArgs {
  id: Scalars['String'];
  userSquadHistorySearchDTO: IUserSquadHistorySearchDto;
}


export interface IQueryGetSquadAssignedResourcesBreakdownArgs {
  squadId: Scalars['String'];
}


export interface IQueryGetSquadByIdArgs {
  id: Scalars['String'];
}


export interface IQueryGetSquadEmployeeIdsArgs {
  squadId: Scalars['String'];
  userSquadHistorySearchDTO: IUserSquadHistorySearchDto;
}


export interface IQueryGetSquadInvoicingPeriodListArgs {
  squadId: Scalars['String'];
  userId?: Maybe<Scalars['String']>;
}


export interface IQueryGetSquadListByClientIdArgs {
  clientId: Scalars['String'];
}


export interface IQueryGetSquadNoteBySquadIdArgs {
  squadId: Scalars['String'];
}


export interface IQueryGetSquadOverviewArgs {
  id: Scalars['String'];
}


export interface IQueryGetSquadRequiredResourcesArgs {
  filter: ISquadRequiredRequestDto;
  pageRequest: IPageRequest;
}


export interface IQueryGetSquadResourceAndSquadByIdArgs {
  squadId: Scalars['String'];
  squadResourceId: Scalars['String'];
  squadRoleId: Scalars['String'];
}


export interface IQueryGetSquadResourceDetailsArgs {
  squadId: Scalars['String'];
}


export interface IQueryGetSquadsInfoArgs {
  filter: IWorklogFilter;
}


export interface IQueryGetSquadsWithFilterArgs {
  pageRequest: IPageRequest;
  squadListDto: ISquadListDto;
}


export interface IQueryGetSucceededUsersArgs {
  filterTestUsers: Scalars['Boolean'];
}


export interface IQueryGetTaggableUsersForJobArgs {
  jobId: Scalars['String'];
}


export interface IQueryGetTicketOwnersAndCountriesArgs {
  squadId: Scalars['String'];
}


export interface IQueryGetTrackedIpsArgs {
  filter: ITrackedIpsFilter;
  pageRequest: IPageRequest;
}


export interface IQueryGetUnassignedClientListByUserIdArgs {
  userId: Scalars['String'];
}


export interface IQueryGetUserAssignedSquadsByUserIdArgs {
  options?: Maybe<IUserAssignedSquadsOptions>;
  userId: Scalars['String'];
}


export interface IQueryGetUserDataArgs {
  squadId?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
}


export interface IQueryGetUserListArgs {
  pageRequest?: Maybe<IPageRequest>;
  userListFilter: IUserListFilter;
}


export interface IQueryGetUserListDropDownArgs {
  pageRequest?: Maybe<IPageRequest>;
  userListFilter: IUserListFilter;
}


export interface IQueryGetUserPreferenceArgs {
  requiredMetadata?: Maybe<IOrderableListEnum>;
}


export interface IQueryGetWorklogCloseDocumentArgs {
  worklogCloseFilter: IWorklogCloseStatusFilterDto;
}


export interface IQueryGetWorklogOverviewArgs {
  worklogFilter: IWorklogFilter;
  worklogLeaveFilter?: Maybe<IWorklogLeaveFilter>;
}


export interface IQueryGetWorklogRequestsArgs {
  pageRequest: IPageRequest;
  worklogFilter: IWorklogFilter;
  worklogLeaveFilter?: Maybe<IWorklogLeaveFilter>;
}


export interface IQueryJobByIdArgs {
  id: Scalars['String'];
}


export interface IQueryJobPaginatedArgs {
  filter: IJobPaginationDto;
  pageRequest: IPageRequest;
}


export interface IQueryJobStatusBasedArgs {
  statusParam?: Maybe<Scalars['String']>;
}


export interface IQueryListAllPermissionGroupsArgs {
  searchInput?: Maybe<ISearchPersonaPermissionGroupInputDto>;
}


export interface IQueryListAllPersonaArgs {
  searchInput?: Maybe<ISearchPersonaPermissionGroupInputDto>;
}


export interface IQueryListApproversArgs {
  listApproversFilter?: Maybe<IListApproversFilterDto>;
}


export interface IQueryListNotesArgs {
  userId: Scalars['String'];
}


export interface IQueryListResourcesArgs {
  filter: IEligibleCandidatesFilterDto;
  pageRequest: IPageRequest;
}


export interface IQueryListResourcesToAssignApproversArgs {
  listApproversFilter?: Maybe<IListApproversFilterDto>;
}


export interface IQueryListSupervisorsArgs {
  listSupervisorsFilter?: Maybe<IListSupervisorsFilterDto>;
}


export interface IQueryOffboardingAndReplaceResourcesArgs {
  squadRoleId: Scalars['String'];
}


export interface IQueryRemoveJobByIdArgs {
  jobId: Scalars['String'];
}


export interface IQueryResumeImportLogByJobIdArgs {
  jobId: Scalars['String'];
}


export interface IQueryResyncImportForSpecificJobArgs {
  id: Scalars['String'];
}


export interface IQueryResyncResumeParsingArgs {
  parsedResumeReq: IParsedResumeReq;
}


export interface IQueryRevalidateEmployeeDataArgs {
  userList: Scalars['String'];
}


export interface IQuerySetJobNewResumesToZeroArgs {
  id: Scalars['String'];
}


export interface IQueryShowCandidateProfileArgs {
  parsedResumeId: Scalars['String'];
}


export interface IQueryStartResumeParsingArgs {
  jobId: Scalars['String'];
}


export interface IQueryUniqueAddedByArgs {
  jobId: Scalars['String'];
}


export interface IQueryUniqueLocationsAndRegionsByJobIdArgs {
  jobId: Scalars['String'];
  selectedLocations?: Maybe<Array<Scalars['String']>>;
  selectedRegions?: Maybe<Array<Scalars['String']>>;
}


export interface IQueryUserSquadHistoriesAdvancedSearchArgs {
  pageRequest: IPageRequest;
  searchDto: IUserSquadHistoryAdvancedSearchDto;
}


export interface IQueryViewSquadDetailsBySquadIdArgs {
  pageRequest: IPageRequest;
  squadId: Scalars['String'];
  userSquadHistorySearchDTO: IUserSquadHistorySearchDto;
}

export enum IRecipientGroupEnum {
  SDO_GROUP = 'SDO_GROUP',
  TEST_GROUP = 'TEST_GROUP'
}

export interface IRecipientGroupResponseObjectType {
  groupName: IRecipientGroupEnum;
  id: Scalars['ID'];
  members: Array<Maybe<IRecipientResponseObjectType>>;
}

export interface IRecipientInputType {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
}

export interface IRecipientResponseObjectType {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
}

export enum IRecurringOptions {
  CUSTOM = 'CUSTOM',
  DAILY = 'DAILY',
  SPECIFIC_DATES = 'SPECIFIC_DATES',
  WEEKDAYS = 'WEEKDAYS'
}

export interface IRecurringTasksDto {
  category: Scalars['String'];
  description: Scalars['String'];
  endTime?: Maybe<Scalars['String']>;
  isRecurring?: Maybe<Scalars['Boolean']>;
  minutes: Scalars['Int'];
  recurringDates?: Maybe<Array<Scalars['String']>>;
  recurringId?: Maybe<Scalars['String']>;
  recurringOptions?: Maybe<IRecurringOptions>;
  squadId?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['String']>;
  worklogId?: Maybe<Scalars['String']>;
}

export interface IRecurringWorklogDto {
  recurringDates?: Maybe<Array<Scalars['String']>>;
  squadId: Scalars['String'];
  tasks: Array<IRecurringTasksDto>;
  userId: Scalars['String'];
}

export interface IRegionResponseDto {
  regions?: Maybe<Array<Maybe<Scalars['String']>>>;
}

export interface IRemovePermissionFromGroupDto {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  permissions: Array<Scalars['String']>;
}

export interface IReplacingEmployeeDto {
  involvementStatus?: Maybe<Scalars['String']>;
  profileImage?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  squadId?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
  userName?: Maybe<Scalars['String']>;
  userSquadHistoryId?: Maybe<Scalars['String']>;
}

export interface IRequestToHire {
  billingCycle?: Maybe<IJobBillingCycle>;
  billingRate?: Maybe<Scalars['Float']>;
  contributingMembers?: Maybe<Array<IContributingMember>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  department?: Maybe<Scalars['String']>;
  descriptionTemplateId?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['DateTime']>;
  enterprisePeopleId?: Maybe<Scalars['String']>;
  experienceLevel?: Maybe<IExperienceLevel>;
  goodToHaveSkills?: Maybe<Array<Scalars['String']>>;
  horizontal?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  industry?: Maybe<Scalars['String']>;
  industryBackground?: Maybe<Scalars['String']>;
  jobCode?: Maybe<Scalars['String']>;
  jobDescription?: Maybe<Scalars['String']>;
  jobId?: Maybe<Scalars['String']>;
  jobPriority?: Maybe<IJobPriority>;
  jobStatus: IJobStatus;
  jobType?: Maybe<IEmploymentType>;
  location?: Maybe<Array<Scalars['String']>>;
  locationToBeHiredFrom?: Maybe<Array<Scalars['String']>>;
  maximumBudget?: Maybe<Scalars['Float']>;
  minimumBudget?: Maybe<Scalars['Float']>;
  mustHaveSkills?: Maybe<Array<Scalars['String']>>;
  noOfVacancies?: Maybe<Scalars['Float']>;
  numberOfResources?: Maybe<Scalars['Float']>;
  projectDescription?: Maybe<Scalars['String']>;
  squadEndDate?: Maybe<Scalars['DateTime']>;
  squadId?: Maybe<Scalars['String']>;
  squadRoleId?: Maybe<Scalars['String']>;
  squadStartDate?: Maybe<Scalars['DateTime']>;
  startDate?: Maybe<Scalars['DateTime']>;
  ticketId?: Maybe<Scalars['String']>;
  timeZone?: Maybe<Array<Scalars['String']>>;
  title?: Maybe<Scalars['String']>;
  travelRequirements?: Maybe<Scalars['String']>;
  typeOfWork?: Maybe<IType_Of_Work>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vertical?: Maybe<Scalars['String']>;
  yearsOfExperience?: Maybe<Scalars['Float']>;
}

export interface IRequestToHireInput {
  billingCycle?: Maybe<IJobBillingCycle>;
  billingRate?: Maybe<Scalars['Float']>;
  contributingMembers?: Maybe<Array<IContributingHiringMembers>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  department?: Maybe<Scalars['String']>;
  descriptionTemplateId?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['DateTime']>;
  enterprisePeopleId?: Maybe<Scalars['String']>;
  experienceLevel?: Maybe<IExperienceLevel>;
  goodToHaveSkills?: Maybe<Array<Scalars['String']>>;
  horizontal?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  industry?: Maybe<Scalars['String']>;
  industryBackground?: Maybe<Scalars['String']>;
  jobCode?: Maybe<Scalars['String']>;
  jobDescription?: Maybe<Scalars['String']>;
  jobId?: Maybe<Scalars['String']>;
  jobPriority?: Maybe<IJobPriority>;
  jobStatus: IJobStatus;
  jobType?: Maybe<IEmploymentType>;
  location?: Maybe<Array<Scalars['String']>>;
  locationToBeHiredFrom?: Maybe<Array<Scalars['String']>>;
  maximumBudget?: Maybe<Scalars['Float']>;
  minimumBudget?: Maybe<Scalars['Float']>;
  mustHaveSkills?: Maybe<Array<Scalars['String']>>;
  noOfVacancies?: Maybe<Scalars['Float']>;
  numberOfResources?: Maybe<Scalars['Float']>;
  projectDescription?: Maybe<Scalars['String']>;
  squadEndDate?: Maybe<Scalars['DateTime']>;
  squadId?: Maybe<Scalars['String']>;
  squadRoleId?: Maybe<Scalars['String']>;
  squadStartDate?: Maybe<Scalars['DateTime']>;
  startDate?: Maybe<Scalars['DateTime']>;
  ticketId?: Maybe<Scalars['String']>;
  timeZone?: Maybe<Array<Scalars['String']>>;
  title?: Maybe<Scalars['String']>;
  travelRequirements?: Maybe<Scalars['String']>;
  typeOfWork?: Maybe<IType_Of_Work>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vertical?: Maybe<Scalars['String']>;
  yearsOfExperience?: Maybe<Scalars['Float']>;
}

export interface IRequestedJobViewsType {
  jobId: Scalars['String'];
  viewedBy: Array<Scalars['String']>;
}

export enum IRequiredForKickOffEnum {
  ALL = 'ALL',
  MANDATORY = 'MANDATORY',
  NON_MANDATORY = 'NON_MANDATORY'
}

export interface IRequiredResourcesDto {
  country?: Maybe<Array<Scalars['String']>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  estimatedEndDate?: Maybe<Scalars['DateTime']>;
  estimatedStartDate?: Maybe<Scalars['DateTime']>;
  experienceLevel?: Maybe<Scalars['String']>;
  isRequestedForHire?: Maybe<Scalars['Boolean']>;
  jobCreatedAt?: Maybe<Scalars['DateTime']>;
  jobType?: Maybe<Scalars['String']>;
  offboardingCandidate?: Maybe<Array<IReplacingEmployeeDto>>;
  offboardingCount?: Maybe<Scalars['Float']>;
  phasesAssigned?: Maybe<Array<Scalars['String']>>;
  priority?: Maybe<Scalars['String']>;
  probableCandidates?: Maybe<Array<IProbableCandidateDto>>;
  probableCandidatesCount?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
  requiredCount?: Maybe<Scalars['Float']>;
  requiredForKickOff?: Maybe<Scalars['Boolean']>;
  role?: Maybe<Scalars['String']>;
  squadId?: Maybe<Scalars['String']>;
  squadResourceId: Scalars['String'];
  squadRoleId: Scalars['String'];
  startDate?: Maybe<Scalars['DateTime']>;
  ticketId?: Maybe<Scalars['String']>;
  ticketLink?: Maybe<Scalars['String']>;
  ticketOwner?: Maybe<Scalars['String']>;
}

export interface IRequiredResourcesPaged {
  /** List of fetched data */
  content: Array<IRequiredResourcesDto>;
  /** Information about pagination */
  pageable: IPageable;
}

export interface IResourceEngagementDto {
  consultants?: Maybe<Scalars['Float']>;
  count?: Maybe<Scalars['Float']>;
  fusemachines?: Maybe<Scalars['Float']>;
  role?: Maybe<Scalars['String']>;
}

export interface IResourceLevelBreakdown {
  LEVEL: Array<Scalars['String']>;
  barChartData: Array<IChartData>;
}

export interface IResponseCsvParser {
  csvLink?: Maybe<Scalars['String']>;
  message: Scalars['String'];
  successful: Scalars['Boolean'];
}

export interface IResubmitWorklogDto {
  isSaveAsDraft?: Maybe<Scalars['Boolean']>;
  squadId?: Maybe<Scalars['String']>;
  tasks?: Maybe<Array<ITasksDto>>;
  worklogId: Scalars['String'];
}

export interface IResume {
  id: Scalars['ID'];
  jobId: Scalars['String'];
  keepBoth?: Maybe<Scalars['Boolean']>;
  orgId: Scalars['String'];
  originalFilename: Scalars['String'];
  resumeUrl: Scalars['String'];
}

export interface IResumeImportDto {
  levelAndCount: Array<ILevelAndCount>;
  levels: Array<Scalars['String']>;
  role: Scalars['String'];
}

export interface IResumeImportLogObjectType {
  filterTestUsers: Scalars['Boolean'];
  id: Scalars['String'];
  jobId: Scalars['String'];
  roleAndLevel: Array<IRoleAndLevels>;
  userIds: Array<Scalars['String']>;
}

export interface IResumeScoreSummaryDto {
  consCount: Scalars['Int'];
  customScore?: Maybe<Scalars['Int']>;
  parsedResumeId: Scalars['String'];
  prosCount: Scalars['Int'];
  resumeId: Scalars['String'];
}

export interface IResumeSignedUrlRequest {
  fileMetaData: Array<IFileMetaData>;
  jobId: Scalars['String'];
}

export interface IResumeSignedUrlResponse {
  fileName: Scalars['String'];
  filePath: Scalars['String'];
  isDuplicate: Scalars['Boolean'];
  signedUrl: Scalars['String'];
}

export enum IResumeSource {
  MANUAL = 'MANUAL',
  SOURCE = 'SOURCE'
}

export interface IResumeUpdateDto {
  dto: Array<IResumeImportDto>;
  id: Scalars['ID'];
}

export interface IRoleAndLevels {
  levelAndCount: Array<ILevelAndCountObjType>;
  role: Scalars['String'];
}

export interface IRoleCandidatesPagedResponse {
  /** List of fetched data */
  content: Array<IProbableCandidateInfoDto>;
  /** Information about pagination */
  pageable: IPageable;
}

export interface IRoleDto {
  type: Scalars['String'];
}

export interface IRoleDtoAddCandidate {
  roleTags: Array<Scalars['String']>;
  type: Scalars['String'];
}

export interface IRoleDtoAddCandidateInput {
  roleTags: Array<Scalars['String']>;
  type: Scalars['String'];
}

export interface IRoleResp {
  /** unique id of the squadroles collection */
  id: Scalars['String'];
  /** id of the squad */
  squadId: Scalars['String'];
  /** unique id of the squadresources collection */
  squadResourceId: Scalars['String'];
}

export interface IRolesResponseDto {
  roles?: Maybe<Array<Maybe<Scalars['String']>>>;
}

export interface IRolesWithCandidatesDto {
  numberOfCandidates: Scalars['Float'];
  role: Scalars['String'];
}

export interface IRthTemplateDto {
  billingCycle?: Maybe<IJobBillingCycle>;
  billingRate?: Maybe<Scalars['Float']>;
  clientSelectionProcess?: Maybe<Scalars['String']>;
  contributingMembers?: Maybe<Array<IContributingHiringMembers>>;
  department?: Maybe<Scalars['String']>;
  departmentId?: Maybe<Scalars['String']>;
  descriptionTemplateId?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['DateTime']>;
  enterprisePeopleId?: Maybe<Scalars['String']>;
  evaluationCriteria?: Maybe<Scalars['String']>;
  experienceLevel?: Maybe<IExperienceLevel>;
  goodToHaveSkills?: Maybe<Array<Scalars['String']>>;
  horizontal?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  industry?: Maybe<Scalars['String']>;
  industryBackground?: Maybe<Scalars['String']>;
  jobCode?: Maybe<Scalars['String']>;
  jobDescription?: Maybe<Scalars['String']>;
  jobId?: Maybe<Scalars['String']>;
  jobPriority?: Maybe<IJobPriority>;
  jobStatus?: Maybe<IJobStatus>;
  jobType?: Maybe<IEmploymentType>;
  location?: Maybe<Array<Scalars['String']>>;
  locationToBeHiredFrom?: Maybe<Array<Scalars['String']>>;
  maximumBudget?: Maybe<Scalars['Float']>;
  minimumBudget?: Maybe<Scalars['Float']>;
  mustHaveSkills?: Maybe<Array<Scalars['String']>>;
  noOfVacancies?: Maybe<Scalars['Float']>;
  numberOfResources?: Maybe<Scalars['Float']>;
  previousReasonsForCandidateDisqualification?: Maybe<Scalars['String']>;
  projectDescription?: Maybe<Scalars['String']>;
  saveAsDraft?: Maybe<Scalars['Boolean']>;
  softSkills?: Maybe<Array<Scalars['String']>>;
  squadEndDate?: Maybe<Scalars['DateTime']>;
  squadId?: Maybe<Scalars['String']>;
  squadRoleId?: Maybe<Scalars['String']>;
  squadStartDate?: Maybe<Scalars['DateTime']>;
  startDate?: Maybe<Scalars['DateTime']>;
  technicalInterviewPanel?: Maybe<Scalars['String']>;
  templateTitle?: Maybe<Scalars['String']>;
  ticketId?: Maybe<Scalars['String']>;
  timeZone?: Maybe<Array<Scalars['String']>>;
  title?: Maybe<Scalars['String']>;
  travelRequirements?: Maybe<Scalars['String']>;
  typeOfWork?: Maybe<IType_Of_Work>;
  vertical?: Maybe<Scalars['String']>;
  yearsOfExperience?: Maybe<Scalars['Float']>;
}

export interface IRthTemplateResp {
  billingCycle?: Maybe<IJobBillingCycle>;
  billingRate?: Maybe<Scalars['Float']>;
  clientSelectionProcess?: Maybe<Scalars['String']>;
  contributingMembers?: Maybe<Array<IContributingMember>>;
  department?: Maybe<Scalars['String']>;
  departmentId?: Maybe<Scalars['String']>;
  descriptionTemplateId?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['DateTime']>;
  enterprisePeopleId?: Maybe<Scalars['String']>;
  evaluationCriteria?: Maybe<Scalars['String']>;
  experienceLevel?: Maybe<IExperienceLevel>;
  goodToHaveSkills?: Maybe<Array<Scalars['String']>>;
  horizontal?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  industry?: Maybe<Scalars['String']>;
  industryBackground?: Maybe<Scalars['String']>;
  jobCode?: Maybe<Scalars['String']>;
  jobDescription?: Maybe<Scalars['String']>;
  jobId?: Maybe<Scalars['String']>;
  jobPriority?: Maybe<IJobPriority>;
  jobStatus?: Maybe<IJobStatus>;
  jobType?: Maybe<IEmploymentType>;
  location?: Maybe<Array<Scalars['String']>>;
  locationToBeHiredFrom?: Maybe<Array<Scalars['String']>>;
  maximumBudget?: Maybe<Scalars['Float']>;
  minimumBudget?: Maybe<Scalars['Float']>;
  mustHaveSkills?: Maybe<Array<Scalars['String']>>;
  noOfVacancies?: Maybe<Scalars['Float']>;
  numberOfResources?: Maybe<Scalars['Float']>;
  previousReasonsForCandidateDisqualification?: Maybe<Scalars['String']>;
  projectDescription?: Maybe<Scalars['String']>;
  saveAsDraft?: Maybe<Scalars['Boolean']>;
  softSkills?: Maybe<Array<Scalars['String']>>;
  squadEndDate?: Maybe<Scalars['DateTime']>;
  squadId?: Maybe<Scalars['String']>;
  squadRoleId?: Maybe<Scalars['String']>;
  squadStartDate?: Maybe<Scalars['DateTime']>;
  startDate?: Maybe<Scalars['DateTime']>;
  technicalInterviewPanel?: Maybe<Scalars['String']>;
  templateTitle?: Maybe<Scalars['String']>;
  ticketId?: Maybe<Scalars['String']>;
  timeZone?: Maybe<Array<Scalars['String']>>;
  title?: Maybe<Scalars['String']>;
  travelRequirements?: Maybe<Scalars['String']>;
  typeOfWork?: Maybe<IType_Of_Work>;
  vertical?: Maybe<Scalars['String']>;
  yearsOfExperience?: Maybe<Scalars['Float']>;
}

export interface ISavedQueryReq {
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  listName: Scalars['String'];
  query: Scalars['String'];
  queryDescription: Scalars['String'];
  queryName: Scalars['String'];
}

export interface ISavedQueryResp {
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  listName: Scalars['String'];
  query: Scalars['String'];
  queryDescription: Scalars['String'];
  queryName: Scalars['String'];
}

export interface IScoreDetail {
  category?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['JSON']>;
  evidence?: Maybe<Array<IEvidenceDetail>>;
  score?: Maybe<Scalars['Float']>;
  scoreRange?: Maybe<Scalars['String']>;
  summary?: Maybe<Scalars['String']>;
}

export interface IScoringResultsDto {
  domainRoleMatchScore: IScoreDetail;
  experienceScore: IScoreDetail;
  finalScore: Scalars['Float'];
  latestEmployer?: Maybe<Scalars['String']>;
  rating?: Maybe<Scalars['String']>;
  regionMatchScore?: Maybe<IScoreDetail>;
  roleMatchScore: IScoreDetail;
  summary?: Maybe<Scalars['String']>;
  technicalSkillScore: IScoreDetail;
  workExperienceCategory?: Maybe<Scalars['String']>;
  yearsOfExperience?: Maybe<Scalars['Float']>;
}

export interface ISearchPersonaPermissionGroupInputDto {
  exactMatch?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
}

export interface ISkill {
  hardSkills?: Maybe<Array<Maybe<IHardSkill>>>;
  softSkills?: Maybe<Array<Maybe<Scalars['String']>>>;
}

export interface ISkillDetail {
  deleteReason?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isApproved: Scalars['Boolean'];
  isDeleted?: Maybe<Scalars['Boolean']>;
  projectExperiences?: Maybe<Array<IProjectExperiences>>;
  skillTitle: Scalars['String'];
  trainingCertificates?: Maybe<Array<ITrainingCertificates>>;
  updateSkillId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
}

export interface ISkillDetailReq {
  deleteReason?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isApproved: Scalars['Boolean'];
  isDeleted?: Maybe<Scalars['Boolean']>;
  projectExperiences?: Maybe<Array<IProjectExperiencesReq>>;
  skillTitle: Scalars['String'];
  trainingCertificates?: Maybe<Array<ITrainingCertificatesReq>>;
  updateSkillId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
}

export interface ISkillSetUploadResponseDto {
  error?: Maybe<Array<Scalars['String']>>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
}

export interface ISkills {
  competency?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
}

export interface ISkillsDto {
  mostProficientTechnologies: Array<Scalars['String']>;
  roles?: Maybe<Array<Scalars['String']>>;
  selectedTechnologies?: Maybe<Array<Scalars['String']>>;
  softSkills: Array<Scalars['String']>;
  somewhatProficientTechnologies: Array<Scalars['String']>;
  yearsOfExperienceInRole?: Maybe<Array<IYearsOfExperienceInput>>;
}

export interface ISkillsReqDto {
  mostProficientTechnologies?: Maybe<Array<Scalars['String']>>;
  roles?: Maybe<Array<Scalars['String']>>;
  selectedTechnologies?: Maybe<Array<Scalars['String']>>;
  softSkills?: Maybe<Array<Scalars['String']>>;
  somewhatProficientTechnologies?: Maybe<Array<Scalars['String']>>;
  yearsOfExperienceInRole?: Maybe<Array<IYearsOfExperience>>;
}

export interface ISkillsResponse {
  skills?: Maybe<Array<Maybe<Scalars['String']>>>;
}

export interface ISkillsSetCandidateProifleInfo {
  mostProficientTechnologies: Array<Scalars['String']>;
  roles: Array<Scalars['String']>;
  selectedTechnologies: Array<Scalars['String']>;
  softSkills: Array<Scalars['String']>;
  somewhatProficientTechnologies: Array<Scalars['String']>;
  yearsOfExperienceInRole: Array<IYearsOfExperienceInRolesOptions>;
}

export interface ISkippedTaskDto {
  reason: Scalars['String'];
  taskId: Scalars['String'];
}

export enum ISortDirection {
  ASC = 'ASC',
  DESC = 'DESC'
}

export interface ISquadAdditionalApproversAndResources {
  /** unique id of approver in collection */
  additionalApproverId?: Maybe<Scalars['String']>;
  /** resources assigned to an additional approver */
  approverResources?: Maybe<Array<Scalars['String']>>;
}

export interface ISquadAdditionalApproversAndResourcesInput {
  /** unique id of approver in collection */
  additionalApproverId?: Maybe<Scalars['String']>;
  /** resources assigned to an additional approver */
  approverResources?: Maybe<Array<Scalars['String']>>;
}

export interface ISquadAndClientInfo {
  clientId?: Maybe<Scalars['String']>;
  clientName?: Maybe<Scalars['String']>;
  squadId?: Maybe<Scalars['String']>;
  squadName?: Maybe<Scalars['String']>;
}

export interface ISquadApprovers {
  /** additional approver array list of the squad */
  additionalApprovers?: Maybe<Array<IApproverDto>>;
  /** default approver object of the squad */
  defaultApprover?: Maybe<IApproverDto>;
  /** unique id of the squad */
  squadId?: Maybe<Scalars['String']>;
}

export interface ISquadCategoryInput {
  descriptions?: Maybe<Array<Scalars['String']>>;
  name: Scalars['String'];
}

export interface ISquadCategoryResponse {
  descriptions?: Maybe<Array<Scalars['String']>>;
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
}

export interface ISquadIdNameDto {
  /** unique id of the squad */
  id: Scalars['String'];
  /** name of the squad */
  name: Scalars['String'];
}

export interface ISquadInfo {
  defaultAllocationInMinutes: Scalars['Float'];
  endDate?: Maybe<Scalars['DateTime']>;
  involvedAs?: Maybe<Scalars['String']>;
  involvementHistory?: Maybe<Array<IInvolvementHistoryResponseDto>>;
  involvementStatus?: Maybe<Scalars['String']>;
  joinedDate?: Maybe<Scalars['DateTime']>;
  squadHistoryId?: Maybe<Scalars['String']>;
  squadId: Scalars['String'];
  squadName?: Maybe<Scalars['String']>;
  squadType?: Maybe<Scalars['String']>;
}

export interface ISquadInfoDto {
  additionalApprovers?: Maybe<Scalars['String']>;
  additionalNotes?: Maybe<Array<Maybe<IAdditionalNoteResponseDto>>>;
  allocatedHours?: Maybe<Scalars['Float']>;
  allowWorklog?: Maybe<Scalars['Boolean']>;
  clientBillingRate?: Maybe<Scalars['Float']>;
  clientId: Scalars['String'];
  clientName: Scalars['String'];
  clientType?: Maybe<Scalars['String']>;
  createdFromHubspot?: Maybe<Scalars['Boolean']>;
  defaultApprover?: Maybe<Scalars['String']>;
  employeeBillingRate?: Maybe<Scalars['Float']>;
  employeementType?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['DateTime']>;
  involvedAs?: Maybe<Scalars['String']>;
  involvementHistory?: Maybe<Array<IInvolvementHistory>>;
  involvementHistoryId?: Maybe<Scalars['String']>;
  involvementStatus?: Maybe<Scalars['String']>;
  jobType?: Maybe<IJobTypeEnum>;
  joinedDate?: Maybe<Scalars['DateTime']>;
  roleInSquad?: Maybe<Scalars['String']>;
  squadHistoryId?: Maybe<Scalars['String']>;
  squadHistoryIds?: Maybe<Array<Scalars['String']>>;
  squadId: Scalars['String'];
  squadName?: Maybe<Scalars['String']>;
  squadRoleId?: Maybe<Scalars['String']>;
  squadType?: Maybe<Scalars['String']>;
  ticketId?: Maybe<Scalars['String']>;
}

export interface ISquadInfoForCandidateDto {
  squadId?: Maybe<Scalars['String']>;
  squadName?: Maybe<Scalars['String']>;
}

export interface ISquadInvoicePeriodList {
  invoiceNumber: Scalars['Float'];
  label: Scalars['String'];
  periodEndDate: Scalars['DateTime'];
  periodStartDate: Scalars['DateTime'];
}

export interface ISquadListDto {
  activeStatus?: Maybe<Scalars['String']>;
  /** list of additional approvers name */
  additionalApprovers?: Maybe<Array<Scalars['String']>>;
  /** list of additional approvers name */
  additionalApproversResources?: Maybe<Array<ISquadAdditionalApproversAndResourcesInput>>;
  approverFilter?: Maybe<Scalars['Boolean']>;
  /** name of the client */
  clientName?: Maybe<Scalars['String']>;
  contactIds?: Maybe<Array<Scalars['String']>>;
  /** list of countries */
  countries?: Maybe<Array<Scalars['String']>>;
  /** ticket created date */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** created date for from filter */
  createdAtDateFrom?: Maybe<Scalars['DateTime']>;
  /** created date for to filter */
  createdAtDateTo?: Maybe<Scalars['DateTime']>;
  /** link to hubspot deal if available */
  dealLink?: Maybe<Scalars['String']>;
  /** name of deal owner */
  dealOwner?: Maybe<Scalars['String']>;
  /** name of the default approver */
  defaultApprover?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  /** end date of the squad */
  endDate?: Maybe<Scalars['DateTime']>;
  /** estimated end date of squad */
  estimatedEndDate?: Maybe<Scalars['DateTime']>;
  industryId?: Maybe<Scalars['String']>;
  /** will be true if there are no review roles */
  isCompletelyAssigned?: Maybe<Scalars['Boolean']>;
  lineOfBusiness?: Maybe<Scalars['String']>;
  /** name of the squad */
  name?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  /** pin/unpin of a squad will be true if pinned */
  pinned?: Maybe<Scalars['Boolean']>;
  resourceRequiredCount?: Maybe<Scalars['Float']>;
  /** search text for filter */
  searchText?: Maybe<Scalars['String']>;
  squadCategoryId?: Maybe<Scalars['String']>;
  squadId?: Maybe<Scalars['String']>;
  /** status of the squad */
  squadStatus?: Maybe<Array<Scalars['String']>>;
  /** ticket owner, created at and region information */
  squadresource?: Maybe<ISquadResourcesDto>;
  startDate?: Maybe<Scalars['DateTime']>;
  statusChangedDate?: Maybe<Scalars['DateTime']>;
  /** running and not running filter */
  tabFilter?: Maybe<Scalars['String']>;
  /** tech stack used in the squad */
  techStack?: Maybe<Array<Scalars['String']>>;
  /** list of ticket owners */
  ticketOwners?: Maybe<Array<Scalars['String']>>;
  timePeriod?: Maybe<Scalars['String']>;
  /** total number of required resources from all of the squads */
  totalRequiredResources?: Maybe<Scalars['Float']>;
  totalResourceCount?: Maybe<Scalars['Float']>;
  verticalId?: Maybe<Scalars['String']>;
}

export interface ISquadListPaged {
  /** List of fetched data */
  content: Array<ISquadListDto>;
  /** Information about pagination */
  pageable: IPageable;
  /** total number of squads based on filter or without filter */
  totalNoOfSquads?: Maybe<Scalars['Float']>;
  /** total number of unassigned roles based on filter or without filter */
  totalUnassignedRoles?: Maybe<Scalars['Float']>;
}

export interface ISquadNameDto {
  _id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
}

export interface ISquadNoteDto {
  clientId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  note: Scalars['String'];
  squadId: Scalars['String'];
  userId?: Maybe<Scalars['String']>;
}

export interface ISquadRequiredRequestDto {
  availabilityEndDate?: Maybe<Scalars['String']>;
  availabilityStartDate?: Maybe<Scalars['String']>;
  country?: Maybe<Array<Scalars['String']>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAtDateFrom?: Maybe<Scalars['DateTime']>;
  createdAtDateTo?: Maybe<Scalars['DateTime']>;
  dateFrom?: Maybe<Scalars['DateTime']>;
  dateTo?: Maybe<Scalars['DateTime']>;
  experienceLevel?: Maybe<Scalars['String']>;
  isRequestedForHire?: Maybe<Scalars['Boolean']>;
  jobCreatedAt?: Maybe<Scalars['DateTime']>;
  jobType?: Maybe<Array<IJobType>>;
  level?: Maybe<Array<IEmployeeLevel>>;
  phaseAssigned?: Maybe<Array<Scalars['String']>>;
  rateFrom?: Maybe<Scalars['Float']>;
  rateTo?: Maybe<Scalars['Float']>;
  requiredForKickOff?: Maybe<IRequiredForKickOffEnum>;
  roles?: Maybe<Array<Scalars['String']>>;
  searchField?: Maybe<Scalars['String']>;
  sortBy?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['String']>;
  squadId: Scalars['String'];
  ticketId?: Maybe<Scalars['String']>;
  ticketOwners?: Maybe<Array<Scalars['String']>>;
}

export interface ISquadResourceDetailDto {
  clientName?: Maybe<Scalars['String']>;
  countSquads?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['String']>;
  overallBudget?: Maybe<Scalars['Float']>;
  squadEndDate?: Maybe<Scalars['DateTime']>;
  squadName?: Maybe<Scalars['String']>;
  squadStartDate?: Maybe<Scalars['DateTime']>;
  usedBudget?: Maybe<Scalars['Float']>;
}

export interface ISquadResourceInputDto {
  /** list of countries */
  country?: Maybe<Array<Scalars['String']>>;
  department?: Maybe<Scalars['String']>;
  departmentId?: Maybe<Scalars['String']>;
  /** end date for the role */
  endDate?: Maybe<Scalars['DateTime']>;
  /** end date for the role */
  estimatedEndDate?: Maybe<Scalars['DateTime']>;
  /** start date for the role */
  estimatedStartDate?: Maybe<Scalars['DateTime']>;
  /** level of experience */
  experienceLevel?: Maybe<Scalars['String']>;
  /** list of skills good to have for the role */
  goodToHaveSkills?: Maybe<Array<Scalars['String']>>;
  /** unique id of the squadresources collection */
  id: Scalars['String'];
  isEdited?: Maybe<Scalars['Boolean']>;
  /** type of job like full time or part time */
  jobType?: Maybe<Scalars['String']>;
  locationToBeHiredFrom?: Maybe<Array<Scalars['String']>>;
  /** previous employee start date for the same role */
  prevEmpStartDate?: Maybe<Scalars['DateTime']>;
  priority?: Maybe<IPriorityEnum>;
  /** list of skills required to have for the role */
  requiredSkills?: Maybe<Array<Scalars['String']>>;
  /** role name for the job */
  role: Scalars['String'];
  /** job description */
  roleDescription?: Maybe<Scalars['String']>;
  /** list of skills required to have for the role */
  softSkills?: Maybe<Array<Scalars['String']>>;
  /** id of the squad */
  squadId: Scalars['String'];
  /** id of the squad roles */
  squadRoleId: Scalars['String'];
  /** start date for the role */
  startDate?: Maybe<Scalars['DateTime']>;
  /** unique id of the ticket in hubspot */
  ticketId?: Maybe<Scalars['String']>;
  /** time zone in which a resource is required to work */
  timeZone?: Maybe<Array<Scalars['String']>>;
  /** hours per week */
  workingHour?: Maybe<Scalars['Float']>;
  /** years of experience */
  yearsOfExperience?: Maybe<Scalars['Float']>;
}

export interface ISquadResourceRoleOutputDto {
  /** unique id of the squadresources collection */
  id: Scalars['String'];
  /** id of the squad */
  squadId: Scalars['String'];
  /** id of the squad role */
  squadRoleId: Scalars['String'];
  /** unique id of ticket in hubspot */
  ticketId?: Maybe<Scalars['String']>;
}

export interface ISquadResourcesDto {
  /** list of countries */
  country?: Maybe<Array<Scalars['String']>>;
  /** ticket created date */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** list of ticket owners */
  ticketOwner?: Maybe<Array<Scalars['String']>>;
}

export enum ISquadType {
  EXTERNAL = 'EXTERNAL',
  INTERNAL = 'INTERNAL',
  OTHERS = 'OTHERS',
  PRESALES_SUPPORT = 'PRESALES_SUPPORT',
  PRODUCT_ENGINEERING = 'PRODUCT_ENGINEERING'
}

export interface ISquaderyConstantsDto {
  constantType: ISquaderyConstantsEnum;
  keyObjects?: Maybe<Array<IKeyObjects>>;
  keyValues?: Maybe<Array<Array<Scalars['String']>>>;
  values?: Maybe<Array<Scalars['String']>>;
}

export enum ISquaderyConstantsEnum {
  CLIENT_OTP_LOGIN_CONFIGS = 'CLIENT_OTP_LOGIN_CONFIGS',
  HANDLE_FUTURE_WORKLOG = 'HANDLE_FUTURE_WORKLOG',
  HORIZONTAL_HEAD_DEPARTMENT_MAP = 'HORIZONTAL_HEAD_DEPARTMENT_MAP',
  HR_EMAIL = 'HR_EMAIL',
  HUBSPOT_APP_ID = 'HUBSPOT_APP_ID',
  HUBSPOT_DEPARTMENT_FIELD = 'HUBSPOT_DEPARTMENT_FIELD',
  HUBSPOT_PRIVATE_APP_KEY = 'HUBSPOT_PRIVATE_APP_KEY',
  HUBSPOT_STAGES = 'HUBSPOT_STAGES',
  INTERNAL_CLIENT = 'INTERNAL_CLIENT',
  JAZZHR_CONSTANTS = 'JAZZHR_CONSTANTS',
  JAZZHR_COUNTRIES = 'JAZZHR_COUNTRIES',
  JAZZHR_EMPLOYMENT_TYPE = 'JAZZHR_EMPLOYMENT_TYPE',
  JAZZHR_EXPERIENCE = 'JAZZHR_EXPERIENCE',
  JAZZHR_LATAM_COUNTRIES = 'JAZZHR_LATAM_COUNTRIES',
  JAZZHR_NA_COUNTRIES = 'JAZZHR_NA_COUNTRIES',
  JAZZHR_PRIMARY_EMAIL = 'JAZZHR_PRIMARY_EMAIL',
  JAZZHR_REGION_COUNTRIES_MAP = 'JAZZHR_REGION_COUNTRIES_MAP',
  RECEIVER_EMAIL = 'RECEIVER_EMAIL',
  RECRUITER_EMAIL = 'RECRUITER_EMAIL',
  RTH_RECEIVERS_INTERNAL = 'RTH_RECEIVERS_INTERNAL',
  SQUAD_ROLES = 'SQUAD_ROLES',
  WORKING_TIMEZONE = 'WORKING_TIMEZONE',
  WORKLOG_EMAIL_APPROVE_NOTIFICATION_SEND_TIME = 'WORKLOG_EMAIL_APPROVE_NOTIFICATION_SEND_TIME',
  WORKLOG_EMAIL_CONFIGS = 'WORKLOG_EMAIL_CONFIGS'
}

export interface ISquadsDto {
  squadId: Scalars['String'];
  squadName?: Maybe<Scalars['String']>;
}

export interface ISupervisorInfo {
  /** Supervisor's designation */
  designation?: Maybe<Scalars['String']>;
  /** Supervisor's user email */
  email?: Maybe<Scalars['String']>;
  /** Supervisor's fullname */
  fullname?: Maybe<Scalars['String']>;
  /** Supervisor's user ID */
  id?: Maybe<Scalars['String']>;
}

export interface ISupportEmailReq {
  emailContent?: Maybe<Scalars['String']>;
  emailSubject?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
}

export interface ITableMetadata {
  addResourceListOrder?: Maybe<Array<IColumnMetadata>>;
  assignedResourcesOrder?: Maybe<Array<IColumnMetadata>>;
  clientListOrder?: Maybe<Array<IColumnMetadata>>;
  clientRolesList?: Maybe<Array<IColumnMetadata>>;
  cmSquadListOrder?: Maybe<Array<IColumnMetadata>>;
  completedSquadListOrder?: Maybe<Array<IColumnMetadata>>;
  employeeListOrder?: Maybe<Array<IColumnMetadata>>;
  jobCandidateList?: Maybe<Array<IColumnMetadata>>;
  jobListOrder?: Maybe<Array<IColumnMetadata>>;
  notRunningSquadListOrder?: Maybe<Array<IColumnMetadata>>;
  requiredResourcesOrder?: Maybe<Array<IColumnMetadata>>;
  roleCandidatesList?: Maybe<Array<IColumnMetadata>>;
  squadListOrder?: Maybe<Array<IColumnMetadata>>;
  worklogDataListOrder?: Maybe<Array<IColumnMetadata>>;
}

export interface ITaggableUser {
  fullname: Scalars['String'];
  id: Scalars['String'];
}

export interface ITasksDto {
  category: Scalars['String'];
  description: Scalars['String'];
  endTime?: Maybe<Scalars['String']>;
  minutes: Scalars['Int'];
  startTime?: Maybe<Scalars['String']>;
  worklogTaskId?: Maybe<Scalars['String']>;
}

export interface IThrottleLogResponseDto {
  handler?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Float']>;
  requestedAt?: Maybe<Scalars['DateTime']>;
  totalHits?: Maybe<Scalars['Float']>;
  userAgent?: Maybe<Scalars['String']>;
}

export interface ITrackedIpResponseDto {
  accessChangeLog?: Maybe<Array<IAccessChangeLogResponseDto>>;
  allowAccess?: Maybe<Scalars['Boolean']>;
  ipAddress?: Maybe<Scalars['String']>;
  throttleLog?: Maybe<Array<IThrottleLogResponseDto>>;
  userId?: Maybe<Scalars['String']>;
}

export interface ITrackedIpsFilter {
  allowAccess?: Maybe<Scalars['Boolean']>;
  ipAddress?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
}

export interface ITrackedIpsPaged {
  /** List of fetched data */
  content: Array<ITrackedIpResponseDto>;
  /** Information about pagination */
  pageable: IPageable;
}

export interface ITrainingCertificateResponseDto {
  certificateId?: Maybe<Scalars['String']>;
  certificateTitle?: Maybe<Scalars['String']>;
  currentlyStudying?: Maybe<Scalars['Boolean']>;
  endDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  instructor?: Maybe<Scalars['String']>;
  issuingInstituionOrOrganization?: Maybe<Scalars['String']>;
  profileId: Scalars['String'];
  startDate: Scalars['DateTime'];
  uploads: Array<IUploadResponse>;
}

export interface ITrainingCertificates {
  certificateName?: Maybe<Scalars['String']>;
  certificateUrl?: Maybe<Scalars['String']>;
  issuedDate: Scalars['String'];
  issuingOrganization: Scalars['String'];
  title: Scalars['String'];
}

export interface ITrainingCertificatesReq {
  certificateName?: Maybe<Scalars['String']>;
  certificateUrl?: Maybe<Scalars['String']>;
  issuedDate: Scalars['String'];
  issuingOrganization: Scalars['String'];
  title: Scalars['String'];
}

export enum IType_Of_Work {
  HYBRID = 'HYBRID',
  ONSITE = 'ONSITE',
  REMOTE = 'REMOTE'
}

export interface IUpdateAdditionalNoteDto {
  /** User Squad History ID.This field is required. */
  involvementHistoryId?: Maybe<Scalars['String']>;
  /** History of changes made */
  modifications?: Maybe<Array<IModificationsInput>>;
  /** Note/comments. This field is required */
  note?: Maybe<Scalars['String']>;
  /** Type of Note. Available Type can be viewed in AdditionalNoteTypeEnum.This field is required. */
  noteType?: Maybe<IAdditionalNoteTypeEnum>;
  /** Changed Involvement status of the employee.Available InvolvementStatus can be viewed in InvolvementStatus enum.This field is required */
  status?: Maybe<Scalars['String']>;
  /** User Squad History ID.This field is required. */
  userSquadHistoryId?: Maybe<Scalars['String']>;
}

export interface IUpdateAllocatedTimePayload {
  allocatedMinutes: Scalars['Float'];
  allocatedTimeId: Scalars['String'];
  fromDate?: Maybe<Scalars['DateTime']>;
  note: Scalars['String'];
  toDate?: Maybe<Scalars['DateTime']>;
}

export interface IUpdateAllocatedTimeResponse {
  allocatedMinutes: Scalars['Float'];
  hourOverview: IHourOverviewResponseDto;
  newAllocatedTimeId: Scalars['String'];
  note?: Maybe<Scalars['String']>;
}

export interface IUpdateBasicInfoDto {
  githubUrl?: Maybe<Scalars['String']>;
  linkedinUrl?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
}

export interface IUpdateCandidateStatusDto {
  candidateStage: IJobCandidateStages;
  candidateStageStatus: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
}

export interface IUpdateNoteDto {
  note: Scalars['String'];
  noteContext?: Maybe<Scalars['String']>;
  noteId: Scalars['String'];
  visibility?: Maybe<INoteVisibility>;
}

export interface IUpdatePersonalInfoDto {
  countryOfResidence?: Maybe<Scalars['String']>;
  gender?: Maybe<IGender>;
  resignDate?: Maybe<Scalars['DateTime']>;
  timezone?: Maybe<Scalars['String']>;
}

export interface IUpdateRecipientGroupInput {
  groupName: IRecipientGroupEnum;
  members: Array<Maybe<IRecipientInputType>>;
}

export interface IUpdateTrainingCertificateDto {
  certificateId?: Maybe<Scalars['String']>;
  certificateTitle?: Maybe<Scalars['String']>;
  currentlyStudying?: Maybe<Scalars['Boolean']>;
  endDate?: Maybe<Scalars['DateTime']>;
  instructor?: Maybe<Scalars['String']>;
  issuingInstituionOrOrganization?: Maybe<Scalars['String']>;
  profileId?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  uploads?: Maybe<Array<Maybe<IUploadInputType>>>;
}

export interface IUpdateWorkInfoDto {
  department?: Maybe<IDepartmentInput>;
  designation?: Maybe<IDesignationInputDto>;
  employeeId?: Maybe<Scalars['String']>;
  employeeLevel?: Maybe<IEmployeeLevel>;
  employeementType?: Maybe<IFuseEmployeementType>;
  jobType?: Maybe<IJobType>;
  paymentOption?: Maybe<Array<IBillingCycle>>;
  roles?: Maybe<Array<Scalars['String']>>;
  shift?: Maybe<IWorkShift>;
}

export interface IUpdateWorklogTaskDto {
  category?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  endTime?: Maybe<Scalars['String']>;
  isRecurring?: Maybe<Scalars['Boolean']>;
  isfromHarvestCSV?: Maybe<Scalars['Boolean']>;
  minutes?: Maybe<Scalars['Int']>;
  recurringDates?: Maybe<Array<Scalars['String']>>;
  recurringId?: Maybe<Scalars['String']>;
  recurringOptions?: Maybe<IRecurringOptions>;
  startTime?: Maybe<Scalars['String']>;
  startTimeTemp?: Maybe<Scalars['String']>;
}

export interface IUploadInputType {
  filename?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
}

export interface IUploadResponse {
  filename?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
}

export interface IUserAssignedSquads {
  /** total allocated hours for the user in the assigned squad */
  allocatedHours?: Maybe<Scalars['Float']>;
  /** End Date of user on squad */
  endDate?: Maybe<Scalars['DateTime']>;
  /** Involvment Status on squad */
  involvementStatus?: Maybe<IInvolvementStatus>;
  /** User involvement type in the squad like core, support or shadow. */
  involvementType?: Maybe<Scalars['String']>;
  /** User job type in the squad like part-time or full-time */
  jobType?: Maybe<Scalars['String']>;
  /** Joined Date of user on squad */
  joinedDate?: Maybe<Scalars['DateTime']>;
  /** Unique ID of the squads collection */
  squadId: Scalars['String'];
  /** Name of the squad */
  squadName: Scalars['String'];
  /** User Squad History id */
  ushId: Scalars['String'];
}

export interface IUserAssignedSquadsOptions {
  /** Name of the squad */
  includeOnHoldSquads?: Maybe<Scalars['Boolean']>;
}

export interface IUserInfoClientDto {
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
}

export interface IUserInfoResponseDtoType {
  email?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  profileId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
}

export interface IUserInformationResponseDto {
  availability?: Maybe<Scalars['String']>;
  canLoggedInUserApproveWorklog?: Maybe<Scalars['Boolean']>;
  department?: Maybe<Scalars['String']>;
  designation?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isAnApprover?: Maybe<Scalars['Boolean']>;
  level?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  profileImage?: Maybe<Scalars['String']>;
  roles?: Maybe<Scalars['String']>;
  squads?: Maybe<Array<ISquadsDto>>;
}

export interface IUserListDto {
  department?: Maybe<Scalars['String']>;
  designation?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  mainDepartment?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  permissionGroup?: Maybe<Array<Maybe<IIdNamePlaceholder>>>;
  personas?: Maybe<Array<Maybe<IIdNamePlaceholder>>>;
  profileImage?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
}

export interface IUserListFilter {
  allUser?: Maybe<Scalars['Boolean']>;
  personaId?: Maybe<Scalars['String']>;
  searchKey?: Maybe<Scalars['String']>;
  subDepartment?: Maybe<Array<Maybe<IDepartmentAndSubDepartment>>>;
}

export interface IUserListPageable {
  /** List of fetched data */
  content: Array<IUserListDto>;
  /** Information about pagination */
  pageable: IPageable;
}

export interface IUserPreferenceType {
  tableMetadata?: Maybe<ITableMetadata>;
  userId: Scalars['String'];
}

export interface IUserProfileDto {
  /** Profile ID */
  profileId?: Maybe<Scalars['String']>;
  /** Supervisor profile ID */
  supervisorProfileId?: Maybe<Scalars['String']>;
  /** User ID */
  userId?: Maybe<Scalars['String']>;
}

export interface IUserSquadHistory {
  /** object id of usersquadhistories collection */
  _id?: Maybe<Scalars['String']>;
  /** total allocated hours a user is assigned in squad */
  allocatedHours?: Maybe<Scalars['Float']>;
  /** end date of user in the squad */
  endDate?: Maybe<Scalars['DateTime']>;
  /** involvement type of user in the squad like core, support or shadow */
  involvedAs?: Maybe<IInvolvedAs>;
  /** involvement history array */
  involvementHistory?: Maybe<Array<IInvolvementHistory>>;
  /** involvement status of user like assigned , onhold, offboarded */
  involvementStatus?: Maybe<IInvolvementStatus>;
  /** type of job like part time or full time */
  jobType?: Maybe<Scalars['String']>;
  /** joined date of user in the squad */
  joinedDate?: Maybe<Scalars['DateTime']>;
  /** id of the squad user is involved */
  squadId?: Maybe<Scalars['String']>;
  /** name of the squad */
  squadName?: Maybe<Scalars['String']>;
  /** unique id of squadroles collection to which a user is assigned */
  squadRoleId?: Maybe<Scalars['String']>;
  /** unique id of user */
  userId?: Maybe<Scalars['String']>;
  /** id of the usersquadhistories collection */
  userSquadHistoryId?: Maybe<Scalars['String']>;
}

export interface IUserSquadHistoryAdvancedSearchDto {
  assignedDevices?: Maybe<Array<Scalars['String']>>;
  assignedStatus?: Maybe<IAssignedStatus>;
  availability?: Maybe<Array<Maybe<Scalars['String']>>>;
  benchStatus?: Maybe<Array<Maybe<Scalars['String']>>>;
  billable?: Maybe<Scalars['String']>;
  client?: Maybe<Array<Maybe<Scalars['String']>>>;
  dashboardAnalyticsEmployeeListDataType?: Maybe<IDashboardAnalyticsEmployeeListDataType>;
  dashboardFlag?: Maybe<Scalars['Boolean']>;
  departmentName?: Maybe<Array<Maybe<Scalars['String']>>>;
  deploymentStatus?: Maybe<Array<Maybe<Scalars['String']>>>;
  designations?: Maybe<Array<Maybe<Scalars['String']>>>;
  employeeActiveStatus?: Maybe<Scalars['String']>;
  employeeLevel?: Maybe<Array<Maybe<Scalars['String']>>>;
  employmentType?: Maybe<Array<Scalars['String']>>;
  engagementLevel?: Maybe<Array<Maybe<Scalars['String']>>>;
  experienceGTE?: Maybe<Scalars['Float']>;
  experienceLTE?: Maybe<Scalars['Float']>;
  involvedAs?: Maybe<Array<Maybe<Scalars['String']>>>;
  jobType?: Maybe<Scalars['String']>;
  rateTypeGTE?: Maybe<Scalars['Float']>;
  rateTypeLTE?: Maybe<Scalars['Float']>;
  region?: Maybe<Array<Maybe<Scalars['String']>>>;
  roles?: Maybe<Array<Maybe<Scalars['String']>>>;
  searchText?: Maybe<Scalars['String']>;
  secondarySkills?: Maybe<Array<Maybe<Scalars['String']>>>;
  shift?: Maybe<Scalars['String']>;
  skills?: Maybe<Array<Maybe<Scalars['String']>>>;
  softSkills?: Maybe<Array<Maybe<Scalars['String']>>>;
  squad?: Maybe<Array<Maybe<IClientNameAndSquads>>>;
  subDepartment?: Maybe<Array<Maybe<IDepartmentAndSubDepartment>>>;
}

export interface IUserSquadHistoryDto {
  assignedDevices?: Maybe<Array<Scalars['String']>>;
  assignedDevicesList?: Maybe<Array<IAssignedDevices>>;
  availability?: Maybe<Scalars['String']>;
  availableFor?: Maybe<Scalars['String']>;
  availableSince?: Maybe<Scalars['DateTime']>;
  currentSquad: Array<ICurrentSquad>;
  currentWorkInfo: ICurrentWorkInfoDto;
  departmentInfo?: Maybe<IDepartment>;
  deploymentStatus?: Maybe<IDeploymentStatus>;
  designation?: Maybe<Scalars['String']>;
  employee?: Maybe<IEmployeeResponse>;
  employeeActiveStatus?: Maybe<Scalars['String']>;
  employeeJobType?: Maybe<Scalars['String']>;
  employeeLevel?: Maybe<Scalars['String']>;
  experience?: Maybe<Array<Maybe<IExperienceResponse>>>;
  gender?: Maybe<IGender>;
  githubUrl?: Maybe<Scalars['String']>;
  immediateSupervisorName?: Maybe<Scalars['String']>;
  joinedDate?: Maybe<Scalars['DateTime']>;
  linkedinUrl?: Maybe<Scalars['String']>;
  originalFilename?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  profileId: Scalars['String'];
  profileImage?: Maybe<Scalars['String']>;
  rate?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  resignDate?: Maybe<Scalars['DateTime']>;
  resumeUrl?: Maybe<Scalars['String']>;
  roles?: Maybe<Array<Maybe<Scalars['String']>>>;
  shift?: Maybe<Scalars['String']>;
  skills?: Maybe<Array<Maybe<Scalars['String']>>>;
  skillsSet?: Maybe<ISkillsDto>;
  squadHistory?: Maybe<Array<ISquadInfoDto>>;
  supervisors?: Maybe<Array<Maybe<IUserSupervisor>>>;
  timeZone?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
}

export interface IUserSquadHistoryPaged {
  /** List of fetched data */
  content: Array<IUserSquadHistoryDto>;
  /** Information about pagination */
  pageable: IPageable;
}

export interface IUserSquadHistorySearchDto {
  /** Availability end date */
  availabilityEndDate?: Maybe<Scalars['String']>;
  /** Availability start date */
  availabilityStartDate?: Maybe<Scalars['String']>;
  /** Estimated end date */
  estimatedEndDate?: Maybe<Scalars['DateTime']>;
  /** Invocing end date */
  invoicingEnd?: Maybe<Scalars['DateTime']>;
  /** Invoicing start date */
  invoicingStart?: Maybe<Scalars['DateTime']>;
  /** Employee involved as */
  involvedAs?: Maybe<Array<IInvolvedAs>>;
  /** Filter data by job type */
  jobType?: Maybe<IJobType>;
  /** Level of employee */
  level?: Maybe<Array<IEmployeeLevel>>;
  /** Current page */
  page?: Maybe<Scalars['Float']>;
  /** Phases assigned */
  phasesAssigned?: Maybe<Array<Scalars['String']>>;
  /** Rate end to */
  rateEndto?: Maybe<Scalars['String']>;
  /** Rate start from */
  rateStartFrom?: Maybe<Scalars['String']>;
  /** Required for kickoff */
  requiredForKickOff?: Maybe<Scalars['String']>;
  /** Skills required */
  requiredSkills?: Maybe<Array<Scalars['String']>>;
  /** Boolean to filter resigned employees(inactive employees) */
  resigned?: Maybe<Scalars['Boolean']>;
  /** Roles of employee */
  roles?: Maybe<Array<Scalars['String']>>;
  /** Search field */
  searchKey?: Maybe<Scalars['String']>;
  /** Items per page */
  size?: Maybe<Scalars['Float']>;
  /** Field to sort by */
  sortBy?: Maybe<Scalars['String']>;
  /** Order of sorting */
  sortOrder?: Maybe<Scalars['String']>;
  /** Start date */
  startDate?: Maybe<Scalars['DateTime']>;
  /** Involvement status of employee */
  status?: Maybe<Array<IInvolvementStatus>>;
  /** Technical skills */
  technicalSkills?: Maybe<Array<Scalars['String']>>;
  /** Working hours */
  workingHour?: Maybe<Scalars['Float']>;
  /** End year of work */
  yearsOfExperienceEnd?: Maybe<Scalars['Float']>;
  /** Starting year of work */
  yearsOfExperienceStart?: Maybe<Scalars['Float']>;
}

export interface IUserSquadHistoryWithNotesDto {
  _id?: Maybe<Scalars['String']>;
  client?: Maybe<IClientNameDto>;
  clientId?: Maybe<Scalars['String']>;
  involvementStatus?: Maybe<Scalars['String']>;
  joinedDate?: Maybe<Scalars['DateTime']>;
  note?: Maybe<Scalars['String']>;
  notes?: Maybe<Array<IInvolvementHistoryDto>>;
  profileId?: Maybe<Scalars['String']>;
  squad?: Maybe<ISquadNameDto>;
  squadId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
}

export interface IUserSupervisor {
  _id?: Maybe<Scalars['String']>;
  departmentName?: Maybe<Scalars['String']>;
  designationName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  fullname?: Maybe<Scalars['String']>;
}

export interface IUserUploadDto {
  country?: Maybe<Scalars['String']>;
  department?: Maybe<Scalars['String']>;
  departmentId?: Maybe<Scalars['String']>;
  designation?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  employeeId?: Maybe<Scalars['String']>;
  employeementType?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<IUserUploadErrors>>>;
  gender?: Maybe<Scalars['String']>;
  grade?: Maybe<Scalars['Float']>;
  jobType?: Maybe<Scalars['String']>;
  joinedDate?: Maybe<Scalars['DateTime']>;
  level?: Maybe<IEmployeeLevel>;
  mostProficientSkills?: Maybe<Array<Scalars['String']>>;
  name?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  shift?: Maybe<Scalars['String']>;
  softSkills?: Maybe<Array<Scalars['String']>>;
  somewhatProficientSkills?: Maybe<Array<Scalars['String']>>;
  timezone?: Maybe<Scalars['String']>;
}

export interface IUserUploadErrors {
  fieldName: Scalars['String'];
  message: Scalars['String'];
}

export interface IUserUploadErrorsInput {
  fieldName: Scalars['String'];
  message: Scalars['String'];
}

export interface IUserUploadInputDto {
  country?: Maybe<Scalars['String']>;
  department?: Maybe<Scalars['String']>;
  departmentId?: Maybe<Scalars['String']>;
  designation?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  employeeId?: Maybe<Scalars['String']>;
  employeementType?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<IUserUploadErrorsInput>>>;
  gender?: Maybe<Scalars['String']>;
  grade?: Maybe<Scalars['Float']>;
  jobType?: Maybe<Scalars['String']>;
  joinedDate?: Maybe<Scalars['DateTime']>;
  level?: Maybe<IEmployeeLevel>;
  mostProficientSkills?: Maybe<Array<Scalars['String']>>;
  name?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  shift?: Maybe<Scalars['String']>;
  softSkills?: Maybe<Array<Scalars['String']>>;
  somewhatProficientSkills?: Maybe<Array<Scalars['String']>>;
  timezone?: Maybe<Scalars['String']>;
}

export interface IUserUploadValidationResponse {
  invalidData?: Maybe<Array<Maybe<IUserUploadDto>>>;
  validData?: Maybe<Array<Maybe<IUserUploadDto>>>;
}

export interface IUsersByRoleAndLevelDto {
  levels: Array<ILevelAndCountByRole>;
  role: Scalars['String'];
}

export interface IUsersByRoleAndLevelData {
  data: Array<IUsersByRoleAndLevelDto>;
  levelList: Array<ILevelList>;
}

export interface IUsersNameListDto {
  employeeName?: Maybe<Scalars['String']>;
}

export interface IVerfiyOtpArgsDto {
  clientId?: Maybe<Scalars['String']>;
  /** Email associated with client, to send OTP to for verification or to login if already verified */
  email: Scalars['String'];
  /** Unique device fingerprint */
  fingerprint: Scalars['String'];
  /** 6 digit OTP code sent in email */
  otp: Scalars['String'];
  /** Unique session token */
  sessionToken: Scalars['String'];
}

export interface IVerifyOtpResponseDto {
  accessToken?: Maybe<Scalars['String']>;
  clientIdsEncoded?: Maybe<Scalars['String']>;
  clientInfo?: Maybe<IClientDetailDto>;
  expiresIn?: Maybe<Scalars['String']>;
  idToken?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  refreshToken?: Maybe<Scalars['String']>;
  tokenType?: Maybe<Scalars['String']>;
  userInfo?: Maybe<IUserInfoClientDto>;
}

export interface IVerticalDto {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  verticalLeadId?: Maybe<Scalars['String']>;
}

export interface IVerticalHeadDto {
  id?: Maybe<Scalars['String']>;
  verticalLeadName?: Maybe<Scalars['String']>;
}

export interface IVerticalIndustryNameDto {
  industryId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
}

export interface IVerticalInfoDto {
  industryId?: Maybe<Scalars['String']>;
  verticalId?: Maybe<Scalars['String']>;
}

export interface IViewResumeUrlsResponse {
  key: Scalars['String'];
  url: Scalars['String'];
}

export interface IViewSquadDetailsDto {
  squadDetails: ISquadDto;
  teamMembers: IEmployeeInfoPaged;
}

export enum IWorklog_Approver_Types {
  ADDITIONAL = 'ADDITIONAL',
  DEFAULT = 'DEFAULT'
}

export interface IWorkExperience {
  totalYearsOfExperience?: Maybe<Scalars['String']>;
  yearsOfExperienceInRoles?: Maybe<Array<IYearsOfExperienceInRoles>>;
}

export interface IWorkExperienceDto {
  company?: Maybe<Scalars['String']>;
  companyAddress?: Maybe<Scalars['String']>;
  profileId: Scalars['String'];
  userId: Scalars['String'];
  workExperienceId?: Maybe<Scalars['String']>;
  workHistory: Array<IWorkHistoryOutput>;
}

export interface IWorkHistoryInput {
  details?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['DateTime']>;
  jobTitle: Scalars['String'];
  role: Scalars['String'];
  startDate: Scalars['DateTime'];
  workHistoryId?: Maybe<Scalars['String']>;
}

export interface IWorkHistoryOutput {
  details?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['DateTime']>;
  jobTitle: Scalars['String'];
  role: Scalars['String'];
  startDate: Scalars['DateTime'];
  workHistoryId?: Maybe<Scalars['String']>;
}

export interface IWorkInformation {
  currentSalary?: Maybe<Scalars['String']>;
  joinType?: Maybe<Scalars['String']>;
  shift?: Maybe<Scalars['String']>;
  timeZone?: Maybe<Scalars['String']>;
  workPreference?: Maybe<Scalars['String']>;
}

export enum IWorkShift {
  DAY = 'DAY',
  EVENING = 'EVENING'
}

export interface IWorklogBatchResponseDto {
  comments: Array<IBatchCommentResponseDto>;
  id: Scalars['String'];
  isSaveAsDraft?: Maybe<Scalars['Boolean']>;
  status: Scalars['String'];
  worklogIds: Array<Scalars['String']>;
  worklogs?: Maybe<Array<Maybe<IWorklogResponseDto>>>;
}

export interface IWorklogCloseDocumentResponseDto {
  closeEndDate?: Maybe<Scalars['DateTime']>;
  closeStartDate?: Maybe<Scalars['DateTime']>;
  squadId?: Maybe<Scalars['String']>;
  status: IWorklogCloseStatus;
}

export enum IWorklogCloseStatus {
  CLOSE = 'CLOSE',
  OPEN = 'OPEN'
}

export interface IWorklogCloseStatusFilterDto {
  endDate?: Maybe<Scalars['DateTime']>;
  squadId: Scalars['String'];
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<IWorklogCloseStatus>;
}

export interface IWorklogCommentsDto {
  categories?: Maybe<Array<Scalars['String']>>;
  comments?: Maybe<Array<ICommentDto>>;
  endDate?: Maybe<Scalars['DateTime']>;
  startDate?: Maybe<Scalars['DateTime']>;
  workedMinutes?: Maybe<Scalars['Int']>;
  worklogId?: Maybe<Scalars['String']>;
  worklogStatus?: Maybe<Scalars['String']>;
}

export interface IWorklogFilter {
  category?: Maybe<Array<Scalars['String']>>;
  fromDate?: Maybe<Scalars['DateTime']>;
  includeDrafts?: Maybe<Scalars['Boolean']>;
  squadId?: Maybe<Scalars['String']>;
  status?: Maybe<IWorklogStatus>;
  toDate?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
}

export interface IWorklogLeaveApproveDeclineReq {
  leaveId: Array<Scalars['String']>;
  leaveStatus: ILeaveStatus;
}

export interface IWorklogLeaveDto {
  id: Scalars['String'];
  leaveCategory: Scalars['String'];
  leaveDate: Scalars['DateTime'];
  leaveRemarks?: Maybe<Scalars['String']>;
  leaveStatus: ILeaveStatus;
  leaveType: ILeaveType;
  squadId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  worklogId?: Maybe<Scalars['String']>;
}

export interface IWorklogLeaveFilter {
  leaveCategory?: Maybe<Array<Scalars['String']>>;
  leaveDate?: Maybe<Array<Scalars['DateTime']>>;
  leaveStatus?: Maybe<Array<ILeaveStatus>>;
  leaveType?: Maybe<Array<ILeaveType>>;
}

export interface IWorklogLeaveReq {
  leaveCategory: Scalars['String'];
  leaveDate: Scalars['DateTime'];
  leaveRemarks: Scalars['String'];
  leaveType: ILeaveType;
  squadId: Scalars['String'];
  userId: Scalars['String'];
  worklogId?: Maybe<Scalars['String']>;
}

export interface IWorklogOverviewResponseDto {
  categoryOverview: Array<ICategoryOverviewResponseDto>;
  consultants: Array<IConsultantInfo>;
  hourOverview: IHourOverviewResponseDto;
  invoicingPeriods?: Maybe<Array<Maybe<ISquadInvoicePeriodList>>>;
  leaves?: Maybe<ILeavesInfo>;
  worklogCount: Array<Scalars['String']>;
}

export enum IWorklogReminder {
  DAILY_REMINDER = 'DAILY_REMINDER',
  WEEKLY_REMINDER = 'WEEKLY_REMINDER'
}

export interface IWorklogResponseDto {
  endDate: Scalars['DateTime'];
  id: Scalars['String'];
  reviewedBy?: Maybe<Scalars['String']>;
  squadId: Scalars['String'];
  startDate: Scalars['DateTime'];
  status: Scalars['String'];
  tasks: Array<IWorklogTaskResponseDto>;
}

/** Status of the worklog. */
export enum IWorklogStatus {
  /** Approved by default/additional approver. */
  APPROVED = 'APPROVED',
  /** Declined by default/additional approver. */
  DECLINED = 'DECLINED',
  /** Awaiting default/additional approver's action. */
  PENDING = 'PENDING',
  /** Resubmitted by consultant. */
  UPDATED = 'UPDATED'
}

export interface IWorklogTaskDto {
  category: Scalars['String'];
  description: Scalars['String'];
  endTime?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  minutes: Scalars['Int'];
  recurringDates?: Maybe<Array<Scalars['String']>>;
  recurringId?: Maybe<Scalars['String']>;
  recurringOptions?: Maybe<IRecurringOptions>;
  startTime?: Maybe<Scalars['String']>;
}

export interface IWorklogTaskResponseDto {
  category: Scalars['String'];
  description: Scalars['String'];
  endTime?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isRecurring?: Maybe<Scalars['Boolean']>;
  minutes: Scalars['Int'];
  recurringDates?: Maybe<Array<Scalars['String']>>;
  recurringId?: Maybe<Scalars['String']>;
  recurringOptions?: Maybe<IRecurringOptions>;
  squadId: Scalars['String'];
  startTime?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  worklogId?: Maybe<Scalars['String']>;
}

export interface IWorklogsDto {
  closeStatus?: Maybe<IWorklogCloseStatus>;
  commentsCount?: Maybe<Scalars['Int']>;
  endDate: Scalars['DateTime'];
  id: Scalars['String'];
  isSaveAsDraft?: Maybe<Scalars['Boolean']>;
  leaveInfo?: Maybe<Array<ILeaveDetail>>;
  resubmittedCount: Scalars['Int'];
  reviewedBy?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  status: Scalars['String'];
  workedMinutes: Scalars['Int'];
  worklogbatchId?: Maybe<Scalars['String']>;
  worklogtasks?: Maybe<Array<IWorklogTaskDto>>;
}

export interface IWorklogsDtoPaged {
  closeEndDate?: Maybe<Scalars['DateTime']>;
  closeStartDate?: Maybe<Scalars['DateTime']>;
  closeStatus?: Maybe<Scalars['Boolean']>;
  /** List of fetched data */
  content: Array<IWorklogsDto>;
  /** Information about pagination */
  pageable: IPageable;
}

export interface IYearMonthDto {
  month?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['String']>;
}

export interface IYearsOfExperienceInRoles {
  roles?: Maybe<Scalars['String']>;
  yearsOfExperience?: Maybe<Scalars['Float']>;
}

export interface IYearsOfExperienceInRolesOptions {
  role: Scalars['String'];
  yearsOfExperience: Scalars['Int'];
}

export interface IAccountExecutiveDto {
  email?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  ownerId?: Maybe<Scalars['String']>;
}

export interface IBillingCycle {
  billingAmount?: Maybe<Scalars['String']>;
  billingType?: Maybe<Scalars['String']>;
}

export interface ICbuDepartmentsResp {
  cbu: Scalars['String'];
  departments: Array<Scalars['String']>;
}

export interface ICertificatesDto {
  certificateID?: Maybe<Scalars['String']>;
  certificateTitle?: Maybe<Scalars['String']>;
  completedOn?: Maybe<ICompletedOnDto>;
  currentlyStudying?: Maybe<Scalars['Boolean']>;
  isCertificateFormCompleted?: Maybe<Scalars['Boolean']>;
  issuingInstitutionOrganization?: Maybe<Scalars['String']>;
  joinedOn?: Maybe<IJoinedOnDto>;
  url?: Maybe<Scalars['String']>;
}

export interface ICertificatesInputDto {
  certificateID?: Maybe<Scalars['String']>;
  certificateTitle?: Maybe<Scalars['String']>;
  completedOn?: Maybe<ICompletedOnInputDto>;
  currentlyStudying?: Maybe<Scalars['Boolean']>;
  isCertificateFormCompleted?: Maybe<Scalars['Boolean']>;
  issuingInstitutionOrganization?: Maybe<Scalars['String']>;
  joinedOn?: Maybe<IJoinedOnInputDto>;
  url?: Maybe<Scalars['String']>;
}

export interface IClient {
  /** list of client contact ids from clientcontacts colleciton */
  contactIds?: Maybe<Array<Scalars['String']>>;
  /** Unique ID of the clients collection */
  id: Scalars['ID'];
  /** name of the client */
  name: Scalars['String'];
  /** onboarding date of the client */
  startDate?: Maybe<Scalars['DateTime']>;
  /** status of client whether active or not */
  status?: Maybe<Scalars['String']>;
}

export interface IClientContact {
  active?: Maybe<Scalars['Boolean']>;
  clientDepartmentId?: Maybe<Scalars['String']>;
  clientId: Scalars['String'];
  designation?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
}

export interface IClientDepartment {
  clientId?: Maybe<Scalars['String']>;
  contactIds?: Maybe<Array<Scalars['String']>>;
  id: Scalars['ID'];
  name: Scalars['String'];
}

export interface IClientDepartmentDto {
  id: Scalars['ID'];
  name: Scalars['String'];
}

export interface IClientDto {
  accountExecutive?: Maybe<IAccountExecutiveDto>;
  annualRevenue?: Maybe<Scalars['Float']>;
  businessUnit?: Maybe<Scalars['String']>;
  buyingLeader?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  clientType: Scalars['String'];
  companyId: Scalars['String'];
  contactIds?: Maybe<Array<Scalars['String']>>;
  countSquads?: Maybe<Scalars['Float']>;
  country?: Maybe<Scalars['String']>;
  createdFromHubspot: Scalars['Boolean'];
  csatRating?: Maybe<Scalars['Float']>;
  deliveryManager?: Maybe<Scalars['String']>;
  domain: Scalars['String'];
  duLeader?: Maybe<Scalars['String']>;
  emailDomains: Array<Scalars['String']>;
  hubspotClientType: Scalars['String'];
  id?: Maybe<Scalars['ID']>;
  itBudget: Scalars['Float'];
  legalEntity?: Maybe<Scalars['String']>;
  msa?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  nda?: Maybe<Scalars['Boolean']>;
  noOfEmployees?: Maybe<Scalars['String']>;
  npsScore?: Maybe<Scalars['Float']>;
  onboardingDate?: Maybe<Scalars['DateTime']>;
  orgId?: Maybe<Scalars['String']>;
  sow?: Maybe<Scalars['Boolean']>;
  startDate?: Maybe<Scalars['DateTime']>;
  state?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  streetAddress?: Maybe<Scalars['String']>;
  streetAddress2?: Maybe<Scalars['String']>;
  tier?: Maybe<Scalars['String']>;
  vertical?: Maybe<IVerticalInfoDto>;
}

export interface IClientInfoDto {
  /** company owner information */
  accountExecutive?: Maybe<Scalars['String']>;
  /** annual revenue of the company */
  annualRevenue?: Maybe<Scalars['Float']>;
  /** business unit of the company */
  businessUnit?: Maybe<Scalars['String']>;
  /** Type of client */
  clientType?: Maybe<Scalars['String']>;
  /** companyId in clients collection and it must be unique. */
  companyId?: Maybe<Scalars['String']>;
  /** list of clientcontacts collection ids */
  contactIds?: Maybe<Array<Scalars['String']>>;
  /** list of client contacts including name, number, email, designation, buying role */
  contacts?: Maybe<Array<IContacts>>;
  /** CSAT Rating for the company */
  csatRating?: Maybe<Scalars['Float']>;
  /** client type from hubspot either startup or enterprise */
  hubspotClientType?: Maybe<Scalars['String']>;
  /** Unique Id for the client in collection */
  id: Scalars['ID'];
  /** IT Budget of the company */
  itBudget?: Maybe<Scalars['String']>;
  /** legal name of the company. legalEntity field in clients collection and it must be unique. */
  legalEntity?: Maybe<Scalars['String']>;
  /** location of the company i.e, string concat of streetaddress, city, state, country */
  location?: Maybe<Scalars['String']>;
  /** is msa contract signed with the company either Yes or No */
  msa?: Maybe<Scalars['String']>;
  /** name of the company. name field in clients collection and it must be unique. */
  name: Scalars['String'];
  /** is nda contract signed with the company either Yes or No */
  nda?: Maybe<Scalars['String']>;
  /** size of the company */
  noOfEmployees?: Maybe<Scalars['String']>;
  /** NPS Score for the company */
  npsScore?: Maybe<Scalars['Float']>;
  /** signed date with the company */
  onboardingDate?: Maybe<Scalars['DateTime']>;
  /** is sow contract signed with the company either Yes or No */
  sow?: Maybe<Scalars['String']>;
  /** list of client squads contacts including name, number, email, designation */
  squadContactDetails?: Maybe<Array<ISquadContactDetail>>;
  /** replaced by onboardingDate in clients collection */
  startDate?: Maybe<Scalars['DateTime']>;
  /** status of client active or inactive */
  status: Scalars['String'];
  /** second location of the company if available */
  streetAddress2?: Maybe<Scalars['String']>;
  /** tier of the company like tier 1, 2 , 3 */
  tier?: Maybe<Scalars['String']>;
  /** total number of client contacts plus total number of client's squads contacts */
  totalNumberOfContacts: Scalars['Float'];
  /** total number of assigned resources in the client squads */
  totalNumberOfEngineers: Scalars['Float'];
  /** total number of client squads */
  totalNumberOfSquads: Scalars['Float'];
  /** name of client vertical in vertical field, name of client vertical lead in verticalLead and name of client industry in industry field */
  verticalInfo?: Maybe<IClientVerticalInfo>;
  /** company domain */
  website?: Maybe<Scalars['String']>;
}

export interface IClientOverviewSquadListDto {
  /** status of the squad like not started , running , delayed, onhold */
  activeStatus?: Maybe<Scalars['String']>;
  aiMembersCount: Scalars['Float'];
  /** list of approvers and additional approvers */
  approvers?: Maybe<ISquadApprovers>;
  /** department information of the squad */
  clientDepartment?: Maybe<ISquadClientDepartmentDto>;
  /** squad owner or deal owner */
  createdBy?: Maybe<Scalars['String']>;
  /** Start date of the squad */
  endDate?: Maybe<Scalars['DateTime']>;
  /** Unique id of the squads collection */
  id: Scalars['ID'];
  /** industry of the squad, will no longer be used in future as replaced by vertical and industry */
  lineOfBusiness?: Maybe<Scalars['String']>;
  /** Name of the squad */
  name: Scalars['String'];
  /** project tier of the squad */
  projectTier?: Maybe<Scalars['Float']>;
  /** Start date of the squad */
  startDate?: Maybe<Scalars['DateTime']>;
  techMembersCount: Scalars['Float'];
  /** owner of the ticket */
  ticketOwner?: Maybe<Array<Scalars['String']>>;
  /** total number of assigned resources */
  totalAssignedCount?: Maybe<Scalars['Float']>;
  totalMembersCount: Scalars['Float'];
  /** total number of assigned plus unassigned resources */
  totalResourceCount?: Maybe<Scalars['Float']>;
  /** Type of the squad e.g: internal or external */
  type?: Maybe<Scalars['String']>;
}

export interface ICompletedOnDto {
  month: Scalars['String'];
  year: Scalars['String'];
}

export interface ICompletedOnInputDto {
  month: Scalars['String'];
  year: Scalars['String'];
}

export interface IContacts {
  /** Buying role of the contact like primary business contact, du leader, bu leader, delivery manager, primary billing contact */
  buyingRole?: Maybe<Scalars['String']>;
  /** Designation of the contact */
  designation: Scalars['String'];
  /** Email of the contact */
  email: Scalars['String'];
  /** Unique ID of the clientcontacts collection */
  id: Scalars['ID'];
  /** Name of the contact */
  name: Scalars['String'];
  /** Phone number of the contact */
  number: Scalars['String'];
}

export interface IDealOwnerDto {
  name?: Maybe<Scalars['String']>;
  ownerEmail?: Maybe<Scalars['String']>;
  ownerId?: Maybe<Scalars['String']>;
}

export interface IDepartment {
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
}

export interface IDepartmentDto {
  /** Sub department ID */
  id?: Maybe<Scalars['ID']>;
  /** Sub department name */
  name?: Maybe<Scalars['String']>;
}

export interface IDepartmentInput {
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
}

export enum IDepartmentLevel {
  MAIN_DEPARTMENT = 'MAIN_DEPARTMENT',
  SUB_DEPARTMENT = 'SUB_DEPARTMENT'
}

export interface IEducationDto {
  completedOn?: Maybe<ICompletedOnDto>;
  currentlyStudying?: Maybe<Scalars['Boolean']>;
  degree?: Maybe<Scalars['String']>;
  fieldOfStudy?: Maybe<Scalars['String']>;
  isEducationFormCompleted?: Maybe<Scalars['Boolean']>;
  joinedOn?: Maybe<IJoinedOnDto>;
  levelOfEducation?: Maybe<Scalars['String']>;
  school?: Maybe<Scalars['String']>;
}

export interface IEducationRequestDto {
  completedOn?: Maybe<ICompletedOnInputDto>;
  currentlyStudying?: Maybe<Scalars['Boolean']>;
  degree?: Maybe<Scalars['String']>;
  fieldOfStudy?: Maybe<Scalars['String']>;
  isEducationFormCompleted?: Maybe<Scalars['Boolean']>;
  joinedOn?: Maybe<IJoinedOnInputDto>;
  levelOfEducation?: Maybe<Scalars['String']>;
  school?: Maybe<Scalars['String']>;
}

export interface IEmployeeInfo {
  additionalNotes?: Maybe<Array<Maybe<IAdditionalNoteResponseDto>>>;
  clientRate?: Maybe<Scalars['Float']>;
  createdBy?: Maybe<Scalars['String']>;
  department?: Maybe<IDepartment>;
  designation?: Maybe<Scalars['String']>;
  employeeActiveStatus?: Maybe<Scalars['String']>;
  employeeId?: Maybe<Scalars['String']>;
  employeeRate?: Maybe<Scalars['Float']>;
  employeementType?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['DateTime']>;
  estimatedEndDate?: Maybe<Scalars['DateTime']>;
  estimatedStartDate?: Maybe<Scalars['DateTime']>;
  experienceLevel?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  involvedAs?: Maybe<Scalars['String']>;
  involvementHistoryId?: Maybe<Scalars['String']>;
  involvementStatus?: Maybe<Scalars['String']>;
  jobType?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  phasesAssigned?: Maybe<Array<Scalars['String']>>;
  profileId: Scalars['String'];
  profileImage?: Maybe<Scalars['String']>;
  rate?: Maybe<Scalars['Float']>;
  rateCurrency?: Maybe<Scalars['String']>;
  rateType?: Maybe<Scalars['String']>;
  region?: Maybe<Array<Scalars['String']>>;
  requiredForKickOff?: Maybe<Scalars['Boolean']>;
  requiredSkills?: Maybe<Array<Scalars['String']>>;
  resignDate?: Maybe<Scalars['DateTime']>;
  role?: Maybe<Scalars['String']>;
  roleDescription?: Maybe<Scalars['String']>;
  squadRoleId?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  technicalSkills?: Maybe<Array<Scalars['String']>>;
  ticketId?: Maybe<Scalars['String']>;
  ticketLink?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
  workingHour?: Maybe<Scalars['Float']>;
  yearsOfExperience?: Maybe<Scalars['Float']>;
}

export interface IEnterprisePeople {
  clientEmail: Scalars['String'];
  client_pov: Scalars['Boolean'];
  customer_pov: Scalars['Boolean'];
  firstName: Scalars['String'];
  id: Scalars['ID'];
  lastName: Scalars['String'];
  orgId: Scalars['String'];
  organization: IOrganization;
  roles: Array<Scalars['String']>;
}

export interface IExperienceDto {
  month?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['String']>;
}

export interface IHistorySquadAndClientDto {
  clientId?: Maybe<Scalars['String']>;
  clientName?: Maybe<Scalars['String']>;
  country?: Maybe<Array<Scalars['String']>>;
  department?: Maybe<Scalars['String']>;
  employeeName?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['DateTime']>;
  experienceLevel?: Maybe<Scalars['String']>;
  goodToHaveSkills?: Maybe<Array<Scalars['String']>>;
  id?: Maybe<Scalars['String']>;
  involvedAs?: Maybe<Scalars['String']>;
  involvementStatus?: Maybe<Scalars['String']>;
  jobDescription?: Maybe<Scalars['String']>;
  jobType?: Maybe<Scalars['String']>;
  joinedDate?: Maybe<Scalars['DateTime']>;
  priority?: Maybe<Scalars['String']>;
  rate?: Maybe<Scalars['Float']>;
  requiredSkills?: Maybe<Array<Scalars['String']>>;
  role?: Maybe<Scalars['String']>;
  squadId?: Maybe<Scalars['String']>;
  squadName?: Maybe<Scalars['String']>;
  squadRoleId?: Maybe<Scalars['String']>;
  ticketId?: Maybe<Scalars['String']>;
  timeZone?: Maybe<Array<Scalars['String']>>;
  userId: Scalars['String'];
}

export interface IInvolvementHistoryInput {
  _id?: Maybe<Scalars['String']>;
  allocatedHours?: Maybe<Scalars['Float']>;
  endDate?: Maybe<Scalars['DateTime']>;
  involvedAs?: Maybe<IInvolvedAs>;
  involvementStatus?: Maybe<IInvolvementStatus>;
  jobType?: Maybe<IJobTypeEnum>;
  joinedDate?: Maybe<Scalars['DateTime']>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  note?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
}

export interface IJoinedOnDto {
  month: Scalars['String'];
  year: Scalars['String'];
}

export interface IJoinedOnInputDto {
  month: Scalars['String'];
  year: Scalars['String'];
}

export interface ILevelData {
  /** total number of resources in the respective level */
  count: Scalars['Float'];
  /** name of the level */
  level: Scalars['String'];
}

export interface ILineOfBusinessReq {
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
}

export interface IListApproversFilterDto {
  /** Type of the approver to list */
  approverType?: Maybe<IWorklog_Approver_Types>;
  /** Flag whether to search all users or squad members only */
  includeAllUsers?: Maybe<Scalars['Boolean']>;
  /** Search approvers by name or designation or email */
  searchKey?: Maybe<Scalars['String']>;
  /** ID of the squad */
  squadId?: Maybe<Scalars['String']>;
}

export interface IListSupervisorsFilterDto {
  /** Search supervisors by name or designation or email */
  searchKey?: Maybe<Scalars['String']>;
}

export interface IOrganization {
  client_pov: Scalars['Boolean'];
  customer_pov: Scalars['Boolean'];
  id: Scalars['ID'];
  name: Scalars['String'];
  url: Scalars['String'];
}

export interface IPermissionGroupResp {
  _id?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  orgId?: Maybe<Scalars['String']>;
  /** Permission_Manage.ANALYTICS */
  permissions: Array<Scalars['String']>;
}

export interface IProjectExperiences {
  description: Scalars['String'];
  monthsOfExperience: Scalars['String'];
  title: Scalars['String'];
  yearsOfExperience: Scalars['String'];
}

export interface IProjectExperiencesReq {
  description: Scalars['String'];
  monthsOfExperience: Scalars['String'];
  title: Scalars['String'];
  yearsOfExperience: Scalars['String'];
}

export interface IRoleData {
  /** level and respective count information */
  levelData: Array<ILevelData>;
  /** name of the role */
  role: Scalars['String'];
}

export interface ISkills {
  competency?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
}

export interface ISquad {
  /** status of the squad like not started, running, delayed, completed or onhold */
  activeStatus?: Maybe<Scalars['String']>;
  /** list of additional approvers of the squad */
  additionalApprovers?: Maybe<Array<Scalars['String']>>;
  /** client department to which squad belongs to */
  clientDepartmentId?: Maybe<Scalars['String']>;
  /** id of the client to which squad belongs to */
  clientId: Scalars['String'];
  /** list of squad contactIds */
  contactIds: Array<Scalars['String']>;
  /** default approver of the squad */
  defaultApprover?: Maybe<Scalars['String']>;
  /** end date of the squad */
  endDate?: Maybe<Scalars['DateTime']>;
  /** unique id of the squad */
  id: Scalars['ID'];
  /** name of the industry currently being replaced by industryId */
  lineOfBusiness?: Maybe<Scalars['String']>;
  /** name of the squad */
  name: Scalars['String'];
  /** start date of the squad */
  startDate?: Maybe<Scalars['DateTime']>;
  /** Tech stack used in squad */
  techStack?: Maybe<Array<Scalars['String']>>;
  /** type of squad like internal or external */
  type: Scalars['String'];
}

export interface ISquadAndSquadResources {
  /** name of the client */
  clientName?: Maybe<Scalars['String']>;
  clientSelectionProcess?: Maybe<Scalars['String']>;
  /** list of region */
  country?: Maybe<Array<Scalars['String']>>;
  /** department related to job role */
  department?: Maybe<Scalars['String']>;
  /** end date */
  endDate?: Maybe<Scalars['DateTime']>;
  /** level of experience required for the job */
  experienceLevel?: Maybe<Scalars['String']>;
  /** list of skills which are good to have for the role */
  goodToHaveSkills?: Maybe<Array<Scalars['String']>>;
  /** unique id of squadresources collection */
  id?: Maybe<Scalars['String']>;
  /** industry where squad belongs to */
  industry?: Maybe<Scalars['String']>;
  /** previous employee involvement type like core, support or shadow */
  involvedAs?: Maybe<Scalars['String']>;
  /** previous employee involvement status like assigned or offboarding_and_replace */
  involvementStatus?: Maybe<IInvolvementStatus>;
  /** is job created for the role if yes will be true else false */
  isRequestedForHire?: Maybe<Scalars['Boolean']>;
  /** job description */
  jobDescription?: Maybe<Scalars['String']>;
  /** job type like part time or full time */
  jobType?: Maybe<Scalars['String']>;
  /** industry of the squad currently being replaced by industry and vertical */
  lineOfBusiness?: Maybe<Scalars['String']>;
  /** list of countries from where resources are required */
  locationToBeHiredFrom?: Maybe<Array<Scalars['String']>>;
  phasesAssigned?: Maybe<Array<Scalars['String']>>;
  /** previous employee end date for the same role */
  prevEmpEndDate?: Maybe<Scalars['DateTime']>;
  /** previous employee start date for the same role */
  prevEmpStartDate?: Maybe<Scalars['DateTime']>;
  /** priority for the job */
  priority?: Maybe<Scalars['String']>;
  /** squad description */
  projectDescription?: Maybe<Scalars['String']>;
  projectTier?: Maybe<Scalars['String']>;
  /** rates per hour */
  rate?: Maybe<Scalars['Float']>;
  /** number of resources required */
  requiredCount?: Maybe<Scalars['String']>;
  /** list of skills required to have for the job role */
  requiredSkills?: Maybe<Array<Scalars['String']>>;
  /** role for the job */
  role?: Maybe<Scalars['String']>;
  softSkills?: Maybe<Array<Scalars['String']>>;
  /** end date of the squad */
  squadEndDate?: Maybe<Scalars['DateTime']>;
  /** id of the squad */
  squadId?: Maybe<Scalars['String']>;
  /** name of the squad */
  squadName?: Maybe<Scalars['String']>;
  /** unique id of the squadroles collection for the specific job role */
  squadRoleId?: Maybe<Scalars['String']>;
  /** start date of the squad */
  squadStartDate?: Maybe<Scalars['DateTime']>;
  /** start date */
  startDate?: Maybe<Scalars['DateTime']>;
  /** unique id of the ticket in hubspot */
  ticketId?: Maybe<Scalars['String']>;
  /** list of timezone from where resources are required */
  timeZone?: Maybe<Array<Scalars['String']>>;
  /** previous employee user id */
  userId?: Maybe<Scalars['String']>;
  /** previous employee unique id from the usersquadhistories collection */
  userSquadHistoryId?: Maybe<Scalars['String']>;
  /** nature of squad's business */
  vertical?: Maybe<Scalars['String']>;
  /** hours per week */
  workingHour?: Maybe<Scalars['Float']>;
  /** years of experience */
  yearsOfExperience?: Maybe<Scalars['Float']>;
}

export interface ISquadClientDepartmentDto {
  id: Scalars['ID'];
  name: Scalars['String'];
}

export interface ISquadContactDetail {
  /** List of contacts by squad from clientcontacts collection. */
  clientContacts: Array<IContacts>;
  /** Unique ID of the squad collections */
  squadId: Scalars['ID'];
  /** Name o,f the squad */
  squadName: Scalars['String'];
}

export interface ISquadDto {
  /** status of the squad like not started, running , delayed, completed or onhold */
  activeStatus?: Maybe<Scalars['String']>;
  /** AdditionalApprovers and their assigned resources */
  additionalApproversResources?: Maybe<Array<ISquadAdditionalApproversAndResources>>;
  /** allow worklog either true or false */
  allowWorklog: Scalars['Boolean'];
  /** list of default approver and additional approvers */
  approvers?: Maybe<ISquadApprovers>;
  /** client information to which squad belongs to */
  client?: Maybe<IClientDto>;
  /** name of the department */
  clientDepartment?: Maybe<IClientDepartmentDto>;
  /** id of the client */
  clientId: Scalars['String'];
  /** description of the squad */
  contacts?: Maybe<Array<IContacts>>;
  /** contract end date of deal in hubspot */
  contractEndDate?: Maybe<Scalars['DateTime']>;
  /** contract start date of deal in hubspot */
  contractStartDate?: Maybe<Scalars['DateTime']>;
  /** will be true if created from hubspot */
  createdFromHubspot: Scalars['Boolean'];
  /** unique id of deal in hubspot if created from hubspot */
  dealId?: Maybe<Scalars['String']>;
  /** link to hubspot deal if the squad is created from hubspot */
  dealLink?: Maybe<Scalars['String']>;
  /** deal owner information like name, email and ownerid */
  dealOwner?: Maybe<IDealOwnerDto>;
  defaultAllocatedMinutes: Scalars['Float'];
  /** description of the squad */
  description?: Maybe<Scalars['String']>;
  /** end date of the squad */
  endDate?: Maybe<Scalars['DateTime']>;
  /** Unique id of the squads collection */
  id: Scalars['ID'];
  /** name of the industry replacing lineofbusiness */
  industry?: Maybe<Scalars['String']>;
  /** id of the verticalindustries collection */
  industryId?: Maybe<Scalars['String']>;
  invoiceIntervalInDays: Scalars['Float'];
  /** name of the industry but currently being replaced by industryId */
  lineOfBusiness?: Maybe<Scalars['String']>;
  /** name of the squad */
  name: Scalars['String'];
  orgId?: Maybe<Scalars['String']>;
  projectTier?: Maybe<Scalars['Float']>;
  /** budget of the squad */
  squadBudget?: Maybe<Scalars['Float']>;
  squadCategoryId?: Maybe<Scalars['String']>;
  squadCategoryName?: Maybe<Scalars['String']>;
  /** start date of the squad */
  startDate?: Maybe<Scalars['DateTime']>;
  /** Tech stack used in squad */
  techStack?: Maybe<Array<Scalars['String']>>;
  /** type of squad like internal or external */
  type?: Maybe<Scalars['String']>;
  /** name of the vertical */
  vertical?: Maybe<Scalars['String']>;
  /** id of the verticals collection */
  verticalId?: Maybe<Scalars['String']>;
}

export interface ISquadEmployeeInfo {
  /** List of resources in the respective squad */
  employeeList?: Maybe<Array<IEmployeeInfo>>;
  /** Unique ID of the squad */
  id: Scalars['ID'];
  /** Name of the squad */
  name: Scalars['String'];
}

export interface ISquadListDto {
  activeStatus?: Maybe<Scalars['String']>;
  /** list of additional approvers name */
  additionalApprovers?: Maybe<Array<Scalars['String']>>;
  /** list of additional approvers name */
  additionalApproversResources?: Maybe<Array<ISquadAdditionalApproversAndResources>>;
  approverFilter?: Maybe<Scalars['Boolean']>;
  /** name of the client */
  clientName?: Maybe<Scalars['String']>;
  contactIds?: Maybe<Array<Scalars['String']>>;
  /** list of countries */
  countries?: Maybe<Array<Scalars['String']>>;
  /** ticket created date */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** created date for from filter */
  createdAtDateFrom?: Maybe<Scalars['DateTime']>;
  /** created date for to filter */
  createdAtDateTo?: Maybe<Scalars['DateTime']>;
  /** link to hubspot deal if available */
  dealLink?: Maybe<Scalars['String']>;
  /** name of deal owner */
  dealOwner?: Maybe<Scalars['String']>;
  /** name of the default approver */
  defaultApprover?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  /** end date of the squad */
  endDate?: Maybe<Scalars['DateTime']>;
  /** estimated end date of squad */
  estimatedEndDate?: Maybe<Scalars['DateTime']>;
  industryId?: Maybe<Scalars['String']>;
  /** will be true if there are no review roles */
  isCompletelyAssigned?: Maybe<Scalars['Boolean']>;
  lineOfBusiness?: Maybe<Scalars['String']>;
  /** name of the squad */
  name?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  /** pin/unpin of a squad will be true if pinned */
  pinned?: Maybe<Scalars['Boolean']>;
  resourceRequiredCount?: Maybe<Scalars['Float']>;
  /** search text for filter */
  searchText?: Maybe<Scalars['String']>;
  squadCategoryId?: Maybe<Scalars['String']>;
  squadId?: Maybe<Scalars['String']>;
  /** status of the squad */
  squadStatus?: Maybe<Array<Scalars['String']>>;
  /** ticket owner, created at and region information */
  squadresource?: Maybe<ISquadResourcesDto>;
  startDate?: Maybe<Scalars['DateTime']>;
  statusChangedDate?: Maybe<Scalars['DateTime']>;
  /** running and not running filter */
  tabFilter?: Maybe<Scalars['String']>;
  /** tech stack used in the squad */
  techStack?: Maybe<Array<Scalars['String']>>;
  /** list of ticket owners */
  ticketOwners?: Maybe<Array<Scalars['String']>>;
  timePeriod?: Maybe<Scalars['String']>;
  /** total number of required resources from all of the squads */
  totalRequiredResources?: Maybe<Scalars['Float']>;
  totalResourceCount?: Maybe<Scalars['Float']>;
  verticalId?: Maybe<Scalars['String']>;
}

export interface ISquadNamesDto {
  name?: Maybe<Scalars['String']>;
  squadId?: Maybe<Scalars['String']>;
}

export interface ISquadNote {
  clientId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  note: Scalars['String'];
  squadId: Scalars['String'];
  userId?: Maybe<Scalars['String']>;
}

export interface ISquadNotes {
  clientId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  note: Scalars['String'];
  squadId: Scalars['String'];
  userId?: Maybe<Scalars['String']>;
}

export interface ISquadOverviewDto {
  /** name of the role, level and count information of AI data */
  AI: Array<IRoleData>;
  /** list of level with their count */
  LEVEL: Array<Scalars['String']>;
  /** name of the role, level and count information of TECH data */
  TECH: Array<IRoleData>;
}

export interface ISquadResourcesDto {
  /** list of countries */
  country?: Maybe<Array<Scalars['String']>>;
  /** ticket created date */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** list of ticket owners */
  ticketOwner?: Maybe<Array<Scalars['String']>>;
}

export interface ISquaderyConstantsResp {
  constantType: ISquaderyConstantsEnum;
  keyObjects?: Maybe<Array<IKeyObjectResp>>;
  keyValues?: Maybe<Array<Array<Scalars['String']>>>;
  values?: Maybe<Array<Scalars['String']>>;
}

export interface ITicketOwnersCountriesDto {
  /** list of countries */
  countries: Array<Scalars['String']>;
  /** list of ticket owner's names */
  ticketOwners: Array<Scalars['String']>;
}

export interface IUpdateSupervisorDto {
  /** Search supervisors by name or designation or email */
  supervisorId: Scalars['String'];
  /** Search supervisors by name or designation or email */
  userId: Scalars['String'];
}

export interface IUploadCertificateDto {
  fileName?: Maybe<Scalars['String']>;
  fileUrl?: Maybe<Scalars['String']>;
}

export interface IUsersNameListDto {
  employeeName?: Maybe<Scalars['String']>;
}

export interface IVerticalInfoDto {
  industryId?: Maybe<Scalars['String']>;
  verticalId?: Maybe<Scalars['String']>;
}

export interface IWorkExperience {
  totalYearsOfExperience?: Maybe<Scalars['String']>;
  yearsOfExperienceInRoles?: Maybe<Array<IYearsOfExperienceInRoles>>;
}

export interface IWorkExperienceDto {
  roles?: Maybe<Array<Scalars['String']>>;
  yearsOfExperienceInRoles: Array<IYearsOfExperienceInput>;
}

export interface IWorkExperienceInputDto {
  roles?: Maybe<Array<Scalars['String']>>;
  yearsOfExperienceInRoles?: Maybe<Array<IYearsOfExperience>>;
}

export interface IYearsOfExperience {
  role?: Maybe<Scalars['String']>;
  yearsOfExperience?: Maybe<Scalars['Float']>;
}

export interface IYearsOfExperienceInRoles {
  roles?: Maybe<Scalars['String']>;
  yearsOfExperience?: Maybe<Scalars['Float']>;
}

export interface IYearsOfExperienceInput {
  role?: Maybe<Scalars['String']>;
  yearsOfExperience?: Maybe<Scalars['Float']>;
}

export interface IYearsOfExperienceResponse {
  role: Scalars['String'];
  yearsOfExperience: Scalars['Float'];
}

export type IRoleDataFragment = { role: string, levelData: Array<{ count: number, level: string }> };

export type IGetFmClientDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type IGetFmClientDetailsQuery = { getFMClientById: { id: string, name: string, startDate?: any | null | undefined, contacts?: Array<{ id: string, name: string, email: string, number: string, designation: string }> | null | undefined } };

export type IGetFmSquadDetailsQueryVariables = Exact<{
  search: Scalars['String'];
}>;


export type IGetFmSquadDetailsQuery = { getFMClientSpecificSquad: Array<{ id: string, name: string, aiMembersCount: number, techMembersCount: number, totalMembersCount: number, projectTier?: number | null | undefined, startDate?: any | null | undefined, activeStatus?: string | null | undefined, lineOfBusiness?: string | null | undefined, clientDepartment?: { id: string, name: string } | null | undefined }> };

export type IGetFmSpecificSquadQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type IGetFmSpecificSquadQuery = { getFMSquadById: { id: string, name: string, activeStatus?: string | null | undefined, lineOfBusiness?: string | null | undefined, projectTier?: number | null | undefined, startDate?: any | null | undefined, type?: string | null | undefined, client?: { id?: string | null | undefined, name?: string | null | undefined, startDate?: any | null | undefined, status?: string | null | undefined } | null | undefined, clientDepartment?: { id: string, name: string } | null | undefined, contacts?: Array<{ id: string, name: string, email: string, number: string, designation: string }> | null | undefined } };

export type IGetFmClientSquadAssignedResourcesQueryVariables = Exact<{
  id: Scalars['String'];
  userSquadHistorySearchDTO: IUserSquadHistorySearchDto;
}>;


export type IGetFmClientSquadAssignedResourcesQuery = { getFMClientSquadAssignedResources: { id: string, name: string, employeeList?: Array<{ id: string, name: string, jobType?: string | null | undefined, experienceLevel?: string | null | undefined, role?: string | null | undefined, yearsOfExperience?: number | null | undefined, requiredSkills?: Array<string> | null | undefined, department?: { id: string, name?: string | null | undefined } | null | undefined }> | null | undefined } };

export type IGetFmClientAssignedResourcesQueryVariables = Exact<{
  userSquadHistorySearchDTO: IUserSquadHistorySearchDto;
}>;


export type IGetFmClientAssignedResourcesQuery = { getFMClientAssignedResources: Array<{ id: string, name: string, employeeList?: Array<{ id: string, name: string, jobType?: string | null | undefined, experienceLevel?: string | null | undefined, role?: string | null | undefined, requiredSkills?: Array<string> | null | undefined, yearsOfExperience?: number | null | undefined, department?: { id: string, name?: string | null | undefined } | null | undefined }> | null | undefined }> };

export type IGetFmSquadOverviewDetailQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type IGetFmSquadOverviewDetailQuery = { getFMSquadOverview: { LEVEL: Array<string>, AI: Array<{ role: string, levelData: Array<{ count: number, level: string }> }>, TECH: Array<{ role: string, levelData: Array<{ count: number, level: string }> }> } };

export type IGetRolesByClientOrSquadQueryVariables = Exact<{
  clientId?: Maybe<Scalars['String']>;
  squadId?: Maybe<Scalars['String']>;
}>;


export type IGetRolesByClientOrSquadQuery = { getRolesByClientOrSquad: Array<string> };

export type IGetSkillsByClientOrSquadQueryVariables = Exact<{
  clientId?: Maybe<Scalars['String']>;
  squadId?: Maybe<Scalars['String']>;
}>;


export type IGetSkillsByClientOrSquadQuery = { getSkillsByClientOrSquad: Array<string> };

export type IFetchUnassignedClientListQueryVariables = Exact<{
  userId: Scalars['String'];
}>;


export type IFetchUnassignedClientListQuery = { getUnassignedClientListByUserId: Array<{ id: string, name: string, clientType?: string | null | undefined, createdFromHubspot?: string | null | undefined }> };

export type IGetClientRolesQueryVariables = Exact<{
  filter: IGetClientRolesFilterDto;
  pageRequest: IPageRequest;
}>;


export type IGetClientRolesQuery = { getClientRoles: { content: Array<{ role?: string | null | undefined, probableCandidatesCount?: number | null | undefined, requiredCount?: number | null | undefined, startDate?: any | null | undefined, squadId?: string | null | undefined, squadName?: string | null | undefined, squadResourceId: string, squadRoleId: string, createdAt?: any | null | undefined, country?: Array<string> | null | undefined, reviewPendingCandidatesCount?: number | null | undefined, status?: string | null | undefined, clientInfo?: { clientName?: string | null | undefined, clientId?: string | null | undefined } | null | undefined }>, pageable: { page: number, totalPages: number, size: number, totalElements: number } } };

export type IGetRoleCandidatesQueryVariables = Exact<{
  filter: IGetRoleCandidatesFilterDto;
  pageRequest: IPageRequest;
}>;


export type IGetRoleCandidatesQuery = { getRoleCandidates: { content: Array<{ involvedAs?: IInvolvedAs | null | undefined, involvementStatus?: IInvolvementStatus | null | undefined, involvementStatusForClients?: IInvolvement_Status_For_Clients_Enum | null | undefined, profileId?: string | null | undefined, softAssignedTill?: any | null | undefined, userId?: string | null | undefined, userName?: string | null | undefined, region?: string | null | undefined, profileImage?: string | null | undefined, resumeUrl?: string | null | undefined, skills?: Array<string> | null | undefined, role?: string | null | undefined, squadInfo?: { squadName?: string | null | undefined, squadId?: string | null | undefined } | null | undefined }>, pageable: { page: number, totalPages: number, size: number, totalElements: number } } };

export type ISaveOrUpdateQueryMutationVariables = Exact<{
  savedQueryDto: ISavedQueryReq;
}>;


export type ISaveOrUpdateQueryMutation = { saveOrUpdateQuery: { id?: string | null | undefined, listName: string, query: string, queryDescription: string, queryName: string, createdAt?: any | null | undefined, createdBy?: string | null | undefined } };

export type IDeleteQueriesMutationVariables = Exact<{
  queryIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type IDeleteQueriesMutation = { deleteQueries: string };

export type IGetCustomQueryFieldQueryVariables = Exact<{
  listName: Scalars['String'];
}>;


export type IGetCustomQueryFieldQuery = { getCustomQueryField: { listName: string, fields?: Array<{ fieldName: string, fieldValues?: Array<string> | null | undefined, mapsTo: string }> | null | undefined } };

export type IGetSavedQueriesQueryVariables = Exact<{
  listName: Scalars['String'];
  searchKey: Scalars['String'];
}>;


export type IGetSavedQueriesQuery = { getSavedQueries: Array<{ id?: string | null | undefined, listName: string, query: string, queryDescription: string, queryName: string, createdAt?: any | null | undefined, createdBy?: string | null | undefined }> };

export type IUserSquadHistoryFragment = { employeeActiveStatus?: string | null | undefined, employeeJobType?: string | null | undefined, availableSince?: any | null | undefined, availableFor?: string | null | undefined, rate?: string | null | undefined, designation?: string | null | undefined, assignedDevices?: Array<string> | null | undefined, profileId: string, userId: string, resumeUrl?: string | null | undefined, profileImage?: string | null | undefined, region?: string | null | undefined, availability?: string | null | undefined, gender?: IGender | null | undefined, deploymentStatus?: IDeploymentStatus | null | undefined, shift?: string | null | undefined, employeeLevel?: string | null | undefined, roles?: Array<string | null | undefined> | null | undefined, resignDate?: any | null | undefined, linkedinUrl?: string | null | undefined, githubUrl?: string | null | undefined, phoneNumber?: string | null | undefined, originalFilename?: string | null | undefined, timeZone?: string | null | undefined, joinedDate?: any | null | undefined, currentSquad: Array<{ clientName?: string | null | undefined, employeementType?: string | null | undefined, joinedDate?: any | null | undefined, squadName?: string | null | undefined, squadId?: string | null | undefined, clientId?: string | null | undefined, endDate?: any | null | undefined, jobType?: IJobTypeEnum | null | undefined }>, employee?: { department?: string | null | undefined, mainDepartment?: string | null | undefined, name?: string | null | undefined, email?: string | null | undefined, employeeId?: string | null | undefined } | null | undefined, experience?: Array<{ role?: string | null | undefined, yearsOfExperience?: number | null | undefined } | null | undefined> | null | undefined, skillsSet?: { mostProficientTechnologies: Array<string>, softSkills: Array<string>, somewhatProficientTechnologies: Array<string> } | null | undefined, supervisors?: Array<{ fullname?: string | null | undefined, email?: string | null | undefined } | null | undefined> | null | undefined, assignedDevicesList?: Array<{ assignedDate?: any | null | undefined, deviceCode: string, deviceDescription: string, deviceName?: string | null | undefined, _id?: string | null | undefined }> | null | undefined, departmentInfo?: { id: string, name?: string | null | undefined } | null | undefined, squadHistory?: Array<{ clientBillingRate?: number | null | undefined, clientId: string, clientName: string, clientType?: string | null | undefined, createdFromHubspot?: boolean | null | undefined, employeeBillingRate?: number | null | undefined, endDate?: any | null | undefined, involvedAs?: string | null | undefined, allocatedHours?: number | null | undefined, involvementStatus?: string | null | undefined, jobType?: IJobTypeEnum | null | undefined, joinedDate?: any | null | undefined, roleInSquad?: string | null | undefined, squadHistoryId?: string | null | undefined, squadId: string, squadName?: string | null | undefined, squadType?: string | null | undefined, involvementHistory?: Array<{ _id?: string | null | undefined, endDate?: any | null | undefined, involvedAs?: IInvolvedAs | null | undefined, involvementStatus?: IInvolvementStatus | null | undefined, jobType?: IJobTypeEnum | null | undefined, joinedDate?: any | null | undefined, modifiedBy?: string | null | undefined, modifiedOn?: any | null | undefined, role?: string | null | undefined, allocatedHours: number, note?: string | null | undefined }> | null | undefined }> | null | undefined, currentWorkInfo: { deploymentStatus?: IDeploymentStatus | null | undefined, designation?: string | null | undefined, employeeId?: string | null | undefined, jobType?: string | null | undefined, level?: IEmployeeLevel | null | undefined, mainDepartment?: string | null | undefined, roles?: Array<string> | null | undefined, workShift?: string | null | undefined, optionExploring?: string | null | undefined, billable?: boolean | null | undefined, employeementType?: IFuseEmployeementType | null | undefined, department?: { id?: string | null | undefined, name?: string | null | undefined } | null | undefined } };

export type IGetUserSquadHistoryQueryVariables = Exact<{
  pageRequest: IPageRequest;
  searchDto: IUserSquadHistoryAdvancedSearchDto;
}>;


export type IGetUserSquadHistoryQuery = { userSquadHistoriesAdvancedSearch: { content: Array<{ employeeActiveStatus?: string | null | undefined, employeeJobType?: string | null | undefined, availableSince?: any | null | undefined, availableFor?: string | null | undefined, rate?: string | null | undefined, designation?: string | null | undefined, assignedDevices?: Array<string> | null | undefined, profileId: string, userId: string, resumeUrl?: string | null | undefined, profileImage?: string | null | undefined, region?: string | null | undefined, availability?: string | null | undefined, gender?: IGender | null | undefined, deploymentStatus?: IDeploymentStatus | null | undefined, shift?: string | null | undefined, employeeLevel?: string | null | undefined, roles?: Array<string | null | undefined> | null | undefined, resignDate?: any | null | undefined, linkedinUrl?: string | null | undefined, githubUrl?: string | null | undefined, phoneNumber?: string | null | undefined, originalFilename?: string | null | undefined, timeZone?: string | null | undefined, joinedDate?: any | null | undefined, currentSquad: Array<{ clientName?: string | null | undefined, employeementType?: string | null | undefined, joinedDate?: any | null | undefined, squadName?: string | null | undefined, squadId?: string | null | undefined, clientId?: string | null | undefined, endDate?: any | null | undefined, jobType?: IJobTypeEnum | null | undefined }>, employee?: { department?: string | null | undefined, mainDepartment?: string | null | undefined, name?: string | null | undefined, email?: string | null | undefined, employeeId?: string | null | undefined } | null | undefined, experience?: Array<{ role?: string | null | undefined, yearsOfExperience?: number | null | undefined } | null | undefined> | null | undefined, skillsSet?: { mostProficientTechnologies: Array<string>, softSkills: Array<string>, somewhatProficientTechnologies: Array<string> } | null | undefined, supervisors?: Array<{ fullname?: string | null | undefined, email?: string | null | undefined } | null | undefined> | null | undefined, assignedDevicesList?: Array<{ assignedDate?: any | null | undefined, deviceCode: string, deviceDescription: string, deviceName?: string | null | undefined, _id?: string | null | undefined }> | null | undefined, departmentInfo?: { id: string, name?: string | null | undefined } | null | undefined, squadHistory?: Array<{ clientBillingRate?: number | null | undefined, clientId: string, clientName: string, clientType?: string | null | undefined, createdFromHubspot?: boolean | null | undefined, employeeBillingRate?: number | null | undefined, endDate?: any | null | undefined, involvedAs?: string | null | undefined, allocatedHours?: number | null | undefined, involvementStatus?: string | null | undefined, jobType?: IJobTypeEnum | null | undefined, joinedDate?: any | null | undefined, roleInSquad?: string | null | undefined, squadHistoryId?: string | null | undefined, squadId: string, squadName?: string | null | undefined, squadType?: string | null | undefined, involvementHistory?: Array<{ _id?: string | null | undefined, endDate?: any | null | undefined, involvedAs?: IInvolvedAs | null | undefined, involvementStatus?: IInvolvementStatus | null | undefined, jobType?: IJobTypeEnum | null | undefined, joinedDate?: any | null | undefined, modifiedBy?: string | null | undefined, modifiedOn?: any | null | undefined, role?: string | null | undefined, allocatedHours: number, note?: string | null | undefined }> | null | undefined }> | null | undefined, currentWorkInfo: { deploymentStatus?: IDeploymentStatus | null | undefined, designation?: string | null | undefined, employeeId?: string | null | undefined, jobType?: string | null | undefined, level?: IEmployeeLevel | null | undefined, mainDepartment?: string | null | undefined, roles?: Array<string> | null | undefined, workShift?: string | null | undefined, optionExploring?: string | null | undefined, billable?: boolean | null | undefined, employeementType?: IFuseEmployeementType | null | undefined, department?: { id?: string | null | undefined, name?: string | null | undefined } | null | undefined } }>, pageable: { page: number, totalPages: number, size: number, totalElements: number } } };

export type IGetAvailabilityListQueryVariables = Exact<{ [key: string]: never; }>;


export type IGetAvailabilityListQuery = { findBenchStatus: Array<{ benchStatus?: Array<string | null | undefined> | null | undefined, benchType?: string | null | undefined }> };

export type IGetSubDepartmentsQueryVariables = Exact<{ [key: string]: never; }>;


export type IGetSubDepartmentsQuery = { getSubDepartments: Array<{ departments: Array<string>, name: string }> };

export type IGetRegionListQueryVariables = Exact<{ [key: string]: never; }>;


export type IGetRegionListQuery = { getRegions: { regions?: Array<string | null | undefined> | null | undefined } };

export type IGetDepartmentListQueryVariables = Exact<{ [key: string]: never; }>;


export type IGetDepartmentListQuery = { getDepartments: Array<{ name: string }> };

export type IGetRoleListQueryVariables = Exact<{ [key: string]: never; }>;


export type IGetRoleListQuery = { findRoles: { roles?: Array<string | null | undefined> | null | undefined } };

export type IGetSkillListQueryVariables = Exact<{ [key: string]: never; }>;


export type IGetSkillListQuery = { findSkills: { skills?: Array<string | null | undefined> | null | undefined } };

export type IGetEngagementLevelQueryVariables = Exact<{ [key: string]: never; }>;


export type IGetEngagementLevelQuery = { findEngagementLevelTypes: { engagementLevel?: Array<string | null | undefined> | null | undefined } };

export type IGetEmployeeLevelQueryVariables = Exact<{ [key: string]: never; }>;


export type IGetEmployeeLevelQuery = { findEmployeeLevelTypes: { employeeLevel?: Array<string | null | undefined> | null | undefined } };

export type IGetClientAndSquadsListQueryVariables = Exact<{
  clientType: Scalars['String'];
}>;


export type IGetClientAndSquadsListQuery = { findClientAndSquads: Array<{ clientName: string, squads?: Array<string | null | undefined> | null | undefined }> };

export type IGetAssignedDevicesQueryVariables = Exact<{ [key: string]: never; }>;


export type IGetAssignedDevicesQuery = { getAssignedDevices: Array<string> };

export type IGetAvailabilityOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type IGetAvailabilityOptionsQuery = { getAvailabilityOptions: Array<{ label?: string | null | undefined, values?: Array<string | null | undefined> | null | undefined }> };

export type IEmployeeListExportToCsvQueryVariables = Exact<{
  exportAll?: Maybe<Scalars['Boolean']>;
  fileFormat: Scalars['String'];
  pageRequest: IPageRequest;
  searchDto: IUserSquadHistoryAdvancedSearchDto;
}>;


export type IEmployeeListExportToCsvQuery = { employeeListExportToCsv: string };

export type IGetFieldHistoryQueryVariables = Exact<{
  fieldHistoryFilter: IFieldHistoryFilterDto;
  pageRequest: IPageRequest;
}>;


export type IGetFieldHistoryQuery = { getFieldHistory: { content: Array<{ _id?: { day?: string | null | undefined, month?: string | null | undefined, year?: string | null | undefined } | null | undefined, changeLog?: Array<{ _id?: string | null | undefined, operationType?: string | null | undefined, createdAt?: string | null | undefined, modifiedBy?: { userId?: string | null | undefined, profileId?: string | null | undefined, name?: string | null | undefined, email?: string | null | undefined, profileImage?: string | null | undefined } | null | undefined, modifications?: { modifiedField?: string | null | undefined, newValue?: string | null | undefined, oldValue?: string | null | undefined } | null | undefined }> | null | undefined }>, pageable: { totalElements: number } } };

export type IBasicInfoFragment = { githubUrl?: string | null | undefined, linkedinUrl?: string | null | undefined, name: string, phoneNumber?: string | null | undefined };

export type IPersonalInfoFragment = { countryOfResidence?: string | null | undefined, timeZone?: string | null | undefined };

export type IBasicAndPersonalInfoFragment = { githubUrl?: string | null | undefined, linkedinUrl?: string | null | undefined, name: string, phoneNumber?: string | null | undefined, countryOfResidence?: string | null | undefined, timeZone?: string | null | undefined };

export type IUpdateBasicInfoMutationVariables = Exact<{
  file?: Maybe<Scalars['Upload']>;
  personalInfoDto: IUpdateBasicInfoDto;
  profileId: Scalars['String'];
  profilePic?: Maybe<Scalars['Upload']>;
}>;


export type IUpdateBasicInfoMutation = { updateBasicInfo: { personalInfo: { githubUrl?: string | null | undefined, linkedinUrl?: string | null | undefined, name: string, phoneNumber?: string | null | undefined } } };

export type IUpdatePersonalInfoMutationVariables = Exact<{
  personalInfoDto: IUpdatePersonalInfoDto;
  profileId: Scalars['String'];
}>;


export type IUpdatePersonalInfoMutation = { updatePersonalInfo: { personalInfo: { countryOfResidence?: string | null | undefined, timeZone?: string | null | undefined } } };

export type IUpdateBasicInfoAndPersonalInfoMutationVariables = Exact<{
  file?: Maybe<Scalars['Upload']>;
  dto: IUpdateBasicInfoDto;
  profileId: Scalars['String'];
  profilePic?: Maybe<Scalars['Upload']>;
  personalInfoDto: IUpdatePersonalInfoDto;
}>;


export type IUpdateBasicInfoAndPersonalInfoMutation = { updateBasicInfoAndPersonalInfo: { personalInfo: { githubUrl?: string | null | undefined, linkedinUrl?: string | null | undefined, name: string, phoneNumber?: string | null | undefined, countryOfResidence?: string | null | undefined, timeZone?: string | null | undefined } } };

export type IUpdateWorkInfoMutationVariables = Exact<{
  workInfoDto: IUpdateWorkInfoDto;
  profileId: Scalars['String'];
}>;


export type IUpdateWorkInfoMutation = { updateWorkInfo: { paymentOption: Array<{ billingAmount?: string | null | undefined, billingType?: string | null | undefined }> } };

export type IUpdateSkillsMutationVariables = Exact<{
  skillDto: ISkillsReqDto;
  profileId: Scalars['String'];
}>;


export type IUpdateSkillsMutation = { updateSkills: { skills?: { mostProficientTechnologies: Array<string>, somewhatProficientTechnologies: Array<string>, softSkills: Array<string> } | null | undefined } };

export type IUpdateWorkExperienceMutationVariables = Exact<{
  workExperience: IWorkExperienceInputDto;
  profileId: Scalars['String'];
}>;


export type IUpdateWorkExperienceMutation = { updateWorkExperience: { experience?: { roles?: Array<string> | null | undefined, yearsOfExperienceInRoles: Array<{ role?: string | null | undefined, yearsOfExperience?: number | null | undefined }> } | null | undefined } };

export type IRemoveSquadHistoryMutationVariables = Exact<{
  squadHistoryId: Scalars['String'];
  userId: Scalars['String'];
}>;


export type IRemoveSquadHistoryMutation = { removeSquadHistory: string };

export type IUpdateEducationMutationVariables = Exact<{
  educationDto: Array<IEducationRequestDto> | IEducationRequestDto;
  profileId: Scalars['String'];
}>;


export type IUpdateEducationMutation = { updateEducation: { education: Array<{ currentlyStudying?: boolean | null | undefined, degree?: string | null | undefined, fieldOfStudy?: string | null | undefined, isEducationFormCompleted?: boolean | null | undefined, levelOfEducation?: string | null | undefined, school?: string | null | undefined, completedOn?: { month: string, year: string } | null | undefined, joinedOn?: { month: string, year: string } | null | undefined }> } };

export type IUpdateJobExperienceMutationVariables = Exact<{
  jobExperienceDto: Array<IJobExperienceInputDto> | IJobExperienceInputDto;
  profileId: Scalars['String'];
}>;


export type IUpdateJobExperienceMutation = { updateJobExperience: { jobExperience?: Array<{ companyName?: string | null | undefined, currentlyEmployed?: boolean | null | undefined, jobLocation?: string | null | undefined, jobTitle?: string | null | undefined, rolesAndResponsibility?: string | null | undefined, jobEndDate?: { month: string, year: string } | null | undefined, jobStartDate?: { month: string, year: string } | null | undefined }> | null | undefined } };

export type IAddTrainingCertificateMutationVariables = Exact<{
  uploads: Array<Scalars['Upload']> | Scalars['Upload'];
  createTrainingCertificateInput: ICreateTrainingCertificateDto;
}>;


export type IAddTrainingCertificateMutation = { addTrainingCertificate: { id: string, certificateId?: string | null | undefined, certificateTitle?: string | null | undefined, currentlyStudying?: boolean | null | undefined, endDate?: any | null | undefined, instructor?: string | null | undefined, issuingInstituionOrOrganization?: string | null | undefined, profileId: string, startDate: any, uploads: Array<{ filename?: string | null | undefined, url?: string | null | undefined }> } };

export type IUpdateTrainingCertificateMutationVariables = Exact<{
  updateTrainingCertificateInput: IUpdateTrainingCertificateDto;
  trainingCertificateId: Scalars['String'];
  uploads: Array<Scalars['Upload']> | Scalars['Upload'];
}>;


export type IUpdateTrainingCertificateMutation = { updateTrainingCertificate: { certificateId?: string | null | undefined, certificateTitle?: string | null | undefined, currentlyStudying?: boolean | null | undefined, endDate?: any | null | undefined, id: string, instructor?: string | null | undefined, issuingInstituionOrOrganization?: string | null | undefined, profileId: string, startDate: any, uploads: Array<{ filename?: string | null | undefined, url?: string | null | undefined }> } };

export type IDeleteTrainingCertificateMutationVariables = Exact<{
  traniningCertificateId: Scalars['String'];
}>;


export type IDeleteTrainingCertificateMutation = { deleteTrainingCertificate: { id: string } };

export type IAddCandidateMutationVariables = Exact<{
  aboutyou: IAboutYouDtoAddCandidate;
  file?: Maybe<Scalars['Upload']>;
  jobdescription?: Maybe<Scalars['Upload']>;
  profileId: Scalars['String'];
}>;


export type IAddCandidateMutation = { addCandidate: { id: string, resumeUrl: string, jobDescriptionUrl: string, email: string, firstName: string, lastName: string, countryOfResidence: string, timeZone?: string | null | undefined, linkedinUrl?: string | null | undefined, githubUrl?: string | null | undefined, phoneNumber?: string | null | undefined, seekingNewRole: boolean, optionExploring: string, startDate: string, originalFilename: string, jobDescriptionFileName: string, paymentOption: Array<{ billingType: string, billingAmount: string }> } };

export type IAddSkillSetMutationVariables = Exact<{
  profileId: Scalars['String'];
  skillset: ISkillsReqDto;
}>;


export type IAddSkillSetMutation = { addSkillSet: { id: string, roles: Array<string>, mostProficientTechnologies: Array<string>, softSkills: Array<string>, somewhatProficientTechnologies: Array<string>, selectedTechnologies: Array<string>, yearsOfExperienceInRole: Array<{ role: string, yearsOfExperience: number }> } };

export type IAddCandidateInterviewEvalMutationVariables = Exact<{
  profileid: Scalars['String'];
  intervieweval: IInterviewEvaluationDto;
  saveAsDraft: Scalars['Boolean'];
}>;


export type IAddCandidateInterviewEvalMutation = { addInterviewEvaluation: { id: string } };

export type IGenerateNewResumeUrlMutationVariables = Exact<{
  profileId: Scalars['String'];
}>;


export type IGenerateNewResumeUrlMutation = { generateNewResumeUrl: string };

export type IRemoveResumeUrlMutationVariables = Exact<{
  fileType: Scalars['String'];
  profileId: Scalars['String'];
}>;


export type IRemoveResumeUrlMutation = { removeResumeUrl: string };

export type ICreateUpdateAssignedDevicesMutationVariables = Exact<{
  AssignedDevicesDto: IAssignedDevicesDto;
}>;


export type ICreateUpdateAssignedDevicesMutation = { createOrUpdateAssignedDevices: { _id?: string | null | undefined, deviceName?: string | null | undefined, userId?: string | null | undefined, profileId?: string | null | undefined, assignedDate?: any | null | undefined, deviceDescription: string, deviceCode: string } };

export type IRemoveAssignedDevicesMutationVariables = Exact<{
  assignedDeviceId: Scalars['String'];
}>;


export type IRemoveAssignedDevicesMutation = { removeAssignedDevices: string };

export type IInviteToSquaderyConnectMutationVariables = Exact<{
  userId: Scalars['String'];
}>;


export type IInviteToSquaderyConnectMutation = { inviteToSquaderyConnect: string };

export type IOnBoardOffBoardInSquadMutationVariables = Exact<{
  onboardOffboardDto: IOnboardOffboardDto;
  moveDto?: Maybe<IMoveDto>;
  newResume?: Maybe<Scalars['Upload']>;
  squadResourceInputDto?: Maybe<ISquadResourceInputDto>;
}>;


export type IOnBoardOffBoardInSquadMutation = { onboardOrOffboardInSquad: string };

export type IUpdateInvolvementhistoryMutationVariables = Exact<{
  editedHistory?: Maybe<Scalars['Float']>;
  involvementHistory: IInvolvementHistoryInput;
  ushId: Scalars['String'];
}>;


export type IUpdateInvolvementhistoryMutation = { updateInvolvementHistory: string };

export type ICreateOrUpdateWorkExperienceMutationVariables = Exact<{
  workExperienceDTO: ICreateWorkExperienceInput;
}>;


export type ICreateOrUpdateWorkExperienceMutation = { createOrUpdateWorkExperience: { company?: string | null | undefined, companyAddress?: string | null | undefined, profileId: string, userId: string, workExperienceId?: string | null | undefined, workHistory: Array<{ details?: string | null | undefined, endDate?: any | null | undefined, jobTitle: string, role: string, startDate: any, workHistoryId?: string | null | undefined }> } };

export type ICreateOverAllExperienceAndRelevantExperienceMutationVariables = Exact<{
  experience: IOverallAndRelevantExperienceDto;
}>;


export type ICreateOverAllExperienceAndRelevantExperienceMutation = { createOverAllExperienceAndRelevantExperience: { userId: string } };

export type ICreateEmployeeMutationVariables = Exact<{
  file: Scalars['Upload'];
  user: IUserUploadInputDto;
}>;


export type ICreateEmployeeMutation = { createEmployee: { profileId: string, userId: string } };

export type IFetchEmployeeProfileQueryVariables = Exact<{
  userId: Scalars['String'];
  squadRoleId?: Maybe<Scalars['String']>;
}>;


export type IFetchEmployeeProfileQuery = { getEmployeePersonalInfoByUserId: { userId: string, profileId?: string | null | undefined, invitedToConnect?: boolean | null | undefined, availableSince?: any | null | undefined, squadStatus?: IInvolvementStatus | null | undefined, employeeActiveStatus?: string | null | undefined, relevantExperience?: { month?: string | null | undefined, year?: string | null | undefined } | null | undefined, overAllExperience?: { month?: string | null | undefined, year?: string | null | undefined } | null | undefined, personalInfo: { resignDate?: any | null | undefined, region?: string | null | undefined, availabilityStatus?: string | null | undefined, countryOfResidence?: string | null | undefined, email: string, filename?: string | null | undefined, joinedDate?: any | null | undefined, name: string, phoneNumber?: string | null | undefined, resumeUrl?: string | null | undefined, role?: string | null | undefined, timeZone?: string | null | undefined, githubUrl?: string | null | undefined, linkedinUrl?: string | null | undefined, profileImage?: string | null | undefined, resumeUpdatedDate?: any | null | undefined, gender?: IGender | null | undefined, availability?: { availabiltyForWork?: string | null | undefined, hoursPerweek?: number | null | undefined, isAvailable?: string | null | undefined, startDate?: string | null | undefined, currentSalary?: { amount?: string | null | undefined, duration?: string | null | undefined, salaryType?: string | null | undefined } | null | undefined } | null | undefined }, supervisors?: Array<{ email?: string | null | undefined, fullname?: string | null | undefined, designationName?: string | null | undefined, departmentName?: string | null | undefined, _id?: string | null | undefined } | null | undefined> | null | undefined, experience?: { roles?: Array<string> | null | undefined, yearsOfExperienceInRoles: Array<{ role?: string | null | undefined, yearsOfExperience?: number | null | undefined }> } | null | undefined, paymentOption: Array<{ billingAmount?: string | null | undefined, billingType?: string | null | undefined }>, skills?: { mostProficientTechnologies: Array<string>, softSkills: Array<string>, somewhatProficientTechnologies: Array<string> } | null | undefined, squads: Array<{ clientType?: string | null | undefined, createdFromHubspot?: boolean | null | undefined, squadId: string, squadHistoryId?: string | null | undefined, squadName?: string | null | undefined, joinedDate?: any | null | undefined, squadType?: string | null | undefined, endDate?: any | null | undefined, involvedAs?: string | null | undefined, involvementStatus?: string | null | undefined, clientId: string, clientName: string, roleInSquad?: string | null | undefined, employeeBillingRate?: number | null | undefined, clientBillingRate?: number | null | undefined, jobType?: IJobTypeEnum | null | undefined, ticketId?: string | null | undefined, allocatedHours?: number | null | undefined, squadRoleId?: string | null | undefined, involvementHistoryId?: string | null | undefined, squadHistoryIds?: Array<string> | null | undefined, involvementHistory?: Array<{ _id?: string | null | undefined, role?: string | null | undefined, involvedAs?: IInvolvedAs | null | undefined, involvementStatus?: IInvolvementStatus | null | undefined, jobType?: IJobTypeEnum | null | undefined, modifiedBy?: string | null | undefined, modifiedOn?: any | null | undefined, joinedDate?: any | null | undefined, endDate?: any | null | undefined, allocatedHours: number, note?: string | null | undefined }> | null | undefined, additionalNotes?: Array<{ createdAt?: any | null | undefined, id?: string | null | undefined, note?: string | null | undefined, noteType?: string | null | undefined, involvementHistoryId?: string | null | undefined, status?: string | null | undefined, modifications?: Array<{ modifiedField: string, newValue: string, oldValue: string } | null | undefined> | null | undefined, createdByUserInfo?: { email: string, fullname: string, profileId: string, profileImage?: string | null | undefined, userId: string } | null | undefined } | null | undefined> | null | undefined }>, jobExperience?: Array<{ companyName?: string | null | undefined, currentlyEmployed?: boolean | null | undefined, jobLocation?: string | null | undefined, jobTitle?: string | null | undefined, rolesAndResponsibility?: string | null | undefined, jobEndDate?: { month: string, year: string } | null | undefined, jobStartDate?: { month: string, year: string } | null | undefined }> | null | undefined, education: Array<{ currentlyStudying?: boolean | null | undefined, degree?: string | null | undefined, fieldOfStudy?: string | null | undefined, isEducationFormCompleted?: boolean | null | undefined, levelOfEducation?: string | null | undefined, school?: string | null | undefined, completedOn?: { month: string, year: string } | null | undefined, joinedOn?: { month: string, year: string } | null | undefined }>, assignedDevices?: Array<{ assignedDate?: any | null | undefined, _id?: string | null | undefined, deviceCode: string, deviceDescription: string, deviceName?: string | null | undefined }> | null | undefined, certificates?: Array<{ certificateID?: string | null | undefined, certificateTitle?: string | null | undefined, currentlyStudying?: boolean | null | undefined, isCertificateFormCompleted?: boolean | null | undefined, issuingInstitutionOrganization?: string | null | undefined, url?: string | null | undefined, completedOn?: { month: string, year: string } | null | undefined, joinedOn?: { month: string, year: string } | null | undefined }> | null | undefined, workExperience?: Array<{ company?: string | null | undefined, companyAddress?: string | null | undefined, profileId: string, userId: string, workExperienceId?: string | null | undefined, workHistory: Array<{ details?: string | null | undefined, endDate?: any | null | undefined, role: string, jobTitle: string, startDate: any, workHistoryId?: string | null | undefined }> }> | null | undefined, currentSquads: Array<{ allocatedHours?: number | null | undefined, clientId: string, clientName: string, involvedAs?: string | null | undefined, involvementStatus?: string | null | undefined, jobType?: IJobTypeEnum | null | undefined, squadId: string, squadName?: string | null | undefined }>, currentWorkInfo: { deploymentStatus?: IDeploymentStatus | null | undefined, designation?: string | null | undefined, employeeId?: string | null | undefined, jobType?: string | null | undefined, level?: IEmployeeLevel | null | undefined, mainDepartment?: string | null | undefined, roles?: Array<string> | null | undefined, workShift?: string | null | undefined, optionExploring?: string | null | undefined, employeementType?: IFuseEmployeementType | null | undefined, billable?: boolean | null | undefined, department?: { id?: string | null | undefined, name?: string | null | undefined } | null | undefined } } };

export type IFetchTimeZoneQueryVariables = Exact<{ [key: string]: never; }>;


export type IFetchTimeZoneQuery = { getTimeZones: Array<string> };

export type IFetchCountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type IFetchCountriesQuery = { getCountries: Array<{ name: string }> };

export type IFetchDepartmentsQueryVariables = Exact<{ [key: string]: never; }>;


export type IFetchDepartmentsQuery = { getDepartments: Array<{ name: string, id: string }> };

export type IFetchDesignationsQueryVariables = Exact<{ [key: string]: never; }>;


export type IFetchDesignationsQuery = { getDesignations: Array<{ name?: string | null | undefined, id?: string | null | undefined, grade?: number | null | undefined }> };

export type IFetchSquadsQueryVariables = Exact<{ [key: string]: never; }>;


export type IFetchSquadsQuery = { getSquads: Array<{ name: string, id: string }> };

export type IFetchAllRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type IFetchAllRolesQuery = { getAllRoles: Array<{ type: string }> };

export type IFetchSkillsQueryVariables = Exact<{ [key: string]: never; }>;


export type IFetchSkillsQuery = { getSkills: Array<string> };

export type IFetchSoftSkillsQueryVariables = Exact<{ [key: string]: never; }>;


export type IFetchSoftSkillsQuery = { getSoftSkills: Array<string> };

export type IFetchRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type IFetchRolesQuery = { getRoles: Array<string> };

export type IFindProfileSquadRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type IFindProfileSquadRolesQuery = { findProfileSquadRoles: Array<string> };

export type IFetchRolesWithCandidateCountQueryVariables = Exact<{ [key: string]: never; }>;


export type IFetchRolesWithCandidateCountQuery = { getRolesWithCandidateCount: Array<{ role: string, numberOfCandidates: number }> };

export type IFetchRolesByTypesQueryVariables = Exact<{
  types: Scalars['String'];
}>;


export type IFetchRolesByTypesQuery = { getRolesByTypes: Array<{ roleTags: Array<string>, type: string }> };

export type IFetchAssessmentsQueryVariables = Exact<{ [key: string]: never; }>;


export type IFetchAssessmentsQuery = { getAssessments: Array<string> };

export type IFetchCountriesAddCandidateQueryVariables = Exact<{ [key: string]: never; }>;


export type IFetchCountriesAddCandidateQuery = { getCountriesAddCandidate: Array<string> };

export type IFetchTimeZonesAddCandidateQueryVariables = Exact<{ [key: string]: never; }>;


export type IFetchTimeZonesAddCandidateQuery = { getTimeZonesAddCandidate: Array<string> };

export type IFetchCandidatesQueryVariables = Exact<{
  candidateAdvancedSearchDto: ICandidateAdvancedSearchDto;
}>;


export type IFetchCandidatesQuery = { getCandidates: { totalPages: number, candidates: Array<{ firstName?: string | null | undefined, lastName?: string | null | undefined, candidateStatus?: ICandidateStatus | null | undefined, countryOfResidence?: string | null | undefined, dateAdded: any, email?: string | null | undefined, githubUrl?: string | null | undefined, id: string, phoneNumber?: string | null | undefined, resumeUrl?: string | null | undefined, seekingNewRole?: boolean | null | undefined, startDate?: any | null | undefined, roles?: Array<string> | null | undefined, originalFilename?: string | null | undefined }> } };

export type IFetchProfileInfoQueryVariables = Exact<{
  profileId: Scalars['String'];
}>;


export type IFetchProfileInfoQuery = { getCandidateInfo: { id: string, originalFilename: string, resumeUrl: string, jobDescriptionFileName: string, jobDescriptionUrl: string, email: string, firstName: string, lastName: string, countryOfResidence: string, timeZone?: string | null | undefined, linkedinUrl?: string | null | undefined, githubUrl?: string | null | undefined, phoneNumber?: string | null | undefined, seekingNewRole: boolean, optionExploring: string, startDate: string, paymentOption: Array<{ billingType: string, billingAmount: string }>, skillsSet: { roles: Array<string>, selectedTechnologies: Array<string>, mostProficientTechnologies: Array<string>, softSkills: Array<string>, somewhatProficientTechnologies: Array<string>, yearsOfExperienceInRole: Array<{ role: string, yearsOfExperience: number }> }, intervieweval: { assignedAssessments: Array<string>, isGoodTeamPlayer: string, recentCoachableMoment: string, candidateEnthusiam: number, candidateLearning: number, candidateCommunication: number, clientProjectsExperience: number, candidateQuestionStrength: number, candidatePreparation: string, squaderyUnderstanding: string } } };

export type IFetchClientListQueryVariables = Exact<{ [key: string]: never; }>;


export type IFetchClientListQuery = { getClientList: Array<{ id: string, name: string }> };

export type IFetchSquadListByClientIdQueryVariables = Exact<{
  clientId: Scalars['String'];
}>;


export type IFetchSquadListByClientIdQuery = { getSquadListByClientId: Array<{ id: string, name: string }> };

export type IGetAllEmployeeSkillsQueryVariables = Exact<{ [key: string]: never; }>;


export type IGetAllEmployeeSkillsQuery = { getAllEmployeeSkills: Array<string> };

export type IFetchInvolvementHistoryQueryVariables = Exact<{
  ushId: Scalars['String'];
}>;


export type IFetchInvolvementHistoryQuery = { getInvolvementHistory: Array<{ endDate?: any | null | undefined, involvedAs?: IInvolvedAs | null | undefined, jobType?: IJobTypeEnum | null | undefined, joinedDate?: any | null | undefined }> };

export type IFetchAllVerticalsQueryVariables = Exact<{ [key: string]: never; }>;


export type IFetchAllVerticalsQuery = { getAllVerticals: Array<{ name?: string | null | undefined, id?: string | null | undefined }> };

export type IFetchAllVerticalIndustryQueryVariables = Exact<{ [key: string]: never; }>;


export type IFetchAllVerticalIndustryQuery = { getAllVerticalIndustry: Array<{ name?: string | null | undefined }> };

export type IFetchAllVerticalHeadsQueryVariables = Exact<{ [key: string]: never; }>;


export type IFetchAllVerticalHeadsQuery = { getAllVerticalHeads: Array<{ id?: string | null | undefined, verticalLeadName?: string | null | undefined }> };

export type IFetchGetAllVerticalIndustryByVerticalIdQueryVariables = Exact<{
  verticalId: Scalars['String'];
}>;


export type IFetchGetAllVerticalIndustryByVerticalIdQuery = { getAllVerticalIndustryByVerticalId: Array<{ name?: string | null | undefined, industryId?: string | null | undefined }> };

export type IFetchGetMainDepartmentAndSubDepartmentsQueryVariables = Exact<{ [key: string]: never; }>;


export type IFetchGetMainDepartmentAndSubDepartmentsQuery = { getMainDepartmentAndSubDepartments: Array<{ mainDepartmentId: string, mainDepartmentName: string, subDepartments?: Array<{ id: string, name?: string | null | undefined } | null | undefined> | null | undefined }> };

export type IFindAllTrainingCertificatesByProfileIdQueryVariables = Exact<{
  profileId: Scalars['String'];
}>;


export type IFindAllTrainingCertificatesByProfileIdQuery = { findAllTrainingCertificatesByProfileId: Array<{ certificateId?: string | null | undefined, certificateTitle?: string | null | undefined, currentlyStudying?: boolean | null | undefined, endDate?: any | null | undefined, id: string, instructor?: string | null | undefined, issuingInstituionOrOrganization?: string | null | undefined, profileId: string, startDate: any, uploads: Array<{ filename?: string | null | undefined, url?: string | null | undefined }> }> };

export type IGetDepartmentByLevelQueryVariables = Exact<{
  level: IDepartmentLevel;
}>;


export type IGetDepartmentByLevelQuery = { getDepartmentByLevel: Array<{ name?: string | null | undefined, id?: string | null | undefined, level?: IDepartmentLevel | null | undefined, parentId?: string | null | undefined }> };

export type IGetEmailExistsQueryVariables = Exact<{
  email: Scalars['String'];
}>;


export type IGetEmailExistsQuery = { emailExists: boolean };

export type IJobsFragment = { experienceLevel: IExperienceLevel, id: string, jobCode: string, jobDescription?: string | null | undefined, title?: string | null | undefined, location?: Array<string> | null | undefined, newResumes?: number | null | undefined, totalResumes?: number | null | undefined, squadId?: string | null | undefined };

export type IResumeImportLogFragment = { id: string, jobId: string, filterTestUsers: boolean, roleAndLevel: Array<{ role: string, levelAndCount: Array<{ level: string, count: number }> }> };

export type IParseResumeFragment = { candidateStatus?: string | null | undefined, candidateStageStatus?: string | null | undefined, address?: string | null | undefined, region?: string | null | undefined, linkedinUrl?: string | null | undefined, githubUrl?: string | null | undefined, batchId?: string | null | undefined, createdAt?: any | null | undefined, email?: Array<string | null | undefined> | null | undefined, firstName?: string | null | undefined, id: string, jobId?: string | null | undefined, userId?: string | null | undefined, lastName?: string | null | undefined, latestEmployer?: string | null | undefined, middleName?: string | null | undefined, phone?: Array<string | null | undefined> | null | undefined, resumeId?: string | null | undefined, resumeSource?: string | null | undefined, resumeUrl?: string | null | undefined, updatedAt?: any | null | undefined, addedBy?: string | null | undefined, yearsOfExperience?: string | null | undefined, noteCount?: number | null | undefined, score?: number | null | undefined, parseStatus?: IParseStatus | null | undefined, remarks?: string | null | undefined, location?: string | null | undefined, skills?: { softSkills?: Array<string | null | undefined> | null | undefined, hardSkills?: Array<{ category?: string | null | undefined, skill?: Array<string> | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type IJobFragment = { experienceLevel: IExperienceLevel, id: string, jobCode: string, jobDescription?: string | null | undefined, jobPriority?: IJobPriority | null | undefined, mustHaveSkills?: Array<string> | null | undefined, goodToHaveSkills?: Array<string> | null | undefined, softSkills?: Array<string> | null | undefined, jobType?: IEmploymentType | null | undefined, location?: Array<string> | null | undefined, numberOfResources?: number | null | undefined, timeZone?: Array<string> | null | undefined, title?: string | null | undefined, billingCycle?: IJobBillingCycle | null | undefined, billingRate?: number | null | undefined, department?: string | null | undefined, squadId?: string | null | undefined, jobStatus: IJobStatus, descriptionTemplateId?: string | null | undefined, minimumBudget?: number | null | undefined, maximumBudget?: number | null | undefined, vertical?: string | null | undefined, industry?: string | null | undefined, horizontal?: string | null | undefined, startDate?: any | null | undefined, endDate?: any | null | undefined, squadStartDate?: any | null | undefined, squadEndDate?: any | null | undefined, yearsOfExperience?: number | null | undefined, locationToBeHiredFrom?: Array<string> | null | undefined };

export type IUploadFileMutationVariables = Exact<{
  file: Scalars['Upload'];
  jobId: Scalars['String'];
  keepBoth: Scalars['Boolean'];
}>;


export type IUploadFileMutation = { uploadFile: { resumeUrl: string, id: string, jobId: string, originalFilename: string, keepBoth?: boolean | null | undefined } };

export type IDeleteUploadedResumeMutationVariables = Exact<{
  resumeId: Scalars['String'];
}>;


export type IDeleteUploadedResumeMutation = { deleteResume: { id: string } };

export type IImportResumesJobMutationVariables = Exact<{
  jobId: Scalars['String'];
  resumeImportDto: IResumeUpdateDto;
  filterTestUsers: Scalars['Boolean'];
}>;


export type IImportResumesJobMutation = { importResumesForJob: { id: string, jobId: string, filterTestUsers: boolean, roleAndLevel: Array<{ role: string, levelAndCount: Array<{ level: string, count: number }> }> } };

export type IDeleteImportResumeMutationVariables = Exact<{
  jobId: Scalars['String'];
}>;


export type IDeleteImportResumeMutation = { deleteResumeImportLogByJobId: string };

export type IDeleteAllUploadedResumeMutationVariables = Exact<{
  jobId: Scalars['String'];
}>;


export type IDeleteAllUploadedResumeMutation = { deleteMultipleResume: string };

export type IDeleteParsedResumeMutationVariables = Exact<{
  parsedResumeReq: IParsedResumeReq;
}>;


export type IDeleteParsedResumeMutation = { deleteParsedResume: string };

export type IUpdateJobStatusMutationVariables = Exact<{
  jobStatusUpdateDto: IJobStatusUpdateDto;
}>;


export type IUpdateJobStatusMutation = { updateJobStatus: { done: boolean, matchedCount: number, modifiedCount: number } };

export type IUpdateResumeDataMutationVariables = Exact<{
  updateParsedResumedDto: IParsedResumeUpdateDto;
}>;


export type IUpdateResumeDataMutation = { updateParsedResume: { batchId?: string | null | undefined, createdAt?: any | null | undefined, middleName?: string | null | undefined, lastName?: string | null | undefined, id: string, jobId?: string | null | undefined, orgId: string, resumeId?: string | null | undefined, resumeSource?: string | null | undefined, resumeUrl?: string | null | undefined, updatedAt?: any | null | undefined, userId?: string | null | undefined, yearsOfExperience?: string | null | undefined, address?: string | null | undefined, firstName?: string | null | undefined, email?: Array<string | null | undefined> | null | undefined, phone?: Array<string | null | undefined> | null | undefined, skills?: { softSkills?: Array<string | null | undefined> | null | undefined, hardSkills?: Array<{ category?: string | null | undefined, skill?: Array<string> | null | undefined } | null | undefined> | null | undefined } | null | undefined } };

export type IDeleteJobByIdMutationVariables = Exact<{
  jobId: Scalars['String'];
}>;


export type IDeleteJobByIdMutation = { deleteJobById: string };

export type IDeleteMultipleResumeByIdsMutationVariables = Exact<{
  resumeIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type IDeleteMultipleResumeByIdsMutation = { deleteMultipleResumeByIds: string };

export type IDeleteSourceParsedResumeMutationVariables = Exact<{
  jobId: Scalars['String'];
}>;


export type IDeleteSourceParsedResumeMutation = { deleteSourceParsedResume: string };

export type IDeleteResumeImportLogByJobIdMutationVariables = Exact<{
  jobId: Scalars['String'];
}>;


export type IDeleteResumeImportLogByJobIdMutation = { deleteResumeImportLogByJobId: string };

export type IDuplicateJobMutationVariables = Exact<{
  jobId: Scalars['String'];
  importCandidates: Scalars['Boolean'];
  enterprisePeopleId: Scalars['String'];
}>;


export type IDuplicateJobMutation = { duplicateJob: { id: string } };

export type IUpdateCandidateStatusMutationVariables = Exact<{
  resumeId: Scalars['String'];
  statusDto: IUpdateCandidateStatusDto;
}>;


export type IUpdateCandidateStatusMutation = { updateCandidateStatus: { candidateStage: IJobCandidateStages, candidateStageStatus: string, jobId: string, parsedResumeId: string, userId?: string | null | undefined } };

export type IMarkJobAsViewedMutationVariables = Exact<{
  jobId: Scalars['String'];
  viewedBy: Scalars['String'];
}>;


export type IMarkJobAsViewedMutation = { markJobAsViewed: { jobId: string, viewedBy: Array<string> } };

export type IUpdateJobMutationVariables = Exact<{
  id: Scalars['String'];
  jobUpdateDto: IJobUpdateDto;
}>;


export type IUpdateJobMutation = { updateJob: { experienceLevel: IExperienceLevel, id: string, jobCode: string, jobDescription?: string | null | undefined, jobPriority?: IJobPriority | null | undefined, mustHaveSkills?: Array<string> | null | undefined, goodToHaveSkills?: Array<string> | null | undefined, softSkills?: Array<string> | null | undefined, jobType?: IEmploymentType | null | undefined, location?: Array<string> | null | undefined, numberOfResources?: number | null | undefined, timeZone?: Array<string> | null | undefined, title?: string | null | undefined, billingCycle?: IJobBillingCycle | null | undefined, billingRate?: number | null | undefined, department?: string | null | undefined, squadId?: string | null | undefined, jobStatus: IJobStatus, descriptionTemplateId?: string | null | undefined, minimumBudget?: number | null | undefined, maximumBudget?: number | null | undefined, vertical?: string | null | undefined, industry?: string | null | undefined, horizontal?: string | null | undefined, startDate?: any | null | undefined, endDate?: any | null | undefined, squadStartDate?: any | null | undefined, squadEndDate?: any | null | undefined, yearsOfExperience?: number | null | undefined, locationToBeHiredFrom?: Array<string> | null | undefined } };

export type ICreateJobDescriptionTemplateMutationVariables = Exact<{
  template: ICreateJobDescriptionTemplate;
}>;


export type ICreateJobDescriptionTemplateMutation = { createJobDescriptionTemplate: { createdBy: string, jobDescription: string, title: string, id?: string | null | undefined } };

export type IAddNoteToCandidateMutationVariables = Exact<{
  createNoteDto: ICreateNoteDto;
}>;


export type IAddNoteToCandidateMutation = { addNoteToCandidate: { candidateId: string, candidateStage?: string | null | undefined, createdBy: string, creatorId: string, jobId: string, note: string, parentId?: string | null | undefined, parsedResumeId: string, noteContext?: string | null | undefined, _id: string } };

export type IUploadDocumentsMutationVariables = Exact<{
  files?: Maybe<Array<Scalars['Upload']> | Scalars['Upload']>;
  parsedResumeId: Scalars['String'];
  uploadedBy: Scalars['String'];
  replaceFile: Scalars['Boolean'];
}>;


export type IUploadDocumentsMutation = { uploadDocuments: { candidateStage: IJobCandidateStages, candidateStageStatus: string, jobId: string, parsedResumeId: string, userId?: string | null | undefined, documents: Array<{ originalFileName: string, docUrl: string, uploadedBy: string, timeStamp: any }> } };

export type IDeleteCandidateDocumentMutationVariables = Exact<{
  docUrl: Scalars['String'];
  parsedResumeId: Scalars['String'];
}>;


export type IDeleteCandidateDocumentMutation = { deleteCandidateDocument: string };

export type IDeleteNoteMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type IDeleteNoteMutation = { deleteNote: string };

export type IUpdateCandidateNoteMutationVariables = Exact<{
  updateNoteDto: IUpdateNoteDto;
}>;


export type IUpdateCandidateNoteMutation = { updateCandidateNote: { _id: string, candidateId: string, candidateStage?: string | null | undefined, createdAt: any, createdBy: string, creatorId: string, jobId: string, note: string, parentId?: string | null | undefined, parsedResumeId: string, updatedAt: any, noteContext?: string | null | undefined } };

export type IUpdateCandidateProfileMutationVariables = Exact<{
  id: Scalars['String'];
  updateCandidateDto: ICandidateInfo;
}>;


export type IUpdateCandidateProfileMutation = { updateCandidateProfile: { address: string, email: Array<string>, firstName: string, id: string, lastName: string, latestEmployer: string, middleName: string, phone: Array<string>, softSkills: Array<string>, technicalSkills: Array<string>, yearsOfExperience: string } };

export type IUnarchiveJobMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type IUnarchiveJobMutation = { unarchiveJob: IJobStatus };

export type IReplaceResumeMutationVariables = Exact<{
  upload: Scalars['Upload'];
  jobId: Scalars['String'];
  resumeId: Scalars['String'];
}>;


export type IReplaceResumeMutation = { replaceResume: { id: string, jobId: string, keepBoth?: boolean | null | undefined, orgId: string, originalFilename: string, resumeUrl: string } };

export type IReparseResumeMutationVariables = Exact<{
  id: Scalars['String'];
  jobUpdateDto: IJobUpdateDto;
}>;


export type IReparseResumeMutation = { reparseResume: string };

export type IRequestGeminiScoringMutationVariables = Exact<{
  data: IMlScoreRequestDto;
}>;


export type IRequestGeminiScoringMutation = { requestGeminiScoring: string };

export type IGetSignedUrlForUploadMutationVariables = Exact<{
  resumeSignedRequest: IResumeSignedUrlRequest;
}>;


export type IGetSignedUrlForUploadMutation = { getSignedUrlForUpload: Array<{ fileName: string, signedUrl: string, filePath: string, isDuplicate: boolean }> };

export type IImportResumesMutationVariables = Exact<{
  jobId: Scalars['String'];
  importResumeRequest: Array<IImportResumeRequest> | IImportResumeRequest;
}>;


export type IImportResumesMutation = { importResumes: string };

export type IGetViewUrlsForResumeMutationVariables = Exact<{
  fileKeys: Array<Scalars['String']> | Scalars['String'];
}>;


export type IGetViewUrlsForResumeMutation = { getViewUrlsForResume: Array<{ key: string, url: string }> };

export type IConvertResumeToPdfMutationVariables = Exact<{
  file: Scalars['Upload'];
}>;


export type IConvertResumeToPdfMutation = { convertResumeToPdf: string };

export type IGetAdvancedSearchQueryVariables = Exact<{
  jobPaginationDto: IJobPaginationDto;
  pageRequest: IPageRequest;
}>;


export type IGetAdvancedSearchQuery = { advancedJobSearch: { content: Array<{ id?: string | null | undefined, createdAt?: any | null | undefined, title?: string | null | undefined, location?: Array<string> | null | undefined, totalResumes?: number | null | undefined, jobStatus?: IJobStatus | null | undefined, newResumes?: number | null | undefined, sources?: Array<string> | null | undefined, createdBy?: string | null | undefined, jobPriority?: IJobPriority | null | undefined, requested?: boolean | null | undefined, candidates?: { active?: number | null | undefined, total?: number | null | undefined, hired?: number | null | undefined } | null | undefined, squadAndClientInfo?: { clientId?: string | null | undefined, clientName?: string | null | undefined, squadId?: string | null | undefined, squadName?: string | null | undefined } | null | undefined }>, pageable: { page: number, size: number, totalElements: number, totalPages: number } } };

export type ISucceededUserFragment = { role: string, levels: Array<{ count: number, level: string }> };

export type IFetchSucceededUsersQueryVariables = Exact<{
  filterTestUsers: Scalars['Boolean'];
}>;


export type IFetchSucceededUsersQuery = { getSucceededUsers: { data: Array<{ role: string, levels: Array<{ count: number, level: string }> }>, levelList: Array<{ label: string, shortForm: string, value: string }> } };

export type IGetJobDetailQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type IGetJobDetailQuery = { jobById: { resumeImportCompleted: boolean, jobStatus: IJobStatus, resumesFromManualSource?: number | null | undefined, resumesFromSquaderyPlatform?: number | null | undefined, resumeParsingStarted?: boolean | null | undefined, totalResumes?: number | null | undefined, newResumes?: number | null | undefined, squadId?: string | null | undefined, enterprisePeopleId?: string | null | undefined, minimumBudget?: number | null | undefined, maximumBudget?: number | null | undefined, vertical?: string | null | undefined, industry?: string | null | undefined, horizontal?: string | null | undefined, startDate?: any | null | undefined, endDate?: any | null | undefined, squadStartDate?: any | null | undefined, squadEndDate?: any | null | undefined, yearsOfExperience?: number | null | undefined, locationToBeHiredFrom?: Array<string> | null | undefined, industryBackground?: string | null | undefined, travelRequirements?: string | null | undefined, typeOfWork?: IType_Of_Work | null | undefined, projectDescription?: string | null | undefined, clientSelectionProcess?: string | null | undefined, evaluationCriteria?: string | null | undefined, previousReasonsForCandidateDisqualification?: string | null | undefined, technicalInterviewPanel?: string | null | undefined, createdAt?: any | null | undefined, clientName?: string | null | undefined, experienceLevel: IExperienceLevel, id: string, jobCode: string, jobDescription?: string | null | undefined, jobPriority?: IJobPriority | null | undefined, mustHaveSkills?: Array<string> | null | undefined, goodToHaveSkills?: Array<string> | null | undefined, softSkills?: Array<string> | null | undefined, jobType?: IEmploymentType | null | undefined, location?: Array<string> | null | undefined, numberOfResources?: number | null | undefined, timeZone?: Array<string> | null | undefined, title?: string | null | undefined, billingCycle?: IJobBillingCycle | null | undefined, billingRate?: number | null | undefined, department?: string | null | undefined, descriptionTemplateId?: string | null | undefined } };

export type IGetResumeImportLogDetailQueryVariables = Exact<{
  jobId: Scalars['String'];
}>;


export type IGetResumeImportLogDetailQuery = { resumeImportLogByJobId: { id: string, jobId: string, filterTestUsers: boolean, roleAndLevel: Array<{ role: string, levelAndCount: Array<{ level: string, count: number }> }> } };

export type IStartParsingResumeQueryVariables = Exact<{
  jobId: Scalars['String'];
}>;


export type IStartParsingResumeQuery = { startResumeParsing: { id: string } };

export type IGetResumeUrlQueryVariables = Exact<{
  resumeId: Scalars['String'];
}>;


export type IGetResumeUrlQuery = { getParsedResumeById: string };

export type IDownloadParsedResumeQueryVariables = Exact<{
  jobId: Scalars['String'];
  parsedResumeIds: Array<Scalars['String']> | Scalars['String'];
  fileType: IFileType;
  exportAll?: Maybe<Scalars['Boolean']>;
}>;


export type IDownloadParsedResumeQuery = { downloadParsedResume: { file: string, fileName: string } };

export type IGetCandidatesByJobIdQueryVariables = Exact<{
  advancedSearchRequest: IAdvancedSearchRequestDto;
  jobId: Scalars['String'];
  pageRequest: IPageRequest;
}>;


export type IGetCandidatesByJobIdQuery = { advancedFilter: { pageable: { page: number, size: number, totalElements: number, totalPages: number }, content: Array<{ candidateStatus?: string | null | undefined, candidateStageStatus?: string | null | undefined, address?: string | null | undefined, region?: string | null | undefined, linkedinUrl?: string | null | undefined, githubUrl?: string | null | undefined, batchId?: string | null | undefined, createdAt?: any | null | undefined, email?: Array<string | null | undefined> | null | undefined, firstName?: string | null | undefined, id: string, jobId?: string | null | undefined, userId?: string | null | undefined, lastName?: string | null | undefined, latestEmployer?: string | null | undefined, middleName?: string | null | undefined, phone?: Array<string | null | undefined> | null | undefined, resumeId?: string | null | undefined, resumeSource?: string | null | undefined, resumeUrl?: string | null | undefined, updatedAt?: any | null | undefined, addedBy?: string | null | undefined, yearsOfExperience?: string | null | undefined, noteCount?: number | null | undefined, score?: number | null | undefined, parseStatus?: IParseStatus | null | undefined, remarks?: string | null | undefined, location?: string | null | undefined, skills?: { softSkills?: Array<string | null | undefined> | null | undefined, hardSkills?: Array<{ category?: string | null | undefined, skill?: Array<string> | null | undefined } | null | undefined> | null | undefined } | null | undefined }> } };

export type IAddResumesQueryVariables = Exact<{
  addResumeRequestDto: IAddResumeRequestDto;
}>;


export type IAddResumesQuery = { addResumes: { jobStatus: IJobStatus, newResumes?: number | null | undefined, resumeImportCompleted: boolean } };

export type IResyncImportJobsQueryVariables = Exact<{ [key: string]: never; }>;


export type IResyncImportJobsQuery = { resyncImportSucceededCandidates: string };

export type IResyncImportForSpecificJobQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type IResyncImportForSpecificJobQuery = { resyncImportForSpecificJob: string };

export type ISetNewResumesToZeroQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type ISetNewResumesToZeroQuery = { setJobNewResumesToZero: { createdAt?: any | null | undefined, experienceLevel: IExperienceLevel, id: string, jobCode: string, jobDescription?: string | null | undefined, jobStatus: IJobStatus, location?: Array<string> | null | undefined, newResumes?: number | null | undefined, orgId: string, resumeImportCompleted: boolean, title?: string | null | undefined, totalPages?: number | null | undefined, totalResumes?: number | null | undefined, updatedAt?: any | null | undefined } };

export type IGetSingleParsedResumeDataQueryVariables = Exact<{
  parsedResumeId: Scalars['String'];
}>;


export type IGetSingleParsedResumeDataQuery = { getSingleParsedResumeData: { candidateStatus?: string | null | undefined, candidateStageStatus?: string | null | undefined, address?: string | null | undefined, region?: string | null | undefined, linkedinUrl?: string | null | undefined, githubUrl?: string | null | undefined, batchId?: string | null | undefined, createdAt?: any | null | undefined, email?: Array<string | null | undefined> | null | undefined, firstName?: string | null | undefined, id: string, jobId?: string | null | undefined, userId?: string | null | undefined, lastName?: string | null | undefined, latestEmployer?: string | null | undefined, middleName?: string | null | undefined, phone?: Array<string | null | undefined> | null | undefined, resumeId?: string | null | undefined, resumeSource?: string | null | undefined, resumeUrl?: string | null | undefined, updatedAt?: any | null | undefined, addedBy?: string | null | undefined, yearsOfExperience?: string | null | undefined, noteCount?: number | null | undefined, score?: number | null | undefined, parseStatus?: IParseStatus | null | undefined, remarks?: string | null | undefined, location?: string | null | undefined, skills?: { softSkills?: Array<string | null | undefined> | null | undefined, hardSkills?: Array<{ category?: string | null | undefined, skill?: Array<string> | null | undefined } | null | undefined> | null | undefined } | null | undefined } };

export type IGetCandidateStageCountQueryVariables = Exact<{
  advancedSearchRequest: IAdvancedSearchRequestDto;
  jobId: Scalars['String'];
  pageRequest: IPageRequest;
}>;


export type IGetCandidateStageCountQuery = { getCandidateStageCount: Array<{ count: number, stage: string }> };

export type IGetEnterprisePeopleQueryVariables = Exact<{
  enterprisePeopleId: Scalars['String'];
}>;


export type IGetEnterprisePeopleQuery = { getEnterprisePeople: { id: string, firstName: string, lastName: string, clientEmail: string, roles: Array<string> } };

export type IGetJobCreatorsQueryVariables = Exact<{ [key: string]: never; }>;


export type IGetJobCreatorsQuery = { getJobCreators: Array<{ id: string, firstName: string, lastName?: string | null | undefined }> };

export type IGetNewRequestedJobsQueryVariables = Exact<{
  enterprisePeopleId: Scalars['String'];
}>;


export type IGetNewRequestedJobsQuery = { getNewRequestedJobs: Array<{ jobId: string, viewedBy: Array<string> }> };

export type IShowCandidateProfileQueryVariables = Exact<{
  parsedResumeId: Scalars['String'];
}>;


export type IShowCandidateProfileQuery = { showCandidateProfile: { jobDescription: string, resumeUrl: string } };

export type ICandidateProfileInfoQueryVariables = Exact<{
  parsedResumeId: Scalars['String'];
}>;


export type ICandidateProfileInfoQuery = { candidateProfileInfo: { candidateStage: IJobCandidateStages, candidateStageStatus: string, email: Array<string>, firstName: string, lastName: string, phoneNumber: Array<string>, score: number, middleName: string } };

export type IFindParsedResumesForProfileQueryVariables = Exact<{
  advancedSearchRequest: IAdvancedSearchRequestDto;
  jobId: Scalars['String'];
  pageRequest: IPageRequest;
}>;


export type IFindParsedResumesForProfileQuery = { findParsedResumesForProfile: Array<string> };

export type IGetCandidateSkillsForJobQueryVariables = Exact<{
  jobId: Scalars['String'];
}>;


export type IGetCandidateSkillsForJobQuery = { getCandidateSkillsForJob: Array<string> };

export type IGetJobDescriptionTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type IGetJobDescriptionTemplatesQuery = { getJobDescriptionTemplates: Array<{ createdBy: string, id?: string | null | undefined, jobDescription: string, title: string }> };

export type IGetCandidateNotesQueryVariables = Exact<{
  parentId: Scalars['String'];
  parsedResumeId: Scalars['String'];
  viewedBy: Scalars['String'];
}>;


export type IGetCandidateNotesQuery = { getCandidateNotes: Array<{ _id: string, candidateId: string, candidateStage?: string | null | undefined, createdBy: string, creatorId: string, jobId: string, note: string, parentId?: string | null | undefined, parsedResumeId: string, createdAt: any, updatedAt: any, replyCount: number, visibility: INoteVisibility, noteContext?: string | null | undefined }> };

export type IGetJobCreatorDetailsQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type IGetJobCreatorDetailsQuery = { getJobCreatorDetails: { email: string, id: string, fullname: string, roles: Array<string> } };

export type IGetCandidateDocumentsQueryVariables = Exact<{
  parsedResumeId: Scalars['String'];
  searchquery: Scalars['String'];
}>;


export type IGetCandidateDocumentsQuery = { getCandidateDocuments: Array<{ originalFileName: string, docUrl: string, uploadedBy: string, timeStamp: any }> };

export type IGetDocumentUrlQueryVariables = Exact<{
  docUrl: Scalars['String'];
}>;


export type IGetDocumentUrlQuery = { getDocumentUrl: string };

export type IGetCandidateProfileFromResumeQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type IGetCandidateProfileFromResumeQuery = { getCandidateProfileFromResume: { address: string, email: Array<string>, firstName: string, id: string, resumeUrl?: string | null | undefined, lastName: string, latestEmployer: string, middleName: string, phone: Array<string>, softSkills: Array<string>, technicalSkills: Array<string>, yearsOfExperience: string } };

export type IGetHiringContributorsQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type IGetHiringContributorsQuery = { getHiringContributors: Array<{ email: string, fullname?: string | null | undefined, id: string, isCreator: boolean, designation?: string | null | undefined }> };

export type IGetAllEnterpriseUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type IGetAllEnterpriseUsersQuery = { getAllEnterpriseUsers: Array<{ email: string, fullname: string, id: string, designation: string }> };

export type IGetTaggableUsersForJobQueryVariables = Exact<{
  jobId: Scalars['String'];
}>;


export type IGetTaggableUsersForJobQuery = { getTaggableUsersForJob: Array<{ fullname: string, id: string }> };

export type IGetRegionForRthQueryVariables = Exact<{
  selectedLocations?: Maybe<Array<Scalars['String']> | Scalars['String']>;
  selectedRegions?: Maybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type IGetRegionForRthQuery = { getRegionForRTH: Array<{ key: string, value: Array<string> }> };

export type IUniqueLocationsAndRegionsByJobIdQueryVariables = Exact<{
  jobId: Scalars['String'];
  selectedLocations?: Maybe<Array<Scalars['String']> | Scalars['String']>;
  selectedRegions?: Maybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type IUniqueLocationsAndRegionsByJobIdQuery = { uniqueLocationsAndRegionsByJobId: Array<{ key: string, value: Array<string> }> };

export type IUniqueAddedByQueryVariables = Exact<{
  jobId: Scalars['String'];
}>;


export type IUniqueAddedByQuery = { uniqueAddedBy: Array<string> };

export type IOtpLoginMutationVariables = Exact<{
  otpLoginArgs: IOtpLoginArgsDto;
}>;


export type IOtpLoginMutation = { otpLogin: { message?: string | null | undefined, sessionToken?: string | null | undefined, accessToken?: string | null | undefined, expiresIn?: string | null | undefined, idToken?: string | null | undefined, refreshToken?: string | null | undefined, tokenType?: string | null | undefined, resendTimer?: string | null | undefined, clientIdsEncoded?: string | null | undefined, userInfo?: { email?: string | null | undefined, id?: string | null | undefined, name?: string | null | undefined } | null | undefined, clientInfo?: { id?: string | null | undefined, name?: string | null | undefined, status?: string | null | undefined } | null | undefined } };

export type IVerifyOtpMutationVariables = Exact<{
  verfiyOtpArgs: IVerfiyOtpArgsDto;
}>;


export type IVerifyOtpMutation = { verifyOtp: { accessToken?: string | null | undefined, idToken?: string | null | undefined, message?: string | null | undefined, tokenType?: string | null | undefined, refreshToken?: string | null | undefined, expiresIn?: string | null | undefined, clientIdsEncoded?: string | null | undefined, userInfo?: { email?: string | null | undefined, id?: string | null | undefined, name?: string | null | undefined } | null | undefined, clientInfo?: { id?: string | null | undefined, name?: string | null | undefined, status?: string | null | undefined } | null | undefined } };

export type IResyncResumeParsingQueryVariables = Exact<{
  parsedResumeReq: IParsedResumeReq;
}>;


export type IResyncResumeParsingQuery = { resyncResumeParsing: string };

export type IGetCandidateSuitabilityScoreQueryVariables = Exact<{
  parsedResumeId: Scalars['String'];
}>;


export type IGetCandidateSuitabilityScoreQuery = { getCandidateSuitabilityScore: { finalScore: number, latestEmployer?: string | null | undefined, rating?: string | null | undefined, summary?: string | null | undefined, workExperienceCategory?: string | null | undefined, yearsOfExperience?: number | null | undefined, domainRoleMatchScore: { category?: string | null | undefined, comment?: any | null | undefined, score?: number | null | undefined, scoreRange?: string | null | undefined, summary?: string | null | undefined, evidence?: Array<{ company?: string | null | undefined }> | null | undefined }, experienceScore: { category?: string | null | undefined, comment?: any | null | undefined, score?: number | null | undefined, scoreRange?: string | null | undefined, summary?: string | null | undefined, evidence?: Array<{ company?: string | null | undefined, role?: string | null | undefined, seniority?: string | null | undefined, responsibilities?: Array<string> | null | undefined, startDate?: string | null | undefined, endDate?: string | null | undefined, technologyUsed?: Array<string> | null | undefined, domain?: string | null | undefined }> | null | undefined }, regionMatchScore?: { category?: string | null | undefined, comment?: any | null | undefined, score?: number | null | undefined, scoreRange?: string | null | undefined, summary?: string | null | undefined, evidence?: Array<{ company?: string | null | undefined, role?: string | null | undefined, seniority?: string | null | undefined, responsibilities?: Array<string> | null | undefined, startDate?: string | null | undefined, endDate?: string | null | undefined, technologyUsed?: Array<string> | null | undefined, domain?: string | null | undefined }> | null | undefined } | null | undefined, roleMatchScore: { category?: string | null | undefined, comment?: any | null | undefined, score?: number | null | undefined, scoreRange?: string | null | undefined, summary?: string | null | undefined, evidence?: Array<{ company?: string | null | undefined, role?: string | null | undefined, seniority?: string | null | undefined, responsibilities?: Array<string> | null | undefined, startDate?: string | null | undefined, endDate?: string | null | undefined, technologyUsed?: Array<string> | null | undefined, domain?: string | null | undefined }> | null | undefined }, technicalSkillScore: { category?: string | null | undefined, comment?: any | null | undefined, score?: number | null | undefined, scoreRange?: string | null | undefined, summary?: string | null | undefined, evidence?: Array<{ company?: string | null | undefined, role?: string | null | undefined, seniority?: string | null | undefined, responsibilities?: Array<string> | null | undefined, startDate?: string | null | undefined, endDate?: string | null | undefined, technologyUsed?: Array<string> | null | undefined, domain?: string | null | undefined }> | null | undefined } } };

export type IGetResumeScoresSummaryQueryVariables = Exact<{
  input: IGetResumeScoresInput;
}>;


export type IGetResumeScoresSummaryQuery = { getResumeScoresSummary: Array<{ consCount: number, parsedResumeId: string, prosCount: number, resumeId: string, customScore?: number | null | undefined }> };

export type IGetLatestResumeScoreQueryVariables = Exact<{
  parsedResumeId: Scalars['String'];
}>;


export type IGetLatestResumeScoreQuery = { getLatestResumeScore?: { candidateCons?: Array<string> | null | undefined, candidatePros?: Array<string> | null | undefined, candidateDescription?: string | null | undefined, customScore?: number | null | undefined, resumeClassificationReasoning?: string | null | undefined } | null | undefined };

export type INoteFragmentFragment = { createdAt?: any | null | undefined, id?: string | null | undefined, note?: string | null | undefined, noteType?: string | null | undefined, involvementHistoryId?: string | null | undefined, status?: string | null | undefined, modifications?: Array<{ modifiedField: string, newValue: string, oldValue: string } | null | undefined> | null | undefined, createdByUserInfo?: { email: string, fullname: string, profileId: string, profileImage?: string | null | undefined, userId: string } | null | undefined };

export type IColumnOrderFragmentFragment = { columnName: string, isPinned: boolean, isVisible: boolean, columnWidth: number };

export type ITableOrderFragmentFragment = { userId: string, tableMetadata?: { employeeListOrder?: Array<{ columnName: string, isPinned: boolean, isVisible: boolean, columnWidth: number }> | null | undefined, clientListOrder?: Array<{ columnName: string, isPinned: boolean, isVisible: boolean, columnWidth: number }> | null | undefined, cmSquadListOrder?: Array<{ columnName: string, isPinned: boolean, isVisible: boolean, columnWidth: number }> | null | undefined, addResourceListOrder?: Array<{ columnName: string, isPinned: boolean, isVisible: boolean, columnWidth: number }> | null | undefined, assignedResourcesOrder?: Array<{ columnName: string, isPinned: boolean, isVisible: boolean, columnWidth: number }> | null | undefined, squadListOrder?: Array<{ columnName: string, isPinned: boolean, isVisible: boolean, columnWidth: number }> | null | undefined, worklogDataListOrder?: Array<{ columnName: string, isPinned: boolean, isVisible: boolean, columnWidth: number }> | null | undefined, requiredResourcesOrder?: Array<{ columnName: string, isPinned: boolean, isVisible: boolean, columnWidth: number }> | null | undefined, jobCandidateList?: Array<{ columnName: string, isPinned: boolean, isVisible: boolean, columnWidth: number }> | null | undefined, jobListOrder?: Array<{ columnName: string, isPinned: boolean, isVisible: boolean, columnWidth: number }> | null | undefined, completedSquadListOrder?: Array<{ columnName: string, isPinned: boolean, isVisible: boolean, columnWidth: number }> | null | undefined, notRunningSquadListOrder?: Array<{ columnName: string, isPinned: boolean, isVisible: boolean, columnWidth: number }> | null | undefined } | null | undefined };

export type ISaveListOrderMutationVariables = Exact<{
  listType: IOrderableListEnum;
  listOrder: Array<IColumnMetadataInput> | IColumnMetadataInput;
}>;


export type ISaveListOrderMutation = { saveListOrder: { userId: string, tableMetadata?: { employeeListOrder?: Array<{ columnName: string, isPinned: boolean, isVisible: boolean, columnWidth: number }> | null | undefined, clientListOrder?: Array<{ columnName: string, isPinned: boolean, isVisible: boolean, columnWidth: number }> | null | undefined, cmSquadListOrder?: Array<{ columnName: string, isPinned: boolean, isVisible: boolean, columnWidth: number }> | null | undefined, addResourceListOrder?: Array<{ columnName: string, isPinned: boolean, isVisible: boolean, columnWidth: number }> | null | undefined, assignedResourcesOrder?: Array<{ columnName: string, isPinned: boolean, isVisible: boolean, columnWidth: number }> | null | undefined, squadListOrder?: Array<{ columnName: string, isPinned: boolean, isVisible: boolean, columnWidth: number }> | null | undefined, worklogDataListOrder?: Array<{ columnName: string, isPinned: boolean, isVisible: boolean, columnWidth: number }> | null | undefined, requiredResourcesOrder?: Array<{ columnName: string, isPinned: boolean, isVisible: boolean, columnWidth: number }> | null | undefined, jobCandidateList?: Array<{ columnName: string, isPinned: boolean, isVisible: boolean, columnWidth: number }> | null | undefined, jobListOrder?: Array<{ columnName: string, isPinned: boolean, isVisible: boolean, columnWidth: number }> | null | undefined, completedSquadListOrder?: Array<{ columnName: string, isPinned: boolean, isVisible: boolean, columnWidth: number }> | null | undefined, notRunningSquadListOrder?: Array<{ columnName: string, isPinned: boolean, isVisible: boolean, columnWidth: number }> | null | undefined } | null | undefined } };

export type IValidateUserBulkUploadMutationVariables = Exact<{
  file: Scalars['Upload'];
}>;


export type IValidateUserBulkUploadMutation = { validateUserBulkUpload: { invalidData?: Array<{ country?: string | null | undefined, department?: string | null | undefined, designation?: string | null | undefined, email?: string | null | undefined, employeementType?: string | null | undefined, employeeId?: string | null | undefined, gender?: string | null | undefined, grade?: number | null | undefined, jobType?: string | null | undefined, joinedDate?: any | null | undefined, mostProficientSkills?: Array<string> | null | undefined, name?: string | null | undefined, phoneNumber?: string | null | undefined, role?: string | null | undefined, shift?: string | null | undefined, softSkills?: Array<string> | null | undefined, somewhatProficientSkills?: Array<string> | null | undefined, timezone?: string | null | undefined, level?: IEmployeeLevel | null | undefined, errors?: Array<{ fieldName: string, message: string } | null | undefined> | null | undefined } | null | undefined> | null | undefined, validData?: Array<{ country?: string | null | undefined, department?: string | null | undefined, designation?: string | null | undefined, email?: string | null | undefined, employeementType?: string | null | undefined, employeeId?: string | null | undefined, gender?: string | null | undefined, grade?: number | null | undefined, jobType?: string | null | undefined, joinedDate?: any | null | undefined, mostProficientSkills?: Array<string> | null | undefined, name?: string | null | undefined, phoneNumber?: string | null | undefined, role?: string | null | undefined, shift?: string | null | undefined, softSkills?: Array<string> | null | undefined, somewhatProficientSkills?: Array<string> | null | undefined, timezone?: string | null | undefined, level?: IEmployeeLevel | null | undefined, errors?: Array<{ fieldName: string, message: string } | null | undefined> | null | undefined } | null | undefined> | null | undefined } };

export type IUserBulkUploadMutationVariables = Exact<{
  files: Array<Scalars['Upload']> | Scalars['Upload'];
  userList: Array<IUserUploadInputDto> | IUserUploadInputDto;
}>;


export type IUserBulkUploadMutation = { userBulkUpload: { invalidData?: Array<{ country?: string | null | undefined, department?: string | null | undefined, designation?: string | null | undefined, email?: string | null | undefined, employeementType?: string | null | undefined, employeeId?: string | null | undefined, gender?: string | null | undefined, grade?: number | null | undefined, jobType?: string | null | undefined, joinedDate?: any | null | undefined, mostProficientSkills?: Array<string> | null | undefined, name?: string | null | undefined, phoneNumber?: string | null | undefined, role?: string | null | undefined, shift?: string | null | undefined, softSkills?: Array<string> | null | undefined, somewhatProficientSkills?: Array<string> | null | undefined, timezone?: string | null | undefined, level?: IEmployeeLevel | null | undefined, errors?: Array<{ fieldName: string, message: string } | null | undefined> | null | undefined } | null | undefined> | null | undefined, validData?: Array<{ country?: string | null | undefined, department?: string | null | undefined, designation?: string | null | undefined, email?: string | null | undefined, employeementType?: string | null | undefined, employeeId?: string | null | undefined, gender?: string | null | undefined, grade?: number | null | undefined, jobType?: string | null | undefined, joinedDate?: any | null | undefined, mostProficientSkills?: Array<string> | null | undefined, name?: string | null | undefined, phoneNumber?: string | null | undefined, role?: string | null | undefined, shift?: string | null | undefined, softSkills?: Array<string> | null | undefined, somewhatProficientSkills?: Array<string> | null | undefined, timezone?: string | null | undefined, level?: IEmployeeLevel | null | undefined, errors?: Array<{ fieldName: string, message: string } | null | undefined> | null | undefined } | null | undefined> | null | undefined } };

export type IRevalidateEmployeeDataQueryVariables = Exact<{
  userList: Scalars['String'];
}>;


export type IRevalidateEmployeeDataQuery = { revalidateEmployeeData: { invalidData?: Array<{ country?: string | null | undefined, department?: string | null | undefined, designation?: string | null | undefined, email?: string | null | undefined, employeementType?: string | null | undefined, employeeId?: string | null | undefined, gender?: string | null | undefined, grade?: number | null | undefined, jobType?: string | null | undefined, joinedDate?: any | null | undefined, mostProficientSkills?: Array<string> | null | undefined, name?: string | null | undefined, phoneNumber?: string | null | undefined, role?: string | null | undefined, shift?: string | null | undefined, softSkills?: Array<string> | null | undefined, somewhatProficientSkills?: Array<string> | null | undefined, timezone?: string | null | undefined, level?: IEmployeeLevel | null | undefined, errors?: Array<{ fieldName: string, message: string } | null | undefined> | null | undefined } | null | undefined> | null | undefined, validData?: Array<{ country?: string | null | undefined, department?: string | null | undefined, designation?: string | null | undefined, email?: string | null | undefined, employeementType?: string | null | undefined, employeeId?: string | null | undefined, gender?: string | null | undefined, grade?: number | null | undefined, jobType?: string | null | undefined, joinedDate?: any | null | undefined, mostProficientSkills?: Array<string> | null | undefined, name?: string | null | undefined, phoneNumber?: string | null | undefined, role?: string | null | undefined, shift?: string | null | undefined, softSkills?: Array<string> | null | undefined, somewhatProficientSkills?: Array<string> | null | undefined, timezone?: string | null | undefined, level?: IEmployeeLevel | null | undefined, errors?: Array<{ fieldName: string, message: string } | null | undefined> | null | undefined } | null | undefined> | null | undefined } };

export type IGetClientsQueryVariables = Exact<{
  filterDto: IClientFilterDto;
  pageable: IPageRequest;
}>;


export type IGetClientsQuery = { getClients: { content: Array<{ id: string, name: string, startDate?: any | null | undefined, status: string, totalNumberOfContacts: number, totalNumberOfEngineers: number, totalNumberOfSquads: number, accountExecutive?: string | null | undefined, companyId?: string | null | undefined, website?: string | null | undefined, location?: string | null | undefined, annualRevenue?: number | null | undefined, noOfEmployees?: string | null | undefined, tier?: string | null | undefined, onboardingDate?: any | null | undefined, nda?: string | null | undefined, msa?: string | null | undefined, sow?: string | null | undefined, businessUnit?: string | null | undefined, csatRating?: number | null | undefined, npsScore?: number | null | undefined, hubspotClientType?: string | null | undefined, streetAddress2?: string | null | undefined, legalEntity?: string | null | undefined, contacts?: Array<{ id: string, name: string, email: string, number: string, designation: string, buyingRole?: string | null | undefined }> | null | undefined, squadContactDetails?: Array<{ squadName: string, squadId: string, clientContacts: Array<{ id: string, email: string, number: string, name: string }> }> | null | undefined, verticalInfo?: { vertical?: string | null | undefined, verticalLead?: string | null | undefined, industry?: string | null | undefined } | null | undefined }>, pageable: { page: number, totalPages: number, size: number, totalElements: number } } };

export type IGetClientContactsQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type IGetClientContactsQuery = { getClientContactGroupedBySquad: Array<{ squadName: string, clientContacts: Array<{ id: string, email: string, number: string, name: string }> }> };

export type IGetClientDetailsQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type IGetClientDetailsQuery = { getClientById: { id: string, name: string, startDate?: any | null | undefined, clientType?: string | null | undefined, contacts?: Array<{ id: string, name: string, email: string, number: string, designation: string }> | null | undefined } };

export type IGetClientListSummaryQueryVariables = Exact<{
  filterDto: IClientFilterDto;
  pageable: IPageRequest;
}>;


export type IGetClientListSummaryQuery = { getClients: { content: Array<{ id: string, name: string }> } };

export type IGetClientSquadsQueryVariables = Exact<{
  id: Scalars['String'];
  pageRequest?: Maybe<IPageRequest>;
}>;


export type IGetClientSquadsQuery = { getClientSpecificSquad: { content: Array<{ id: string, activeStatus?: string | null | undefined, aiMembersCount: number, techMembersCount: number, totalMembersCount: number, name: string, startDate?: any | null | undefined, type?: string | null | undefined, createdBy?: string | null | undefined, totalResourceCount?: number | null | undefined, totalAssignedCount?: number | null | undefined, ticketOwner?: Array<string> | null | undefined, endDate?: any | null | undefined, approvers?: { squadId?: string | null | undefined, additionalApprovers?: Array<{ designation?: string | null | undefined, fullname?: string | null | undefined, userId?: string | null | undefined }> | null | undefined, defaultApprover?: { designation?: string | null | undefined, fullname?: string | null | undefined, userId?: string | null | undefined } | null | undefined } | null | undefined, clientDepartment?: { id: string, name: string } | null | undefined }>, pageable: { page: number, totalPages: number, size: number, totalElements: number } } };

export type IGetClientResourcesQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type IGetClientResourcesQuery = { getClientById: { id: string, name: string } };

export type IGetContributingHiringMembersQueryVariables = Exact<{ [key: string]: never; }>;


export type IGetContributingHiringMembersQuery = { getContributingHiringMembers: { email: string, fullname: string, id: string, roles?: string | null | undefined, designation?: { id?: string | null | undefined, name?: string | null | undefined, grade?: number | null | undefined } | null | undefined } };

export type IGetClientSquadsDetailQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type IGetClientSquadsDetailQuery = { getSquadById: { id: string, name: string, allowWorklog: boolean, description?: string | null | undefined, dealLink?: string | null | undefined, techStack?: Array<string> | null | undefined, type?: string | null | undefined, startDate?: any | null | undefined, squadBudget?: number | null | undefined, endDate?: any | null | undefined, activeStatus?: string | null | undefined, lineOfBusiness?: string | null | undefined, vertical?: string | null | undefined, verticalId?: string | null | undefined, squadCategoryName?: string | null | undefined, squadCategoryId?: string | null | undefined, industry?: string | null | undefined, industryId?: string | null | undefined, projectTier?: number | null | undefined, contacts?: Array<{ id: string, name: string, email: string, number: string, designation: string }> | null | undefined, dealOwner?: { name?: string | null | undefined, ownerEmail?: string | null | undefined, ownerId?: string | null | undefined } | null | undefined, client?: { id?: string | null | undefined, name?: string | null | undefined, startDate?: any | null | undefined, status?: string | null | undefined, countSquads?: number | null | undefined } | null | undefined, clientDepartment?: { id: string, name: string } | null | undefined, additionalApproversResources?: Array<{ additionalApproverId?: string | null | undefined, approverResources?: Array<string> | null | undefined }> | null | undefined, approvers?: { additionalApprovers?: Array<{ fullname?: string | null | undefined, userId?: string | null | undefined, designation?: string | null | undefined }> | null | undefined, defaultApprover?: { designation?: string | null | undefined, userId?: string | null | undefined, fullname?: string | null | undefined } | null | undefined } | null | undefined } };

export type IGetSquadDetailsBySquadIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type IGetSquadDetailsBySquadIdQuery = { getSquadById: { activeStatus?: string | null | undefined, name: string, startDate?: any | null | undefined, endDate?: any | null | undefined } };

export type IGetSquadAssignedResourcesQueryVariables = Exact<{
  id: Scalars['String'];
  userSquadHistorySearchDTO: IUserSquadHistorySearchDto;
}>;


export type IGetSquadAssignedResourcesQuery = { getSquadAssignedResources: { id: string, name: string, employeeList?: Array<{ id: string, name: string, profileImage?: string | null | undefined, jobType?: string | null | undefined, rate?: number | null | undefined, rateType?: string | null | undefined, rateCurrency?: string | null | undefined, role?: string | null | undefined, yearsOfExperience?: number | null | undefined, experienceLevel?: string | null | undefined, requiredSkills?: Array<string> | null | undefined, userId: string, clientRate?: number | null | undefined, employeeRate?: number | null | undefined, involvementStatus?: string | null | undefined, startDate?: any | null | undefined, endDate?: any | null | undefined, estimatedEndDate?: any | null | undefined, department?: { id: string, name?: string | null | undefined } | null | undefined }> | null | undefined } };

export type IGetAssignResourcesQueryVariables = Exact<{
  id: Scalars['String'];
  userSquadHistorySearchDTO: IUserSquadHistorySearchDto;
}>;


export type IGetAssignResourcesQuery = { getClientsAssignedResources: Array<{ id: string, name: string, employeeList?: Array<{ id: string, name: string, jobType?: string | null | undefined, rate?: number | null | undefined, rateType?: string | null | undefined, rateCurrency?: string | null | undefined, role?: string | null | undefined, yearsOfExperience?: number | null | undefined, requiredSkills?: Array<string> | null | undefined, experienceLevel?: string | null | undefined, userId: string, employeeRate?: number | null | undefined, clientRate?: number | null | undefined, involvementStatus?: string | null | undefined, startDate?: any | null | undefined, endDate?: any | null | undefined, estimatedEndDate?: any | null | undefined, profileImage?: string | null | undefined, department?: { id: string, name?: string | null | undefined } | null | undefined, additionalNotes?: Array<{ createdAt?: any | null | undefined, id?: string | null | undefined, note?: string | null | undefined, noteType?: string | null | undefined, involvementHistoryId?: string | null | undefined, status?: string | null | undefined, modifications?: Array<{ modifiedField: string, newValue: string, oldValue: string } | null | undefined> | null | undefined, createdByUserInfo?: { email: string, fullname: string, profileId: string, profileImage?: string | null | undefined, userId: string } | null | undefined } | null | undefined> | null | undefined }> | null | undefined }> };

export type IGetSquadOverviewDetailQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type IGetSquadOverviewDetailQuery = { getSquadOverview: { LEVEL: Array<string>, AI: Array<{ role: string, levelData: Array<{ count: number, level: string }> }>, TECH: Array<{ role: string, levelData: Array<{ count: number, level: string }> }> } };

export type IGetSquadResourceAndSquadByIdQueryVariables = Exact<{
  squadId: Scalars['String'];
  squadResourceId: Scalars['String'];
  squadRoleId: Scalars['String'];
}>;


export type IGetSquadResourceAndSquadByIdQuery = { getSquadResourceAndSquadById: Array<{ clientName?: string | null | undefined, country?: Array<string> | null | undefined, id?: string | null | undefined, lineOfBusiness?: string | null | undefined, projectTier?: string | null | undefined, phasesAssigned?: Array<string> | null | undefined, rate?: number | null | undefined, requiredCount?: string | null | undefined, requiredSkills?: Array<string> | null | undefined, role?: string | null | undefined, squadEndDate?: any | null | undefined, squadName?: string | null | undefined, squadStartDate?: any | null | undefined, ticketId?: string | null | undefined, department?: string | null | undefined, goodToHaveSkills?: Array<string> | null | undefined, jobDescription?: string | null | undefined, experienceLevel?: string | null | undefined, priority?: string | null | undefined, jobType?: string | null | undefined, projectDescription?: string | null | undefined, yearsOfExperience?: number | null | undefined, timeZone?: Array<string> | null | undefined, endDate?: any | null | undefined, startDate?: any | null | undefined, vertical?: string | null | undefined, industry?: string | null | undefined, locationToBeHiredFrom?: Array<string> | null | undefined, clientSelectionProcess?: string | null | undefined, softSkills?: Array<string> | null | undefined }> };

export type IGetTicketOwnersAndCountriesQueryVariables = Exact<{
  squadId: Scalars['String'];
}>;


export type IGetTicketOwnersAndCountriesQuery = { getTicketOwnersAndCountries: Array<{ countries: Array<string>, ticketOwners: Array<string> }> };

export type IGetDealOwnersInSquadQueryVariables = Exact<{ [key: string]: never; }>;


export type IGetDealOwnersInSquadQuery = { getDealOwnersInSquad: Array<string> };

export type IGetWorkingTimeZonesQueryVariables = Exact<{ [key: string]: never; }>;


export type IGetWorkingTimeZonesQuery = { getWorkingTimeZones: Array<string> };

export type IGetUserAssignedSquadsByUserIdQueryVariables = Exact<{
  userId: Scalars['String'];
  options?: Maybe<IUserAssignedSquadsOptions>;
}>;


export type IGetUserAssignedSquadsByUserIdQuery = { getUserAssignedSquadsByUserId: Array<{ squadName: string, jobType?: string | null | undefined, involvementType?: string | null | undefined, squadId: string, allocatedHours?: number | null | undefined }> };

export type IGetUserPreferenceQueryVariables = Exact<{ [key: string]: never; }>;


export type IGetUserPreferenceQuery = { getUserPreference: { userId: string, tableMetadata?: { employeeListOrder?: Array<{ columnName: string, isPinned: boolean, isVisible: boolean, columnWidth: number }> | null | undefined, clientListOrder?: Array<{ columnName: string, isPinned: boolean, isVisible: boolean, columnWidth: number }> | null | undefined, cmSquadListOrder?: Array<{ columnName: string, isPinned: boolean, isVisible: boolean, columnWidth: number }> | null | undefined, addResourceListOrder?: Array<{ columnName: string, isPinned: boolean, isVisible: boolean, columnWidth: number }> | null | undefined, assignedResourcesOrder?: Array<{ columnName: string, isPinned: boolean, isVisible: boolean, columnWidth: number }> | null | undefined, squadListOrder?: Array<{ columnName: string, isPinned: boolean, isVisible: boolean, columnWidth: number }> | null | undefined, worklogDataListOrder?: Array<{ columnName: string, isPinned: boolean, isVisible: boolean, columnWidth: number }> | null | undefined, requiredResourcesOrder?: Array<{ columnName: string, isPinned: boolean, isVisible: boolean, columnWidth: number }> | null | undefined, jobCandidateList?: Array<{ columnName: string, isPinned: boolean, isVisible: boolean, columnWidth: number }> | null | undefined, jobListOrder?: Array<{ columnName: string, isPinned: boolean, isVisible: boolean, columnWidth: number }> | null | undefined, completedSquadListOrder?: Array<{ columnName: string, isPinned: boolean, isVisible: boolean, columnWidth: number }> | null | undefined, notRunningSquadListOrder?: Array<{ columnName: string, isPinned: boolean, isVisible: boolean, columnWidth: number }> | null | undefined } | null | undefined } };

export type IRoleDetailsQueryVariables = Exact<{
  squadRoleId: Scalars['String'];
  userSquadHistoryId: Scalars['String'];
}>;


export type IRoleDetailsQuery = { getRoleDetailsById: { id?: string | null | undefined, ticketId?: string | null | undefined, squadId?: string | null | undefined, squadRoleId?: string | null | undefined, role?: string | null | undefined, experienceLevel?: string | null | undefined, workingHour?: number | null | undefined, country?: Array<string> | null | undefined, timeZone?: Array<string> | null | undefined, jobType?: string | null | undefined, yearsOfExperience?: number | null | undefined, startDate?: any | null | undefined, endDate?: any | null | undefined, requiredSkills?: Array<string> | null | undefined, goodToHaveSkills?: Array<string> | null | undefined, jobDescription?: string | null | undefined, prevEmpStartDate?: any | null | undefined, prevEmpEndDate?: any | null | undefined, involvedAs?: string | null | undefined, involvementStatus?: IInvolvementStatus | null | undefined, userId?: string | null | undefined, userSquadHistoryId?: string | null | undefined } };

export type IGetDashboardAnalyticsQueryVariables = Exact<{ [key: string]: never; }>;


export type IGetDashboardAnalyticsQuery = { getDashboardAnalytics: { partiallyDeployable: number, totalDeployable: number, totalNoOfActiveConsultant: number, totalNoOfActiveConsultantCoreFullTime: number, totalNoOfActiveConsultantCorePartTime: number, totalNoOfAssigned: number, totalNoOfClientBillableProjectCore: number, totalNoOfClientBillableProjectCoreFullTime: number, totalNoOfClientBillableProjectCorePartTime: number, totalNoOfClientNonBillableProjectShadow: number, totalNoOfClientNonBillableProjectShadowFullTime: number, totalNoOfClientNonBillableProjectShadowPartTime: number, totalNoOfClientNonBillableProjectSupport: number, totalNoOfClientNonBillableProjectSupportFullTime: number, totalNoOfClientNonBillableProjectSupportPartTime: number, totalNoOfEmployees: number, totalNoOfInactiveConsultant: number, totalNoOfInternalProjectCoreFullTime: number, totalNoOfInternalProjectCorePartTime: number, totalNoOfInternalProjectShadowFullTime: number, totalNoOfInternalProjectShadowPartTime: number, totalNoOfInternalProjectSupportFullTime: number, totalNoOfInternalProjectSupportPartTime: number, totalNoOfOnBench: number, totalNoOfUnassigned: number, totalNofOfInternalProjectCore: number, totalNofOfInternalProjectShadow: number, totalNofOfInternalProjectSupport: number } };

export type IGetRoleInfoByHistoryIdQueryVariables = Exact<{
  historyId: Scalars['String'];
}>;


export type IGetRoleInfoByHistoryIdQuery = { getRoleInfoByHistoryId: { clientId?: string | null | undefined, clientName?: string | null | undefined, squadId?: string | null | undefined, squadName?: string | null | undefined, role?: string | null | undefined, experienceLevel?: string | null | undefined, jobType?: string | null | undefined, squadRoleId?: string | null | undefined, ticketId?: string | null | undefined, department?: string | null | undefined, country?: Array<string> | null | undefined, timeZone?: Array<string> | null | undefined, priority?: string | null | undefined, rate?: number | null | undefined, requiredSkills?: Array<string> | null | undefined, goodToHaveSkills?: Array<string> | null | undefined, jobDescription?: string | null | undefined, endDate?: any | null | undefined, joinedDate?: any | null | undefined, employeeName?: string | null | undefined, involvedAs?: string | null | undefined, userId: string } };

export type IFetchRunningSquadByClientIdQueryVariables = Exact<{
  clientId: Scalars['String'];
}>;


export type IFetchRunningSquadByClientIdQuery = { getRunningSquadsByClientId: Array<{ id: string, name: string }> };

export type IGetEmployeeUploadSampleQueryVariables = Exact<{ [key: string]: never; }>;


export type IGetEmployeeUploadSampleQuery = { getEmployeeUploadSample: string };

export type IExportErrorDataSheetQueryVariables = Exact<{
  userList: Scalars['String'];
}>;


export type IExportErrorDataSheetQuery = { exportErrorDataSheet: string };

export type IGetAllSquadCategoryQueryVariables = Exact<{ [key: string]: never; }>;


export type IGetAllSquadCategoryQuery = { findAllSquadCategory: Array<{ descriptions?: Array<string> | null | undefined, id: string, name?: string | null | undefined }> };

export type ICreateSquadNoteMutationVariables = Exact<{
  note: Scalars['String'];
  squadId: Scalars['String'];
}>;


export type ICreateSquadNoteMutation = { createSquadNote: { note: string, clientId: string, squadId: string, userId?: string | null | undefined, createdAt?: any | null | undefined } };

export type IUpdateSquadMutationVariables = Exact<{
  squadId: Scalars['String'];
  squadListDto: ISquadListDto;
  clientContactDto: Array<ICreateClientContactDto> | ICreateClientContactDto;
}>;


export type IUpdateSquadMutation = { updateSquad: { name: string, clientId: string, startDate?: any | null | undefined, endDate?: any | null | undefined, id: string } };

export type IRemoveClientContactMutationVariables = Exact<{
  clientContactId: Scalars['String'];
  squadId: Scalars['String'];
}>;


export type IRemoveClientContactMutation = { removeClientContact: string };

export type ICreateOrUpdateRequestToHireMutationVariables = Exact<{
  requestToHire: IJobUpdateDto;
}>;


export type ICreateOrUpdateRequestToHireMutation = { createOrUpdateRequestToHire: { billingCycle?: IJobBillingCycle | null | undefined, billingRate?: number | null | undefined, createdAt?: any | null | undefined, enterprisePeopleId?: string | null | undefined, experienceLevel?: IExperienceLevel | null | undefined, goodToHaveSkills?: Array<string> | null | undefined, id?: string | null | undefined, jobCode?: string | null | undefined, jobDescription?: string | null | undefined, jobPriority?: IJobPriority | null | undefined, jobStatus: IJobStatus, jobType?: IEmploymentType | null | undefined, location?: Array<string> | null | undefined, mustHaveSkills?: Array<string> | null | undefined, noOfVacancies?: number | null | undefined, squadId?: string | null | undefined, timeZone?: Array<string> | null | undefined, title?: string | null | undefined, updatedAt?: any | null | undefined, squadStartDate?: any | null | undefined, squadEndDate?: any | null | undefined, startDate?: any | null | undefined, endDate?: any | null | undefined, vertical?: string | null | undefined, industry?: string | null | undefined, minimumBudget?: number | null | undefined, maximumBudget?: number | null | undefined, locationToBeHiredFrom?: Array<string> | null | undefined, yearsOfExperience?: number | null | undefined } };

export type ICreateRthTemplateMutationVariables = Exact<{
  rthTemplate: IRthTemplateDto;
}>;


export type ICreateRthTemplateMutation = { createRthTemplate: { billingCycle?: IJobBillingCycle | null | undefined, billingRate?: number | null | undefined, clientSelectionProcess?: string | null | undefined, department?: string | null | undefined, descriptionTemplateId?: string | null | undefined, endDate?: any | null | undefined, enterprisePeopleId?: string | null | undefined, evaluationCriteria?: string | null | undefined, experienceLevel?: IExperienceLevel | null | undefined, goodToHaveSkills?: Array<string> | null | undefined, horizontal?: string | null | undefined, id?: string | null | undefined, industry?: string | null | undefined, industryBackground?: string | null | undefined, jobCode?: string | null | undefined, jobDescription?: string | null | undefined, jobId?: string | null | undefined, jobPriority?: IJobPriority | null | undefined, jobStatus?: IJobStatus | null | undefined, jobType?: IEmploymentType | null | undefined, location?: Array<string> | null | undefined, locationToBeHiredFrom?: Array<string> | null | undefined, maximumBudget?: number | null | undefined, minimumBudget?: number | null | undefined, mustHaveSkills?: Array<string> | null | undefined, noOfVacancies?: number | null | undefined, numberOfResources?: number | null | undefined, projectDescription?: string | null | undefined, saveAsDraft?: boolean | null | undefined, softSkills?: Array<string> | null | undefined, squadEndDate?: any | null | undefined, squadId?: string | null | undefined, squadRoleId?: string | null | undefined, squadStartDate?: any | null | undefined, startDate?: any | null | undefined, technicalInterviewPanel?: string | null | undefined, templateTitle?: string | null | undefined, ticketId?: string | null | undefined, timeZone?: Array<string> | null | undefined, title?: string | null | undefined, travelRequirements?: string | null | undefined, typeOfWork?: IType_Of_Work | null | undefined, vertical?: string | null | undefined, yearsOfExperience?: number | null | undefined, contributingMembers?: Array<{ id: string, isCreator: boolean }> | null | undefined } };

export type ICreateRolesInSquadMutationVariables = Exact<{
  squadResources: ICreateRoleDto;
}>;


export type ICreateRolesInSquadMutation = { createRolesInSquad: Array<{ id: string, squadId: string, squadResourceId: string }> };

export type IUpdateRoleDetailsByResourceIdMutationVariables = Exact<{
  squadResourceInputDto: ISquadResourceInputDto;
}>;


export type IUpdateRoleDetailsByResourceIdMutation = { updateRoleDetailsByResourceId: { squadId: string, ticketId?: string | null | undefined, squadRoleId: string, id: string } };

export type IToggleSquadPinByUserIdMutationVariables = Exact<{
  squadId: Scalars['String'];
}>;


export type IToggleSquadPinByUserIdMutation = { toggleSquadPinByUserId: string };

export type ICreateInternalSquadMutationVariables = Exact<{
  internalSquadDto: IInternalSquadDto;
}>;


export type ICreateInternalSquadMutation = { createInternalSquad: { description?: string | null | undefined, lineOfBusiness?: string | null | undefined, name: string, startDate?: any | null | undefined, endDate?: any | null | undefined, id: string, type?: string | null | undefined, squadCategoryId?: string | null | undefined } };

export type ICreateAdditionalNoteMutationVariables = Exact<{
  createAdditionalNoteDto: ICreateAdditionalNoteDto;
}>;


export type ICreateAdditionalNoteMutation = { createAdditionalNote: Array<{ createdAt?: any | null | undefined, id?: string | null | undefined, note?: string | null | undefined, noteType?: string | null | undefined, involvementHistoryId?: string | null | undefined, status?: string | null | undefined, modifications?: Array<{ modifiedField: string, newValue: string, oldValue: string } | null | undefined> | null | undefined, createdByUserInfo?: { email: string, fullname: string, profileId: string, profileImage?: string | null | undefined, userId: string } | null | undefined }> };

export type IUpdateAdditionalNoteMutationVariables = Exact<{
  additionalNoteId: Scalars['String'];
  updateAdditionalNoteDto: IUpdateAdditionalNoteDto;
}>;


export type IUpdateAdditionalNoteMutation = { updateAdditionalNote: Array<{ createdAt?: any | null | undefined, id?: string | null | undefined, note?: string | null | undefined, noteType?: string | null | undefined, involvementHistoryId?: string | null | undefined, status?: string | null | undefined, modifications?: Array<{ modifiedField: string, newValue: string, oldValue: string } | null | undefined> | null | undefined, createdByUserInfo?: { email: string, fullname: string, profileId: string, profileImage?: string | null | undefined, userId: string } | null | undefined }> };

export type IUpdateSupervisorsMutationVariables = Exact<{
  updateSupervisorData: IUpdateSupervisorDto;
}>;


export type IUpdateSupervisorsMutation = { updateSupervisors: { profileId?: string | null | undefined, supervisorProfileId?: string | null | undefined, userId?: string | null | undefined } };

export type IGetAssignedTeamMembersQueryVariables = Exact<{
  squadId: Scalars['String'];
  pageRequest: IPageRequest;
  userSquadHistorySearchDTO: IUserSquadHistorySearchDto;
}>;


export type IGetAssignedTeamMembersQuery = { getAssignedTeamMembers: { content: Array<{ clientRate?: number | null | undefined, employeeRate?: number | null | undefined, endDate?: any | null | undefined, id: string, involvementStatus?: string | null | undefined, employeeActiveStatus?: string | null | undefined, jobType?: string | null | undefined, startDate?: any | null | undefined, experienceLevel?: string | null | undefined, name: string, phasesAssigned?: Array<string> | null | undefined, rate?: number | null | undefined, rateCurrency?: string | null | undefined, rateType?: string | null | undefined, role?: string | null | undefined, requiredSkills?: Array<string> | null | undefined, userId: string, involvedAs?: string | null | undefined, profileId: string, profileImage?: string | null | undefined, requiredForKickOff?: boolean | null | undefined, employeementType?: string | null | undefined, estimatedEndDate?: any | null | undefined, squadRoleId?: string | null | undefined, technicalSkills?: Array<string> | null | undefined, involvementHistoryId?: string | null | undefined, ticketId?: string | null | undefined, ticketLink?: string | null | undefined, department?: { id: string, name?: string | null | undefined } | null | undefined, additionalNotes?: Array<{ createdAt?: any | null | undefined, id?: string | null | undefined, note?: string | null | undefined, noteType?: string | null | undefined, involvementHistoryId?: string | null | undefined, status?: string | null | undefined, modifications?: Array<{ modifiedField: string, newValue: string, oldValue: string } | null | undefined> | null | undefined, createdByUserInfo?: { email: string, fullname: string, profileId: string, profileImage?: string | null | undefined, userId: string } | null | undefined } | null | undefined> | null | undefined }>, pageable: { page: number, totalPages: number, size: number, totalElements: number } } };

export type IGetTechViewSquadListQueryVariables = Exact<{
  pageRequest: IPageRequest;
  squadListDto: ISquadListDto;
}>;


export type IGetTechViewSquadListQuery = { getSquadsWithFilter: { totalNoOfSquads?: number | null | undefined, totalUnassignedRoles?: number | null | undefined, pageable: { page: number, totalPages: number, size: number, totalElements: number }, content: Array<{ dealLink?: string | null | undefined, pinned?: boolean | null | undefined, activeStatus?: string | null | undefined, approverFilter?: boolean | null | undefined, clientName?: string | null | undefined, isCompletelyAssigned?: boolean | null | undefined, endDate?: any | null | undefined, techStack?: Array<string> | null | undefined, name?: string | null | undefined, note?: string | null | undefined, searchText?: string | null | undefined, squadId?: string | null | undefined, startDate?: any | null | undefined, totalRequiredResources?: number | null | undefined, resourceRequiredCount?: number | null | undefined, timePeriod?: string | null | undefined, totalResourceCount?: number | null | undefined, dealOwner?: string | null | undefined, defaultApprover?: string | null | undefined, squadresource?: { createdAt?: any | null | undefined, ticketOwner?: Array<string> | null | undefined, country?: Array<string> | null | undefined } | null | undefined }> } };

export type IGetcountSquadUnassignedrolesQueryVariables = Exact<{
  squadListDto: ISquadListDto;
}>;


export type IGetcountSquadUnassignedrolesQuery = { countSquadUnassignedroles: Array<{ totalSquads: number, totalUnassignedRoles: number }> };

export type IGetClientSquadCbuListQueryVariables = Exact<{ [key: string]: never; }>;


export type IGetClientSquadCbuListQuery = { getCbuLists: Array<string>, getClientList: Array<{ id: string, name: string }>, getSquads: Array<{ id: string, name: string }> };

export type IGetSquadNoteQueryVariables = Exact<{
  squadId: Scalars['String'];
}>;


export type IGetSquadNoteQuery = { getSquadNoteBySquadId: Array<{ note: string, clientId?: string | null | undefined, squadId: string, userId?: string | null | undefined, createdAt?: any | null | undefined }> };

export type IGetSquadResourceDetailsQueryVariables = Exact<{
  squadId: Scalars['String'];
}>;


export type IGetSquadResourceDetailsQuery = { getSquadResourceDetails: { clientName?: string | null | undefined, id?: string | null | undefined, overallBudget?: number | null | undefined, usedBudget?: number | null | undefined, squadName?: string | null | undefined, squadStartDate?: any | null | undefined, squadEndDate?: any | null | undefined, countSquads?: number | null | undefined } };

export type IGetRolesToAssignCandidatesQueryVariables = Exact<{
  squadId: Scalars['String'];
  pageRequest: IPageRequest;
}>;


export type IGetRolesToAssignCandidatesQuery = { getRolesToAssignCandidates: { totalCandidates?: number | null | undefined, assignedCandidates?: number | null | undefined, assigned?: Array<{ clientRate?: number | null | undefined, employeeRate?: number | null | undefined, endDate?: any | null | undefined, id: string, involvementStatus?: string | null | undefined, jobType?: string | null | undefined, startDate?: any | null | undefined, experienceLevel?: string | null | undefined, name: string, phasesAssigned?: Array<string> | null | undefined, rate?: number | null | undefined, rateCurrency?: string | null | undefined, rateType?: string | null | undefined, role?: string | null | undefined, requiredSkills?: Array<string> | null | undefined, userId: string, profileImage?: string | null | undefined, involvedAs?: string | null | undefined, profileId: string, requiredForKickOff?: boolean | null | undefined, employeementType?: string | null | undefined, squadRoleId?: string | null | undefined, roleDescription?: string | null | undefined, workingHour?: number | null | undefined, estimatedStartDate?: any | null | undefined, region?: Array<string> | null | undefined, createdBy?: string | null | undefined, ticketId?: string | null | undefined, department?: { id: string, name?: string | null | undefined } | null | undefined }> | null | undefined, considered?: Array<{ endDate?: any | null | undefined, estimatedEndDate?: any | null | undefined, experienceLevel?: string | null | undefined, numberOfCandidates?: number | null | undefined, phasesAssigned?: Array<string> | null | undefined, rate?: number | null | undefined, requiredForKickOff?: boolean | null | undefined, requiredSkills?: Array<string> | null | undefined, role?: string | null | undefined, roleDescription?: string | null | undefined, squadRoleId?: string | null | undefined, startDate?: any | null | undefined, workingHour?: number | null | undefined, squadResourceId?: string | null | undefined, isRequestedForHire?: boolean | null | undefined, estimatedStartDate?: any | null | undefined, region?: Array<string> | null | undefined, jobType?: string | null | undefined, createdBy?: string | null | undefined, offboardingCandidate?: number | null | undefined, ticketId?: string | null | undefined, probableCandidates?: Array<{ name?: string | null | undefined, profileId?: string | null | undefined, profileImage?: string | null | undefined }> | null | undefined }> | null | undefined, unassigned?: Array<{ department?: string | null | undefined, endDate?: any | null | undefined, estimatedEndDate?: any | null | undefined, experienceLevel?: string | null | undefined, numberOfCandidates?: number | null | undefined, phasesAssigned?: Array<string> | null | undefined, priority?: IPriorityEnum | null | undefined, rate?: number | null | undefined, requiredForKickOff?: boolean | null | undefined, requiredSkills?: Array<string> | null | undefined, role?: string | null | undefined, roleDescription?: string | null | undefined, squadRoleId?: string | null | undefined, startDate?: any | null | undefined, workingHour?: number | null | undefined, squadResourceId?: string | null | undefined, isRequestedForHire?: boolean | null | undefined, estimatedStartDate?: any | null | undefined, region?: Array<string> | null | undefined, jobType?: string | null | undefined, createdBy?: string | null | undefined, offboardingCandidate?: number | null | undefined, ticketId?: string | null | undefined, timeZone?: Array<string> | null | undefined, yearsOfExperience?: number | null | undefined, locationToBeHiredFrom?: Array<string> | null | undefined, probableCandidates?: Array<{ name?: string | null | undefined, profileId?: string | null | undefined, profileImage?: string | null | undefined }> | null | undefined }> | null | undefined } };

export type IGetRequiredResourcesQueryVariables = Exact<{
  filter: ISquadRequiredRequestDto;
  pageRequest: IPageRequest;
}>;


export type IGetRequiredResourcesQuery = { getSquadRequiredResources: { content: Array<{ role?: string | null | undefined, requiredForKickOff?: boolean | null | undefined, probableCandidatesCount?: number | null | undefined, requiredCount?: number | null | undefined, phasesAssigned?: Array<string> | null | undefined, startDate?: any | null | undefined, endDate?: any | null | undefined, estimatedEndDate?: any | null | undefined, jobType?: string | null | undefined, squadId?: string | null | undefined, squadResourceId: string, squadRoleId: string, rate?: number | null | undefined, estimatedStartDate?: any | null | undefined, createdAt?: any | null | undefined, ticketOwner?: string | null | undefined, ticketId?: string | null | undefined, country?: Array<string> | null | undefined, experienceLevel?: string | null | undefined, isRequestedForHire?: boolean | null | undefined, priority?: string | null | undefined, jobCreatedAt?: any | null | undefined, offboardingCount?: number | null | undefined, ticketLink?: string | null | undefined, probableCandidates?: Array<{ userName?: string | null | undefined, profileImage?: string | null | undefined, squadId?: string | null | undefined, userId?: string | null | undefined }> | null | undefined }>, pageable: { page: number, size: number, totalElements: number, totalPages: number } } };

export type IListResourcesQueryVariables = Exact<{
  filter: IEligibleCandidatesFilterDto;
  pageRequest: IPageRequest;
}>;


export type IListResourcesQuery = { listResources: { skillForAdvancedFilter?: Array<string> | null | undefined, content: Array<{ consideredCandidate: boolean, jobType?: IJobTypeEnum | null | undefined, level?: IEmployeeLevel | null | undefined, name: string, department?: string | null | undefined, subDepartment?: string | null | undefined, resumeUrl?: string | null | undefined, resourceStatus?: string | null | undefined, profileId: string, profileImage?: string | null | undefined, rate?: number | null | undefined, role: string, skills?: Array<string> | null | undefined, squadStatus?: IInvolvementStatus | null | undefined, employeeType?: IFuseEmployeementType | null | undefined, userId: string, beingReplaced: boolean, availabilityStatus?: IAvailabilityStatus | null | undefined, deploymentStatus?: IDeploymentStatus | null | undefined, userSquadHistory?: Array<{ _id?: string | null | undefined, involvementStatus?: IInvolvementStatus | null | undefined, involvedAs?: IInvolvedAs | null | undefined, jobType?: string | null | undefined, endDate?: any | null | undefined, squadName?: string | null | undefined, squadId?: string | null | undefined, joinedDate?: any | null | undefined, allocatedHours?: number | null | undefined, squadRoleId?: string | null | undefined }> | null | undefined, userSquadHistoryUnfiltered?: Array<{ squadName?: string | null | undefined, endDate?: any | null | undefined, squadId?: string | null | undefined, involvedAs?: IInvolvedAs | null | undefined, involvementStatus?: IInvolvementStatus | null | undefined, jobType?: string | null | undefined, involvementHistory?: Array<{ endDate?: any | null | undefined, involvedAs?: IInvolvedAs | null | undefined, involvementStatus?: IInvolvementStatus | null | undefined, jobType?: IJobTypeEnum | null | undefined, allocatedHours: number }> | null | undefined }> | null | undefined, overallStatus?: Array<{ clientName?: string | null | undefined, involvementStatus?: IInvolvementStatus | null | undefined, roleInSquad?: string | null | undefined, squadName?: string | null | undefined, squadRoleId: string }> | null | undefined, currentSquads?: Array<{ involvedAs?: IInvolvedAs | null | undefined, jobType?: string | null | undefined, squadName?: string | null | undefined, squadId?: string | null | undefined, endDate?: any | null | undefined, squadRoleId?: string | null | undefined, allocatedHours?: number | null | undefined }> | null | undefined, matchInfo?: { deploymentMatchScore?: number | null | undefined, skillMatchScore?: number | null | undefined, departmentMatchScore?: number | null | undefined, levelMatchScore?: number | null | undefined, countryMatchScore?: number | null | undefined, matchType?: IMatch_Types | null | undefined, overallScore?: number | null | undefined } | null | undefined }>, pageable: { page: number, size: number, totalElements: number, totalPages: number } } };

export type IListNotesQueryVariables = Exact<{
  userId: Scalars['String'];
}>;


export type IListNotesQuery = { listNotes: Array<{ _id?: string | null | undefined, userId?: string | null | undefined, profileId?: string | null | undefined, squadId?: string | null | undefined, clientId?: string | null | undefined, involvementStatus?: string | null | undefined, joinedDate?: any | null | undefined, notes?: Array<{ note?: string | null | undefined }> | null | undefined, client?: { _id?: string | null | undefined, name?: string | null | undefined } | null | undefined, squad?: { _id?: string | null | undefined, name?: string | null | undefined } | null | undefined }> };

export type IGetRolesInSquadQueryVariables = Exact<{
  squadId: Scalars['String'];
}>;


export type IGetRolesInSquadQuery = { getRolesInSquad?: Array<string> | null | undefined };

export type IGetPhasesInSquadQueryVariables = Exact<{
  squadId: Scalars['String'];
}>;


export type IGetPhasesInSquadQuery = { getPhasesInSquad?: Array<string> | null | undefined };

export type IGetRoleToAssignCandidateQueryVariables = Exact<{
  squadId: Scalars['String'];
  squadRoleId: Scalars['String'];
}>;


export type IGetRoleToAssignCandidateQuery = { getRoleToAssignCandidate: { endDate?: any | null | undefined, experienceLevel?: string | null | undefined, numberOfCandidates?: number | null | undefined, phasesAssigned?: Array<string> | null | undefined, rate?: number | null | undefined, requiredForKickOff?: boolean | null | undefined, requiredSkills?: Array<string> | null | undefined, role?: string | null | undefined, roleDescription?: string | null | undefined, squadRoleId?: string | null | undefined, startDate?: any | null | undefined, workingHour?: number | null | undefined, estimatedStartDate?: any | null | undefined, region?: Array<string> | null | undefined, jobType?: string | null | undefined, createdBy?: string | null | undefined, probableCandidates?: Array<{ name?: string | null | undefined, profileId?: string | null | undefined, profileImage?: string | null | undefined }> | null | undefined } };

export type IConsideredResourcesQueryVariables = Exact<{
  filter: IEligibleCandidatesFilterDto;
  pageRequest: IPageRequest;
}>;


export type IConsideredResourcesQuery = { consideredResources: { content: Array<{ consideredCandidate: boolean, jobType?: IJobTypeEnum | null | undefined, level?: IEmployeeLevel | null | undefined, name: string, profileId: string, profileImage?: string | null | undefined, rate?: number | null | undefined, role: string, skillMatchedPercent?: number | null | undefined, skills?: Array<string> | null | undefined, squadStatus?: IInvolvementStatus | null | undefined, employeeType?: IFuseEmployeementType | null | undefined, userId: string, roles?: Array<string> | null | undefined, designation?: string | null | undefined, resumeUrl?: string | null | undefined, overallStatus?: Array<{ clientName?: string | null | undefined, involvementStatus?: IInvolvementStatus | null | undefined, roleInSquad?: string | null | undefined, squadName?: string | null | undefined, squadRoleId: string }> | null | undefined }>, pageable: { page: number, size: number, totalElements: number, totalPages: number } } };

export type IGetEmployeePersonalInfoQueryVariables = Exact<{
  userId: Scalars['String'];
  squadRoleId: Scalars['String'];
}>;


export type IGetEmployeePersonalInfoQuery = { getEmployeePersonalInfo: { userId: string, profileId?: string | null | undefined, squadStatus?: IInvolvementStatus | null | undefined, availableSince?: any | null | undefined, relevantExperience?: { month?: string | null | undefined, year?: string | null | undefined } | null | undefined, overAllExperience?: { month?: string | null | undefined, year?: string | null | undefined } | null | undefined, personalInfo: { countryOfResidence?: string | null | undefined, availabilityStatus?: string | null | undefined, region?: string | null | undefined, email: string, filename?: string | null | undefined, joinedDate?: any | null | undefined, name: string, phoneNumber?: string | null | undefined, resumeUrl?: string | null | undefined, role?: string | null | undefined, timeZone?: string | null | undefined, githubUrl?: string | null | undefined, linkedinUrl?: string | null | undefined, profileImage?: string | null | undefined, gender?: IGender | null | undefined, resignDate?: any | null | undefined }, experience?: { roles?: Array<string> | null | undefined, yearsOfExperienceInRoles: Array<{ role?: string | null | undefined, yearsOfExperience?: number | null | undefined }> } | null | undefined, paymentOption: Array<{ billingAmount?: string | null | undefined, billingType?: string | null | undefined }>, skills?: { mostProficientTechnologies: Array<string>, softSkills: Array<string>, somewhatProficientTechnologies: Array<string> } | null | undefined, assignedDevices?: Array<{ assignedDate?: any | null | undefined, _id?: string | null | undefined, deviceCode: string, deviceDescription: string, deviceName?: string | null | undefined }> | null | undefined, squads: Array<{ squadId: string, squadHistoryId?: string | null | undefined, squadName?: string | null | undefined, joinedDate?: any | null | undefined, allocatedHours?: number | null | undefined, squadType?: string | null | undefined, endDate?: any | null | undefined, involvedAs?: string | null | undefined, involvementStatus?: string | null | undefined, clientId: string, clientName: string, roleInSquad?: string | null | undefined, employeeBillingRate?: number | null | undefined, clientBillingRate?: number | null | undefined, jobType?: IJobTypeEnum | null | undefined, squadRoleId?: string | null | undefined, involvementHistory?: Array<{ involvedAs?: IInvolvedAs | null | undefined, involvementStatus?: IInvolvementStatus | null | undefined, jobType?: IJobTypeEnum | null | undefined, modifiedBy?: string | null | undefined, modifiedOn?: any | null | undefined, joinedDate?: any | null | undefined, endDate?: any | null | undefined, role?: string | null | undefined }> | null | undefined, additionalNotes?: Array<{ createdAt?: any | null | undefined, id?: string | null | undefined, note?: string | null | undefined, noteType?: string | null | undefined, involvementHistoryId?: string | null | undefined, status?: string | null | undefined, modifications?: Array<{ modifiedField: string, newValue: string, oldValue: string } | null | undefined> | null | undefined, createdByUserInfo?: { email: string, fullname: string, profileId: string, profileImage?: string | null | undefined, userId: string } | null | undefined } | null | undefined> | null | undefined }>, supervisors?: Array<{ email?: string | null | undefined, fullname?: string | null | undefined, designationName?: string | null | undefined, departmentName?: string | null | undefined } | null | undefined> | null | undefined, jobExperience?: Array<{ companyName?: string | null | undefined, currentlyEmployed?: boolean | null | undefined, jobLocation?: string | null | undefined, jobTitle?: string | null | undefined, rolesAndResponsibility?: string | null | undefined, jobEndDate?: { month: string, year: string } | null | undefined, jobStartDate?: { month: string, year: string } | null | undefined }> | null | undefined, education: Array<{ currentlyStudying?: boolean | null | undefined, degree?: string | null | undefined, fieldOfStudy?: string | null | undefined, isEducationFormCompleted?: boolean | null | undefined, levelOfEducation?: string | null | undefined, school?: string | null | undefined, completedOn?: { month: string, year: string } | null | undefined, joinedOn?: { month: string, year: string } | null | undefined }>, certificates?: Array<{ certificateID?: string | null | undefined, certificateTitle?: string | null | undefined, currentlyStudying?: boolean | null | undefined, isCertificateFormCompleted?: boolean | null | undefined, issuingInstitutionOrganization?: string | null | undefined, url?: string | null | undefined, completedOn?: { month: string, year: string } | null | undefined, joinedOn?: { month: string, year: string } | null | undefined }> | null | undefined, workExperience?: Array<{ company?: string | null | undefined, companyAddress?: string | null | undefined, profileId: string, userId: string, workExperienceId?: string | null | undefined, workHistory: Array<{ details?: string | null | undefined, endDate?: any | null | undefined, role: string, jobTitle: string, startDate: any, workHistoryId?: string | null | undefined }> }> | null | undefined, currentWorkInfo: { deploymentStatus?: IDeploymentStatus | null | undefined, designation?: string | null | undefined, employeeId?: string | null | undefined, jobType?: string | null | undefined, level?: IEmployeeLevel | null | undefined, mainDepartment?: string | null | undefined, roles?: Array<string> | null | undefined, workShift?: string | null | undefined, optionExploring?: string | null | undefined, department?: { id?: string | null | undefined, name?: string | null | undefined } | null | undefined } } };

export type IGetCbuListQueryVariables = Exact<{ [key: string]: never; }>;


export type IGetCbuListQuery = { getCbuLists: Array<string> };

export type IGetResourcesToAssignApprovesQueryVariables = Exact<{
  listApproversFilterDto?: Maybe<IListApproversFilterDto>;
}>;


export type IGetResourcesToAssignApprovesQuery = { listResourcesToAssignApprovers: Array<{ designation?: string | null | undefined, userId: string, name?: string | null | undefined, email?: string | null | undefined, isApproverAssigned?: boolean | null | undefined }> };

export type IGetSquadAssignedResourcesBreakdownQueryVariables = Exact<{
  squadId: Scalars['String'];
}>;


export type IGetSquadAssignedResourcesBreakdownQuery = { getSquadAssignedResourcesBreakdown: { LEVEL: Array<string>, barChartData: Array<{ department: string, consultantEmployeeList: Array<{ role: string, levelData: Array<{ count: number, level: string }> }>, fuseMachineEmployeeList: Array<{ role: string, levelData: Array<{ count: number, level: string }> }> }> } };

export type IOffboardingAndReplaceResourcesQueryVariables = Exact<{
  squadRoleId: Scalars['String'];
}>;


export type IOffboardingAndReplaceResourcesQuery = { __typename: 'Query', offboardingAndReplaceResources: { __typename: 'EligibleCandidatesDto', jobType?: IJobTypeEnum | null | undefined, level?: IEmployeeLevel | null | undefined, name: string, profileId: string, profileImage?: string | null | undefined, rate?: number | null | undefined, role: string, skillMatchedPercent?: number | null | undefined, skills?: Array<string> | null | undefined, squadStatus?: IInvolvementStatus | null | undefined, employeeType?: IFuseEmployeementType | null | undefined, userId: string, roles?: Array<string> | null | undefined, designation?: string | null | undefined, prevEmpEndDate?: any | null | undefined, prevEmpStartDate?: any | null | undefined } };

export type IGetAllVerticalsQueryVariables = Exact<{ [key: string]: never; }>;


export type IGetAllVerticalsQuery = { getAllVerticals: Array<{ id?: string | null | undefined, name?: string | null | undefined }> };

export type IGetAllSquadsTechStackQueryVariables = Exact<{ [key: string]: never; }>;


export type IGetAllSquadsTechStackQuery = { getAllSquadsTechStack: Array<string> };

export type IGetAllLineOfBusinessQueryVariables = Exact<{ [key: string]: never; }>;


export type IGetAllLineOfBusinessQuery = { getAllLineOfBusiness: Array<{ name: string }> };

export type IGetRolesToAssignQueryVariables = Exact<{ [key: string]: never; }>;


export type IGetRolesToAssignQuery = { getRolesToAssign: Array<string> };

export type IExportCsvAssignedResourcesQueryVariables = Exact<{
  pageRequest: IPageRequest;
  squadId: Scalars['String'];
  userSquadHistorySearchDTO: IUserSquadHistorySearchDto;
}>;


export type IExportCsvAssignedResourcesQuery = { exportCsvAssignedResources: string };

export type IFindAllAdditionalNotesByUserSquadHistoryIdQueryVariables = Exact<{
  involvementHistoryId?: Maybe<Scalars['String']>;
  userSquadHistoryIds?: Maybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type IFindAllAdditionalNotesByUserSquadHistoryIdQuery = { findAllAdditionalNotesByUserSquadHistoryId: Array<{ createdAt?: any | null | undefined, id?: string | null | undefined, note?: string | null | undefined, noteType?: string | null | undefined, involvementHistoryId?: string | null | undefined, status?: string | null | undefined, modifications?: Array<{ modifiedField: string, newValue: string, oldValue: string } | null | undefined> | null | undefined, createdByUserInfo?: { email: string, fullname: string, profileId: string, profileImage?: string | null | undefined, userId: string } | null | undefined }> };

export type IGetRequiredResourceRolesInSquadQueryVariables = Exact<{
  squadId: Scalars['String'];
}>;


export type IGetRequiredResourceRolesInSquadQuery = { getRequiredResourceRolesInSquad: Array<string> };

export type IGetRthTemplateQueryVariables = Exact<{
  searchKey: Scalars['String'];
}>;


export type IGetRthTemplateQuery = { getRthTemplate: Array<{ billingCycle?: IJobBillingCycle | null | undefined, billingRate?: number | null | undefined, clientSelectionProcess?: string | null | undefined, department?: string | null | undefined, descriptionTemplateId?: string | null | undefined, endDate?: any | null | undefined, enterprisePeopleId?: string | null | undefined, evaluationCriteria?: string | null | undefined, experienceLevel?: IExperienceLevel | null | undefined, goodToHaveSkills?: Array<string> | null | undefined, horizontal?: string | null | undefined, id?: string | null | undefined, industry?: string | null | undefined, industryBackground?: string | null | undefined, jobCode?: string | null | undefined, jobDescription?: string | null | undefined, jobId?: string | null | undefined, jobPriority?: IJobPriority | null | undefined, jobStatus?: IJobStatus | null | undefined, jobType?: IEmploymentType | null | undefined, location?: Array<string> | null | undefined, locationToBeHiredFrom?: Array<string> | null | undefined, maximumBudget?: number | null | undefined, minimumBudget?: number | null | undefined, mustHaveSkills?: Array<string> | null | undefined, noOfVacancies?: number | null | undefined, numberOfResources?: number | null | undefined, projectDescription?: string | null | undefined, saveAsDraft?: boolean | null | undefined, softSkills?: Array<string> | null | undefined, squadEndDate?: any | null | undefined, squadId?: string | null | undefined, squadRoleId?: string | null | undefined, squadStartDate?: any | null | undefined, startDate?: any | null | undefined, technicalInterviewPanel?: string | null | undefined, templateTitle?: string | null | undefined, ticketId?: string | null | undefined, timeZone?: Array<string> | null | undefined, title?: string | null | undefined, travelRequirements?: string | null | undefined, typeOfWork?: IType_Of_Work | null | undefined, vertical?: string | null | undefined, yearsOfExperience?: number | null | undefined, previousReasonsForCandidateDisqualification?: string | null | undefined, contributingMembers?: Array<{ id: string, isCreator: boolean }> | null | undefined }> };

export type IGetRoleDetailsBySquadRoleIdQueryVariables = Exact<{
  squadId: Scalars['String'];
  squadRoleId: Scalars['String'];
}>;


export type IGetRoleDetailsBySquadRoleIdQuery = { getRoleDetailsBySquadRoleId: { createdBy?: string | null | undefined, department?: string | null | undefined, endDate?: any | null | undefined, estimatedEndDate?: any | null | undefined, estimatedStartDate?: any | null | undefined, experienceLevel?: string | null | undefined, isJobTemplateSaved?: boolean | null | undefined, isRequestedForHire?: boolean | null | undefined, jobType?: string | null | undefined, locationToBeHiredFrom?: Array<string> | null | undefined, numberOfCandidates?: number | null | undefined, offboardingCandidate?: number | null | undefined, phasesAssigned?: Array<string> | null | undefined, priority?: IPriorityEnum | null | undefined, rate?: number | null | undefined, region?: Array<string> | null | undefined, requiredForKickOff?: boolean | null | undefined, requiredSkills?: Array<string> | null | undefined, role?: string | null | undefined, roleDescription?: string | null | undefined, squadResourceId?: string | null | undefined, squadRoleId?: string | null | undefined, startDate?: any | null | undefined, ticketId?: string | null | undefined, timeZone?: Array<string> | null | undefined, workingHour?: number | null | undefined, yearsOfExperience?: number | null | undefined, softSkills?: Array<string> | null | undefined, goodToHaveSkills?: Array<string> | null | undefined, probableCandidates?: Array<{ employeeId?: string | null | undefined, name?: string | null | undefined, profileId?: string | null | undefined, profileImage?: string | null | undefined, userId?: string | null | undefined }> | null | undefined } };

export type IListSupervisorsQueryVariables = Exact<{
  listSupervisorsFilterDto?: Maybe<IListSupervisorsFilterDto>;
}>;


export type IListSupervisorsQuery = { listSupervisors: Array<{ designation?: string | null | undefined, email?: string | null | undefined, fullname?: string | null | undefined, id?: string | null | undefined }> };

export type IAddNewCommentMutationVariables = Exact<{
  comment: Scalars['String'];
  squadId: Scalars['String'];
  worklogId: Scalars['String'];
}>;


export type IAddNewCommentMutation = { addNewComment: { worklogId?: string | null | undefined, worklogStatus?: string | null | undefined, workedMinutes?: number | null | undefined, categories?: Array<string> | null | undefined, startDate?: any | null | undefined, endDate?: any | null | undefined, comments?: Array<{ content?: string | null | undefined, addedOn?: any | null | undefined, commentedBy?: { id: string, name?: string | null | undefined, level?: string | null | undefined, department?: string | null | undefined, designation?: string | null | undefined, profileImage?: string | null | undefined, roles?: string | null | undefined, squads?: Array<{ squadId: string, squadName?: string | null | undefined }> | null | undefined } | null | undefined }> | null | undefined } };

export type IApproveDeclineWorklogsMutationVariables = Exact<{
  worklogData: IApproveDeclineWorklogArgs;
}>;


export type IApproveDeclineWorklogsMutation = { approveDeclineWorklogs: boolean };

export type IWorklogLeaveApproveDeclineMutationVariables = Exact<{
  worklogLeaveApproveDeclineReq: IWorklogLeaveApproveDeclineReq;
}>;


export type IWorklogLeaveApproveDeclineMutation = { worklogLeaveApproveDecline: string };

export type IUpdateAllocatedTimeMutationVariables = Exact<{
  updateAllocatedTimePayload: IUpdateAllocatedTimePayload;
}>;


export type IUpdateAllocatedTimeMutation = { updateAllocatedTime: { allocatedMinutes: number, newAllocatedTimeId: string, note?: string | null | undefined, hourOverview: { allocatedTimeId?: string | null | undefined, notesCount: number, userSquadHistoryId?: string | null | undefined, totalAllocatedMinutes: number, overview: Array<{ status: string, totalMinutes: number }> } } };

export type IUpdateWorklogCloseDocumentMutationVariables = Exact<{
  worklogCloseFilter: IWorklogCloseStatusFilterDto;
}>;


export type IUpdateWorklogCloseDocumentMutation = { updateWorklogCloseDocument: string };

export type IGetWorklogOverviewQueryVariables = Exact<{
  worklogFilter: IWorklogFilter;
  worklogLeaveFilter?: Maybe<IWorklogLeaveFilter>;
}>;


export type IGetWorklogOverviewQuery = { getWorklogOverview: { worklogCount: Array<string>, hourOverview: { allocatedTimeId?: string | null | undefined, userSquadHistoryId?: string | null | undefined, notesCount: number, totalAllocatedMinutes: number, overview: Array<{ status: string, totalMinutes: number }> }, consultants: Array<{ id: string, name: string }>, categoryOverview: Array<{ category: string, totalMinutes: number }>, leaves?: { firstHalfLeaves?: number | null | undefined, secondHalfLeaves?: number | null | undefined, totalLeaves?: number | null | undefined, wholeDayLeaves?: number | null | undefined, totalApprovedLeaves?: number | null | undefined, futureLeaves?: number | null | undefined } | null | undefined } };

export type IGetWorklogRequestsQueryVariables = Exact<{
  worklogFilter: IWorklogFilter;
  pageRequest: IPageRequest;
  worklogLeaveFilter?: Maybe<IWorklogLeaveFilter>;
}>;


export type IGetWorklogRequestsQuery = { getWorklogRequests?: { closeEndDate?: any | null | undefined, closeStartDate?: any | null | undefined, closeStatus?: boolean | null | undefined, content: Array<{ closeStatus?: IWorklogCloseStatus | null | undefined, commentsCount?: number | null | undefined, endDate: any, id: string, isSaveAsDraft?: boolean | null | undefined, resubmittedCount: number, reviewedBy?: string | null | undefined, startDate: any, status: string, workedMinutes: number, worklogbatchId?: string | null | undefined, worklogtasks?: Array<{ category: string, description: string, endTime?: string | null | undefined, id: string, minutes: number, startTime?: string | null | undefined }> | null | undefined, leaveInfo?: Array<{ _id?: string | null | undefined, leaveStatus?: ILeaveStatus | null | undefined, leaveCategory?: string | null | undefined, leaveType?: ILeaveType | null | undefined, leaveRemarks?: string | null | undefined }> | null | undefined }>, pageable: { page: number, size: number, totalElements: number, totalPages: number } } | null | undefined };

export type IGetAssignedResourcesWorkLogTabQueryVariables = Exact<{
  squadId: Scalars['String'];
  userSquadHistorySearchDTO: IUserSquadHistorySearchDto;
  pageRequest: IPageRequest;
}>;


export type IGetAssignedResourcesWorkLogTabQuery = { getAssignedResourcesWorklogTab: { content: Array<{ employee: { userId: string, id: string, name: string, involvedAs?: string | null | undefined, jobType?: string | null | undefined, employeementType?: string | null | undefined, experienceLevel?: string | null | undefined, role?: string | null | undefined, profileImage?: string | null | undefined, workingHour?: number | null | undefined, department?: { name?: string | null | undefined } | null | undefined }, resourceWorklogs: { totalAllocatedMinutes: number, overview: Array<{ status: string, totalMinutes: number }> } }> } };

export type IGetUserDataQueryVariables = Exact<{
  userId: Scalars['String'];
  squadId?: Maybe<Scalars['String']>;
}>;


export type IGetUserDataQuery = { getUserData: { id: string, name?: string | null | undefined, profileImage?: string | null | undefined, canLoggedInUserApproveWorklog?: boolean | null | undefined, department?: string | null | undefined, designation?: string | null | undefined, level?: string | null | undefined, roles?: string | null | undefined, availability?: string | null | undefined, isAnApprover?: boolean | null | undefined, squads?: Array<{ squadId: string, squadName?: string | null | undefined }> | null | undefined } };

export type IListApproversQueryVariables = Exact<{
  listApproversFilterDto?: Maybe<IListApproversFilterDto>;
}>;


export type IListApproversQuery = { listApprovers: Array<{ designation?: string | null | undefined, id?: string | null | undefined, fullname?: string | null | undefined, email?: string | null | undefined }> };

export type IGetCommentsQueryVariables = Exact<{
  commentFilter: ICommentFilter;
}>;


export type IGetCommentsQuery = { getComments?: Array<{ worklogId?: string | null | undefined, worklogStatus?: string | null | undefined, workedMinutes?: number | null | undefined, categories?: Array<string> | null | undefined, startDate?: any | null | undefined, endDate?: any | null | undefined, comments?: Array<{ content?: string | null | undefined, addedOn?: any | null | undefined, commentedBy?: { id: string, name?: string | null | undefined, level?: string | null | undefined, department?: string | null | undefined, designation?: string | null | undefined, profileImage?: string | null | undefined, roles?: string | null | undefined, squads?: Array<{ squadId: string, squadName?: string | null | undefined }> | null | undefined } | null | undefined }> | null | undefined }> | null | undefined };

export type IGetSquadEmployeeIdsQueryVariables = Exact<{
  squadId: Scalars['String'];
  userSquadHistorySearchDto: IUserSquadHistorySearchDto;
}>;


export type IGetSquadEmployeeIdsQuery = { getSquadEmployeeIds: Array<string> };

export type IGetSquadInvoicingPeriodListQueryVariables = Exact<{
  squadId: Scalars['String'];
  userId?: Maybe<Scalars['String']>;
}>;


export type IGetSquadInvoicingPeriodListQuery = { getSquadInvoicingPeriodList: Array<{ invoiceNumber: number, periodStartDate: any, periodEndDate: any, label: string }> };

export type IExportWorklogQueryVariables = Exact<{
  filter: IExportAndInvoiceWorklogFilter;
}>;


export type IExportWorklogQuery = { exportWorklog: string };

export type IGetInvoiceRelateDataQueryVariables = Exact<{
  invoicingFilter: IExportAndInvoiceWorklogFilter;
}>;


export type IGetInvoiceRelateDataQuery = { getInvoiceRelateData: { clientAddress?: string | null | undefined, clientEmail?: string | null | undefined, clientName: string, invoicingDate: string, invoicingPeriod: string, squadName: string, employee: Array<{ employeeName: string, role: string, billingType?: string | null | undefined, employeeRate?: number | null | undefined, workingHour: number, roleType: string }> } };

export type IFetchNotesQueryVariables = Exact<{
  userSquadHistoryId: Scalars['String'];
}>;


export type IFetchNotesQuery = { fetchNotes: Array<{ allocatedMinutes?: number | null | undefined, allocatedTimeId?: string | null | undefined, note?: string | null | undefined, userSquadHistoryId?: string | null | undefined, updatedAt?: any | null | undefined, modifiedBy?: { email?: string | null | undefined, fullname?: string | null | undefined, profileImage?: string | null | undefined, userId?: string | null | undefined } | null | undefined }> };

export type IGetWorklogCloseDocumentQueryVariables = Exact<{
  worklogCloseFilter: IWorklogCloseStatusFilterDto;
}>;


export type IGetWorklogCloseDocumentQuery = { getWorklogCloseDocument: { closeEndDate?: any | null | undefined, closeStartDate?: any | null | undefined, status: IWorklogCloseStatus } };

export type ICreatePermissionGroupMutationVariables = Exact<{
  permissionGroupDto: IPermissionGroupDto;
}>;


export type ICreatePermissionGroupMutation = { createPermissionGroup: { id?: string | null | undefined, name: string, orgId: string, permissions: Array<string> } };

export type ICreatePersonaMutationVariables = Exact<{
  personaDto: IPersonaInputDto;
}>;


export type ICreatePersonaMutation = { createPersona: { id?: string | null | undefined, name?: string | null | undefined, orgId?: string | null | undefined, permissionGroupIds?: Array<string> | null | undefined } };

export type IAssignPersonaToUsersMutationVariables = Exact<{
  assignPersonaDto: IAssignPersonaDto;
}>;


export type IAssignPersonaToUsersMutation = { assignPersonaToUsers: string };

export type ICreatePermissionHierarchyMutationVariables = Exact<{
  permissionHierarchyDto: IPermissionHierarchyDto;
}>;


export type ICreatePermissionHierarchyMutation = { createPermissionHierarchy: { id?: string | null | undefined, description: string, parentId?: string | null | undefined, permission: string, selected?: boolean | null | undefined, title: string } };

export type IGetAllPermissionGroupsQueryVariables = Exact<{
  searchKey?: Maybe<Scalars['String']>;
}>;


export type IGetAllPermissionGroupsQuery = { getAllPermissionGroups: Array<{ _id?: string | null | undefined, name?: string | null | undefined, orgId?: string | null | undefined, permissions: Array<string>, description?: string | null | undefined, createdBy?: string | null | undefined, createdAt?: any | null | undefined }> };

export type IGetPermissionGroupByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type IGetPermissionGroupByIdQuery = { getPermissionGroupById: { _id?: string | null | undefined, name?: string | null | undefined, orgId?: string | null | undefined, permissions: Array<string>, description?: string | null | undefined, createdBy?: string | null | undefined, createdAt?: any | null | undefined } };

export type IGetAllPersonaQueryVariables = Exact<{
  searchKey: Scalars['String'];
}>;


export type IGetAllPersonaQuery = { getAllPersona: Array<{ id?: string | null | undefined, name?: string | null | undefined, orgId?: string | null | undefined, permissionGroupIds?: Array<string> | null | undefined, description?: string | null | undefined, createdBy?: string | null | undefined, createdAt?: any | null | undefined, permissionGroups?: Array<{ _id?: string | null | undefined, createdAt?: any | null | undefined, createdBy?: string | null | undefined, description?: string | null | undefined, name?: string | null | undefined, orgId?: string | null | undefined, permissions: Array<string> } | null | undefined> | null | undefined }> };

export type IGetPermissionHierarchyQueryVariables = Exact<{
  filterSelected?: Maybe<Scalars['Boolean']>;
  permissionGroupId?: Maybe<Scalars['String']>;
}>;


export type IGetPermissionHierarchyQuery = { getPermissionHierarchy?: Array<{ description: string, id?: string | null | undefined, parentId?: string | null | undefined, permission: string, selected?: boolean | null | undefined, title: string, type: IPermissionType, permissionHierarchy?: Array<{ description: string, id?: string | null | undefined, parentId?: string | null | undefined, permission: string, selected?: boolean | null | undefined, title: string, type: IPermissionType, permissionHierarchy?: Array<{ description: string, id?: string | null | undefined, parentId?: string | null | undefined, permission: string, selected?: boolean | null | undefined, title: string, type: IPermissionType, permissionHierarchy?: Array<{ description: string, id?: string | null | undefined, parentId?: string | null | undefined, permission: string, selected?: boolean | null | undefined, title: string, type: IPermissionType, permissionHierarchy?: Array<{ description: string, id?: string | null | undefined, parentId?: string | null | undefined, permission: string, selected?: boolean | null | undefined, title: string, type: IPermissionType, permissionHierarchy?: Array<{ description: string, id?: string | null | undefined, parentId?: string | null | undefined, permission: string, selected?: boolean | null | undefined, title: string, type: IPermissionType }> | null | undefined }> | null | undefined }> | null | undefined }> | null | undefined }> | null | undefined } | null | undefined> | null | undefined };

export type IGetUserListQueryVariables = Exact<{
  pageRequest?: Maybe<IPageRequest>;
  userListFilter: IUserListFilter;
}>;


export type IGetUserListQuery = { getUserList: { content: Array<{ userId?: string | null | undefined, email?: string | null | undefined, name?: string | null | undefined, department?: string | null | undefined, mainDepartment?: string | null | undefined, designation?: string | null | undefined, profileImage?: string | null | undefined, permissionGroup?: Array<{ id: string, name: string } | null | undefined> | null | undefined, personas?: Array<{ id: string, name: string } | null | undefined> | null | undefined }>, pageable: { page: number, size: number, totalElements: number, totalPages: number } } };

export type IGetUserListDropDownQueryVariables = Exact<{
  pageRequest?: Maybe<IPageRequest>;
  userListFilter: IUserListFilter;
}>;


export type IGetUserListDropDownQuery = { getUserListDropDown: { content: Array<{ userId?: string | null | undefined, email?: string | null | undefined, name?: string | null | undefined, department?: string | null | undefined, mainDepartment?: string | null | undefined, designation?: string | null | undefined, profileImage?: string | null | undefined, permissionGroup?: Array<{ id: string, name: string } | null | undefined> | null | undefined, personas?: Array<{ id: string, name: string } | null | undefined> | null | undefined }>, pageable: { page: number, size: number, totalElements: number, totalPages: number } } };

export type IGetPersonaByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type IGetPersonaByIdQuery = { getPersonaById: { id?: string | null | undefined, name?: string | null | undefined, orgId?: string | null | undefined, permissionGroupIds?: Array<string> | null | undefined, description?: string | null | undefined, createdBy?: string | null | undefined, createdAt?: any | null | undefined, permissionGroups?: Array<{ _id?: string | null | undefined, createdAt?: any | null | undefined, createdBy?: string | null | undefined, description?: string | null | undefined, name?: string | null | undefined, orgId?: string | null | undefined, permissions: Array<string> } | null | undefined> | null | undefined } };

export type IGetAllPermissionsQueryVariables = Exact<{ [key: string]: never; }>;


export type IGetAllPermissionsQuery = { getAllPermissions: Array<ICombined_Permissions> };

export const RoleDataFragmentDoc = gql`
    fragment roleData on roleData {
  levelData {
    count
    level
  }
  role
}
    `;
export const UserSquadHistoryFragmentDoc = gql`
    fragment userSquadHistory on UserSquadHistoryDTO {
  employeeActiveStatus
  currentSquad {
    clientName
    employeementType
    joinedDate
    squadName
    squadId
    clientId
    endDate
    jobType
  }
  employee {
    department
    mainDepartment
    name
    email
    employeeId
  }
  employeeJobType
  experience {
    role
    yearsOfExperience
  }
  availableSince
  availableFor
  rate
  designation
  skillsSet {
    mostProficientTechnologies
    softSkills
    somewhatProficientTechnologies
  }
  assignedDevices
  profileId
  userId
  resumeUrl
  profileImage
  region
  availability
  gender
  deploymentStatus
  shift
  employeeLevel
  roles
  resignDate
  supervisors {
    fullname
    email
  }
  skillsSet {
    softSkills
    mostProficientTechnologies
    somewhatProficientTechnologies
  }
  assignedDevicesList {
    assignedDate
    deviceCode
    deviceDescription
    deviceName
    _id
  }
  linkedinUrl
  githubUrl
  phoneNumber
  originalFilename
  timeZone
  joinedDate
  departmentInfo {
    id
    name
  }
  squadHistory {
    clientBillingRate
    clientId
    clientName
    clientType
    createdFromHubspot
    employeeBillingRate
    endDate
    involvedAs
    allocatedHours
    involvementHistory {
      _id
      endDate
      involvedAs
      involvementStatus
      jobType
      joinedDate
      modifiedBy
      modifiedOn
      role
      allocatedHours
      note
    }
    involvementStatus
    jobType
    joinedDate
    roleInSquad
    squadHistoryId
    squadId
    squadName
    squadType
  }
  currentWorkInfo {
    department {
      id
      name
    }
    deploymentStatus
    designation
    employeeId
    jobType
    level
    mainDepartment
    roles
    workShift
    optionExploring
    billable
    employeementType
  }
}
    `;
export const BasicInfoFragmentDoc = gql`
    fragment basicInfo on PersonalInfoDto {
  githubUrl
  linkedinUrl
  name
  phoneNumber
}
    `;
export const PersonalInfoFragmentDoc = gql`
    fragment personalInfo on PersonalInfoDto {
  countryOfResidence
  timeZone
}
    `;
export const BasicAndPersonalInfoFragmentDoc = gql`
    fragment basicAndPersonalInfo on PersonalInfoDto {
  githubUrl
  linkedinUrl
  name
  phoneNumber
  countryOfResidence
  timeZone
}
    `;
export const JobsFragmentDoc = gql`
    fragment jobs on Job {
  experienceLevel
  id
  jobCode
  jobDescription
  title
  location
  newResumes
  totalResumes
  squadId
}
    `;
export const ResumeImportLogFragmentDoc = gql`
    fragment resumeImportLog on ResumeImportLogObjectType {
  id
  jobId
  filterTestUsers
  roleAndLevel {
    role
    levelAndCount {
      level
      count
    }
  }
}
    `;
export const ParseResumeFragmentDoc = gql`
    fragment parseResume on ParsedResume {
  candidateStatus
  candidateStageStatus
  address
  region
  linkedinUrl
  githubUrl
  batchId
  createdAt
  email
  firstName
  id
  jobId
  userId
  lastName
  latestEmployer
  middleName
  phone
  resumeId
  resumeSource
  resumeUrl
  skills {
    hardSkills {
      category
      skill
    }
    softSkills
  }
  updatedAt
  addedBy
  yearsOfExperience
  noteCount
  score
  parseStatus
  remarks
  linkedinUrl
  githubUrl
  region
  addedBy
  location
}
    `;
export const JobFragmentDoc = gql`
    fragment job on Job {
  experienceLevel
  id
  jobCode
  jobDescription
  jobPriority
  mustHaveSkills
  goodToHaveSkills
  softSkills
  jobType
  location
  numberOfResources
  timeZone
  title
  billingCycle
  billingRate
  department
  squadId
  jobStatus
  descriptionTemplateId
  minimumBudget
  maximumBudget
  vertical
  industry
  horizontal
  startDate
  endDate
  squadStartDate
  squadEndDate
  yearsOfExperience
  locationToBeHiredFrom
}
    `;
export const SucceededUserFragmentDoc = gql`
    fragment succeededUser on UsersByRoleAndLevelDTO {
  role
  levels {
    count
    level
  }
}
    `;
export const NoteFragmentFragmentDoc = gql`
    fragment NoteFragment on AdditionalNoteResponseDto {
  createdAt
  id
  note
  noteType
  involvementHistoryId
  modifications {
    modifiedField
    newValue
    oldValue
  }
  status
  createdByUserInfo {
    email
    fullname
    profileId
    profileImage
    userId
  }
}
    `;
export const ColumnOrderFragmentFragmentDoc = gql`
    fragment ColumnOrderFragment on ColumnMetadata {
  columnName
  isPinned
  isVisible
  columnWidth
}
    `;
export const TableOrderFragmentFragmentDoc = gql`
    fragment TableOrderFragment on UserPreferenceType {
  tableMetadata {
    employeeListOrder {
      ...ColumnOrderFragment
    }
    clientListOrder {
      ...ColumnOrderFragment
    }
    cmSquadListOrder {
      ...ColumnOrderFragment
    }
    addResourceListOrder {
      ...ColumnOrderFragment
    }
    assignedResourcesOrder {
      ...ColumnOrderFragment
    }
    squadListOrder {
      ...ColumnOrderFragment
    }
    worklogDataListOrder {
      ...ColumnOrderFragment
    }
    requiredResourcesOrder {
      ...ColumnOrderFragment
    }
    jobCandidateList {
      ...ColumnOrderFragment
    }
    jobListOrder {
      ...ColumnOrderFragment
    }
    completedSquadListOrder {
      ...ColumnOrderFragment
    }
    notRunningSquadListOrder {
      ...ColumnOrderFragment
    }
  }
  userId
}
    ${ColumnOrderFragmentFragmentDoc}`;
export const GetFmClientDetailsDocument = gql`
    query getFmClientDetails {
  getFMClientById {
    id
    name
    startDate
    contacts {
      id
      name
      email
      number
      designation
    }
  }
}
    `;

/**
 * __useGetFmClientDetailsQuery__
 *
 * To run a query within a React component, call `useGetFmClientDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFmClientDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFmClientDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFmClientDetailsQuery(baseOptions?: Apollo.QueryHookOptions<IGetFmClientDetailsQuery, IGetFmClientDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetFmClientDetailsQuery, IGetFmClientDetailsQueryVariables>(GetFmClientDetailsDocument, options);
      }
export function useGetFmClientDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetFmClientDetailsQuery, IGetFmClientDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetFmClientDetailsQuery, IGetFmClientDetailsQueryVariables>(GetFmClientDetailsDocument, options);
        }
export type GetFmClientDetailsQueryHookResult = ReturnType<typeof useGetFmClientDetailsQuery>;
export type GetFmClientDetailsLazyQueryHookResult = ReturnType<typeof useGetFmClientDetailsLazyQuery>;
export type GetFmClientDetailsQueryResult = Apollo.QueryResult<IGetFmClientDetailsQuery, IGetFmClientDetailsQueryVariables>;
export const GetFmSquadDetailsDocument = gql`
    query getFmSquadDetails($search: String!) {
  getFMClientSpecificSquad(search: $search) {
    id
    name
    clientDepartment {
      id
      name
    }
    aiMembersCount
    techMembersCount
    totalMembersCount
    projectTier
    startDate
    activeStatus
    lineOfBusiness
  }
}
    `;

/**
 * __useGetFmSquadDetailsQuery__
 *
 * To run a query within a React component, call `useGetFmSquadDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFmSquadDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFmSquadDetailsQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetFmSquadDetailsQuery(baseOptions: Apollo.QueryHookOptions<IGetFmSquadDetailsQuery, IGetFmSquadDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetFmSquadDetailsQuery, IGetFmSquadDetailsQueryVariables>(GetFmSquadDetailsDocument, options);
      }
export function useGetFmSquadDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetFmSquadDetailsQuery, IGetFmSquadDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetFmSquadDetailsQuery, IGetFmSquadDetailsQueryVariables>(GetFmSquadDetailsDocument, options);
        }
export type GetFmSquadDetailsQueryHookResult = ReturnType<typeof useGetFmSquadDetailsQuery>;
export type GetFmSquadDetailsLazyQueryHookResult = ReturnType<typeof useGetFmSquadDetailsLazyQuery>;
export type GetFmSquadDetailsQueryResult = Apollo.QueryResult<IGetFmSquadDetailsQuery, IGetFmSquadDetailsQueryVariables>;
export const GetFmSpecificSquadDocument = gql`
    query getFmSpecificSquad($id: String!) {
  getFMSquadById(id: $id) {
    id
    name
    activeStatus
    client {
      id
      name
      startDate
      status
    }
    clientDepartment {
      id
      name
    }
    contacts {
      id
      name
      email
      number
      designation
    }
    lineOfBusiness
    projectTier
    startDate
    type
  }
}
    `;

/**
 * __useGetFmSpecificSquadQuery__
 *
 * To run a query within a React component, call `useGetFmSpecificSquadQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFmSpecificSquadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFmSpecificSquadQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetFmSpecificSquadQuery(baseOptions: Apollo.QueryHookOptions<IGetFmSpecificSquadQuery, IGetFmSpecificSquadQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetFmSpecificSquadQuery, IGetFmSpecificSquadQueryVariables>(GetFmSpecificSquadDocument, options);
      }
export function useGetFmSpecificSquadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetFmSpecificSquadQuery, IGetFmSpecificSquadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetFmSpecificSquadQuery, IGetFmSpecificSquadQueryVariables>(GetFmSpecificSquadDocument, options);
        }
export type GetFmSpecificSquadQueryHookResult = ReturnType<typeof useGetFmSpecificSquadQuery>;
export type GetFmSpecificSquadLazyQueryHookResult = ReturnType<typeof useGetFmSpecificSquadLazyQuery>;
export type GetFmSpecificSquadQueryResult = Apollo.QueryResult<IGetFmSpecificSquadQuery, IGetFmSpecificSquadQueryVariables>;
export const GetFmClientSquadAssignedResourcesDocument = gql`
    query GetFMClientSquadAssignedResources($id: String!, $userSquadHistorySearchDTO: UserSquadHistorySearchDTO!) {
  getFMClientSquadAssignedResources(
    id: $id
    userSquadHistorySearchDTO: $userSquadHistorySearchDTO
  ) {
    id
    name
    employeeList {
      id
      name
      department {
        id
        name
      }
      jobType
      experienceLevel
      role
      yearsOfExperience
      requiredSkills
    }
  }
}
    `;

/**
 * __useGetFmClientSquadAssignedResourcesQuery__
 *
 * To run a query within a React component, call `useGetFmClientSquadAssignedResourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFmClientSquadAssignedResourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFmClientSquadAssignedResourcesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      userSquadHistorySearchDTO: // value for 'userSquadHistorySearchDTO'
 *   },
 * });
 */
export function useGetFmClientSquadAssignedResourcesQuery(baseOptions: Apollo.QueryHookOptions<IGetFmClientSquadAssignedResourcesQuery, IGetFmClientSquadAssignedResourcesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetFmClientSquadAssignedResourcesQuery, IGetFmClientSquadAssignedResourcesQueryVariables>(GetFmClientSquadAssignedResourcesDocument, options);
      }
export function useGetFmClientSquadAssignedResourcesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetFmClientSquadAssignedResourcesQuery, IGetFmClientSquadAssignedResourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetFmClientSquadAssignedResourcesQuery, IGetFmClientSquadAssignedResourcesQueryVariables>(GetFmClientSquadAssignedResourcesDocument, options);
        }
export type GetFmClientSquadAssignedResourcesQueryHookResult = ReturnType<typeof useGetFmClientSquadAssignedResourcesQuery>;
export type GetFmClientSquadAssignedResourcesLazyQueryHookResult = ReturnType<typeof useGetFmClientSquadAssignedResourcesLazyQuery>;
export type GetFmClientSquadAssignedResourcesQueryResult = Apollo.QueryResult<IGetFmClientSquadAssignedResourcesQuery, IGetFmClientSquadAssignedResourcesQueryVariables>;
export const GetFmClientAssignedResourcesDocument = gql`
    query getFmClientAssignedResources($userSquadHistorySearchDTO: UserSquadHistorySearchDTO!) {
  getFMClientAssignedResources(
    userSquadHistorySearchDTO: $userSquadHistorySearchDTO
  ) {
    id
    name
    employeeList {
      id
      name
      department {
        id
        name
      }
      jobType
      experienceLevel
      role
      requiredSkills
      yearsOfExperience
    }
  }
}
    `;

/**
 * __useGetFmClientAssignedResourcesQuery__
 *
 * To run a query within a React component, call `useGetFmClientAssignedResourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFmClientAssignedResourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFmClientAssignedResourcesQuery({
 *   variables: {
 *      userSquadHistorySearchDTO: // value for 'userSquadHistorySearchDTO'
 *   },
 * });
 */
export function useGetFmClientAssignedResourcesQuery(baseOptions: Apollo.QueryHookOptions<IGetFmClientAssignedResourcesQuery, IGetFmClientAssignedResourcesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetFmClientAssignedResourcesQuery, IGetFmClientAssignedResourcesQueryVariables>(GetFmClientAssignedResourcesDocument, options);
      }
export function useGetFmClientAssignedResourcesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetFmClientAssignedResourcesQuery, IGetFmClientAssignedResourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetFmClientAssignedResourcesQuery, IGetFmClientAssignedResourcesQueryVariables>(GetFmClientAssignedResourcesDocument, options);
        }
export type GetFmClientAssignedResourcesQueryHookResult = ReturnType<typeof useGetFmClientAssignedResourcesQuery>;
export type GetFmClientAssignedResourcesLazyQueryHookResult = ReturnType<typeof useGetFmClientAssignedResourcesLazyQuery>;
export type GetFmClientAssignedResourcesQueryResult = Apollo.QueryResult<IGetFmClientAssignedResourcesQuery, IGetFmClientAssignedResourcesQueryVariables>;
export const GetFmSquadOverviewDetailDocument = gql`
    query getFmSquadOverviewDetail($id: String!) {
  getFMSquadOverview(id: $id) {
    AI {
      ...roleData
    }
    TECH {
      ...roleData
    }
    LEVEL
  }
}
    ${RoleDataFragmentDoc}`;

/**
 * __useGetFmSquadOverviewDetailQuery__
 *
 * To run a query within a React component, call `useGetFmSquadOverviewDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFmSquadOverviewDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFmSquadOverviewDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetFmSquadOverviewDetailQuery(baseOptions: Apollo.QueryHookOptions<IGetFmSquadOverviewDetailQuery, IGetFmSquadOverviewDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetFmSquadOverviewDetailQuery, IGetFmSquadOverviewDetailQueryVariables>(GetFmSquadOverviewDetailDocument, options);
      }
export function useGetFmSquadOverviewDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetFmSquadOverviewDetailQuery, IGetFmSquadOverviewDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetFmSquadOverviewDetailQuery, IGetFmSquadOverviewDetailQueryVariables>(GetFmSquadOverviewDetailDocument, options);
        }
export type GetFmSquadOverviewDetailQueryHookResult = ReturnType<typeof useGetFmSquadOverviewDetailQuery>;
export type GetFmSquadOverviewDetailLazyQueryHookResult = ReturnType<typeof useGetFmSquadOverviewDetailLazyQuery>;
export type GetFmSquadOverviewDetailQueryResult = Apollo.QueryResult<IGetFmSquadOverviewDetailQuery, IGetFmSquadOverviewDetailQueryVariables>;
export const GetRolesByClientOrSquadDocument = gql`
    query GetRolesByClientOrSquad($clientId: String, $squadId: String) {
  getRolesByClientOrSquad(clientId: $clientId, squadId: $squadId)
}
    `;

/**
 * __useGetRolesByClientOrSquadQuery__
 *
 * To run a query within a React component, call `useGetRolesByClientOrSquadQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRolesByClientOrSquadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRolesByClientOrSquadQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      squadId: // value for 'squadId'
 *   },
 * });
 */
export function useGetRolesByClientOrSquadQuery(baseOptions?: Apollo.QueryHookOptions<IGetRolesByClientOrSquadQuery, IGetRolesByClientOrSquadQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetRolesByClientOrSquadQuery, IGetRolesByClientOrSquadQueryVariables>(GetRolesByClientOrSquadDocument, options);
      }
export function useGetRolesByClientOrSquadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetRolesByClientOrSquadQuery, IGetRolesByClientOrSquadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetRolesByClientOrSquadQuery, IGetRolesByClientOrSquadQueryVariables>(GetRolesByClientOrSquadDocument, options);
        }
export type GetRolesByClientOrSquadQueryHookResult = ReturnType<typeof useGetRolesByClientOrSquadQuery>;
export type GetRolesByClientOrSquadLazyQueryHookResult = ReturnType<typeof useGetRolesByClientOrSquadLazyQuery>;
export type GetRolesByClientOrSquadQueryResult = Apollo.QueryResult<IGetRolesByClientOrSquadQuery, IGetRolesByClientOrSquadQueryVariables>;
export const GetSkillsByClientOrSquadDocument = gql`
    query GetSkillsByClientOrSquad($clientId: String, $squadId: String) {
  getSkillsByClientOrSquad(clientId: $clientId, squadId: $squadId)
}
    `;

/**
 * __useGetSkillsByClientOrSquadQuery__
 *
 * To run a query within a React component, call `useGetSkillsByClientOrSquadQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSkillsByClientOrSquadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSkillsByClientOrSquadQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      squadId: // value for 'squadId'
 *   },
 * });
 */
export function useGetSkillsByClientOrSquadQuery(baseOptions?: Apollo.QueryHookOptions<IGetSkillsByClientOrSquadQuery, IGetSkillsByClientOrSquadQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetSkillsByClientOrSquadQuery, IGetSkillsByClientOrSquadQueryVariables>(GetSkillsByClientOrSquadDocument, options);
      }
export function useGetSkillsByClientOrSquadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetSkillsByClientOrSquadQuery, IGetSkillsByClientOrSquadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetSkillsByClientOrSquadQuery, IGetSkillsByClientOrSquadQueryVariables>(GetSkillsByClientOrSquadDocument, options);
        }
export type GetSkillsByClientOrSquadQueryHookResult = ReturnType<typeof useGetSkillsByClientOrSquadQuery>;
export type GetSkillsByClientOrSquadLazyQueryHookResult = ReturnType<typeof useGetSkillsByClientOrSquadLazyQuery>;
export type GetSkillsByClientOrSquadQueryResult = Apollo.QueryResult<IGetSkillsByClientOrSquadQuery, IGetSkillsByClientOrSquadQueryVariables>;
export const FetchUnassignedClientListDocument = gql`
    query fetchUnassignedClientList($userId: String!) {
  getUnassignedClientListByUserId(userId: $userId) {
    id
    name
    clientType
    createdFromHubspot
  }
}
    `;

/**
 * __useFetchUnassignedClientListQuery__
 *
 * To run a query within a React component, call `useFetchUnassignedClientListQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchUnassignedClientListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchUnassignedClientListQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useFetchUnassignedClientListQuery(baseOptions: Apollo.QueryHookOptions<IFetchUnassignedClientListQuery, IFetchUnassignedClientListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IFetchUnassignedClientListQuery, IFetchUnassignedClientListQueryVariables>(FetchUnassignedClientListDocument, options);
      }
export function useFetchUnassignedClientListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IFetchUnassignedClientListQuery, IFetchUnassignedClientListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IFetchUnassignedClientListQuery, IFetchUnassignedClientListQueryVariables>(FetchUnassignedClientListDocument, options);
        }
export type FetchUnassignedClientListQueryHookResult = ReturnType<typeof useFetchUnassignedClientListQuery>;
export type FetchUnassignedClientListLazyQueryHookResult = ReturnType<typeof useFetchUnassignedClientListLazyQuery>;
export type FetchUnassignedClientListQueryResult = Apollo.QueryResult<IFetchUnassignedClientListQuery, IFetchUnassignedClientListQueryVariables>;
export const GetClientRolesDocument = gql`
    query getClientRoles($filter: GetClientRolesFilterDto!, $pageRequest: PageRequest!) {
  getClientRoles(filter: $filter, pageRequest: $pageRequest) {
    content {
      role
      probableCandidatesCount
      requiredCount
      startDate
      squadId
      squadName
      squadResourceId
      squadRoleId
      createdAt
      country
      reviewPendingCandidatesCount
      requiredCount
      status
      clientInfo {
        clientName
        clientId
      }
    }
    pageable {
      page
      totalPages
      size
      totalElements
    }
  }
}
    `;

/**
 * __useGetClientRolesQuery__
 *
 * To run a query within a React component, call `useGetClientRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientRolesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pageRequest: // value for 'pageRequest'
 *   },
 * });
 */
export function useGetClientRolesQuery(baseOptions: Apollo.QueryHookOptions<IGetClientRolesQuery, IGetClientRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetClientRolesQuery, IGetClientRolesQueryVariables>(GetClientRolesDocument, options);
      }
export function useGetClientRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetClientRolesQuery, IGetClientRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetClientRolesQuery, IGetClientRolesQueryVariables>(GetClientRolesDocument, options);
        }
export type GetClientRolesQueryHookResult = ReturnType<typeof useGetClientRolesQuery>;
export type GetClientRolesLazyQueryHookResult = ReturnType<typeof useGetClientRolesLazyQuery>;
export type GetClientRolesQueryResult = Apollo.QueryResult<IGetClientRolesQuery, IGetClientRolesQueryVariables>;
export const GetRoleCandidatesDocument = gql`
    query getRoleCandidates($filter: GetRoleCandidatesFilterDto!, $pageRequest: PageRequest!) {
  getRoleCandidates(filter: $filter, pageRequest: $pageRequest) {
    content {
      involvedAs
      involvementStatus
      involvementStatusForClients
      profileId
      softAssignedTill
      userId
      userName
      region
      profileImage
      resumeUrl
      skills
      role
      squadInfo {
        squadName
        squadId
      }
    }
    pageable {
      page
      totalPages
      size
      totalElements
    }
  }
}
    `;

/**
 * __useGetRoleCandidatesQuery__
 *
 * To run a query within a React component, call `useGetRoleCandidatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRoleCandidatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRoleCandidatesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pageRequest: // value for 'pageRequest'
 *   },
 * });
 */
export function useGetRoleCandidatesQuery(baseOptions: Apollo.QueryHookOptions<IGetRoleCandidatesQuery, IGetRoleCandidatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetRoleCandidatesQuery, IGetRoleCandidatesQueryVariables>(GetRoleCandidatesDocument, options);
      }
export function useGetRoleCandidatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetRoleCandidatesQuery, IGetRoleCandidatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetRoleCandidatesQuery, IGetRoleCandidatesQueryVariables>(GetRoleCandidatesDocument, options);
        }
export type GetRoleCandidatesQueryHookResult = ReturnType<typeof useGetRoleCandidatesQuery>;
export type GetRoleCandidatesLazyQueryHookResult = ReturnType<typeof useGetRoleCandidatesLazyQuery>;
export type GetRoleCandidatesQueryResult = Apollo.QueryResult<IGetRoleCandidatesQuery, IGetRoleCandidatesQueryVariables>;
export const SaveOrUpdateQueryDocument = gql`
    mutation saveOrUpdateQuery($savedQueryDto: SavedQueryReq!) {
  saveOrUpdateQuery(savedQueryDto: $savedQueryDto) {
    id
    listName
    query
    queryDescription
    queryName
    createdAt
    createdBy
  }
}
    `;
export type ISaveOrUpdateQueryMutationFn = Apollo.MutationFunction<ISaveOrUpdateQueryMutation, ISaveOrUpdateQueryMutationVariables>;

/**
 * __useSaveOrUpdateQueryMutation__
 *
 * To run a mutation, you first call `useSaveOrUpdateQueryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveOrUpdateQueryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveOrUpdateQueryMutation, { data, loading, error }] = useSaveOrUpdateQueryMutation({
 *   variables: {
 *      savedQueryDto: // value for 'savedQueryDto'
 *   },
 * });
 */
export function useSaveOrUpdateQueryMutation(baseOptions?: Apollo.MutationHookOptions<ISaveOrUpdateQueryMutation, ISaveOrUpdateQueryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ISaveOrUpdateQueryMutation, ISaveOrUpdateQueryMutationVariables>(SaveOrUpdateQueryDocument, options);
      }
export type SaveOrUpdateQueryMutationHookResult = ReturnType<typeof useSaveOrUpdateQueryMutation>;
export type SaveOrUpdateQueryMutationResult = Apollo.MutationResult<ISaveOrUpdateQueryMutation>;
export type SaveOrUpdateQueryMutationOptions = Apollo.BaseMutationOptions<ISaveOrUpdateQueryMutation, ISaveOrUpdateQueryMutationVariables>;
export const DeleteQueriesDocument = gql`
    mutation deleteQueries($queryIds: [String!]!) {
  deleteQueries(queryIds: $queryIds)
}
    `;
export type IDeleteQueriesMutationFn = Apollo.MutationFunction<IDeleteQueriesMutation, IDeleteQueriesMutationVariables>;

/**
 * __useDeleteQueriesMutation__
 *
 * To run a mutation, you first call `useDeleteQueriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteQueriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteQueriesMutation, { data, loading, error }] = useDeleteQueriesMutation({
 *   variables: {
 *      queryIds: // value for 'queryIds'
 *   },
 * });
 */
export function useDeleteQueriesMutation(baseOptions?: Apollo.MutationHookOptions<IDeleteQueriesMutation, IDeleteQueriesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IDeleteQueriesMutation, IDeleteQueriesMutationVariables>(DeleteQueriesDocument, options);
      }
export type DeleteQueriesMutationHookResult = ReturnType<typeof useDeleteQueriesMutation>;
export type DeleteQueriesMutationResult = Apollo.MutationResult<IDeleteQueriesMutation>;
export type DeleteQueriesMutationOptions = Apollo.BaseMutationOptions<IDeleteQueriesMutation, IDeleteQueriesMutationVariables>;
export const GetCustomQueryFieldDocument = gql`
    query getCustomQueryField($listName: String!) {
  getCustomQueryField(listName: $listName) {
    fields {
      fieldName
      fieldValues
      mapsTo
    }
    listName
  }
}
    `;

/**
 * __useGetCustomQueryFieldQuery__
 *
 * To run a query within a React component, call `useGetCustomQueryFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomQueryFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomQueryFieldQuery({
 *   variables: {
 *      listName: // value for 'listName'
 *   },
 * });
 */
export function useGetCustomQueryFieldQuery(baseOptions: Apollo.QueryHookOptions<IGetCustomQueryFieldQuery, IGetCustomQueryFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetCustomQueryFieldQuery, IGetCustomQueryFieldQueryVariables>(GetCustomQueryFieldDocument, options);
      }
export function useGetCustomQueryFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetCustomQueryFieldQuery, IGetCustomQueryFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetCustomQueryFieldQuery, IGetCustomQueryFieldQueryVariables>(GetCustomQueryFieldDocument, options);
        }
export type GetCustomQueryFieldQueryHookResult = ReturnType<typeof useGetCustomQueryFieldQuery>;
export type GetCustomQueryFieldLazyQueryHookResult = ReturnType<typeof useGetCustomQueryFieldLazyQuery>;
export type GetCustomQueryFieldQueryResult = Apollo.QueryResult<IGetCustomQueryFieldQuery, IGetCustomQueryFieldQueryVariables>;
export const GetSavedQueriesDocument = gql`
    query getSavedQueries($listName: String!, $searchKey: String!) {
  getSavedQueries(listName: $listName, searchKey: $searchKey) {
    id
    listName
    query
    queryDescription
    queryName
    createdAt
    createdBy
  }
}
    `;

/**
 * __useGetSavedQueriesQuery__
 *
 * To run a query within a React component, call `useGetSavedQueriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSavedQueriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSavedQueriesQuery({
 *   variables: {
 *      listName: // value for 'listName'
 *      searchKey: // value for 'searchKey'
 *   },
 * });
 */
export function useGetSavedQueriesQuery(baseOptions: Apollo.QueryHookOptions<IGetSavedQueriesQuery, IGetSavedQueriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetSavedQueriesQuery, IGetSavedQueriesQueryVariables>(GetSavedQueriesDocument, options);
      }
export function useGetSavedQueriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetSavedQueriesQuery, IGetSavedQueriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetSavedQueriesQuery, IGetSavedQueriesQueryVariables>(GetSavedQueriesDocument, options);
        }
export type GetSavedQueriesQueryHookResult = ReturnType<typeof useGetSavedQueriesQuery>;
export type GetSavedQueriesLazyQueryHookResult = ReturnType<typeof useGetSavedQueriesLazyQuery>;
export type GetSavedQueriesQueryResult = Apollo.QueryResult<IGetSavedQueriesQuery, IGetSavedQueriesQueryVariables>;
export const GetUserSquadHistoryDocument = gql`
    query getUserSquadHistory($pageRequest: PageRequest!, $searchDto: UserSquadHistoryAdvancedSearchDto!) {
  userSquadHistoriesAdvancedSearch(
    pageRequest: $pageRequest
    searchDto: $searchDto
  ) {
    content {
      ...userSquadHistory
    }
    pageable {
      page
      totalPages
      size
      totalElements
    }
  }
}
    ${UserSquadHistoryFragmentDoc}`;

/**
 * __useGetUserSquadHistoryQuery__
 *
 * To run a query within a React component, call `useGetUserSquadHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserSquadHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserSquadHistoryQuery({
 *   variables: {
 *      pageRequest: // value for 'pageRequest'
 *      searchDto: // value for 'searchDto'
 *   },
 * });
 */
export function useGetUserSquadHistoryQuery(baseOptions: Apollo.QueryHookOptions<IGetUserSquadHistoryQuery, IGetUserSquadHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetUserSquadHistoryQuery, IGetUserSquadHistoryQueryVariables>(GetUserSquadHistoryDocument, options);
      }
export function useGetUserSquadHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetUserSquadHistoryQuery, IGetUserSquadHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetUserSquadHistoryQuery, IGetUserSquadHistoryQueryVariables>(GetUserSquadHistoryDocument, options);
        }
export type GetUserSquadHistoryQueryHookResult = ReturnType<typeof useGetUserSquadHistoryQuery>;
export type GetUserSquadHistoryLazyQueryHookResult = ReturnType<typeof useGetUserSquadHistoryLazyQuery>;
export type GetUserSquadHistoryQueryResult = Apollo.QueryResult<IGetUserSquadHistoryQuery, IGetUserSquadHistoryQueryVariables>;
export const GetAvailabilityListDocument = gql`
    query getAvailabilityList {
  findBenchStatus {
    benchStatus
    benchType
  }
}
    `;

/**
 * __useGetAvailabilityListQuery__
 *
 * To run a query within a React component, call `useGetAvailabilityListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailabilityListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailabilityListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAvailabilityListQuery(baseOptions?: Apollo.QueryHookOptions<IGetAvailabilityListQuery, IGetAvailabilityListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetAvailabilityListQuery, IGetAvailabilityListQueryVariables>(GetAvailabilityListDocument, options);
      }
export function useGetAvailabilityListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetAvailabilityListQuery, IGetAvailabilityListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetAvailabilityListQuery, IGetAvailabilityListQueryVariables>(GetAvailabilityListDocument, options);
        }
export type GetAvailabilityListQueryHookResult = ReturnType<typeof useGetAvailabilityListQuery>;
export type GetAvailabilityListLazyQueryHookResult = ReturnType<typeof useGetAvailabilityListLazyQuery>;
export type GetAvailabilityListQueryResult = Apollo.QueryResult<IGetAvailabilityListQuery, IGetAvailabilityListQueryVariables>;
export const GetSubDepartmentsDocument = gql`
    query getSubDepartments {
  getSubDepartments {
    departments
    name
  }
}
    `;

/**
 * __useGetSubDepartmentsQuery__
 *
 * To run a query within a React component, call `useGetSubDepartmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubDepartmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubDepartmentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSubDepartmentsQuery(baseOptions?: Apollo.QueryHookOptions<IGetSubDepartmentsQuery, IGetSubDepartmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetSubDepartmentsQuery, IGetSubDepartmentsQueryVariables>(GetSubDepartmentsDocument, options);
      }
export function useGetSubDepartmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetSubDepartmentsQuery, IGetSubDepartmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetSubDepartmentsQuery, IGetSubDepartmentsQueryVariables>(GetSubDepartmentsDocument, options);
        }
export type GetSubDepartmentsQueryHookResult = ReturnType<typeof useGetSubDepartmentsQuery>;
export type GetSubDepartmentsLazyQueryHookResult = ReturnType<typeof useGetSubDepartmentsLazyQuery>;
export type GetSubDepartmentsQueryResult = Apollo.QueryResult<IGetSubDepartmentsQuery, IGetSubDepartmentsQueryVariables>;
export const GetRegionListDocument = gql`
    query getRegionList {
  getRegions {
    regions
  }
}
    `;

/**
 * __useGetRegionListQuery__
 *
 * To run a query within a React component, call `useGetRegionListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegionListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegionListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRegionListQuery(baseOptions?: Apollo.QueryHookOptions<IGetRegionListQuery, IGetRegionListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetRegionListQuery, IGetRegionListQueryVariables>(GetRegionListDocument, options);
      }
export function useGetRegionListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetRegionListQuery, IGetRegionListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetRegionListQuery, IGetRegionListQueryVariables>(GetRegionListDocument, options);
        }
export type GetRegionListQueryHookResult = ReturnType<typeof useGetRegionListQuery>;
export type GetRegionListLazyQueryHookResult = ReturnType<typeof useGetRegionListLazyQuery>;
export type GetRegionListQueryResult = Apollo.QueryResult<IGetRegionListQuery, IGetRegionListQueryVariables>;
export const GetDepartmentListDocument = gql`
    query getDepartmentList {
  getDepartments {
    name
  }
}
    `;

/**
 * __useGetDepartmentListQuery__
 *
 * To run a query within a React component, call `useGetDepartmentListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDepartmentListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDepartmentListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDepartmentListQuery(baseOptions?: Apollo.QueryHookOptions<IGetDepartmentListQuery, IGetDepartmentListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetDepartmentListQuery, IGetDepartmentListQueryVariables>(GetDepartmentListDocument, options);
      }
export function useGetDepartmentListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetDepartmentListQuery, IGetDepartmentListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetDepartmentListQuery, IGetDepartmentListQueryVariables>(GetDepartmentListDocument, options);
        }
export type GetDepartmentListQueryHookResult = ReturnType<typeof useGetDepartmentListQuery>;
export type GetDepartmentListLazyQueryHookResult = ReturnType<typeof useGetDepartmentListLazyQuery>;
export type GetDepartmentListQueryResult = Apollo.QueryResult<IGetDepartmentListQuery, IGetDepartmentListQueryVariables>;
export const GetRoleListDocument = gql`
    query getRoleList {
  findRoles {
    roles
  }
}
    `;

/**
 * __useGetRoleListQuery__
 *
 * To run a query within a React component, call `useGetRoleListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRoleListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRoleListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRoleListQuery(baseOptions?: Apollo.QueryHookOptions<IGetRoleListQuery, IGetRoleListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetRoleListQuery, IGetRoleListQueryVariables>(GetRoleListDocument, options);
      }
export function useGetRoleListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetRoleListQuery, IGetRoleListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetRoleListQuery, IGetRoleListQueryVariables>(GetRoleListDocument, options);
        }
export type GetRoleListQueryHookResult = ReturnType<typeof useGetRoleListQuery>;
export type GetRoleListLazyQueryHookResult = ReturnType<typeof useGetRoleListLazyQuery>;
export type GetRoleListQueryResult = Apollo.QueryResult<IGetRoleListQuery, IGetRoleListQueryVariables>;
export const GetSkillListDocument = gql`
    query getSkillList {
  findSkills {
    skills
  }
}
    `;

/**
 * __useGetSkillListQuery__
 *
 * To run a query within a React component, call `useGetSkillListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSkillListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSkillListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSkillListQuery(baseOptions?: Apollo.QueryHookOptions<IGetSkillListQuery, IGetSkillListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetSkillListQuery, IGetSkillListQueryVariables>(GetSkillListDocument, options);
      }
export function useGetSkillListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetSkillListQuery, IGetSkillListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetSkillListQuery, IGetSkillListQueryVariables>(GetSkillListDocument, options);
        }
export type GetSkillListQueryHookResult = ReturnType<typeof useGetSkillListQuery>;
export type GetSkillListLazyQueryHookResult = ReturnType<typeof useGetSkillListLazyQuery>;
export type GetSkillListQueryResult = Apollo.QueryResult<IGetSkillListQuery, IGetSkillListQueryVariables>;
export const GetEngagementLevelDocument = gql`
    query getEngagementLevel {
  findEngagementLevelTypes {
    engagementLevel
  }
}
    `;

/**
 * __useGetEngagementLevelQuery__
 *
 * To run a query within a React component, call `useGetEngagementLevelQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEngagementLevelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEngagementLevelQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEngagementLevelQuery(baseOptions?: Apollo.QueryHookOptions<IGetEngagementLevelQuery, IGetEngagementLevelQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetEngagementLevelQuery, IGetEngagementLevelQueryVariables>(GetEngagementLevelDocument, options);
      }
export function useGetEngagementLevelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetEngagementLevelQuery, IGetEngagementLevelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetEngagementLevelQuery, IGetEngagementLevelQueryVariables>(GetEngagementLevelDocument, options);
        }
export type GetEngagementLevelQueryHookResult = ReturnType<typeof useGetEngagementLevelQuery>;
export type GetEngagementLevelLazyQueryHookResult = ReturnType<typeof useGetEngagementLevelLazyQuery>;
export type GetEngagementLevelQueryResult = Apollo.QueryResult<IGetEngagementLevelQuery, IGetEngagementLevelQueryVariables>;
export const GetEmployeeLevelDocument = gql`
    query getEmployeeLevel {
  findEmployeeLevelTypes {
    employeeLevel
  }
}
    `;

/**
 * __useGetEmployeeLevelQuery__
 *
 * To run a query within a React component, call `useGetEmployeeLevelQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeeLevelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeeLevelQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEmployeeLevelQuery(baseOptions?: Apollo.QueryHookOptions<IGetEmployeeLevelQuery, IGetEmployeeLevelQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetEmployeeLevelQuery, IGetEmployeeLevelQueryVariables>(GetEmployeeLevelDocument, options);
      }
export function useGetEmployeeLevelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetEmployeeLevelQuery, IGetEmployeeLevelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetEmployeeLevelQuery, IGetEmployeeLevelQueryVariables>(GetEmployeeLevelDocument, options);
        }
export type GetEmployeeLevelQueryHookResult = ReturnType<typeof useGetEmployeeLevelQuery>;
export type GetEmployeeLevelLazyQueryHookResult = ReturnType<typeof useGetEmployeeLevelLazyQuery>;
export type GetEmployeeLevelQueryResult = Apollo.QueryResult<IGetEmployeeLevelQuery, IGetEmployeeLevelQueryVariables>;
export const GetClientAndSquadsListDocument = gql`
    query getClientAndSquadsList($clientType: String!) {
  findClientAndSquads(clientType: $clientType) {
    clientName
    squads
  }
}
    `;

/**
 * __useGetClientAndSquadsListQuery__
 *
 * To run a query within a React component, call `useGetClientAndSquadsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientAndSquadsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientAndSquadsListQuery({
 *   variables: {
 *      clientType: // value for 'clientType'
 *   },
 * });
 */
export function useGetClientAndSquadsListQuery(baseOptions: Apollo.QueryHookOptions<IGetClientAndSquadsListQuery, IGetClientAndSquadsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetClientAndSquadsListQuery, IGetClientAndSquadsListQueryVariables>(GetClientAndSquadsListDocument, options);
      }
export function useGetClientAndSquadsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetClientAndSquadsListQuery, IGetClientAndSquadsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetClientAndSquadsListQuery, IGetClientAndSquadsListQueryVariables>(GetClientAndSquadsListDocument, options);
        }
export type GetClientAndSquadsListQueryHookResult = ReturnType<typeof useGetClientAndSquadsListQuery>;
export type GetClientAndSquadsListLazyQueryHookResult = ReturnType<typeof useGetClientAndSquadsListLazyQuery>;
export type GetClientAndSquadsListQueryResult = Apollo.QueryResult<IGetClientAndSquadsListQuery, IGetClientAndSquadsListQueryVariables>;
export const GetAssignedDevicesDocument = gql`
    query getAssignedDevices {
  getAssignedDevices
}
    `;

/**
 * __useGetAssignedDevicesQuery__
 *
 * To run a query within a React component, call `useGetAssignedDevicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssignedDevicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssignedDevicesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAssignedDevicesQuery(baseOptions?: Apollo.QueryHookOptions<IGetAssignedDevicesQuery, IGetAssignedDevicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetAssignedDevicesQuery, IGetAssignedDevicesQueryVariables>(GetAssignedDevicesDocument, options);
      }
export function useGetAssignedDevicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetAssignedDevicesQuery, IGetAssignedDevicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetAssignedDevicesQuery, IGetAssignedDevicesQueryVariables>(GetAssignedDevicesDocument, options);
        }
export type GetAssignedDevicesQueryHookResult = ReturnType<typeof useGetAssignedDevicesQuery>;
export type GetAssignedDevicesLazyQueryHookResult = ReturnType<typeof useGetAssignedDevicesLazyQuery>;
export type GetAssignedDevicesQueryResult = Apollo.QueryResult<IGetAssignedDevicesQuery, IGetAssignedDevicesQueryVariables>;
export const GetAvailabilityOptionsDocument = gql`
    query getAvailabilityOptions {
  getAvailabilityOptions {
    label
    values
  }
}
    `;

/**
 * __useGetAvailabilityOptionsQuery__
 *
 * To run a query within a React component, call `useGetAvailabilityOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailabilityOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailabilityOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAvailabilityOptionsQuery(baseOptions?: Apollo.QueryHookOptions<IGetAvailabilityOptionsQuery, IGetAvailabilityOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetAvailabilityOptionsQuery, IGetAvailabilityOptionsQueryVariables>(GetAvailabilityOptionsDocument, options);
      }
export function useGetAvailabilityOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetAvailabilityOptionsQuery, IGetAvailabilityOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetAvailabilityOptionsQuery, IGetAvailabilityOptionsQueryVariables>(GetAvailabilityOptionsDocument, options);
        }
export type GetAvailabilityOptionsQueryHookResult = ReturnType<typeof useGetAvailabilityOptionsQuery>;
export type GetAvailabilityOptionsLazyQueryHookResult = ReturnType<typeof useGetAvailabilityOptionsLazyQuery>;
export type GetAvailabilityOptionsQueryResult = Apollo.QueryResult<IGetAvailabilityOptionsQuery, IGetAvailabilityOptionsQueryVariables>;
export const EmployeeListExportToCsvDocument = gql`
    query employeeListExportToCsv($exportAll: Boolean, $fileFormat: String!, $pageRequest: PageRequest!, $searchDto: UserSquadHistoryAdvancedSearchDto!) {
  employeeListExportToCsv(
    exportAll: $exportAll
    fileFormat: $fileFormat
    pageRequest: $pageRequest
    searchDto: $searchDto
  )
}
    `;

/**
 * __useEmployeeListExportToCsvQuery__
 *
 * To run a query within a React component, call `useEmployeeListExportToCsvQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeeListExportToCsvQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeeListExportToCsvQuery({
 *   variables: {
 *      exportAll: // value for 'exportAll'
 *      fileFormat: // value for 'fileFormat'
 *      pageRequest: // value for 'pageRequest'
 *      searchDto: // value for 'searchDto'
 *   },
 * });
 */
export function useEmployeeListExportToCsvQuery(baseOptions: Apollo.QueryHookOptions<IEmployeeListExportToCsvQuery, IEmployeeListExportToCsvQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IEmployeeListExportToCsvQuery, IEmployeeListExportToCsvQueryVariables>(EmployeeListExportToCsvDocument, options);
      }
export function useEmployeeListExportToCsvLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IEmployeeListExportToCsvQuery, IEmployeeListExportToCsvQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IEmployeeListExportToCsvQuery, IEmployeeListExportToCsvQueryVariables>(EmployeeListExportToCsvDocument, options);
        }
export type EmployeeListExportToCsvQueryHookResult = ReturnType<typeof useEmployeeListExportToCsvQuery>;
export type EmployeeListExportToCsvLazyQueryHookResult = ReturnType<typeof useEmployeeListExportToCsvLazyQuery>;
export type EmployeeListExportToCsvQueryResult = Apollo.QueryResult<IEmployeeListExportToCsvQuery, IEmployeeListExportToCsvQueryVariables>;
export const GetFieldHistoryDocument = gql`
    query getFieldHistory($fieldHistoryFilter: FieldHistoryFilterDto!, $pageRequest: PageRequest!) {
  getFieldHistory(
    fieldHistoryFilter: $fieldHistoryFilter
    pageRequest: $pageRequest
  ) {
    content {
      _id {
        day
        month
        year
      }
      changeLog {
        _id
        operationType
        modifiedBy {
          userId
          profileId
          name
          email
          profileImage
        }
        modifications {
          modifiedField
          newValue
          oldValue
        }
        createdAt
      }
    }
    pageable {
      totalElements
    }
  }
}
    `;

/**
 * __useGetFieldHistoryQuery__
 *
 * To run a query within a React component, call `useGetFieldHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFieldHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFieldHistoryQuery({
 *   variables: {
 *      fieldHistoryFilter: // value for 'fieldHistoryFilter'
 *      pageRequest: // value for 'pageRequest'
 *   },
 * });
 */
export function useGetFieldHistoryQuery(baseOptions: Apollo.QueryHookOptions<IGetFieldHistoryQuery, IGetFieldHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetFieldHistoryQuery, IGetFieldHistoryQueryVariables>(GetFieldHistoryDocument, options);
      }
export function useGetFieldHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetFieldHistoryQuery, IGetFieldHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetFieldHistoryQuery, IGetFieldHistoryQueryVariables>(GetFieldHistoryDocument, options);
        }
export type GetFieldHistoryQueryHookResult = ReturnType<typeof useGetFieldHistoryQuery>;
export type GetFieldHistoryLazyQueryHookResult = ReturnType<typeof useGetFieldHistoryLazyQuery>;
export type GetFieldHistoryQueryResult = Apollo.QueryResult<IGetFieldHistoryQuery, IGetFieldHistoryQueryVariables>;
export const UpdateBasicInfoDocument = gql`
    mutation UpdateBasicInfo($file: Upload, $personalInfoDto: UpdateBasicInfoDto!, $profileId: String!, $profilePic: Upload) {
  updateBasicInfo(
    file: $file
    personalInfoDto: $personalInfoDto
    profileId: $profileId
    profilePic: $profilePic
  ) {
    personalInfo {
      ...basicInfo
    }
  }
}
    ${BasicInfoFragmentDoc}`;
export type IUpdateBasicInfoMutationFn = Apollo.MutationFunction<IUpdateBasicInfoMutation, IUpdateBasicInfoMutationVariables>;

/**
 * __useUpdateBasicInfoMutation__
 *
 * To run a mutation, you first call `useUpdateBasicInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBasicInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBasicInfoMutation, { data, loading, error }] = useUpdateBasicInfoMutation({
 *   variables: {
 *      file: // value for 'file'
 *      personalInfoDto: // value for 'personalInfoDto'
 *      profileId: // value for 'profileId'
 *      profilePic: // value for 'profilePic'
 *   },
 * });
 */
export function useUpdateBasicInfoMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateBasicInfoMutation, IUpdateBasicInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateBasicInfoMutation, IUpdateBasicInfoMutationVariables>(UpdateBasicInfoDocument, options);
      }
export type UpdateBasicInfoMutationHookResult = ReturnType<typeof useUpdateBasicInfoMutation>;
export type UpdateBasicInfoMutationResult = Apollo.MutationResult<IUpdateBasicInfoMutation>;
export type UpdateBasicInfoMutationOptions = Apollo.BaseMutationOptions<IUpdateBasicInfoMutation, IUpdateBasicInfoMutationVariables>;
export const UpdatePersonalInfoDocument = gql`
    mutation UpdatePersonalInfo($personalInfoDto: UpdatePersonalInfoDto!, $profileId: String!) {
  updatePersonalInfo(personalInfoDto: $personalInfoDto, profileId: $profileId) {
    personalInfo {
      ...personalInfo
    }
  }
}
    ${PersonalInfoFragmentDoc}`;
export type IUpdatePersonalInfoMutationFn = Apollo.MutationFunction<IUpdatePersonalInfoMutation, IUpdatePersonalInfoMutationVariables>;

/**
 * __useUpdatePersonalInfoMutation__
 *
 * To run a mutation, you first call `useUpdatePersonalInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePersonalInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePersonalInfoMutation, { data, loading, error }] = useUpdatePersonalInfoMutation({
 *   variables: {
 *      personalInfoDto: // value for 'personalInfoDto'
 *      profileId: // value for 'profileId'
 *   },
 * });
 */
export function useUpdatePersonalInfoMutation(baseOptions?: Apollo.MutationHookOptions<IUpdatePersonalInfoMutation, IUpdatePersonalInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdatePersonalInfoMutation, IUpdatePersonalInfoMutationVariables>(UpdatePersonalInfoDocument, options);
      }
export type UpdatePersonalInfoMutationHookResult = ReturnType<typeof useUpdatePersonalInfoMutation>;
export type UpdatePersonalInfoMutationResult = Apollo.MutationResult<IUpdatePersonalInfoMutation>;
export type UpdatePersonalInfoMutationOptions = Apollo.BaseMutationOptions<IUpdatePersonalInfoMutation, IUpdatePersonalInfoMutationVariables>;
export const UpdateBasicInfoAndPersonalInfoDocument = gql`
    mutation updateBasicInfoAndPersonalInfo($file: Upload, $dto: UpdateBasicInfoDto!, $profileId: String!, $profilePic: Upload, $personalInfoDto: UpdatePersonalInfoDto!) {
  updateBasicInfoAndPersonalInfo(
    file: $file
    dto: $dto
    profileId: $profileId
    profilePic: $profilePic
    personalInfoDto: $personalInfoDto
  ) {
    personalInfo {
      ...basicAndPersonalInfo
    }
  }
}
    ${BasicAndPersonalInfoFragmentDoc}`;
export type IUpdateBasicInfoAndPersonalInfoMutationFn = Apollo.MutationFunction<IUpdateBasicInfoAndPersonalInfoMutation, IUpdateBasicInfoAndPersonalInfoMutationVariables>;

/**
 * __useUpdateBasicInfoAndPersonalInfoMutation__
 *
 * To run a mutation, you first call `useUpdateBasicInfoAndPersonalInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBasicInfoAndPersonalInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBasicInfoAndPersonalInfoMutation, { data, loading, error }] = useUpdateBasicInfoAndPersonalInfoMutation({
 *   variables: {
 *      file: // value for 'file'
 *      dto: // value for 'dto'
 *      profileId: // value for 'profileId'
 *      profilePic: // value for 'profilePic'
 *      personalInfoDto: // value for 'personalInfoDto'
 *   },
 * });
 */
export function useUpdateBasicInfoAndPersonalInfoMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateBasicInfoAndPersonalInfoMutation, IUpdateBasicInfoAndPersonalInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateBasicInfoAndPersonalInfoMutation, IUpdateBasicInfoAndPersonalInfoMutationVariables>(UpdateBasicInfoAndPersonalInfoDocument, options);
      }
export type UpdateBasicInfoAndPersonalInfoMutationHookResult = ReturnType<typeof useUpdateBasicInfoAndPersonalInfoMutation>;
export type UpdateBasicInfoAndPersonalInfoMutationResult = Apollo.MutationResult<IUpdateBasicInfoAndPersonalInfoMutation>;
export type UpdateBasicInfoAndPersonalInfoMutationOptions = Apollo.BaseMutationOptions<IUpdateBasicInfoAndPersonalInfoMutation, IUpdateBasicInfoAndPersonalInfoMutationVariables>;
export const UpdateWorkInfoDocument = gql`
    mutation UpdateWorkInfo($workInfoDto: UpdateWorkInfoDto!, $profileId: String!) {
  updateWorkInfo(workInfoDto: $workInfoDto, profileId: $profileId) {
    paymentOption {
      billingAmount
      billingType
    }
  }
}
    `;
export type IUpdateWorkInfoMutationFn = Apollo.MutationFunction<IUpdateWorkInfoMutation, IUpdateWorkInfoMutationVariables>;

/**
 * __useUpdateWorkInfoMutation__
 *
 * To run a mutation, you first call `useUpdateWorkInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkInfoMutation, { data, loading, error }] = useUpdateWorkInfoMutation({
 *   variables: {
 *      workInfoDto: // value for 'workInfoDto'
 *      profileId: // value for 'profileId'
 *   },
 * });
 */
export function useUpdateWorkInfoMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateWorkInfoMutation, IUpdateWorkInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateWorkInfoMutation, IUpdateWorkInfoMutationVariables>(UpdateWorkInfoDocument, options);
      }
export type UpdateWorkInfoMutationHookResult = ReturnType<typeof useUpdateWorkInfoMutation>;
export type UpdateWorkInfoMutationResult = Apollo.MutationResult<IUpdateWorkInfoMutation>;
export type UpdateWorkInfoMutationOptions = Apollo.BaseMutationOptions<IUpdateWorkInfoMutation, IUpdateWorkInfoMutationVariables>;
export const UpdateSkillsDocument = gql`
    mutation UpdateSkills($skillDto: SkillsReqDto!, $profileId: String!) {
  updateSkills(skillDto: $skillDto, profileId: $profileId) {
    skills {
      mostProficientTechnologies
      somewhatProficientTechnologies
      softSkills
    }
  }
}
    `;
export type IUpdateSkillsMutationFn = Apollo.MutationFunction<IUpdateSkillsMutation, IUpdateSkillsMutationVariables>;

/**
 * __useUpdateSkillsMutation__
 *
 * To run a mutation, you first call `useUpdateSkillsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSkillsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSkillsMutation, { data, loading, error }] = useUpdateSkillsMutation({
 *   variables: {
 *      skillDto: // value for 'skillDto'
 *      profileId: // value for 'profileId'
 *   },
 * });
 */
export function useUpdateSkillsMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateSkillsMutation, IUpdateSkillsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateSkillsMutation, IUpdateSkillsMutationVariables>(UpdateSkillsDocument, options);
      }
export type UpdateSkillsMutationHookResult = ReturnType<typeof useUpdateSkillsMutation>;
export type UpdateSkillsMutationResult = Apollo.MutationResult<IUpdateSkillsMutation>;
export type UpdateSkillsMutationOptions = Apollo.BaseMutationOptions<IUpdateSkillsMutation, IUpdateSkillsMutationVariables>;
export const UpdateWorkExperienceDocument = gql`
    mutation UpdateWorkExperience($workExperience: workExperienceInputDto!, $profileId: String!) {
  updateWorkExperience(workExperience: $workExperience, profileId: $profileId) {
    experience {
      roles
      yearsOfExperienceInRoles {
        role
        yearsOfExperience
      }
    }
  }
}
    `;
export type IUpdateWorkExperienceMutationFn = Apollo.MutationFunction<IUpdateWorkExperienceMutation, IUpdateWorkExperienceMutationVariables>;

/**
 * __useUpdateWorkExperienceMutation__
 *
 * To run a mutation, you first call `useUpdateWorkExperienceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkExperienceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkExperienceMutation, { data, loading, error }] = useUpdateWorkExperienceMutation({
 *   variables: {
 *      workExperience: // value for 'workExperience'
 *      profileId: // value for 'profileId'
 *   },
 * });
 */
export function useUpdateWorkExperienceMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateWorkExperienceMutation, IUpdateWorkExperienceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateWorkExperienceMutation, IUpdateWorkExperienceMutationVariables>(UpdateWorkExperienceDocument, options);
      }
export type UpdateWorkExperienceMutationHookResult = ReturnType<typeof useUpdateWorkExperienceMutation>;
export type UpdateWorkExperienceMutationResult = Apollo.MutationResult<IUpdateWorkExperienceMutation>;
export type UpdateWorkExperienceMutationOptions = Apollo.BaseMutationOptions<IUpdateWorkExperienceMutation, IUpdateWorkExperienceMutationVariables>;
export const RemoveSquadHistoryDocument = gql`
    mutation RemoveSquadHistory($squadHistoryId: String!, $userId: String!) {
  removeSquadHistory(squadHistoryId: $squadHistoryId, userId: $userId)
}
    `;
export type IRemoveSquadHistoryMutationFn = Apollo.MutationFunction<IRemoveSquadHistoryMutation, IRemoveSquadHistoryMutationVariables>;

/**
 * __useRemoveSquadHistoryMutation__
 *
 * To run a mutation, you first call `useRemoveSquadHistoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveSquadHistoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeSquadHistoryMutation, { data, loading, error }] = useRemoveSquadHistoryMutation({
 *   variables: {
 *      squadHistoryId: // value for 'squadHistoryId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useRemoveSquadHistoryMutation(baseOptions?: Apollo.MutationHookOptions<IRemoveSquadHistoryMutation, IRemoveSquadHistoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IRemoveSquadHistoryMutation, IRemoveSquadHistoryMutationVariables>(RemoveSquadHistoryDocument, options);
      }
export type RemoveSquadHistoryMutationHookResult = ReturnType<typeof useRemoveSquadHistoryMutation>;
export type RemoveSquadHistoryMutationResult = Apollo.MutationResult<IRemoveSquadHistoryMutation>;
export type RemoveSquadHistoryMutationOptions = Apollo.BaseMutationOptions<IRemoveSquadHistoryMutation, IRemoveSquadHistoryMutationVariables>;
export const UpdateEducationDocument = gql`
    mutation UpdateEducation($educationDto: [educationRequestDto!]!, $profileId: String!) {
  updateEducation(educationDto: $educationDto, profileId: $profileId) {
    education {
      completedOn {
        month
        year
      }
      currentlyStudying
      degree
      fieldOfStudy
      isEducationFormCompleted
      joinedOn {
        month
        year
      }
      levelOfEducation
      school
    }
  }
}
    `;
export type IUpdateEducationMutationFn = Apollo.MutationFunction<IUpdateEducationMutation, IUpdateEducationMutationVariables>;

/**
 * __useUpdateEducationMutation__
 *
 * To run a mutation, you first call `useUpdateEducationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEducationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEducationMutation, { data, loading, error }] = useUpdateEducationMutation({
 *   variables: {
 *      educationDto: // value for 'educationDto'
 *      profileId: // value for 'profileId'
 *   },
 * });
 */
export function useUpdateEducationMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateEducationMutation, IUpdateEducationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateEducationMutation, IUpdateEducationMutationVariables>(UpdateEducationDocument, options);
      }
export type UpdateEducationMutationHookResult = ReturnType<typeof useUpdateEducationMutation>;
export type UpdateEducationMutationResult = Apollo.MutationResult<IUpdateEducationMutation>;
export type UpdateEducationMutationOptions = Apollo.BaseMutationOptions<IUpdateEducationMutation, IUpdateEducationMutationVariables>;
export const UpdateJobExperienceDocument = gql`
    mutation UpdateJobExperience($jobExperienceDto: [JobExperienceInputDto!]!, $profileId: String!) {
  updateJobExperience(jobExperienceDto: $jobExperienceDto, profileId: $profileId) {
    jobExperience {
      companyName
      currentlyEmployed
      jobEndDate {
        month
        year
      }
      jobLocation
      jobStartDate {
        month
        year
      }
      jobTitle
      rolesAndResponsibility
    }
  }
}
    `;
export type IUpdateJobExperienceMutationFn = Apollo.MutationFunction<IUpdateJobExperienceMutation, IUpdateJobExperienceMutationVariables>;

/**
 * __useUpdateJobExperienceMutation__
 *
 * To run a mutation, you first call `useUpdateJobExperienceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateJobExperienceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateJobExperienceMutation, { data, loading, error }] = useUpdateJobExperienceMutation({
 *   variables: {
 *      jobExperienceDto: // value for 'jobExperienceDto'
 *      profileId: // value for 'profileId'
 *   },
 * });
 */
export function useUpdateJobExperienceMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateJobExperienceMutation, IUpdateJobExperienceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateJobExperienceMutation, IUpdateJobExperienceMutationVariables>(UpdateJobExperienceDocument, options);
      }
export type UpdateJobExperienceMutationHookResult = ReturnType<typeof useUpdateJobExperienceMutation>;
export type UpdateJobExperienceMutationResult = Apollo.MutationResult<IUpdateJobExperienceMutation>;
export type UpdateJobExperienceMutationOptions = Apollo.BaseMutationOptions<IUpdateJobExperienceMutation, IUpdateJobExperienceMutationVariables>;
export const AddTrainingCertificateDocument = gql`
    mutation addTrainingCertificate($uploads: [Upload!]!, $createTrainingCertificateInput: CreateTrainingCertificateDto!) {
  addTrainingCertificate(
    createTrainingCertificateInput: $createTrainingCertificateInput
    uploads: $uploads
  ) {
    id
    certificateId
    certificateTitle
    currentlyStudying
    endDate
    instructor
    issuingInstituionOrOrganization
    profileId
    startDate
    uploads {
      filename
      url
    }
  }
}
    `;
export type IAddTrainingCertificateMutationFn = Apollo.MutationFunction<IAddTrainingCertificateMutation, IAddTrainingCertificateMutationVariables>;

/**
 * __useAddTrainingCertificateMutation__
 *
 * To run a mutation, you first call `useAddTrainingCertificateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTrainingCertificateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTrainingCertificateMutation, { data, loading, error }] = useAddTrainingCertificateMutation({
 *   variables: {
 *      uploads: // value for 'uploads'
 *      createTrainingCertificateInput: // value for 'createTrainingCertificateInput'
 *   },
 * });
 */
export function useAddTrainingCertificateMutation(baseOptions?: Apollo.MutationHookOptions<IAddTrainingCertificateMutation, IAddTrainingCertificateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IAddTrainingCertificateMutation, IAddTrainingCertificateMutationVariables>(AddTrainingCertificateDocument, options);
      }
export type AddTrainingCertificateMutationHookResult = ReturnType<typeof useAddTrainingCertificateMutation>;
export type AddTrainingCertificateMutationResult = Apollo.MutationResult<IAddTrainingCertificateMutation>;
export type AddTrainingCertificateMutationOptions = Apollo.BaseMutationOptions<IAddTrainingCertificateMutation, IAddTrainingCertificateMutationVariables>;
export const UpdateTrainingCertificateDocument = gql`
    mutation updateTrainingCertificate($updateTrainingCertificateInput: UpdateTrainingCertificateDto!, $trainingCertificateId: String!, $uploads: [Upload!]!) {
  updateTrainingCertificate(
    trainingCertificateId: $trainingCertificateId
    updateTrainingCertificateInput: $updateTrainingCertificateInput
    uploads: $uploads
  ) {
    certificateId
    certificateTitle
    currentlyStudying
    endDate
    id
    instructor
    uploads {
      filename
      url
    }
    issuingInstituionOrOrganization
    profileId
    startDate
  }
}
    `;
export type IUpdateTrainingCertificateMutationFn = Apollo.MutationFunction<IUpdateTrainingCertificateMutation, IUpdateTrainingCertificateMutationVariables>;

/**
 * __useUpdateTrainingCertificateMutation__
 *
 * To run a mutation, you first call `useUpdateTrainingCertificateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTrainingCertificateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTrainingCertificateMutation, { data, loading, error }] = useUpdateTrainingCertificateMutation({
 *   variables: {
 *      updateTrainingCertificateInput: // value for 'updateTrainingCertificateInput'
 *      trainingCertificateId: // value for 'trainingCertificateId'
 *      uploads: // value for 'uploads'
 *   },
 * });
 */
export function useUpdateTrainingCertificateMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateTrainingCertificateMutation, IUpdateTrainingCertificateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateTrainingCertificateMutation, IUpdateTrainingCertificateMutationVariables>(UpdateTrainingCertificateDocument, options);
      }
export type UpdateTrainingCertificateMutationHookResult = ReturnType<typeof useUpdateTrainingCertificateMutation>;
export type UpdateTrainingCertificateMutationResult = Apollo.MutationResult<IUpdateTrainingCertificateMutation>;
export type UpdateTrainingCertificateMutationOptions = Apollo.BaseMutationOptions<IUpdateTrainingCertificateMutation, IUpdateTrainingCertificateMutationVariables>;
export const DeleteTrainingCertificateDocument = gql`
    mutation deleteTrainingCertificate($traniningCertificateId: String!) {
  deleteTrainingCertificate(traniningCertificateId: $traniningCertificateId) {
    id
  }
}
    `;
export type IDeleteTrainingCertificateMutationFn = Apollo.MutationFunction<IDeleteTrainingCertificateMutation, IDeleteTrainingCertificateMutationVariables>;

/**
 * __useDeleteTrainingCertificateMutation__
 *
 * To run a mutation, you first call `useDeleteTrainingCertificateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTrainingCertificateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTrainingCertificateMutation, { data, loading, error }] = useDeleteTrainingCertificateMutation({
 *   variables: {
 *      traniningCertificateId: // value for 'traniningCertificateId'
 *   },
 * });
 */
export function useDeleteTrainingCertificateMutation(baseOptions?: Apollo.MutationHookOptions<IDeleteTrainingCertificateMutation, IDeleteTrainingCertificateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IDeleteTrainingCertificateMutation, IDeleteTrainingCertificateMutationVariables>(DeleteTrainingCertificateDocument, options);
      }
export type DeleteTrainingCertificateMutationHookResult = ReturnType<typeof useDeleteTrainingCertificateMutation>;
export type DeleteTrainingCertificateMutationResult = Apollo.MutationResult<IDeleteTrainingCertificateMutation>;
export type DeleteTrainingCertificateMutationOptions = Apollo.BaseMutationOptions<IDeleteTrainingCertificateMutation, IDeleteTrainingCertificateMutationVariables>;
export const AddCandidateDocument = gql`
    mutation AddCandidate($aboutyou: AboutYouDtoAddCandidate!, $file: Upload, $jobdescription: Upload, $profileId: String!) {
  addCandidate(
    aboutyou: $aboutyou
    file: $file
    jobdescription: $jobdescription
    profileId: $profileId
  ) {
    id
    resumeUrl
    jobDescriptionUrl
    email
    firstName
    lastName
    countryOfResidence
    timeZone
    linkedinUrl
    githubUrl
    phoneNumber
    seekingNewRole
    optionExploring
    startDate
    paymentOption {
      billingType
      billingAmount
    }
    originalFilename
    jobDescriptionFileName
  }
}
    `;
export type IAddCandidateMutationFn = Apollo.MutationFunction<IAddCandidateMutation, IAddCandidateMutationVariables>;

/**
 * __useAddCandidateMutation__
 *
 * To run a mutation, you first call `useAddCandidateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCandidateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCandidateMutation, { data, loading, error }] = useAddCandidateMutation({
 *   variables: {
 *      aboutyou: // value for 'aboutyou'
 *      file: // value for 'file'
 *      jobdescription: // value for 'jobdescription'
 *      profileId: // value for 'profileId'
 *   },
 * });
 */
export function useAddCandidateMutation(baseOptions?: Apollo.MutationHookOptions<IAddCandidateMutation, IAddCandidateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IAddCandidateMutation, IAddCandidateMutationVariables>(AddCandidateDocument, options);
      }
export type AddCandidateMutationHookResult = ReturnType<typeof useAddCandidateMutation>;
export type AddCandidateMutationResult = Apollo.MutationResult<IAddCandidateMutation>;
export type AddCandidateMutationOptions = Apollo.BaseMutationOptions<IAddCandidateMutation, IAddCandidateMutationVariables>;
export const AddSkillSetDocument = gql`
    mutation AddSkillSet($profileId: String!, $skillset: SkillsReqDto!) {
  addSkillSet(profileid: $profileId, skillset: $skillset) {
    id
    roles
    yearsOfExperienceInRole {
      role
      yearsOfExperience
    }
    mostProficientTechnologies
    softSkills
    somewhatProficientTechnologies
    selectedTechnologies
  }
}
    `;
export type IAddSkillSetMutationFn = Apollo.MutationFunction<IAddSkillSetMutation, IAddSkillSetMutationVariables>;

/**
 * __useAddSkillSetMutation__
 *
 * To run a mutation, you first call `useAddSkillSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSkillSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSkillSetMutation, { data, loading, error }] = useAddSkillSetMutation({
 *   variables: {
 *      profileId: // value for 'profileId'
 *      skillset: // value for 'skillset'
 *   },
 * });
 */
export function useAddSkillSetMutation(baseOptions?: Apollo.MutationHookOptions<IAddSkillSetMutation, IAddSkillSetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IAddSkillSetMutation, IAddSkillSetMutationVariables>(AddSkillSetDocument, options);
      }
export type AddSkillSetMutationHookResult = ReturnType<typeof useAddSkillSetMutation>;
export type AddSkillSetMutationResult = Apollo.MutationResult<IAddSkillSetMutation>;
export type AddSkillSetMutationOptions = Apollo.BaseMutationOptions<IAddSkillSetMutation, IAddSkillSetMutationVariables>;
export const AddCandidateInterviewEvalDocument = gql`
    mutation AddCandidateInterviewEval($profileid: String!, $intervieweval: InterviewEvaluationDto!, $saveAsDraft: Boolean!) {
  addInterviewEvaluation(
    profileid: $profileid
    intervieweval: $intervieweval
    saveAsDraft: $saveAsDraft
  ) {
    id
  }
}
    `;
export type IAddCandidateInterviewEvalMutationFn = Apollo.MutationFunction<IAddCandidateInterviewEvalMutation, IAddCandidateInterviewEvalMutationVariables>;

/**
 * __useAddCandidateInterviewEvalMutation__
 *
 * To run a mutation, you first call `useAddCandidateInterviewEvalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCandidateInterviewEvalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCandidateInterviewEvalMutation, { data, loading, error }] = useAddCandidateInterviewEvalMutation({
 *   variables: {
 *      profileid: // value for 'profileid'
 *      intervieweval: // value for 'intervieweval'
 *      saveAsDraft: // value for 'saveAsDraft'
 *   },
 * });
 */
export function useAddCandidateInterviewEvalMutation(baseOptions?: Apollo.MutationHookOptions<IAddCandidateInterviewEvalMutation, IAddCandidateInterviewEvalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IAddCandidateInterviewEvalMutation, IAddCandidateInterviewEvalMutationVariables>(AddCandidateInterviewEvalDocument, options);
      }
export type AddCandidateInterviewEvalMutationHookResult = ReturnType<typeof useAddCandidateInterviewEvalMutation>;
export type AddCandidateInterviewEvalMutationResult = Apollo.MutationResult<IAddCandidateInterviewEvalMutation>;
export type AddCandidateInterviewEvalMutationOptions = Apollo.BaseMutationOptions<IAddCandidateInterviewEvalMutation, IAddCandidateInterviewEvalMutationVariables>;
export const GenerateNewResumeUrlDocument = gql`
    mutation GenerateNewResumeUrl($profileId: String!) {
  generateNewResumeUrl(profileId: $profileId)
}
    `;
export type IGenerateNewResumeUrlMutationFn = Apollo.MutationFunction<IGenerateNewResumeUrlMutation, IGenerateNewResumeUrlMutationVariables>;

/**
 * __useGenerateNewResumeUrlMutation__
 *
 * To run a mutation, you first call `useGenerateNewResumeUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateNewResumeUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateNewResumeUrlMutation, { data, loading, error }] = useGenerateNewResumeUrlMutation({
 *   variables: {
 *      profileId: // value for 'profileId'
 *   },
 * });
 */
export function useGenerateNewResumeUrlMutation(baseOptions?: Apollo.MutationHookOptions<IGenerateNewResumeUrlMutation, IGenerateNewResumeUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IGenerateNewResumeUrlMutation, IGenerateNewResumeUrlMutationVariables>(GenerateNewResumeUrlDocument, options);
      }
export type GenerateNewResumeUrlMutationHookResult = ReturnType<typeof useGenerateNewResumeUrlMutation>;
export type GenerateNewResumeUrlMutationResult = Apollo.MutationResult<IGenerateNewResumeUrlMutation>;
export type GenerateNewResumeUrlMutationOptions = Apollo.BaseMutationOptions<IGenerateNewResumeUrlMutation, IGenerateNewResumeUrlMutationVariables>;
export const RemoveResumeUrlDocument = gql`
    mutation RemoveResumeUrl($fileType: String!, $profileId: String!) {
  removeResumeUrl(fileType: $fileType, profileId: $profileId)
}
    `;
export type IRemoveResumeUrlMutationFn = Apollo.MutationFunction<IRemoveResumeUrlMutation, IRemoveResumeUrlMutationVariables>;

/**
 * __useRemoveResumeUrlMutation__
 *
 * To run a mutation, you first call `useRemoveResumeUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveResumeUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeResumeUrlMutation, { data, loading, error }] = useRemoveResumeUrlMutation({
 *   variables: {
 *      fileType: // value for 'fileType'
 *      profileId: // value for 'profileId'
 *   },
 * });
 */
export function useRemoveResumeUrlMutation(baseOptions?: Apollo.MutationHookOptions<IRemoveResumeUrlMutation, IRemoveResumeUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IRemoveResumeUrlMutation, IRemoveResumeUrlMutationVariables>(RemoveResumeUrlDocument, options);
      }
export type RemoveResumeUrlMutationHookResult = ReturnType<typeof useRemoveResumeUrlMutation>;
export type RemoveResumeUrlMutationResult = Apollo.MutationResult<IRemoveResumeUrlMutation>;
export type RemoveResumeUrlMutationOptions = Apollo.BaseMutationOptions<IRemoveResumeUrlMutation, IRemoveResumeUrlMutationVariables>;
export const CreateUpdateAssignedDevicesDocument = gql`
    mutation CreateUpdateAssignedDevices($AssignedDevicesDto: AssignedDevicesDto!) {
  createOrUpdateAssignedDevices(AssignedDevicesDto: $AssignedDevicesDto) {
    _id
    deviceName
    userId
    profileId
    assignedDate
    deviceDescription
    deviceCode
  }
}
    `;
export type ICreateUpdateAssignedDevicesMutationFn = Apollo.MutationFunction<ICreateUpdateAssignedDevicesMutation, ICreateUpdateAssignedDevicesMutationVariables>;

/**
 * __useCreateUpdateAssignedDevicesMutation__
 *
 * To run a mutation, you first call `useCreateUpdateAssignedDevicesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUpdateAssignedDevicesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUpdateAssignedDevicesMutation, { data, loading, error }] = useCreateUpdateAssignedDevicesMutation({
 *   variables: {
 *      AssignedDevicesDto: // value for 'AssignedDevicesDto'
 *   },
 * });
 */
export function useCreateUpdateAssignedDevicesMutation(baseOptions?: Apollo.MutationHookOptions<ICreateUpdateAssignedDevicesMutation, ICreateUpdateAssignedDevicesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ICreateUpdateAssignedDevicesMutation, ICreateUpdateAssignedDevicesMutationVariables>(CreateUpdateAssignedDevicesDocument, options);
      }
export type CreateUpdateAssignedDevicesMutationHookResult = ReturnType<typeof useCreateUpdateAssignedDevicesMutation>;
export type CreateUpdateAssignedDevicesMutationResult = Apollo.MutationResult<ICreateUpdateAssignedDevicesMutation>;
export type CreateUpdateAssignedDevicesMutationOptions = Apollo.BaseMutationOptions<ICreateUpdateAssignedDevicesMutation, ICreateUpdateAssignedDevicesMutationVariables>;
export const RemoveAssignedDevicesDocument = gql`
    mutation RemoveAssignedDevices($assignedDeviceId: String!) {
  removeAssignedDevices(assignedDeviceId: $assignedDeviceId)
}
    `;
export type IRemoveAssignedDevicesMutationFn = Apollo.MutationFunction<IRemoveAssignedDevicesMutation, IRemoveAssignedDevicesMutationVariables>;

/**
 * __useRemoveAssignedDevicesMutation__
 *
 * To run a mutation, you first call `useRemoveAssignedDevicesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAssignedDevicesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAssignedDevicesMutation, { data, loading, error }] = useRemoveAssignedDevicesMutation({
 *   variables: {
 *      assignedDeviceId: // value for 'assignedDeviceId'
 *   },
 * });
 */
export function useRemoveAssignedDevicesMutation(baseOptions?: Apollo.MutationHookOptions<IRemoveAssignedDevicesMutation, IRemoveAssignedDevicesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IRemoveAssignedDevicesMutation, IRemoveAssignedDevicesMutationVariables>(RemoveAssignedDevicesDocument, options);
      }
export type RemoveAssignedDevicesMutationHookResult = ReturnType<typeof useRemoveAssignedDevicesMutation>;
export type RemoveAssignedDevicesMutationResult = Apollo.MutationResult<IRemoveAssignedDevicesMutation>;
export type RemoveAssignedDevicesMutationOptions = Apollo.BaseMutationOptions<IRemoveAssignedDevicesMutation, IRemoveAssignedDevicesMutationVariables>;
export const InviteToSquaderyConnectDocument = gql`
    mutation InviteToSquaderyConnect($userId: String!) {
  inviteToSquaderyConnect(userId: $userId)
}
    `;
export type IInviteToSquaderyConnectMutationFn = Apollo.MutationFunction<IInviteToSquaderyConnectMutation, IInviteToSquaderyConnectMutationVariables>;

/**
 * __useInviteToSquaderyConnectMutation__
 *
 * To run a mutation, you first call `useInviteToSquaderyConnectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteToSquaderyConnectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteToSquaderyConnectMutation, { data, loading, error }] = useInviteToSquaderyConnectMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useInviteToSquaderyConnectMutation(baseOptions?: Apollo.MutationHookOptions<IInviteToSquaderyConnectMutation, IInviteToSquaderyConnectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IInviteToSquaderyConnectMutation, IInviteToSquaderyConnectMutationVariables>(InviteToSquaderyConnectDocument, options);
      }
export type InviteToSquaderyConnectMutationHookResult = ReturnType<typeof useInviteToSquaderyConnectMutation>;
export type InviteToSquaderyConnectMutationResult = Apollo.MutationResult<IInviteToSquaderyConnectMutation>;
export type InviteToSquaderyConnectMutationOptions = Apollo.BaseMutationOptions<IInviteToSquaderyConnectMutation, IInviteToSquaderyConnectMutationVariables>;
export const OnBoardOffBoardInSquadDocument = gql`
    mutation OnBoardOffBoardInSquad($onboardOffboardDto: OnboardOffboardDto!, $moveDto: MoveDto, $newResume: Upload, $squadResourceInputDto: SquadResourceInputDto) {
  onboardOrOffboardInSquad(
    onboardOffboardDto: $onboardOffboardDto
    moveDto: $moveDto
    newResume: $newResume
    squadResourceInputDto: $squadResourceInputDto
  )
}
    `;
export type IOnBoardOffBoardInSquadMutationFn = Apollo.MutationFunction<IOnBoardOffBoardInSquadMutation, IOnBoardOffBoardInSquadMutationVariables>;

/**
 * __useOnBoardOffBoardInSquadMutation__
 *
 * To run a mutation, you first call `useOnBoardOffBoardInSquadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOnBoardOffBoardInSquadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [onBoardOffBoardInSquadMutation, { data, loading, error }] = useOnBoardOffBoardInSquadMutation({
 *   variables: {
 *      onboardOffboardDto: // value for 'onboardOffboardDto'
 *      moveDto: // value for 'moveDto'
 *      newResume: // value for 'newResume'
 *      squadResourceInputDto: // value for 'squadResourceInputDto'
 *   },
 * });
 */
export function useOnBoardOffBoardInSquadMutation(baseOptions?: Apollo.MutationHookOptions<IOnBoardOffBoardInSquadMutation, IOnBoardOffBoardInSquadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IOnBoardOffBoardInSquadMutation, IOnBoardOffBoardInSquadMutationVariables>(OnBoardOffBoardInSquadDocument, options);
      }
export type OnBoardOffBoardInSquadMutationHookResult = ReturnType<typeof useOnBoardOffBoardInSquadMutation>;
export type OnBoardOffBoardInSquadMutationResult = Apollo.MutationResult<IOnBoardOffBoardInSquadMutation>;
export type OnBoardOffBoardInSquadMutationOptions = Apollo.BaseMutationOptions<IOnBoardOffBoardInSquadMutation, IOnBoardOffBoardInSquadMutationVariables>;
export const UpdateInvolvementhistoryDocument = gql`
    mutation updateInvolvementhistory($editedHistory: Float, $involvementHistory: involvementHistoryInput!, $ushId: String!) {
  updateInvolvementHistory(
    editedHistory: $editedHistory
    involvementHistory: $involvementHistory
    ushId: $ushId
  )
}
    `;
export type IUpdateInvolvementhistoryMutationFn = Apollo.MutationFunction<IUpdateInvolvementhistoryMutation, IUpdateInvolvementhistoryMutationVariables>;

/**
 * __useUpdateInvolvementhistoryMutation__
 *
 * To run a mutation, you first call `useUpdateInvolvementhistoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInvolvementhistoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInvolvementhistoryMutation, { data, loading, error }] = useUpdateInvolvementhistoryMutation({
 *   variables: {
 *      editedHistory: // value for 'editedHistory'
 *      involvementHistory: // value for 'involvementHistory'
 *      ushId: // value for 'ushId'
 *   },
 * });
 */
export function useUpdateInvolvementhistoryMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateInvolvementhistoryMutation, IUpdateInvolvementhistoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateInvolvementhistoryMutation, IUpdateInvolvementhistoryMutationVariables>(UpdateInvolvementhistoryDocument, options);
      }
export type UpdateInvolvementhistoryMutationHookResult = ReturnType<typeof useUpdateInvolvementhistoryMutation>;
export type UpdateInvolvementhistoryMutationResult = Apollo.MutationResult<IUpdateInvolvementhistoryMutation>;
export type UpdateInvolvementhistoryMutationOptions = Apollo.BaseMutationOptions<IUpdateInvolvementhistoryMutation, IUpdateInvolvementhistoryMutationVariables>;
export const CreateOrUpdateWorkExperienceDocument = gql`
    mutation createOrUpdateWorkExperience($workExperienceDTO: CreateWorkExperienceInput!) {
  createOrUpdateWorkExperience(workExperienceDTO: $workExperienceDTO) {
    company
    companyAddress
    profileId
    userId
    workExperienceId
    workHistory {
      details
      endDate
      jobTitle
      role
      startDate
      workHistoryId
    }
  }
}
    `;
export type ICreateOrUpdateWorkExperienceMutationFn = Apollo.MutationFunction<ICreateOrUpdateWorkExperienceMutation, ICreateOrUpdateWorkExperienceMutationVariables>;

/**
 * __useCreateOrUpdateWorkExperienceMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateWorkExperienceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateWorkExperienceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateWorkExperienceMutation, { data, loading, error }] = useCreateOrUpdateWorkExperienceMutation({
 *   variables: {
 *      workExperienceDTO: // value for 'workExperienceDTO'
 *   },
 * });
 */
export function useCreateOrUpdateWorkExperienceMutation(baseOptions?: Apollo.MutationHookOptions<ICreateOrUpdateWorkExperienceMutation, ICreateOrUpdateWorkExperienceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ICreateOrUpdateWorkExperienceMutation, ICreateOrUpdateWorkExperienceMutationVariables>(CreateOrUpdateWorkExperienceDocument, options);
      }
export type CreateOrUpdateWorkExperienceMutationHookResult = ReturnType<typeof useCreateOrUpdateWorkExperienceMutation>;
export type CreateOrUpdateWorkExperienceMutationResult = Apollo.MutationResult<ICreateOrUpdateWorkExperienceMutation>;
export type CreateOrUpdateWorkExperienceMutationOptions = Apollo.BaseMutationOptions<ICreateOrUpdateWorkExperienceMutation, ICreateOrUpdateWorkExperienceMutationVariables>;
export const CreateOverAllExperienceAndRelevantExperienceDocument = gql`
    mutation createOverAllExperienceAndRelevantExperience($experience: OverallAndRelevantExperienceDto!) {
  createOverAllExperienceAndRelevantExperience(experience: $experience) {
    userId
  }
}
    `;
export type ICreateOverAllExperienceAndRelevantExperienceMutationFn = Apollo.MutationFunction<ICreateOverAllExperienceAndRelevantExperienceMutation, ICreateOverAllExperienceAndRelevantExperienceMutationVariables>;

/**
 * __useCreateOverAllExperienceAndRelevantExperienceMutation__
 *
 * To run a mutation, you first call `useCreateOverAllExperienceAndRelevantExperienceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOverAllExperienceAndRelevantExperienceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOverAllExperienceAndRelevantExperienceMutation, { data, loading, error }] = useCreateOverAllExperienceAndRelevantExperienceMutation({
 *   variables: {
 *      experience: // value for 'experience'
 *   },
 * });
 */
export function useCreateOverAllExperienceAndRelevantExperienceMutation(baseOptions?: Apollo.MutationHookOptions<ICreateOverAllExperienceAndRelevantExperienceMutation, ICreateOverAllExperienceAndRelevantExperienceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ICreateOverAllExperienceAndRelevantExperienceMutation, ICreateOverAllExperienceAndRelevantExperienceMutationVariables>(CreateOverAllExperienceAndRelevantExperienceDocument, options);
      }
export type CreateOverAllExperienceAndRelevantExperienceMutationHookResult = ReturnType<typeof useCreateOverAllExperienceAndRelevantExperienceMutation>;
export type CreateOverAllExperienceAndRelevantExperienceMutationResult = Apollo.MutationResult<ICreateOverAllExperienceAndRelevantExperienceMutation>;
export type CreateOverAllExperienceAndRelevantExperienceMutationOptions = Apollo.BaseMutationOptions<ICreateOverAllExperienceAndRelevantExperienceMutation, ICreateOverAllExperienceAndRelevantExperienceMutationVariables>;
export const CreateEmployeeDocument = gql`
    mutation createEmployee($file: Upload!, $user: UserUploadInputDto!) {
  createEmployee(file: $file, user: $user) {
    profileId
    userId
  }
}
    `;
export type ICreateEmployeeMutationFn = Apollo.MutationFunction<ICreateEmployeeMutation, ICreateEmployeeMutationVariables>;

/**
 * __useCreateEmployeeMutation__
 *
 * To run a mutation, you first call `useCreateEmployeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEmployeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEmployeeMutation, { data, loading, error }] = useCreateEmployeeMutation({
 *   variables: {
 *      file: // value for 'file'
 *      user: // value for 'user'
 *   },
 * });
 */
export function useCreateEmployeeMutation(baseOptions?: Apollo.MutationHookOptions<ICreateEmployeeMutation, ICreateEmployeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ICreateEmployeeMutation, ICreateEmployeeMutationVariables>(CreateEmployeeDocument, options);
      }
export type CreateEmployeeMutationHookResult = ReturnType<typeof useCreateEmployeeMutation>;
export type CreateEmployeeMutationResult = Apollo.MutationResult<ICreateEmployeeMutation>;
export type CreateEmployeeMutationOptions = Apollo.BaseMutationOptions<ICreateEmployeeMutation, ICreateEmployeeMutationVariables>;
export const FetchEmployeeProfileDocument = gql`
    query fetchEmployeeProfile($userId: String!, $squadRoleId: String) {
  getEmployeePersonalInfoByUserId(userId: $userId, squadRoleId: $squadRoleId) {
    userId
    profileId
    invitedToConnect
    availableSince
    relevantExperience {
      month
      year
    }
    overAllExperience {
      month
      year
    }
    personalInfo {
      availability {
        availabiltyForWork
        currentSalary {
          amount
          duration
          salaryType
        }
        hoursPerweek
        isAvailable
        startDate
      }
      resignDate
      region
      availabilityStatus
      countryOfResidence
      email
      filename
      joinedDate
      name
      phoneNumber
      resumeUrl
      role
      timeZone
      githubUrl
      linkedinUrl
      profileImage
      resumeUpdatedDate
      gender
    }
    supervisors {
      email
      fullname
      designationName
      departmentName
      _id
    }
    experience {
      roles
      yearsOfExperienceInRoles {
        role
        yearsOfExperience
      }
    }
    paymentOption {
      billingAmount
      billingType
    }
    profileId
    skills {
      mostProficientTechnologies
      softSkills
      somewhatProficientTechnologies
    }
    squads {
      clientType
      createdFromHubspot
      squadId
      squadHistoryId
      squadName
      joinedDate
      squadType
      endDate
      involvedAs
      involvementStatus
      clientId
      clientName
      roleInSquad
      employeeBillingRate
      clientBillingRate
      jobType
      ticketId
      allocatedHours
      squadRoleId
      involvementHistoryId
      squadHistoryIds
      involvementHistory {
        _id
        role
        involvedAs
        involvementStatus
        jobType
        modifiedBy
        modifiedOn
        joinedDate
        endDate
        allocatedHours
        note
      }
      additionalNotes {
        ...NoteFragment
      }
    }
    jobExperience {
      companyName
      currentlyEmployed
      jobEndDate {
        month
        year
      }
      jobLocation
      jobStartDate {
        month
        year
      }
      jobTitle
      rolesAndResponsibility
    }
    education {
      completedOn {
        month
        year
      }
      currentlyStudying
      degree
      fieldOfStudy
      isEducationFormCompleted
      joinedOn {
        month
        year
      }
      levelOfEducation
      school
    }
    assignedDevices {
      assignedDate
      _id
      deviceCode
      deviceDescription
      deviceName
    }
    certificates {
      certificateID
      certificateTitle
      completedOn {
        month
        year
      }
      currentlyStudying
      isCertificateFormCompleted
      issuingInstitutionOrganization
      joinedOn {
        month
        year
      }
      url
    }
    workExperience {
      company
      companyAddress
      profileId
      userId
      workExperienceId
      workHistory {
        details
        endDate
        role
        jobTitle
        startDate
        workHistoryId
      }
    }
    currentSquads {
      allocatedHours
      clientId
      clientName
      involvedAs
      involvementStatus
      jobType
      squadId
      squadName
    }
    currentWorkInfo {
      department {
        id
        name
      }
      deploymentStatus
      designation
      employeeId
      jobType
      level
      mainDepartment
      roles
      workShift
      optionExploring
      employeementType
      billable
    }
    squadStatus
    employeeActiveStatus
  }
}
    ${NoteFragmentFragmentDoc}`;

/**
 * __useFetchEmployeeProfileQuery__
 *
 * To run a query within a React component, call `useFetchEmployeeProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchEmployeeProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchEmployeeProfileQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      squadRoleId: // value for 'squadRoleId'
 *   },
 * });
 */
export function useFetchEmployeeProfileQuery(baseOptions: Apollo.QueryHookOptions<IFetchEmployeeProfileQuery, IFetchEmployeeProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IFetchEmployeeProfileQuery, IFetchEmployeeProfileQueryVariables>(FetchEmployeeProfileDocument, options);
      }
export function useFetchEmployeeProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IFetchEmployeeProfileQuery, IFetchEmployeeProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IFetchEmployeeProfileQuery, IFetchEmployeeProfileQueryVariables>(FetchEmployeeProfileDocument, options);
        }
export type FetchEmployeeProfileQueryHookResult = ReturnType<typeof useFetchEmployeeProfileQuery>;
export type FetchEmployeeProfileLazyQueryHookResult = ReturnType<typeof useFetchEmployeeProfileLazyQuery>;
export type FetchEmployeeProfileQueryResult = Apollo.QueryResult<IFetchEmployeeProfileQuery, IFetchEmployeeProfileQueryVariables>;
export const FetchTimeZoneDocument = gql`
    query fetchTimeZone {
  getTimeZones
}
    `;

/**
 * __useFetchTimeZoneQuery__
 *
 * To run a query within a React component, call `useFetchTimeZoneQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchTimeZoneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchTimeZoneQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchTimeZoneQuery(baseOptions?: Apollo.QueryHookOptions<IFetchTimeZoneQuery, IFetchTimeZoneQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IFetchTimeZoneQuery, IFetchTimeZoneQueryVariables>(FetchTimeZoneDocument, options);
      }
export function useFetchTimeZoneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IFetchTimeZoneQuery, IFetchTimeZoneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IFetchTimeZoneQuery, IFetchTimeZoneQueryVariables>(FetchTimeZoneDocument, options);
        }
export type FetchTimeZoneQueryHookResult = ReturnType<typeof useFetchTimeZoneQuery>;
export type FetchTimeZoneLazyQueryHookResult = ReturnType<typeof useFetchTimeZoneLazyQuery>;
export type FetchTimeZoneQueryResult = Apollo.QueryResult<IFetchTimeZoneQuery, IFetchTimeZoneQueryVariables>;
export const FetchCountriesDocument = gql`
    query fetchCountries {
  getCountries {
    name
  }
}
    `;

/**
 * __useFetchCountriesQuery__
 *
 * To run a query within a React component, call `useFetchCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCountriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchCountriesQuery(baseOptions?: Apollo.QueryHookOptions<IFetchCountriesQuery, IFetchCountriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IFetchCountriesQuery, IFetchCountriesQueryVariables>(FetchCountriesDocument, options);
      }
export function useFetchCountriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IFetchCountriesQuery, IFetchCountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IFetchCountriesQuery, IFetchCountriesQueryVariables>(FetchCountriesDocument, options);
        }
export type FetchCountriesQueryHookResult = ReturnType<typeof useFetchCountriesQuery>;
export type FetchCountriesLazyQueryHookResult = ReturnType<typeof useFetchCountriesLazyQuery>;
export type FetchCountriesQueryResult = Apollo.QueryResult<IFetchCountriesQuery, IFetchCountriesQueryVariables>;
export const FetchDepartmentsDocument = gql`
    query fetchDepartments {
  getDepartments {
    name
    id
  }
}
    `;

/**
 * __useFetchDepartmentsQuery__
 *
 * To run a query within a React component, call `useFetchDepartmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchDepartmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchDepartmentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchDepartmentsQuery(baseOptions?: Apollo.QueryHookOptions<IFetchDepartmentsQuery, IFetchDepartmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IFetchDepartmentsQuery, IFetchDepartmentsQueryVariables>(FetchDepartmentsDocument, options);
      }
export function useFetchDepartmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IFetchDepartmentsQuery, IFetchDepartmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IFetchDepartmentsQuery, IFetchDepartmentsQueryVariables>(FetchDepartmentsDocument, options);
        }
export type FetchDepartmentsQueryHookResult = ReturnType<typeof useFetchDepartmentsQuery>;
export type FetchDepartmentsLazyQueryHookResult = ReturnType<typeof useFetchDepartmentsLazyQuery>;
export type FetchDepartmentsQueryResult = Apollo.QueryResult<IFetchDepartmentsQuery, IFetchDepartmentsQueryVariables>;
export const FetchDesignationsDocument = gql`
    query fetchDesignations {
  getDesignations {
    name
    id
    grade
  }
}
    `;

/**
 * __useFetchDesignationsQuery__
 *
 * To run a query within a React component, call `useFetchDesignationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchDesignationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchDesignationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchDesignationsQuery(baseOptions?: Apollo.QueryHookOptions<IFetchDesignationsQuery, IFetchDesignationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IFetchDesignationsQuery, IFetchDesignationsQueryVariables>(FetchDesignationsDocument, options);
      }
export function useFetchDesignationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IFetchDesignationsQuery, IFetchDesignationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IFetchDesignationsQuery, IFetchDesignationsQueryVariables>(FetchDesignationsDocument, options);
        }
export type FetchDesignationsQueryHookResult = ReturnType<typeof useFetchDesignationsQuery>;
export type FetchDesignationsLazyQueryHookResult = ReturnType<typeof useFetchDesignationsLazyQuery>;
export type FetchDesignationsQueryResult = Apollo.QueryResult<IFetchDesignationsQuery, IFetchDesignationsQueryVariables>;
export const FetchSquadsDocument = gql`
    query fetchSquads {
  getSquads {
    name
    id
  }
}
    `;

/**
 * __useFetchSquadsQuery__
 *
 * To run a query within a React component, call `useFetchSquadsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchSquadsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchSquadsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchSquadsQuery(baseOptions?: Apollo.QueryHookOptions<IFetchSquadsQuery, IFetchSquadsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IFetchSquadsQuery, IFetchSquadsQueryVariables>(FetchSquadsDocument, options);
      }
export function useFetchSquadsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IFetchSquadsQuery, IFetchSquadsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IFetchSquadsQuery, IFetchSquadsQueryVariables>(FetchSquadsDocument, options);
        }
export type FetchSquadsQueryHookResult = ReturnType<typeof useFetchSquadsQuery>;
export type FetchSquadsLazyQueryHookResult = ReturnType<typeof useFetchSquadsLazyQuery>;
export type FetchSquadsQueryResult = Apollo.QueryResult<IFetchSquadsQuery, IFetchSquadsQueryVariables>;
export const FetchAllRolesDocument = gql`
    query fetchAllRoles {
  getAllRoles {
    type
  }
}
    `;

/**
 * __useFetchAllRolesQuery__
 *
 * To run a query within a React component, call `useFetchAllRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAllRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAllRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchAllRolesQuery(baseOptions?: Apollo.QueryHookOptions<IFetchAllRolesQuery, IFetchAllRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IFetchAllRolesQuery, IFetchAllRolesQueryVariables>(FetchAllRolesDocument, options);
      }
export function useFetchAllRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IFetchAllRolesQuery, IFetchAllRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IFetchAllRolesQuery, IFetchAllRolesQueryVariables>(FetchAllRolesDocument, options);
        }
export type FetchAllRolesQueryHookResult = ReturnType<typeof useFetchAllRolesQuery>;
export type FetchAllRolesLazyQueryHookResult = ReturnType<typeof useFetchAllRolesLazyQuery>;
export type FetchAllRolesQueryResult = Apollo.QueryResult<IFetchAllRolesQuery, IFetchAllRolesQueryVariables>;
export const FetchSkillsDocument = gql`
    query fetchSkills {
  getSkills
}
    `;

/**
 * __useFetchSkillsQuery__
 *
 * To run a query within a React component, call `useFetchSkillsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchSkillsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchSkillsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchSkillsQuery(baseOptions?: Apollo.QueryHookOptions<IFetchSkillsQuery, IFetchSkillsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IFetchSkillsQuery, IFetchSkillsQueryVariables>(FetchSkillsDocument, options);
      }
export function useFetchSkillsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IFetchSkillsQuery, IFetchSkillsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IFetchSkillsQuery, IFetchSkillsQueryVariables>(FetchSkillsDocument, options);
        }
export type FetchSkillsQueryHookResult = ReturnType<typeof useFetchSkillsQuery>;
export type FetchSkillsLazyQueryHookResult = ReturnType<typeof useFetchSkillsLazyQuery>;
export type FetchSkillsQueryResult = Apollo.QueryResult<IFetchSkillsQuery, IFetchSkillsQueryVariables>;
export const FetchSoftSkillsDocument = gql`
    query fetchSoftSkills {
  getSoftSkills
}
    `;

/**
 * __useFetchSoftSkillsQuery__
 *
 * To run a query within a React component, call `useFetchSoftSkillsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchSoftSkillsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchSoftSkillsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchSoftSkillsQuery(baseOptions?: Apollo.QueryHookOptions<IFetchSoftSkillsQuery, IFetchSoftSkillsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IFetchSoftSkillsQuery, IFetchSoftSkillsQueryVariables>(FetchSoftSkillsDocument, options);
      }
export function useFetchSoftSkillsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IFetchSoftSkillsQuery, IFetchSoftSkillsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IFetchSoftSkillsQuery, IFetchSoftSkillsQueryVariables>(FetchSoftSkillsDocument, options);
        }
export type FetchSoftSkillsQueryHookResult = ReturnType<typeof useFetchSoftSkillsQuery>;
export type FetchSoftSkillsLazyQueryHookResult = ReturnType<typeof useFetchSoftSkillsLazyQuery>;
export type FetchSoftSkillsQueryResult = Apollo.QueryResult<IFetchSoftSkillsQuery, IFetchSoftSkillsQueryVariables>;
export const FetchRolesDocument = gql`
    query fetchRoles {
  getRoles
}
    `;

/**
 * __useFetchRolesQuery__
 *
 * To run a query within a React component, call `useFetchRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchRolesQuery(baseOptions?: Apollo.QueryHookOptions<IFetchRolesQuery, IFetchRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IFetchRolesQuery, IFetchRolesQueryVariables>(FetchRolesDocument, options);
      }
export function useFetchRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IFetchRolesQuery, IFetchRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IFetchRolesQuery, IFetchRolesQueryVariables>(FetchRolesDocument, options);
        }
export type FetchRolesQueryHookResult = ReturnType<typeof useFetchRolesQuery>;
export type FetchRolesLazyQueryHookResult = ReturnType<typeof useFetchRolesLazyQuery>;
export type FetchRolesQueryResult = Apollo.QueryResult<IFetchRolesQuery, IFetchRolesQueryVariables>;
export const FindProfileSquadRolesDocument = gql`
    query findProfileSquadRoles {
  findProfileSquadRoles
}
    `;

/**
 * __useFindProfileSquadRolesQuery__
 *
 * To run a query within a React component, call `useFindProfileSquadRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindProfileSquadRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindProfileSquadRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useFindProfileSquadRolesQuery(baseOptions?: Apollo.QueryHookOptions<IFindProfileSquadRolesQuery, IFindProfileSquadRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IFindProfileSquadRolesQuery, IFindProfileSquadRolesQueryVariables>(FindProfileSquadRolesDocument, options);
      }
export function useFindProfileSquadRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IFindProfileSquadRolesQuery, IFindProfileSquadRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IFindProfileSquadRolesQuery, IFindProfileSquadRolesQueryVariables>(FindProfileSquadRolesDocument, options);
        }
export type FindProfileSquadRolesQueryHookResult = ReturnType<typeof useFindProfileSquadRolesQuery>;
export type FindProfileSquadRolesLazyQueryHookResult = ReturnType<typeof useFindProfileSquadRolesLazyQuery>;
export type FindProfileSquadRolesQueryResult = Apollo.QueryResult<IFindProfileSquadRolesQuery, IFindProfileSquadRolesQueryVariables>;
export const FetchRolesWithCandidateCountDocument = gql`
    query fetchRolesWithCandidateCount {
  getRolesWithCandidateCount {
    role
    numberOfCandidates
  }
}
    `;

/**
 * __useFetchRolesWithCandidateCountQuery__
 *
 * To run a query within a React component, call `useFetchRolesWithCandidateCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchRolesWithCandidateCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchRolesWithCandidateCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchRolesWithCandidateCountQuery(baseOptions?: Apollo.QueryHookOptions<IFetchRolesWithCandidateCountQuery, IFetchRolesWithCandidateCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IFetchRolesWithCandidateCountQuery, IFetchRolesWithCandidateCountQueryVariables>(FetchRolesWithCandidateCountDocument, options);
      }
export function useFetchRolesWithCandidateCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IFetchRolesWithCandidateCountQuery, IFetchRolesWithCandidateCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IFetchRolesWithCandidateCountQuery, IFetchRolesWithCandidateCountQueryVariables>(FetchRolesWithCandidateCountDocument, options);
        }
export type FetchRolesWithCandidateCountQueryHookResult = ReturnType<typeof useFetchRolesWithCandidateCountQuery>;
export type FetchRolesWithCandidateCountLazyQueryHookResult = ReturnType<typeof useFetchRolesWithCandidateCountLazyQuery>;
export type FetchRolesWithCandidateCountQueryResult = Apollo.QueryResult<IFetchRolesWithCandidateCountQuery, IFetchRolesWithCandidateCountQueryVariables>;
export const FetchRolesByTypesDocument = gql`
    query fetchRolesByTypes($types: String!) {
  getRolesByTypes(types: $types) {
    roleTags
    type
  }
}
    `;

/**
 * __useFetchRolesByTypesQuery__
 *
 * To run a query within a React component, call `useFetchRolesByTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchRolesByTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchRolesByTypesQuery({
 *   variables: {
 *      types: // value for 'types'
 *   },
 * });
 */
export function useFetchRolesByTypesQuery(baseOptions: Apollo.QueryHookOptions<IFetchRolesByTypesQuery, IFetchRolesByTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IFetchRolesByTypesQuery, IFetchRolesByTypesQueryVariables>(FetchRolesByTypesDocument, options);
      }
export function useFetchRolesByTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IFetchRolesByTypesQuery, IFetchRolesByTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IFetchRolesByTypesQuery, IFetchRolesByTypesQueryVariables>(FetchRolesByTypesDocument, options);
        }
export type FetchRolesByTypesQueryHookResult = ReturnType<typeof useFetchRolesByTypesQuery>;
export type FetchRolesByTypesLazyQueryHookResult = ReturnType<typeof useFetchRolesByTypesLazyQuery>;
export type FetchRolesByTypesQueryResult = Apollo.QueryResult<IFetchRolesByTypesQuery, IFetchRolesByTypesQueryVariables>;
export const FetchAssessmentsDocument = gql`
    query fetchAssessments {
  getAssessments
}
    `;

/**
 * __useFetchAssessmentsQuery__
 *
 * To run a query within a React component, call `useFetchAssessmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAssessmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAssessmentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchAssessmentsQuery(baseOptions?: Apollo.QueryHookOptions<IFetchAssessmentsQuery, IFetchAssessmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IFetchAssessmentsQuery, IFetchAssessmentsQueryVariables>(FetchAssessmentsDocument, options);
      }
export function useFetchAssessmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IFetchAssessmentsQuery, IFetchAssessmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IFetchAssessmentsQuery, IFetchAssessmentsQueryVariables>(FetchAssessmentsDocument, options);
        }
export type FetchAssessmentsQueryHookResult = ReturnType<typeof useFetchAssessmentsQuery>;
export type FetchAssessmentsLazyQueryHookResult = ReturnType<typeof useFetchAssessmentsLazyQuery>;
export type FetchAssessmentsQueryResult = Apollo.QueryResult<IFetchAssessmentsQuery, IFetchAssessmentsQueryVariables>;
export const FetchCountriesAddCandidateDocument = gql`
    query fetchCountriesAddCandidate {
  getCountriesAddCandidate
}
    `;

/**
 * __useFetchCountriesAddCandidateQuery__
 *
 * To run a query within a React component, call `useFetchCountriesAddCandidateQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCountriesAddCandidateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCountriesAddCandidateQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchCountriesAddCandidateQuery(baseOptions?: Apollo.QueryHookOptions<IFetchCountriesAddCandidateQuery, IFetchCountriesAddCandidateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IFetchCountriesAddCandidateQuery, IFetchCountriesAddCandidateQueryVariables>(FetchCountriesAddCandidateDocument, options);
      }
export function useFetchCountriesAddCandidateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IFetchCountriesAddCandidateQuery, IFetchCountriesAddCandidateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IFetchCountriesAddCandidateQuery, IFetchCountriesAddCandidateQueryVariables>(FetchCountriesAddCandidateDocument, options);
        }
export type FetchCountriesAddCandidateQueryHookResult = ReturnType<typeof useFetchCountriesAddCandidateQuery>;
export type FetchCountriesAddCandidateLazyQueryHookResult = ReturnType<typeof useFetchCountriesAddCandidateLazyQuery>;
export type FetchCountriesAddCandidateQueryResult = Apollo.QueryResult<IFetchCountriesAddCandidateQuery, IFetchCountriesAddCandidateQueryVariables>;
export const FetchTimeZonesAddCandidateDocument = gql`
    query fetchTimeZonesAddCandidate {
  getTimeZonesAddCandidate
}
    `;

/**
 * __useFetchTimeZonesAddCandidateQuery__
 *
 * To run a query within a React component, call `useFetchTimeZonesAddCandidateQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchTimeZonesAddCandidateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchTimeZonesAddCandidateQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchTimeZonesAddCandidateQuery(baseOptions?: Apollo.QueryHookOptions<IFetchTimeZonesAddCandidateQuery, IFetchTimeZonesAddCandidateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IFetchTimeZonesAddCandidateQuery, IFetchTimeZonesAddCandidateQueryVariables>(FetchTimeZonesAddCandidateDocument, options);
      }
export function useFetchTimeZonesAddCandidateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IFetchTimeZonesAddCandidateQuery, IFetchTimeZonesAddCandidateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IFetchTimeZonesAddCandidateQuery, IFetchTimeZonesAddCandidateQueryVariables>(FetchTimeZonesAddCandidateDocument, options);
        }
export type FetchTimeZonesAddCandidateQueryHookResult = ReturnType<typeof useFetchTimeZonesAddCandidateQuery>;
export type FetchTimeZonesAddCandidateLazyQueryHookResult = ReturnType<typeof useFetchTimeZonesAddCandidateLazyQuery>;
export type FetchTimeZonesAddCandidateQueryResult = Apollo.QueryResult<IFetchTimeZonesAddCandidateQuery, IFetchTimeZonesAddCandidateQueryVariables>;
export const FetchCandidatesDocument = gql`
    query fetchCandidates($candidateAdvancedSearchDto: CandidateAdvancedSearchDto!) {
  getCandidates(candidateAdvancedSearchDto: $candidateAdvancedSearchDto) {
    candidates {
      firstName
      lastName
      candidateStatus
      countryOfResidence
      dateAdded
      email
      githubUrl
      id
      phoneNumber
      resumeUrl
      seekingNewRole
      startDate
      roles
      originalFilename
    }
    totalPages
  }
}
    `;

/**
 * __useFetchCandidatesQuery__
 *
 * To run a query within a React component, call `useFetchCandidatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCandidatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCandidatesQuery({
 *   variables: {
 *      candidateAdvancedSearchDto: // value for 'candidateAdvancedSearchDto'
 *   },
 * });
 */
export function useFetchCandidatesQuery(baseOptions: Apollo.QueryHookOptions<IFetchCandidatesQuery, IFetchCandidatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IFetchCandidatesQuery, IFetchCandidatesQueryVariables>(FetchCandidatesDocument, options);
      }
export function useFetchCandidatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IFetchCandidatesQuery, IFetchCandidatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IFetchCandidatesQuery, IFetchCandidatesQueryVariables>(FetchCandidatesDocument, options);
        }
export type FetchCandidatesQueryHookResult = ReturnType<typeof useFetchCandidatesQuery>;
export type FetchCandidatesLazyQueryHookResult = ReturnType<typeof useFetchCandidatesLazyQuery>;
export type FetchCandidatesQueryResult = Apollo.QueryResult<IFetchCandidatesQuery, IFetchCandidatesQueryVariables>;
export const FetchProfileInfoDocument = gql`
    query fetchProfileInfo($profileId: String!) {
  getCandidateInfo(profileId: $profileId) {
    id
    originalFilename
    resumeUrl
    jobDescriptionFileName
    jobDescriptionUrl
    email
    firstName
    lastName
    countryOfResidence
    timeZone
    linkedinUrl
    githubUrl
    phoneNumber
    seekingNewRole
    optionExploring
    paymentOption {
      billingType
      billingAmount
    }
    startDate
    skillsSet {
      roles
      selectedTechnologies
      mostProficientTechnologies
      softSkills
      somewhatProficientTechnologies
      yearsOfExperienceInRole {
        role
        yearsOfExperience
      }
    }
    intervieweval {
      assignedAssessments
      isGoodTeamPlayer
      recentCoachableMoment
      candidateEnthusiam
      candidateLearning
      candidateCommunication
      clientProjectsExperience
      candidateQuestionStrength
      candidatePreparation
      squaderyUnderstanding
    }
  }
}
    `;

/**
 * __useFetchProfileInfoQuery__
 *
 * To run a query within a React component, call `useFetchProfileInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchProfileInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchProfileInfoQuery({
 *   variables: {
 *      profileId: // value for 'profileId'
 *   },
 * });
 */
export function useFetchProfileInfoQuery(baseOptions: Apollo.QueryHookOptions<IFetchProfileInfoQuery, IFetchProfileInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IFetchProfileInfoQuery, IFetchProfileInfoQueryVariables>(FetchProfileInfoDocument, options);
      }
export function useFetchProfileInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IFetchProfileInfoQuery, IFetchProfileInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IFetchProfileInfoQuery, IFetchProfileInfoQueryVariables>(FetchProfileInfoDocument, options);
        }
export type FetchProfileInfoQueryHookResult = ReturnType<typeof useFetchProfileInfoQuery>;
export type FetchProfileInfoLazyQueryHookResult = ReturnType<typeof useFetchProfileInfoLazyQuery>;
export type FetchProfileInfoQueryResult = Apollo.QueryResult<IFetchProfileInfoQuery, IFetchProfileInfoQueryVariables>;
export const FetchClientListDocument = gql`
    query fetchClientList {
  getClientList {
    id
    name
  }
}
    `;

/**
 * __useFetchClientListQuery__
 *
 * To run a query within a React component, call `useFetchClientListQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchClientListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchClientListQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchClientListQuery(baseOptions?: Apollo.QueryHookOptions<IFetchClientListQuery, IFetchClientListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IFetchClientListQuery, IFetchClientListQueryVariables>(FetchClientListDocument, options);
      }
export function useFetchClientListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IFetchClientListQuery, IFetchClientListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IFetchClientListQuery, IFetchClientListQueryVariables>(FetchClientListDocument, options);
        }
export type FetchClientListQueryHookResult = ReturnType<typeof useFetchClientListQuery>;
export type FetchClientListLazyQueryHookResult = ReturnType<typeof useFetchClientListLazyQuery>;
export type FetchClientListQueryResult = Apollo.QueryResult<IFetchClientListQuery, IFetchClientListQueryVariables>;
export const FetchSquadListByClientIdDocument = gql`
    query fetchSquadListByClientId($clientId: String!) {
  getSquadListByClientId(clientId: $clientId) {
    id
    name
  }
}
    `;

/**
 * __useFetchSquadListByClientIdQuery__
 *
 * To run a query within a React component, call `useFetchSquadListByClientIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchSquadListByClientIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchSquadListByClientIdQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useFetchSquadListByClientIdQuery(baseOptions: Apollo.QueryHookOptions<IFetchSquadListByClientIdQuery, IFetchSquadListByClientIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IFetchSquadListByClientIdQuery, IFetchSquadListByClientIdQueryVariables>(FetchSquadListByClientIdDocument, options);
      }
export function useFetchSquadListByClientIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IFetchSquadListByClientIdQuery, IFetchSquadListByClientIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IFetchSquadListByClientIdQuery, IFetchSquadListByClientIdQueryVariables>(FetchSquadListByClientIdDocument, options);
        }
export type FetchSquadListByClientIdQueryHookResult = ReturnType<typeof useFetchSquadListByClientIdQuery>;
export type FetchSquadListByClientIdLazyQueryHookResult = ReturnType<typeof useFetchSquadListByClientIdLazyQuery>;
export type FetchSquadListByClientIdQueryResult = Apollo.QueryResult<IFetchSquadListByClientIdQuery, IFetchSquadListByClientIdQueryVariables>;
export const GetAllEmployeeSkillsDocument = gql`
    query getAllEmployeeSkills {
  getAllEmployeeSkills
}
    `;

/**
 * __useGetAllEmployeeSkillsQuery__
 *
 * To run a query within a React component, call `useGetAllEmployeeSkillsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllEmployeeSkillsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllEmployeeSkillsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllEmployeeSkillsQuery(baseOptions?: Apollo.QueryHookOptions<IGetAllEmployeeSkillsQuery, IGetAllEmployeeSkillsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetAllEmployeeSkillsQuery, IGetAllEmployeeSkillsQueryVariables>(GetAllEmployeeSkillsDocument, options);
      }
export function useGetAllEmployeeSkillsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetAllEmployeeSkillsQuery, IGetAllEmployeeSkillsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetAllEmployeeSkillsQuery, IGetAllEmployeeSkillsQueryVariables>(GetAllEmployeeSkillsDocument, options);
        }
export type GetAllEmployeeSkillsQueryHookResult = ReturnType<typeof useGetAllEmployeeSkillsQuery>;
export type GetAllEmployeeSkillsLazyQueryHookResult = ReturnType<typeof useGetAllEmployeeSkillsLazyQuery>;
export type GetAllEmployeeSkillsQueryResult = Apollo.QueryResult<IGetAllEmployeeSkillsQuery, IGetAllEmployeeSkillsQueryVariables>;
export const FetchInvolvementHistoryDocument = gql`
    query fetchInvolvementHistory($ushId: String!) {
  getInvolvementHistory(ushId: $ushId) {
    endDate
    involvedAs
    jobType
    joinedDate
  }
}
    `;

/**
 * __useFetchInvolvementHistoryQuery__
 *
 * To run a query within a React component, call `useFetchInvolvementHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchInvolvementHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchInvolvementHistoryQuery({
 *   variables: {
 *      ushId: // value for 'ushId'
 *   },
 * });
 */
export function useFetchInvolvementHistoryQuery(baseOptions: Apollo.QueryHookOptions<IFetchInvolvementHistoryQuery, IFetchInvolvementHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IFetchInvolvementHistoryQuery, IFetchInvolvementHistoryQueryVariables>(FetchInvolvementHistoryDocument, options);
      }
export function useFetchInvolvementHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IFetchInvolvementHistoryQuery, IFetchInvolvementHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IFetchInvolvementHistoryQuery, IFetchInvolvementHistoryQueryVariables>(FetchInvolvementHistoryDocument, options);
        }
export type FetchInvolvementHistoryQueryHookResult = ReturnType<typeof useFetchInvolvementHistoryQuery>;
export type FetchInvolvementHistoryLazyQueryHookResult = ReturnType<typeof useFetchInvolvementHistoryLazyQuery>;
export type FetchInvolvementHistoryQueryResult = Apollo.QueryResult<IFetchInvolvementHistoryQuery, IFetchInvolvementHistoryQueryVariables>;
export const FetchAllVerticalsDocument = gql`
    query fetchAllVerticals {
  getAllVerticals {
    name
    id
  }
}
    `;

/**
 * __useFetchAllVerticalsQuery__
 *
 * To run a query within a React component, call `useFetchAllVerticalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAllVerticalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAllVerticalsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchAllVerticalsQuery(baseOptions?: Apollo.QueryHookOptions<IFetchAllVerticalsQuery, IFetchAllVerticalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IFetchAllVerticalsQuery, IFetchAllVerticalsQueryVariables>(FetchAllVerticalsDocument, options);
      }
export function useFetchAllVerticalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IFetchAllVerticalsQuery, IFetchAllVerticalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IFetchAllVerticalsQuery, IFetchAllVerticalsQueryVariables>(FetchAllVerticalsDocument, options);
        }
export type FetchAllVerticalsQueryHookResult = ReturnType<typeof useFetchAllVerticalsQuery>;
export type FetchAllVerticalsLazyQueryHookResult = ReturnType<typeof useFetchAllVerticalsLazyQuery>;
export type FetchAllVerticalsQueryResult = Apollo.QueryResult<IFetchAllVerticalsQuery, IFetchAllVerticalsQueryVariables>;
export const FetchAllVerticalIndustryDocument = gql`
    query fetchAllVerticalIndustry {
  getAllVerticalIndustry {
    name
  }
}
    `;

/**
 * __useFetchAllVerticalIndustryQuery__
 *
 * To run a query within a React component, call `useFetchAllVerticalIndustryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAllVerticalIndustryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAllVerticalIndustryQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchAllVerticalIndustryQuery(baseOptions?: Apollo.QueryHookOptions<IFetchAllVerticalIndustryQuery, IFetchAllVerticalIndustryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IFetchAllVerticalIndustryQuery, IFetchAllVerticalIndustryQueryVariables>(FetchAllVerticalIndustryDocument, options);
      }
export function useFetchAllVerticalIndustryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IFetchAllVerticalIndustryQuery, IFetchAllVerticalIndustryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IFetchAllVerticalIndustryQuery, IFetchAllVerticalIndustryQueryVariables>(FetchAllVerticalIndustryDocument, options);
        }
export type FetchAllVerticalIndustryQueryHookResult = ReturnType<typeof useFetchAllVerticalIndustryQuery>;
export type FetchAllVerticalIndustryLazyQueryHookResult = ReturnType<typeof useFetchAllVerticalIndustryLazyQuery>;
export type FetchAllVerticalIndustryQueryResult = Apollo.QueryResult<IFetchAllVerticalIndustryQuery, IFetchAllVerticalIndustryQueryVariables>;
export const FetchAllVerticalHeadsDocument = gql`
    query fetchAllVerticalHeads {
  getAllVerticalHeads {
    id
    verticalLeadName
  }
}
    `;

/**
 * __useFetchAllVerticalHeadsQuery__
 *
 * To run a query within a React component, call `useFetchAllVerticalHeadsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAllVerticalHeadsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAllVerticalHeadsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchAllVerticalHeadsQuery(baseOptions?: Apollo.QueryHookOptions<IFetchAllVerticalHeadsQuery, IFetchAllVerticalHeadsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IFetchAllVerticalHeadsQuery, IFetchAllVerticalHeadsQueryVariables>(FetchAllVerticalHeadsDocument, options);
      }
export function useFetchAllVerticalHeadsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IFetchAllVerticalHeadsQuery, IFetchAllVerticalHeadsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IFetchAllVerticalHeadsQuery, IFetchAllVerticalHeadsQueryVariables>(FetchAllVerticalHeadsDocument, options);
        }
export type FetchAllVerticalHeadsQueryHookResult = ReturnType<typeof useFetchAllVerticalHeadsQuery>;
export type FetchAllVerticalHeadsLazyQueryHookResult = ReturnType<typeof useFetchAllVerticalHeadsLazyQuery>;
export type FetchAllVerticalHeadsQueryResult = Apollo.QueryResult<IFetchAllVerticalHeadsQuery, IFetchAllVerticalHeadsQueryVariables>;
export const FetchGetAllVerticalIndustryByVerticalIdDocument = gql`
    query fetchGetAllVerticalIndustryByVerticalId($verticalId: String!) {
  getAllVerticalIndustryByVerticalId(verticalId: $verticalId) {
    name
    industryId
  }
}
    `;

/**
 * __useFetchGetAllVerticalIndustryByVerticalIdQuery__
 *
 * To run a query within a React component, call `useFetchGetAllVerticalIndustryByVerticalIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchGetAllVerticalIndustryByVerticalIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchGetAllVerticalIndustryByVerticalIdQuery({
 *   variables: {
 *      verticalId: // value for 'verticalId'
 *   },
 * });
 */
export function useFetchGetAllVerticalIndustryByVerticalIdQuery(baseOptions: Apollo.QueryHookOptions<IFetchGetAllVerticalIndustryByVerticalIdQuery, IFetchGetAllVerticalIndustryByVerticalIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IFetchGetAllVerticalIndustryByVerticalIdQuery, IFetchGetAllVerticalIndustryByVerticalIdQueryVariables>(FetchGetAllVerticalIndustryByVerticalIdDocument, options);
      }
export function useFetchGetAllVerticalIndustryByVerticalIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IFetchGetAllVerticalIndustryByVerticalIdQuery, IFetchGetAllVerticalIndustryByVerticalIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IFetchGetAllVerticalIndustryByVerticalIdQuery, IFetchGetAllVerticalIndustryByVerticalIdQueryVariables>(FetchGetAllVerticalIndustryByVerticalIdDocument, options);
        }
export type FetchGetAllVerticalIndustryByVerticalIdQueryHookResult = ReturnType<typeof useFetchGetAllVerticalIndustryByVerticalIdQuery>;
export type FetchGetAllVerticalIndustryByVerticalIdLazyQueryHookResult = ReturnType<typeof useFetchGetAllVerticalIndustryByVerticalIdLazyQuery>;
export type FetchGetAllVerticalIndustryByVerticalIdQueryResult = Apollo.QueryResult<IFetchGetAllVerticalIndustryByVerticalIdQuery, IFetchGetAllVerticalIndustryByVerticalIdQueryVariables>;
export const FetchGetMainDepartmentAndSubDepartmentsDocument = gql`
    query fetchGetMainDepartmentAndSubDepartments {
  getMainDepartmentAndSubDepartments {
    mainDepartmentId
    mainDepartmentName
    subDepartments {
      id
      name
    }
  }
}
    `;

/**
 * __useFetchGetMainDepartmentAndSubDepartmentsQuery__
 *
 * To run a query within a React component, call `useFetchGetMainDepartmentAndSubDepartmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchGetMainDepartmentAndSubDepartmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchGetMainDepartmentAndSubDepartmentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchGetMainDepartmentAndSubDepartmentsQuery(baseOptions?: Apollo.QueryHookOptions<IFetchGetMainDepartmentAndSubDepartmentsQuery, IFetchGetMainDepartmentAndSubDepartmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IFetchGetMainDepartmentAndSubDepartmentsQuery, IFetchGetMainDepartmentAndSubDepartmentsQueryVariables>(FetchGetMainDepartmentAndSubDepartmentsDocument, options);
      }
export function useFetchGetMainDepartmentAndSubDepartmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IFetchGetMainDepartmentAndSubDepartmentsQuery, IFetchGetMainDepartmentAndSubDepartmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IFetchGetMainDepartmentAndSubDepartmentsQuery, IFetchGetMainDepartmentAndSubDepartmentsQueryVariables>(FetchGetMainDepartmentAndSubDepartmentsDocument, options);
        }
export type FetchGetMainDepartmentAndSubDepartmentsQueryHookResult = ReturnType<typeof useFetchGetMainDepartmentAndSubDepartmentsQuery>;
export type FetchGetMainDepartmentAndSubDepartmentsLazyQueryHookResult = ReturnType<typeof useFetchGetMainDepartmentAndSubDepartmentsLazyQuery>;
export type FetchGetMainDepartmentAndSubDepartmentsQueryResult = Apollo.QueryResult<IFetchGetMainDepartmentAndSubDepartmentsQuery, IFetchGetMainDepartmentAndSubDepartmentsQueryVariables>;
export const FindAllTrainingCertificatesByProfileIdDocument = gql`
    query findAllTrainingCertificatesByProfileId($profileId: String!) {
  findAllTrainingCertificatesByProfileId(profileId: $profileId) {
    certificateId
    certificateTitle
    currentlyStudying
    endDate
    id
    instructor
    issuingInstituionOrOrganization
    profileId
    startDate
    uploads {
      filename
      url
    }
  }
}
    `;

/**
 * __useFindAllTrainingCertificatesByProfileIdQuery__
 *
 * To run a query within a React component, call `useFindAllTrainingCertificatesByProfileIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllTrainingCertificatesByProfileIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllTrainingCertificatesByProfileIdQuery({
 *   variables: {
 *      profileId: // value for 'profileId'
 *   },
 * });
 */
export function useFindAllTrainingCertificatesByProfileIdQuery(baseOptions: Apollo.QueryHookOptions<IFindAllTrainingCertificatesByProfileIdQuery, IFindAllTrainingCertificatesByProfileIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IFindAllTrainingCertificatesByProfileIdQuery, IFindAllTrainingCertificatesByProfileIdQueryVariables>(FindAllTrainingCertificatesByProfileIdDocument, options);
      }
export function useFindAllTrainingCertificatesByProfileIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IFindAllTrainingCertificatesByProfileIdQuery, IFindAllTrainingCertificatesByProfileIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IFindAllTrainingCertificatesByProfileIdQuery, IFindAllTrainingCertificatesByProfileIdQueryVariables>(FindAllTrainingCertificatesByProfileIdDocument, options);
        }
export type FindAllTrainingCertificatesByProfileIdQueryHookResult = ReturnType<typeof useFindAllTrainingCertificatesByProfileIdQuery>;
export type FindAllTrainingCertificatesByProfileIdLazyQueryHookResult = ReturnType<typeof useFindAllTrainingCertificatesByProfileIdLazyQuery>;
export type FindAllTrainingCertificatesByProfileIdQueryResult = Apollo.QueryResult<IFindAllTrainingCertificatesByProfileIdQuery, IFindAllTrainingCertificatesByProfileIdQueryVariables>;
export const GetDepartmentByLevelDocument = gql`
    query getDepartmentByLevel($level: departmentLevel!) {
  getDepartmentByLevel(level: $level) {
    name
    id
    level
    parentId
  }
}
    `;

/**
 * __useGetDepartmentByLevelQuery__
 *
 * To run a query within a React component, call `useGetDepartmentByLevelQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDepartmentByLevelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDepartmentByLevelQuery({
 *   variables: {
 *      level: // value for 'level'
 *   },
 * });
 */
export function useGetDepartmentByLevelQuery(baseOptions: Apollo.QueryHookOptions<IGetDepartmentByLevelQuery, IGetDepartmentByLevelQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetDepartmentByLevelQuery, IGetDepartmentByLevelQueryVariables>(GetDepartmentByLevelDocument, options);
      }
export function useGetDepartmentByLevelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetDepartmentByLevelQuery, IGetDepartmentByLevelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetDepartmentByLevelQuery, IGetDepartmentByLevelQueryVariables>(GetDepartmentByLevelDocument, options);
        }
export type GetDepartmentByLevelQueryHookResult = ReturnType<typeof useGetDepartmentByLevelQuery>;
export type GetDepartmentByLevelLazyQueryHookResult = ReturnType<typeof useGetDepartmentByLevelLazyQuery>;
export type GetDepartmentByLevelQueryResult = Apollo.QueryResult<IGetDepartmentByLevelQuery, IGetDepartmentByLevelQueryVariables>;
export const GetEmailExistsDocument = gql`
    query getEmailExists($email: String!) {
  emailExists(email: $email)
}
    `;

/**
 * __useGetEmailExistsQuery__
 *
 * To run a query within a React component, call `useGetEmailExistsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmailExistsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmailExistsQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useGetEmailExistsQuery(baseOptions: Apollo.QueryHookOptions<IGetEmailExistsQuery, IGetEmailExistsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetEmailExistsQuery, IGetEmailExistsQueryVariables>(GetEmailExistsDocument, options);
      }
export function useGetEmailExistsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetEmailExistsQuery, IGetEmailExistsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetEmailExistsQuery, IGetEmailExistsQueryVariables>(GetEmailExistsDocument, options);
        }
export type GetEmailExistsQueryHookResult = ReturnType<typeof useGetEmailExistsQuery>;
export type GetEmailExistsLazyQueryHookResult = ReturnType<typeof useGetEmailExistsLazyQuery>;
export type GetEmailExistsQueryResult = Apollo.QueryResult<IGetEmailExistsQuery, IGetEmailExistsQueryVariables>;
export const UploadFileDocument = gql`
    mutation UploadFile($file: Upload!, $jobId: String!, $keepBoth: Boolean!) {
  uploadFile(file: $file, jobId: $jobId, keepBoth: $keepBoth) {
    resumeUrl
    id
    jobId
    originalFilename
    keepBoth
  }
}
    `;
export type IUploadFileMutationFn = Apollo.MutationFunction<IUploadFileMutation, IUploadFileMutationVariables>;

/**
 * __useUploadFileMutation__
 *
 * To run a mutation, you first call `useUploadFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadFileMutation, { data, loading, error }] = useUploadFileMutation({
 *   variables: {
 *      file: // value for 'file'
 *      jobId: // value for 'jobId'
 *      keepBoth: // value for 'keepBoth'
 *   },
 * });
 */
export function useUploadFileMutation(baseOptions?: Apollo.MutationHookOptions<IUploadFileMutation, IUploadFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUploadFileMutation, IUploadFileMutationVariables>(UploadFileDocument, options);
      }
export type UploadFileMutationHookResult = ReturnType<typeof useUploadFileMutation>;
export type UploadFileMutationResult = Apollo.MutationResult<IUploadFileMutation>;
export type UploadFileMutationOptions = Apollo.BaseMutationOptions<IUploadFileMutation, IUploadFileMutationVariables>;
export const DeleteUploadedResumeDocument = gql`
    mutation DeleteUploadedResume($resumeId: String!) {
  deleteResume(resumeId: $resumeId) {
    id
  }
}
    `;
export type IDeleteUploadedResumeMutationFn = Apollo.MutationFunction<IDeleteUploadedResumeMutation, IDeleteUploadedResumeMutationVariables>;

/**
 * __useDeleteUploadedResumeMutation__
 *
 * To run a mutation, you first call `useDeleteUploadedResumeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUploadedResumeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUploadedResumeMutation, { data, loading, error }] = useDeleteUploadedResumeMutation({
 *   variables: {
 *      resumeId: // value for 'resumeId'
 *   },
 * });
 */
export function useDeleteUploadedResumeMutation(baseOptions?: Apollo.MutationHookOptions<IDeleteUploadedResumeMutation, IDeleteUploadedResumeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IDeleteUploadedResumeMutation, IDeleteUploadedResumeMutationVariables>(DeleteUploadedResumeDocument, options);
      }
export type DeleteUploadedResumeMutationHookResult = ReturnType<typeof useDeleteUploadedResumeMutation>;
export type DeleteUploadedResumeMutationResult = Apollo.MutationResult<IDeleteUploadedResumeMutation>;
export type DeleteUploadedResumeMutationOptions = Apollo.BaseMutationOptions<IDeleteUploadedResumeMutation, IDeleteUploadedResumeMutationVariables>;
export const ImportResumesJobDocument = gql`
    mutation ImportResumesJob($jobId: String!, $resumeImportDto: ResumeUpdateDto!, $filterTestUsers: Boolean!) {
  importResumesForJob(
    jobId: $jobId
    resumeImportDto: $resumeImportDto
    filterTestUsers: $filterTestUsers
  ) {
    ...resumeImportLog
  }
}
    ${ResumeImportLogFragmentDoc}`;
export type IImportResumesJobMutationFn = Apollo.MutationFunction<IImportResumesJobMutation, IImportResumesJobMutationVariables>;

/**
 * __useImportResumesJobMutation__
 *
 * To run a mutation, you first call `useImportResumesJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportResumesJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importResumesJobMutation, { data, loading, error }] = useImportResumesJobMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *      resumeImportDto: // value for 'resumeImportDto'
 *      filterTestUsers: // value for 'filterTestUsers'
 *   },
 * });
 */
export function useImportResumesJobMutation(baseOptions?: Apollo.MutationHookOptions<IImportResumesJobMutation, IImportResumesJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IImportResumesJobMutation, IImportResumesJobMutationVariables>(ImportResumesJobDocument, options);
      }
export type ImportResumesJobMutationHookResult = ReturnType<typeof useImportResumesJobMutation>;
export type ImportResumesJobMutationResult = Apollo.MutationResult<IImportResumesJobMutation>;
export type ImportResumesJobMutationOptions = Apollo.BaseMutationOptions<IImportResumesJobMutation, IImportResumesJobMutationVariables>;
export const DeleteImportResumeDocument = gql`
    mutation DeleteImportResume($jobId: String!) {
  deleteResumeImportLogByJobId(jobId: $jobId)
}
    `;
export type IDeleteImportResumeMutationFn = Apollo.MutationFunction<IDeleteImportResumeMutation, IDeleteImportResumeMutationVariables>;

/**
 * __useDeleteImportResumeMutation__
 *
 * To run a mutation, you first call `useDeleteImportResumeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteImportResumeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteImportResumeMutation, { data, loading, error }] = useDeleteImportResumeMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useDeleteImportResumeMutation(baseOptions?: Apollo.MutationHookOptions<IDeleteImportResumeMutation, IDeleteImportResumeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IDeleteImportResumeMutation, IDeleteImportResumeMutationVariables>(DeleteImportResumeDocument, options);
      }
export type DeleteImportResumeMutationHookResult = ReturnType<typeof useDeleteImportResumeMutation>;
export type DeleteImportResumeMutationResult = Apollo.MutationResult<IDeleteImportResumeMutation>;
export type DeleteImportResumeMutationOptions = Apollo.BaseMutationOptions<IDeleteImportResumeMutation, IDeleteImportResumeMutationVariables>;
export const DeleteAllUploadedResumeDocument = gql`
    mutation DeleteAllUploadedResume($jobId: String!) {
  deleteMultipleResume(jobId: $jobId)
}
    `;
export type IDeleteAllUploadedResumeMutationFn = Apollo.MutationFunction<IDeleteAllUploadedResumeMutation, IDeleteAllUploadedResumeMutationVariables>;

/**
 * __useDeleteAllUploadedResumeMutation__
 *
 * To run a mutation, you first call `useDeleteAllUploadedResumeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAllUploadedResumeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAllUploadedResumeMutation, { data, loading, error }] = useDeleteAllUploadedResumeMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useDeleteAllUploadedResumeMutation(baseOptions?: Apollo.MutationHookOptions<IDeleteAllUploadedResumeMutation, IDeleteAllUploadedResumeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IDeleteAllUploadedResumeMutation, IDeleteAllUploadedResumeMutationVariables>(DeleteAllUploadedResumeDocument, options);
      }
export type DeleteAllUploadedResumeMutationHookResult = ReturnType<typeof useDeleteAllUploadedResumeMutation>;
export type DeleteAllUploadedResumeMutationResult = Apollo.MutationResult<IDeleteAllUploadedResumeMutation>;
export type DeleteAllUploadedResumeMutationOptions = Apollo.BaseMutationOptions<IDeleteAllUploadedResumeMutation, IDeleteAllUploadedResumeMutationVariables>;
export const DeleteParsedResumeDocument = gql`
    mutation DeleteParsedResume($parsedResumeReq: ParsedResumeReq!) {
  deleteParsedResume(parsedResumeReq: $parsedResumeReq)
}
    `;
export type IDeleteParsedResumeMutationFn = Apollo.MutationFunction<IDeleteParsedResumeMutation, IDeleteParsedResumeMutationVariables>;

/**
 * __useDeleteParsedResumeMutation__
 *
 * To run a mutation, you first call `useDeleteParsedResumeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteParsedResumeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteParsedResumeMutation, { data, loading, error }] = useDeleteParsedResumeMutation({
 *   variables: {
 *      parsedResumeReq: // value for 'parsedResumeReq'
 *   },
 * });
 */
export function useDeleteParsedResumeMutation(baseOptions?: Apollo.MutationHookOptions<IDeleteParsedResumeMutation, IDeleteParsedResumeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IDeleteParsedResumeMutation, IDeleteParsedResumeMutationVariables>(DeleteParsedResumeDocument, options);
      }
export type DeleteParsedResumeMutationHookResult = ReturnType<typeof useDeleteParsedResumeMutation>;
export type DeleteParsedResumeMutationResult = Apollo.MutationResult<IDeleteParsedResumeMutation>;
export type DeleteParsedResumeMutationOptions = Apollo.BaseMutationOptions<IDeleteParsedResumeMutation, IDeleteParsedResumeMutationVariables>;
export const UpdateJobStatusDocument = gql`
    mutation UpdateJobStatus($jobStatusUpdateDto: JobStatusUpdateDto!) {
  updateJobStatus(jobStatusUpdateDto: $jobStatusUpdateDto) {
    done
    matchedCount
    modifiedCount
  }
}
    `;
export type IUpdateJobStatusMutationFn = Apollo.MutationFunction<IUpdateJobStatusMutation, IUpdateJobStatusMutationVariables>;

/**
 * __useUpdateJobStatusMutation__
 *
 * To run a mutation, you first call `useUpdateJobStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateJobStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateJobStatusMutation, { data, loading, error }] = useUpdateJobStatusMutation({
 *   variables: {
 *      jobStatusUpdateDto: // value for 'jobStatusUpdateDto'
 *   },
 * });
 */
export function useUpdateJobStatusMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateJobStatusMutation, IUpdateJobStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateJobStatusMutation, IUpdateJobStatusMutationVariables>(UpdateJobStatusDocument, options);
      }
export type UpdateJobStatusMutationHookResult = ReturnType<typeof useUpdateJobStatusMutation>;
export type UpdateJobStatusMutationResult = Apollo.MutationResult<IUpdateJobStatusMutation>;
export type UpdateJobStatusMutationOptions = Apollo.BaseMutationOptions<IUpdateJobStatusMutation, IUpdateJobStatusMutationVariables>;
export const UpdateResumeDataDocument = gql`
    mutation updateResumeData($updateParsedResumedDto: ParsedResumeUpdateDto!) {
  updateParsedResume(updateParsedResumedDto: $updateParsedResumedDto) {
    batchId
    createdAt
    middleName
    lastName
    id
    jobId
    orgId
    resumeId
    resumeSource
    resumeUrl
    resumeId
    updatedAt
    userId
    yearsOfExperience
    address
    firstName
    email
    phone
    skills {
      hardSkills {
        category
        skill
      }
      softSkills
    }
  }
}
    `;
export type IUpdateResumeDataMutationFn = Apollo.MutationFunction<IUpdateResumeDataMutation, IUpdateResumeDataMutationVariables>;

/**
 * __useUpdateResumeDataMutation__
 *
 * To run a mutation, you first call `useUpdateResumeDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateResumeDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateResumeDataMutation, { data, loading, error }] = useUpdateResumeDataMutation({
 *   variables: {
 *      updateParsedResumedDto: // value for 'updateParsedResumedDto'
 *   },
 * });
 */
export function useUpdateResumeDataMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateResumeDataMutation, IUpdateResumeDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateResumeDataMutation, IUpdateResumeDataMutationVariables>(UpdateResumeDataDocument, options);
      }
export type UpdateResumeDataMutationHookResult = ReturnType<typeof useUpdateResumeDataMutation>;
export type UpdateResumeDataMutationResult = Apollo.MutationResult<IUpdateResumeDataMutation>;
export type UpdateResumeDataMutationOptions = Apollo.BaseMutationOptions<IUpdateResumeDataMutation, IUpdateResumeDataMutationVariables>;
export const DeleteJobByIdDocument = gql`
    mutation DeleteJobById($jobId: String!) {
  deleteJobById(jobId: $jobId)
}
    `;
export type IDeleteJobByIdMutationFn = Apollo.MutationFunction<IDeleteJobByIdMutation, IDeleteJobByIdMutationVariables>;

/**
 * __useDeleteJobByIdMutation__
 *
 * To run a mutation, you first call `useDeleteJobByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteJobByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteJobByIdMutation, { data, loading, error }] = useDeleteJobByIdMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useDeleteJobByIdMutation(baseOptions?: Apollo.MutationHookOptions<IDeleteJobByIdMutation, IDeleteJobByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IDeleteJobByIdMutation, IDeleteJobByIdMutationVariables>(DeleteJobByIdDocument, options);
      }
export type DeleteJobByIdMutationHookResult = ReturnType<typeof useDeleteJobByIdMutation>;
export type DeleteJobByIdMutationResult = Apollo.MutationResult<IDeleteJobByIdMutation>;
export type DeleteJobByIdMutationOptions = Apollo.BaseMutationOptions<IDeleteJobByIdMutation, IDeleteJobByIdMutationVariables>;
export const DeleteMultipleResumeByIdsDocument = gql`
    mutation DeleteMultipleResumeByIds($resumeIds: [String!]!) {
  deleteMultipleResumeByIds(resumeIds: $resumeIds)
}
    `;
export type IDeleteMultipleResumeByIdsMutationFn = Apollo.MutationFunction<IDeleteMultipleResumeByIdsMutation, IDeleteMultipleResumeByIdsMutationVariables>;

/**
 * __useDeleteMultipleResumeByIdsMutation__
 *
 * To run a mutation, you first call `useDeleteMultipleResumeByIdsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMultipleResumeByIdsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMultipleResumeByIdsMutation, { data, loading, error }] = useDeleteMultipleResumeByIdsMutation({
 *   variables: {
 *      resumeIds: // value for 'resumeIds'
 *   },
 * });
 */
export function useDeleteMultipleResumeByIdsMutation(baseOptions?: Apollo.MutationHookOptions<IDeleteMultipleResumeByIdsMutation, IDeleteMultipleResumeByIdsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IDeleteMultipleResumeByIdsMutation, IDeleteMultipleResumeByIdsMutationVariables>(DeleteMultipleResumeByIdsDocument, options);
      }
export type DeleteMultipleResumeByIdsMutationHookResult = ReturnType<typeof useDeleteMultipleResumeByIdsMutation>;
export type DeleteMultipleResumeByIdsMutationResult = Apollo.MutationResult<IDeleteMultipleResumeByIdsMutation>;
export type DeleteMultipleResumeByIdsMutationOptions = Apollo.BaseMutationOptions<IDeleteMultipleResumeByIdsMutation, IDeleteMultipleResumeByIdsMutationVariables>;
export const DeleteSourceParsedResumeDocument = gql`
    mutation DeleteSourceParsedResume($jobId: String!) {
  deleteSourceParsedResume(jobId: $jobId)
}
    `;
export type IDeleteSourceParsedResumeMutationFn = Apollo.MutationFunction<IDeleteSourceParsedResumeMutation, IDeleteSourceParsedResumeMutationVariables>;

/**
 * __useDeleteSourceParsedResumeMutation__
 *
 * To run a mutation, you first call `useDeleteSourceParsedResumeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSourceParsedResumeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSourceParsedResumeMutation, { data, loading, error }] = useDeleteSourceParsedResumeMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useDeleteSourceParsedResumeMutation(baseOptions?: Apollo.MutationHookOptions<IDeleteSourceParsedResumeMutation, IDeleteSourceParsedResumeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IDeleteSourceParsedResumeMutation, IDeleteSourceParsedResumeMutationVariables>(DeleteSourceParsedResumeDocument, options);
      }
export type DeleteSourceParsedResumeMutationHookResult = ReturnType<typeof useDeleteSourceParsedResumeMutation>;
export type DeleteSourceParsedResumeMutationResult = Apollo.MutationResult<IDeleteSourceParsedResumeMutation>;
export type DeleteSourceParsedResumeMutationOptions = Apollo.BaseMutationOptions<IDeleteSourceParsedResumeMutation, IDeleteSourceParsedResumeMutationVariables>;
export const DeleteResumeImportLogByJobIdDocument = gql`
    mutation DeleteResumeImportLogByJobId($jobId: String!) {
  deleteResumeImportLogByJobId(jobId: $jobId)
}
    `;
export type IDeleteResumeImportLogByJobIdMutationFn = Apollo.MutationFunction<IDeleteResumeImportLogByJobIdMutation, IDeleteResumeImportLogByJobIdMutationVariables>;

/**
 * __useDeleteResumeImportLogByJobIdMutation__
 *
 * To run a mutation, you first call `useDeleteResumeImportLogByJobIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteResumeImportLogByJobIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteResumeImportLogByJobIdMutation, { data, loading, error }] = useDeleteResumeImportLogByJobIdMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useDeleteResumeImportLogByJobIdMutation(baseOptions?: Apollo.MutationHookOptions<IDeleteResumeImportLogByJobIdMutation, IDeleteResumeImportLogByJobIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IDeleteResumeImportLogByJobIdMutation, IDeleteResumeImportLogByJobIdMutationVariables>(DeleteResumeImportLogByJobIdDocument, options);
      }
export type DeleteResumeImportLogByJobIdMutationHookResult = ReturnType<typeof useDeleteResumeImportLogByJobIdMutation>;
export type DeleteResumeImportLogByJobIdMutationResult = Apollo.MutationResult<IDeleteResumeImportLogByJobIdMutation>;
export type DeleteResumeImportLogByJobIdMutationOptions = Apollo.BaseMutationOptions<IDeleteResumeImportLogByJobIdMutation, IDeleteResumeImportLogByJobIdMutationVariables>;
export const DuplicateJobDocument = gql`
    mutation duplicateJob($jobId: String!, $importCandidates: Boolean!, $enterprisePeopleId: String!) {
  duplicateJob(
    jobId: $jobId
    importCandidates: $importCandidates
    enterprisePeopleId: $enterprisePeopleId
  ) {
    id
  }
}
    `;
export type IDuplicateJobMutationFn = Apollo.MutationFunction<IDuplicateJobMutation, IDuplicateJobMutationVariables>;

/**
 * __useDuplicateJobMutation__
 *
 * To run a mutation, you first call `useDuplicateJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateJobMutation, { data, loading, error }] = useDuplicateJobMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *      importCandidates: // value for 'importCandidates'
 *      enterprisePeopleId: // value for 'enterprisePeopleId'
 *   },
 * });
 */
export function useDuplicateJobMutation(baseOptions?: Apollo.MutationHookOptions<IDuplicateJobMutation, IDuplicateJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IDuplicateJobMutation, IDuplicateJobMutationVariables>(DuplicateJobDocument, options);
      }
export type DuplicateJobMutationHookResult = ReturnType<typeof useDuplicateJobMutation>;
export type DuplicateJobMutationResult = Apollo.MutationResult<IDuplicateJobMutation>;
export type DuplicateJobMutationOptions = Apollo.BaseMutationOptions<IDuplicateJobMutation, IDuplicateJobMutationVariables>;
export const UpdateCandidateStatusDocument = gql`
    mutation UpdateCandidateStatus($resumeId: String!, $statusDto: UpdateCandidateStatusDto!) {
  updateCandidateStatus(resumeId: $resumeId, statusDto: $statusDto) {
    candidateStage
    candidateStageStatus
    jobId
    parsedResumeId
    userId
  }
}
    `;
export type IUpdateCandidateStatusMutationFn = Apollo.MutationFunction<IUpdateCandidateStatusMutation, IUpdateCandidateStatusMutationVariables>;

/**
 * __useUpdateCandidateStatusMutation__
 *
 * To run a mutation, you first call `useUpdateCandidateStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCandidateStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCandidateStatusMutation, { data, loading, error }] = useUpdateCandidateStatusMutation({
 *   variables: {
 *      resumeId: // value for 'resumeId'
 *      statusDto: // value for 'statusDto'
 *   },
 * });
 */
export function useUpdateCandidateStatusMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateCandidateStatusMutation, IUpdateCandidateStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateCandidateStatusMutation, IUpdateCandidateStatusMutationVariables>(UpdateCandidateStatusDocument, options);
      }
export type UpdateCandidateStatusMutationHookResult = ReturnType<typeof useUpdateCandidateStatusMutation>;
export type UpdateCandidateStatusMutationResult = Apollo.MutationResult<IUpdateCandidateStatusMutation>;
export type UpdateCandidateStatusMutationOptions = Apollo.BaseMutationOptions<IUpdateCandidateStatusMutation, IUpdateCandidateStatusMutationVariables>;
export const MarkJobAsViewedDocument = gql`
    mutation MarkJobAsViewed($jobId: String!, $viewedBy: String!) {
  markJobAsViewed(jobId: $jobId, viewedBy: $viewedBy) {
    jobId
    viewedBy
  }
}
    `;
export type IMarkJobAsViewedMutationFn = Apollo.MutationFunction<IMarkJobAsViewedMutation, IMarkJobAsViewedMutationVariables>;

/**
 * __useMarkJobAsViewedMutation__
 *
 * To run a mutation, you first call `useMarkJobAsViewedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkJobAsViewedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markJobAsViewedMutation, { data, loading, error }] = useMarkJobAsViewedMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *      viewedBy: // value for 'viewedBy'
 *   },
 * });
 */
export function useMarkJobAsViewedMutation(baseOptions?: Apollo.MutationHookOptions<IMarkJobAsViewedMutation, IMarkJobAsViewedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IMarkJobAsViewedMutation, IMarkJobAsViewedMutationVariables>(MarkJobAsViewedDocument, options);
      }
export type MarkJobAsViewedMutationHookResult = ReturnType<typeof useMarkJobAsViewedMutation>;
export type MarkJobAsViewedMutationResult = Apollo.MutationResult<IMarkJobAsViewedMutation>;
export type MarkJobAsViewedMutationOptions = Apollo.BaseMutationOptions<IMarkJobAsViewedMutation, IMarkJobAsViewedMutationVariables>;
export const UpdateJobDocument = gql`
    mutation UpdateJob($id: String!, $jobUpdateDto: JobUpdateDto!) {
  updateJob(id: $id, jobUpdateDto: $jobUpdateDto) {
    ...job
  }
}
    ${JobFragmentDoc}`;
export type IUpdateJobMutationFn = Apollo.MutationFunction<IUpdateJobMutation, IUpdateJobMutationVariables>;

/**
 * __useUpdateJobMutation__
 *
 * To run a mutation, you first call `useUpdateJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateJobMutation, { data, loading, error }] = useUpdateJobMutation({
 *   variables: {
 *      id: // value for 'id'
 *      jobUpdateDto: // value for 'jobUpdateDto'
 *   },
 * });
 */
export function useUpdateJobMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateJobMutation, IUpdateJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateJobMutation, IUpdateJobMutationVariables>(UpdateJobDocument, options);
      }
export type UpdateJobMutationHookResult = ReturnType<typeof useUpdateJobMutation>;
export type UpdateJobMutationResult = Apollo.MutationResult<IUpdateJobMutation>;
export type UpdateJobMutationOptions = Apollo.BaseMutationOptions<IUpdateJobMutation, IUpdateJobMutationVariables>;
export const CreateJobDescriptionTemplateDocument = gql`
    mutation CreateJobDescriptionTemplate($template: CreateJobDescriptionTemplate!) {
  createJobDescriptionTemplate(template: $template) {
    createdBy
    jobDescription
    title
    id
  }
}
    `;
export type ICreateJobDescriptionTemplateMutationFn = Apollo.MutationFunction<ICreateJobDescriptionTemplateMutation, ICreateJobDescriptionTemplateMutationVariables>;

/**
 * __useCreateJobDescriptionTemplateMutation__
 *
 * To run a mutation, you first call `useCreateJobDescriptionTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateJobDescriptionTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createJobDescriptionTemplateMutation, { data, loading, error }] = useCreateJobDescriptionTemplateMutation({
 *   variables: {
 *      template: // value for 'template'
 *   },
 * });
 */
export function useCreateJobDescriptionTemplateMutation(baseOptions?: Apollo.MutationHookOptions<ICreateJobDescriptionTemplateMutation, ICreateJobDescriptionTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ICreateJobDescriptionTemplateMutation, ICreateJobDescriptionTemplateMutationVariables>(CreateJobDescriptionTemplateDocument, options);
      }
export type CreateJobDescriptionTemplateMutationHookResult = ReturnType<typeof useCreateJobDescriptionTemplateMutation>;
export type CreateJobDescriptionTemplateMutationResult = Apollo.MutationResult<ICreateJobDescriptionTemplateMutation>;
export type CreateJobDescriptionTemplateMutationOptions = Apollo.BaseMutationOptions<ICreateJobDescriptionTemplateMutation, ICreateJobDescriptionTemplateMutationVariables>;
export const AddNoteToCandidateDocument = gql`
    mutation AddNoteToCandidate($createNoteDto: CreateNoteDto!) {
  addNoteToCandidate(createNoteDto: $createNoteDto) {
    candidateId
    candidateStage
    createdBy
    creatorId
    jobId
    note
    parentId
    parsedResumeId
    noteContext
    _id
  }
}
    `;
export type IAddNoteToCandidateMutationFn = Apollo.MutationFunction<IAddNoteToCandidateMutation, IAddNoteToCandidateMutationVariables>;

/**
 * __useAddNoteToCandidateMutation__
 *
 * To run a mutation, you first call `useAddNoteToCandidateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddNoteToCandidateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addNoteToCandidateMutation, { data, loading, error }] = useAddNoteToCandidateMutation({
 *   variables: {
 *      createNoteDto: // value for 'createNoteDto'
 *   },
 * });
 */
export function useAddNoteToCandidateMutation(baseOptions?: Apollo.MutationHookOptions<IAddNoteToCandidateMutation, IAddNoteToCandidateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IAddNoteToCandidateMutation, IAddNoteToCandidateMutationVariables>(AddNoteToCandidateDocument, options);
      }
export type AddNoteToCandidateMutationHookResult = ReturnType<typeof useAddNoteToCandidateMutation>;
export type AddNoteToCandidateMutationResult = Apollo.MutationResult<IAddNoteToCandidateMutation>;
export type AddNoteToCandidateMutationOptions = Apollo.BaseMutationOptions<IAddNoteToCandidateMutation, IAddNoteToCandidateMutationVariables>;
export const UploadDocumentsDocument = gql`
    mutation UploadDocuments($files: [Upload!], $parsedResumeId: String!, $uploadedBy: String!, $replaceFile: Boolean!) {
  uploadDocuments(
    files: $files
    parsedResumeId: $parsedResumeId
    uploadedBy: $uploadedBy
    replaceFile: $replaceFile
  ) {
    candidateStage
    candidateStageStatus
    jobId
    parsedResumeId
    userId
    documents {
      originalFileName
      docUrl
      uploadedBy
      timeStamp
    }
  }
}
    `;
export type IUploadDocumentsMutationFn = Apollo.MutationFunction<IUploadDocumentsMutation, IUploadDocumentsMutationVariables>;

/**
 * __useUploadDocumentsMutation__
 *
 * To run a mutation, you first call `useUploadDocumentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadDocumentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadDocumentsMutation, { data, loading, error }] = useUploadDocumentsMutation({
 *   variables: {
 *      files: // value for 'files'
 *      parsedResumeId: // value for 'parsedResumeId'
 *      uploadedBy: // value for 'uploadedBy'
 *      replaceFile: // value for 'replaceFile'
 *   },
 * });
 */
export function useUploadDocumentsMutation(baseOptions?: Apollo.MutationHookOptions<IUploadDocumentsMutation, IUploadDocumentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUploadDocumentsMutation, IUploadDocumentsMutationVariables>(UploadDocumentsDocument, options);
      }
export type UploadDocumentsMutationHookResult = ReturnType<typeof useUploadDocumentsMutation>;
export type UploadDocumentsMutationResult = Apollo.MutationResult<IUploadDocumentsMutation>;
export type UploadDocumentsMutationOptions = Apollo.BaseMutationOptions<IUploadDocumentsMutation, IUploadDocumentsMutationVariables>;
export const DeleteCandidateDocumentDocument = gql`
    mutation deleteCandidateDocument($docUrl: String!, $parsedResumeId: String!) {
  deleteCandidateDocument(docUrl: $docUrl, parsedResumeId: $parsedResumeId)
}
    `;
export type IDeleteCandidateDocumentMutationFn = Apollo.MutationFunction<IDeleteCandidateDocumentMutation, IDeleteCandidateDocumentMutationVariables>;

/**
 * __useDeleteCandidateDocumentMutation__
 *
 * To run a mutation, you first call `useDeleteCandidateDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCandidateDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCandidateDocumentMutation, { data, loading, error }] = useDeleteCandidateDocumentMutation({
 *   variables: {
 *      docUrl: // value for 'docUrl'
 *      parsedResumeId: // value for 'parsedResumeId'
 *   },
 * });
 */
export function useDeleteCandidateDocumentMutation(baseOptions?: Apollo.MutationHookOptions<IDeleteCandidateDocumentMutation, IDeleteCandidateDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IDeleteCandidateDocumentMutation, IDeleteCandidateDocumentMutationVariables>(DeleteCandidateDocumentDocument, options);
      }
export type DeleteCandidateDocumentMutationHookResult = ReturnType<typeof useDeleteCandidateDocumentMutation>;
export type DeleteCandidateDocumentMutationResult = Apollo.MutationResult<IDeleteCandidateDocumentMutation>;
export type DeleteCandidateDocumentMutationOptions = Apollo.BaseMutationOptions<IDeleteCandidateDocumentMutation, IDeleteCandidateDocumentMutationVariables>;
export const DeleteNoteDocument = gql`
    mutation DeleteNote($id: String!) {
  deleteNote(id: $id)
}
    `;
export type IDeleteNoteMutationFn = Apollo.MutationFunction<IDeleteNoteMutation, IDeleteNoteMutationVariables>;

/**
 * __useDeleteNoteMutation__
 *
 * To run a mutation, you first call `useDeleteNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteNoteMutation, { data, loading, error }] = useDeleteNoteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteNoteMutation(baseOptions?: Apollo.MutationHookOptions<IDeleteNoteMutation, IDeleteNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IDeleteNoteMutation, IDeleteNoteMutationVariables>(DeleteNoteDocument, options);
      }
export type DeleteNoteMutationHookResult = ReturnType<typeof useDeleteNoteMutation>;
export type DeleteNoteMutationResult = Apollo.MutationResult<IDeleteNoteMutation>;
export type DeleteNoteMutationOptions = Apollo.BaseMutationOptions<IDeleteNoteMutation, IDeleteNoteMutationVariables>;
export const UpdateCandidateNoteDocument = gql`
    mutation UpdateCandidateNote($updateNoteDto: UpdateNoteDto!) {
  updateCandidateNote(updateNoteDto: $updateNoteDto) {
    _id
    candidateId
    candidateStage
    createdAt
    createdBy
    creatorId
    jobId
    note
    parentId
    parsedResumeId
    updatedAt
    noteContext
  }
}
    `;
export type IUpdateCandidateNoteMutationFn = Apollo.MutationFunction<IUpdateCandidateNoteMutation, IUpdateCandidateNoteMutationVariables>;

/**
 * __useUpdateCandidateNoteMutation__
 *
 * To run a mutation, you first call `useUpdateCandidateNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCandidateNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCandidateNoteMutation, { data, loading, error }] = useUpdateCandidateNoteMutation({
 *   variables: {
 *      updateNoteDto: // value for 'updateNoteDto'
 *   },
 * });
 */
export function useUpdateCandidateNoteMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateCandidateNoteMutation, IUpdateCandidateNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateCandidateNoteMutation, IUpdateCandidateNoteMutationVariables>(UpdateCandidateNoteDocument, options);
      }
export type UpdateCandidateNoteMutationHookResult = ReturnType<typeof useUpdateCandidateNoteMutation>;
export type UpdateCandidateNoteMutationResult = Apollo.MutationResult<IUpdateCandidateNoteMutation>;
export type UpdateCandidateNoteMutationOptions = Apollo.BaseMutationOptions<IUpdateCandidateNoteMutation, IUpdateCandidateNoteMutationVariables>;
export const UpdateCandidateProfileDocument = gql`
    mutation UpdateCandidateProfile($id: String!, $updateCandidateDto: CandidateInfo!) {
  updateCandidateProfile(id: $id, updateCandidateDto: $updateCandidateDto) {
    address
    email
    firstName
    id
    lastName
    latestEmployer
    middleName
    phone
    softSkills
    technicalSkills
    yearsOfExperience
  }
}
    `;
export type IUpdateCandidateProfileMutationFn = Apollo.MutationFunction<IUpdateCandidateProfileMutation, IUpdateCandidateProfileMutationVariables>;

/**
 * __useUpdateCandidateProfileMutation__
 *
 * To run a mutation, you first call `useUpdateCandidateProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCandidateProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCandidateProfileMutation, { data, loading, error }] = useUpdateCandidateProfileMutation({
 *   variables: {
 *      id: // value for 'id'
 *      updateCandidateDto: // value for 'updateCandidateDto'
 *   },
 * });
 */
export function useUpdateCandidateProfileMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateCandidateProfileMutation, IUpdateCandidateProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateCandidateProfileMutation, IUpdateCandidateProfileMutationVariables>(UpdateCandidateProfileDocument, options);
      }
export type UpdateCandidateProfileMutationHookResult = ReturnType<typeof useUpdateCandidateProfileMutation>;
export type UpdateCandidateProfileMutationResult = Apollo.MutationResult<IUpdateCandidateProfileMutation>;
export type UpdateCandidateProfileMutationOptions = Apollo.BaseMutationOptions<IUpdateCandidateProfileMutation, IUpdateCandidateProfileMutationVariables>;
export const UnarchiveJobDocument = gql`
    mutation UnarchiveJob($id: String!) {
  unarchiveJob(id: $id)
}
    `;
export type IUnarchiveJobMutationFn = Apollo.MutationFunction<IUnarchiveJobMutation, IUnarchiveJobMutationVariables>;

/**
 * __useUnarchiveJobMutation__
 *
 * To run a mutation, you first call `useUnarchiveJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnarchiveJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unarchiveJobMutation, { data, loading, error }] = useUnarchiveJobMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnarchiveJobMutation(baseOptions?: Apollo.MutationHookOptions<IUnarchiveJobMutation, IUnarchiveJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUnarchiveJobMutation, IUnarchiveJobMutationVariables>(UnarchiveJobDocument, options);
      }
export type UnarchiveJobMutationHookResult = ReturnType<typeof useUnarchiveJobMutation>;
export type UnarchiveJobMutationResult = Apollo.MutationResult<IUnarchiveJobMutation>;
export type UnarchiveJobMutationOptions = Apollo.BaseMutationOptions<IUnarchiveJobMutation, IUnarchiveJobMutationVariables>;
export const ReplaceResumeDocument = gql`
    mutation ReplaceResume($upload: Upload!, $jobId: String!, $resumeId: String!) {
  replaceResume(file: $upload, jobId: $jobId, resumeId: $resumeId) {
    id
    jobId
    keepBoth
    orgId
    originalFilename
    resumeUrl
  }
}
    `;
export type IReplaceResumeMutationFn = Apollo.MutationFunction<IReplaceResumeMutation, IReplaceResumeMutationVariables>;

/**
 * __useReplaceResumeMutation__
 *
 * To run a mutation, you first call `useReplaceResumeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReplaceResumeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [replaceResumeMutation, { data, loading, error }] = useReplaceResumeMutation({
 *   variables: {
 *      upload: // value for 'upload'
 *      jobId: // value for 'jobId'
 *      resumeId: // value for 'resumeId'
 *   },
 * });
 */
export function useReplaceResumeMutation(baseOptions?: Apollo.MutationHookOptions<IReplaceResumeMutation, IReplaceResumeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IReplaceResumeMutation, IReplaceResumeMutationVariables>(ReplaceResumeDocument, options);
      }
export type ReplaceResumeMutationHookResult = ReturnType<typeof useReplaceResumeMutation>;
export type ReplaceResumeMutationResult = Apollo.MutationResult<IReplaceResumeMutation>;
export type ReplaceResumeMutationOptions = Apollo.BaseMutationOptions<IReplaceResumeMutation, IReplaceResumeMutationVariables>;
export const ReparseResumeDocument = gql`
    mutation ReparseResume($id: String!, $jobUpdateDto: JobUpdateDto!) {
  reparseResume(id: $id, jobUpdateDto: $jobUpdateDto)
}
    `;
export type IReparseResumeMutationFn = Apollo.MutationFunction<IReparseResumeMutation, IReparseResumeMutationVariables>;

/**
 * __useReparseResumeMutation__
 *
 * To run a mutation, you first call `useReparseResumeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReparseResumeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reparseResumeMutation, { data, loading, error }] = useReparseResumeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      jobUpdateDto: // value for 'jobUpdateDto'
 *   },
 * });
 */
export function useReparseResumeMutation(baseOptions?: Apollo.MutationHookOptions<IReparseResumeMutation, IReparseResumeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IReparseResumeMutation, IReparseResumeMutationVariables>(ReparseResumeDocument, options);
      }
export type ReparseResumeMutationHookResult = ReturnType<typeof useReparseResumeMutation>;
export type ReparseResumeMutationResult = Apollo.MutationResult<IReparseResumeMutation>;
export type ReparseResumeMutationOptions = Apollo.BaseMutationOptions<IReparseResumeMutation, IReparseResumeMutationVariables>;
export const RequestGeminiScoringDocument = gql`
    mutation requestGeminiScoring($data: MLScoreRequestDto!) {
  requestGeminiScoring(data: $data)
}
    `;
export type IRequestGeminiScoringMutationFn = Apollo.MutationFunction<IRequestGeminiScoringMutation, IRequestGeminiScoringMutationVariables>;

/**
 * __useRequestGeminiScoringMutation__
 *
 * To run a mutation, you first call `useRequestGeminiScoringMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestGeminiScoringMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestGeminiScoringMutation, { data, loading, error }] = useRequestGeminiScoringMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRequestGeminiScoringMutation(baseOptions?: Apollo.MutationHookOptions<IRequestGeminiScoringMutation, IRequestGeminiScoringMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IRequestGeminiScoringMutation, IRequestGeminiScoringMutationVariables>(RequestGeminiScoringDocument, options);
      }
export type RequestGeminiScoringMutationHookResult = ReturnType<typeof useRequestGeminiScoringMutation>;
export type RequestGeminiScoringMutationResult = Apollo.MutationResult<IRequestGeminiScoringMutation>;
export type RequestGeminiScoringMutationOptions = Apollo.BaseMutationOptions<IRequestGeminiScoringMutation, IRequestGeminiScoringMutationVariables>;
export const GetSignedUrlForUploadDocument = gql`
    mutation GetSignedUrlForUpload($resumeSignedRequest: ResumeSignedUrlRequest!) {
  getSignedUrlForUpload(resumeSignedRequest: $resumeSignedRequest) {
    fileName
    signedUrl
    filePath
    isDuplicate
  }
}
    `;
export type IGetSignedUrlForUploadMutationFn = Apollo.MutationFunction<IGetSignedUrlForUploadMutation, IGetSignedUrlForUploadMutationVariables>;

/**
 * __useGetSignedUrlForUploadMutation__
 *
 * To run a mutation, you first call `useGetSignedUrlForUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetSignedUrlForUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getSignedUrlForUploadMutation, { data, loading, error }] = useGetSignedUrlForUploadMutation({
 *   variables: {
 *      resumeSignedRequest: // value for 'resumeSignedRequest'
 *   },
 * });
 */
export function useGetSignedUrlForUploadMutation(baseOptions?: Apollo.MutationHookOptions<IGetSignedUrlForUploadMutation, IGetSignedUrlForUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IGetSignedUrlForUploadMutation, IGetSignedUrlForUploadMutationVariables>(GetSignedUrlForUploadDocument, options);
      }
export type GetSignedUrlForUploadMutationHookResult = ReturnType<typeof useGetSignedUrlForUploadMutation>;
export type GetSignedUrlForUploadMutationResult = Apollo.MutationResult<IGetSignedUrlForUploadMutation>;
export type GetSignedUrlForUploadMutationOptions = Apollo.BaseMutationOptions<IGetSignedUrlForUploadMutation, IGetSignedUrlForUploadMutationVariables>;
export const ImportResumesDocument = gql`
    mutation ImportResumes($jobId: String!, $importResumeRequest: [ImportResumeRequest!]!) {
  importResumes(jobId: $jobId, resumes: $importResumeRequest)
}
    `;
export type IImportResumesMutationFn = Apollo.MutationFunction<IImportResumesMutation, IImportResumesMutationVariables>;

/**
 * __useImportResumesMutation__
 *
 * To run a mutation, you first call `useImportResumesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportResumesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importResumesMutation, { data, loading, error }] = useImportResumesMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *      importResumeRequest: // value for 'importResumeRequest'
 *   },
 * });
 */
export function useImportResumesMutation(baseOptions?: Apollo.MutationHookOptions<IImportResumesMutation, IImportResumesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IImportResumesMutation, IImportResumesMutationVariables>(ImportResumesDocument, options);
      }
export type ImportResumesMutationHookResult = ReturnType<typeof useImportResumesMutation>;
export type ImportResumesMutationResult = Apollo.MutationResult<IImportResumesMutation>;
export type ImportResumesMutationOptions = Apollo.BaseMutationOptions<IImportResumesMutation, IImportResumesMutationVariables>;
export const GetViewUrlsForResumeDocument = gql`
    mutation getViewUrlsForResume($fileKeys: [String!]!) {
  getViewUrlsForResume(fileKeys: $fileKeys) {
    key
    url
  }
}
    `;
export type IGetViewUrlsForResumeMutationFn = Apollo.MutationFunction<IGetViewUrlsForResumeMutation, IGetViewUrlsForResumeMutationVariables>;

/**
 * __useGetViewUrlsForResumeMutation__
 *
 * To run a mutation, you first call `useGetViewUrlsForResumeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetViewUrlsForResumeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getViewUrlsForResumeMutation, { data, loading, error }] = useGetViewUrlsForResumeMutation({
 *   variables: {
 *      fileKeys: // value for 'fileKeys'
 *   },
 * });
 */
export function useGetViewUrlsForResumeMutation(baseOptions?: Apollo.MutationHookOptions<IGetViewUrlsForResumeMutation, IGetViewUrlsForResumeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IGetViewUrlsForResumeMutation, IGetViewUrlsForResumeMutationVariables>(GetViewUrlsForResumeDocument, options);
      }
export type GetViewUrlsForResumeMutationHookResult = ReturnType<typeof useGetViewUrlsForResumeMutation>;
export type GetViewUrlsForResumeMutationResult = Apollo.MutationResult<IGetViewUrlsForResumeMutation>;
export type GetViewUrlsForResumeMutationOptions = Apollo.BaseMutationOptions<IGetViewUrlsForResumeMutation, IGetViewUrlsForResumeMutationVariables>;
export const ConvertResumeToPdfDocument = gql`
    mutation convertResumeToPdf($file: Upload!) {
  convertResumeToPdf(file: $file)
}
    `;
export type IConvertResumeToPdfMutationFn = Apollo.MutationFunction<IConvertResumeToPdfMutation, IConvertResumeToPdfMutationVariables>;

/**
 * __useConvertResumeToPdfMutation__
 *
 * To run a mutation, you first call `useConvertResumeToPdfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConvertResumeToPdfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [convertResumeToPdfMutation, { data, loading, error }] = useConvertResumeToPdfMutation({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function useConvertResumeToPdfMutation(baseOptions?: Apollo.MutationHookOptions<IConvertResumeToPdfMutation, IConvertResumeToPdfMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IConvertResumeToPdfMutation, IConvertResumeToPdfMutationVariables>(ConvertResumeToPdfDocument, options);
      }
export type ConvertResumeToPdfMutationHookResult = ReturnType<typeof useConvertResumeToPdfMutation>;
export type ConvertResumeToPdfMutationResult = Apollo.MutationResult<IConvertResumeToPdfMutation>;
export type ConvertResumeToPdfMutationOptions = Apollo.BaseMutationOptions<IConvertResumeToPdfMutation, IConvertResumeToPdfMutationVariables>;
export const GetAdvancedSearchDocument = gql`
    query getAdvancedSearch($jobPaginationDto: JobPaginationDto!, $pageRequest: PageRequest!) {
  advancedJobSearch(
    jobPaginationDto: $jobPaginationDto
    pageRequest: $pageRequest
  ) {
    content {
      id
      createdAt
      title
      location
      totalResumes
      jobStatus
      newResumes
      sources
      createdBy
      jobPriority
      requested
      jobPriority
      candidates {
        active
        total
        hired
      }
      squadAndClientInfo {
        clientId
        clientName
        squadId
        squadName
      }
    }
    pageable {
      page
      size
      totalElements
      totalPages
    }
  }
}
    `;

/**
 * __useGetAdvancedSearchQuery__
 *
 * To run a query within a React component, call `useGetAdvancedSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdvancedSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdvancedSearchQuery({
 *   variables: {
 *      jobPaginationDto: // value for 'jobPaginationDto'
 *      pageRequest: // value for 'pageRequest'
 *   },
 * });
 */
export function useGetAdvancedSearchQuery(baseOptions: Apollo.QueryHookOptions<IGetAdvancedSearchQuery, IGetAdvancedSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetAdvancedSearchQuery, IGetAdvancedSearchQueryVariables>(GetAdvancedSearchDocument, options);
      }
export function useGetAdvancedSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetAdvancedSearchQuery, IGetAdvancedSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetAdvancedSearchQuery, IGetAdvancedSearchQueryVariables>(GetAdvancedSearchDocument, options);
        }
export type GetAdvancedSearchQueryHookResult = ReturnType<typeof useGetAdvancedSearchQuery>;
export type GetAdvancedSearchLazyQueryHookResult = ReturnType<typeof useGetAdvancedSearchLazyQuery>;
export type GetAdvancedSearchQueryResult = Apollo.QueryResult<IGetAdvancedSearchQuery, IGetAdvancedSearchQueryVariables>;
export const FetchSucceededUsersDocument = gql`
    query fetchSucceededUsers($filterTestUsers: Boolean!) {
  getSucceededUsers(filterTestUsers: $filterTestUsers) {
    data {
      ...succeededUser
    }
    levelList {
      label
      shortForm
      value
    }
  }
}
    ${SucceededUserFragmentDoc}`;

/**
 * __useFetchSucceededUsersQuery__
 *
 * To run a query within a React component, call `useFetchSucceededUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchSucceededUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchSucceededUsersQuery({
 *   variables: {
 *      filterTestUsers: // value for 'filterTestUsers'
 *   },
 * });
 */
export function useFetchSucceededUsersQuery(baseOptions: Apollo.QueryHookOptions<IFetchSucceededUsersQuery, IFetchSucceededUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IFetchSucceededUsersQuery, IFetchSucceededUsersQueryVariables>(FetchSucceededUsersDocument, options);
      }
export function useFetchSucceededUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IFetchSucceededUsersQuery, IFetchSucceededUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IFetchSucceededUsersQuery, IFetchSucceededUsersQueryVariables>(FetchSucceededUsersDocument, options);
        }
export type FetchSucceededUsersQueryHookResult = ReturnType<typeof useFetchSucceededUsersQuery>;
export type FetchSucceededUsersLazyQueryHookResult = ReturnType<typeof useFetchSucceededUsersLazyQuery>;
export type FetchSucceededUsersQueryResult = Apollo.QueryResult<IFetchSucceededUsersQuery, IFetchSucceededUsersQueryVariables>;
export const GetJobDetailDocument = gql`
    query getJobDetail($id: String!) {
  jobById(id: $id) {
    resumeImportCompleted
    ...job
    jobStatus
    resumesFromManualSource
    resumesFromSquaderyPlatform
    resumeParsingStarted
    totalResumes
    newResumes
    squadId
    enterprisePeopleId
    minimumBudget
    maximumBudget
    vertical
    industry
    horizontal
    startDate
    endDate
    squadStartDate
    squadEndDate
    yearsOfExperience
    locationToBeHiredFrom
    industryBackground
    travelRequirements
    typeOfWork
    projectDescription
    clientSelectionProcess
    evaluationCriteria
    previousReasonsForCandidateDisqualification
    technicalInterviewPanel
    createdAt
    clientName
  }
}
    ${JobFragmentDoc}`;

/**
 * __useGetJobDetailQuery__
 *
 * To run a query within a React component, call `useGetJobDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetJobDetailQuery(baseOptions: Apollo.QueryHookOptions<IGetJobDetailQuery, IGetJobDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetJobDetailQuery, IGetJobDetailQueryVariables>(GetJobDetailDocument, options);
      }
export function useGetJobDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetJobDetailQuery, IGetJobDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetJobDetailQuery, IGetJobDetailQueryVariables>(GetJobDetailDocument, options);
        }
export type GetJobDetailQueryHookResult = ReturnType<typeof useGetJobDetailQuery>;
export type GetJobDetailLazyQueryHookResult = ReturnType<typeof useGetJobDetailLazyQuery>;
export type GetJobDetailQueryResult = Apollo.QueryResult<IGetJobDetailQuery, IGetJobDetailQueryVariables>;
export const GetResumeImportLogDetailDocument = gql`
    query getResumeImportLogDetail($jobId: String!) {
  resumeImportLogByJobId(jobId: $jobId) {
    ...resumeImportLog
  }
}
    ${ResumeImportLogFragmentDoc}`;

/**
 * __useGetResumeImportLogDetailQuery__
 *
 * To run a query within a React component, call `useGetResumeImportLogDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetResumeImportLogDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetResumeImportLogDetailQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useGetResumeImportLogDetailQuery(baseOptions: Apollo.QueryHookOptions<IGetResumeImportLogDetailQuery, IGetResumeImportLogDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetResumeImportLogDetailQuery, IGetResumeImportLogDetailQueryVariables>(GetResumeImportLogDetailDocument, options);
      }
export function useGetResumeImportLogDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetResumeImportLogDetailQuery, IGetResumeImportLogDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetResumeImportLogDetailQuery, IGetResumeImportLogDetailQueryVariables>(GetResumeImportLogDetailDocument, options);
        }
export type GetResumeImportLogDetailQueryHookResult = ReturnType<typeof useGetResumeImportLogDetailQuery>;
export type GetResumeImportLogDetailLazyQueryHookResult = ReturnType<typeof useGetResumeImportLogDetailLazyQuery>;
export type GetResumeImportLogDetailQueryResult = Apollo.QueryResult<IGetResumeImportLogDetailQuery, IGetResumeImportLogDetailQueryVariables>;
export const StartParsingResumeDocument = gql`
    query startParsingResume($jobId: String!) {
  startResumeParsing(jobId: $jobId) {
    id
  }
}
    `;

/**
 * __useStartParsingResumeQuery__
 *
 * To run a query within a React component, call `useStartParsingResumeQuery` and pass it any options that fit your needs.
 * When your component renders, `useStartParsingResumeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStartParsingResumeQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useStartParsingResumeQuery(baseOptions: Apollo.QueryHookOptions<IStartParsingResumeQuery, IStartParsingResumeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IStartParsingResumeQuery, IStartParsingResumeQueryVariables>(StartParsingResumeDocument, options);
      }
export function useStartParsingResumeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IStartParsingResumeQuery, IStartParsingResumeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IStartParsingResumeQuery, IStartParsingResumeQueryVariables>(StartParsingResumeDocument, options);
        }
export type StartParsingResumeQueryHookResult = ReturnType<typeof useStartParsingResumeQuery>;
export type StartParsingResumeLazyQueryHookResult = ReturnType<typeof useStartParsingResumeLazyQuery>;
export type StartParsingResumeQueryResult = Apollo.QueryResult<IStartParsingResumeQuery, IStartParsingResumeQueryVariables>;
export const GetResumeUrlDocument = gql`
    query getResumeUrl($resumeId: String!) {
  getParsedResumeById(parsedResumeId: $resumeId)
}
    `;

/**
 * __useGetResumeUrlQuery__
 *
 * To run a query within a React component, call `useGetResumeUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetResumeUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetResumeUrlQuery({
 *   variables: {
 *      resumeId: // value for 'resumeId'
 *   },
 * });
 */
export function useGetResumeUrlQuery(baseOptions: Apollo.QueryHookOptions<IGetResumeUrlQuery, IGetResumeUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetResumeUrlQuery, IGetResumeUrlQueryVariables>(GetResumeUrlDocument, options);
      }
export function useGetResumeUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetResumeUrlQuery, IGetResumeUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetResumeUrlQuery, IGetResumeUrlQueryVariables>(GetResumeUrlDocument, options);
        }
export type GetResumeUrlQueryHookResult = ReturnType<typeof useGetResumeUrlQuery>;
export type GetResumeUrlLazyQueryHookResult = ReturnType<typeof useGetResumeUrlLazyQuery>;
export type GetResumeUrlQueryResult = Apollo.QueryResult<IGetResumeUrlQuery, IGetResumeUrlQueryVariables>;
export const DownloadParsedResumeDocument = gql`
    query downloadParsedResume($jobId: String!, $parsedResumeIds: [String!]!, $fileType: FileType!, $exportAll: Boolean) {
  downloadParsedResume(
    jobId: $jobId
    parsedResumeIds: $parsedResumeIds
    fileType: $fileType
    exportAll: $exportAll
  ) {
    file
    fileName
  }
}
    `;

/**
 * __useDownloadParsedResumeQuery__
 *
 * To run a query within a React component, call `useDownloadParsedResumeQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadParsedResumeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadParsedResumeQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *      parsedResumeIds: // value for 'parsedResumeIds'
 *      fileType: // value for 'fileType'
 *      exportAll: // value for 'exportAll'
 *   },
 * });
 */
export function useDownloadParsedResumeQuery(baseOptions: Apollo.QueryHookOptions<IDownloadParsedResumeQuery, IDownloadParsedResumeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IDownloadParsedResumeQuery, IDownloadParsedResumeQueryVariables>(DownloadParsedResumeDocument, options);
      }
export function useDownloadParsedResumeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IDownloadParsedResumeQuery, IDownloadParsedResumeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IDownloadParsedResumeQuery, IDownloadParsedResumeQueryVariables>(DownloadParsedResumeDocument, options);
        }
export type DownloadParsedResumeQueryHookResult = ReturnType<typeof useDownloadParsedResumeQuery>;
export type DownloadParsedResumeLazyQueryHookResult = ReturnType<typeof useDownloadParsedResumeLazyQuery>;
export type DownloadParsedResumeQueryResult = Apollo.QueryResult<IDownloadParsedResumeQuery, IDownloadParsedResumeQueryVariables>;
export const GetCandidatesByJobIdDocument = gql`
    query getCandidatesByJobId($advancedSearchRequest: AdvancedSearchRequestDto!, $jobId: String!, $pageRequest: PageRequest!) {
  advancedFilter(
    advancedSearchRequest: $advancedSearchRequest
    jobId: $jobId
    pageRequest: $pageRequest
  ) {
    pageable {
      page
      size
      totalElements
      totalPages
    }
    content {
      ...parseResume
    }
  }
}
    ${ParseResumeFragmentDoc}`;

/**
 * __useGetCandidatesByJobIdQuery__
 *
 * To run a query within a React component, call `useGetCandidatesByJobIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCandidatesByJobIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCandidatesByJobIdQuery({
 *   variables: {
 *      advancedSearchRequest: // value for 'advancedSearchRequest'
 *      jobId: // value for 'jobId'
 *      pageRequest: // value for 'pageRequest'
 *   },
 * });
 */
export function useGetCandidatesByJobIdQuery(baseOptions: Apollo.QueryHookOptions<IGetCandidatesByJobIdQuery, IGetCandidatesByJobIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetCandidatesByJobIdQuery, IGetCandidatesByJobIdQueryVariables>(GetCandidatesByJobIdDocument, options);
      }
export function useGetCandidatesByJobIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetCandidatesByJobIdQuery, IGetCandidatesByJobIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetCandidatesByJobIdQuery, IGetCandidatesByJobIdQueryVariables>(GetCandidatesByJobIdDocument, options);
        }
export type GetCandidatesByJobIdQueryHookResult = ReturnType<typeof useGetCandidatesByJobIdQuery>;
export type GetCandidatesByJobIdLazyQueryHookResult = ReturnType<typeof useGetCandidatesByJobIdLazyQuery>;
export type GetCandidatesByJobIdQueryResult = Apollo.QueryResult<IGetCandidatesByJobIdQuery, IGetCandidatesByJobIdQueryVariables>;
export const AddResumesDocument = gql`
    query AddResumes($addResumeRequestDto: AddResumeRequestDto!) {
  addResumes(addResumeRequest: $addResumeRequestDto) {
    jobStatus
    newResumes
    resumeImportCompleted
  }
}
    `;

/**
 * __useAddResumesQuery__
 *
 * To run a query within a React component, call `useAddResumesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddResumesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddResumesQuery({
 *   variables: {
 *      addResumeRequestDto: // value for 'addResumeRequestDto'
 *   },
 * });
 */
export function useAddResumesQuery(baseOptions: Apollo.QueryHookOptions<IAddResumesQuery, IAddResumesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IAddResumesQuery, IAddResumesQueryVariables>(AddResumesDocument, options);
      }
export function useAddResumesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IAddResumesQuery, IAddResumesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IAddResumesQuery, IAddResumesQueryVariables>(AddResumesDocument, options);
        }
export type AddResumesQueryHookResult = ReturnType<typeof useAddResumesQuery>;
export type AddResumesLazyQueryHookResult = ReturnType<typeof useAddResumesLazyQuery>;
export type AddResumesQueryResult = Apollo.QueryResult<IAddResumesQuery, IAddResumesQueryVariables>;
export const ResyncImportJobsDocument = gql`
    query resyncImportJobs {
  resyncImportSucceededCandidates
}
    `;

/**
 * __useResyncImportJobsQuery__
 *
 * To run a query within a React component, call `useResyncImportJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useResyncImportJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResyncImportJobsQuery({
 *   variables: {
 *   },
 * });
 */
export function useResyncImportJobsQuery(baseOptions?: Apollo.QueryHookOptions<IResyncImportJobsQuery, IResyncImportJobsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IResyncImportJobsQuery, IResyncImportJobsQueryVariables>(ResyncImportJobsDocument, options);
      }
export function useResyncImportJobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IResyncImportJobsQuery, IResyncImportJobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IResyncImportJobsQuery, IResyncImportJobsQueryVariables>(ResyncImportJobsDocument, options);
        }
export type ResyncImportJobsQueryHookResult = ReturnType<typeof useResyncImportJobsQuery>;
export type ResyncImportJobsLazyQueryHookResult = ReturnType<typeof useResyncImportJobsLazyQuery>;
export type ResyncImportJobsQueryResult = Apollo.QueryResult<IResyncImportJobsQuery, IResyncImportJobsQueryVariables>;
export const ResyncImportForSpecificJobDocument = gql`
    query resyncImportForSpecificJob($id: String!) {
  resyncImportForSpecificJob(id: $id)
}
    `;

/**
 * __useResyncImportForSpecificJobQuery__
 *
 * To run a query within a React component, call `useResyncImportForSpecificJobQuery` and pass it any options that fit your needs.
 * When your component renders, `useResyncImportForSpecificJobQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResyncImportForSpecificJobQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useResyncImportForSpecificJobQuery(baseOptions: Apollo.QueryHookOptions<IResyncImportForSpecificJobQuery, IResyncImportForSpecificJobQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IResyncImportForSpecificJobQuery, IResyncImportForSpecificJobQueryVariables>(ResyncImportForSpecificJobDocument, options);
      }
export function useResyncImportForSpecificJobLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IResyncImportForSpecificJobQuery, IResyncImportForSpecificJobQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IResyncImportForSpecificJobQuery, IResyncImportForSpecificJobQueryVariables>(ResyncImportForSpecificJobDocument, options);
        }
export type ResyncImportForSpecificJobQueryHookResult = ReturnType<typeof useResyncImportForSpecificJobQuery>;
export type ResyncImportForSpecificJobLazyQueryHookResult = ReturnType<typeof useResyncImportForSpecificJobLazyQuery>;
export type ResyncImportForSpecificJobQueryResult = Apollo.QueryResult<IResyncImportForSpecificJobQuery, IResyncImportForSpecificJobQueryVariables>;
export const SetNewResumesToZeroDocument = gql`
    query SetNewResumesToZero($id: String!) {
  setJobNewResumesToZero(id: $id) {
    createdAt
    experienceLevel
    id
    jobCode
    jobDescription
    jobStatus
    location
    newResumes
    orgId
    resumeImportCompleted
    title
    totalPages
    totalResumes
    updatedAt
  }
}
    `;

/**
 * __useSetNewResumesToZeroQuery__
 *
 * To run a query within a React component, call `useSetNewResumesToZeroQuery` and pass it any options that fit your needs.
 * When your component renders, `useSetNewResumesToZeroQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSetNewResumesToZeroQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSetNewResumesToZeroQuery(baseOptions: Apollo.QueryHookOptions<ISetNewResumesToZeroQuery, ISetNewResumesToZeroQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ISetNewResumesToZeroQuery, ISetNewResumesToZeroQueryVariables>(SetNewResumesToZeroDocument, options);
      }
export function useSetNewResumesToZeroLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ISetNewResumesToZeroQuery, ISetNewResumesToZeroQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ISetNewResumesToZeroQuery, ISetNewResumesToZeroQueryVariables>(SetNewResumesToZeroDocument, options);
        }
export type SetNewResumesToZeroQueryHookResult = ReturnType<typeof useSetNewResumesToZeroQuery>;
export type SetNewResumesToZeroLazyQueryHookResult = ReturnType<typeof useSetNewResumesToZeroLazyQuery>;
export type SetNewResumesToZeroQueryResult = Apollo.QueryResult<ISetNewResumesToZeroQuery, ISetNewResumesToZeroQueryVariables>;
export const GetSingleParsedResumeDataDocument = gql`
    query getSingleParsedResumeData($parsedResumeId: String!) {
  getSingleParsedResumeData(parsedResumeId: $parsedResumeId) {
    ...parseResume
  }
}
    ${ParseResumeFragmentDoc}`;

/**
 * __useGetSingleParsedResumeDataQuery__
 *
 * To run a query within a React component, call `useGetSingleParsedResumeDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSingleParsedResumeDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSingleParsedResumeDataQuery({
 *   variables: {
 *      parsedResumeId: // value for 'parsedResumeId'
 *   },
 * });
 */
export function useGetSingleParsedResumeDataQuery(baseOptions: Apollo.QueryHookOptions<IGetSingleParsedResumeDataQuery, IGetSingleParsedResumeDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetSingleParsedResumeDataQuery, IGetSingleParsedResumeDataQueryVariables>(GetSingleParsedResumeDataDocument, options);
      }
export function useGetSingleParsedResumeDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetSingleParsedResumeDataQuery, IGetSingleParsedResumeDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetSingleParsedResumeDataQuery, IGetSingleParsedResumeDataQueryVariables>(GetSingleParsedResumeDataDocument, options);
        }
export type GetSingleParsedResumeDataQueryHookResult = ReturnType<typeof useGetSingleParsedResumeDataQuery>;
export type GetSingleParsedResumeDataLazyQueryHookResult = ReturnType<typeof useGetSingleParsedResumeDataLazyQuery>;
export type GetSingleParsedResumeDataQueryResult = Apollo.QueryResult<IGetSingleParsedResumeDataQuery, IGetSingleParsedResumeDataQueryVariables>;
export const GetCandidateStageCountDocument = gql`
    query getCandidateStageCount($advancedSearchRequest: AdvancedSearchRequestDto!, $jobId: String!, $pageRequest: PageRequest!) {
  getCandidateStageCount(
    advancedSearchRequest: $advancedSearchRequest
    jobId: $jobId
    pageRequest: $pageRequest
  ) {
    count
    stage
  }
}
    `;

/**
 * __useGetCandidateStageCountQuery__
 *
 * To run a query within a React component, call `useGetCandidateStageCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCandidateStageCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCandidateStageCountQuery({
 *   variables: {
 *      advancedSearchRequest: // value for 'advancedSearchRequest'
 *      jobId: // value for 'jobId'
 *      pageRequest: // value for 'pageRequest'
 *   },
 * });
 */
export function useGetCandidateStageCountQuery(baseOptions: Apollo.QueryHookOptions<IGetCandidateStageCountQuery, IGetCandidateStageCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetCandidateStageCountQuery, IGetCandidateStageCountQueryVariables>(GetCandidateStageCountDocument, options);
      }
export function useGetCandidateStageCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetCandidateStageCountQuery, IGetCandidateStageCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetCandidateStageCountQuery, IGetCandidateStageCountQueryVariables>(GetCandidateStageCountDocument, options);
        }
export type GetCandidateStageCountQueryHookResult = ReturnType<typeof useGetCandidateStageCountQuery>;
export type GetCandidateStageCountLazyQueryHookResult = ReturnType<typeof useGetCandidateStageCountLazyQuery>;
export type GetCandidateStageCountQueryResult = Apollo.QueryResult<IGetCandidateStageCountQuery, IGetCandidateStageCountQueryVariables>;
export const GetEnterprisePeopleDocument = gql`
    query getEnterprisePeople($enterprisePeopleId: String!) {
  getEnterprisePeople(enterprisePeopleId: $enterprisePeopleId) {
    id
    firstName
    lastName
    clientEmail
    roles
  }
}
    `;

/**
 * __useGetEnterprisePeopleQuery__
 *
 * To run a query within a React component, call `useGetEnterprisePeopleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEnterprisePeopleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEnterprisePeopleQuery({
 *   variables: {
 *      enterprisePeopleId: // value for 'enterprisePeopleId'
 *   },
 * });
 */
export function useGetEnterprisePeopleQuery(baseOptions: Apollo.QueryHookOptions<IGetEnterprisePeopleQuery, IGetEnterprisePeopleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetEnterprisePeopleQuery, IGetEnterprisePeopleQueryVariables>(GetEnterprisePeopleDocument, options);
      }
export function useGetEnterprisePeopleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetEnterprisePeopleQuery, IGetEnterprisePeopleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetEnterprisePeopleQuery, IGetEnterprisePeopleQueryVariables>(GetEnterprisePeopleDocument, options);
        }
export type GetEnterprisePeopleQueryHookResult = ReturnType<typeof useGetEnterprisePeopleQuery>;
export type GetEnterprisePeopleLazyQueryHookResult = ReturnType<typeof useGetEnterprisePeopleLazyQuery>;
export type GetEnterprisePeopleQueryResult = Apollo.QueryResult<IGetEnterprisePeopleQuery, IGetEnterprisePeopleQueryVariables>;
export const GetJobCreatorsDocument = gql`
    query getJobCreators {
  getJobCreators {
    id
    firstName
    lastName
  }
}
    `;

/**
 * __useGetJobCreatorsQuery__
 *
 * To run a query within a React component, call `useGetJobCreatorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobCreatorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobCreatorsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetJobCreatorsQuery(baseOptions?: Apollo.QueryHookOptions<IGetJobCreatorsQuery, IGetJobCreatorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetJobCreatorsQuery, IGetJobCreatorsQueryVariables>(GetJobCreatorsDocument, options);
      }
export function useGetJobCreatorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetJobCreatorsQuery, IGetJobCreatorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetJobCreatorsQuery, IGetJobCreatorsQueryVariables>(GetJobCreatorsDocument, options);
        }
export type GetJobCreatorsQueryHookResult = ReturnType<typeof useGetJobCreatorsQuery>;
export type GetJobCreatorsLazyQueryHookResult = ReturnType<typeof useGetJobCreatorsLazyQuery>;
export type GetJobCreatorsQueryResult = Apollo.QueryResult<IGetJobCreatorsQuery, IGetJobCreatorsQueryVariables>;
export const GetNewRequestedJobsDocument = gql`
    query getNewRequestedJobs($enterprisePeopleId: String!) {
  getNewRequestedJobs(enterprisePeopleId: $enterprisePeopleId) {
    jobId
    viewedBy
  }
}
    `;

/**
 * __useGetNewRequestedJobsQuery__
 *
 * To run a query within a React component, call `useGetNewRequestedJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNewRequestedJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNewRequestedJobsQuery({
 *   variables: {
 *      enterprisePeopleId: // value for 'enterprisePeopleId'
 *   },
 * });
 */
export function useGetNewRequestedJobsQuery(baseOptions: Apollo.QueryHookOptions<IGetNewRequestedJobsQuery, IGetNewRequestedJobsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetNewRequestedJobsQuery, IGetNewRequestedJobsQueryVariables>(GetNewRequestedJobsDocument, options);
      }
export function useGetNewRequestedJobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetNewRequestedJobsQuery, IGetNewRequestedJobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetNewRequestedJobsQuery, IGetNewRequestedJobsQueryVariables>(GetNewRequestedJobsDocument, options);
        }
export type GetNewRequestedJobsQueryHookResult = ReturnType<typeof useGetNewRequestedJobsQuery>;
export type GetNewRequestedJobsLazyQueryHookResult = ReturnType<typeof useGetNewRequestedJobsLazyQuery>;
export type GetNewRequestedJobsQueryResult = Apollo.QueryResult<IGetNewRequestedJobsQuery, IGetNewRequestedJobsQueryVariables>;
export const ShowCandidateProfileDocument = gql`
    query showCandidateProfile($parsedResumeId: String!) {
  showCandidateProfile(parsedResumeId: $parsedResumeId) {
    jobDescription
    resumeUrl
  }
}
    `;

/**
 * __useShowCandidateProfileQuery__
 *
 * To run a query within a React component, call `useShowCandidateProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useShowCandidateProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShowCandidateProfileQuery({
 *   variables: {
 *      parsedResumeId: // value for 'parsedResumeId'
 *   },
 * });
 */
export function useShowCandidateProfileQuery(baseOptions: Apollo.QueryHookOptions<IShowCandidateProfileQuery, IShowCandidateProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IShowCandidateProfileQuery, IShowCandidateProfileQueryVariables>(ShowCandidateProfileDocument, options);
      }
export function useShowCandidateProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IShowCandidateProfileQuery, IShowCandidateProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IShowCandidateProfileQuery, IShowCandidateProfileQueryVariables>(ShowCandidateProfileDocument, options);
        }
export type ShowCandidateProfileQueryHookResult = ReturnType<typeof useShowCandidateProfileQuery>;
export type ShowCandidateProfileLazyQueryHookResult = ReturnType<typeof useShowCandidateProfileLazyQuery>;
export type ShowCandidateProfileQueryResult = Apollo.QueryResult<IShowCandidateProfileQuery, IShowCandidateProfileQueryVariables>;
export const CandidateProfileInfoDocument = gql`
    query candidateProfileInfo($parsedResumeId: String!) {
  candidateProfileInfo(parsedResumeId: $parsedResumeId) {
    candidateStage
    candidateStageStatus
    email
    firstName
    lastName
    phoneNumber
    score
    middleName
  }
}
    `;

/**
 * __useCandidateProfileInfoQuery__
 *
 * To run a query within a React component, call `useCandidateProfileInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useCandidateProfileInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCandidateProfileInfoQuery({
 *   variables: {
 *      parsedResumeId: // value for 'parsedResumeId'
 *   },
 * });
 */
export function useCandidateProfileInfoQuery(baseOptions: Apollo.QueryHookOptions<ICandidateProfileInfoQuery, ICandidateProfileInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ICandidateProfileInfoQuery, ICandidateProfileInfoQueryVariables>(CandidateProfileInfoDocument, options);
      }
export function useCandidateProfileInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ICandidateProfileInfoQuery, ICandidateProfileInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ICandidateProfileInfoQuery, ICandidateProfileInfoQueryVariables>(CandidateProfileInfoDocument, options);
        }
export type CandidateProfileInfoQueryHookResult = ReturnType<typeof useCandidateProfileInfoQuery>;
export type CandidateProfileInfoLazyQueryHookResult = ReturnType<typeof useCandidateProfileInfoLazyQuery>;
export type CandidateProfileInfoQueryResult = Apollo.QueryResult<ICandidateProfileInfoQuery, ICandidateProfileInfoQueryVariables>;
export const FindParsedResumesForProfileDocument = gql`
    query findParsedResumesForProfile($advancedSearchRequest: AdvancedSearchRequestDto!, $jobId: String!, $pageRequest: PageRequest!) {
  findParsedResumesForProfile(
    advancedSearchRequest: $advancedSearchRequest
    jobId: $jobId
    pageRequest: $pageRequest
  )
}
    `;

/**
 * __useFindParsedResumesForProfileQuery__
 *
 * To run a query within a React component, call `useFindParsedResumesForProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindParsedResumesForProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindParsedResumesForProfileQuery({
 *   variables: {
 *      advancedSearchRequest: // value for 'advancedSearchRequest'
 *      jobId: // value for 'jobId'
 *      pageRequest: // value for 'pageRequest'
 *   },
 * });
 */
export function useFindParsedResumesForProfileQuery(baseOptions: Apollo.QueryHookOptions<IFindParsedResumesForProfileQuery, IFindParsedResumesForProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IFindParsedResumesForProfileQuery, IFindParsedResumesForProfileQueryVariables>(FindParsedResumesForProfileDocument, options);
      }
export function useFindParsedResumesForProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IFindParsedResumesForProfileQuery, IFindParsedResumesForProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IFindParsedResumesForProfileQuery, IFindParsedResumesForProfileQueryVariables>(FindParsedResumesForProfileDocument, options);
        }
export type FindParsedResumesForProfileQueryHookResult = ReturnType<typeof useFindParsedResumesForProfileQuery>;
export type FindParsedResumesForProfileLazyQueryHookResult = ReturnType<typeof useFindParsedResumesForProfileLazyQuery>;
export type FindParsedResumesForProfileQueryResult = Apollo.QueryResult<IFindParsedResumesForProfileQuery, IFindParsedResumesForProfileQueryVariables>;
export const GetCandidateSkillsForJobDocument = gql`
    query getCandidateSkillsForJob($jobId: String!) {
  getCandidateSkillsForJob(jobId: $jobId)
}
    `;

/**
 * __useGetCandidateSkillsForJobQuery__
 *
 * To run a query within a React component, call `useGetCandidateSkillsForJobQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCandidateSkillsForJobQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCandidateSkillsForJobQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useGetCandidateSkillsForJobQuery(baseOptions: Apollo.QueryHookOptions<IGetCandidateSkillsForJobQuery, IGetCandidateSkillsForJobQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetCandidateSkillsForJobQuery, IGetCandidateSkillsForJobQueryVariables>(GetCandidateSkillsForJobDocument, options);
      }
export function useGetCandidateSkillsForJobLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetCandidateSkillsForJobQuery, IGetCandidateSkillsForJobQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetCandidateSkillsForJobQuery, IGetCandidateSkillsForJobQueryVariables>(GetCandidateSkillsForJobDocument, options);
        }
export type GetCandidateSkillsForJobQueryHookResult = ReturnType<typeof useGetCandidateSkillsForJobQuery>;
export type GetCandidateSkillsForJobLazyQueryHookResult = ReturnType<typeof useGetCandidateSkillsForJobLazyQuery>;
export type GetCandidateSkillsForJobQueryResult = Apollo.QueryResult<IGetCandidateSkillsForJobQuery, IGetCandidateSkillsForJobQueryVariables>;
export const GetJobDescriptionTemplatesDocument = gql`
    query getJobDescriptionTemplates {
  getJobDescriptionTemplates {
    createdBy
    id
    jobDescription
    title
  }
}
    `;

/**
 * __useGetJobDescriptionTemplatesQuery__
 *
 * To run a query within a React component, call `useGetJobDescriptionTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobDescriptionTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobDescriptionTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetJobDescriptionTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<IGetJobDescriptionTemplatesQuery, IGetJobDescriptionTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetJobDescriptionTemplatesQuery, IGetJobDescriptionTemplatesQueryVariables>(GetJobDescriptionTemplatesDocument, options);
      }
export function useGetJobDescriptionTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetJobDescriptionTemplatesQuery, IGetJobDescriptionTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetJobDescriptionTemplatesQuery, IGetJobDescriptionTemplatesQueryVariables>(GetJobDescriptionTemplatesDocument, options);
        }
export type GetJobDescriptionTemplatesQueryHookResult = ReturnType<typeof useGetJobDescriptionTemplatesQuery>;
export type GetJobDescriptionTemplatesLazyQueryHookResult = ReturnType<typeof useGetJobDescriptionTemplatesLazyQuery>;
export type GetJobDescriptionTemplatesQueryResult = Apollo.QueryResult<IGetJobDescriptionTemplatesQuery, IGetJobDescriptionTemplatesQueryVariables>;
export const GetCandidateNotesDocument = gql`
    query getCandidateNotes($parentId: String!, $parsedResumeId: String!, $viewedBy: String!) {
  getCandidateNotes(
    parentId: $parentId
    parsedResumeId: $parsedResumeId
    viewedBy: $viewedBy
  ) {
    _id
    candidateId
    candidateStage
    createdBy
    creatorId
    jobId
    note
    parentId
    parsedResumeId
    createdAt
    updatedAt
    replyCount
    visibility
    noteContext
  }
}
    `;

/**
 * __useGetCandidateNotesQuery__
 *
 * To run a query within a React component, call `useGetCandidateNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCandidateNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCandidateNotesQuery({
 *   variables: {
 *      parentId: // value for 'parentId'
 *      parsedResumeId: // value for 'parsedResumeId'
 *      viewedBy: // value for 'viewedBy'
 *   },
 * });
 */
export function useGetCandidateNotesQuery(baseOptions: Apollo.QueryHookOptions<IGetCandidateNotesQuery, IGetCandidateNotesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetCandidateNotesQuery, IGetCandidateNotesQueryVariables>(GetCandidateNotesDocument, options);
      }
export function useGetCandidateNotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetCandidateNotesQuery, IGetCandidateNotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetCandidateNotesQuery, IGetCandidateNotesQueryVariables>(GetCandidateNotesDocument, options);
        }
export type GetCandidateNotesQueryHookResult = ReturnType<typeof useGetCandidateNotesQuery>;
export type GetCandidateNotesLazyQueryHookResult = ReturnType<typeof useGetCandidateNotesLazyQuery>;
export type GetCandidateNotesQueryResult = Apollo.QueryResult<IGetCandidateNotesQuery, IGetCandidateNotesQueryVariables>;
export const GetJobCreatorDetailsDocument = gql`
    query getJobCreatorDetails($id: String!) {
  getJobCreatorDetails(id: $id) {
    email
    id
    fullname
    roles
  }
}
    `;

/**
 * __useGetJobCreatorDetailsQuery__
 *
 * To run a query within a React component, call `useGetJobCreatorDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobCreatorDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobCreatorDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetJobCreatorDetailsQuery(baseOptions: Apollo.QueryHookOptions<IGetJobCreatorDetailsQuery, IGetJobCreatorDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetJobCreatorDetailsQuery, IGetJobCreatorDetailsQueryVariables>(GetJobCreatorDetailsDocument, options);
      }
export function useGetJobCreatorDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetJobCreatorDetailsQuery, IGetJobCreatorDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetJobCreatorDetailsQuery, IGetJobCreatorDetailsQueryVariables>(GetJobCreatorDetailsDocument, options);
        }
export type GetJobCreatorDetailsQueryHookResult = ReturnType<typeof useGetJobCreatorDetailsQuery>;
export type GetJobCreatorDetailsLazyQueryHookResult = ReturnType<typeof useGetJobCreatorDetailsLazyQuery>;
export type GetJobCreatorDetailsQueryResult = Apollo.QueryResult<IGetJobCreatorDetailsQuery, IGetJobCreatorDetailsQueryVariables>;
export const GetCandidateDocumentsDocument = gql`
    query getCandidateDocuments($parsedResumeId: String!, $searchquery: String!) {
  getCandidateDocuments(
    parsedResumeId: $parsedResumeId
    searchquery: $searchquery
  ) {
    originalFileName
    docUrl
    uploadedBy
    timeStamp
  }
}
    `;

/**
 * __useGetCandidateDocumentsQuery__
 *
 * To run a query within a React component, call `useGetCandidateDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCandidateDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCandidateDocumentsQuery({
 *   variables: {
 *      parsedResumeId: // value for 'parsedResumeId'
 *      searchquery: // value for 'searchquery'
 *   },
 * });
 */
export function useGetCandidateDocumentsQuery(baseOptions: Apollo.QueryHookOptions<IGetCandidateDocumentsQuery, IGetCandidateDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetCandidateDocumentsQuery, IGetCandidateDocumentsQueryVariables>(GetCandidateDocumentsDocument, options);
      }
export function useGetCandidateDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetCandidateDocumentsQuery, IGetCandidateDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetCandidateDocumentsQuery, IGetCandidateDocumentsQueryVariables>(GetCandidateDocumentsDocument, options);
        }
export type GetCandidateDocumentsQueryHookResult = ReturnType<typeof useGetCandidateDocumentsQuery>;
export type GetCandidateDocumentsLazyQueryHookResult = ReturnType<typeof useGetCandidateDocumentsLazyQuery>;
export type GetCandidateDocumentsQueryResult = Apollo.QueryResult<IGetCandidateDocumentsQuery, IGetCandidateDocumentsQueryVariables>;
export const GetDocumentUrlDocument = gql`
    query getDocumentUrl($docUrl: String!) {
  getDocumentUrl(docUrl: $docUrl)
}
    `;

/**
 * __useGetDocumentUrlQuery__
 *
 * To run a query within a React component, call `useGetDocumentUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentUrlQuery({
 *   variables: {
 *      docUrl: // value for 'docUrl'
 *   },
 * });
 */
export function useGetDocumentUrlQuery(baseOptions: Apollo.QueryHookOptions<IGetDocumentUrlQuery, IGetDocumentUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetDocumentUrlQuery, IGetDocumentUrlQueryVariables>(GetDocumentUrlDocument, options);
      }
export function useGetDocumentUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetDocumentUrlQuery, IGetDocumentUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetDocumentUrlQuery, IGetDocumentUrlQueryVariables>(GetDocumentUrlDocument, options);
        }
export type GetDocumentUrlQueryHookResult = ReturnType<typeof useGetDocumentUrlQuery>;
export type GetDocumentUrlLazyQueryHookResult = ReturnType<typeof useGetDocumentUrlLazyQuery>;
export type GetDocumentUrlQueryResult = Apollo.QueryResult<IGetDocumentUrlQuery, IGetDocumentUrlQueryVariables>;
export const GetCandidateProfileFromResumeDocument = gql`
    query getCandidateProfileFromResume($id: String!) {
  getCandidateProfileFromResume(id: $id) {
    address
    email
    firstName
    id
    resumeUrl
    lastName
    latestEmployer
    middleName
    phone
    softSkills
    technicalSkills
    yearsOfExperience
  }
}
    `;

/**
 * __useGetCandidateProfileFromResumeQuery__
 *
 * To run a query within a React component, call `useGetCandidateProfileFromResumeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCandidateProfileFromResumeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCandidateProfileFromResumeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCandidateProfileFromResumeQuery(baseOptions: Apollo.QueryHookOptions<IGetCandidateProfileFromResumeQuery, IGetCandidateProfileFromResumeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetCandidateProfileFromResumeQuery, IGetCandidateProfileFromResumeQueryVariables>(GetCandidateProfileFromResumeDocument, options);
      }
export function useGetCandidateProfileFromResumeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetCandidateProfileFromResumeQuery, IGetCandidateProfileFromResumeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetCandidateProfileFromResumeQuery, IGetCandidateProfileFromResumeQueryVariables>(GetCandidateProfileFromResumeDocument, options);
        }
export type GetCandidateProfileFromResumeQueryHookResult = ReturnType<typeof useGetCandidateProfileFromResumeQuery>;
export type GetCandidateProfileFromResumeLazyQueryHookResult = ReturnType<typeof useGetCandidateProfileFromResumeLazyQuery>;
export type GetCandidateProfileFromResumeQueryResult = Apollo.QueryResult<IGetCandidateProfileFromResumeQuery, IGetCandidateProfileFromResumeQueryVariables>;
export const GetHiringContributorsDocument = gql`
    query getHiringContributors($id: String!) {
  getHiringContributors(id: $id) {
    email
    fullname
    id
    isCreator
    designation
  }
}
    `;

/**
 * __useGetHiringContributorsQuery__
 *
 * To run a query within a React component, call `useGetHiringContributorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHiringContributorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHiringContributorsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetHiringContributorsQuery(baseOptions: Apollo.QueryHookOptions<IGetHiringContributorsQuery, IGetHiringContributorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetHiringContributorsQuery, IGetHiringContributorsQueryVariables>(GetHiringContributorsDocument, options);
      }
export function useGetHiringContributorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetHiringContributorsQuery, IGetHiringContributorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetHiringContributorsQuery, IGetHiringContributorsQueryVariables>(GetHiringContributorsDocument, options);
        }
export type GetHiringContributorsQueryHookResult = ReturnType<typeof useGetHiringContributorsQuery>;
export type GetHiringContributorsLazyQueryHookResult = ReturnType<typeof useGetHiringContributorsLazyQuery>;
export type GetHiringContributorsQueryResult = Apollo.QueryResult<IGetHiringContributorsQuery, IGetHiringContributorsQueryVariables>;
export const GetAllEnterpriseUsersDocument = gql`
    query getAllEnterpriseUsers {
  getAllEnterpriseUsers {
    email
    fullname
    id
    designation
  }
}
    `;

/**
 * __useGetAllEnterpriseUsersQuery__
 *
 * To run a query within a React component, call `useGetAllEnterpriseUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllEnterpriseUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllEnterpriseUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllEnterpriseUsersQuery(baseOptions?: Apollo.QueryHookOptions<IGetAllEnterpriseUsersQuery, IGetAllEnterpriseUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetAllEnterpriseUsersQuery, IGetAllEnterpriseUsersQueryVariables>(GetAllEnterpriseUsersDocument, options);
      }
export function useGetAllEnterpriseUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetAllEnterpriseUsersQuery, IGetAllEnterpriseUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetAllEnterpriseUsersQuery, IGetAllEnterpriseUsersQueryVariables>(GetAllEnterpriseUsersDocument, options);
        }
export type GetAllEnterpriseUsersQueryHookResult = ReturnType<typeof useGetAllEnterpriseUsersQuery>;
export type GetAllEnterpriseUsersLazyQueryHookResult = ReturnType<typeof useGetAllEnterpriseUsersLazyQuery>;
export type GetAllEnterpriseUsersQueryResult = Apollo.QueryResult<IGetAllEnterpriseUsersQuery, IGetAllEnterpriseUsersQueryVariables>;
export const GetTaggableUsersForJobDocument = gql`
    query getTaggableUsersForJob($jobId: String!) {
  getTaggableUsersForJob(jobId: $jobId) {
    fullname
    id
  }
}
    `;

/**
 * __useGetTaggableUsersForJobQuery__
 *
 * To run a query within a React component, call `useGetTaggableUsersForJobQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaggableUsersForJobQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaggableUsersForJobQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useGetTaggableUsersForJobQuery(baseOptions: Apollo.QueryHookOptions<IGetTaggableUsersForJobQuery, IGetTaggableUsersForJobQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetTaggableUsersForJobQuery, IGetTaggableUsersForJobQueryVariables>(GetTaggableUsersForJobDocument, options);
      }
export function useGetTaggableUsersForJobLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetTaggableUsersForJobQuery, IGetTaggableUsersForJobQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetTaggableUsersForJobQuery, IGetTaggableUsersForJobQueryVariables>(GetTaggableUsersForJobDocument, options);
        }
export type GetTaggableUsersForJobQueryHookResult = ReturnType<typeof useGetTaggableUsersForJobQuery>;
export type GetTaggableUsersForJobLazyQueryHookResult = ReturnType<typeof useGetTaggableUsersForJobLazyQuery>;
export type GetTaggableUsersForJobQueryResult = Apollo.QueryResult<IGetTaggableUsersForJobQuery, IGetTaggableUsersForJobQueryVariables>;
export const GetRegionForRthDocument = gql`
    query getRegionForRTH($selectedLocations: [String!], $selectedRegions: [String!]) {
  getRegionForRTH(
    selectedLocations: $selectedLocations
    selectedRegions: $selectedRegions
  ) {
    key
    value
  }
}
    `;

/**
 * __useGetRegionForRthQuery__
 *
 * To run a query within a React component, call `useGetRegionForRthQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegionForRthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegionForRthQuery({
 *   variables: {
 *      selectedLocations: // value for 'selectedLocations'
 *      selectedRegions: // value for 'selectedRegions'
 *   },
 * });
 */
export function useGetRegionForRthQuery(baseOptions?: Apollo.QueryHookOptions<IGetRegionForRthQuery, IGetRegionForRthQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetRegionForRthQuery, IGetRegionForRthQueryVariables>(GetRegionForRthDocument, options);
      }
export function useGetRegionForRthLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetRegionForRthQuery, IGetRegionForRthQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetRegionForRthQuery, IGetRegionForRthQueryVariables>(GetRegionForRthDocument, options);
        }
export type GetRegionForRthQueryHookResult = ReturnType<typeof useGetRegionForRthQuery>;
export type GetRegionForRthLazyQueryHookResult = ReturnType<typeof useGetRegionForRthLazyQuery>;
export type GetRegionForRthQueryResult = Apollo.QueryResult<IGetRegionForRthQuery, IGetRegionForRthQueryVariables>;
export const UniqueLocationsAndRegionsByJobIdDocument = gql`
    query uniqueLocationsAndRegionsByJobId($jobId: String!, $selectedLocations: [String!], $selectedRegions: [String!]) {
  uniqueLocationsAndRegionsByJobId(
    jobId: $jobId
    selectedLocations: $selectedLocations
    selectedRegions: $selectedRegions
  ) {
    key
    value
  }
}
    `;

/**
 * __useUniqueLocationsAndRegionsByJobIdQuery__
 *
 * To run a query within a React component, call `useUniqueLocationsAndRegionsByJobIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useUniqueLocationsAndRegionsByJobIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUniqueLocationsAndRegionsByJobIdQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *      selectedLocations: // value for 'selectedLocations'
 *      selectedRegions: // value for 'selectedRegions'
 *   },
 * });
 */
export function useUniqueLocationsAndRegionsByJobIdQuery(baseOptions: Apollo.QueryHookOptions<IUniqueLocationsAndRegionsByJobIdQuery, IUniqueLocationsAndRegionsByJobIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IUniqueLocationsAndRegionsByJobIdQuery, IUniqueLocationsAndRegionsByJobIdQueryVariables>(UniqueLocationsAndRegionsByJobIdDocument, options);
      }
export function useUniqueLocationsAndRegionsByJobIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IUniqueLocationsAndRegionsByJobIdQuery, IUniqueLocationsAndRegionsByJobIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IUniqueLocationsAndRegionsByJobIdQuery, IUniqueLocationsAndRegionsByJobIdQueryVariables>(UniqueLocationsAndRegionsByJobIdDocument, options);
        }
export type UniqueLocationsAndRegionsByJobIdQueryHookResult = ReturnType<typeof useUniqueLocationsAndRegionsByJobIdQuery>;
export type UniqueLocationsAndRegionsByJobIdLazyQueryHookResult = ReturnType<typeof useUniqueLocationsAndRegionsByJobIdLazyQuery>;
export type UniqueLocationsAndRegionsByJobIdQueryResult = Apollo.QueryResult<IUniqueLocationsAndRegionsByJobIdQuery, IUniqueLocationsAndRegionsByJobIdQueryVariables>;
export const UniqueAddedByDocument = gql`
    query uniqueAddedBy($jobId: String!) {
  uniqueAddedBy(jobId: $jobId)
}
    `;

/**
 * __useUniqueAddedByQuery__
 *
 * To run a query within a React component, call `useUniqueAddedByQuery` and pass it any options that fit your needs.
 * When your component renders, `useUniqueAddedByQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUniqueAddedByQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useUniqueAddedByQuery(baseOptions: Apollo.QueryHookOptions<IUniqueAddedByQuery, IUniqueAddedByQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IUniqueAddedByQuery, IUniqueAddedByQueryVariables>(UniqueAddedByDocument, options);
      }
export function useUniqueAddedByLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IUniqueAddedByQuery, IUniqueAddedByQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IUniqueAddedByQuery, IUniqueAddedByQueryVariables>(UniqueAddedByDocument, options);
        }
export type UniqueAddedByQueryHookResult = ReturnType<typeof useUniqueAddedByQuery>;
export type UniqueAddedByLazyQueryHookResult = ReturnType<typeof useUniqueAddedByLazyQuery>;
export type UniqueAddedByQueryResult = Apollo.QueryResult<IUniqueAddedByQuery, IUniqueAddedByQueryVariables>;
export const OtpLoginDocument = gql`
    mutation OtpLogin($otpLoginArgs: OtpLoginArgsDTO!) {
  otpLogin(otpLoginArgs: $otpLoginArgs) {
    message
    sessionToken
    accessToken
    expiresIn
    idToken
    refreshToken
    tokenType
    resendTimer
    clientIdsEncoded
    userInfo {
      email
      id
      name
    }
    clientInfo {
      id
      name
      status
    }
  }
}
    `;
export type IOtpLoginMutationFn = Apollo.MutationFunction<IOtpLoginMutation, IOtpLoginMutationVariables>;

/**
 * __useOtpLoginMutation__
 *
 * To run a mutation, you first call `useOtpLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOtpLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [otpLoginMutation, { data, loading, error }] = useOtpLoginMutation({
 *   variables: {
 *      otpLoginArgs: // value for 'otpLoginArgs'
 *   },
 * });
 */
export function useOtpLoginMutation(baseOptions?: Apollo.MutationHookOptions<IOtpLoginMutation, IOtpLoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IOtpLoginMutation, IOtpLoginMutationVariables>(OtpLoginDocument, options);
      }
export type OtpLoginMutationHookResult = ReturnType<typeof useOtpLoginMutation>;
export type OtpLoginMutationResult = Apollo.MutationResult<IOtpLoginMutation>;
export type OtpLoginMutationOptions = Apollo.BaseMutationOptions<IOtpLoginMutation, IOtpLoginMutationVariables>;
export const VerifyOtpDocument = gql`
    mutation VerifyOtp($verfiyOtpArgs: VerfiyOtpArgsDTO!) {
  verifyOtp(verfiyOtpArgs: $verfiyOtpArgs) {
    accessToken
    idToken
    message
    tokenType
    refreshToken
    expiresIn
    clientIdsEncoded
    userInfo {
      email
      id
      name
    }
    clientInfo {
      id
      name
      status
    }
  }
}
    `;
export type IVerifyOtpMutationFn = Apollo.MutationFunction<IVerifyOtpMutation, IVerifyOtpMutationVariables>;

/**
 * __useVerifyOtpMutation__
 *
 * To run a mutation, you first call `useVerifyOtpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyOtpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyOtpMutation, { data, loading, error }] = useVerifyOtpMutation({
 *   variables: {
 *      verfiyOtpArgs: // value for 'verfiyOtpArgs'
 *   },
 * });
 */
export function useVerifyOtpMutation(baseOptions?: Apollo.MutationHookOptions<IVerifyOtpMutation, IVerifyOtpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IVerifyOtpMutation, IVerifyOtpMutationVariables>(VerifyOtpDocument, options);
      }
export type VerifyOtpMutationHookResult = ReturnType<typeof useVerifyOtpMutation>;
export type VerifyOtpMutationResult = Apollo.MutationResult<IVerifyOtpMutation>;
export type VerifyOtpMutationOptions = Apollo.BaseMutationOptions<IVerifyOtpMutation, IVerifyOtpMutationVariables>;
export const ResyncResumeParsingDocument = gql`
    query resyncResumeParsing($parsedResumeReq: ParsedResumeReq!) {
  resyncResumeParsing(parsedResumeReq: $parsedResumeReq)
}
    `;

/**
 * __useResyncResumeParsingQuery__
 *
 * To run a query within a React component, call `useResyncResumeParsingQuery` and pass it any options that fit your needs.
 * When your component renders, `useResyncResumeParsingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResyncResumeParsingQuery({
 *   variables: {
 *      parsedResumeReq: // value for 'parsedResumeReq'
 *   },
 * });
 */
export function useResyncResumeParsingQuery(baseOptions: Apollo.QueryHookOptions<IResyncResumeParsingQuery, IResyncResumeParsingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IResyncResumeParsingQuery, IResyncResumeParsingQueryVariables>(ResyncResumeParsingDocument, options);
      }
export function useResyncResumeParsingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IResyncResumeParsingQuery, IResyncResumeParsingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IResyncResumeParsingQuery, IResyncResumeParsingQueryVariables>(ResyncResumeParsingDocument, options);
        }
export type ResyncResumeParsingQueryHookResult = ReturnType<typeof useResyncResumeParsingQuery>;
export type ResyncResumeParsingLazyQueryHookResult = ReturnType<typeof useResyncResumeParsingLazyQuery>;
export type ResyncResumeParsingQueryResult = Apollo.QueryResult<IResyncResumeParsingQuery, IResyncResumeParsingQueryVariables>;
export const GetCandidateSuitabilityScoreDocument = gql`
    query getCandidateSuitabilityScore($parsedResumeId: String!) {
  getCandidateSuitabilityScore(parsedResumeId: $parsedResumeId) {
    domainRoleMatchScore {
      category
      comment
      evidence {
        company
      }
      score
      scoreRange
      summary
    }
    experienceScore {
      category
      comment
      evidence {
        company
        role
        seniority
        responsibilities
        startDate
        endDate
        technologyUsed
        domain
      }
      score
      scoreRange
      summary
    }
    finalScore
    latestEmployer
    rating
    regionMatchScore {
      category
      comment
      evidence {
        company
        role
        seniority
        responsibilities
        startDate
        endDate
        technologyUsed
        domain
      }
      score
      scoreRange
      summary
    }
    roleMatchScore {
      category
      comment
      evidence {
        company
        role
        seniority
        responsibilities
        startDate
        endDate
        technologyUsed
        domain
      }
      score
      scoreRange
      summary
    }
    summary
    technicalSkillScore {
      category
      comment
      evidence {
        company
        role
        seniority
        responsibilities
        startDate
        endDate
        technologyUsed
        domain
      }
      score
      scoreRange
      summary
    }
    workExperienceCategory
    yearsOfExperience
  }
}
    `;

/**
 * __useGetCandidateSuitabilityScoreQuery__
 *
 * To run a query within a React component, call `useGetCandidateSuitabilityScoreQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCandidateSuitabilityScoreQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCandidateSuitabilityScoreQuery({
 *   variables: {
 *      parsedResumeId: // value for 'parsedResumeId'
 *   },
 * });
 */
export function useGetCandidateSuitabilityScoreQuery(baseOptions: Apollo.QueryHookOptions<IGetCandidateSuitabilityScoreQuery, IGetCandidateSuitabilityScoreQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetCandidateSuitabilityScoreQuery, IGetCandidateSuitabilityScoreQueryVariables>(GetCandidateSuitabilityScoreDocument, options);
      }
export function useGetCandidateSuitabilityScoreLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetCandidateSuitabilityScoreQuery, IGetCandidateSuitabilityScoreQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetCandidateSuitabilityScoreQuery, IGetCandidateSuitabilityScoreQueryVariables>(GetCandidateSuitabilityScoreDocument, options);
        }
export type GetCandidateSuitabilityScoreQueryHookResult = ReturnType<typeof useGetCandidateSuitabilityScoreQuery>;
export type GetCandidateSuitabilityScoreLazyQueryHookResult = ReturnType<typeof useGetCandidateSuitabilityScoreLazyQuery>;
export type GetCandidateSuitabilityScoreQueryResult = Apollo.QueryResult<IGetCandidateSuitabilityScoreQuery, IGetCandidateSuitabilityScoreQueryVariables>;
export const GetResumeScoresSummaryDocument = gql`
    query getResumeScoresSummary($input: GetResumeScoresInput!) {
  getResumeScoresSummary(input: $input) {
    consCount
    parsedResumeId
    prosCount
    resumeId
    customScore
  }
}
    `;

/**
 * __useGetResumeScoresSummaryQuery__
 *
 * To run a query within a React component, call `useGetResumeScoresSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetResumeScoresSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetResumeScoresSummaryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetResumeScoresSummaryQuery(baseOptions: Apollo.QueryHookOptions<IGetResumeScoresSummaryQuery, IGetResumeScoresSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetResumeScoresSummaryQuery, IGetResumeScoresSummaryQueryVariables>(GetResumeScoresSummaryDocument, options);
      }
export function useGetResumeScoresSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetResumeScoresSummaryQuery, IGetResumeScoresSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetResumeScoresSummaryQuery, IGetResumeScoresSummaryQueryVariables>(GetResumeScoresSummaryDocument, options);
        }
export type GetResumeScoresSummaryQueryHookResult = ReturnType<typeof useGetResumeScoresSummaryQuery>;
export type GetResumeScoresSummaryLazyQueryHookResult = ReturnType<typeof useGetResumeScoresSummaryLazyQuery>;
export type GetResumeScoresSummaryQueryResult = Apollo.QueryResult<IGetResumeScoresSummaryQuery, IGetResumeScoresSummaryQueryVariables>;
export const GetLatestResumeScoreDocument = gql`
    query getLatestResumeScore($parsedResumeId: String!) {
  getLatestResumeScore(parsedResumeId: $parsedResumeId) {
    candidateCons
    candidatePros
    candidateDescription
    customScore
    resumeClassificationReasoning
  }
}
    `;

/**
 * __useGetLatestResumeScoreQuery__
 *
 * To run a query within a React component, call `useGetLatestResumeScoreQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLatestResumeScoreQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLatestResumeScoreQuery({
 *   variables: {
 *      parsedResumeId: // value for 'parsedResumeId'
 *   },
 * });
 */
export function useGetLatestResumeScoreQuery(baseOptions: Apollo.QueryHookOptions<IGetLatestResumeScoreQuery, IGetLatestResumeScoreQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetLatestResumeScoreQuery, IGetLatestResumeScoreQueryVariables>(GetLatestResumeScoreDocument, options);
      }
export function useGetLatestResumeScoreLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetLatestResumeScoreQuery, IGetLatestResumeScoreQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetLatestResumeScoreQuery, IGetLatestResumeScoreQueryVariables>(GetLatestResumeScoreDocument, options);
        }
export type GetLatestResumeScoreQueryHookResult = ReturnType<typeof useGetLatestResumeScoreQuery>;
export type GetLatestResumeScoreLazyQueryHookResult = ReturnType<typeof useGetLatestResumeScoreLazyQuery>;
export type GetLatestResumeScoreQueryResult = Apollo.QueryResult<IGetLatestResumeScoreQuery, IGetLatestResumeScoreQueryVariables>;
export const SaveListOrderDocument = gql`
    mutation SaveListOrder($listType: OrderableListEnum!, $listOrder: [ColumnMetadataInput!]!) {
  saveListOrder(listType: $listType, listOrder: $listOrder) {
    ...TableOrderFragment
  }
}
    ${TableOrderFragmentFragmentDoc}`;
export type ISaveListOrderMutationFn = Apollo.MutationFunction<ISaveListOrderMutation, ISaveListOrderMutationVariables>;

/**
 * __useSaveListOrderMutation__
 *
 * To run a mutation, you first call `useSaveListOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveListOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveListOrderMutation, { data, loading, error }] = useSaveListOrderMutation({
 *   variables: {
 *      listType: // value for 'listType'
 *      listOrder: // value for 'listOrder'
 *   },
 * });
 */
export function useSaveListOrderMutation(baseOptions?: Apollo.MutationHookOptions<ISaveListOrderMutation, ISaveListOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ISaveListOrderMutation, ISaveListOrderMutationVariables>(SaveListOrderDocument, options);
      }
export type SaveListOrderMutationHookResult = ReturnType<typeof useSaveListOrderMutation>;
export type SaveListOrderMutationResult = Apollo.MutationResult<ISaveListOrderMutation>;
export type SaveListOrderMutationOptions = Apollo.BaseMutationOptions<ISaveListOrderMutation, ISaveListOrderMutationVariables>;
export const ValidateUserBulkUploadDocument = gql`
    mutation validateUserBulkUpload($file: Upload!) {
  validateUserBulkUpload(file: $file) {
    invalidData {
      country
      department
      designation
      email
      employeementType
      employeeId
      errors {
        fieldName
        message
      }
      gender
      grade
      jobType
      joinedDate
      mostProficientSkills
      name
      phoneNumber
      role
      shift
      softSkills
      somewhatProficientSkills
      timezone
      level
    }
    validData {
      country
      department
      designation
      email
      employeementType
      employeeId
      errors {
        fieldName
        message
      }
      gender
      grade
      jobType
      joinedDate
      mostProficientSkills
      name
      phoneNumber
      role
      shift
      softSkills
      somewhatProficientSkills
      timezone
      level
    }
  }
}
    `;
export type IValidateUserBulkUploadMutationFn = Apollo.MutationFunction<IValidateUserBulkUploadMutation, IValidateUserBulkUploadMutationVariables>;

/**
 * __useValidateUserBulkUploadMutation__
 *
 * To run a mutation, you first call `useValidateUserBulkUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateUserBulkUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateUserBulkUploadMutation, { data, loading, error }] = useValidateUserBulkUploadMutation({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function useValidateUserBulkUploadMutation(baseOptions?: Apollo.MutationHookOptions<IValidateUserBulkUploadMutation, IValidateUserBulkUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IValidateUserBulkUploadMutation, IValidateUserBulkUploadMutationVariables>(ValidateUserBulkUploadDocument, options);
      }
export type ValidateUserBulkUploadMutationHookResult = ReturnType<typeof useValidateUserBulkUploadMutation>;
export type ValidateUserBulkUploadMutationResult = Apollo.MutationResult<IValidateUserBulkUploadMutation>;
export type ValidateUserBulkUploadMutationOptions = Apollo.BaseMutationOptions<IValidateUserBulkUploadMutation, IValidateUserBulkUploadMutationVariables>;
export const UserBulkUploadDocument = gql`
    mutation userBulkUpload($files: [Upload!]!, $userList: [UserUploadInputDto!]!) {
  userBulkUpload(files: $files, userList: $userList) {
    invalidData {
      country
      department
      designation
      email
      employeementType
      employeeId
      errors {
        fieldName
        message
      }
      gender
      grade
      jobType
      joinedDate
      mostProficientSkills
      name
      phoneNumber
      role
      shift
      softSkills
      somewhatProficientSkills
      timezone
      level
    }
    validData {
      country
      department
      designation
      email
      employeementType
      employeeId
      errors {
        fieldName
        message
      }
      gender
      grade
      jobType
      joinedDate
      mostProficientSkills
      name
      phoneNumber
      role
      shift
      softSkills
      somewhatProficientSkills
      timezone
      level
    }
  }
}
    `;
export type IUserBulkUploadMutationFn = Apollo.MutationFunction<IUserBulkUploadMutation, IUserBulkUploadMutationVariables>;

/**
 * __useUserBulkUploadMutation__
 *
 * To run a mutation, you first call `useUserBulkUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserBulkUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userBulkUploadMutation, { data, loading, error }] = useUserBulkUploadMutation({
 *   variables: {
 *      files: // value for 'files'
 *      userList: // value for 'userList'
 *   },
 * });
 */
export function useUserBulkUploadMutation(baseOptions?: Apollo.MutationHookOptions<IUserBulkUploadMutation, IUserBulkUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUserBulkUploadMutation, IUserBulkUploadMutationVariables>(UserBulkUploadDocument, options);
      }
export type UserBulkUploadMutationHookResult = ReturnType<typeof useUserBulkUploadMutation>;
export type UserBulkUploadMutationResult = Apollo.MutationResult<IUserBulkUploadMutation>;
export type UserBulkUploadMutationOptions = Apollo.BaseMutationOptions<IUserBulkUploadMutation, IUserBulkUploadMutationVariables>;
export const RevalidateEmployeeDataDocument = gql`
    query revalidateEmployeeData($userList: String!) {
  revalidateEmployeeData(userList: $userList) {
    invalidData {
      country
      department
      designation
      email
      employeementType
      employeeId
      errors {
        fieldName
        message
      }
      gender
      grade
      jobType
      joinedDate
      mostProficientSkills
      name
      phoneNumber
      role
      shift
      softSkills
      somewhatProficientSkills
      timezone
      level
    }
    validData {
      country
      department
      designation
      email
      employeementType
      employeeId
      errors {
        fieldName
        message
      }
      gender
      grade
      jobType
      joinedDate
      mostProficientSkills
      name
      phoneNumber
      role
      shift
      softSkills
      somewhatProficientSkills
      timezone
      level
    }
  }
}
    `;

/**
 * __useRevalidateEmployeeDataQuery__
 *
 * To run a query within a React component, call `useRevalidateEmployeeDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useRevalidateEmployeeDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRevalidateEmployeeDataQuery({
 *   variables: {
 *      userList: // value for 'userList'
 *   },
 * });
 */
export function useRevalidateEmployeeDataQuery(baseOptions: Apollo.QueryHookOptions<IRevalidateEmployeeDataQuery, IRevalidateEmployeeDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IRevalidateEmployeeDataQuery, IRevalidateEmployeeDataQueryVariables>(RevalidateEmployeeDataDocument, options);
      }
export function useRevalidateEmployeeDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IRevalidateEmployeeDataQuery, IRevalidateEmployeeDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IRevalidateEmployeeDataQuery, IRevalidateEmployeeDataQueryVariables>(RevalidateEmployeeDataDocument, options);
        }
export type RevalidateEmployeeDataQueryHookResult = ReturnType<typeof useRevalidateEmployeeDataQuery>;
export type RevalidateEmployeeDataLazyQueryHookResult = ReturnType<typeof useRevalidateEmployeeDataLazyQuery>;
export type RevalidateEmployeeDataQueryResult = Apollo.QueryResult<IRevalidateEmployeeDataQuery, IRevalidateEmployeeDataQueryVariables>;
export const GetClientsDocument = gql`
    query getClients($filterDto: ClientFilterDto!, $pageable: PageRequest!) {
  getClients(filterDto: $filterDto, pageable: $pageable) {
    content {
      id
      name
      startDate
      status
      totalNumberOfContacts
      contacts {
        id
        name
        email
        number
        designation
        buyingRole
      }
      squadContactDetails {
        squadName
        squadId
        clientContacts {
          id
          email
          number
          name
        }
      }
      verticalInfo {
        vertical
        verticalLead
        industry
      }
      totalNumberOfEngineers
      totalNumberOfSquads
      accountExecutive
      companyId
      website
      location
      annualRevenue
      noOfEmployees
      tier
      onboardingDate
      nda
      msa
      sow
      businessUnit
      csatRating
      npsScore
      hubspotClientType
      noOfEmployees
      streetAddress2
      legalEntity
    }
    pageable {
      page
      totalPages
      size
      totalElements
    }
  }
}
    `;

/**
 * __useGetClientsQuery__
 *
 * To run a query within a React component, call `useGetClientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientsQuery({
 *   variables: {
 *      filterDto: // value for 'filterDto'
 *      pageable: // value for 'pageable'
 *   },
 * });
 */
export function useGetClientsQuery(baseOptions: Apollo.QueryHookOptions<IGetClientsQuery, IGetClientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetClientsQuery, IGetClientsQueryVariables>(GetClientsDocument, options);
      }
export function useGetClientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetClientsQuery, IGetClientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetClientsQuery, IGetClientsQueryVariables>(GetClientsDocument, options);
        }
export type GetClientsQueryHookResult = ReturnType<typeof useGetClientsQuery>;
export type GetClientsLazyQueryHookResult = ReturnType<typeof useGetClientsLazyQuery>;
export type GetClientsQueryResult = Apollo.QueryResult<IGetClientsQuery, IGetClientsQueryVariables>;
export const GetClientContactsDocument = gql`
    query getClientContacts($id: String!) {
  getClientContactGroupedBySquad(id: $id) {
    squadName
    clientContacts {
      id
      email
      number
      name
    }
  }
}
    `;

/**
 * __useGetClientContactsQuery__
 *
 * To run a query within a React component, call `useGetClientContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientContactsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetClientContactsQuery(baseOptions: Apollo.QueryHookOptions<IGetClientContactsQuery, IGetClientContactsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetClientContactsQuery, IGetClientContactsQueryVariables>(GetClientContactsDocument, options);
      }
export function useGetClientContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetClientContactsQuery, IGetClientContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetClientContactsQuery, IGetClientContactsQueryVariables>(GetClientContactsDocument, options);
        }
export type GetClientContactsQueryHookResult = ReturnType<typeof useGetClientContactsQuery>;
export type GetClientContactsLazyQueryHookResult = ReturnType<typeof useGetClientContactsLazyQuery>;
export type GetClientContactsQueryResult = Apollo.QueryResult<IGetClientContactsQuery, IGetClientContactsQueryVariables>;
export const GetClientDetailsDocument = gql`
    query getClientDetails($id: String!) {
  getClientById(id: $id) {
    id
    name
    startDate
    clientType
    contacts {
      id
      name
      email
      number
      designation
    }
  }
}
    `;

/**
 * __useGetClientDetailsQuery__
 *
 * To run a query within a React component, call `useGetClientDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetClientDetailsQuery(baseOptions: Apollo.QueryHookOptions<IGetClientDetailsQuery, IGetClientDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetClientDetailsQuery, IGetClientDetailsQueryVariables>(GetClientDetailsDocument, options);
      }
export function useGetClientDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetClientDetailsQuery, IGetClientDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetClientDetailsQuery, IGetClientDetailsQueryVariables>(GetClientDetailsDocument, options);
        }
export type GetClientDetailsQueryHookResult = ReturnType<typeof useGetClientDetailsQuery>;
export type GetClientDetailsLazyQueryHookResult = ReturnType<typeof useGetClientDetailsLazyQuery>;
export type GetClientDetailsQueryResult = Apollo.QueryResult<IGetClientDetailsQuery, IGetClientDetailsQueryVariables>;
export const GetClientListSummaryDocument = gql`
    query getClientListSummary($filterDto: ClientFilterDto!, $pageable: PageRequest!) {
  getClients(filterDto: $filterDto, pageable: $pageable) {
    content {
      id
      name
    }
  }
}
    `;

/**
 * __useGetClientListSummaryQuery__
 *
 * To run a query within a React component, call `useGetClientListSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientListSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientListSummaryQuery({
 *   variables: {
 *      filterDto: // value for 'filterDto'
 *      pageable: // value for 'pageable'
 *   },
 * });
 */
export function useGetClientListSummaryQuery(baseOptions: Apollo.QueryHookOptions<IGetClientListSummaryQuery, IGetClientListSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetClientListSummaryQuery, IGetClientListSummaryQueryVariables>(GetClientListSummaryDocument, options);
      }
export function useGetClientListSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetClientListSummaryQuery, IGetClientListSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetClientListSummaryQuery, IGetClientListSummaryQueryVariables>(GetClientListSummaryDocument, options);
        }
export type GetClientListSummaryQueryHookResult = ReturnType<typeof useGetClientListSummaryQuery>;
export type GetClientListSummaryLazyQueryHookResult = ReturnType<typeof useGetClientListSummaryLazyQuery>;
export type GetClientListSummaryQueryResult = Apollo.QueryResult<IGetClientListSummaryQuery, IGetClientListSummaryQueryVariables>;
export const GetClientSquadsDocument = gql`
    query getClientSquads($id: String!, $pageRequest: PageRequest) {
  getClientSpecificSquad(id: $id, pageRequest: $pageRequest) {
    content {
      id
      activeStatus
      approvers {
        additionalApprovers {
          designation
          fullname
          userId
        }
        squadId
        defaultApprover {
          designation
          fullname
          userId
        }
      }
      aiMembersCount
      techMembersCount
      totalMembersCount
      name
      startDate
      type
      clientDepartment {
        id
        name
      }
      createdBy
      totalResourceCount
      totalAssignedCount
      ticketOwner
      endDate
    }
    pageable {
      page
      totalPages
      size
      totalElements
    }
  }
}
    `;

/**
 * __useGetClientSquadsQuery__
 *
 * To run a query within a React component, call `useGetClientSquadsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientSquadsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientSquadsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      pageRequest: // value for 'pageRequest'
 *   },
 * });
 */
export function useGetClientSquadsQuery(baseOptions: Apollo.QueryHookOptions<IGetClientSquadsQuery, IGetClientSquadsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetClientSquadsQuery, IGetClientSquadsQueryVariables>(GetClientSquadsDocument, options);
      }
export function useGetClientSquadsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetClientSquadsQuery, IGetClientSquadsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetClientSquadsQuery, IGetClientSquadsQueryVariables>(GetClientSquadsDocument, options);
        }
export type GetClientSquadsQueryHookResult = ReturnType<typeof useGetClientSquadsQuery>;
export type GetClientSquadsLazyQueryHookResult = ReturnType<typeof useGetClientSquadsLazyQuery>;
export type GetClientSquadsQueryResult = Apollo.QueryResult<IGetClientSquadsQuery, IGetClientSquadsQueryVariables>;
export const GetClientResourcesDocument = gql`
    query getClientResources($id: String!) {
  getClientById(id: $id) {
    id
    name
  }
}
    `;

/**
 * __useGetClientResourcesQuery__
 *
 * To run a query within a React component, call `useGetClientResourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientResourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientResourcesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetClientResourcesQuery(baseOptions: Apollo.QueryHookOptions<IGetClientResourcesQuery, IGetClientResourcesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetClientResourcesQuery, IGetClientResourcesQueryVariables>(GetClientResourcesDocument, options);
      }
export function useGetClientResourcesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetClientResourcesQuery, IGetClientResourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetClientResourcesQuery, IGetClientResourcesQueryVariables>(GetClientResourcesDocument, options);
        }
export type GetClientResourcesQueryHookResult = ReturnType<typeof useGetClientResourcesQuery>;
export type GetClientResourcesLazyQueryHookResult = ReturnType<typeof useGetClientResourcesLazyQuery>;
export type GetClientResourcesQueryResult = Apollo.QueryResult<IGetClientResourcesQuery, IGetClientResourcesQueryVariables>;
export const GetContributingHiringMembersDocument = gql`
    query getContributingHiringMembers {
  getContributingHiringMembers {
    designation {
      id
      name
      grade
    }
    email
    fullname
    id
    roles
  }
}
    `;

/**
 * __useGetContributingHiringMembersQuery__
 *
 * To run a query within a React component, call `useGetContributingHiringMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContributingHiringMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContributingHiringMembersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetContributingHiringMembersQuery(baseOptions?: Apollo.QueryHookOptions<IGetContributingHiringMembersQuery, IGetContributingHiringMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetContributingHiringMembersQuery, IGetContributingHiringMembersQueryVariables>(GetContributingHiringMembersDocument, options);
      }
export function useGetContributingHiringMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetContributingHiringMembersQuery, IGetContributingHiringMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetContributingHiringMembersQuery, IGetContributingHiringMembersQueryVariables>(GetContributingHiringMembersDocument, options);
        }
export type GetContributingHiringMembersQueryHookResult = ReturnType<typeof useGetContributingHiringMembersQuery>;
export type GetContributingHiringMembersLazyQueryHookResult = ReturnType<typeof useGetContributingHiringMembersLazyQuery>;
export type GetContributingHiringMembersQueryResult = Apollo.QueryResult<IGetContributingHiringMembersQuery, IGetContributingHiringMembersQueryVariables>;
export const GetClientSquadsDetailDocument = gql`
    query getClientSquadsDetail($id: String!) {
  getSquadById(id: $id) {
    id
    name
    allowWorklog
    contacts {
      id
      name
      email
      number
      designation
    }
    description
    dealLink
    techStack
    type
    startDate
    squadBudget
    endDate
    activeStatus
    lineOfBusiness
    vertical
    verticalId
    squadCategoryName
    squadCategoryId
    industry
    industryId
    projectTier
    dealOwner {
      name
      ownerEmail
      ownerId
    }
    client {
      id
      name
      startDate
      status
      countSquads
    }
    clientDepartment {
      id
      name
    }
    additionalApproversResources {
      additionalApproverId
      approverResources
    }
    approvers {
      additionalApprovers {
        fullname
        userId
        designation
      }
      defaultApprover {
        designation
        userId
        fullname
      }
    }
  }
}
    `;

/**
 * __useGetClientSquadsDetailQuery__
 *
 * To run a query within a React component, call `useGetClientSquadsDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientSquadsDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientSquadsDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetClientSquadsDetailQuery(baseOptions: Apollo.QueryHookOptions<IGetClientSquadsDetailQuery, IGetClientSquadsDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetClientSquadsDetailQuery, IGetClientSquadsDetailQueryVariables>(GetClientSquadsDetailDocument, options);
      }
export function useGetClientSquadsDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetClientSquadsDetailQuery, IGetClientSquadsDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetClientSquadsDetailQuery, IGetClientSquadsDetailQueryVariables>(GetClientSquadsDetailDocument, options);
        }
export type GetClientSquadsDetailQueryHookResult = ReturnType<typeof useGetClientSquadsDetailQuery>;
export type GetClientSquadsDetailLazyQueryHookResult = ReturnType<typeof useGetClientSquadsDetailLazyQuery>;
export type GetClientSquadsDetailQueryResult = Apollo.QueryResult<IGetClientSquadsDetailQuery, IGetClientSquadsDetailQueryVariables>;
export const GetSquadDetailsBySquadIdDocument = gql`
    query getSquadDetailsBySquadId($id: String!) {
  getSquadById(id: $id) {
    activeStatus
    name
    startDate
    endDate
  }
}
    `;

/**
 * __useGetSquadDetailsBySquadIdQuery__
 *
 * To run a query within a React component, call `useGetSquadDetailsBySquadIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSquadDetailsBySquadIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSquadDetailsBySquadIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSquadDetailsBySquadIdQuery(baseOptions: Apollo.QueryHookOptions<IGetSquadDetailsBySquadIdQuery, IGetSquadDetailsBySquadIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetSquadDetailsBySquadIdQuery, IGetSquadDetailsBySquadIdQueryVariables>(GetSquadDetailsBySquadIdDocument, options);
      }
export function useGetSquadDetailsBySquadIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetSquadDetailsBySquadIdQuery, IGetSquadDetailsBySquadIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetSquadDetailsBySquadIdQuery, IGetSquadDetailsBySquadIdQueryVariables>(GetSquadDetailsBySquadIdDocument, options);
        }
export type GetSquadDetailsBySquadIdQueryHookResult = ReturnType<typeof useGetSquadDetailsBySquadIdQuery>;
export type GetSquadDetailsBySquadIdLazyQueryHookResult = ReturnType<typeof useGetSquadDetailsBySquadIdLazyQuery>;
export type GetSquadDetailsBySquadIdQueryResult = Apollo.QueryResult<IGetSquadDetailsBySquadIdQuery, IGetSquadDetailsBySquadIdQueryVariables>;
export const GetSquadAssignedResourcesDocument = gql`
    query GetSquadAssignedResources($id: String!, $userSquadHistorySearchDTO: UserSquadHistorySearchDTO!) {
  getSquadAssignedResources(
    id: $id
    userSquadHistorySearchDTO: $userSquadHistorySearchDTO
  ) {
    id
    name
    employeeList {
      id
      name
      profileImage
      department {
        id
        name
      }
      jobType
      rate
      rateType
      rateCurrency
      role
      yearsOfExperience
      experienceLevel
      requiredSkills
      userId
      clientRate
      employeeRate
      involvementStatus
      startDate
      endDate
      estimatedEndDate
    }
  }
}
    `;

/**
 * __useGetSquadAssignedResourcesQuery__
 *
 * To run a query within a React component, call `useGetSquadAssignedResourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSquadAssignedResourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSquadAssignedResourcesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      userSquadHistorySearchDTO: // value for 'userSquadHistorySearchDTO'
 *   },
 * });
 */
export function useGetSquadAssignedResourcesQuery(baseOptions: Apollo.QueryHookOptions<IGetSquadAssignedResourcesQuery, IGetSquadAssignedResourcesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetSquadAssignedResourcesQuery, IGetSquadAssignedResourcesQueryVariables>(GetSquadAssignedResourcesDocument, options);
      }
export function useGetSquadAssignedResourcesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetSquadAssignedResourcesQuery, IGetSquadAssignedResourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetSquadAssignedResourcesQuery, IGetSquadAssignedResourcesQueryVariables>(GetSquadAssignedResourcesDocument, options);
        }
export type GetSquadAssignedResourcesQueryHookResult = ReturnType<typeof useGetSquadAssignedResourcesQuery>;
export type GetSquadAssignedResourcesLazyQueryHookResult = ReturnType<typeof useGetSquadAssignedResourcesLazyQuery>;
export type GetSquadAssignedResourcesQueryResult = Apollo.QueryResult<IGetSquadAssignedResourcesQuery, IGetSquadAssignedResourcesQueryVariables>;
export const GetAssignResourcesDocument = gql`
    query getAssignResources($id: String!, $userSquadHistorySearchDTO: UserSquadHistorySearchDTO!) {
  getClientsAssignedResources(
    id: $id
    userSquadHistorySearchDTO: $userSquadHistorySearchDTO
  ) {
    id
    name
    employeeList {
      id
      name
      department {
        id
        name
      }
      jobType
      rate
      rateType
      rateCurrency
      role
      yearsOfExperience
      requiredSkills
      experienceLevel
      userId
      employeeRate
      clientRate
      involvementStatus
      startDate
      endDate
      estimatedEndDate
      profileImage
      additionalNotes {
        ...NoteFragment
      }
    }
  }
}
    ${NoteFragmentFragmentDoc}`;

/**
 * __useGetAssignResourcesQuery__
 *
 * To run a query within a React component, call `useGetAssignResourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssignResourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssignResourcesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      userSquadHistorySearchDTO: // value for 'userSquadHistorySearchDTO'
 *   },
 * });
 */
export function useGetAssignResourcesQuery(baseOptions: Apollo.QueryHookOptions<IGetAssignResourcesQuery, IGetAssignResourcesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetAssignResourcesQuery, IGetAssignResourcesQueryVariables>(GetAssignResourcesDocument, options);
      }
export function useGetAssignResourcesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetAssignResourcesQuery, IGetAssignResourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetAssignResourcesQuery, IGetAssignResourcesQueryVariables>(GetAssignResourcesDocument, options);
        }
export type GetAssignResourcesQueryHookResult = ReturnType<typeof useGetAssignResourcesQuery>;
export type GetAssignResourcesLazyQueryHookResult = ReturnType<typeof useGetAssignResourcesLazyQuery>;
export type GetAssignResourcesQueryResult = Apollo.QueryResult<IGetAssignResourcesQuery, IGetAssignResourcesQueryVariables>;
export const GetSquadOverviewDetailDocument = gql`
    query getSquadOverviewDetail($id: String!) {
  getSquadOverview(id: $id) {
    AI {
      ...roleData
    }
    TECH {
      ...roleData
    }
    LEVEL
  }
}
    ${RoleDataFragmentDoc}`;

/**
 * __useGetSquadOverviewDetailQuery__
 *
 * To run a query within a React component, call `useGetSquadOverviewDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSquadOverviewDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSquadOverviewDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSquadOverviewDetailQuery(baseOptions: Apollo.QueryHookOptions<IGetSquadOverviewDetailQuery, IGetSquadOverviewDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetSquadOverviewDetailQuery, IGetSquadOverviewDetailQueryVariables>(GetSquadOverviewDetailDocument, options);
      }
export function useGetSquadOverviewDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetSquadOverviewDetailQuery, IGetSquadOverviewDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetSquadOverviewDetailQuery, IGetSquadOverviewDetailQueryVariables>(GetSquadOverviewDetailDocument, options);
        }
export type GetSquadOverviewDetailQueryHookResult = ReturnType<typeof useGetSquadOverviewDetailQuery>;
export type GetSquadOverviewDetailLazyQueryHookResult = ReturnType<typeof useGetSquadOverviewDetailLazyQuery>;
export type GetSquadOverviewDetailQueryResult = Apollo.QueryResult<IGetSquadOverviewDetailQuery, IGetSquadOverviewDetailQueryVariables>;
export const GetSquadResourceAndSquadByIdDocument = gql`
    query getSquadResourceAndSquadById($squadId: String!, $squadResourceId: String!, $squadRoleId: String!) {
  getSquadResourceAndSquadById(
    squadId: $squadId
    squadResourceId: $squadResourceId
    squadRoleId: $squadRoleId
  ) {
    clientName
    country
    id
    lineOfBusiness
    projectTier
    phasesAssigned
    rate
    requiredCount
    requiredSkills
    role
    squadEndDate
    squadName
    squadStartDate
    ticketId
    department
    goodToHaveSkills
    jobDescription
    experienceLevel
    priority
    jobType
    projectDescription
    yearsOfExperience
    timeZone
    endDate
    startDate
    vertical
    industry
    squadStartDate
    squadEndDate
    locationToBeHiredFrom
    clientSelectionProcess
    softSkills
  }
}
    `;

/**
 * __useGetSquadResourceAndSquadByIdQuery__
 *
 * To run a query within a React component, call `useGetSquadResourceAndSquadByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSquadResourceAndSquadByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSquadResourceAndSquadByIdQuery({
 *   variables: {
 *      squadId: // value for 'squadId'
 *      squadResourceId: // value for 'squadResourceId'
 *      squadRoleId: // value for 'squadRoleId'
 *   },
 * });
 */
export function useGetSquadResourceAndSquadByIdQuery(baseOptions: Apollo.QueryHookOptions<IGetSquadResourceAndSquadByIdQuery, IGetSquadResourceAndSquadByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetSquadResourceAndSquadByIdQuery, IGetSquadResourceAndSquadByIdQueryVariables>(GetSquadResourceAndSquadByIdDocument, options);
      }
export function useGetSquadResourceAndSquadByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetSquadResourceAndSquadByIdQuery, IGetSquadResourceAndSquadByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetSquadResourceAndSquadByIdQuery, IGetSquadResourceAndSquadByIdQueryVariables>(GetSquadResourceAndSquadByIdDocument, options);
        }
export type GetSquadResourceAndSquadByIdQueryHookResult = ReturnType<typeof useGetSquadResourceAndSquadByIdQuery>;
export type GetSquadResourceAndSquadByIdLazyQueryHookResult = ReturnType<typeof useGetSquadResourceAndSquadByIdLazyQuery>;
export type GetSquadResourceAndSquadByIdQueryResult = Apollo.QueryResult<IGetSquadResourceAndSquadByIdQuery, IGetSquadResourceAndSquadByIdQueryVariables>;
export const GetTicketOwnersAndCountriesDocument = gql`
    query getTicketOwnersAndCountries($squadId: String!) {
  getTicketOwnersAndCountries(squadId: $squadId) {
    countries
    ticketOwners
  }
}
    `;

/**
 * __useGetTicketOwnersAndCountriesQuery__
 *
 * To run a query within a React component, call `useGetTicketOwnersAndCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTicketOwnersAndCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTicketOwnersAndCountriesQuery({
 *   variables: {
 *      squadId: // value for 'squadId'
 *   },
 * });
 */
export function useGetTicketOwnersAndCountriesQuery(baseOptions: Apollo.QueryHookOptions<IGetTicketOwnersAndCountriesQuery, IGetTicketOwnersAndCountriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetTicketOwnersAndCountriesQuery, IGetTicketOwnersAndCountriesQueryVariables>(GetTicketOwnersAndCountriesDocument, options);
      }
export function useGetTicketOwnersAndCountriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetTicketOwnersAndCountriesQuery, IGetTicketOwnersAndCountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetTicketOwnersAndCountriesQuery, IGetTicketOwnersAndCountriesQueryVariables>(GetTicketOwnersAndCountriesDocument, options);
        }
export type GetTicketOwnersAndCountriesQueryHookResult = ReturnType<typeof useGetTicketOwnersAndCountriesQuery>;
export type GetTicketOwnersAndCountriesLazyQueryHookResult = ReturnType<typeof useGetTicketOwnersAndCountriesLazyQuery>;
export type GetTicketOwnersAndCountriesQueryResult = Apollo.QueryResult<IGetTicketOwnersAndCountriesQuery, IGetTicketOwnersAndCountriesQueryVariables>;
export const GetDealOwnersInSquadDocument = gql`
    query getDealOwnersInSquad {
  getDealOwnersInSquad
}
    `;

/**
 * __useGetDealOwnersInSquadQuery__
 *
 * To run a query within a React component, call `useGetDealOwnersInSquadQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDealOwnersInSquadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDealOwnersInSquadQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDealOwnersInSquadQuery(baseOptions?: Apollo.QueryHookOptions<IGetDealOwnersInSquadQuery, IGetDealOwnersInSquadQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetDealOwnersInSquadQuery, IGetDealOwnersInSquadQueryVariables>(GetDealOwnersInSquadDocument, options);
      }
export function useGetDealOwnersInSquadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetDealOwnersInSquadQuery, IGetDealOwnersInSquadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetDealOwnersInSquadQuery, IGetDealOwnersInSquadQueryVariables>(GetDealOwnersInSquadDocument, options);
        }
export type GetDealOwnersInSquadQueryHookResult = ReturnType<typeof useGetDealOwnersInSquadQuery>;
export type GetDealOwnersInSquadLazyQueryHookResult = ReturnType<typeof useGetDealOwnersInSquadLazyQuery>;
export type GetDealOwnersInSquadQueryResult = Apollo.QueryResult<IGetDealOwnersInSquadQuery, IGetDealOwnersInSquadQueryVariables>;
export const GetWorkingTimeZonesDocument = gql`
    query getWorkingTimeZones {
  getWorkingTimeZones
}
    `;

/**
 * __useGetWorkingTimeZonesQuery__
 *
 * To run a query within a React component, call `useGetWorkingTimeZonesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkingTimeZonesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkingTimeZonesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetWorkingTimeZonesQuery(baseOptions?: Apollo.QueryHookOptions<IGetWorkingTimeZonesQuery, IGetWorkingTimeZonesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetWorkingTimeZonesQuery, IGetWorkingTimeZonesQueryVariables>(GetWorkingTimeZonesDocument, options);
      }
export function useGetWorkingTimeZonesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetWorkingTimeZonesQuery, IGetWorkingTimeZonesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetWorkingTimeZonesQuery, IGetWorkingTimeZonesQueryVariables>(GetWorkingTimeZonesDocument, options);
        }
export type GetWorkingTimeZonesQueryHookResult = ReturnType<typeof useGetWorkingTimeZonesQuery>;
export type GetWorkingTimeZonesLazyQueryHookResult = ReturnType<typeof useGetWorkingTimeZonesLazyQuery>;
export type GetWorkingTimeZonesQueryResult = Apollo.QueryResult<IGetWorkingTimeZonesQuery, IGetWorkingTimeZonesQueryVariables>;
export const GetUserAssignedSquadsByUserIdDocument = gql`
    query getUserAssignedSquadsByUserId($userId: String!, $options: UserAssignedSquadsOptions) {
  getUserAssignedSquadsByUserId(userId: $userId, options: $options) {
    squadName
    jobType
    involvementType
    squadId
    allocatedHours
  }
}
    `;

/**
 * __useGetUserAssignedSquadsByUserIdQuery__
 *
 * To run a query within a React component, call `useGetUserAssignedSquadsByUserIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserAssignedSquadsByUserIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserAssignedSquadsByUserIdQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useGetUserAssignedSquadsByUserIdQuery(baseOptions: Apollo.QueryHookOptions<IGetUserAssignedSquadsByUserIdQuery, IGetUserAssignedSquadsByUserIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetUserAssignedSquadsByUserIdQuery, IGetUserAssignedSquadsByUserIdQueryVariables>(GetUserAssignedSquadsByUserIdDocument, options);
      }
export function useGetUserAssignedSquadsByUserIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetUserAssignedSquadsByUserIdQuery, IGetUserAssignedSquadsByUserIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetUserAssignedSquadsByUserIdQuery, IGetUserAssignedSquadsByUserIdQueryVariables>(GetUserAssignedSquadsByUserIdDocument, options);
        }
export type GetUserAssignedSquadsByUserIdQueryHookResult = ReturnType<typeof useGetUserAssignedSquadsByUserIdQuery>;
export type GetUserAssignedSquadsByUserIdLazyQueryHookResult = ReturnType<typeof useGetUserAssignedSquadsByUserIdLazyQuery>;
export type GetUserAssignedSquadsByUserIdQueryResult = Apollo.QueryResult<IGetUserAssignedSquadsByUserIdQuery, IGetUserAssignedSquadsByUserIdQueryVariables>;
export const GetUserPreferenceDocument = gql`
    query getUserPreference {
  getUserPreference {
    ...TableOrderFragment
  }
}
    ${TableOrderFragmentFragmentDoc}`;

/**
 * __useGetUserPreferenceQuery__
 *
 * To run a query within a React component, call `useGetUserPreferenceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserPreferenceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserPreferenceQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserPreferenceQuery(baseOptions?: Apollo.QueryHookOptions<IGetUserPreferenceQuery, IGetUserPreferenceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetUserPreferenceQuery, IGetUserPreferenceQueryVariables>(GetUserPreferenceDocument, options);
      }
export function useGetUserPreferenceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetUserPreferenceQuery, IGetUserPreferenceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetUserPreferenceQuery, IGetUserPreferenceQueryVariables>(GetUserPreferenceDocument, options);
        }
export type GetUserPreferenceQueryHookResult = ReturnType<typeof useGetUserPreferenceQuery>;
export type GetUserPreferenceLazyQueryHookResult = ReturnType<typeof useGetUserPreferenceLazyQuery>;
export type GetUserPreferenceQueryResult = Apollo.QueryResult<IGetUserPreferenceQuery, IGetUserPreferenceQueryVariables>;
export const RoleDetailsDocument = gql`
    query roleDetails($squadRoleId: String!, $userSquadHistoryId: String!) {
  getRoleDetailsById(
    squadRoleId: $squadRoleId
    userSquadHistoryId: $userSquadHistoryId
  ) {
    id
    ticketId
    squadId
    squadRoleId
    role
    experienceLevel
    workingHour
    country
    timeZone
    jobType
    yearsOfExperience
    startDate
    endDate
    requiredSkills
    goodToHaveSkills
    jobDescription
    prevEmpStartDate
    prevEmpEndDate
    involvedAs
    involvementStatus
    userId
    userSquadHistoryId
  }
}
    `;

/**
 * __useRoleDetailsQuery__
 *
 * To run a query within a React component, call `useRoleDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoleDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoleDetailsQuery({
 *   variables: {
 *      squadRoleId: // value for 'squadRoleId'
 *      userSquadHistoryId: // value for 'userSquadHistoryId'
 *   },
 * });
 */
export function useRoleDetailsQuery(baseOptions: Apollo.QueryHookOptions<IRoleDetailsQuery, IRoleDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IRoleDetailsQuery, IRoleDetailsQueryVariables>(RoleDetailsDocument, options);
      }
export function useRoleDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IRoleDetailsQuery, IRoleDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IRoleDetailsQuery, IRoleDetailsQueryVariables>(RoleDetailsDocument, options);
        }
export type RoleDetailsQueryHookResult = ReturnType<typeof useRoleDetailsQuery>;
export type RoleDetailsLazyQueryHookResult = ReturnType<typeof useRoleDetailsLazyQuery>;
export type RoleDetailsQueryResult = Apollo.QueryResult<IRoleDetailsQuery, IRoleDetailsQueryVariables>;
export const GetDashboardAnalyticsDocument = gql`
    query getDashboardAnalytics {
  getDashboardAnalytics {
    partiallyDeployable
    totalDeployable
    totalNoOfActiveConsultant
    totalNoOfActiveConsultantCoreFullTime
    totalNoOfActiveConsultantCorePartTime
    totalNoOfAssigned
    totalNoOfClientBillableProjectCore
    totalNoOfClientBillableProjectCoreFullTime
    totalNoOfClientBillableProjectCorePartTime
    totalNoOfClientNonBillableProjectShadow
    totalNoOfClientNonBillableProjectShadowFullTime
    totalNoOfClientNonBillableProjectShadowPartTime
    totalNoOfClientNonBillableProjectSupport
    totalNoOfClientNonBillableProjectSupportFullTime
    totalNoOfClientNonBillableProjectSupportPartTime
    totalNoOfEmployees
    totalNoOfInactiveConsultant
    totalNoOfInternalProjectCoreFullTime
    totalNoOfInternalProjectCorePartTime
    totalNoOfInternalProjectShadowFullTime
    totalNoOfInternalProjectShadowPartTime
    totalNoOfInternalProjectSupportFullTime
    totalNoOfInternalProjectSupportPartTime
    totalNoOfOnBench
    totalNoOfUnassigned
    totalNofOfInternalProjectCore
    totalNofOfInternalProjectShadow
    totalNofOfInternalProjectSupport
  }
}
    `;

/**
 * __useGetDashboardAnalyticsQuery__
 *
 * To run a query within a React component, call `useGetDashboardAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDashboardAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDashboardAnalyticsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDashboardAnalyticsQuery(baseOptions?: Apollo.QueryHookOptions<IGetDashboardAnalyticsQuery, IGetDashboardAnalyticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetDashboardAnalyticsQuery, IGetDashboardAnalyticsQueryVariables>(GetDashboardAnalyticsDocument, options);
      }
export function useGetDashboardAnalyticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetDashboardAnalyticsQuery, IGetDashboardAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetDashboardAnalyticsQuery, IGetDashboardAnalyticsQueryVariables>(GetDashboardAnalyticsDocument, options);
        }
export type GetDashboardAnalyticsQueryHookResult = ReturnType<typeof useGetDashboardAnalyticsQuery>;
export type GetDashboardAnalyticsLazyQueryHookResult = ReturnType<typeof useGetDashboardAnalyticsLazyQuery>;
export type GetDashboardAnalyticsQueryResult = Apollo.QueryResult<IGetDashboardAnalyticsQuery, IGetDashboardAnalyticsQueryVariables>;
export const GetRoleInfoByHistoryIdDocument = gql`
    query getRoleInfoByHistoryId($historyId: String!) {
  getRoleInfoByHistoryId(historyId: $historyId) {
    clientId
    clientName
    squadId
    squadName
    role
    experienceLevel
    jobType
    squadRoleId
    ticketId
    department
    country
    timeZone
    priority
    rate
    requiredSkills
    goodToHaveSkills
    jobDescription
    endDate
    joinedDate
    employeeName
    involvedAs
    userId
  }
}
    `;

/**
 * __useGetRoleInfoByHistoryIdQuery__
 *
 * To run a query within a React component, call `useGetRoleInfoByHistoryIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRoleInfoByHistoryIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRoleInfoByHistoryIdQuery({
 *   variables: {
 *      historyId: // value for 'historyId'
 *   },
 * });
 */
export function useGetRoleInfoByHistoryIdQuery(baseOptions: Apollo.QueryHookOptions<IGetRoleInfoByHistoryIdQuery, IGetRoleInfoByHistoryIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetRoleInfoByHistoryIdQuery, IGetRoleInfoByHistoryIdQueryVariables>(GetRoleInfoByHistoryIdDocument, options);
      }
export function useGetRoleInfoByHistoryIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetRoleInfoByHistoryIdQuery, IGetRoleInfoByHistoryIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetRoleInfoByHistoryIdQuery, IGetRoleInfoByHistoryIdQueryVariables>(GetRoleInfoByHistoryIdDocument, options);
        }
export type GetRoleInfoByHistoryIdQueryHookResult = ReturnType<typeof useGetRoleInfoByHistoryIdQuery>;
export type GetRoleInfoByHistoryIdLazyQueryHookResult = ReturnType<typeof useGetRoleInfoByHistoryIdLazyQuery>;
export type GetRoleInfoByHistoryIdQueryResult = Apollo.QueryResult<IGetRoleInfoByHistoryIdQuery, IGetRoleInfoByHistoryIdQueryVariables>;
export const FetchRunningSquadByClientIdDocument = gql`
    query fetchRunningSquadByClientId($clientId: String!) {
  getRunningSquadsByClientId(clientId: $clientId) {
    id
    name
  }
}
    `;

/**
 * __useFetchRunningSquadByClientIdQuery__
 *
 * To run a query within a React component, call `useFetchRunningSquadByClientIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchRunningSquadByClientIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchRunningSquadByClientIdQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useFetchRunningSquadByClientIdQuery(baseOptions: Apollo.QueryHookOptions<IFetchRunningSquadByClientIdQuery, IFetchRunningSquadByClientIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IFetchRunningSquadByClientIdQuery, IFetchRunningSquadByClientIdQueryVariables>(FetchRunningSquadByClientIdDocument, options);
      }
export function useFetchRunningSquadByClientIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IFetchRunningSquadByClientIdQuery, IFetchRunningSquadByClientIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IFetchRunningSquadByClientIdQuery, IFetchRunningSquadByClientIdQueryVariables>(FetchRunningSquadByClientIdDocument, options);
        }
export type FetchRunningSquadByClientIdQueryHookResult = ReturnType<typeof useFetchRunningSquadByClientIdQuery>;
export type FetchRunningSquadByClientIdLazyQueryHookResult = ReturnType<typeof useFetchRunningSquadByClientIdLazyQuery>;
export type FetchRunningSquadByClientIdQueryResult = Apollo.QueryResult<IFetchRunningSquadByClientIdQuery, IFetchRunningSquadByClientIdQueryVariables>;
export const GetEmployeeUploadSampleDocument = gql`
    query getEmployeeUploadSample {
  getEmployeeUploadSample
}
    `;

/**
 * __useGetEmployeeUploadSampleQuery__
 *
 * To run a query within a React component, call `useGetEmployeeUploadSampleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeeUploadSampleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeeUploadSampleQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEmployeeUploadSampleQuery(baseOptions?: Apollo.QueryHookOptions<IGetEmployeeUploadSampleQuery, IGetEmployeeUploadSampleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetEmployeeUploadSampleQuery, IGetEmployeeUploadSampleQueryVariables>(GetEmployeeUploadSampleDocument, options);
      }
export function useGetEmployeeUploadSampleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetEmployeeUploadSampleQuery, IGetEmployeeUploadSampleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetEmployeeUploadSampleQuery, IGetEmployeeUploadSampleQueryVariables>(GetEmployeeUploadSampleDocument, options);
        }
export type GetEmployeeUploadSampleQueryHookResult = ReturnType<typeof useGetEmployeeUploadSampleQuery>;
export type GetEmployeeUploadSampleLazyQueryHookResult = ReturnType<typeof useGetEmployeeUploadSampleLazyQuery>;
export type GetEmployeeUploadSampleQueryResult = Apollo.QueryResult<IGetEmployeeUploadSampleQuery, IGetEmployeeUploadSampleQueryVariables>;
export const ExportErrorDataSheetDocument = gql`
    query exportErrorDataSheet($userList: String!) {
  exportErrorDataSheet(userList: $userList)
}
    `;

/**
 * __useExportErrorDataSheetQuery__
 *
 * To run a query within a React component, call `useExportErrorDataSheetQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportErrorDataSheetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportErrorDataSheetQuery({
 *   variables: {
 *      userList: // value for 'userList'
 *   },
 * });
 */
export function useExportErrorDataSheetQuery(baseOptions: Apollo.QueryHookOptions<IExportErrorDataSheetQuery, IExportErrorDataSheetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IExportErrorDataSheetQuery, IExportErrorDataSheetQueryVariables>(ExportErrorDataSheetDocument, options);
      }
export function useExportErrorDataSheetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IExportErrorDataSheetQuery, IExportErrorDataSheetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IExportErrorDataSheetQuery, IExportErrorDataSheetQueryVariables>(ExportErrorDataSheetDocument, options);
        }
export type ExportErrorDataSheetQueryHookResult = ReturnType<typeof useExportErrorDataSheetQuery>;
export type ExportErrorDataSheetLazyQueryHookResult = ReturnType<typeof useExportErrorDataSheetLazyQuery>;
export type ExportErrorDataSheetQueryResult = Apollo.QueryResult<IExportErrorDataSheetQuery, IExportErrorDataSheetQueryVariables>;
export const GetAllSquadCategoryDocument = gql`
    query getAllSquadCategory {
  findAllSquadCategory {
    descriptions
    id
    name
  }
}
    `;

/**
 * __useGetAllSquadCategoryQuery__
 *
 * To run a query within a React component, call `useGetAllSquadCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllSquadCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllSquadCategoryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllSquadCategoryQuery(baseOptions?: Apollo.QueryHookOptions<IGetAllSquadCategoryQuery, IGetAllSquadCategoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetAllSquadCategoryQuery, IGetAllSquadCategoryQueryVariables>(GetAllSquadCategoryDocument, options);
      }
export function useGetAllSquadCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetAllSquadCategoryQuery, IGetAllSquadCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetAllSquadCategoryQuery, IGetAllSquadCategoryQueryVariables>(GetAllSquadCategoryDocument, options);
        }
export type GetAllSquadCategoryQueryHookResult = ReturnType<typeof useGetAllSquadCategoryQuery>;
export type GetAllSquadCategoryLazyQueryHookResult = ReturnType<typeof useGetAllSquadCategoryLazyQuery>;
export type GetAllSquadCategoryQueryResult = Apollo.QueryResult<IGetAllSquadCategoryQuery, IGetAllSquadCategoryQueryVariables>;
export const CreateSquadNoteDocument = gql`
    mutation createSquadNote($note: String!, $squadId: String!) {
  createSquadNote(note: $note, squadId: $squadId) {
    note
    clientId
    squadId
    userId
    createdAt
  }
}
    `;
export type ICreateSquadNoteMutationFn = Apollo.MutationFunction<ICreateSquadNoteMutation, ICreateSquadNoteMutationVariables>;

/**
 * __useCreateSquadNoteMutation__
 *
 * To run a mutation, you first call `useCreateSquadNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSquadNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSquadNoteMutation, { data, loading, error }] = useCreateSquadNoteMutation({
 *   variables: {
 *      note: // value for 'note'
 *      squadId: // value for 'squadId'
 *   },
 * });
 */
export function useCreateSquadNoteMutation(baseOptions?: Apollo.MutationHookOptions<ICreateSquadNoteMutation, ICreateSquadNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ICreateSquadNoteMutation, ICreateSquadNoteMutationVariables>(CreateSquadNoteDocument, options);
      }
export type CreateSquadNoteMutationHookResult = ReturnType<typeof useCreateSquadNoteMutation>;
export type CreateSquadNoteMutationResult = Apollo.MutationResult<ICreateSquadNoteMutation>;
export type CreateSquadNoteMutationOptions = Apollo.BaseMutationOptions<ICreateSquadNoteMutation, ICreateSquadNoteMutationVariables>;
export const UpdateSquadDocument = gql`
    mutation updateSquad($squadId: String!, $squadListDto: SquadListDto!, $clientContactDto: [CreateClientContactDto!]!) {
  updateSquad(
    squadId: $squadId
    squadListDto: $squadListDto
    clientContactDto: $clientContactDto
  ) {
    name
    clientId
    startDate
    endDate
    id
  }
}
    `;
export type IUpdateSquadMutationFn = Apollo.MutationFunction<IUpdateSquadMutation, IUpdateSquadMutationVariables>;

/**
 * __useUpdateSquadMutation__
 *
 * To run a mutation, you first call `useUpdateSquadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSquadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSquadMutation, { data, loading, error }] = useUpdateSquadMutation({
 *   variables: {
 *      squadId: // value for 'squadId'
 *      squadListDto: // value for 'squadListDto'
 *      clientContactDto: // value for 'clientContactDto'
 *   },
 * });
 */
export function useUpdateSquadMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateSquadMutation, IUpdateSquadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateSquadMutation, IUpdateSquadMutationVariables>(UpdateSquadDocument, options);
      }
export type UpdateSquadMutationHookResult = ReturnType<typeof useUpdateSquadMutation>;
export type UpdateSquadMutationResult = Apollo.MutationResult<IUpdateSquadMutation>;
export type UpdateSquadMutationOptions = Apollo.BaseMutationOptions<IUpdateSquadMutation, IUpdateSquadMutationVariables>;
export const RemoveClientContactDocument = gql`
    mutation removeClientContact($clientContactId: String!, $squadId: String!) {
  removeClientContact(clientContactId: $clientContactId, squadId: $squadId)
}
    `;
export type IRemoveClientContactMutationFn = Apollo.MutationFunction<IRemoveClientContactMutation, IRemoveClientContactMutationVariables>;

/**
 * __useRemoveClientContactMutation__
 *
 * To run a mutation, you first call `useRemoveClientContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveClientContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeClientContactMutation, { data, loading, error }] = useRemoveClientContactMutation({
 *   variables: {
 *      clientContactId: // value for 'clientContactId'
 *      squadId: // value for 'squadId'
 *   },
 * });
 */
export function useRemoveClientContactMutation(baseOptions?: Apollo.MutationHookOptions<IRemoveClientContactMutation, IRemoveClientContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IRemoveClientContactMutation, IRemoveClientContactMutationVariables>(RemoveClientContactDocument, options);
      }
export type RemoveClientContactMutationHookResult = ReturnType<typeof useRemoveClientContactMutation>;
export type RemoveClientContactMutationResult = Apollo.MutationResult<IRemoveClientContactMutation>;
export type RemoveClientContactMutationOptions = Apollo.BaseMutationOptions<IRemoveClientContactMutation, IRemoveClientContactMutationVariables>;
export const CreateOrUpdateRequestToHireDocument = gql`
    mutation createOrUpdateRequestToHire($requestToHire: JobUpdateDto!) {
  createOrUpdateRequestToHire(requestToHire: $requestToHire) {
    billingCycle
    billingRate
    createdAt
    enterprisePeopleId
    experienceLevel
    goodToHaveSkills
    id
    jobCode
    jobDescription
    jobPriority
    jobStatus
    jobType
    location
    mustHaveSkills
    noOfVacancies
    squadId
    timeZone
    title
    updatedAt
    squadStartDate
    squadEndDate
    startDate
    endDate
    vertical
    industry
    minimumBudget
    maximumBudget
    locationToBeHiredFrom
    yearsOfExperience
  }
}
    `;
export type ICreateOrUpdateRequestToHireMutationFn = Apollo.MutationFunction<ICreateOrUpdateRequestToHireMutation, ICreateOrUpdateRequestToHireMutationVariables>;

/**
 * __useCreateOrUpdateRequestToHireMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateRequestToHireMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateRequestToHireMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateRequestToHireMutation, { data, loading, error }] = useCreateOrUpdateRequestToHireMutation({
 *   variables: {
 *      requestToHire: // value for 'requestToHire'
 *   },
 * });
 */
export function useCreateOrUpdateRequestToHireMutation(baseOptions?: Apollo.MutationHookOptions<ICreateOrUpdateRequestToHireMutation, ICreateOrUpdateRequestToHireMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ICreateOrUpdateRequestToHireMutation, ICreateOrUpdateRequestToHireMutationVariables>(CreateOrUpdateRequestToHireDocument, options);
      }
export type CreateOrUpdateRequestToHireMutationHookResult = ReturnType<typeof useCreateOrUpdateRequestToHireMutation>;
export type CreateOrUpdateRequestToHireMutationResult = Apollo.MutationResult<ICreateOrUpdateRequestToHireMutation>;
export type CreateOrUpdateRequestToHireMutationOptions = Apollo.BaseMutationOptions<ICreateOrUpdateRequestToHireMutation, ICreateOrUpdateRequestToHireMutationVariables>;
export const CreateRthTemplateDocument = gql`
    mutation createRthTemplate($rthTemplate: RthTemplateDto!) {
  createRthTemplate(rthTemplate: $rthTemplate) {
    billingCycle
    billingRate
    clientSelectionProcess
    contributingMembers {
      id
      isCreator
    }
    department
    descriptionTemplateId
    endDate
    enterprisePeopleId
    evaluationCriteria
    experienceLevel
    goodToHaveSkills
    horizontal
    id
    industry
    industryBackground
    jobCode
    jobDescription
    jobId
    jobPriority
    jobStatus
    jobType
    location
    locationToBeHiredFrom
    maximumBudget
    minimumBudget
    mustHaveSkills
    noOfVacancies
    numberOfResources
    projectDescription
    saveAsDraft
    softSkills
    squadEndDate
    squadId
    squadRoleId
    squadStartDate
    startDate
    technicalInterviewPanel
    templateTitle
    ticketId
    timeZone
    title
    travelRequirements
    typeOfWork
    vertical
    yearsOfExperience
  }
}
    `;
export type ICreateRthTemplateMutationFn = Apollo.MutationFunction<ICreateRthTemplateMutation, ICreateRthTemplateMutationVariables>;

/**
 * __useCreateRthTemplateMutation__
 *
 * To run a mutation, you first call `useCreateRthTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRthTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRthTemplateMutation, { data, loading, error }] = useCreateRthTemplateMutation({
 *   variables: {
 *      rthTemplate: // value for 'rthTemplate'
 *   },
 * });
 */
export function useCreateRthTemplateMutation(baseOptions?: Apollo.MutationHookOptions<ICreateRthTemplateMutation, ICreateRthTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ICreateRthTemplateMutation, ICreateRthTemplateMutationVariables>(CreateRthTemplateDocument, options);
      }
export type CreateRthTemplateMutationHookResult = ReturnType<typeof useCreateRthTemplateMutation>;
export type CreateRthTemplateMutationResult = Apollo.MutationResult<ICreateRthTemplateMutation>;
export type CreateRthTemplateMutationOptions = Apollo.BaseMutationOptions<ICreateRthTemplateMutation, ICreateRthTemplateMutationVariables>;
export const CreateRolesInSquadDocument = gql`
    mutation createRolesInSquad($squadResources: CreateRoleDto!) {
  createRolesInSquad(squadResources: $squadResources) {
    id
    squadId
    squadResourceId
  }
}
    `;
export type ICreateRolesInSquadMutationFn = Apollo.MutationFunction<ICreateRolesInSquadMutation, ICreateRolesInSquadMutationVariables>;

/**
 * __useCreateRolesInSquadMutation__
 *
 * To run a mutation, you first call `useCreateRolesInSquadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRolesInSquadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRolesInSquadMutation, { data, loading, error }] = useCreateRolesInSquadMutation({
 *   variables: {
 *      squadResources: // value for 'squadResources'
 *   },
 * });
 */
export function useCreateRolesInSquadMutation(baseOptions?: Apollo.MutationHookOptions<ICreateRolesInSquadMutation, ICreateRolesInSquadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ICreateRolesInSquadMutation, ICreateRolesInSquadMutationVariables>(CreateRolesInSquadDocument, options);
      }
export type CreateRolesInSquadMutationHookResult = ReturnType<typeof useCreateRolesInSquadMutation>;
export type CreateRolesInSquadMutationResult = Apollo.MutationResult<ICreateRolesInSquadMutation>;
export type CreateRolesInSquadMutationOptions = Apollo.BaseMutationOptions<ICreateRolesInSquadMutation, ICreateRolesInSquadMutationVariables>;
export const UpdateRoleDetailsByResourceIdDocument = gql`
    mutation updateRoleDetailsByResourceId($squadResourceInputDto: SquadResourceInputDto!) {
  updateRoleDetailsByResourceId(squadResourceInputDto: $squadResourceInputDto) {
    squadId
    ticketId
    squadRoleId
    id
  }
}
    `;
export type IUpdateRoleDetailsByResourceIdMutationFn = Apollo.MutationFunction<IUpdateRoleDetailsByResourceIdMutation, IUpdateRoleDetailsByResourceIdMutationVariables>;

/**
 * __useUpdateRoleDetailsByResourceIdMutation__
 *
 * To run a mutation, you first call `useUpdateRoleDetailsByResourceIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRoleDetailsByResourceIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRoleDetailsByResourceIdMutation, { data, loading, error }] = useUpdateRoleDetailsByResourceIdMutation({
 *   variables: {
 *      squadResourceInputDto: // value for 'squadResourceInputDto'
 *   },
 * });
 */
export function useUpdateRoleDetailsByResourceIdMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateRoleDetailsByResourceIdMutation, IUpdateRoleDetailsByResourceIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateRoleDetailsByResourceIdMutation, IUpdateRoleDetailsByResourceIdMutationVariables>(UpdateRoleDetailsByResourceIdDocument, options);
      }
export type UpdateRoleDetailsByResourceIdMutationHookResult = ReturnType<typeof useUpdateRoleDetailsByResourceIdMutation>;
export type UpdateRoleDetailsByResourceIdMutationResult = Apollo.MutationResult<IUpdateRoleDetailsByResourceIdMutation>;
export type UpdateRoleDetailsByResourceIdMutationOptions = Apollo.BaseMutationOptions<IUpdateRoleDetailsByResourceIdMutation, IUpdateRoleDetailsByResourceIdMutationVariables>;
export const ToggleSquadPinByUserIdDocument = gql`
    mutation toggleSquadPinByUserId($squadId: String!) {
  toggleSquadPinByUserId(squadId: $squadId)
}
    `;
export type IToggleSquadPinByUserIdMutationFn = Apollo.MutationFunction<IToggleSquadPinByUserIdMutation, IToggleSquadPinByUserIdMutationVariables>;

/**
 * __useToggleSquadPinByUserIdMutation__
 *
 * To run a mutation, you first call `useToggleSquadPinByUserIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleSquadPinByUserIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleSquadPinByUserIdMutation, { data, loading, error }] = useToggleSquadPinByUserIdMutation({
 *   variables: {
 *      squadId: // value for 'squadId'
 *   },
 * });
 */
export function useToggleSquadPinByUserIdMutation(baseOptions?: Apollo.MutationHookOptions<IToggleSquadPinByUserIdMutation, IToggleSquadPinByUserIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IToggleSquadPinByUserIdMutation, IToggleSquadPinByUserIdMutationVariables>(ToggleSquadPinByUserIdDocument, options);
      }
export type ToggleSquadPinByUserIdMutationHookResult = ReturnType<typeof useToggleSquadPinByUserIdMutation>;
export type ToggleSquadPinByUserIdMutationResult = Apollo.MutationResult<IToggleSquadPinByUserIdMutation>;
export type ToggleSquadPinByUserIdMutationOptions = Apollo.BaseMutationOptions<IToggleSquadPinByUserIdMutation, IToggleSquadPinByUserIdMutationVariables>;
export const CreateInternalSquadDocument = gql`
    mutation createInternalSquad($internalSquadDto: InternalSquadDto!) {
  createInternalSquad(internalSquadDto: $internalSquadDto) {
    description
    lineOfBusiness
    name
    startDate
    endDate
    id
    type
    squadCategoryId
  }
}
    `;
export type ICreateInternalSquadMutationFn = Apollo.MutationFunction<ICreateInternalSquadMutation, ICreateInternalSquadMutationVariables>;

/**
 * __useCreateInternalSquadMutation__
 *
 * To run a mutation, you first call `useCreateInternalSquadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInternalSquadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInternalSquadMutation, { data, loading, error }] = useCreateInternalSquadMutation({
 *   variables: {
 *      internalSquadDto: // value for 'internalSquadDto'
 *   },
 * });
 */
export function useCreateInternalSquadMutation(baseOptions?: Apollo.MutationHookOptions<ICreateInternalSquadMutation, ICreateInternalSquadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ICreateInternalSquadMutation, ICreateInternalSquadMutationVariables>(CreateInternalSquadDocument, options);
      }
export type CreateInternalSquadMutationHookResult = ReturnType<typeof useCreateInternalSquadMutation>;
export type CreateInternalSquadMutationResult = Apollo.MutationResult<ICreateInternalSquadMutation>;
export type CreateInternalSquadMutationOptions = Apollo.BaseMutationOptions<ICreateInternalSquadMutation, ICreateInternalSquadMutationVariables>;
export const CreateAdditionalNoteDocument = gql`
    mutation createAdditionalNote($createAdditionalNoteDto: CreateAdditionalNoteDto!) {
  createAdditionalNote(createAdditionalNoteDto: $createAdditionalNoteDto) {
    ...NoteFragment
  }
}
    ${NoteFragmentFragmentDoc}`;
export type ICreateAdditionalNoteMutationFn = Apollo.MutationFunction<ICreateAdditionalNoteMutation, ICreateAdditionalNoteMutationVariables>;

/**
 * __useCreateAdditionalNoteMutation__
 *
 * To run a mutation, you first call `useCreateAdditionalNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAdditionalNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAdditionalNoteMutation, { data, loading, error }] = useCreateAdditionalNoteMutation({
 *   variables: {
 *      createAdditionalNoteDto: // value for 'createAdditionalNoteDto'
 *   },
 * });
 */
export function useCreateAdditionalNoteMutation(baseOptions?: Apollo.MutationHookOptions<ICreateAdditionalNoteMutation, ICreateAdditionalNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ICreateAdditionalNoteMutation, ICreateAdditionalNoteMutationVariables>(CreateAdditionalNoteDocument, options);
      }
export type CreateAdditionalNoteMutationHookResult = ReturnType<typeof useCreateAdditionalNoteMutation>;
export type CreateAdditionalNoteMutationResult = Apollo.MutationResult<ICreateAdditionalNoteMutation>;
export type CreateAdditionalNoteMutationOptions = Apollo.BaseMutationOptions<ICreateAdditionalNoteMutation, ICreateAdditionalNoteMutationVariables>;
export const UpdateAdditionalNoteDocument = gql`
    mutation updateAdditionalNote($additionalNoteId: String!, $updateAdditionalNoteDto: UpdateAdditionalNoteDto!) {
  updateAdditionalNote(
    additionalNoteId: $additionalNoteId
    updateAdditionalNoteDto: $updateAdditionalNoteDto
  ) {
    ...NoteFragment
  }
}
    ${NoteFragmentFragmentDoc}`;
export type IUpdateAdditionalNoteMutationFn = Apollo.MutationFunction<IUpdateAdditionalNoteMutation, IUpdateAdditionalNoteMutationVariables>;

/**
 * __useUpdateAdditionalNoteMutation__
 *
 * To run a mutation, you first call `useUpdateAdditionalNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAdditionalNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAdditionalNoteMutation, { data, loading, error }] = useUpdateAdditionalNoteMutation({
 *   variables: {
 *      additionalNoteId: // value for 'additionalNoteId'
 *      updateAdditionalNoteDto: // value for 'updateAdditionalNoteDto'
 *   },
 * });
 */
export function useUpdateAdditionalNoteMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateAdditionalNoteMutation, IUpdateAdditionalNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateAdditionalNoteMutation, IUpdateAdditionalNoteMutationVariables>(UpdateAdditionalNoteDocument, options);
      }
export type UpdateAdditionalNoteMutationHookResult = ReturnType<typeof useUpdateAdditionalNoteMutation>;
export type UpdateAdditionalNoteMutationResult = Apollo.MutationResult<IUpdateAdditionalNoteMutation>;
export type UpdateAdditionalNoteMutationOptions = Apollo.BaseMutationOptions<IUpdateAdditionalNoteMutation, IUpdateAdditionalNoteMutationVariables>;
export const UpdateSupervisorsDocument = gql`
    mutation UpdateSupervisors($updateSupervisorData: updateSupervisorDto!) {
  updateSupervisors(updateSupervisorData: $updateSupervisorData) {
    profileId
    supervisorProfileId
    userId
  }
}
    `;
export type IUpdateSupervisorsMutationFn = Apollo.MutationFunction<IUpdateSupervisorsMutation, IUpdateSupervisorsMutationVariables>;

/**
 * __useUpdateSupervisorsMutation__
 *
 * To run a mutation, you first call `useUpdateSupervisorsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSupervisorsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSupervisorsMutation, { data, loading, error }] = useUpdateSupervisorsMutation({
 *   variables: {
 *      updateSupervisorData: // value for 'updateSupervisorData'
 *   },
 * });
 */
export function useUpdateSupervisorsMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateSupervisorsMutation, IUpdateSupervisorsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateSupervisorsMutation, IUpdateSupervisorsMutationVariables>(UpdateSupervisorsDocument, options);
      }
export type UpdateSupervisorsMutationHookResult = ReturnType<typeof useUpdateSupervisorsMutation>;
export type UpdateSupervisorsMutationResult = Apollo.MutationResult<IUpdateSupervisorsMutation>;
export type UpdateSupervisorsMutationOptions = Apollo.BaseMutationOptions<IUpdateSupervisorsMutation, IUpdateSupervisorsMutationVariables>;
export const GetAssignedTeamMembersDocument = gql`
    query getAssignedTeamMembers($squadId: String!, $pageRequest: PageRequest!, $userSquadHistorySearchDTO: UserSquadHistorySearchDTO!) {
  getAssignedTeamMembers(
    squadId: $squadId
    pageRequest: $pageRequest
    userSquadHistorySearchDTO: $userSquadHistorySearchDTO
  ) {
    content {
      clientRate
      employeeRate
      department {
        id
        name
      }
      endDate
      id
      involvementStatus
      employeeActiveStatus
      jobType
      startDate
      experienceLevel
      name
      phasesAssigned
      rate
      rateCurrency
      rateType
      role
      requiredSkills
      userId
      involvedAs
      profileId
      profileImage
      requiredForKickOff
      employeementType
      estimatedEndDate
      squadRoleId
      technicalSkills
      involvementHistoryId
      ticketId
      ticketLink
      additionalNotes {
        ...NoteFragment
      }
    }
    pageable {
      page
      totalPages
      size
      totalElements
    }
  }
}
    ${NoteFragmentFragmentDoc}`;

/**
 * __useGetAssignedTeamMembersQuery__
 *
 * To run a query within a React component, call `useGetAssignedTeamMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssignedTeamMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssignedTeamMembersQuery({
 *   variables: {
 *      squadId: // value for 'squadId'
 *      pageRequest: // value for 'pageRequest'
 *      userSquadHistorySearchDTO: // value for 'userSquadHistorySearchDTO'
 *   },
 * });
 */
export function useGetAssignedTeamMembersQuery(baseOptions: Apollo.QueryHookOptions<IGetAssignedTeamMembersQuery, IGetAssignedTeamMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetAssignedTeamMembersQuery, IGetAssignedTeamMembersQueryVariables>(GetAssignedTeamMembersDocument, options);
      }
export function useGetAssignedTeamMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetAssignedTeamMembersQuery, IGetAssignedTeamMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetAssignedTeamMembersQuery, IGetAssignedTeamMembersQueryVariables>(GetAssignedTeamMembersDocument, options);
        }
export type GetAssignedTeamMembersQueryHookResult = ReturnType<typeof useGetAssignedTeamMembersQuery>;
export type GetAssignedTeamMembersLazyQueryHookResult = ReturnType<typeof useGetAssignedTeamMembersLazyQuery>;
export type GetAssignedTeamMembersQueryResult = Apollo.QueryResult<IGetAssignedTeamMembersQuery, IGetAssignedTeamMembersQueryVariables>;
export const GetTechViewSquadListDocument = gql`
    query getTechViewSquadList($pageRequest: PageRequest!, $squadListDto: SquadListDto!) {
  getSquadsWithFilter(pageRequest: $pageRequest, squadListDto: $squadListDto) {
    pageable {
      page
      totalPages
      size
      totalElements
    }
    content {
      dealLink
      pinned
      activeStatus
      approverFilter
      clientName
      isCompletelyAssigned
      endDate
      techStack
      name
      note
      searchText
      squadId
      startDate
      totalRequiredResources
      resourceRequiredCount
      squadresource {
        createdAt
        ticketOwner
        country
      }
      timePeriod
      totalResourceCount
      dealOwner
      defaultApprover
    }
    totalNoOfSquads
    totalUnassignedRoles
  }
}
    `;

/**
 * __useGetTechViewSquadListQuery__
 *
 * To run a query within a React component, call `useGetTechViewSquadListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTechViewSquadListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTechViewSquadListQuery({
 *   variables: {
 *      pageRequest: // value for 'pageRequest'
 *      squadListDto: // value for 'squadListDto'
 *   },
 * });
 */
export function useGetTechViewSquadListQuery(baseOptions: Apollo.QueryHookOptions<IGetTechViewSquadListQuery, IGetTechViewSquadListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetTechViewSquadListQuery, IGetTechViewSquadListQueryVariables>(GetTechViewSquadListDocument, options);
      }
export function useGetTechViewSquadListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetTechViewSquadListQuery, IGetTechViewSquadListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetTechViewSquadListQuery, IGetTechViewSquadListQueryVariables>(GetTechViewSquadListDocument, options);
        }
export type GetTechViewSquadListQueryHookResult = ReturnType<typeof useGetTechViewSquadListQuery>;
export type GetTechViewSquadListLazyQueryHookResult = ReturnType<typeof useGetTechViewSquadListLazyQuery>;
export type GetTechViewSquadListQueryResult = Apollo.QueryResult<IGetTechViewSquadListQuery, IGetTechViewSquadListQueryVariables>;
export const GetcountSquadUnassignedrolesDocument = gql`
    query getcountSquadUnassignedroles($squadListDto: SquadListDto!) {
  countSquadUnassignedroles(squadListDto: $squadListDto) {
    totalSquads
    totalUnassignedRoles
  }
}
    `;

/**
 * __useGetcountSquadUnassignedrolesQuery__
 *
 * To run a query within a React component, call `useGetcountSquadUnassignedrolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetcountSquadUnassignedrolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetcountSquadUnassignedrolesQuery({
 *   variables: {
 *      squadListDto: // value for 'squadListDto'
 *   },
 * });
 */
export function useGetcountSquadUnassignedrolesQuery(baseOptions: Apollo.QueryHookOptions<IGetcountSquadUnassignedrolesQuery, IGetcountSquadUnassignedrolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetcountSquadUnassignedrolesQuery, IGetcountSquadUnassignedrolesQueryVariables>(GetcountSquadUnassignedrolesDocument, options);
      }
export function useGetcountSquadUnassignedrolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetcountSquadUnassignedrolesQuery, IGetcountSquadUnassignedrolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetcountSquadUnassignedrolesQuery, IGetcountSquadUnassignedrolesQueryVariables>(GetcountSquadUnassignedrolesDocument, options);
        }
export type GetcountSquadUnassignedrolesQueryHookResult = ReturnType<typeof useGetcountSquadUnassignedrolesQuery>;
export type GetcountSquadUnassignedrolesLazyQueryHookResult = ReturnType<typeof useGetcountSquadUnassignedrolesLazyQuery>;
export type GetcountSquadUnassignedrolesQueryResult = Apollo.QueryResult<IGetcountSquadUnassignedrolesQuery, IGetcountSquadUnassignedrolesQueryVariables>;
export const GetClientSquadCbuListDocument = gql`
    query getClientSquadCbuList {
  getClientList {
    id
    name
  }
  getSquads {
    id
    name
  }
  getCbuLists
}
    `;

/**
 * __useGetClientSquadCbuListQuery__
 *
 * To run a query within a React component, call `useGetClientSquadCbuListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientSquadCbuListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientSquadCbuListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetClientSquadCbuListQuery(baseOptions?: Apollo.QueryHookOptions<IGetClientSquadCbuListQuery, IGetClientSquadCbuListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetClientSquadCbuListQuery, IGetClientSquadCbuListQueryVariables>(GetClientSquadCbuListDocument, options);
      }
export function useGetClientSquadCbuListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetClientSquadCbuListQuery, IGetClientSquadCbuListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetClientSquadCbuListQuery, IGetClientSquadCbuListQueryVariables>(GetClientSquadCbuListDocument, options);
        }
export type GetClientSquadCbuListQueryHookResult = ReturnType<typeof useGetClientSquadCbuListQuery>;
export type GetClientSquadCbuListLazyQueryHookResult = ReturnType<typeof useGetClientSquadCbuListLazyQuery>;
export type GetClientSquadCbuListQueryResult = Apollo.QueryResult<IGetClientSquadCbuListQuery, IGetClientSquadCbuListQueryVariables>;
export const GetSquadNoteDocument = gql`
    query getSquadNote($squadId: String!) {
  getSquadNoteBySquadId(squadId: $squadId) {
    note
    clientId
    squadId
    userId
    createdAt
  }
}
    `;

/**
 * __useGetSquadNoteQuery__
 *
 * To run a query within a React component, call `useGetSquadNoteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSquadNoteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSquadNoteQuery({
 *   variables: {
 *      squadId: // value for 'squadId'
 *   },
 * });
 */
export function useGetSquadNoteQuery(baseOptions: Apollo.QueryHookOptions<IGetSquadNoteQuery, IGetSquadNoteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetSquadNoteQuery, IGetSquadNoteQueryVariables>(GetSquadNoteDocument, options);
      }
export function useGetSquadNoteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetSquadNoteQuery, IGetSquadNoteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetSquadNoteQuery, IGetSquadNoteQueryVariables>(GetSquadNoteDocument, options);
        }
export type GetSquadNoteQueryHookResult = ReturnType<typeof useGetSquadNoteQuery>;
export type GetSquadNoteLazyQueryHookResult = ReturnType<typeof useGetSquadNoteLazyQuery>;
export type GetSquadNoteQueryResult = Apollo.QueryResult<IGetSquadNoteQuery, IGetSquadNoteQueryVariables>;
export const GetSquadResourceDetailsDocument = gql`
    query getSquadResourceDetails($squadId: String!) {
  getSquadResourceDetails(squadId: $squadId) {
    clientName
    id
    overallBudget
    usedBudget
    squadName
    squadStartDate
    squadEndDate
    countSquads
  }
}
    `;

/**
 * __useGetSquadResourceDetailsQuery__
 *
 * To run a query within a React component, call `useGetSquadResourceDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSquadResourceDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSquadResourceDetailsQuery({
 *   variables: {
 *      squadId: // value for 'squadId'
 *   },
 * });
 */
export function useGetSquadResourceDetailsQuery(baseOptions: Apollo.QueryHookOptions<IGetSquadResourceDetailsQuery, IGetSquadResourceDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetSquadResourceDetailsQuery, IGetSquadResourceDetailsQueryVariables>(GetSquadResourceDetailsDocument, options);
      }
export function useGetSquadResourceDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetSquadResourceDetailsQuery, IGetSquadResourceDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetSquadResourceDetailsQuery, IGetSquadResourceDetailsQueryVariables>(GetSquadResourceDetailsDocument, options);
        }
export type GetSquadResourceDetailsQueryHookResult = ReturnType<typeof useGetSquadResourceDetailsQuery>;
export type GetSquadResourceDetailsLazyQueryHookResult = ReturnType<typeof useGetSquadResourceDetailsLazyQuery>;
export type GetSquadResourceDetailsQueryResult = Apollo.QueryResult<IGetSquadResourceDetailsQuery, IGetSquadResourceDetailsQueryVariables>;
export const GetRolesToAssignCandidatesDocument = gql`
    query getRolesToAssignCandidates($squadId: String!, $pageRequest: PageRequest!) {
  getRolesToAssignCandidates(squadId: $squadId, pageRequest: $pageRequest) {
    totalCandidates
    assignedCandidates
    assigned {
      clientRate
      employeeRate
      department {
        id
        name
      }
      endDate
      id
      involvementStatus
      jobType
      startDate
      experienceLevel
      name
      phasesAssigned
      rate
      rateCurrency
      rateType
      role
      requiredSkills
      userId
      profileImage
      involvedAs
      profileId
      profileId
      requiredForKickOff
      employeementType
      squadRoleId
      roleDescription
      workingHour
      estimatedStartDate
      region
      createdBy
      ticketId
    }
    considered {
      endDate
      estimatedEndDate
      experienceLevel
      numberOfCandidates
      phasesAssigned
      probableCandidates {
        name
        profileId
        profileImage
      }
      rate
      requiredForKickOff
      requiredSkills
      role
      roleDescription
      squadRoleId
      startDate
      workingHour
      squadResourceId
      isRequestedForHire
      estimatedStartDate
      region
      jobType
      createdBy
      offboardingCandidate
      ticketId
    }
    unassigned {
      department
      endDate
      estimatedEndDate
      experienceLevel
      numberOfCandidates
      phasesAssigned
      probableCandidates {
        name
        profileId
        profileImage
      }
      priority
      rate
      requiredForKickOff
      requiredSkills
      role
      roleDescription
      squadRoleId
      startDate
      workingHour
      squadResourceId
      isRequestedForHire
      estimatedStartDate
      region
      jobType
      createdBy
      offboardingCandidate
      ticketId
      timeZone
      yearsOfExperience
      locationToBeHiredFrom
    }
  }
}
    `;

/**
 * __useGetRolesToAssignCandidatesQuery__
 *
 * To run a query within a React component, call `useGetRolesToAssignCandidatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRolesToAssignCandidatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRolesToAssignCandidatesQuery({
 *   variables: {
 *      squadId: // value for 'squadId'
 *      pageRequest: // value for 'pageRequest'
 *   },
 * });
 */
export function useGetRolesToAssignCandidatesQuery(baseOptions: Apollo.QueryHookOptions<IGetRolesToAssignCandidatesQuery, IGetRolesToAssignCandidatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetRolesToAssignCandidatesQuery, IGetRolesToAssignCandidatesQueryVariables>(GetRolesToAssignCandidatesDocument, options);
      }
export function useGetRolesToAssignCandidatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetRolesToAssignCandidatesQuery, IGetRolesToAssignCandidatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetRolesToAssignCandidatesQuery, IGetRolesToAssignCandidatesQueryVariables>(GetRolesToAssignCandidatesDocument, options);
        }
export type GetRolesToAssignCandidatesQueryHookResult = ReturnType<typeof useGetRolesToAssignCandidatesQuery>;
export type GetRolesToAssignCandidatesLazyQueryHookResult = ReturnType<typeof useGetRolesToAssignCandidatesLazyQuery>;
export type GetRolesToAssignCandidatesQueryResult = Apollo.QueryResult<IGetRolesToAssignCandidatesQuery, IGetRolesToAssignCandidatesQueryVariables>;
export const GetRequiredResourcesDocument = gql`
    query getRequiredResources($filter: SquadRequiredRequestDto!, $pageRequest: PageRequest!) {
  getSquadRequiredResources(filter: $filter, pageRequest: $pageRequest) {
    content {
      role
      requiredForKickOff
      probableCandidatesCount
      requiredCount
      phasesAssigned
      startDate
      endDate
      estimatedEndDate
      jobType
      squadId
      squadResourceId
      squadRoleId
      probableCandidates {
        userName
        profileImage
        squadId
        userId
      }
      rate
      estimatedStartDate
      createdAt
      ticketOwner
      ticketId
      country
      experienceLevel
      isRequestedForHire
      priority
      jobCreatedAt
      offboardingCount
      ticketLink
    }
    pageable {
      page
      size
      totalElements
      totalPages
    }
  }
}
    `;

/**
 * __useGetRequiredResourcesQuery__
 *
 * To run a query within a React component, call `useGetRequiredResourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRequiredResourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRequiredResourcesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pageRequest: // value for 'pageRequest'
 *   },
 * });
 */
export function useGetRequiredResourcesQuery(baseOptions: Apollo.QueryHookOptions<IGetRequiredResourcesQuery, IGetRequiredResourcesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetRequiredResourcesQuery, IGetRequiredResourcesQueryVariables>(GetRequiredResourcesDocument, options);
      }
export function useGetRequiredResourcesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetRequiredResourcesQuery, IGetRequiredResourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetRequiredResourcesQuery, IGetRequiredResourcesQueryVariables>(GetRequiredResourcesDocument, options);
        }
export type GetRequiredResourcesQueryHookResult = ReturnType<typeof useGetRequiredResourcesQuery>;
export type GetRequiredResourcesLazyQueryHookResult = ReturnType<typeof useGetRequiredResourcesLazyQuery>;
export type GetRequiredResourcesQueryResult = Apollo.QueryResult<IGetRequiredResourcesQuery, IGetRequiredResourcesQueryVariables>;
export const ListResourcesDocument = gql`
    query ListResources($filter: EligibleCandidatesFilterDto!, $pageRequest: PageRequest!) {
  listResources(filter: $filter, pageRequest: $pageRequest) {
    content {
      consideredCandidate
      jobType
      level
      name
      department
      subDepartment
      resumeUrl
      resourceStatus
      userSquadHistory {
        _id
        involvementStatus
        involvedAs
        jobType
        endDate
        squadName
        squadId
        joinedDate
        allocatedHours
        squadRoleId
      }
      userSquadHistoryUnfiltered {
        squadName
        endDate
        squadId
        involvedAs
        involvementStatus
        jobType
        involvementHistory {
          endDate
          involvedAs
          involvementStatus
          jobType
          allocatedHours
        }
      }
      overallStatus {
        clientName
        involvementStatus
        roleInSquad
        squadName
        squadRoleId
      }
      profileId
      profileImage
      rate
      role
      skills
      squadStatus
      employeeType
      userId
      beingReplaced
      currentSquads {
        involvedAs
        jobType
        squadName
        squadId
        endDate
        squadRoleId
        allocatedHours
      }
      availabilityStatus
      deploymentStatus
      matchInfo {
        deploymentMatchScore
        skillMatchScore
        departmentMatchScore
        levelMatchScore
        countryMatchScore
        matchType
        overallScore
      }
    }
    pageable {
      page
      size
      totalElements
      totalPages
    }
    skillForAdvancedFilter
  }
}
    `;

/**
 * __useListResourcesQuery__
 *
 * To run a query within a React component, call `useListResourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListResourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListResourcesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pageRequest: // value for 'pageRequest'
 *   },
 * });
 */
export function useListResourcesQuery(baseOptions: Apollo.QueryHookOptions<IListResourcesQuery, IListResourcesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IListResourcesQuery, IListResourcesQueryVariables>(ListResourcesDocument, options);
      }
export function useListResourcesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IListResourcesQuery, IListResourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IListResourcesQuery, IListResourcesQueryVariables>(ListResourcesDocument, options);
        }
export type ListResourcesQueryHookResult = ReturnType<typeof useListResourcesQuery>;
export type ListResourcesLazyQueryHookResult = ReturnType<typeof useListResourcesLazyQuery>;
export type ListResourcesQueryResult = Apollo.QueryResult<IListResourcesQuery, IListResourcesQueryVariables>;
export const ListNotesDocument = gql`
    query listNotes($userId: String!) {
  listNotes(userId: $userId) {
    _id
    userId
    profileId
    squadId
    clientId
    involvementStatus
    joinedDate
    notes {
      note
    }
    client {
      _id
      name
    }
    squad {
      _id
      name
    }
  }
}
    `;

/**
 * __useListNotesQuery__
 *
 * To run a query within a React component, call `useListNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListNotesQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useListNotesQuery(baseOptions: Apollo.QueryHookOptions<IListNotesQuery, IListNotesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IListNotesQuery, IListNotesQueryVariables>(ListNotesDocument, options);
      }
export function useListNotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IListNotesQuery, IListNotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IListNotesQuery, IListNotesQueryVariables>(ListNotesDocument, options);
        }
export type ListNotesQueryHookResult = ReturnType<typeof useListNotesQuery>;
export type ListNotesLazyQueryHookResult = ReturnType<typeof useListNotesLazyQuery>;
export type ListNotesQueryResult = Apollo.QueryResult<IListNotesQuery, IListNotesQueryVariables>;
export const GetRolesInSquadDocument = gql`
    query getRolesInSquad($squadId: String!) {
  getRolesInSquad(squadId: $squadId)
}
    `;

/**
 * __useGetRolesInSquadQuery__
 *
 * To run a query within a React component, call `useGetRolesInSquadQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRolesInSquadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRolesInSquadQuery({
 *   variables: {
 *      squadId: // value for 'squadId'
 *   },
 * });
 */
export function useGetRolesInSquadQuery(baseOptions: Apollo.QueryHookOptions<IGetRolesInSquadQuery, IGetRolesInSquadQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetRolesInSquadQuery, IGetRolesInSquadQueryVariables>(GetRolesInSquadDocument, options);
      }
export function useGetRolesInSquadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetRolesInSquadQuery, IGetRolesInSquadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetRolesInSquadQuery, IGetRolesInSquadQueryVariables>(GetRolesInSquadDocument, options);
        }
export type GetRolesInSquadQueryHookResult = ReturnType<typeof useGetRolesInSquadQuery>;
export type GetRolesInSquadLazyQueryHookResult = ReturnType<typeof useGetRolesInSquadLazyQuery>;
export type GetRolesInSquadQueryResult = Apollo.QueryResult<IGetRolesInSquadQuery, IGetRolesInSquadQueryVariables>;
export const GetPhasesInSquadDocument = gql`
    query getPhasesInSquad($squadId: String!) {
  getPhasesInSquad(squadId: $squadId)
}
    `;

/**
 * __useGetPhasesInSquadQuery__
 *
 * To run a query within a React component, call `useGetPhasesInSquadQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPhasesInSquadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPhasesInSquadQuery({
 *   variables: {
 *      squadId: // value for 'squadId'
 *   },
 * });
 */
export function useGetPhasesInSquadQuery(baseOptions: Apollo.QueryHookOptions<IGetPhasesInSquadQuery, IGetPhasesInSquadQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetPhasesInSquadQuery, IGetPhasesInSquadQueryVariables>(GetPhasesInSquadDocument, options);
      }
export function useGetPhasesInSquadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetPhasesInSquadQuery, IGetPhasesInSquadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetPhasesInSquadQuery, IGetPhasesInSquadQueryVariables>(GetPhasesInSquadDocument, options);
        }
export type GetPhasesInSquadQueryHookResult = ReturnType<typeof useGetPhasesInSquadQuery>;
export type GetPhasesInSquadLazyQueryHookResult = ReturnType<typeof useGetPhasesInSquadLazyQuery>;
export type GetPhasesInSquadQueryResult = Apollo.QueryResult<IGetPhasesInSquadQuery, IGetPhasesInSquadQueryVariables>;
export const GetRoleToAssignCandidateDocument = gql`
    query getRoleToAssignCandidate($squadId: String!, $squadRoleId: String!) {
  getRoleToAssignCandidate(squadId: $squadId, squadRoleId: $squadRoleId) {
    endDate
    experienceLevel
    numberOfCandidates
    phasesAssigned
    probableCandidates {
      name
      profileId
      profileImage
    }
    rate
    requiredForKickOff
    experienceLevel
    requiredSkills
    role
    roleDescription
    squadRoleId
    startDate
    workingHour
    estimatedStartDate
    region
    jobType
    createdBy
  }
}
    `;

/**
 * __useGetRoleToAssignCandidateQuery__
 *
 * To run a query within a React component, call `useGetRoleToAssignCandidateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRoleToAssignCandidateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRoleToAssignCandidateQuery({
 *   variables: {
 *      squadId: // value for 'squadId'
 *      squadRoleId: // value for 'squadRoleId'
 *   },
 * });
 */
export function useGetRoleToAssignCandidateQuery(baseOptions: Apollo.QueryHookOptions<IGetRoleToAssignCandidateQuery, IGetRoleToAssignCandidateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetRoleToAssignCandidateQuery, IGetRoleToAssignCandidateQueryVariables>(GetRoleToAssignCandidateDocument, options);
      }
export function useGetRoleToAssignCandidateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetRoleToAssignCandidateQuery, IGetRoleToAssignCandidateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetRoleToAssignCandidateQuery, IGetRoleToAssignCandidateQueryVariables>(GetRoleToAssignCandidateDocument, options);
        }
export type GetRoleToAssignCandidateQueryHookResult = ReturnType<typeof useGetRoleToAssignCandidateQuery>;
export type GetRoleToAssignCandidateLazyQueryHookResult = ReturnType<typeof useGetRoleToAssignCandidateLazyQuery>;
export type GetRoleToAssignCandidateQueryResult = Apollo.QueryResult<IGetRoleToAssignCandidateQuery, IGetRoleToAssignCandidateQueryVariables>;
export const ConsideredResourcesDocument = gql`
    query consideredResources($filter: EligibleCandidatesFilterDto!, $pageRequest: PageRequest!) {
  consideredResources(filter: $filter, pageRequest: $pageRequest) {
    content {
      consideredCandidate
      jobType
      level
      name
      overallStatus {
        clientName
        involvementStatus
        roleInSquad
        squadName
        squadRoleId
      }
      profileId
      profileImage
      rate
      role
      skillMatchedPercent
      skills
      squadStatus
      employeeType
      userId
      roles
      designation
      resumeUrl
    }
    pageable {
      page
      size
      totalElements
      totalPages
    }
  }
}
    `;

/**
 * __useConsideredResourcesQuery__
 *
 * To run a query within a React component, call `useConsideredResourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsideredResourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsideredResourcesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pageRequest: // value for 'pageRequest'
 *   },
 * });
 */
export function useConsideredResourcesQuery(baseOptions: Apollo.QueryHookOptions<IConsideredResourcesQuery, IConsideredResourcesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IConsideredResourcesQuery, IConsideredResourcesQueryVariables>(ConsideredResourcesDocument, options);
      }
export function useConsideredResourcesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IConsideredResourcesQuery, IConsideredResourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IConsideredResourcesQuery, IConsideredResourcesQueryVariables>(ConsideredResourcesDocument, options);
        }
export type ConsideredResourcesQueryHookResult = ReturnType<typeof useConsideredResourcesQuery>;
export type ConsideredResourcesLazyQueryHookResult = ReturnType<typeof useConsideredResourcesLazyQuery>;
export type ConsideredResourcesQueryResult = Apollo.QueryResult<IConsideredResourcesQuery, IConsideredResourcesQueryVariables>;
export const GetEmployeePersonalInfoDocument = gql`
    query getEmployeePersonalInfo($userId: String!, $squadRoleId: String!) {
  getEmployeePersonalInfo(userId: $userId, squadRoleId: $squadRoleId) {
    userId
    profileId
    squadStatus
    availableSince
    relevantExperience {
      month
      year
    }
    overAllExperience {
      month
      year
    }
    personalInfo {
      countryOfResidence
      availabilityStatus
      region
      email
      filename
      joinedDate
      name
      phoneNumber
      resumeUrl
      role
      timeZone
      githubUrl
      linkedinUrl
      profileImage
      gender
      resignDate
    }
    experience {
      roles
      yearsOfExperienceInRoles {
        role
        yearsOfExperience
      }
    }
    paymentOption {
      billingAmount
      billingType
    }
    profileId
    skills {
      mostProficientTechnologies
      softSkills
      somewhatProficientTechnologies
    }
    assignedDevices {
      assignedDate
      _id
      deviceCode
      deviceDescription
      deviceName
    }
    squads {
      squadId
      squadHistoryId
      squadName
      joinedDate
      allocatedHours
      squadType
      endDate
      involvedAs
      involvementStatus
      clientId
      clientName
      roleInSquad
      employeeBillingRate
      clientBillingRate
      jobType
      squadRoleId
      involvementHistory {
        involvedAs
        involvementStatus
        jobType
        modifiedBy
        modifiedOn
        joinedDate
        endDate
        role
      }
      additionalNotes {
        ...NoteFragment
      }
    }
    supervisors {
      email
      fullname
      designationName
      departmentName
    }
    jobExperience {
      companyName
      currentlyEmployed
      jobEndDate {
        month
        year
      }
      jobLocation
      jobStartDate {
        month
        year
      }
      jobTitle
      rolesAndResponsibility
    }
    education {
      completedOn {
        month
        year
      }
      currentlyStudying
      degree
      fieldOfStudy
      isEducationFormCompleted
      joinedOn {
        month
        year
      }
      levelOfEducation
      school
    }
    certificates {
      certificateID
      certificateTitle
      completedOn {
        month
        year
      }
      currentlyStudying
      isCertificateFormCompleted
      issuingInstitutionOrganization
      joinedOn {
        month
        year
      }
      url
    }
    workExperience {
      company
      companyAddress
      profileId
      userId
      workExperienceId
      workHistory {
        details
        endDate
        role
        jobTitle
        startDate
        workHistoryId
      }
    }
    currentWorkInfo {
      department {
        id
        name
      }
      deploymentStatus
      designation
      employeeId
      jobType
      level
      mainDepartment
      roles
      workShift
      optionExploring
    }
  }
}
    ${NoteFragmentFragmentDoc}`;

/**
 * __useGetEmployeePersonalInfoQuery__
 *
 * To run a query within a React component, call `useGetEmployeePersonalInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeePersonalInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeePersonalInfoQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      squadRoleId: // value for 'squadRoleId'
 *   },
 * });
 */
export function useGetEmployeePersonalInfoQuery(baseOptions: Apollo.QueryHookOptions<IGetEmployeePersonalInfoQuery, IGetEmployeePersonalInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetEmployeePersonalInfoQuery, IGetEmployeePersonalInfoQueryVariables>(GetEmployeePersonalInfoDocument, options);
      }
export function useGetEmployeePersonalInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetEmployeePersonalInfoQuery, IGetEmployeePersonalInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetEmployeePersonalInfoQuery, IGetEmployeePersonalInfoQueryVariables>(GetEmployeePersonalInfoDocument, options);
        }
export type GetEmployeePersonalInfoQueryHookResult = ReturnType<typeof useGetEmployeePersonalInfoQuery>;
export type GetEmployeePersonalInfoLazyQueryHookResult = ReturnType<typeof useGetEmployeePersonalInfoLazyQuery>;
export type GetEmployeePersonalInfoQueryResult = Apollo.QueryResult<IGetEmployeePersonalInfoQuery, IGetEmployeePersonalInfoQueryVariables>;
export const GetCbuListDocument = gql`
    query getCbuList {
  getCbuLists
}
    `;

/**
 * __useGetCbuListQuery__
 *
 * To run a query within a React component, call `useGetCbuListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCbuListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCbuListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCbuListQuery(baseOptions?: Apollo.QueryHookOptions<IGetCbuListQuery, IGetCbuListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetCbuListQuery, IGetCbuListQueryVariables>(GetCbuListDocument, options);
      }
export function useGetCbuListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetCbuListQuery, IGetCbuListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetCbuListQuery, IGetCbuListQueryVariables>(GetCbuListDocument, options);
        }
export type GetCbuListQueryHookResult = ReturnType<typeof useGetCbuListQuery>;
export type GetCbuListLazyQueryHookResult = ReturnType<typeof useGetCbuListLazyQuery>;
export type GetCbuListQueryResult = Apollo.QueryResult<IGetCbuListQuery, IGetCbuListQueryVariables>;
export const GetResourcesToAssignApprovesDocument = gql`
    query getResourcesToAssignApproves($listApproversFilterDto: listApproversFilterDto) {
  listResourcesToAssignApprovers(listApproversFilter: $listApproversFilterDto) {
    designation
    userId
    name
    email
    isApproverAssigned
  }
}
    `;

/**
 * __useGetResourcesToAssignApprovesQuery__
 *
 * To run a query within a React component, call `useGetResourcesToAssignApprovesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetResourcesToAssignApprovesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetResourcesToAssignApprovesQuery({
 *   variables: {
 *      listApproversFilterDto: // value for 'listApproversFilterDto'
 *   },
 * });
 */
export function useGetResourcesToAssignApprovesQuery(baseOptions?: Apollo.QueryHookOptions<IGetResourcesToAssignApprovesQuery, IGetResourcesToAssignApprovesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetResourcesToAssignApprovesQuery, IGetResourcesToAssignApprovesQueryVariables>(GetResourcesToAssignApprovesDocument, options);
      }
export function useGetResourcesToAssignApprovesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetResourcesToAssignApprovesQuery, IGetResourcesToAssignApprovesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetResourcesToAssignApprovesQuery, IGetResourcesToAssignApprovesQueryVariables>(GetResourcesToAssignApprovesDocument, options);
        }
export type GetResourcesToAssignApprovesQueryHookResult = ReturnType<typeof useGetResourcesToAssignApprovesQuery>;
export type GetResourcesToAssignApprovesLazyQueryHookResult = ReturnType<typeof useGetResourcesToAssignApprovesLazyQuery>;
export type GetResourcesToAssignApprovesQueryResult = Apollo.QueryResult<IGetResourcesToAssignApprovesQuery, IGetResourcesToAssignApprovesQueryVariables>;
export const GetSquadAssignedResourcesBreakdownDocument = gql`
    query getSquadAssignedResourcesBreakdown($squadId: String!) {
  getSquadAssignedResourcesBreakdown(squadId: $squadId) {
    LEVEL
    barChartData {
      consultantEmployeeList {
        levelData {
          count
          level
        }
        role
      }
      department
      fuseMachineEmployeeList {
        levelData {
          count
          level
        }
        role
      }
    }
  }
}
    `;

/**
 * __useGetSquadAssignedResourcesBreakdownQuery__
 *
 * To run a query within a React component, call `useGetSquadAssignedResourcesBreakdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSquadAssignedResourcesBreakdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSquadAssignedResourcesBreakdownQuery({
 *   variables: {
 *      squadId: // value for 'squadId'
 *   },
 * });
 */
export function useGetSquadAssignedResourcesBreakdownQuery(baseOptions: Apollo.QueryHookOptions<IGetSquadAssignedResourcesBreakdownQuery, IGetSquadAssignedResourcesBreakdownQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetSquadAssignedResourcesBreakdownQuery, IGetSquadAssignedResourcesBreakdownQueryVariables>(GetSquadAssignedResourcesBreakdownDocument, options);
      }
export function useGetSquadAssignedResourcesBreakdownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetSquadAssignedResourcesBreakdownQuery, IGetSquadAssignedResourcesBreakdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetSquadAssignedResourcesBreakdownQuery, IGetSquadAssignedResourcesBreakdownQueryVariables>(GetSquadAssignedResourcesBreakdownDocument, options);
        }
export type GetSquadAssignedResourcesBreakdownQueryHookResult = ReturnType<typeof useGetSquadAssignedResourcesBreakdownQuery>;
export type GetSquadAssignedResourcesBreakdownLazyQueryHookResult = ReturnType<typeof useGetSquadAssignedResourcesBreakdownLazyQuery>;
export type GetSquadAssignedResourcesBreakdownQueryResult = Apollo.QueryResult<IGetSquadAssignedResourcesBreakdownQuery, IGetSquadAssignedResourcesBreakdownQueryVariables>;
export const OffboardingAndReplaceResourcesDocument = gql`
    query offboardingAndReplaceResources($squadRoleId: String!) {
  offboardingAndReplaceResources(squadRoleId: $squadRoleId) {
    jobType
    level
    name
    profileId
    profileImage
    rate
    role
    skillMatchedPercent
    skills
    squadStatus
    employeeType
    userId
    roles
    designation
    squadStatus
    prevEmpEndDate
    prevEmpStartDate
    __typename
  }
  __typename
}
    `;

/**
 * __useOffboardingAndReplaceResourcesQuery__
 *
 * To run a query within a React component, call `useOffboardingAndReplaceResourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOffboardingAndReplaceResourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOffboardingAndReplaceResourcesQuery({
 *   variables: {
 *      squadRoleId: // value for 'squadRoleId'
 *   },
 * });
 */
export function useOffboardingAndReplaceResourcesQuery(baseOptions: Apollo.QueryHookOptions<IOffboardingAndReplaceResourcesQuery, IOffboardingAndReplaceResourcesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IOffboardingAndReplaceResourcesQuery, IOffboardingAndReplaceResourcesQueryVariables>(OffboardingAndReplaceResourcesDocument, options);
      }
export function useOffboardingAndReplaceResourcesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IOffboardingAndReplaceResourcesQuery, IOffboardingAndReplaceResourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IOffboardingAndReplaceResourcesQuery, IOffboardingAndReplaceResourcesQueryVariables>(OffboardingAndReplaceResourcesDocument, options);
        }
export type OffboardingAndReplaceResourcesQueryHookResult = ReturnType<typeof useOffboardingAndReplaceResourcesQuery>;
export type OffboardingAndReplaceResourcesLazyQueryHookResult = ReturnType<typeof useOffboardingAndReplaceResourcesLazyQuery>;
export type OffboardingAndReplaceResourcesQueryResult = Apollo.QueryResult<IOffboardingAndReplaceResourcesQuery, IOffboardingAndReplaceResourcesQueryVariables>;
export const GetAllVerticalsDocument = gql`
    query getAllVerticals {
  getAllVerticals {
    id
    name
  }
}
    `;

/**
 * __useGetAllVerticalsQuery__
 *
 * To run a query within a React component, call `useGetAllVerticalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllVerticalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllVerticalsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllVerticalsQuery(baseOptions?: Apollo.QueryHookOptions<IGetAllVerticalsQuery, IGetAllVerticalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetAllVerticalsQuery, IGetAllVerticalsQueryVariables>(GetAllVerticalsDocument, options);
      }
export function useGetAllVerticalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetAllVerticalsQuery, IGetAllVerticalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetAllVerticalsQuery, IGetAllVerticalsQueryVariables>(GetAllVerticalsDocument, options);
        }
export type GetAllVerticalsQueryHookResult = ReturnType<typeof useGetAllVerticalsQuery>;
export type GetAllVerticalsLazyQueryHookResult = ReturnType<typeof useGetAllVerticalsLazyQuery>;
export type GetAllVerticalsQueryResult = Apollo.QueryResult<IGetAllVerticalsQuery, IGetAllVerticalsQueryVariables>;
export const GetAllSquadsTechStackDocument = gql`
    query getAllSquadsTechStack {
  getAllSquadsTechStack
}
    `;

/**
 * __useGetAllSquadsTechStackQuery__
 *
 * To run a query within a React component, call `useGetAllSquadsTechStackQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllSquadsTechStackQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllSquadsTechStackQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllSquadsTechStackQuery(baseOptions?: Apollo.QueryHookOptions<IGetAllSquadsTechStackQuery, IGetAllSquadsTechStackQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetAllSquadsTechStackQuery, IGetAllSquadsTechStackQueryVariables>(GetAllSquadsTechStackDocument, options);
      }
export function useGetAllSquadsTechStackLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetAllSquadsTechStackQuery, IGetAllSquadsTechStackQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetAllSquadsTechStackQuery, IGetAllSquadsTechStackQueryVariables>(GetAllSquadsTechStackDocument, options);
        }
export type GetAllSquadsTechStackQueryHookResult = ReturnType<typeof useGetAllSquadsTechStackQuery>;
export type GetAllSquadsTechStackLazyQueryHookResult = ReturnType<typeof useGetAllSquadsTechStackLazyQuery>;
export type GetAllSquadsTechStackQueryResult = Apollo.QueryResult<IGetAllSquadsTechStackQuery, IGetAllSquadsTechStackQueryVariables>;
export const GetAllLineOfBusinessDocument = gql`
    query getAllLineOfBusiness {
  getAllLineOfBusiness {
    name
  }
}
    `;

/**
 * __useGetAllLineOfBusinessQuery__
 *
 * To run a query within a React component, call `useGetAllLineOfBusinessQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllLineOfBusinessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllLineOfBusinessQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllLineOfBusinessQuery(baseOptions?: Apollo.QueryHookOptions<IGetAllLineOfBusinessQuery, IGetAllLineOfBusinessQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetAllLineOfBusinessQuery, IGetAllLineOfBusinessQueryVariables>(GetAllLineOfBusinessDocument, options);
      }
export function useGetAllLineOfBusinessLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetAllLineOfBusinessQuery, IGetAllLineOfBusinessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetAllLineOfBusinessQuery, IGetAllLineOfBusinessQueryVariables>(GetAllLineOfBusinessDocument, options);
        }
export type GetAllLineOfBusinessQueryHookResult = ReturnType<typeof useGetAllLineOfBusinessQuery>;
export type GetAllLineOfBusinessLazyQueryHookResult = ReturnType<typeof useGetAllLineOfBusinessLazyQuery>;
export type GetAllLineOfBusinessQueryResult = Apollo.QueryResult<IGetAllLineOfBusinessQuery, IGetAllLineOfBusinessQueryVariables>;
export const GetRolesToAssignDocument = gql`
    query getRolesToAssign {
  getRolesToAssign
}
    `;

/**
 * __useGetRolesToAssignQuery__
 *
 * To run a query within a React component, call `useGetRolesToAssignQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRolesToAssignQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRolesToAssignQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRolesToAssignQuery(baseOptions?: Apollo.QueryHookOptions<IGetRolesToAssignQuery, IGetRolesToAssignQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetRolesToAssignQuery, IGetRolesToAssignQueryVariables>(GetRolesToAssignDocument, options);
      }
export function useGetRolesToAssignLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetRolesToAssignQuery, IGetRolesToAssignQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetRolesToAssignQuery, IGetRolesToAssignQueryVariables>(GetRolesToAssignDocument, options);
        }
export type GetRolesToAssignQueryHookResult = ReturnType<typeof useGetRolesToAssignQuery>;
export type GetRolesToAssignLazyQueryHookResult = ReturnType<typeof useGetRolesToAssignLazyQuery>;
export type GetRolesToAssignQueryResult = Apollo.QueryResult<IGetRolesToAssignQuery, IGetRolesToAssignQueryVariables>;
export const ExportCsvAssignedResourcesDocument = gql`
    query exportCsvAssignedResources($pageRequest: PageRequest!, $squadId: String!, $userSquadHistorySearchDTO: UserSquadHistorySearchDTO!) {
  exportCsvAssignedResources(
    pageRequest: $pageRequest
    squadId: $squadId
    userSquadHistorySearchDTO: $userSquadHistorySearchDTO
  )
}
    `;

/**
 * __useExportCsvAssignedResourcesQuery__
 *
 * To run a query within a React component, call `useExportCsvAssignedResourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportCsvAssignedResourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportCsvAssignedResourcesQuery({
 *   variables: {
 *      pageRequest: // value for 'pageRequest'
 *      squadId: // value for 'squadId'
 *      userSquadHistorySearchDTO: // value for 'userSquadHistorySearchDTO'
 *   },
 * });
 */
export function useExportCsvAssignedResourcesQuery(baseOptions: Apollo.QueryHookOptions<IExportCsvAssignedResourcesQuery, IExportCsvAssignedResourcesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IExportCsvAssignedResourcesQuery, IExportCsvAssignedResourcesQueryVariables>(ExportCsvAssignedResourcesDocument, options);
      }
export function useExportCsvAssignedResourcesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IExportCsvAssignedResourcesQuery, IExportCsvAssignedResourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IExportCsvAssignedResourcesQuery, IExportCsvAssignedResourcesQueryVariables>(ExportCsvAssignedResourcesDocument, options);
        }
export type ExportCsvAssignedResourcesQueryHookResult = ReturnType<typeof useExportCsvAssignedResourcesQuery>;
export type ExportCsvAssignedResourcesLazyQueryHookResult = ReturnType<typeof useExportCsvAssignedResourcesLazyQuery>;
export type ExportCsvAssignedResourcesQueryResult = Apollo.QueryResult<IExportCsvAssignedResourcesQuery, IExportCsvAssignedResourcesQueryVariables>;
export const FindAllAdditionalNotesByUserSquadHistoryIdDocument = gql`
    query findAllAdditionalNotesByUserSquadHistoryId($involvementHistoryId: String, $userSquadHistoryIds: [String!]) {
  findAllAdditionalNotesByUserSquadHistoryId(
    involvementHistoryId: $involvementHistoryId
    userSquadHistoryIds: $userSquadHistoryIds
  ) {
    ...NoteFragment
  }
}
    ${NoteFragmentFragmentDoc}`;

/**
 * __useFindAllAdditionalNotesByUserSquadHistoryIdQuery__
 *
 * To run a query within a React component, call `useFindAllAdditionalNotesByUserSquadHistoryIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllAdditionalNotesByUserSquadHistoryIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllAdditionalNotesByUserSquadHistoryIdQuery({
 *   variables: {
 *      involvementHistoryId: // value for 'involvementHistoryId'
 *      userSquadHistoryIds: // value for 'userSquadHistoryIds'
 *   },
 * });
 */
export function useFindAllAdditionalNotesByUserSquadHistoryIdQuery(baseOptions?: Apollo.QueryHookOptions<IFindAllAdditionalNotesByUserSquadHistoryIdQuery, IFindAllAdditionalNotesByUserSquadHistoryIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IFindAllAdditionalNotesByUserSquadHistoryIdQuery, IFindAllAdditionalNotesByUserSquadHistoryIdQueryVariables>(FindAllAdditionalNotesByUserSquadHistoryIdDocument, options);
      }
export function useFindAllAdditionalNotesByUserSquadHistoryIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IFindAllAdditionalNotesByUserSquadHistoryIdQuery, IFindAllAdditionalNotesByUserSquadHistoryIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IFindAllAdditionalNotesByUserSquadHistoryIdQuery, IFindAllAdditionalNotesByUserSquadHistoryIdQueryVariables>(FindAllAdditionalNotesByUserSquadHistoryIdDocument, options);
        }
export type FindAllAdditionalNotesByUserSquadHistoryIdQueryHookResult = ReturnType<typeof useFindAllAdditionalNotesByUserSquadHistoryIdQuery>;
export type FindAllAdditionalNotesByUserSquadHistoryIdLazyQueryHookResult = ReturnType<typeof useFindAllAdditionalNotesByUserSquadHistoryIdLazyQuery>;
export type FindAllAdditionalNotesByUserSquadHistoryIdQueryResult = Apollo.QueryResult<IFindAllAdditionalNotesByUserSquadHistoryIdQuery, IFindAllAdditionalNotesByUserSquadHistoryIdQueryVariables>;
export const GetRequiredResourceRolesInSquadDocument = gql`
    query getRequiredResourceRolesInSquad($squadId: String!) {
  getRequiredResourceRolesInSquad(squadId: $squadId)
}
    `;

/**
 * __useGetRequiredResourceRolesInSquadQuery__
 *
 * To run a query within a React component, call `useGetRequiredResourceRolesInSquadQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRequiredResourceRolesInSquadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRequiredResourceRolesInSquadQuery({
 *   variables: {
 *      squadId: // value for 'squadId'
 *   },
 * });
 */
export function useGetRequiredResourceRolesInSquadQuery(baseOptions: Apollo.QueryHookOptions<IGetRequiredResourceRolesInSquadQuery, IGetRequiredResourceRolesInSquadQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetRequiredResourceRolesInSquadQuery, IGetRequiredResourceRolesInSquadQueryVariables>(GetRequiredResourceRolesInSquadDocument, options);
      }
export function useGetRequiredResourceRolesInSquadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetRequiredResourceRolesInSquadQuery, IGetRequiredResourceRolesInSquadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetRequiredResourceRolesInSquadQuery, IGetRequiredResourceRolesInSquadQueryVariables>(GetRequiredResourceRolesInSquadDocument, options);
        }
export type GetRequiredResourceRolesInSquadQueryHookResult = ReturnType<typeof useGetRequiredResourceRolesInSquadQuery>;
export type GetRequiredResourceRolesInSquadLazyQueryHookResult = ReturnType<typeof useGetRequiredResourceRolesInSquadLazyQuery>;
export type GetRequiredResourceRolesInSquadQueryResult = Apollo.QueryResult<IGetRequiredResourceRolesInSquadQuery, IGetRequiredResourceRolesInSquadQueryVariables>;
export const GetRthTemplateDocument = gql`
    query getRthTemplate($searchKey: String!) {
  getRthTemplate(searchKey: $searchKey) {
    billingCycle
    billingRate
    clientSelectionProcess
    contributingMembers {
      id
      isCreator
    }
    department
    descriptionTemplateId
    endDate
    enterprisePeopleId
    evaluationCriteria
    experienceLevel
    goodToHaveSkills
    horizontal
    id
    industry
    industryBackground
    jobCode
    jobDescription
    jobId
    jobPriority
    jobStatus
    jobType
    location
    locationToBeHiredFrom
    maximumBudget
    minimumBudget
    mustHaveSkills
    noOfVacancies
    numberOfResources
    projectDescription
    saveAsDraft
    softSkills
    squadEndDate
    squadId
    squadRoleId
    squadStartDate
    startDate
    technicalInterviewPanel
    templateTitle
    ticketId
    timeZone
    title
    travelRequirements
    typeOfWork
    vertical
    yearsOfExperience
    previousReasonsForCandidateDisqualification
  }
}
    `;

/**
 * __useGetRthTemplateQuery__
 *
 * To run a query within a React component, call `useGetRthTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRthTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRthTemplateQuery({
 *   variables: {
 *      searchKey: // value for 'searchKey'
 *   },
 * });
 */
export function useGetRthTemplateQuery(baseOptions: Apollo.QueryHookOptions<IGetRthTemplateQuery, IGetRthTemplateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetRthTemplateQuery, IGetRthTemplateQueryVariables>(GetRthTemplateDocument, options);
      }
export function useGetRthTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetRthTemplateQuery, IGetRthTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetRthTemplateQuery, IGetRthTemplateQueryVariables>(GetRthTemplateDocument, options);
        }
export type GetRthTemplateQueryHookResult = ReturnType<typeof useGetRthTemplateQuery>;
export type GetRthTemplateLazyQueryHookResult = ReturnType<typeof useGetRthTemplateLazyQuery>;
export type GetRthTemplateQueryResult = Apollo.QueryResult<IGetRthTemplateQuery, IGetRthTemplateQueryVariables>;
export const GetRoleDetailsBySquadRoleIdDocument = gql`
    query getRoleDetailsBySquadRoleId($squadId: String!, $squadRoleId: String!) {
  getRoleDetailsBySquadRoleId(squadId: $squadId, squadRoleId: $squadRoleId) {
    createdBy
    department
    endDate
    estimatedEndDate
    estimatedStartDate
    experienceLevel
    isJobTemplateSaved
    isRequestedForHire
    jobType
    locationToBeHiredFrom
    numberOfCandidates
    offboardingCandidate
    phasesAssigned
    priority
    probableCandidates {
      employeeId
      name
      profileId
      profileImage
      userId
    }
    rate
    region
    requiredForKickOff
    requiredSkills
    role
    roleDescription
    squadResourceId
    squadRoleId
    startDate
    ticketId
    timeZone
    workingHour
    yearsOfExperience
    softSkills
    goodToHaveSkills
  }
}
    `;

/**
 * __useGetRoleDetailsBySquadRoleIdQuery__
 *
 * To run a query within a React component, call `useGetRoleDetailsBySquadRoleIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRoleDetailsBySquadRoleIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRoleDetailsBySquadRoleIdQuery({
 *   variables: {
 *      squadId: // value for 'squadId'
 *      squadRoleId: // value for 'squadRoleId'
 *   },
 * });
 */
export function useGetRoleDetailsBySquadRoleIdQuery(baseOptions: Apollo.QueryHookOptions<IGetRoleDetailsBySquadRoleIdQuery, IGetRoleDetailsBySquadRoleIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetRoleDetailsBySquadRoleIdQuery, IGetRoleDetailsBySquadRoleIdQueryVariables>(GetRoleDetailsBySquadRoleIdDocument, options);
      }
export function useGetRoleDetailsBySquadRoleIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetRoleDetailsBySquadRoleIdQuery, IGetRoleDetailsBySquadRoleIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetRoleDetailsBySquadRoleIdQuery, IGetRoleDetailsBySquadRoleIdQueryVariables>(GetRoleDetailsBySquadRoleIdDocument, options);
        }
export type GetRoleDetailsBySquadRoleIdQueryHookResult = ReturnType<typeof useGetRoleDetailsBySquadRoleIdQuery>;
export type GetRoleDetailsBySquadRoleIdLazyQueryHookResult = ReturnType<typeof useGetRoleDetailsBySquadRoleIdLazyQuery>;
export type GetRoleDetailsBySquadRoleIdQueryResult = Apollo.QueryResult<IGetRoleDetailsBySquadRoleIdQuery, IGetRoleDetailsBySquadRoleIdQueryVariables>;
export const ListSupervisorsDocument = gql`
    query ListSupervisors($listSupervisorsFilterDto: listSupervisorsFilterDto) {
  listSupervisors(listSupervisorsFilter: $listSupervisorsFilterDto) {
    designation
    email
    fullname
    id
  }
}
    `;

/**
 * __useListSupervisorsQuery__
 *
 * To run a query within a React component, call `useListSupervisorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListSupervisorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListSupervisorsQuery({
 *   variables: {
 *      listSupervisorsFilterDto: // value for 'listSupervisorsFilterDto'
 *   },
 * });
 */
export function useListSupervisorsQuery(baseOptions?: Apollo.QueryHookOptions<IListSupervisorsQuery, IListSupervisorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IListSupervisorsQuery, IListSupervisorsQueryVariables>(ListSupervisorsDocument, options);
      }
export function useListSupervisorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IListSupervisorsQuery, IListSupervisorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IListSupervisorsQuery, IListSupervisorsQueryVariables>(ListSupervisorsDocument, options);
        }
export type ListSupervisorsQueryHookResult = ReturnType<typeof useListSupervisorsQuery>;
export type ListSupervisorsLazyQueryHookResult = ReturnType<typeof useListSupervisorsLazyQuery>;
export type ListSupervisorsQueryResult = Apollo.QueryResult<IListSupervisorsQuery, IListSupervisorsQueryVariables>;
export const AddNewCommentDocument = gql`
    mutation addNewComment($comment: String!, $squadId: String!, $worklogId: String!) {
  addNewComment(comment: $comment, squadId: $squadId, worklogId: $worklogId) {
    worklogId
    worklogStatus
    workedMinutes
    categories
    startDate
    endDate
    comments {
      content
      addedOn
      commentedBy {
        id
        name
        level
        department
        designation
        profileImage
        roles
        squads {
          squadId
          squadName
        }
      }
    }
  }
}
    `;
export type IAddNewCommentMutationFn = Apollo.MutationFunction<IAddNewCommentMutation, IAddNewCommentMutationVariables>;

/**
 * __useAddNewCommentMutation__
 *
 * To run a mutation, you first call `useAddNewCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddNewCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addNewCommentMutation, { data, loading, error }] = useAddNewCommentMutation({
 *   variables: {
 *      comment: // value for 'comment'
 *      squadId: // value for 'squadId'
 *      worklogId: // value for 'worklogId'
 *   },
 * });
 */
export function useAddNewCommentMutation(baseOptions?: Apollo.MutationHookOptions<IAddNewCommentMutation, IAddNewCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IAddNewCommentMutation, IAddNewCommentMutationVariables>(AddNewCommentDocument, options);
      }
export type AddNewCommentMutationHookResult = ReturnType<typeof useAddNewCommentMutation>;
export type AddNewCommentMutationResult = Apollo.MutationResult<IAddNewCommentMutation>;
export type AddNewCommentMutationOptions = Apollo.BaseMutationOptions<IAddNewCommentMutation, IAddNewCommentMutationVariables>;
export const ApproveDeclineWorklogsDocument = gql`
    mutation approveDeclineWorklogs($worklogData: ApproveDeclineWorklogArgs!) {
  approveDeclineWorklogs(worklogData: $worklogData)
}
    `;
export type IApproveDeclineWorklogsMutationFn = Apollo.MutationFunction<IApproveDeclineWorklogsMutation, IApproveDeclineWorklogsMutationVariables>;

/**
 * __useApproveDeclineWorklogsMutation__
 *
 * To run a mutation, you first call `useApproveDeclineWorklogsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveDeclineWorklogsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveDeclineWorklogsMutation, { data, loading, error }] = useApproveDeclineWorklogsMutation({
 *   variables: {
 *      worklogData: // value for 'worklogData'
 *   },
 * });
 */
export function useApproveDeclineWorklogsMutation(baseOptions?: Apollo.MutationHookOptions<IApproveDeclineWorklogsMutation, IApproveDeclineWorklogsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IApproveDeclineWorklogsMutation, IApproveDeclineWorklogsMutationVariables>(ApproveDeclineWorklogsDocument, options);
      }
export type ApproveDeclineWorklogsMutationHookResult = ReturnType<typeof useApproveDeclineWorklogsMutation>;
export type ApproveDeclineWorklogsMutationResult = Apollo.MutationResult<IApproveDeclineWorklogsMutation>;
export type ApproveDeclineWorklogsMutationOptions = Apollo.BaseMutationOptions<IApproveDeclineWorklogsMutation, IApproveDeclineWorklogsMutationVariables>;
export const WorklogLeaveApproveDeclineDocument = gql`
    mutation worklogLeaveApproveDecline($worklogLeaveApproveDeclineReq: WorklogLeaveApproveDeclineReq!) {
  worklogLeaveApproveDecline(
    worklogLeaveApproveDeclineReq: $worklogLeaveApproveDeclineReq
  )
}
    `;
export type IWorklogLeaveApproveDeclineMutationFn = Apollo.MutationFunction<IWorklogLeaveApproveDeclineMutation, IWorklogLeaveApproveDeclineMutationVariables>;

/**
 * __useWorklogLeaveApproveDeclineMutation__
 *
 * To run a mutation, you first call `useWorklogLeaveApproveDeclineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWorklogLeaveApproveDeclineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [worklogLeaveApproveDeclineMutation, { data, loading, error }] = useWorklogLeaveApproveDeclineMutation({
 *   variables: {
 *      worklogLeaveApproveDeclineReq: // value for 'worklogLeaveApproveDeclineReq'
 *   },
 * });
 */
export function useWorklogLeaveApproveDeclineMutation(baseOptions?: Apollo.MutationHookOptions<IWorklogLeaveApproveDeclineMutation, IWorklogLeaveApproveDeclineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IWorklogLeaveApproveDeclineMutation, IWorklogLeaveApproveDeclineMutationVariables>(WorklogLeaveApproveDeclineDocument, options);
      }
export type WorklogLeaveApproveDeclineMutationHookResult = ReturnType<typeof useWorklogLeaveApproveDeclineMutation>;
export type WorklogLeaveApproveDeclineMutationResult = Apollo.MutationResult<IWorklogLeaveApproveDeclineMutation>;
export type WorklogLeaveApproveDeclineMutationOptions = Apollo.BaseMutationOptions<IWorklogLeaveApproveDeclineMutation, IWorklogLeaveApproveDeclineMutationVariables>;
export const UpdateAllocatedTimeDocument = gql`
    mutation updateAllocatedTime($updateAllocatedTimePayload: UpdateAllocatedTimePayload!) {
  updateAllocatedTime(updateAllocatedTimePayload: $updateAllocatedTimePayload) {
    allocatedMinutes
    hourOverview {
      allocatedTimeId
      notesCount
      userSquadHistoryId
      totalAllocatedMinutes
      overview {
        status
        totalMinutes
      }
    }
    newAllocatedTimeId
    note
  }
}
    `;
export type IUpdateAllocatedTimeMutationFn = Apollo.MutationFunction<IUpdateAllocatedTimeMutation, IUpdateAllocatedTimeMutationVariables>;

/**
 * __useUpdateAllocatedTimeMutation__
 *
 * To run a mutation, you first call `useUpdateAllocatedTimeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAllocatedTimeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAllocatedTimeMutation, { data, loading, error }] = useUpdateAllocatedTimeMutation({
 *   variables: {
 *      updateAllocatedTimePayload: // value for 'updateAllocatedTimePayload'
 *   },
 * });
 */
export function useUpdateAllocatedTimeMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateAllocatedTimeMutation, IUpdateAllocatedTimeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateAllocatedTimeMutation, IUpdateAllocatedTimeMutationVariables>(UpdateAllocatedTimeDocument, options);
      }
export type UpdateAllocatedTimeMutationHookResult = ReturnType<typeof useUpdateAllocatedTimeMutation>;
export type UpdateAllocatedTimeMutationResult = Apollo.MutationResult<IUpdateAllocatedTimeMutation>;
export type UpdateAllocatedTimeMutationOptions = Apollo.BaseMutationOptions<IUpdateAllocatedTimeMutation, IUpdateAllocatedTimeMutationVariables>;
export const UpdateWorklogCloseDocumentDocument = gql`
    mutation updateWorklogCloseDocument($worklogCloseFilter: WorklogCloseStatusFilterDto!) {
  updateWorklogCloseDocument(worklogCloseFilter: $worklogCloseFilter)
}
    `;
export type IUpdateWorklogCloseDocumentMutationFn = Apollo.MutationFunction<IUpdateWorklogCloseDocumentMutation, IUpdateWorklogCloseDocumentMutationVariables>;

/**
 * __useUpdateWorklogCloseDocumentMutation__
 *
 * To run a mutation, you first call `useUpdateWorklogCloseDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorklogCloseDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorklogCloseDocumentMutation, { data, loading, error }] = useUpdateWorklogCloseDocumentMutation({
 *   variables: {
 *      worklogCloseFilter: // value for 'worklogCloseFilter'
 *   },
 * });
 */
export function useUpdateWorklogCloseDocumentMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateWorklogCloseDocumentMutation, IUpdateWorklogCloseDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateWorklogCloseDocumentMutation, IUpdateWorklogCloseDocumentMutationVariables>(UpdateWorklogCloseDocumentDocument, options);
      }
export type UpdateWorklogCloseDocumentMutationHookResult = ReturnType<typeof useUpdateWorklogCloseDocumentMutation>;
export type UpdateWorklogCloseDocumentMutationResult = Apollo.MutationResult<IUpdateWorklogCloseDocumentMutation>;
export type UpdateWorklogCloseDocumentMutationOptions = Apollo.BaseMutationOptions<IUpdateWorklogCloseDocumentMutation, IUpdateWorklogCloseDocumentMutationVariables>;
export const GetWorklogOverviewDocument = gql`
    query getWorklogOverview($worklogFilter: WorklogFilter!, $worklogLeaveFilter: WorklogLeaveFilter) {
  getWorklogOverview(
    worklogFilter: $worklogFilter
    worklogLeaveFilter: $worklogLeaveFilter
  ) {
    worklogCount
    hourOverview {
      allocatedTimeId
      userSquadHistoryId
      notesCount
      totalAllocatedMinutes
      overview {
        status
        totalMinutes
      }
    }
    consultants {
      id
      name
    }
    categoryOverview {
      category
      totalMinutes
    }
    leaves {
      firstHalfLeaves
      secondHalfLeaves
      totalLeaves
      wholeDayLeaves
      totalApprovedLeaves
      futureLeaves
    }
  }
}
    `;

/**
 * __useGetWorklogOverviewQuery__
 *
 * To run a query within a React component, call `useGetWorklogOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorklogOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorklogOverviewQuery({
 *   variables: {
 *      worklogFilter: // value for 'worklogFilter'
 *      worklogLeaveFilter: // value for 'worklogLeaveFilter'
 *   },
 * });
 */
export function useGetWorklogOverviewQuery(baseOptions: Apollo.QueryHookOptions<IGetWorklogOverviewQuery, IGetWorklogOverviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetWorklogOverviewQuery, IGetWorklogOverviewQueryVariables>(GetWorklogOverviewDocument, options);
      }
export function useGetWorklogOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetWorklogOverviewQuery, IGetWorklogOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetWorklogOverviewQuery, IGetWorklogOverviewQueryVariables>(GetWorklogOverviewDocument, options);
        }
export type GetWorklogOverviewQueryHookResult = ReturnType<typeof useGetWorklogOverviewQuery>;
export type GetWorklogOverviewLazyQueryHookResult = ReturnType<typeof useGetWorklogOverviewLazyQuery>;
export type GetWorklogOverviewQueryResult = Apollo.QueryResult<IGetWorklogOverviewQuery, IGetWorklogOverviewQueryVariables>;
export const GetWorklogRequestsDocument = gql`
    query getWorklogRequests($worklogFilter: WorklogFilter!, $pageRequest: PageRequest!, $worklogLeaveFilter: WorklogLeaveFilter) {
  getWorklogRequests(
    worklogFilter: $worklogFilter
    pageRequest: $pageRequest
    worklogLeaveFilter: $worklogLeaveFilter
  ) {
    closeEndDate
    closeStartDate
    closeStatus
    content {
      closeStatus
      commentsCount
      endDate
      id
      isSaveAsDraft
      resubmittedCount
      reviewedBy
      startDate
      status
      workedMinutes
      worklogbatchId
      worklogtasks {
        category
        description
        endTime
        id
        minutes
        startTime
      }
      leaveInfo {
        _id
        leaveStatus
        leaveCategory
        leaveType
        leaveRemarks
      }
    }
    pageable {
      page
      size
      totalElements
      totalPages
    }
  }
}
    `;

/**
 * __useGetWorklogRequestsQuery__
 *
 * To run a query within a React component, call `useGetWorklogRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorklogRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorklogRequestsQuery({
 *   variables: {
 *      worklogFilter: // value for 'worklogFilter'
 *      pageRequest: // value for 'pageRequest'
 *      worklogLeaveFilter: // value for 'worklogLeaveFilter'
 *   },
 * });
 */
export function useGetWorklogRequestsQuery(baseOptions: Apollo.QueryHookOptions<IGetWorklogRequestsQuery, IGetWorklogRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetWorklogRequestsQuery, IGetWorklogRequestsQueryVariables>(GetWorklogRequestsDocument, options);
      }
export function useGetWorklogRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetWorklogRequestsQuery, IGetWorklogRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetWorklogRequestsQuery, IGetWorklogRequestsQueryVariables>(GetWorklogRequestsDocument, options);
        }
export type GetWorklogRequestsQueryHookResult = ReturnType<typeof useGetWorklogRequestsQuery>;
export type GetWorklogRequestsLazyQueryHookResult = ReturnType<typeof useGetWorklogRequestsLazyQuery>;
export type GetWorklogRequestsQueryResult = Apollo.QueryResult<IGetWorklogRequestsQuery, IGetWorklogRequestsQueryVariables>;
export const GetAssignedResourcesWorkLogTabDocument = gql`
    query getAssignedResourcesWorkLogTab($squadId: String!, $userSquadHistorySearchDTO: UserSquadHistorySearchDTO!, $pageRequest: PageRequest!) {
  getAssignedResourcesWorklogTab(
    squadId: $squadId
    userSquadHistorySearchDTO: $userSquadHistorySearchDTO
    pageRequest: $pageRequest
  ) {
    content {
      employee {
        userId
        id
        name
        involvedAs
        department {
          name
        }
        jobType
        employeementType
        experienceLevel
        role
        profileImage
        workingHour
      }
      resourceWorklogs {
        overview {
          status
          totalMinutes
        }
        totalAllocatedMinutes
      }
    }
  }
}
    `;

/**
 * __useGetAssignedResourcesWorkLogTabQuery__
 *
 * To run a query within a React component, call `useGetAssignedResourcesWorkLogTabQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssignedResourcesWorkLogTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssignedResourcesWorkLogTabQuery({
 *   variables: {
 *      squadId: // value for 'squadId'
 *      userSquadHistorySearchDTO: // value for 'userSquadHistorySearchDTO'
 *      pageRequest: // value for 'pageRequest'
 *   },
 * });
 */
export function useGetAssignedResourcesWorkLogTabQuery(baseOptions: Apollo.QueryHookOptions<IGetAssignedResourcesWorkLogTabQuery, IGetAssignedResourcesWorkLogTabQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetAssignedResourcesWorkLogTabQuery, IGetAssignedResourcesWorkLogTabQueryVariables>(GetAssignedResourcesWorkLogTabDocument, options);
      }
export function useGetAssignedResourcesWorkLogTabLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetAssignedResourcesWorkLogTabQuery, IGetAssignedResourcesWorkLogTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetAssignedResourcesWorkLogTabQuery, IGetAssignedResourcesWorkLogTabQueryVariables>(GetAssignedResourcesWorkLogTabDocument, options);
        }
export type GetAssignedResourcesWorkLogTabQueryHookResult = ReturnType<typeof useGetAssignedResourcesWorkLogTabQuery>;
export type GetAssignedResourcesWorkLogTabLazyQueryHookResult = ReturnType<typeof useGetAssignedResourcesWorkLogTabLazyQuery>;
export type GetAssignedResourcesWorkLogTabQueryResult = Apollo.QueryResult<IGetAssignedResourcesWorkLogTabQuery, IGetAssignedResourcesWorkLogTabQueryVariables>;
export const GetUserDataDocument = gql`
    query getUserData($userId: String!, $squadId: String) {
  getUserData(userId: $userId, squadId: $squadId) {
    id
    name
    profileImage
    canLoggedInUserApproveWorklog
    department
    designation
    level
    roles
    availability
    isAnApprover
    squads {
      squadId
      squadName
    }
  }
}
    `;

/**
 * __useGetUserDataQuery__
 *
 * To run a query within a React component, call `useGetUserDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserDataQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      squadId: // value for 'squadId'
 *   },
 * });
 */
export function useGetUserDataQuery(baseOptions: Apollo.QueryHookOptions<IGetUserDataQuery, IGetUserDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetUserDataQuery, IGetUserDataQueryVariables>(GetUserDataDocument, options);
      }
export function useGetUserDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetUserDataQuery, IGetUserDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetUserDataQuery, IGetUserDataQueryVariables>(GetUserDataDocument, options);
        }
export type GetUserDataQueryHookResult = ReturnType<typeof useGetUserDataQuery>;
export type GetUserDataLazyQueryHookResult = ReturnType<typeof useGetUserDataLazyQuery>;
export type GetUserDataQueryResult = Apollo.QueryResult<IGetUserDataQuery, IGetUserDataQueryVariables>;
export const ListApproversDocument = gql`
    query listApprovers($listApproversFilterDto: listApproversFilterDto) {
  listApprovers(listApproversFilter: $listApproversFilterDto) {
    designation
    id
    fullname
    email
  }
}
    `;

/**
 * __useListApproversQuery__
 *
 * To run a query within a React component, call `useListApproversQuery` and pass it any options that fit your needs.
 * When your component renders, `useListApproversQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListApproversQuery({
 *   variables: {
 *      listApproversFilterDto: // value for 'listApproversFilterDto'
 *   },
 * });
 */
export function useListApproversQuery(baseOptions?: Apollo.QueryHookOptions<IListApproversQuery, IListApproversQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IListApproversQuery, IListApproversQueryVariables>(ListApproversDocument, options);
      }
export function useListApproversLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IListApproversQuery, IListApproversQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IListApproversQuery, IListApproversQueryVariables>(ListApproversDocument, options);
        }
export type ListApproversQueryHookResult = ReturnType<typeof useListApproversQuery>;
export type ListApproversLazyQueryHookResult = ReturnType<typeof useListApproversLazyQuery>;
export type ListApproversQueryResult = Apollo.QueryResult<IListApproversQuery, IListApproversQueryVariables>;
export const GetCommentsDocument = gql`
    query getComments($commentFilter: CommentFilter!) {
  getComments(commentFilter: $commentFilter) {
    worklogId
    worklogStatus
    workedMinutes
    categories
    startDate
    endDate
    comments {
      content
      addedOn
      commentedBy {
        id
        name
        level
        department
        designation
        profileImage
        roles
        squads {
          squadId
          squadName
        }
      }
    }
  }
}
    `;

/**
 * __useGetCommentsQuery__
 *
 * To run a query within a React component, call `useGetCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommentsQuery({
 *   variables: {
 *      commentFilter: // value for 'commentFilter'
 *   },
 * });
 */
export function useGetCommentsQuery(baseOptions: Apollo.QueryHookOptions<IGetCommentsQuery, IGetCommentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetCommentsQuery, IGetCommentsQueryVariables>(GetCommentsDocument, options);
      }
export function useGetCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetCommentsQuery, IGetCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetCommentsQuery, IGetCommentsQueryVariables>(GetCommentsDocument, options);
        }
export type GetCommentsQueryHookResult = ReturnType<typeof useGetCommentsQuery>;
export type GetCommentsLazyQueryHookResult = ReturnType<typeof useGetCommentsLazyQuery>;
export type GetCommentsQueryResult = Apollo.QueryResult<IGetCommentsQuery, IGetCommentsQueryVariables>;
export const GetSquadEmployeeIdsDocument = gql`
    query getSquadEmployeeIds($squadId: String!, $userSquadHistorySearchDto: UserSquadHistorySearchDTO!) {
  getSquadEmployeeIds(
    squadId: $squadId
    userSquadHistorySearchDTO: $userSquadHistorySearchDto
  )
}
    `;

/**
 * __useGetSquadEmployeeIdsQuery__
 *
 * To run a query within a React component, call `useGetSquadEmployeeIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSquadEmployeeIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSquadEmployeeIdsQuery({
 *   variables: {
 *      squadId: // value for 'squadId'
 *      userSquadHistorySearchDto: // value for 'userSquadHistorySearchDto'
 *   },
 * });
 */
export function useGetSquadEmployeeIdsQuery(baseOptions: Apollo.QueryHookOptions<IGetSquadEmployeeIdsQuery, IGetSquadEmployeeIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetSquadEmployeeIdsQuery, IGetSquadEmployeeIdsQueryVariables>(GetSquadEmployeeIdsDocument, options);
      }
export function useGetSquadEmployeeIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetSquadEmployeeIdsQuery, IGetSquadEmployeeIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetSquadEmployeeIdsQuery, IGetSquadEmployeeIdsQueryVariables>(GetSquadEmployeeIdsDocument, options);
        }
export type GetSquadEmployeeIdsQueryHookResult = ReturnType<typeof useGetSquadEmployeeIdsQuery>;
export type GetSquadEmployeeIdsLazyQueryHookResult = ReturnType<typeof useGetSquadEmployeeIdsLazyQuery>;
export type GetSquadEmployeeIdsQueryResult = Apollo.QueryResult<IGetSquadEmployeeIdsQuery, IGetSquadEmployeeIdsQueryVariables>;
export const GetSquadInvoicingPeriodListDocument = gql`
    query getSquadInvoicingPeriodList($squadId: String!, $userId: String) {
  getSquadInvoicingPeriodList(squadId: $squadId, userId: $userId) {
    invoiceNumber
    periodStartDate
    periodEndDate
    label
  }
}
    `;

/**
 * __useGetSquadInvoicingPeriodListQuery__
 *
 * To run a query within a React component, call `useGetSquadInvoicingPeriodListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSquadInvoicingPeriodListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSquadInvoicingPeriodListQuery({
 *   variables: {
 *      squadId: // value for 'squadId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetSquadInvoicingPeriodListQuery(baseOptions: Apollo.QueryHookOptions<IGetSquadInvoicingPeriodListQuery, IGetSquadInvoicingPeriodListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetSquadInvoicingPeriodListQuery, IGetSquadInvoicingPeriodListQueryVariables>(GetSquadInvoicingPeriodListDocument, options);
      }
export function useGetSquadInvoicingPeriodListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetSquadInvoicingPeriodListQuery, IGetSquadInvoicingPeriodListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetSquadInvoicingPeriodListQuery, IGetSquadInvoicingPeriodListQueryVariables>(GetSquadInvoicingPeriodListDocument, options);
        }
export type GetSquadInvoicingPeriodListQueryHookResult = ReturnType<typeof useGetSquadInvoicingPeriodListQuery>;
export type GetSquadInvoicingPeriodListLazyQueryHookResult = ReturnType<typeof useGetSquadInvoicingPeriodListLazyQuery>;
export type GetSquadInvoicingPeriodListQueryResult = Apollo.QueryResult<IGetSquadInvoicingPeriodListQuery, IGetSquadInvoicingPeriodListQueryVariables>;
export const ExportWorklogDocument = gql`
    query exportWorklog($filter: ExportAndInvoiceWorklogFilter!) {
  exportWorklog(filter: $filter)
}
    `;

/**
 * __useExportWorklogQuery__
 *
 * To run a query within a React component, call `useExportWorklogQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportWorklogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportWorklogQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useExportWorklogQuery(baseOptions: Apollo.QueryHookOptions<IExportWorklogQuery, IExportWorklogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IExportWorklogQuery, IExportWorklogQueryVariables>(ExportWorklogDocument, options);
      }
export function useExportWorklogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IExportWorklogQuery, IExportWorklogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IExportWorklogQuery, IExportWorklogQueryVariables>(ExportWorklogDocument, options);
        }
export type ExportWorklogQueryHookResult = ReturnType<typeof useExportWorklogQuery>;
export type ExportWorklogLazyQueryHookResult = ReturnType<typeof useExportWorklogLazyQuery>;
export type ExportWorklogQueryResult = Apollo.QueryResult<IExportWorklogQuery, IExportWorklogQueryVariables>;
export const GetInvoiceRelateDataDocument = gql`
    query getInvoiceRelateData($invoicingFilter: ExportAndInvoiceWorklogFilter!) {
  getInvoiceRelateData(invoicingFilter: $invoicingFilter) {
    clientAddress
    clientEmail
    clientName
    invoicingDate
    invoicingPeriod
    squadName
    employee {
      employeeName
      role
      billingType
      employeeRate
      workingHour
      roleType
    }
  }
}
    `;

/**
 * __useGetInvoiceRelateDataQuery__
 *
 * To run a query within a React component, call `useGetInvoiceRelateDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoiceRelateDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoiceRelateDataQuery({
 *   variables: {
 *      invoicingFilter: // value for 'invoicingFilter'
 *   },
 * });
 */
export function useGetInvoiceRelateDataQuery(baseOptions: Apollo.QueryHookOptions<IGetInvoiceRelateDataQuery, IGetInvoiceRelateDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetInvoiceRelateDataQuery, IGetInvoiceRelateDataQueryVariables>(GetInvoiceRelateDataDocument, options);
      }
export function useGetInvoiceRelateDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetInvoiceRelateDataQuery, IGetInvoiceRelateDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetInvoiceRelateDataQuery, IGetInvoiceRelateDataQueryVariables>(GetInvoiceRelateDataDocument, options);
        }
export type GetInvoiceRelateDataQueryHookResult = ReturnType<typeof useGetInvoiceRelateDataQuery>;
export type GetInvoiceRelateDataLazyQueryHookResult = ReturnType<typeof useGetInvoiceRelateDataLazyQuery>;
export type GetInvoiceRelateDataQueryResult = Apollo.QueryResult<IGetInvoiceRelateDataQuery, IGetInvoiceRelateDataQueryVariables>;
export const FetchNotesDocument = gql`
    query fetchNotes($userSquadHistoryId: String!) {
  fetchNotes(userSquadHistoryId: $userSquadHistoryId) {
    allocatedMinutes
    allocatedTimeId
    modifiedBy {
      email
      fullname
      profileImage
      userId
    }
    note
    userSquadHistoryId
    updatedAt
  }
}
    `;

/**
 * __useFetchNotesQuery__
 *
 * To run a query within a React component, call `useFetchNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchNotesQuery({
 *   variables: {
 *      userSquadHistoryId: // value for 'userSquadHistoryId'
 *   },
 * });
 */
export function useFetchNotesQuery(baseOptions: Apollo.QueryHookOptions<IFetchNotesQuery, IFetchNotesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IFetchNotesQuery, IFetchNotesQueryVariables>(FetchNotesDocument, options);
      }
export function useFetchNotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IFetchNotesQuery, IFetchNotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IFetchNotesQuery, IFetchNotesQueryVariables>(FetchNotesDocument, options);
        }
export type FetchNotesQueryHookResult = ReturnType<typeof useFetchNotesQuery>;
export type FetchNotesLazyQueryHookResult = ReturnType<typeof useFetchNotesLazyQuery>;
export type FetchNotesQueryResult = Apollo.QueryResult<IFetchNotesQuery, IFetchNotesQueryVariables>;
export const GetWorklogCloseDocumentDocument = gql`
    query getWorklogCloseDocument($worklogCloseFilter: WorklogCloseStatusFilterDto!) {
  getWorklogCloseDocument(worklogCloseFilter: $worklogCloseFilter) {
    closeEndDate
    closeStartDate
    status
  }
}
    `;

/**
 * __useGetWorklogCloseDocumentQuery__
 *
 * To run a query within a React component, call `useGetWorklogCloseDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorklogCloseDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorklogCloseDocumentQuery({
 *   variables: {
 *      worklogCloseFilter: // value for 'worklogCloseFilter'
 *   },
 * });
 */
export function useGetWorklogCloseDocumentQuery(baseOptions: Apollo.QueryHookOptions<IGetWorklogCloseDocumentQuery, IGetWorklogCloseDocumentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetWorklogCloseDocumentQuery, IGetWorklogCloseDocumentQueryVariables>(GetWorklogCloseDocumentDocument, options);
      }
export function useGetWorklogCloseDocumentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetWorklogCloseDocumentQuery, IGetWorklogCloseDocumentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetWorklogCloseDocumentQuery, IGetWorklogCloseDocumentQueryVariables>(GetWorklogCloseDocumentDocument, options);
        }
export type GetWorklogCloseDocumentQueryHookResult = ReturnType<typeof useGetWorklogCloseDocumentQuery>;
export type GetWorklogCloseDocumentLazyQueryHookResult = ReturnType<typeof useGetWorklogCloseDocumentLazyQuery>;
export type GetWorklogCloseDocumentQueryResult = Apollo.QueryResult<IGetWorklogCloseDocumentQuery, IGetWorklogCloseDocumentQueryVariables>;
export const CreatePermissionGroupDocument = gql`
    mutation createPermissionGroup($permissionGroupDto: PermissionGroupDto!) {
  createPermissionGroup(permissionGroupDto: $permissionGroupDto) {
    id
    name
    orgId
    permissions
  }
}
    `;
export type ICreatePermissionGroupMutationFn = Apollo.MutationFunction<ICreatePermissionGroupMutation, ICreatePermissionGroupMutationVariables>;

/**
 * __useCreatePermissionGroupMutation__
 *
 * To run a mutation, you first call `useCreatePermissionGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePermissionGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPermissionGroupMutation, { data, loading, error }] = useCreatePermissionGroupMutation({
 *   variables: {
 *      permissionGroupDto: // value for 'permissionGroupDto'
 *   },
 * });
 */
export function useCreatePermissionGroupMutation(baseOptions?: Apollo.MutationHookOptions<ICreatePermissionGroupMutation, ICreatePermissionGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ICreatePermissionGroupMutation, ICreatePermissionGroupMutationVariables>(CreatePermissionGroupDocument, options);
      }
export type CreatePermissionGroupMutationHookResult = ReturnType<typeof useCreatePermissionGroupMutation>;
export type CreatePermissionGroupMutationResult = Apollo.MutationResult<ICreatePermissionGroupMutation>;
export type CreatePermissionGroupMutationOptions = Apollo.BaseMutationOptions<ICreatePermissionGroupMutation, ICreatePermissionGroupMutationVariables>;
export const CreatePersonaDocument = gql`
    mutation createPersona($personaDto: PersonaInputDto!) {
  createPersona(personaDto: $personaDto) {
    id
    name
    orgId
    permissionGroupIds
  }
}
    `;
export type ICreatePersonaMutationFn = Apollo.MutationFunction<ICreatePersonaMutation, ICreatePersonaMutationVariables>;

/**
 * __useCreatePersonaMutation__
 *
 * To run a mutation, you first call `useCreatePersonaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePersonaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPersonaMutation, { data, loading, error }] = useCreatePersonaMutation({
 *   variables: {
 *      personaDto: // value for 'personaDto'
 *   },
 * });
 */
export function useCreatePersonaMutation(baseOptions?: Apollo.MutationHookOptions<ICreatePersonaMutation, ICreatePersonaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ICreatePersonaMutation, ICreatePersonaMutationVariables>(CreatePersonaDocument, options);
      }
export type CreatePersonaMutationHookResult = ReturnType<typeof useCreatePersonaMutation>;
export type CreatePersonaMutationResult = Apollo.MutationResult<ICreatePersonaMutation>;
export type CreatePersonaMutationOptions = Apollo.BaseMutationOptions<ICreatePersonaMutation, ICreatePersonaMutationVariables>;
export const AssignPersonaToUsersDocument = gql`
    mutation assignPersonaToUsers($assignPersonaDto: AssignPersonaDto!) {
  assignPersonaToUsers(assignPersonaDto: $assignPersonaDto)
}
    `;
export type IAssignPersonaToUsersMutationFn = Apollo.MutationFunction<IAssignPersonaToUsersMutation, IAssignPersonaToUsersMutationVariables>;

/**
 * __useAssignPersonaToUsersMutation__
 *
 * To run a mutation, you first call `useAssignPersonaToUsersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignPersonaToUsersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignPersonaToUsersMutation, { data, loading, error }] = useAssignPersonaToUsersMutation({
 *   variables: {
 *      assignPersonaDto: // value for 'assignPersonaDto'
 *   },
 * });
 */
export function useAssignPersonaToUsersMutation(baseOptions?: Apollo.MutationHookOptions<IAssignPersonaToUsersMutation, IAssignPersonaToUsersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IAssignPersonaToUsersMutation, IAssignPersonaToUsersMutationVariables>(AssignPersonaToUsersDocument, options);
      }
export type AssignPersonaToUsersMutationHookResult = ReturnType<typeof useAssignPersonaToUsersMutation>;
export type AssignPersonaToUsersMutationResult = Apollo.MutationResult<IAssignPersonaToUsersMutation>;
export type AssignPersonaToUsersMutationOptions = Apollo.BaseMutationOptions<IAssignPersonaToUsersMutation, IAssignPersonaToUsersMutationVariables>;
export const CreatePermissionHierarchyDocument = gql`
    mutation createPermissionHierarchy($permissionHierarchyDto: PermissionHierarchyDto!) {
  createPermissionHierarchy(permissionHierarchyDto: $permissionHierarchyDto) {
    id
    description
    parentId
    permission
    selected
    title
  }
}
    `;
export type ICreatePermissionHierarchyMutationFn = Apollo.MutationFunction<ICreatePermissionHierarchyMutation, ICreatePermissionHierarchyMutationVariables>;

/**
 * __useCreatePermissionHierarchyMutation__
 *
 * To run a mutation, you first call `useCreatePermissionHierarchyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePermissionHierarchyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPermissionHierarchyMutation, { data, loading, error }] = useCreatePermissionHierarchyMutation({
 *   variables: {
 *      permissionHierarchyDto: // value for 'permissionHierarchyDto'
 *   },
 * });
 */
export function useCreatePermissionHierarchyMutation(baseOptions?: Apollo.MutationHookOptions<ICreatePermissionHierarchyMutation, ICreatePermissionHierarchyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ICreatePermissionHierarchyMutation, ICreatePermissionHierarchyMutationVariables>(CreatePermissionHierarchyDocument, options);
      }
export type CreatePermissionHierarchyMutationHookResult = ReturnType<typeof useCreatePermissionHierarchyMutation>;
export type CreatePermissionHierarchyMutationResult = Apollo.MutationResult<ICreatePermissionHierarchyMutation>;
export type CreatePermissionHierarchyMutationOptions = Apollo.BaseMutationOptions<ICreatePermissionHierarchyMutation, ICreatePermissionHierarchyMutationVariables>;
export const GetAllPermissionGroupsDocument = gql`
    query getAllPermissionGroups($searchKey: String) {
  getAllPermissionGroups(searchKey: $searchKey) {
    _id
    name
    orgId
    permissions
    description
    createdBy
    createdAt
  }
}
    `;

/**
 * __useGetAllPermissionGroupsQuery__
 *
 * To run a query within a React component, call `useGetAllPermissionGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllPermissionGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllPermissionGroupsQuery({
 *   variables: {
 *      searchKey: // value for 'searchKey'
 *   },
 * });
 */
export function useGetAllPermissionGroupsQuery(baseOptions?: Apollo.QueryHookOptions<IGetAllPermissionGroupsQuery, IGetAllPermissionGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetAllPermissionGroupsQuery, IGetAllPermissionGroupsQueryVariables>(GetAllPermissionGroupsDocument, options);
      }
export function useGetAllPermissionGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetAllPermissionGroupsQuery, IGetAllPermissionGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetAllPermissionGroupsQuery, IGetAllPermissionGroupsQueryVariables>(GetAllPermissionGroupsDocument, options);
        }
export type GetAllPermissionGroupsQueryHookResult = ReturnType<typeof useGetAllPermissionGroupsQuery>;
export type GetAllPermissionGroupsLazyQueryHookResult = ReturnType<typeof useGetAllPermissionGroupsLazyQuery>;
export type GetAllPermissionGroupsQueryResult = Apollo.QueryResult<IGetAllPermissionGroupsQuery, IGetAllPermissionGroupsQueryVariables>;
export const GetPermissionGroupByIdDocument = gql`
    query getPermissionGroupById($id: String!) {
  getPermissionGroupById(id: $id) {
    _id
    name
    orgId
    permissions
    description
    createdBy
    createdAt
  }
}
    `;

/**
 * __useGetPermissionGroupByIdQuery__
 *
 * To run a query within a React component, call `useGetPermissionGroupByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPermissionGroupByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPermissionGroupByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPermissionGroupByIdQuery(baseOptions: Apollo.QueryHookOptions<IGetPermissionGroupByIdQuery, IGetPermissionGroupByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetPermissionGroupByIdQuery, IGetPermissionGroupByIdQueryVariables>(GetPermissionGroupByIdDocument, options);
      }
export function useGetPermissionGroupByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetPermissionGroupByIdQuery, IGetPermissionGroupByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetPermissionGroupByIdQuery, IGetPermissionGroupByIdQueryVariables>(GetPermissionGroupByIdDocument, options);
        }
export type GetPermissionGroupByIdQueryHookResult = ReturnType<typeof useGetPermissionGroupByIdQuery>;
export type GetPermissionGroupByIdLazyQueryHookResult = ReturnType<typeof useGetPermissionGroupByIdLazyQuery>;
export type GetPermissionGroupByIdQueryResult = Apollo.QueryResult<IGetPermissionGroupByIdQuery, IGetPermissionGroupByIdQueryVariables>;
export const GetAllPersonaDocument = gql`
    query getAllPersona($searchKey: String!) {
  getAllPersona(searchKey: $searchKey) {
    id
    name
    orgId
    permissionGroupIds
    description
    createdBy
    createdAt
    permissionGroups {
      _id
      createdAt
      createdBy
      description
      name
      orgId
      permissions
    }
  }
}
    `;

/**
 * __useGetAllPersonaQuery__
 *
 * To run a query within a React component, call `useGetAllPersonaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllPersonaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllPersonaQuery({
 *   variables: {
 *      searchKey: // value for 'searchKey'
 *   },
 * });
 */
export function useGetAllPersonaQuery(baseOptions: Apollo.QueryHookOptions<IGetAllPersonaQuery, IGetAllPersonaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetAllPersonaQuery, IGetAllPersonaQueryVariables>(GetAllPersonaDocument, options);
      }
export function useGetAllPersonaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetAllPersonaQuery, IGetAllPersonaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetAllPersonaQuery, IGetAllPersonaQueryVariables>(GetAllPersonaDocument, options);
        }
export type GetAllPersonaQueryHookResult = ReturnType<typeof useGetAllPersonaQuery>;
export type GetAllPersonaLazyQueryHookResult = ReturnType<typeof useGetAllPersonaLazyQuery>;
export type GetAllPersonaQueryResult = Apollo.QueryResult<IGetAllPersonaQuery, IGetAllPersonaQueryVariables>;
export const GetPermissionHierarchyDocument = gql`
    query getPermissionHierarchy($filterSelected: Boolean, $permissionGroupId: String) {
  getPermissionHierarchy(
    filterSelected: $filterSelected
    permissionGroupId: $permissionGroupId
  ) {
    description
    id
    parentId
    permission
    permissionHierarchy {
      description
      id
      parentId
      permission
      permissionHierarchy {
        description
        id
        parentId
        permission
        permissionHierarchy {
          description
          id
          parentId
          permission
          permissionHierarchy {
            description
            id
            parentId
            permission
            permissionHierarchy {
              description
              id
              parentId
              permission
              selected
              title
              type
            }
            selected
            title
            type
          }
          selected
          title
          type
        }
        selected
        title
        type
      }
      selected
      title
      type
    }
    selected
    title
    type
  }
}
    `;

/**
 * __useGetPermissionHierarchyQuery__
 *
 * To run a query within a React component, call `useGetPermissionHierarchyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPermissionHierarchyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPermissionHierarchyQuery({
 *   variables: {
 *      filterSelected: // value for 'filterSelected'
 *      permissionGroupId: // value for 'permissionGroupId'
 *   },
 * });
 */
export function useGetPermissionHierarchyQuery(baseOptions?: Apollo.QueryHookOptions<IGetPermissionHierarchyQuery, IGetPermissionHierarchyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetPermissionHierarchyQuery, IGetPermissionHierarchyQueryVariables>(GetPermissionHierarchyDocument, options);
      }
export function useGetPermissionHierarchyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetPermissionHierarchyQuery, IGetPermissionHierarchyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetPermissionHierarchyQuery, IGetPermissionHierarchyQueryVariables>(GetPermissionHierarchyDocument, options);
        }
export type GetPermissionHierarchyQueryHookResult = ReturnType<typeof useGetPermissionHierarchyQuery>;
export type GetPermissionHierarchyLazyQueryHookResult = ReturnType<typeof useGetPermissionHierarchyLazyQuery>;
export type GetPermissionHierarchyQueryResult = Apollo.QueryResult<IGetPermissionHierarchyQuery, IGetPermissionHierarchyQueryVariables>;
export const GetUserListDocument = gql`
    query getUserList($pageRequest: PageRequest, $userListFilter: UserListFilter!) {
  getUserList(pageRequest: $pageRequest, userListFilter: $userListFilter) {
    content {
      userId
      email
      name
      department
      mainDepartment
      designation
      profileImage
      permissionGroup {
        id
        name
      }
      personas {
        id
        name
      }
    }
    pageable {
      page
      size
      totalElements
      totalPages
    }
  }
}
    `;

/**
 * __useGetUserListQuery__
 *
 * To run a query within a React component, call `useGetUserListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserListQuery({
 *   variables: {
 *      pageRequest: // value for 'pageRequest'
 *      userListFilter: // value for 'userListFilter'
 *   },
 * });
 */
export function useGetUserListQuery(baseOptions: Apollo.QueryHookOptions<IGetUserListQuery, IGetUserListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetUserListQuery, IGetUserListQueryVariables>(GetUserListDocument, options);
      }
export function useGetUserListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetUserListQuery, IGetUserListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetUserListQuery, IGetUserListQueryVariables>(GetUserListDocument, options);
        }
export type GetUserListQueryHookResult = ReturnType<typeof useGetUserListQuery>;
export type GetUserListLazyQueryHookResult = ReturnType<typeof useGetUserListLazyQuery>;
export type GetUserListQueryResult = Apollo.QueryResult<IGetUserListQuery, IGetUserListQueryVariables>;
export const GetUserListDropDownDocument = gql`
    query getUserListDropDown($pageRequest: PageRequest, $userListFilter: UserListFilter!) {
  getUserListDropDown(pageRequest: $pageRequest, userListFilter: $userListFilter) {
    content {
      userId
      email
      name
      department
      mainDepartment
      designation
      profileImage
      permissionGroup {
        id
        name
      }
      personas {
        id
        name
      }
    }
    pageable {
      page
      size
      totalElements
      totalPages
    }
  }
}
    `;

/**
 * __useGetUserListDropDownQuery__
 *
 * To run a query within a React component, call `useGetUserListDropDownQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserListDropDownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserListDropDownQuery({
 *   variables: {
 *      pageRequest: // value for 'pageRequest'
 *      userListFilter: // value for 'userListFilter'
 *   },
 * });
 */
export function useGetUserListDropDownQuery(baseOptions: Apollo.QueryHookOptions<IGetUserListDropDownQuery, IGetUserListDropDownQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetUserListDropDownQuery, IGetUserListDropDownQueryVariables>(GetUserListDropDownDocument, options);
      }
export function useGetUserListDropDownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetUserListDropDownQuery, IGetUserListDropDownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetUserListDropDownQuery, IGetUserListDropDownQueryVariables>(GetUserListDropDownDocument, options);
        }
export type GetUserListDropDownQueryHookResult = ReturnType<typeof useGetUserListDropDownQuery>;
export type GetUserListDropDownLazyQueryHookResult = ReturnType<typeof useGetUserListDropDownLazyQuery>;
export type GetUserListDropDownQueryResult = Apollo.QueryResult<IGetUserListDropDownQuery, IGetUserListDropDownQueryVariables>;
export const GetPersonaByIdDocument = gql`
    query getPersonaById($id: String!) {
  getPersonaById(id: $id) {
    id
    name
    orgId
    permissionGroupIds
    description
    createdBy
    createdAt
    permissionGroups {
      _id
      createdAt
      createdBy
      description
      name
      orgId
      permissions
    }
  }
}
    `;

/**
 * __useGetPersonaByIdQuery__
 *
 * To run a query within a React component, call `useGetPersonaByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPersonaByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPersonaByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPersonaByIdQuery(baseOptions: Apollo.QueryHookOptions<IGetPersonaByIdQuery, IGetPersonaByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetPersonaByIdQuery, IGetPersonaByIdQueryVariables>(GetPersonaByIdDocument, options);
      }
export function useGetPersonaByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetPersonaByIdQuery, IGetPersonaByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetPersonaByIdQuery, IGetPersonaByIdQueryVariables>(GetPersonaByIdDocument, options);
        }
export type GetPersonaByIdQueryHookResult = ReturnType<typeof useGetPersonaByIdQuery>;
export type GetPersonaByIdLazyQueryHookResult = ReturnType<typeof useGetPersonaByIdLazyQuery>;
export type GetPersonaByIdQueryResult = Apollo.QueryResult<IGetPersonaByIdQuery, IGetPersonaByIdQueryVariables>;
export const GetAllPermissionsDocument = gql`
    query getAllPermissions {
  getAllPermissions
}
    `;

/**
 * __useGetAllPermissionsQuery__
 *
 * To run a query within a React component, call `useGetAllPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllPermissionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllPermissionsQuery(baseOptions?: Apollo.QueryHookOptions<IGetAllPermissionsQuery, IGetAllPermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetAllPermissionsQuery, IGetAllPermissionsQueryVariables>(GetAllPermissionsDocument, options);
      }
export function useGetAllPermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetAllPermissionsQuery, IGetAllPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetAllPermissionsQuery, IGetAllPermissionsQueryVariables>(GetAllPermissionsDocument, options);
        }
export type GetAllPermissionsQueryHookResult = ReturnType<typeof useGetAllPermissionsQuery>;
export type GetAllPermissionsLazyQueryHookResult = ReturnType<typeof useGetAllPermissionsLazyQuery>;
export type GetAllPermissionsQueryResult = Apollo.QueryResult<IGetAllPermissionsQuery, IGetAllPermissionsQueryVariables>;